(function(scope){
'use strict';

function F(arity, fun, wrapper) {
  wrapper.a = arity;
  wrapper.f = fun;
  return wrapper;
}

function F2(fun) {
  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
}
function F3(fun) {
  return F(3, fun, function(a) {
    return function(b) { return function(c) { return fun(a, b, c); }; };
  });
}
function F4(fun) {
  return F(4, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return fun(a, b, c, d); }; }; };
  });
}
function F5(fun) {
  return F(5, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
  });
}
function F6(fun) {
  return F(6, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return fun(a, b, c, d, e, f); }; }; }; }; };
  });
}
function F7(fun) {
  return F(7, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
  });
}
function F8(fun) {
  return F(8, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) {
    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
  });
}
function F9(fun) {
  return F(9, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) { return function(i) {
    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
  });
}

function A2(fun, a, b) {
  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
}
function A3(fun, a, b, c) {
  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
}
function A4(fun, a, b, c, d) {
  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
}
function A5(fun, a, b, c, d, e) {
  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
}
function A6(fun, a, b, c, d, e, f) {
  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
}
function A7(fun, a, b, c, d, e, f, g) {
  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
}
function A8(fun, a, b, c, d, e, f, g, h) {
  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
}
function A9(fun, a, b, c, d, e, f, g, h, i) {
  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
}




var _JsArray_empty = [];

function _JsArray_singleton(value)
{
    return [value];
}

function _JsArray_length(array)
{
    return array.length;
}

var _JsArray_initialize = F3(function(size, offset, func)
{
    var result = new Array(size);

    for (var i = 0; i < size; i++)
    {
        result[i] = func(offset + i);
    }

    return result;
});

var _JsArray_initializeFromList = F2(function (max, ls)
{
    var result = new Array(max);

    for (var i = 0; i < max && ls.b; i++)
    {
        result[i] = ls.a;
        ls = ls.b;
    }

    result.length = i;
    return _Utils_Tuple2(result, ls);
});

var _JsArray_unsafeGet = F2(function(index, array)
{
    return array[index];
});

var _JsArray_unsafeSet = F3(function(index, value, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[index] = value;
    return result;
});

var _JsArray_push = F2(function(value, array)
{
    var length = array.length;
    var result = new Array(length + 1);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[length] = value;
    return result;
});

var _JsArray_foldl = F3(function(func, acc, array)
{
    var length = array.length;

    for (var i = 0; i < length; i++)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_foldr = F3(function(func, acc, array)
{
    for (var i = array.length - 1; i >= 0; i--)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_map = F2(function(func, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = func(array[i]);
    }

    return result;
});

var _JsArray_indexedMap = F3(function(func, offset, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = A2(func, offset + i, array[i]);
    }

    return result;
});

var _JsArray_slice = F3(function(from, to, array)
{
    return array.slice(from, to);
});

var _JsArray_appendN = F3(function(n, dest, source)
{
    var destLen = dest.length;
    var itemsToCopy = n - destLen;

    if (itemsToCopy > source.length)
    {
        itemsToCopy = source.length;
    }

    var size = destLen + itemsToCopy;
    var result = new Array(size);

    for (var i = 0; i < destLen; i++)
    {
        result[i] = dest[i];
    }

    for (var i = 0; i < itemsToCopy; i++)
    {
        result[i + destLen] = source[i];
    }

    return result;
});



var _List_Nil = { $: 0 };
var _List_Nil_UNUSED = { $: '[]' };

function _List_Cons(hd, tl) { return { $: 1, a: hd, b: tl }; }
function _List_Cons_UNUSED(hd, tl) { return { $: '::', a: hd, b: tl }; }


var _List_cons = F2(_List_Cons);

function _List_fromArray(arr)
{
	var out = _List_Nil;
	for (var i = arr.length; i--; )
	{
		out = _List_Cons(arr[i], out);
	}
	return out;
}

function _List_toArray(xs)
{
	for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
	{
		out.push(xs.a);
	}
	return out;
}

var _List_map2 = F3(function(f, xs, ys)
{
	for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
	{
		arr.push(A2(f, xs.a, ys.a));
	}
	return _List_fromArray(arr);
});

var _List_map3 = F4(function(f, xs, ys, zs)
{
	for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A3(f, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map4 = F5(function(f, ws, xs, ys, zs)
{
	for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
{
	for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_sortBy = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		return _Utils_cmp(f(a), f(b));
	}));
});

var _List_sortWith = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		var ord = A2(f, a, b);
		return ord === elm$core$Basics$EQ ? 0 : ord === elm$core$Basics$LT ? -1 : 1;
	}));
});



// LOG

var _Debug_log = F2(function(tag, value)
{
	return value;
});

var _Debug_log_UNUSED = F2(function(tag, value)
{
	console.log(tag + ': ' + _Debug_toString(value));
	return value;
});


// TODOS

function _Debug_todo(moduleName, region)
{
	return function(message) {
		_Debug_crash(8, moduleName, region, message);
	};
}

function _Debug_todoCase(moduleName, region, value)
{
	return function(message) {
		_Debug_crash(9, moduleName, region, value, message);
	};
}


// TO STRING

function _Debug_toString(value)
{
	return '<internals>';
}

function _Debug_toString_UNUSED(value)
{
	return _Debug_toAnsiString(false, value);
}

function _Debug_toAnsiString(ansi, value)
{
	if (typeof value === 'function')
	{
		return _Debug_internalColor(ansi, '<function>');
	}

	if (typeof value === 'boolean')
	{
		return _Debug_ctorColor(ansi, value ? 'True' : 'False');
	}

	if (typeof value === 'number')
	{
		return _Debug_numberColor(ansi, value + '');
	}

	if (value instanceof String)
	{
		return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
	}

	if (typeof value === 'string')
	{
		return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
	}

	if (typeof value === 'object' && '$' in value)
	{
		var tag = value.$;

		if (typeof tag === 'number')
		{
			return _Debug_internalColor(ansi, '<internals>');
		}

		if (tag[0] === '#')
		{
			var output = [];
			for (var k in value)
			{
				if (k === '$') continue;
				output.push(_Debug_toAnsiString(ansi, value[k]));
			}
			return '(' + output.join(',') + ')';
		}

		if (tag === 'Set_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Set')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, elm$core$Set$toList(value));
		}

		if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Dict')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, elm$core$Dict$toList(value));
		}

		if (tag === 'Array_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Array')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, elm$core$Array$toList(value));
		}

		if (tag === '::' || tag === '[]')
		{
			var output = '[';

			value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)

			for (; value.b; value = value.b) // WHILE_CONS
			{
				output += ',' + _Debug_toAnsiString(ansi, value.a);
			}
			return output + ']';
		}

		var output = '';
		for (var i in value)
		{
			if (i === '$') continue;
			var str = _Debug_toAnsiString(ansi, value[i]);
			var c0 = str[0];
			var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
			output += ' ' + (parenless ? str : '(' + str + ')');
		}
		return _Debug_ctorColor(ansi, tag) + output;
	}

	if (typeof DataView === 'function' && value instanceof DataView)
	{
		return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
	}

	if (typeof File === 'function' && value instanceof File)
	{
		return _Debug_internalColor(ansi, '<' + value.name + '>');
	}

	if (typeof value === 'object')
	{
		var output = [];
		for (var key in value)
		{
			var field = key[0] === '_' ? key.slice(1) : key;
			output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
		}
		if (output.length === 0)
		{
			return '{}';
		}
		return '{ ' + output.join(', ') + ' }';
	}

	return _Debug_internalColor(ansi, '<internals>');
}

function _Debug_addSlashes(str, isChar)
{
	var s = str
		.replace(/\\/g, '\\\\')
		.replace(/\n/g, '\\n')
		.replace(/\t/g, '\\t')
		.replace(/\r/g, '\\r')
		.replace(/\v/g, '\\v')
		.replace(/\0/g, '\\0');

	if (isChar)
	{
		return s.replace(/\'/g, '\\\'');
	}
	else
	{
		return s.replace(/\"/g, '\\"');
	}
}

function _Debug_ctorColor(ansi, string)
{
	return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
}

function _Debug_numberColor(ansi, string)
{
	return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
}

function _Debug_stringColor(ansi, string)
{
	return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
}

function _Debug_charColor(ansi, string)
{
	return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
}

function _Debug_fadeColor(ansi, string)
{
	return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
}

function _Debug_internalColor(ansi, string)
{
	return ansi ? '\x1b[94m' + string + '\x1b[0m' : string;
}

function _Debug_toHexDigit(n)
{
	return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
}


// CRASH


function _Debug_crash(identifier)
{
	throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
}


function _Debug_crash_UNUSED(identifier, fact1, fact2, fact3, fact4)
{
	switch(identifier)
	{
		case 0:
			throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');

		case 1:
			throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');

		case 2:
			var jsonErrorString = fact1;
			throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);

		case 3:
			var portName = fact1;
			throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');

		case 4:
			var portName = fact1;
			var problem = fact2;
			throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);

		case 5:
			throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');

		case 6:
			var moduleName = fact1;
			throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');

		case 8:
			var moduleName = fact1;
			var region = fact2;
			var message = fact3;
			throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);

		case 9:
			var moduleName = fact1;
			var region = fact2;
			var value = fact3;
			var message = fact4;
			throw new Error(
				'TODO in module `' + moduleName + '` from the `case` expression '
				+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
				+ _Debug_toString(value).replace('\n', '\n    ')
				+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
			);

		case 10:
			throw new Error('Bug in https://github.com/elm/virtual-dom/issues');

		case 11:
			throw new Error('Cannot perform mod 0. Division by zero error.');
	}
}

function _Debug_regionToString(region)
{
	if (region.fF.aV === region.ez.aV)
	{
		return 'on line ' + region.fF.aV;
	}
	return 'on lines ' + region.fF.aV + ' through ' + region.ez.aV;
}



// EQUALITY

function _Utils_eq(x, y)
{
	for (
		var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
		isEqual && (pair = stack.pop());
		isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
		)
	{}

	return isEqual;
}

function _Utils_eqHelp(x, y, depth, stack)
{
	if (depth > 100)
	{
		stack.push(_Utils_Tuple2(x,y));
		return true;
	}

	if (x === y)
	{
		return true;
	}

	if (typeof x !== 'object' || x === null || y === null)
	{
		typeof x === 'function' && _Debug_crash(5);
		return false;
	}

	/**_UNUSED/
	if (x.$ === 'Set_elm_builtin')
	{
		x = elm$core$Set$toList(x);
		y = elm$core$Set$toList(y);
	}
	if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
	{
		x = elm$core$Dict$toList(x);
		y = elm$core$Dict$toList(y);
	}
	//*/

	/**/
	if (x.$ < 0)
	{
		x = elm$core$Dict$toList(x);
		y = elm$core$Dict$toList(y);
	}
	//*/

	for (var key in x)
	{
		if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
		{
			return false;
		}
	}
	return true;
}

var _Utils_equal = F2(_Utils_eq);
var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });



// COMPARISONS

// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
// the particular integer values assigned to LT, EQ, and GT.

function _Utils_cmp(x, y, ord)
{
	if (typeof x !== 'object')
	{
		return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
	}

	/**_UNUSED/
	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? 0 : a < b ? -1 : 1;
	}
	//*/

	/**/
	if (typeof x.$ === 'undefined')
	//*/
	/**_UNUSED/
	if (x.$[0] === '#')
	//*/
	{
		return (ord = _Utils_cmp(x.a, y.a))
			? ord
			: (ord = _Utils_cmp(x.b, y.b))
				? ord
				: _Utils_cmp(x.c, y.c);
	}

	// traverse conses until end of a list or a mismatch
	for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
	return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
}

var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });

var _Utils_compare = F2(function(x, y)
{
	var n = _Utils_cmp(x, y);
	return n < 0 ? elm$core$Basics$LT : n ? elm$core$Basics$GT : elm$core$Basics$EQ;
});


// COMMON VALUES

var _Utils_Tuple0 = 0;
var _Utils_Tuple0_UNUSED = { $: '#0' };

function _Utils_Tuple2(a, b) { return { a: a, b: b }; }
function _Utils_Tuple2_UNUSED(a, b) { return { $: '#2', a: a, b: b }; }

function _Utils_Tuple3(a, b, c) { return { a: a, b: b, c: c }; }
function _Utils_Tuple3_UNUSED(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }

function _Utils_chr(c) { return c; }
function _Utils_chr_UNUSED(c) { return new String(c); }


// RECORDS

function _Utils_update(oldRecord, updatedFields)
{
	var newRecord = {};

	for (var key in oldRecord)
	{
		newRecord[key] = oldRecord[key];
	}

	for (var key in updatedFields)
	{
		newRecord[key] = updatedFields[key];
	}

	return newRecord;
}


// APPEND

var _Utils_append = F2(_Utils_ap);

function _Utils_ap(xs, ys)
{
	// append Strings
	if (typeof xs === 'string')
	{
		return xs + ys;
	}

	// append Lists
	if (!xs.b)
	{
		return ys;
	}
	var root = _List_Cons(xs.a, ys);
	xs = xs.b
	for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
	{
		curr = curr.b = _List_Cons(xs.a, ys);
	}
	return root;
}



// MATH

var _Basics_add = F2(function(a, b) { return a + b; });
var _Basics_sub = F2(function(a, b) { return a - b; });
var _Basics_mul = F2(function(a, b) { return a * b; });
var _Basics_fdiv = F2(function(a, b) { return a / b; });
var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
var _Basics_pow = F2(Math.pow);

var _Basics_remainderBy = F2(function(b, a) { return a % b; });

// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
var _Basics_modBy = F2(function(modulus, x)
{
	var answer = x % modulus;
	return modulus === 0
		? _Debug_crash(11)
		:
	((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
		? answer + modulus
		: answer;
});


// TRIGONOMETRY

var _Basics_pi = Math.PI;
var _Basics_e = Math.E;
var _Basics_cos = Math.cos;
var _Basics_sin = Math.sin;
var _Basics_tan = Math.tan;
var _Basics_acos = Math.acos;
var _Basics_asin = Math.asin;
var _Basics_atan = Math.atan;
var _Basics_atan2 = F2(Math.atan2);


// MORE MATH

function _Basics_toFloat(x) { return x; }
function _Basics_truncate(n) { return n | 0; }
function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }

var _Basics_ceiling = Math.ceil;
var _Basics_floor = Math.floor;
var _Basics_round = Math.round;
var _Basics_sqrt = Math.sqrt;
var _Basics_log = Math.log;
var _Basics_isNaN = isNaN;


// BOOLEANS

function _Basics_not(bool) { return !bool; }
var _Basics_and = F2(function(a, b) { return a && b; });
var _Basics_or  = F2(function(a, b) { return a || b; });
var _Basics_xor = F2(function(a, b) { return a !== b; });



var _String_cons = F2(function(chr, str)
{
	return chr + str;
});

function _String_uncons(string)
{
	var word = string.charCodeAt(0);
	return word
		? elm$core$Maybe$Just(
			0xD800 <= word && word <= 0xDBFF
				? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
				: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
		)
		: elm$core$Maybe$Nothing;
}

var _String_append = F2(function(a, b)
{
	return a + b;
});

function _String_length(str)
{
	return str.length;
}

var _String_map = F2(function(func, string)
{
	var len = string.length;
	var array = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = string.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			array[i] = func(_Utils_chr(string[i] + string[i+1]));
			i += 2;
			continue;
		}
		array[i] = func(_Utils_chr(string[i]));
		i++;
	}
	return array.join('');
});

var _String_filter = F2(function(isGood, str)
{
	var arr = [];
	var len = str.length;
	var i = 0;
	while (i < len)
	{
		var char = str[i];
		var word = str.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += str[i];
			i++;
		}

		if (isGood(_Utils_chr(char)))
		{
			arr.push(char);
		}
	}
	return arr.join('');
});

function _String_reverse(str)
{
	var len = str.length;
	var arr = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = str.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			arr[len - i] = str[i + 1];
			i++;
			arr[len - i] = str[i - 1];
			i++;
		}
		else
		{
			arr[len - i] = str[i];
			i++;
		}
	}
	return arr.join('');
}

var _String_foldl = F3(function(func, state, string)
{
	var len = string.length;
	var i = 0;
	while (i < len)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += string[i];
			i++;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_foldr = F3(function(func, state, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_split = F2(function(sep, str)
{
	return str.split(sep);
});

var _String_join = F2(function(sep, strs)
{
	return strs.join(sep);
});

var _String_slice = F3(function(start, end, str) {
	return str.slice(start, end);
});

function _String_trim(str)
{
	return str.trim();
}

function _String_trimLeft(str)
{
	return str.replace(/^\s+/, '');
}

function _String_trimRight(str)
{
	return str.replace(/\s+$/, '');
}

function _String_words(str)
{
	return _List_fromArray(str.trim().split(/\s+/g));
}

function _String_lines(str)
{
	return _List_fromArray(str.split(/\r\n|\r|\n/g));
}

function _String_toUpper(str)
{
	return str.toUpperCase();
}

function _String_toLower(str)
{
	return str.toLowerCase();
}

var _String_any = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (isGood(_Utils_chr(char)))
		{
			return true;
		}
	}
	return false;
});

var _String_all = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (!isGood(_Utils_chr(char)))
		{
			return false;
		}
	}
	return true;
});

var _String_contains = F2(function(sub, str)
{
	return str.indexOf(sub) > -1;
});

var _String_startsWith = F2(function(sub, str)
{
	return str.indexOf(sub) === 0;
});

var _String_endsWith = F2(function(sub, str)
{
	return str.length >= sub.length &&
		str.lastIndexOf(sub) === str.length - sub.length;
});

var _String_indexes = F2(function(sub, str)
{
	var subLen = sub.length;

	if (subLen < 1)
	{
		return _List_Nil;
	}

	var i = 0;
	var is = [];

	while ((i = str.indexOf(sub, i)) > -1)
	{
		is.push(i);
		i = i + subLen;
	}

	return _List_fromArray(is);
});


// TO STRING

function _String_fromNumber(number)
{
	return number + '';
}


// INT CONVERSIONS

function _String_toInt(str)
{
	var total = 0;
	var code0 = str.charCodeAt(0);
	var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;

	for (var i = start; i < str.length; ++i)
	{
		var code = str.charCodeAt(i);
		if (code < 0x30 || 0x39 < code)
		{
			return elm$core$Maybe$Nothing;
		}
		total = 10 * total + code - 0x30;
	}

	return i == start
		? elm$core$Maybe$Nothing
		: elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
}


// FLOAT CONVERSIONS

function _String_toFloat(s)
{
	// check if it is a hex, octal, or binary number
	if (s.length === 0 || /[\sxbo]/.test(s))
	{
		return elm$core$Maybe$Nothing;
	}
	var n = +s;
	// faster isNaN check
	return n === n ? elm$core$Maybe$Just(n) : elm$core$Maybe$Nothing;
}

function _String_fromList(chars)
{
	return _List_toArray(chars).join('');
}




function _Char_toCode(char)
{
	var code = char.charCodeAt(0);
	if (0xD800 <= code && code <= 0xDBFF)
	{
		return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
	}
	return code;
}

function _Char_fromCode(code)
{
	return _Utils_chr(
		(code < 0 || 0x10FFFF < code)
			? '\uFFFD'
			:
		(code <= 0xFFFF)
			? String.fromCharCode(code)
			:
		(code -= 0x10000,
			String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
		)
	);
}

function _Char_toUpper(char)
{
	return _Utils_chr(char.toUpperCase());
}

function _Char_toLower(char)
{
	return _Utils_chr(char.toLowerCase());
}

function _Char_toLocaleUpper(char)
{
	return _Utils_chr(char.toLocaleUpperCase());
}

function _Char_toLocaleLower(char)
{
	return _Utils_chr(char.toLocaleLowerCase());
}



/**_UNUSED/
function _Json_errorToString(error)
{
	return elm$json$Json$Decode$errorToString(error);
}
//*/


// CORE DECODERS

function _Json_succeed(msg)
{
	return {
		$: 0,
		a: msg
	};
}

function _Json_fail(msg)
{
	return {
		$: 1,
		a: msg
	};
}

function _Json_decodePrim(decoder)
{
	return { $: 2, b: decoder };
}

var _Json_decodeInt = _Json_decodePrim(function(value) {
	return (typeof value !== 'number')
		? _Json_expecting('an INT', value)
		:
	(-2147483647 < value && value < 2147483647 && (value | 0) === value)
		? elm$core$Result$Ok(value)
		:
	(isFinite(value) && !(value % 1))
		? elm$core$Result$Ok(value)
		: _Json_expecting('an INT', value);
});

var _Json_decodeBool = _Json_decodePrim(function(value) {
	return (typeof value === 'boolean')
		? elm$core$Result$Ok(value)
		: _Json_expecting('a BOOL', value);
});

var _Json_decodeFloat = _Json_decodePrim(function(value) {
	return (typeof value === 'number')
		? elm$core$Result$Ok(value)
		: _Json_expecting('a FLOAT', value);
});

var _Json_decodeValue = _Json_decodePrim(function(value) {
	return elm$core$Result$Ok(_Json_wrap(value));
});

var _Json_decodeString = _Json_decodePrim(function(value) {
	return (typeof value === 'string')
		? elm$core$Result$Ok(value)
		: (value instanceof String)
			? elm$core$Result$Ok(value + '')
			: _Json_expecting('a STRING', value);
});

function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }

function _Json_decodeNull(value) { return { $: 5, c: value }; }

var _Json_decodeField = F2(function(field, decoder)
{
	return {
		$: 6,
		d: field,
		b: decoder
	};
});

var _Json_decodeIndex = F2(function(index, decoder)
{
	return {
		$: 7,
		e: index,
		b: decoder
	};
});

function _Json_decodeKeyValuePairs(decoder)
{
	return {
		$: 8,
		b: decoder
	};
}

function _Json_mapMany(f, decoders)
{
	return {
		$: 9,
		f: f,
		g: decoders
	};
}

var _Json_andThen = F2(function(callback, decoder)
{
	return {
		$: 10,
		b: decoder,
		h: callback
	};
});

function _Json_oneOf(decoders)
{
	return {
		$: 11,
		g: decoders
	};
}


// DECODING OBJECTS

var _Json_map1 = F2(function(f, d1)
{
	return _Json_mapMany(f, [d1]);
});

var _Json_map2 = F3(function(f, d1, d2)
{
	return _Json_mapMany(f, [d1, d2]);
});

var _Json_map3 = F4(function(f, d1, d2, d3)
{
	return _Json_mapMany(f, [d1, d2, d3]);
});

var _Json_map4 = F5(function(f, d1, d2, d3, d4)
{
	return _Json_mapMany(f, [d1, d2, d3, d4]);
});

var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
});

var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
});

var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
});

var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
});


// DECODE

var _Json_runOnString = F2(function(decoder, string)
{
	try
	{
		var value = JSON.parse(string);
		return _Json_runHelp(decoder, value);
	}
	catch (e)
	{
		return elm$core$Result$Err(A2(elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
	}
});

var _Json_run = F2(function(decoder, value)
{
	return _Json_runHelp(decoder, _Json_unwrap(value));
});

function _Json_runHelp(decoder, value)
{
	switch (decoder.$)
	{
		case 2:
			return decoder.b(value);

		case 5:
			return (value === null)
				? elm$core$Result$Ok(decoder.c)
				: _Json_expecting('null', value);

		case 3:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('a LIST', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);

		case 4:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);

		case 6:
			var field = decoder.d;
			if (typeof value !== 'object' || value === null || !(field in value))
			{
				return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
			}
			var result = _Json_runHelp(decoder.b, value[field]);
			return (elm$core$Result$isOk(result)) ? result : elm$core$Result$Err(A2(elm$json$Json$Decode$Field, field, result.a));

		case 7:
			var index = decoder.e;
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			if (index >= value.length)
			{
				return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
			}
			var result = _Json_runHelp(decoder.b, value[index]);
			return (elm$core$Result$isOk(result)) ? result : elm$core$Result$Err(A2(elm$json$Json$Decode$Index, index, result.a));

		case 8:
			if (typeof value !== 'object' || value === null || _Json_isArray(value))
			{
				return _Json_expecting('an OBJECT', value);
			}

			var keyValuePairs = _List_Nil;
			// TODO test perf of Object.keys and switch when support is good enough
			for (var key in value)
			{
				if (value.hasOwnProperty(key))
				{
					var result = _Json_runHelp(decoder.b, value[key]);
					if (!elm$core$Result$isOk(result))
					{
						return elm$core$Result$Err(A2(elm$json$Json$Decode$Field, key, result.a));
					}
					keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
				}
			}
			return elm$core$Result$Ok(elm$core$List$reverse(keyValuePairs));

		case 9:
			var answer = decoder.f;
			var decoders = decoder.g;
			for (var i = 0; i < decoders.length; i++)
			{
				var result = _Json_runHelp(decoders[i], value);
				if (!elm$core$Result$isOk(result))
				{
					return result;
				}
				answer = answer(result.a);
			}
			return elm$core$Result$Ok(answer);

		case 10:
			var result = _Json_runHelp(decoder.b, value);
			return (!elm$core$Result$isOk(result))
				? result
				: _Json_runHelp(decoder.h(result.a), value);

		case 11:
			var errors = _List_Nil;
			for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
			{
				var result = _Json_runHelp(temp.a, value);
				if (elm$core$Result$isOk(result))
				{
					return result;
				}
				errors = _List_Cons(result.a, errors);
			}
			return elm$core$Result$Err(elm$json$Json$Decode$OneOf(elm$core$List$reverse(errors)));

		case 1:
			return elm$core$Result$Err(A2(elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));

		case 0:
			return elm$core$Result$Ok(decoder.a);
	}
}

function _Json_runArrayDecoder(decoder, value, toElmValue)
{
	var len = value.length;
	var array = new Array(len);
	for (var i = 0; i < len; i++)
	{
		var result = _Json_runHelp(decoder, value[i]);
		if (!elm$core$Result$isOk(result))
		{
			return elm$core$Result$Err(A2(elm$json$Json$Decode$Index, i, result.a));
		}
		array[i] = result.a;
	}
	return elm$core$Result$Ok(toElmValue(array));
}

function _Json_isArray(value)
{
	return Array.isArray(value) || (typeof FileList === 'function' && value instanceof FileList);
}

function _Json_toElmArray(array)
{
	return A2(elm$core$Array$initialize, array.length, function(i) { return array[i]; });
}

function _Json_expecting(type, value)
{
	return elm$core$Result$Err(A2(elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
}


// EQUALITY

function _Json_equality(x, y)
{
	if (x === y)
	{
		return true;
	}

	if (x.$ !== y.$)
	{
		return false;
	}

	switch (x.$)
	{
		case 0:
		case 1:
			return x.a === y.a;

		case 2:
			return x.b === y.b;

		case 5:
			return x.c === y.c;

		case 3:
		case 4:
		case 8:
			return _Json_equality(x.b, y.b);

		case 6:
			return x.d === y.d && _Json_equality(x.b, y.b);

		case 7:
			return x.e === y.e && _Json_equality(x.b, y.b);

		case 9:
			return x.f === y.f && _Json_listEquality(x.g, y.g);

		case 10:
			return x.h === y.h && _Json_equality(x.b, y.b);

		case 11:
			return _Json_listEquality(x.g, y.g);
	}
}

function _Json_listEquality(aDecoders, bDecoders)
{
	var len = aDecoders.length;
	if (len !== bDecoders.length)
	{
		return false;
	}
	for (var i = 0; i < len; i++)
	{
		if (!_Json_equality(aDecoders[i], bDecoders[i]))
		{
			return false;
		}
	}
	return true;
}


// ENCODE

var _Json_encode = F2(function(indentLevel, value)
{
	return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
});

function _Json_wrap_UNUSED(value) { return { $: 0, a: value }; }
function _Json_unwrap_UNUSED(value) { return value.a; }

function _Json_wrap(value) { return value; }
function _Json_unwrap(value) { return value; }

function _Json_emptyArray() { return []; }
function _Json_emptyObject() { return {}; }

var _Json_addField = F3(function(key, value, object)
{
	object[key] = _Json_unwrap(value);
	return object;
});

function _Json_addEntry(func)
{
	return F2(function(entry, array)
	{
		array.push(_Json_unwrap(func(entry)));
		return array;
	});
}

var _Json_encodeNull = _Json_wrap(null);




// STRINGS


var _Parser_isSubString = F5(function(smallString, offset, row, col, bigString)
{
	var smallLength = smallString.length;
	var isGood = offset + smallLength <= bigString.length;

	for (var i = 0; isGood && i < smallLength; )
	{
		var code = bigString.charCodeAt(offset);
		isGood =
			smallString[i++] === bigString[offset++]
			&& (
				code === 0x000A /* \n */
					? ( row++, col=1 )
					: ( col++, (code & 0xF800) === 0xD800 ? smallString[i++] === bigString[offset++] : 1 )
			)
	}

	return _Utils_Tuple3(isGood ? offset : -1, row, col);
});



// CHARS


var _Parser_isSubChar = F3(function(predicate, offset, string)
{
	return (
		string.length <= offset
			? -1
			:
		(string.charCodeAt(offset) & 0xF800) === 0xD800
			? (predicate(_Utils_chr(string.substr(offset, 2))) ? offset + 2 : -1)
			:
		(predicate(_Utils_chr(string[offset]))
			? ((string[offset] === '\n') ? -2 : (offset + 1))
			: -1
		)
	);
});


var _Parser_isAsciiCode = F3(function(code, offset, string)
{
	return string.charCodeAt(offset) === code;
});



// NUMBERS


var _Parser_chompBase10 = F2(function(offset, string)
{
	for (; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (code < 0x30 || 0x39 < code)
		{
			return offset;
		}
	}
	return offset;
});


var _Parser_consumeBase = F3(function(base, offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var digit = string.charCodeAt(offset) - 0x30;
		if (digit < 0 || base <= digit) break;
		total = base * total + digit;
	}
	return _Utils_Tuple2(offset, total);
});


var _Parser_consumeBase16 = F2(function(offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (0x30 <= code && code <= 0x39)
		{
			total = 16 * total + code - 0x30;
		}
		else if (0x41 <= code && code <= 0x46)
		{
			total = 16 * total + code - 55;
		}
		else if (0x61 <= code && code <= 0x66)
		{
			total = 16 * total + code - 87;
		}
		else
		{
			break;
		}
	}
	return _Utils_Tuple2(offset, total);
});



// FIND STRING


var _Parser_findSubString = F5(function(smallString, offset, row, col, bigString)
{
	var newOffset = bigString.indexOf(smallString, offset);
	var target = newOffset < 0 ? bigString.length : newOffset + smallString.length;

	while (offset < target)
	{
		var code = bigString.charCodeAt(offset++);
		code === 0x000A /* \n */
			? ( col=1, row++ )
			: ( col++, (code & 0xF800) === 0xD800 && offset++ )
	}

	return _Utils_Tuple3(newOffset, row, col);
});



var _Bitwise_and = F2(function(a, b)
{
	return a & b;
});

var _Bitwise_or = F2(function(a, b)
{
	return a | b;
});

var _Bitwise_xor = F2(function(a, b)
{
	return a ^ b;
});

function _Bitwise_complement(a)
{
	return ~a;
};

var _Bitwise_shiftLeftBy = F2(function(offset, a)
{
	return a << offset;
});

var _Bitwise_shiftRightBy = F2(function(offset, a)
{
	return a >> offset;
});

var _Bitwise_shiftRightZfBy = F2(function(offset, a)
{
	return a >>> offset;
});



// TASKS

function _Scheduler_succeed(value)
{
	return {
		$: 0,
		a: value
	};
}

function _Scheduler_fail(error)
{
	return {
		$: 1,
		a: error
	};
}

function _Scheduler_binding(callback)
{
	return {
		$: 2,
		b: callback,
		c: null
	};
}

var _Scheduler_andThen = F2(function(callback, task)
{
	return {
		$: 3,
		b: callback,
		d: task
	};
});

var _Scheduler_onError = F2(function(callback, task)
{
	return {
		$: 4,
		b: callback,
		d: task
	};
});

function _Scheduler_receive(callback)
{
	return {
		$: 5,
		b: callback
	};
}


// PROCESSES

var _Scheduler_guid = 0;

function _Scheduler_rawSpawn(task)
{
	var proc = {
		$: 0,
		e: _Scheduler_guid++,
		f: task,
		g: null,
		h: []
	};

	_Scheduler_enqueue(proc);

	return proc;
}

function _Scheduler_spawn(task)
{
	return _Scheduler_binding(function(callback) {
		callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
	});
}

function _Scheduler_rawSend(proc, msg)
{
	proc.h.push(msg);
	_Scheduler_enqueue(proc);
}

var _Scheduler_send = F2(function(proc, msg)
{
	return _Scheduler_binding(function(callback) {
		_Scheduler_rawSend(proc, msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});

function _Scheduler_kill(proc)
{
	return _Scheduler_binding(function(callback) {
		var task = proc.f;
		if (task.$ === 2 && task.c)
		{
			task.c();
		}

		proc.f = null;

		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
}


/* STEP PROCESSES

type alias Process =
  { $ : tag
  , id : unique_id
  , root : Task
  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
  , mailbox : [msg]
  }

*/


var _Scheduler_working = false;
var _Scheduler_queue = [];


function _Scheduler_enqueue(proc)
{
	_Scheduler_queue.push(proc);
	if (_Scheduler_working)
	{
		return;
	}
	_Scheduler_working = true;
	while (proc = _Scheduler_queue.shift())
	{
		_Scheduler_step(proc);
	}
	_Scheduler_working = false;
}


function _Scheduler_step(proc)
{
	while (proc.f)
	{
		var rootTag = proc.f.$;
		if (rootTag === 0 || rootTag === 1)
		{
			while (proc.g && proc.g.$ !== rootTag)
			{
				proc.g = proc.g.i;
			}
			if (!proc.g)
			{
				return;
			}
			proc.f = proc.g.b(proc.f.a);
			proc.g = proc.g.i;
		}
		else if (rootTag === 2)
		{
			proc.f.c = proc.f.b(function(newRoot) {
				proc.f = newRoot;
				_Scheduler_enqueue(proc);
			});
			return;
		}
		else if (rootTag === 5)
		{
			if (proc.h.length === 0)
			{
				return;
			}
			proc.f = proc.f.b(proc.h.shift());
		}
		else // if (rootTag === 3 || rootTag === 4)
		{
			proc.g = {
				$: rootTag === 3 ? 0 : 1,
				b: proc.f.b,
				i: proc.g
			};
			proc.f = proc.f.d;
		}
	}
}



function _Process_sleep(time)
{
	return _Scheduler_binding(function(callback) {
		var id = setTimeout(function() {
			callback(_Scheduler_succeed(_Utils_Tuple0));
		}, time);

		return function() { clearTimeout(id); };
	});
}




// PROGRAMS


var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.eQ,
		impl.fY,
		impl.fJ,
		function() { return function() {} }
	);
});



// INITIALIZE A PROGRAM


function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
{
	var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
	elm$core$Result$isOk(result) || _Debug_crash(2 /**_UNUSED/, _Json_errorToString(result.a) /**/);
	var managers = {};
	result = init(result.a);
	var model = result.a;
	var stepper = stepperBuilder(sendToApp, model);
	var ports = _Platform_setupEffects(managers, sendToApp);

	function sendToApp(msg, viewMetadata)
	{
		result = A2(update, msg, model);
		stepper(model = result.a, viewMetadata);
		_Platform_dispatchEffects(managers, result.b, subscriptions(model));
	}

	_Platform_dispatchEffects(managers, result.b, subscriptions(model));

	return ports ? { ports: ports } : {};
}



// TRACK PRELOADS
//
// This is used by code in elm/browser and elm/http
// to register any HTTP requests that are triggered by init.
//


var _Platform_preload;


function _Platform_registerPreload(url)
{
	_Platform_preload.add(url);
}



// EFFECT MANAGERS


var _Platform_effectManagers = {};


function _Platform_setupEffects(managers, sendToApp)
{
	var ports;

	// setup all necessary effect managers
	for (var key in _Platform_effectManagers)
	{
		var manager = _Platform_effectManagers[key];

		if (manager.a)
		{
			ports = ports || {};
			ports[key] = manager.a(key, sendToApp);
		}

		managers[key] = _Platform_instantiateManager(manager, sendToApp);
	}

	return ports;
}


function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
{
	return {
		b: init,
		c: onEffects,
		d: onSelfMsg,
		e: cmdMap,
		f: subMap
	};
}


function _Platform_instantiateManager(info, sendToApp)
{
	var router = {
		g: sendToApp,
		h: undefined
	};

	var onEffects = info.c;
	var onSelfMsg = info.d;
	var cmdMap = info.e;
	var subMap = info.f;

	function loop(state)
	{
		return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
		{
			var value = msg.a;

			if (msg.$ === 0)
			{
				return A3(onSelfMsg, router, value, state);
			}

			return cmdMap && subMap
				? A4(onEffects, router, value.i, value.j, state)
				: A3(onEffects, router, cmdMap ? value.i : value.j, state);
		}));
	}

	return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
}



// ROUTING


var _Platform_sendToApp = F2(function(router, msg)
{
	return _Scheduler_binding(function(callback)
	{
		router.g(msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});


var _Platform_sendToSelf = F2(function(router, msg)
{
	return A2(_Scheduler_send, router.h, {
		$: 0,
		a: msg
	});
});



// BAGS


function _Platform_leaf(home)
{
	return function(value)
	{
		return {
			$: 1,
			k: home,
			l: value
		};
	};
}


function _Platform_batch(list)
{
	return {
		$: 2,
		m: list
	};
}


var _Platform_map = F2(function(tagger, bag)
{
	return {
		$: 3,
		n: tagger,
		o: bag
	}
});



// PIPE BAGS INTO EFFECT MANAGERS


function _Platform_dispatchEffects(managers, cmdBag, subBag)
{
	var effectsDict = {};
	_Platform_gatherEffects(true, cmdBag, effectsDict, null);
	_Platform_gatherEffects(false, subBag, effectsDict, null);

	for (var home in managers)
	{
		_Scheduler_rawSend(managers[home], {
			$: 'fx',
			a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
		});
	}
}


function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
{
	switch (bag.$)
	{
		case 1:
			var home = bag.k;
			var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
			effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
			return;

		case 2:
			for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
			{
				_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
			}
			return;

		case 3:
			_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
				p: bag.n,
				q: taggers
			});
			return;
	}
}


function _Platform_toEffect(isCmd, home, taggers, value)
{
	function applyTaggers(x)
	{
		for (var temp = taggers; temp; temp = temp.q)
		{
			x = temp.p(x);
		}
		return x;
	}

	var map = isCmd
		? _Platform_effectManagers[home].e
		: _Platform_effectManagers[home].f;

	return A2(map, applyTaggers, value)
}


function _Platform_insert(isCmd, newEffect, effects)
{
	effects = effects || { i: _List_Nil, j: _List_Nil };

	isCmd
		? (effects.i = _List_Cons(newEffect, effects.i))
		: (effects.j = _List_Cons(newEffect, effects.j));

	return effects;
}



// PORTS


function _Platform_checkPortName(name)
{
	if (_Platform_effectManagers[name])
	{
		_Debug_crash(3, name)
	}
}



// OUTGOING PORTS


function _Platform_outgoingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		e: _Platform_outgoingPortMap,
		r: converter,
		a: _Platform_setupOutgoingPort
	};
	return _Platform_leaf(name);
}


var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });


function _Platform_setupOutgoingPort(name)
{
	var subs = [];
	var converter = _Platform_effectManagers[name].r;

	// CREATE MANAGER

	var init = _Process_sleep(0);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
	{
		for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
		{
			// grab a separate reference to subs in case unsubscribe is called
			var currentSubs = subs;
			var value = _Json_unwrap(converter(cmdList.a));
			for (var i = 0; i < currentSubs.length; i++)
			{
				currentSubs[i](value);
			}
		}
		return init;
	});

	// PUBLIC API

	function subscribe(callback)
	{
		subs.push(callback);
	}

	function unsubscribe(callback)
	{
		// copy subs into a new array in case unsubscribe is called within a
		// subscribed callback
		subs = subs.slice();
		var index = subs.indexOf(callback);
		if (index >= 0)
		{
			subs.splice(index, 1);
		}
	}

	return {
		subscribe: subscribe,
		unsubscribe: unsubscribe
	};
}



// INCOMING PORTS


function _Platform_incomingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		f: _Platform_incomingPortMap,
		r: converter,
		a: _Platform_setupIncomingPort
	};
	return _Platform_leaf(name);
}


var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
{
	return function(value)
	{
		return tagger(finalTagger(value));
	};
});


function _Platform_setupIncomingPort(name, sendToApp)
{
	var subs = _List_Nil;
	var converter = _Platform_effectManagers[name].r;

	// CREATE MANAGER

	var init = _Scheduler_succeed(null);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, subList, state)
	{
		subs = subList;
		return init;
	});

	// PUBLIC API

	function send(incomingValue)
	{
		var result = A2(_Json_run, converter, _Json_wrap(incomingValue));

		elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);

		var value = result.a;
		for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
		{
			sendToApp(temp.a(value));
		}
	}

	return { send: send };
}



// EXPORT ELM MODULES
//
// Have DEBUG and PROD versions so that we can (1) give nicer errors in
// debug mode and (2) not pay for the bits needed for that in prod mode.
//


function _Platform_export(exports)
{
	scope['Elm']
		? _Platform_mergeExportsProd(scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsProd(obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6)
				: _Platform_mergeExportsProd(obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}


function _Platform_export_UNUSED(exports)
{
	scope['Elm']
		? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsDebug(moduleName, obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6, moduleName)
				: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}



// SEND REQUEST

var _Http_toTask = F3(function(router, toTask, request)
{
	return _Scheduler_binding(function(callback)
	{
		function done(response) {
			callback(toTask(request.z.a(response)));
		}

		var xhr = new XMLHttpRequest();
		xhr.addEventListener('error', function() { done(elm$http$Http$NetworkError_); });
		xhr.addEventListener('timeout', function() { done(elm$http$Http$Timeout_); });
		xhr.addEventListener('load', function() { done(_Http_toResponse(request.z.b, xhr)); });
		elm$core$Maybe$isJust(request.aJ) && _Http_track(router, xhr, request.aJ.a);

		try {
			xhr.open(request.aw, request.B, true);
		} catch (e) {
			return done(elm$http$Http$BadUrl_(request.B));
		}

		_Http_configureRequest(xhr, request);

		request.cZ.a && xhr.setRequestHeader('Content-Type', request.cZ.a);
		xhr.send(request.cZ.b);

		return function() { xhr.c = true; xhr.abort(); };
	});
});


// CONFIGURE

function _Http_configureRequest(xhr, request)
{
	for (var headers = request.as; headers.b; headers = headers.b) // WHILE_CONS
	{
		xhr.setRequestHeader(headers.a.a, headers.a.b);
	}
	xhr.timeout = request.aH.a || 0;
	xhr.responseType = request.z.d;
	xhr.withCredentials = request.ao;
}


// RESPONSES

function _Http_toResponse(toBody, xhr)
{
	return A2(
		200 <= xhr.status && xhr.status < 300 ? elm$http$Http$GoodStatus_ : elm$http$Http$BadStatus_,
		_Http_toMetadata(xhr),
		toBody(xhr.response)
	);
}


// METADATA

function _Http_toMetadata(xhr)
{
	return {
		B: xhr.responseURL,
		cF: xhr.status,
		fG: xhr.statusText,
		as: _Http_parseHeaders(xhr.getAllResponseHeaders())
	};
}


// HEADERS

function _Http_parseHeaders(rawHeaders)
{
	if (!rawHeaders)
	{
		return elm$core$Dict$empty;
	}

	var headers = elm$core$Dict$empty;
	var headerPairs = rawHeaders.split('\r\n');
	for (var i = headerPairs.length; i--; )
	{
		var headerPair = headerPairs[i];
		var index = headerPair.indexOf(': ');
		if (index > 0)
		{
			var key = headerPair.substring(0, index);
			var value = headerPair.substring(index + 2);

			headers = A3(elm$core$Dict$update, key, function(oldValue) {
				return elm$core$Maybe$Just(elm$core$Maybe$isJust(oldValue)
					? value + ', ' + oldValue.a
					: value
				);
			}, headers);
		}
	}
	return headers;
}


// EXPECT

var _Http_expect = F3(function(type, toBody, toValue)
{
	return {
		$: 0,
		d: type,
		b: toBody,
		a: toValue
	};
});

var _Http_mapExpect = F2(function(func, expect)
{
	return {
		$: 0,
		d: expect.d,
		b: expect.b,
		a: function(x) { return func(expect.a(x)); }
	};
});

function _Http_toDataView(arrayBuffer)
{
	return new DataView(arrayBuffer);
}


// BODY and PARTS

var _Http_emptyBody = { $: 0 };
var _Http_pair = F2(function(a, b) { return { $: 0, a: a, b: b }; });

function _Http_toFormData(parts)
{
	for (var formData = new FormData(); parts.b; parts = parts.b) // WHILE_CONS
	{
		var part = parts.a;
		formData.append(part.a, part.b);
	}
	return formData;
}

var _Http_bytesToBlob = F2(function(mime, bytes)
{
	return new Blob([bytes], { type: mime });
});


// PROGRESS

function _Http_track(router, xhr, tracker)
{
	// TODO check out lengthComputable on loadstart event

	xhr.upload.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2(elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, elm$http$Http$Sending({
			fz: event.loaded,
			fC: event.total
		}))));
	});
	xhr.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2(elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, elm$http$Http$Receiving({
			fp: event.loaded,
			fC: event.lengthComputable ? elm$core$Maybe$Just(event.total) : elm$core$Maybe$Nothing
		}))));
	});
}

function _Url_percentEncode(string)
{
	return encodeURIComponent(string);
}

function _Url_percentDecode(string)
{
	try
	{
		return elm$core$Maybe$Just(decodeURIComponent(string));
	}
	catch (e)
	{
		return elm$core$Maybe$Nothing;
	}
}



// HELPERS


var _VirtualDom_divertHrefToApp;

var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};


function _VirtualDom_appendChild(parent, child)
{
	parent.appendChild(child);
}

var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
{
	// NOTE: this function needs _Platform_export available to work

	/**/
	var node = args['node'];
	//*/
	/**_UNUSED/
	var node = args && args['node'] ? args['node'] : _Debug_crash(0);
	//*/

	node.parentNode.replaceChild(
		_VirtualDom_render(virtualNode, function() {}),
		node
	);

	return {};
});



// TEXT


function _VirtualDom_text(string)
{
	return {
		$: 0,
		a: string
	};
}



// NODE


var _VirtualDom_nodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 1,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_node = _VirtualDom_nodeNS(undefined);



// KEYED NODE


var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 2,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);



// CUSTOM


function _VirtualDom_custom(factList, model, render, diff)
{
	return {
		$: 3,
		d: _VirtualDom_organizeFacts(factList),
		g: model,
		h: render,
		i: diff
	};
}



// MAP


var _VirtualDom_map = F2(function(tagger, node)
{
	return {
		$: 4,
		j: tagger,
		k: node,
		b: 1 + (node.b || 0)
	};
});



// LAZY


function _VirtualDom_thunk(refs, thunk)
{
	return {
		$: 5,
		l: refs,
		m: thunk,
		k: undefined
	};
}

var _VirtualDom_lazy = F2(function(func, a)
{
	return _VirtualDom_thunk([func, a], function() {
		return func(a);
	});
});

var _VirtualDom_lazy2 = F3(function(func, a, b)
{
	return _VirtualDom_thunk([func, a, b], function() {
		return A2(func, a, b);
	});
});

var _VirtualDom_lazy3 = F4(function(func, a, b, c)
{
	return _VirtualDom_thunk([func, a, b, c], function() {
		return A3(func, a, b, c);
	});
});

var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
{
	return _VirtualDom_thunk([func, a, b, c, d], function() {
		return A4(func, a, b, c, d);
	});
});

var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
{
	return _VirtualDom_thunk([func, a, b, c, d, e], function() {
		return A5(func, a, b, c, d, e);
	});
});

var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
		return A6(func, a, b, c, d, e, f);
	});
});

var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
		return A7(func, a, b, c, d, e, f, g);
	});
});

var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
		return A8(func, a, b, c, d, e, f, g, h);
	});
});



// FACTS


var _VirtualDom_on = F2(function(key, handler)
{
	return {
		$: 'a0',
		n: key,
		o: handler
	};
});
var _VirtualDom_style = F2(function(key, value)
{
	return {
		$: 'a1',
		n: key,
		o: value
	};
});
var _VirtualDom_property = F2(function(key, value)
{
	return {
		$: 'a2',
		n: key,
		o: value
	};
});
var _VirtualDom_attribute = F2(function(key, value)
{
	return {
		$: 'a3',
		n: key,
		o: value
	};
});
var _VirtualDom_attributeNS = F3(function(namespace, key, value)
{
	return {
		$: 'a4',
		n: key,
		o: { f: namespace, o: value }
	};
});



// XSS ATTACK VECTOR CHECKS


function _VirtualDom_noScript(tag)
{
	return tag == 'script' ? 'p' : tag;
}

function _VirtualDom_noOnOrFormAction(key)
{
	return /^(on|formAction$)/i.test(key) ? 'data-' + key : key;
}

function _VirtualDom_noInnerHtmlOrFormAction(key)
{
	return key == 'innerHTML' || key == 'formAction' ? 'data-' + key : key;
}

function _VirtualDom_noJavaScriptUri(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,'')) ? '' : value;
}

function _VirtualDom_noJavaScriptUri_UNUSED(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,''))
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlUri(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value) ? '' : value;
}

function _VirtualDom_noJavaScriptOrHtmlUri_UNUSED(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value)
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}



// MAP FACTS


var _VirtualDom_mapAttribute = F2(function(func, attr)
{
	return (attr.$ === 'a0')
		? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
		: attr;
});

function _VirtualDom_mapHandler(func, handler)
{
	var tag = elm$virtual_dom$VirtualDom$toHandlerInt(handler);

	// 0 = Normal
	// 1 = MayStopPropagation
	// 2 = MayPreventDefault
	// 3 = Custom

	return {
		$: handler.$,
		a:
			!tag
				? A2(elm$json$Json$Decode$map, func, handler.a)
				:
			A3(elm$json$Json$Decode$map2,
				tag < 3
					? _VirtualDom_mapEventTuple
					: _VirtualDom_mapEventRecord,
				elm$json$Json$Decode$succeed(func),
				handler.a
			)
	};
}

var _VirtualDom_mapEventTuple = F2(function(func, tuple)
{
	return _Utils_Tuple2(func(tuple.a), tuple.b);
});

var _VirtualDom_mapEventRecord = F2(function(func, record)
{
	return {
		T: func(record.T),
		cG: record.cG,
		ct: record.ct
	}
});



// ORGANIZE FACTS


function _VirtualDom_organizeFacts(factList)
{
	for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
	{
		var entry = factList.a;

		var tag = entry.$;
		var key = entry.n;
		var value = entry.o;

		if (tag === 'a2')
		{
			(key === 'className')
				? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
				: facts[key] = _Json_unwrap(value);

			continue;
		}

		var subFacts = facts[tag] || (facts[tag] = {});
		(tag === 'a3' && key === 'class')
			? _VirtualDom_addClass(subFacts, key, value)
			: subFacts[key] = value;
	}

	return facts;
}

function _VirtualDom_addClass(object, key, newClass)
{
	var classes = object[key];
	object[key] = classes ? classes + ' ' + newClass : newClass;
}



// RENDER


function _VirtualDom_render(vNode, eventNode)
{
	var tag = vNode.$;

	if (tag === 5)
	{
		return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
	}

	if (tag === 0)
	{
		return _VirtualDom_doc.createTextNode(vNode.a);
	}

	if (tag === 4)
	{
		var subNode = vNode.k;
		var tagger = vNode.j;

		while (subNode.$ === 4)
		{
			typeof tagger !== 'object'
				? tagger = [tagger, subNode.j]
				: tagger.push(subNode.j);

			subNode = subNode.k;
		}

		var subEventRoot = { j: tagger, p: eventNode };
		var domNode = _VirtualDom_render(subNode, subEventRoot);
		domNode.elm_event_node_ref = subEventRoot;
		return domNode;
	}

	if (tag === 3)
	{
		var domNode = vNode.h(vNode.g);
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
		return domNode;
	}

	// at this point `tag` must be 1 or 2

	var domNode = vNode.f
		? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
		: _VirtualDom_doc.createElement(vNode.c);

	if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
	{
		domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
	}

	_VirtualDom_applyFacts(domNode, eventNode, vNode.d);

	for (var kids = vNode.e, i = 0; i < kids.length; i++)
	{
		_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
	}

	return domNode;
}



// APPLY FACTS


function _VirtualDom_applyFacts(domNode, eventNode, facts)
{
	for (var key in facts)
	{
		var value = facts[key];

		key === 'a1'
			? _VirtualDom_applyStyles(domNode, value)
			:
		key === 'a0'
			? _VirtualDom_applyEvents(domNode, eventNode, value)
			:
		key === 'a3'
			? _VirtualDom_applyAttrs(domNode, value)
			:
		key === 'a4'
			? _VirtualDom_applyAttrsNS(domNode, value)
			:
		((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
	}
}



// APPLY STYLES


function _VirtualDom_applyStyles(domNode, styles)
{
	var domNodeStyle = domNode.style;

	for (var key in styles)
	{
		domNodeStyle[key] = styles[key];
	}
}



// APPLY ATTRS


function _VirtualDom_applyAttrs(domNode, attrs)
{
	for (var key in attrs)
	{
		var value = attrs[key];
		typeof value !== 'undefined'
			? domNode.setAttribute(key, value)
			: domNode.removeAttribute(key);
	}
}



// APPLY NAMESPACED ATTRS


function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
{
	for (var key in nsAttrs)
	{
		var pair = nsAttrs[key];
		var namespace = pair.f;
		var value = pair.o;

		typeof value !== 'undefined'
			? domNode.setAttributeNS(namespace, key, value)
			: domNode.removeAttributeNS(namespace, key);
	}
}



// APPLY EVENTS


function _VirtualDom_applyEvents(domNode, eventNode, events)
{
	var allCallbacks = domNode.elmFs || (domNode.elmFs = {});

	for (var key in events)
	{
		var newHandler = events[key];
		var oldCallback = allCallbacks[key];

		if (!newHandler)
		{
			domNode.removeEventListener(key, oldCallback);
			allCallbacks[key] = undefined;
			continue;
		}

		if (oldCallback)
		{
			var oldHandler = oldCallback.q;
			if (oldHandler.$ === newHandler.$)
			{
				oldCallback.q = newHandler;
				continue;
			}
			domNode.removeEventListener(key, oldCallback);
		}

		oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
		domNode.addEventListener(key, oldCallback,
			_VirtualDom_passiveSupported
			&& { passive: elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
		);
		allCallbacks[key] = oldCallback;
	}
}



// PASSIVE EVENTS


var _VirtualDom_passiveSupported;

try
{
	window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
		get: function() { _VirtualDom_passiveSupported = true; }
	}));
}
catch(e) {}



// EVENT HANDLERS


function _VirtualDom_makeCallback(eventNode, initialHandler)
{
	function callback(event)
	{
		var handler = callback.q;
		var result = _Json_runHelp(handler.a, event);

		if (!elm$core$Result$isOk(result))
		{
			return;
		}

		var tag = elm$virtual_dom$VirtualDom$toHandlerInt(handler);

		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom

		var value = result.a;
		var message = !tag ? value : tag < 3 ? value.a : value.T;
		var stopPropagation = tag == 1 ? value.b : tag == 3 && value.cG;
		var currentEventNode = (
			stopPropagation && event.stopPropagation(),
			(tag == 2 ? value.b : tag == 3 && value.ct) && event.preventDefault(),
			eventNode
		);
		var tagger;
		var i;
		while (tagger = currentEventNode.j)
		{
			if (typeof tagger == 'function')
			{
				message = tagger(message);
			}
			else
			{
				for (var i = tagger.length; i--; )
				{
					message = tagger[i](message);
				}
			}
			currentEventNode = currentEventNode.p;
		}
		currentEventNode(message, stopPropagation); // stopPropagation implies isSync
	}

	callback.q = initialHandler;

	return callback;
}

function _VirtualDom_equalEvents(x, y)
{
	return x.$ == y.$ && _Json_equality(x.a, y.a);
}



// DIFF


// TODO: Should we do patches like in iOS?
//
// type Patch
//   = At Int Patch
//   | Batch (List Patch)
//   | Change ...
//
// How could it not be better?
//
function _VirtualDom_diff(x, y)
{
	var patches = [];
	_VirtualDom_diffHelp(x, y, patches, 0);
	return patches;
}


function _VirtualDom_pushPatch(patches, type, index, data)
{
	var patch = {
		$: type,
		r: index,
		s: data,
		t: undefined,
		u: undefined
	};
	patches.push(patch);
	return patch;
}


function _VirtualDom_diffHelp(x, y, patches, index)
{
	if (x === y)
	{
		return;
	}

	var xType = x.$;
	var yType = y.$;

	// Bail if you run into different types of nodes. Implies that the
	// structure has changed significantly and it's not worth a diff.
	if (xType !== yType)
	{
		if (xType === 1 && yType === 2)
		{
			y = _VirtualDom_dekey(y);
			yType = 1;
		}
		else
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	}

	// Now we know that both nodes are the same $.
	switch (yType)
	{
		case 5:
			var xRefs = x.l;
			var yRefs = y.l;
			var i = xRefs.length;
			var same = i === yRefs.length;
			while (same && i--)
			{
				same = xRefs[i] === yRefs[i];
			}
			if (same)
			{
				y.k = x.k;
				return;
			}
			y.k = y.m();
			var subPatches = [];
			_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
			subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
			return;

		case 4:
			// gather nested taggers
			var xTaggers = x.j;
			var yTaggers = y.j;
			var nesting = false;

			var xSubNode = x.k;
			while (xSubNode.$ === 4)
			{
				nesting = true;

				typeof xTaggers !== 'object'
					? xTaggers = [xTaggers, xSubNode.j]
					: xTaggers.push(xSubNode.j);

				xSubNode = xSubNode.k;
			}

			var ySubNode = y.k;
			while (ySubNode.$ === 4)
			{
				nesting = true;

				typeof yTaggers !== 'object'
					? yTaggers = [yTaggers, ySubNode.j]
					: yTaggers.push(ySubNode.j);

				ySubNode = ySubNode.k;
			}

			// Just bail if different numbers of taggers. This implies the
			// structure of the virtual DOM has changed.
			if (nesting && xTaggers.length !== yTaggers.length)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			// check if taggers are "the same"
			if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
			{
				_VirtualDom_pushPatch(patches, 2, index, yTaggers);
			}

			// diff everything below the taggers
			_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
			return;

		case 0:
			if (x.a !== y.a)
			{
				_VirtualDom_pushPatch(patches, 3, index, y.a);
			}
			return;

		case 1:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
			return;

		case 2:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
			return;

		case 3:
			if (x.h !== y.h)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
			factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

			var patch = y.i(x.g, y.g);
			patch && _VirtualDom_pushPatch(patches, 5, index, patch);

			return;
	}
}

// assumes the incoming arrays are the same length
function _VirtualDom_pairwiseRefEqual(as, bs)
{
	for (var i = 0; i < as.length; i++)
	{
		if (as[i] !== bs[i])
		{
			return false;
		}
	}

	return true;
}

function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
{
	// Bail if obvious indicators have changed. Implies more serious
	// structural changes such that it's not worth it to diff.
	if (x.c !== y.c || x.f !== y.f)
	{
		_VirtualDom_pushPatch(patches, 0, index, y);
		return;
	}

	var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
	factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

	diffKids(x, y, patches, index);
}



// DIFF FACTS


// TODO Instead of creating a new diff object, it's possible to just test if
// there *is* a diff. During the actual patch, do the diff again and make the
// modifications directly. This way, there's no new allocations. Worth it?
function _VirtualDom_diffFacts(x, y, category)
{
	var diff;

	// look for changes and removals
	for (var xKey in x)
	{
		if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
		{
			var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
			if (subDiff)
			{
				diff = diff || {};
				diff[xKey] = subDiff;
			}
			continue;
		}

		// remove if not in the new facts
		if (!(xKey in y))
		{
			diff = diff || {};
			diff[xKey] =
				!category
					? (typeof x[xKey] === 'string' ? '' : null)
					:
				(category === 'a1')
					? ''
					:
				(category === 'a0' || category === 'a3')
					? undefined
					:
				{ f: x[xKey].f, o: undefined };

			continue;
		}

		var xValue = x[xKey];
		var yValue = y[xKey];

		// reference equal, so don't worry about it
		if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
			|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
		{
			continue;
		}

		diff = diff || {};
		diff[xKey] = yValue;
	}

	// add new stuff
	for (var yKey in y)
	{
		if (!(yKey in x))
		{
			diff = diff || {};
			diff[yKey] = y[yKey];
		}
	}

	return diff;
}



// DIFF KIDS


function _VirtualDom_diffKids(xParent, yParent, patches, index)
{
	var xKids = xParent.e;
	var yKids = yParent.e;

	var xLen = xKids.length;
	var yLen = yKids.length;

	// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

	if (xLen > yLen)
	{
		_VirtualDom_pushPatch(patches, 6, index, {
			v: yLen,
			i: xLen - yLen
		});
	}
	else if (xLen < yLen)
	{
		_VirtualDom_pushPatch(patches, 7, index, {
			v: xLen,
			e: yKids
		});
	}

	// PAIRWISE DIFF EVERYTHING ELSE

	for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
	{
		var xKid = xKids[i];
		_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
		index += xKid.b || 0;
	}
}



// KEYED DIFF


function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
{
	var localPatches = [];

	var changes = {}; // Dict String Entry
	var inserts = []; // Array { index : Int, entry : Entry }
	// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

	var xKids = xParent.e;
	var yKids = yParent.e;
	var xLen = xKids.length;
	var yLen = yKids.length;
	var xIndex = 0;
	var yIndex = 0;

	var index = rootIndex;

	while (xIndex < xLen && yIndex < yLen)
	{
		var x = xKids[xIndex];
		var y = yKids[yIndex];

		var xKey = x.a;
		var yKey = y.a;
		var xNode = x.b;
		var yNode = y.b;

		var newMatch = undefined;
		var oldMatch = undefined;

		// check if keys match

		if (xKey === yKey)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
			index += xNode.b || 0;

			xIndex++;
			yIndex++;
			continue;
		}

		// look ahead 1 to detect insertions and removals.

		var xNext = xKids[xIndex + 1];
		var yNext = yKids[yIndex + 1];

		if (xNext)
		{
			var xNextKey = xNext.a;
			var xNextNode = xNext.b;
			oldMatch = yKey === xNextKey;
		}

		if (yNext)
		{
			var yNextKey = yNext.a;
			var yNextNode = yNext.b;
			newMatch = xKey === yNextKey;
		}


		// swap x and y
		if (newMatch && oldMatch)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		// insert y
		if (newMatch)
		{
			index++;
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			index += xNode.b || 0;

			xIndex += 1;
			yIndex += 2;
			continue;
		}

		// remove x
		if (oldMatch)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 1;
			continue;
		}

		// remove x, insert y
		if (xNext && xNextKey === yNextKey)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		break;
	}

	// eat up any remaining nodes with removeNode and insertNode

	while (xIndex < xLen)
	{
		index++;
		var x = xKids[xIndex];
		var xNode = x.b;
		_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
		index += xNode.b || 0;
		xIndex++;
	}

	while (yIndex < yLen)
	{
		var endInserts = endInserts || [];
		var y = yKids[yIndex];
		_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
		yIndex++;
	}

	if (localPatches.length > 0 || inserts.length > 0 || endInserts)
	{
		_VirtualDom_pushPatch(patches, 8, rootIndex, {
			w: localPatches,
			x: inserts,
			y: endInserts
		});
	}
}



// CHANGES FROM KEYED DIFF


var _VirtualDom_POSTFIX = '_elmW6BL';


function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		entry = {
			c: 0,
			z: vnode,
			r: yIndex,
			s: undefined
		};

		inserts.push({ r: yIndex, A: entry });
		changes[key] = entry;

		return;
	}

	// this key was removed earlier, a match!
	if (entry.c === 1)
	{
		inserts.push({ r: yIndex, A: entry });

		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
		entry.r = yIndex;
		entry.s.s = {
			w: subPatches,
			A: entry
		};

		return;
	}

	// this key has already been inserted or moved, a duplicate!
	_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
}


function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);

		changes[key] = {
			c: 1,
			z: vnode,
			r: index,
			s: patch
		};

		return;
	}

	// this key was inserted earlier, a match!
	if (entry.c === 0)
	{
		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);

		_VirtualDom_pushPatch(localPatches, 9, index, {
			w: subPatches,
			A: entry
		});

		return;
	}

	// this key has already been removed or moved, a duplicate!
	_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
}



// ADD DOM NODES
//
// Each DOM node has an "index" assigned in order of traversal. It is important
// to minimize our crawl over the actual DOM, so these indexes (along with the
// descendantsCount of virtual nodes) let us skip touching entire subtrees of
// the DOM if we know there are no patches there.


function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
{
	_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
}


// assumes `patches` is non-empty and indexes increase monotonically.
function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
{
	var patch = patches[i];
	var index = patch.r;

	while (index === low)
	{
		var patchType = patch.$;

		if (patchType === 1)
		{
			_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
		}
		else if (patchType === 8)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var subPatches = patch.s.w;
			if (subPatches.length > 0)
			{
				_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
			}
		}
		else if (patchType === 9)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var data = patch.s;
			if (data)
			{
				data.A.s = domNode;
				var subPatches = data.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
		}
		else
		{
			patch.t = domNode;
			patch.u = eventNode;
		}

		i++;

		if (!(patch = patches[i]) || (index = patch.r) > high)
		{
			return i;
		}
	}

	var tag = vNode.$;

	if (tag === 4)
	{
		var subNode = vNode.k;

		while (subNode.$ === 4)
		{
			subNode = subNode.k;
		}

		return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
	}

	// tag must be 1 or 2 at this point

	var vKids = vNode.e;
	var childNodes = domNode.childNodes;
	for (var j = 0; j < vKids.length; j++)
	{
		low++;
		var vKid = tag === 1 ? vKids[j] : vKids[j].b;
		var nextLow = low + (vKid.b || 0);
		if (low <= index && index <= nextLow)
		{
			i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
		low = nextLow;
	}
	return i;
}



// APPLY PATCHES


function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
{
	if (patches.length === 0)
	{
		return rootDomNode;
	}

	_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
	return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
}

function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
{
	for (var i = 0; i < patches.length; i++)
	{
		var patch = patches[i];
		var localDomNode = patch.t
		var newNode = _VirtualDom_applyPatch(localDomNode, patch);
		if (localDomNode === rootDomNode)
		{
			rootDomNode = newNode;
		}
	}
	return rootDomNode;
}

function _VirtualDom_applyPatch(domNode, patch)
{
	switch (patch.$)
	{
		case 0:
			return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);

		case 4:
			_VirtualDom_applyFacts(domNode, patch.u, patch.s);
			return domNode;

		case 3:
			domNode.replaceData(0, domNode.length, patch.s);
			return domNode;

		case 1:
			return _VirtualDom_applyPatchesHelp(domNode, patch.s);

		case 2:
			if (domNode.elm_event_node_ref)
			{
				domNode.elm_event_node_ref.j = patch.s;
			}
			else
			{
				domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
			}
			return domNode;

		case 6:
			var data = patch.s;
			for (var i = 0; i < data.i; i++)
			{
				domNode.removeChild(domNode.childNodes[data.v]);
			}
			return domNode;

		case 7:
			var data = patch.s;
			var kids = data.e;
			var i = data.v;
			var theEnd = domNode.childNodes[i];
			for (; i < kids.length; i++)
			{
				domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
			}
			return domNode;

		case 9:
			var data = patch.s;
			if (!data)
			{
				domNode.parentNode.removeChild(domNode);
				return domNode;
			}
			var entry = data.A;
			if (typeof entry.r !== 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
			}
			entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
			return domNode;

		case 8:
			return _VirtualDom_applyPatchReorder(domNode, patch);

		case 5:
			return patch.s(domNode);

		default:
			_Debug_crash(10); // 'Ran into an unknown patch!'
	}
}


function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
{
	var parentNode = domNode.parentNode;
	var newNode = _VirtualDom_render(vNode, eventNode);

	if (!newNode.elm_event_node_ref)
	{
		newNode.elm_event_node_ref = domNode.elm_event_node_ref;
	}

	if (parentNode && newNode !== domNode)
	{
		parentNode.replaceChild(newNode, domNode);
	}
	return newNode;
}


function _VirtualDom_applyPatchReorder(domNode, patch)
{
	var data = patch.s;

	// remove end inserts
	var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);

	// removals
	domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);

	// inserts
	var inserts = data.x;
	for (var i = 0; i < inserts.length; i++)
	{
		var insert = inserts[i];
		var entry = insert.A;
		var node = entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u);
		domNode.insertBefore(node, domNode.childNodes[insert.r]);
	}

	// add end inserts
	if (frag)
	{
		_VirtualDom_appendChild(domNode, frag);
	}

	return domNode;
}


function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
{
	if (!endInserts)
	{
		return;
	}

	var frag = _VirtualDom_doc.createDocumentFragment();
	for (var i = 0; i < endInserts.length; i++)
	{
		var insert = endInserts[i];
		var entry = insert.A;
		_VirtualDom_appendChild(frag, entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u)
		);
	}
	return frag;
}


function _VirtualDom_virtualize(node)
{
	// TEXT NODES

	if (node.nodeType === 3)
	{
		return _VirtualDom_text(node.textContent);
	}


	// WEIRD NODES

	if (node.nodeType !== 1)
	{
		return _VirtualDom_text('');
	}


	// ELEMENT NODES

	var attrList = _List_Nil;
	var attrs = node.attributes;
	for (var i = attrs.length; i--; )
	{
		var attr = attrs[i];
		var name = attr.name;
		var value = attr.value;
		attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
	}

	var tag = node.tagName.toLowerCase();
	var kidList = _List_Nil;
	var kids = node.childNodes;

	for (var i = kids.length; i--; )
	{
		kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
	}
	return A3(_VirtualDom_node, tag, attrList, kidList);
}

function _VirtualDom_dekey(keyedNode)
{
	var keyedKids = keyedNode.e;
	var len = keyedKids.length;
	var kids = new Array(len);
	for (var i = 0; i < len; i++)
	{
		kids[i] = keyedKids[i].b;
	}

	return {
		$: 1,
		c: keyedNode.c,
		d: keyedNode.d,
		e: kids,
		f: keyedNode.f,
		b: keyedNode.b
	};
}




// ELEMENT


var _Debugger_element;

var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.eQ,
		impl.fY,
		impl.fJ,
		function(sendToApp, initialModel) {
			var view = impl.f_;
			/**/
			var domNode = args['node'];
			//*/
			/**_UNUSED/
			var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
			//*/
			var currNode = _VirtualDom_virtualize(domNode);

			return _Browser_makeAnimator(initialModel, function(model)
			{
				var nextNode = view(model);
				var patches = _VirtualDom_diff(currNode, nextNode);
				domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
				currNode = nextNode;
			});
		}
	);
});



// DOCUMENT


var _Debugger_document;

var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.eQ,
		impl.fY,
		impl.fJ,
		function(sendToApp, initialModel) {
			var divertHrefToApp = impl.a1 && impl.a1(sendToApp)
			var view = impl.f_;
			var title = _VirtualDom_doc.title;
			var bodyNode = _VirtualDom_doc.body;
			var currNode = _VirtualDom_virtualize(bodyNode);
			return _Browser_makeAnimator(initialModel, function(model)
			{
				_VirtualDom_divertHrefToApp = divertHrefToApp;
				var doc = view(model);
				var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.cZ);
				var patches = _VirtualDom_diff(currNode, nextNode);
				bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
				currNode = nextNode;
				_VirtualDom_divertHrefToApp = 0;
				(title !== doc.d1) && (_VirtualDom_doc.title = title = doc.d1);
			});
		}
	);
});



// ANIMATION


var _Browser_cancelAnimationFrame =
	typeof cancelAnimationFrame !== 'undefined'
		? cancelAnimationFrame
		: function(id) { clearTimeout(id); };

var _Browser_requestAnimationFrame =
	typeof requestAnimationFrame !== 'undefined'
		? requestAnimationFrame
		: function(callback) { return setTimeout(callback, 1000 / 60); };


function _Browser_makeAnimator(model, draw)
{
	draw(model);

	var state = 0;

	function updateIfNeeded()
	{
		state = state === 1
			? 0
			: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
	}

	return function(nextModel, isSync)
	{
		model = nextModel;

		isSync
			? ( draw(model),
				state === 2 && (state = 1)
				)
			: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
				state = 2
				);
	};
}



// APPLICATION


function _Browser_application(impl)
{
	var onUrlChange = impl.fa;
	var onUrlRequest = impl.fb;
	var key = function() { key.a(onUrlChange(_Browser_getUrl())); };

	return _Browser_document({
		a1: function(sendToApp)
		{
			key.a = sendToApp;
			_Browser_window.addEventListener('popstate', key);
			_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);

			return F2(function(domNode, event)
			{
				if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
				{
					event.preventDefault();
					var href = domNode.href;
					var curr = _Browser_getUrl();
					var next = elm$url$Url$fromString(href).a;
					sendToApp(onUrlRequest(
						(next
							&& curr.dK === next.dK
							&& curr.$7 === next.$7
							&& curr.dF.a === next.dF.a
						)
							? elm$browser$Browser$Internal(next)
							: elm$browser$Browser$External(href)
					));
				}
			});
		},
		eQ: function(flags)
		{
			return A3(impl.eQ, flags, _Browser_getUrl(), key);
		},
		f_: impl.f_,
		fY: impl.fY,
		fJ: impl.fJ
	});
}

function _Browser_getUrl()
{
	return elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
}

var _Browser_go = F2(function(key, n)
{
	return A2(elm$core$Task$perform, elm$core$Basics$never, _Scheduler_binding(function() {
		n && history.go(n);
		key();
	}));
});

var _Browser_pushUrl = F2(function(key, url)
{
	return A2(elm$core$Task$perform, elm$core$Basics$never, _Scheduler_binding(function() {
		history.pushState({}, '', url);
		key();
	}));
});

var _Browser_replaceUrl = F2(function(key, url)
{
	return A2(elm$core$Task$perform, elm$core$Basics$never, _Scheduler_binding(function() {
		history.replaceState({}, '', url);
		key();
	}));
});



// GLOBAL EVENTS


var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;

var _Browser_on = F3(function(node, eventName, sendToSelf)
{
	return _Scheduler_spawn(_Scheduler_binding(function(callback)
	{
		function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
		node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
		return function() { node.removeEventListener(eventName, handler); };
	}));
});

var _Browser_decodeEvent = F2(function(decoder, event)
{
	var result = _Json_runHelp(decoder, event);
	return elm$core$Result$isOk(result) ? elm$core$Maybe$Just(result.a) : elm$core$Maybe$Nothing;
});



// PAGE VISIBILITY


function _Browser_visibilityInfo()
{
	return (typeof _VirtualDom_doc.hidden !== 'undefined')
		? { eK: 'hidden', ep: 'visibilitychange' }
		:
	(typeof _VirtualDom_doc.mozHidden !== 'undefined')
		? { eK: 'mozHidden', ep: 'mozvisibilitychange' }
		:
	(typeof _VirtualDom_doc.msHidden !== 'undefined')
		? { eK: 'msHidden', ep: 'msvisibilitychange' }
		:
	(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
		? { eK: 'webkitHidden', ep: 'webkitvisibilitychange' }
		: { eK: 'hidden', ep: 'visibilitychange' };
}



// ANIMATION FRAMES


function _Browser_rAF()
{
	return _Scheduler_binding(function(callback)
	{
		var id = _Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(Date.now()));
		});

		return function() {
			_Browser_cancelAnimationFrame(id);
		};
	});
}


function _Browser_now()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(Date.now()));
	});
}



// DOM STUFF


function _Browser_withNode(id, doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			var node = document.getElementById(id);
			callback(node
				? _Scheduler_succeed(doStuff(node))
				: _Scheduler_fail(elm$browser$Browser$Dom$NotFound(id))
			);
		});
	});
}


function _Browser_withWindow(doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(doStuff()));
		});
	});
}


// FOCUS and BLUR


var _Browser_call = F2(function(functionName, id)
{
	return _Browser_withNode(id, function(node) {
		node[functionName]();
		return _Utils_Tuple0;
	});
});



// WINDOW VIEWPORT


function _Browser_getViewport()
{
	return {
		dW: _Browser_getScene(),
		d8: {
			bI: _Browser_window.pageXOffset,
			bJ: _Browser_window.pageYOffset,
			aN: _Browser_doc.documentElement.clientWidth,
			at: _Browser_doc.documentElement.clientHeight
		}
	};
}

function _Browser_getScene()
{
	var body = _Browser_doc.body;
	var elem = _Browser_doc.documentElement;
	return {
		aN: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
		at: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
	};
}

var _Browser_setViewport = F2(function(x, y)
{
	return _Browser_withWindow(function()
	{
		_Browser_window.scroll(x, y);
		return _Utils_Tuple0;
	});
});



// ELEMENT VIEWPORT


function _Browser_getViewportOf(id)
{
	return _Browser_withNode(id, function(node)
	{
		return {
			dW: {
				aN: node.scrollWidth,
				at: node.scrollHeight
			},
			d8: {
				bI: node.scrollLeft,
				bJ: node.scrollTop,
				aN: node.clientWidth,
				at: node.clientHeight
			}
		};
	});
}


var _Browser_setViewportOf = F3(function(id, x, y)
{
	return _Browser_withNode(id, function(node)
	{
		node.scrollLeft = x;
		node.scrollTop = y;
		return _Utils_Tuple0;
	});
});



// ELEMENT


function _Browser_getElement(id)
{
	return _Browser_withNode(id, function(node)
	{
		var rect = node.getBoundingClientRect();
		var x = _Browser_window.pageXOffset;
		var y = _Browser_window.pageYOffset;
		return {
			dW: _Browser_getScene(),
			d8: {
				bI: x,
				bJ: y,
				aN: _Browser_doc.documentElement.clientWidth,
				at: _Browser_doc.documentElement.clientHeight
			},
			ex: {
				bI: x + rect.left,
				bJ: y + rect.top,
				aN: rect.width,
				at: rect.height
			}
		};
	});
}



// LOAD and RELOAD


function _Browser_reload(skipCache)
{
	return A2(elm$core$Task$perform, elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		_VirtualDom_doc.location.reload(skipCache);
	}));
}

function _Browser_load(url)
{
	return A2(elm$core$Task$perform, elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		try
		{
			_Browser_window.location = url;
		}
		catch(err)
		{
			// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
			// Other browsers reload the page, so let's be consistent about that.
			_VirtualDom_doc.location.reload(false);
		}
	}));
}



function _Time_now(millisToPosix)
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(millisToPosix(Date.now())));
	});
}

var _Time_setInterval = F2(function(interval, task)
{
	return _Scheduler_binding(function(callback)
	{
		var id = setInterval(function() { _Scheduler_rawSpawn(task); }, interval);
		return function() { clearInterval(id); };
	});
});

function _Time_here()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(
			A2(elm$time$Time$customZone, -(new Date().getTimezoneOffset()), _List_Nil)
		));
	});
}


function _Time_getZoneName()
{
	return _Scheduler_binding(function(callback)
	{
		try
		{
			var name = elm$time$Time$Name(Intl.DateTimeFormat().resolvedOptions().timeZone);
		}
		catch (e)
		{
			var name = elm$time$Time$Offset(new Date().getTimezoneOffset());
		}
		callback(_Scheduler_succeed(name));
	});
}




// VIRTUAL-DOM WIDGETS


var _Markdown_toHtml = F3(function(options, factList, rawMarkdown)
{
	return _VirtualDom_custom(
		factList,
		{
			a: options,
			b: rawMarkdown
		},
		_Markdown_render,
		_Markdown_diff
	);
});



// WIDGET IMPLEMENTATION


function _Markdown_render(model)
{
	return A2(_Markdown_replace, model, _VirtualDom_doc.createElement('div'));
}


function _Markdown_diff(x, y)
{
	return x.b === y.b && x.a === y.a
		? false
		: _Markdown_replace(y);
}


var _Markdown_replace = F2(function(model, div)
{
	div.innerHTML = _Markdown_marked(model.b, _Markdown_formatOptions(model.a));
	return div;
});



// ACTUAL MARKDOWN PARSER


var _Markdown_marked = function() {
	// catch the `marked` object regardless of the outer environment.
	// (ex. a CommonJS module compatible environment.)
	// note that this depends on marked's implementation of environment detection.
	var module = {};
	var exports = module.exports = {};

	/**
	 * marked - a markdown parser
	 * Copyright (c) 2011-2014, Christopher Jeffrey. (MIT Licensed)
	 * https://github.com/chjj/marked
	 * commit cd2f6f5b7091154c5526e79b5f3bfb4d15995a51
	 */
	(function(){var block={newline:/^\n+/,code:/^( {4}[^\n]+\n*)+/,fences:noop,hr:/^( *[-*_]){3,} *(?:\n+|$)/,heading:/^ *(#{1,6}) *([^\n]+?) *#* *(?:\n+|$)/,nptable:noop,lheading:/^([^\n]+)\n *(=|-){2,} *(?:\n+|$)/,blockquote:/^( *>[^\n]+(\n(?!def)[^\n]+)*\n*)+/,list:/^( *)(bull) [\s\S]+?(?:hr|def|\n{2,}(?! )(?!\1bull )\n*|\s*$)/,html:/^ *(?:comment *(?:\n|\s*$)|closed *(?:\n{2,}|\s*$)|closing *(?:\n{2,}|\s*$))/,def:/^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +["(]([^\n]+)[")])? *(?:\n+|$)/,table:noop,paragraph:/^((?:[^\n]+\n?(?!hr|heading|lheading|blockquote|tag|def))+)\n*/,text:/^[^\n]+/};block.bullet=/(?:[*+-]|\d+\.)/;block.item=/^( *)(bull) [^\n]*(?:\n(?!\1bull )[^\n]*)*/;block.item=replace(block.item,"gm")(/bull/g,block.bullet)();block.list=replace(block.list)(/bull/g,block.bullet)("hr","\\n+(?=\\1?(?:[-*_] *){3,}(?:\\n+|$))")("def","\\n+(?="+block.def.source+")")();block.blockquote=replace(block.blockquote)("def",block.def)();block._tag="(?!(?:"+"a|em|strong|small|s|cite|q|dfn|abbr|data|time|code"+"|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo"+"|span|br|wbr|ins|del|img)\\b)\\w+(?!:/|[^\\w\\s@]*@)\\b";block.html=replace(block.html)("comment",/<!--[\s\S]*?-->/)("closed",/<(tag)[\s\S]+?<\/\1>/)("closing",/<tag(?:"[^"]*"|'[^']*'|[^'">])*?>/)(/tag/g,block._tag)();block.paragraph=replace(block.paragraph)("hr",block.hr)("heading",block.heading)("lheading",block.lheading)("blockquote",block.blockquote)("tag","<"+block._tag)("def",block.def)();block.normal=merge({},block);block.gfm=merge({},block.normal,{fences:/^ *(`{3,}|~{3,})[ \.]*(\S+)? *\n([\s\S]*?)\s*\1 *(?:\n+|$)/,paragraph:/^/,heading:/^ *(#{1,6}) +([^\n]+?) *#* *(?:\n+|$)/});block.gfm.paragraph=replace(block.paragraph)("(?!","(?!"+block.gfm.fences.source.replace("\\1","\\2")+"|"+block.list.source.replace("\\1","\\3")+"|")();block.tables=merge({},block.gfm,{nptable:/^ *(\S.*\|.*)\n *([-:]+ *\|[-| :]*)\n((?:.*\|.*(?:\n|$))*)\n*/,table:/^ *\|(.+)\n *\|( *[-:]+[-| :]*)\n((?: *\|.*(?:\n|$))*)\n*/});function Lexer(options){this.tokens=[];this.tokens.links={};this.options=options||marked.defaults;this.rules=block.normal;if(this.options.gfm){if(this.options.tables){this.rules=block.tables}else{this.rules=block.gfm}}}Lexer.rules=block;Lexer.lex=function(src,options){var lexer=new Lexer(options);return lexer.lex(src)};Lexer.prototype.lex=function(src){src=src.replace(/\r\n|\r/g,"\n").replace(/\t/g,"    ").replace(/\u00a0/g," ").replace(/\u2424/g,"\n");return this.token(src,true)};Lexer.prototype.token=function(src,top,bq){var src=src.replace(/^ +$/gm,""),next,loose,cap,bull,b,item,space,i,l;while(src){if(cap=this.rules.newline.exec(src)){src=src.substring(cap[0].length);if(cap[0].length>1){this.tokens.push({type:"space"})}}if(cap=this.rules.code.exec(src)){src=src.substring(cap[0].length);cap=cap[0].replace(/^ {4}/gm,"");this.tokens.push({type:"code",text:!this.options.pedantic?cap.replace(/\n+$/,""):cap});continue}if(cap=this.rules.fences.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:"code",lang:cap[2],text:cap[3]||""});continue}if(cap=this.rules.heading.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:"heading",depth:cap[1].length,text:cap[2]});continue}if(top&&(cap=this.rules.nptable.exec(src))){src=src.substring(cap[0].length);item={type:"table",header:cap[1].replace(/^ *| *\| *$/g,"").split(/ *\| */),align:cap[2].replace(/^ *|\| *$/g,"").split(/ *\| */),cells:cap[3].replace(/\n$/,"").split("\n")};for(i=0;i<item.align.length;i++){if(/^ *-+: *$/.test(item.align[i])){item.align[i]="right"}else if(/^ *:-+: *$/.test(item.align[i])){item.align[i]="center"}else if(/^ *:-+ *$/.test(item.align[i])){item.align[i]="left"}else{item.align[i]=null}}for(i=0;i<item.cells.length;i++){item.cells[i]=item.cells[i].split(/ *\| */)}this.tokens.push(item);continue}if(cap=this.rules.lheading.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:"heading",depth:cap[2]==="="?1:2,text:cap[1]});continue}if(cap=this.rules.hr.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:"hr"});continue}if(cap=this.rules.blockquote.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:"blockquote_start"});cap=cap[0].replace(/^ *> ?/gm,"");this.token(cap,top,true);this.tokens.push({type:"blockquote_end"});continue}if(cap=this.rules.list.exec(src)){src=src.substring(cap[0].length);bull=cap[2];this.tokens.push({type:"list_start",ordered:bull.length>1});cap=cap[0].match(this.rules.item);next=false;l=cap.length;i=0;for(;i<l;i++){item=cap[i];space=item.length;item=item.replace(/^ *([*+-]|\d+\.) +/,"");if(~item.indexOf("\n ")){space-=item.length;item=!this.options.pedantic?item.replace(new RegExp("^ {1,"+space+"}","gm"),""):item.replace(/^ {1,4}/gm,"")}if(this.options.smartLists&&i!==l-1){b=block.bullet.exec(cap[i+1])[0];if(bull!==b&&!(bull.length>1&&b.length>1)){src=cap.slice(i+1).join("\n")+src;i=l-1}}loose=next||/\n\n(?!\s*$)/.test(item);if(i!==l-1){next=item.charAt(item.length-1)==="\n";if(!loose)loose=next}this.tokens.push({type:loose?"loose_item_start":"list_item_start"});this.token(item,false,bq);this.tokens.push({type:"list_item_end"})}this.tokens.push({type:"list_end"});continue}if(cap=this.rules.html.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:this.options.sanitize?"paragraph":"html",pre:!this.options.sanitizer&&(cap[1]==="pre"||cap[1]==="script"||cap[1]==="style"),text:cap[0]});continue}if(!bq&&top&&(cap=this.rules.def.exec(src))){src=src.substring(cap[0].length);this.tokens.links[cap[1].toLowerCase()]={href:cap[2],title:cap[3]};continue}if(top&&(cap=this.rules.table.exec(src))){src=src.substring(cap[0].length);item={type:"table",header:cap[1].replace(/^ *| *\| *$/g,"").split(/ *\| */),align:cap[2].replace(/^ *|\| *$/g,"").split(/ *\| */),cells:cap[3].replace(/(?: *\| *)?\n$/,"").split("\n")};for(i=0;i<item.align.length;i++){if(/^ *-+: *$/.test(item.align[i])){item.align[i]="right"}else if(/^ *:-+: *$/.test(item.align[i])){item.align[i]="center"}else if(/^ *:-+ *$/.test(item.align[i])){item.align[i]="left"}else{item.align[i]=null}}for(i=0;i<item.cells.length;i++){item.cells[i]=item.cells[i].replace(/^ *\| *| *\| *$/g,"").split(/ *\| */)}this.tokens.push(item);continue}if(top&&(cap=this.rules.paragraph.exec(src))){src=src.substring(cap[0].length);this.tokens.push({type:"paragraph",text:cap[1].charAt(cap[1].length-1)==="\n"?cap[1].slice(0,-1):cap[1]});continue}if(cap=this.rules.text.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:"text",text:cap[0]});continue}if(src){throw new Error("Infinite loop on byte: "+src.charCodeAt(0))}}return this.tokens};var inline={escape:/^\\([\\`*{}\[\]()#+\-.!_>])/,autolink:/^<([^ >]+(@|:\/)[^ >]+)>/,url:noop,tag:/^<!--[\s\S]*?-->|^<\/?\w+(?:"[^"]*"|'[^']*'|[^'">])*?>/,link:/^!?\[(inside)\]\(href\)/,reflink:/^!?\[(inside)\]\s*\[([^\]]*)\]/,nolink:/^!?\[((?:\[[^\]]*\]|[^\[\]])*)\]/,strong:/^_\_([\s\S]+?)_\_(?!_)|^\*\*([\s\S]+?)\*\*(?!\*)/,em:/^\b_((?:[^_]|_\_)+?)_\b|^\*((?:\*\*|[\s\S])+?)\*(?!\*)/,code:/^(`+)\s*([\s\S]*?[^`])\s*\1(?!`)/,br:/^ {2,}\n(?!\s*$)/,del:noop,text:/^[\s\S]+?(?=[\\<!\[_*`]| {2,}\n|$)/};inline._inside=/(?:\[[^\]]*\]|[^\[\]]|\](?=[^\[]*\]))*/;inline._href=/\s*<?([\s\S]*?)>?(?:\s+['"]([\s\S]*?)['"])?\s*/;inline.link=replace(inline.link)("inside",inline._inside)("href",inline._href)();inline.reflink=replace(inline.reflink)("inside",inline._inside)();inline.normal=merge({},inline);inline.pedantic=merge({},inline.normal,{strong:/^_\_(?=\S)([\s\S]*?\S)_\_(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,em:/^_(?=\S)([\s\S]*?\S)_(?!_)|^\*(?=\S)([\s\S]*?\S)\*(?!\*)/});inline.gfm=merge({},inline.normal,{escape:replace(inline.escape)("])","~|])")(),url:/^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/,del:/^~~(?=\S)([\s\S]*?\S)~~/,text:replace(inline.text)("]|","~]|")("|","|https?://|")()});inline.breaks=merge({},inline.gfm,{br:replace(inline.br)("{2,}","*")(),text:replace(inline.gfm.text)("{2,}","*")()});function InlineLexer(links,options){this.options=options||marked.defaults;this.links=links;this.rules=inline.normal;this.renderer=this.options.renderer||new Renderer;this.renderer.options=this.options;if(!this.links){throw new Error("Tokens array requires a `links` property.")}if(this.options.gfm){if(this.options.breaks){this.rules=inline.breaks}else{this.rules=inline.gfm}}else if(this.options.pedantic){this.rules=inline.pedantic}}InlineLexer.rules=inline;InlineLexer.output=function(src,links,options){var inline=new InlineLexer(links,options);return inline.output(src)};InlineLexer.prototype.output=function(src){var out="",link,text,href,cap;while(src){if(cap=this.rules.escape.exec(src)){src=src.substring(cap[0].length);out+=cap[1];continue}if(cap=this.rules.autolink.exec(src)){src=src.substring(cap[0].length);if(cap[2]==="@"){text=cap[1].charAt(6)===":"?this.mangle(cap[1].substring(7)):this.mangle(cap[1]);href=this.mangle("mailto:")+text}else{text=escape(cap[1]);href=text}out+=this.renderer.link(href,null,text);continue}if(!this.inLink&&(cap=this.rules.url.exec(src))){src=src.substring(cap[0].length);text=escape(cap[1]);href=text;out+=this.renderer.link(href,null,text);continue}if(cap=this.rules.tag.exec(src)){if(!this.inLink&&/^<a /i.test(cap[0])){this.inLink=true}else if(this.inLink&&/^<\/a>/i.test(cap[0])){this.inLink=false}src=src.substring(cap[0].length);out+=this.options.sanitize?this.options.sanitizer?this.options.sanitizer(cap[0]):escape(cap[0]):cap[0];continue}if(cap=this.rules.link.exec(src)){src=src.substring(cap[0].length);this.inLink=true;out+=this.outputLink(cap,{href:cap[2],title:cap[3]});this.inLink=false;continue}if((cap=this.rules.reflink.exec(src))||(cap=this.rules.nolink.exec(src))){src=src.substring(cap[0].length);link=(cap[2]||cap[1]).replace(/\s+/g," ");link=this.links[link.toLowerCase()];if(!link||!link.href){out+=cap[0].charAt(0);src=cap[0].substring(1)+src;continue}this.inLink=true;out+=this.outputLink(cap,link);this.inLink=false;continue}if(cap=this.rules.strong.exec(src)){src=src.substring(cap[0].length);out+=this.renderer.strong(this.output(cap[2]||cap[1]));continue}if(cap=this.rules.em.exec(src)){src=src.substring(cap[0].length);out+=this.renderer.em(this.output(cap[2]||cap[1]));continue}if(cap=this.rules.code.exec(src)){src=src.substring(cap[0].length);out+=this.renderer.codespan(escape(cap[2],true));continue}if(cap=this.rules.br.exec(src)){src=src.substring(cap[0].length);out+=this.renderer.br();continue}if(cap=this.rules.del.exec(src)){src=src.substring(cap[0].length);out+=this.renderer.del(this.output(cap[1]));continue}if(cap=this.rules.text.exec(src)){src=src.substring(cap[0].length);out+=this.renderer.text(escape(this.smartypants(cap[0])));continue}if(src){throw new Error("Infinite loop on byte: "+src.charCodeAt(0))}}return out};InlineLexer.prototype.outputLink=function(cap,link){var href=escape(link.href),title=link.title?escape(link.title):null;return cap[0].charAt(0)!=="!"?this.renderer.link(href,title,this.output(cap[1])):this.renderer.image(href,title,escape(cap[1]))};InlineLexer.prototype.smartypants=function(text){if(!this.options.smartypants)return text;return text.replace(/---/g,"—").replace(/--/g,"–").replace(/(^|[-\u2014\/(\[{"\s])'/g,"$1‘").replace(/'/g,"’").replace(/(^|[-\u2014\/(\[{\u2018\s])"/g,"$1“").replace(/"/g,"”").replace(/\.{3}/g,"…")};InlineLexer.prototype.mangle=function(text){if(!this.options.mangle)return text;var out="",l=text.length,i=0,ch;for(;i<l;i++){ch=text.charCodeAt(i);if(Math.random()>.5){ch="x"+ch.toString(16)}out+="&#"+ch+";"}return out};function Renderer(options){this.options=options||{}}Renderer.prototype.code=function(code,lang,escaped){if(this.options.highlight){var out=this.options.highlight(code,lang);if(out!=null&&out!==code){escaped=true;code=out}}if(!lang){return"<pre><code>"+(escaped?code:escape(code,true))+"\n</code></pre>"}return'<pre><code class="'+this.options.langPrefix+escape(lang,true)+'">'+(escaped?code:escape(code,true))+"\n</code></pre>\n"};Renderer.prototype.blockquote=function(quote){return"<blockquote>\n"+quote+"</blockquote>\n"};Renderer.prototype.html=function(html){return html};Renderer.prototype.heading=function(text,level,raw){return"<h"+level+' id="'+this.options.headerPrefix+raw.toLowerCase().replace(/[^\w]+/g,"-")+'">'+text+"</h"+level+">\n"};Renderer.prototype.hr=function(){return this.options.xhtml?"<hr/>\n":"<hr>\n"};Renderer.prototype.list=function(body,ordered){var type=ordered?"ol":"ul";return"<"+type+">\n"+body+"</"+type+">\n"};Renderer.prototype.listitem=function(text){return"<li>"+text+"</li>\n"};Renderer.prototype.paragraph=function(text){return"<p>"+text+"</p>\n"};Renderer.prototype.table=function(header,body){return"<table>\n"+"<thead>\n"+header+"</thead>\n"+"<tbody>\n"+body+"</tbody>\n"+"</table>\n"};Renderer.prototype.tablerow=function(content){return"<tr>\n"+content+"</tr>\n"};Renderer.prototype.tablecell=function(content,flags){var type=flags.header?"th":"td";var tag=flags.align?"<"+type+' style="text-align:'+flags.align+'">':"<"+type+">";return tag+content+"</"+type+">\n"};Renderer.prototype.strong=function(text){return"<strong>"+text+"</strong>"};Renderer.prototype.em=function(text){return"<em>"+text+"</em>"};Renderer.prototype.codespan=function(text){return"<code>"+text+"</code>"};Renderer.prototype.br=function(){return this.options.xhtml?"<br/>":"<br>"};Renderer.prototype.del=function(text){return"<del>"+text+"</del>"};Renderer.prototype.link=function(href,title,text){if(this.options.sanitize){try{var prot=decodeURIComponent(unescape(href)).replace(/[^\w:]/g,"").toLowerCase()}catch(e){return""}if(prot.indexOf("javascript:")===0||prot.indexOf("vbscript:")===0||prot.indexOf("data:")===0){return""}}var out='<a href="'+href+'"';if(title){out+=' title="'+title+'"'}out+=">"+text+"</a>";return out};Renderer.prototype.image=function(href,title,text){var out='<img src="'+href+'" alt="'+text+'"';if(title){out+=' title="'+title+'"'}out+=this.options.xhtml?"/>":">";return out};Renderer.prototype.text=function(text){return text};function Parser(options){this.tokens=[];this.token=null;this.options=options||marked.defaults;this.options.renderer=this.options.renderer||new Renderer;this.renderer=this.options.renderer;this.renderer.options=this.options}Parser.parse=function(src,options,renderer){var parser=new Parser(options,renderer);return parser.parse(src)};Parser.prototype.parse=function(src){this.inline=new InlineLexer(src.links,this.options,this.renderer);this.tokens=src.reverse();var out="";while(this.next()){out+=this.tok()}return out};Parser.prototype.next=function(){return this.token=this.tokens.pop()};Parser.prototype.peek=function(){return this.tokens[this.tokens.length-1]||0};Parser.prototype.parseText=function(){var body=this.token.text;while(this.peek().type==="text"){body+="\n"+this.next().text}return this.inline.output(body)};Parser.prototype.tok=function(){switch(this.token.type){case"space":{return""}case"hr":{return this.renderer.hr()}case"heading":{return this.renderer.heading(this.inline.output(this.token.text),this.token.depth,this.token.text)}case"code":{return this.renderer.code(this.token.text,this.token.lang,this.token.escaped)}case"table":{var header="",body="",i,row,cell,flags,j;cell="";for(i=0;i<this.token.header.length;i++){flags={header:true,align:this.token.align[i]};cell+=this.renderer.tablecell(this.inline.output(this.token.header[i]),{header:true,align:this.token.align[i]})}header+=this.renderer.tablerow(cell);for(i=0;i<this.token.cells.length;i++){row=this.token.cells[i];cell="";for(j=0;j<row.length;j++){cell+=this.renderer.tablecell(this.inline.output(row[j]),{header:false,align:this.token.align[j]})}body+=this.renderer.tablerow(cell)}return this.renderer.table(header,body)}case"blockquote_start":{var body="";while(this.next().type!=="blockquote_end"){body+=this.tok()}return this.renderer.blockquote(body)}case"list_start":{var body="",ordered=this.token.ordered;while(this.next().type!=="list_end"){body+=this.tok()}return this.renderer.list(body,ordered)}case"list_item_start":{var body="";while(this.next().type!=="list_item_end"){body+=this.token.type==="text"?this.parseText():this.tok()}return this.renderer.listitem(body)}case"loose_item_start":{var body="";while(this.next().type!=="list_item_end"){body+=this.tok()}return this.renderer.listitem(body)}case"html":{var html=!this.token.pre&&!this.options.pedantic?this.inline.output(this.token.text):this.token.text;return this.renderer.html(html)}case"paragraph":{return this.renderer.paragraph(this.inline.output(this.token.text))}case"text":{return this.renderer.paragraph(this.parseText())}}};function escape(html,encode){return html.replace(!encode?/&(?!#?\w+;)/g:/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#39;")}function unescape(html){return html.replace(/&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/g,function(_,n){n=n.toLowerCase();if(n==="colon")return":";if(n.charAt(0)==="#"){return n.charAt(1)==="x"?String.fromCharCode(parseInt(n.substring(2),16)):String.fromCharCode(+n.substring(1))}return""})}function replace(regex,opt){regex=regex.source;opt=opt||"";return function self(name,val){if(!name)return new RegExp(regex,opt);val=val.source||val;val=val.replace(/(^|[^\[])\^/g,"$1");regex=regex.replace(name,val);return self}}function noop(){}noop.exec=noop;function merge(obj){var i=1,target,key;for(;i<arguments.length;i++){target=arguments[i];for(key in target){if(Object.prototype.hasOwnProperty.call(target,key)){obj[key]=target[key]}}}return obj}function marked(src,opt,callback){if(callback||typeof opt==="function"){if(!callback){callback=opt;opt=null}opt=merge({},marked.defaults,opt||{});var highlight=opt.highlight,tokens,pending,i=0;try{tokens=Lexer.lex(src,opt)}catch(e){return callback(e)}pending=tokens.length;var done=function(err){if(err){opt.highlight=highlight;return callback(err)}var out;try{out=Parser.parse(tokens,opt)}catch(e){err=e}opt.highlight=highlight;return err?callback(err):callback(null,out)};if(!highlight||highlight.length<3){return done()}delete opt.highlight;if(!pending)return done();for(;i<tokens.length;i++){(function(token){if(token.type!=="code"){return--pending||done()}return highlight(token.text,token.lang,function(err,code){if(err)return done(err);if(code==null||code===token.text){return--pending||done()}token.text=code;token.escaped=true;--pending||done()})})(tokens[i])}return}try{if(opt)opt=merge({},marked.defaults,opt);return Parser.parse(Lexer.lex(src,opt),opt)}catch(e){e.message+="\nPlease report this to https://github.com/chjj/marked.";if((opt||marked.defaults).silent){return"<p>An error occured:</p><pre>"+escape(e.message+"",true)+"</pre>"}throw e}}marked.options=marked.setOptions=function(opt){merge(marked.defaults,opt);return marked};marked.defaults={gfm:true,tables:true,breaks:false,pedantic:false,sanitize:false,sanitizer:null,mangle:true,smartLists:false,silent:false,highlight:null,langPrefix:"lang-",smartypants:false,headerPrefix:"",renderer:new Renderer,xhtml:false};marked.Parser=Parser;marked.parser=Parser.parse;marked.Renderer=Renderer;marked.Lexer=Lexer;marked.lexer=Lexer.lex;marked.InlineLexer=InlineLexer;marked.inlineLexer=InlineLexer.output;marked.parse=marked;if(typeof module!=="undefined"&&typeof exports==="object"){module.exports=marked}else if(typeof define==="function"&&define.amd){define(function(){return marked})}else{this.marked=marked}}).call(function(){return this||(typeof window!=="undefined"?window:global)}());

	return module.exports;
}();


// FORMAT OPTIONS FOR MARKED IMPLEMENTATION

function _Markdown_formatOptions(options)
{
	function toHighlight(code, lang)
	{
		if (!lang && elm$core$Maybe$isJust(options.c8))
		{
			lang = options.c8.a;
		}

		if (typeof hljs !== 'undefined' && lang && hljs.listLanguages().indexOf(lang) >= 0)
		{
			return hljs.highlight(lang, code, true).value;
		}

		return code;
	}

	var gfm = options.dl.a;

	return {
		highlight: toHighlight,
		gfm: gfm,
		tables: gfm && gfm.fO,
		breaks: gfm && gfm.ej,
		sanitize: options.dV,
		smartypants: options.dY
	};
}
var author$project$Main$LinkClicked = function (a) {
	return {$: 1, a: a};
};
var author$project$Main$UrlChanged = function (a) {
	return {$: 0, a: a};
};
var author$project$GameData$GameData = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var author$project$GameData$Lists = F6(
	function (tabs, units, upgrades, spells, achievements, mtxs) {
		return {aQ: achievements, cg: mtxs, s: spells, bD: tabs, k: units, o: upgrades};
	});
var author$project$GameData$Achievement$Id$toString = function (_n0) {
	var id = _n0;
	return id;
};
var author$project$GameData$Achievement$idToString = author$project$GameData$Achievement$Id$toString;
var elm$core$Basics$composeR = F3(
	function (f, g, x) {
		return g(
			f(x));
	});
var author$project$GameData$Achievement$name = A2(
	elm$core$Basics$composeR,
	function ($) {
		return $.eL;
	},
	author$project$GameData$Achievement$idToString);
var author$project$GameData$Item$Spell = function (a) {
	return {$: 2, a: a};
};
var author$project$GameData$Item$Unit = function (a) {
	return {$: 0, a: a};
};
var author$project$GameData$Item$Upgrade = function (a) {
	return {$: 1, a: a};
};
var author$project$GameData$Item$cost = function (item) {
	switch (item.$) {
		case 0:
			var u = item.a;
			return u.es;
		case 1:
			var u = item.a;
			return u.es;
		default:
			var u = item.a;
			return u.es;
	}
};
var author$project$GameData$Item$Id$SpellId = function (a) {
	return {$: 2, a: a};
};
var author$project$GameData$Item$Id$UnitId = function (a) {
	return {$: 0, a: a};
};
var author$project$GameData$Item$Id$UpgradeId = function (a) {
	return {$: 1, a: a};
};
var author$project$GameData$Item$id = function (item) {
	switch (item.$) {
		case 0:
			var u = item.a;
			return author$project$GameData$Item$Id$UnitId(u.eL);
		case 1:
			var u = item.a;
			return author$project$GameData$Item$Id$UpgradeId(u.eL);
		default:
			var s = item.a;
			return author$project$GameData$Item$Id$SpellId(s.eL);
	}
};
var author$project$GameData$Spell$Id$toString = function (_n0) {
	var id = _n0;
	return id;
};
var author$project$GameData$Unit$Id$toString = function (_n0) {
	var id = _n0;
	return id;
};
var author$project$GameData$Upgrade$Id$toString = function (_n0) {
	var id = _n0;
	return id;
};
var author$project$GameData$Item$Id$toString = function (wrap) {
	switch (wrap.$) {
		case 0:
			var i = wrap.a;
			return author$project$GameData$Unit$Id$toString(i);
		case 1:
			var i = wrap.a;
			return author$project$GameData$Upgrade$Id$toString(i);
		default:
			var i = wrap.a;
			return author$project$GameData$Spell$Id$toString(i);
	}
};
var author$project$GameData$Item$idToString = author$project$GameData$Item$Id$toString;
var author$project$GameData$Item$name = A2(elm$core$Basics$composeR, author$project$GameData$Item$id, author$project$GameData$Item$idToString);
var elm$core$Maybe$Just = function (a) {
	return {$: 0, a: a};
};
var elm$core$Maybe$Nothing = {$: 1};
var author$project$GameData$Item$slug = function (item) {
	switch (item.$) {
		case 0:
			var u = item.a;
			return elm$core$Maybe$Just(u.cA);
		case 2:
			var u = item.a;
			return elm$core$Maybe$Just(u.cA);
		default:
			return elm$core$Maybe$Nothing;
	}
};
var author$project$GameData$Mtx$Id$toString = function (_n0) {
	var id = _n0;
	return id;
};
var author$project$GameData$Mtx$idToString = author$project$GameData$Mtx$Id$toString;
var author$project$GameData$Spell$idToString = author$project$GameData$Spell$Id$toString;
var author$project$GameData$Spell$name = A2(
	elm$core$Basics$composeR,
	function ($) {
		return $.eL;
	},
	author$project$GameData$Spell$idToString);
var author$project$GameData$Tab$Id$toString = function (_n0) {
	var id = _n0;
	return id;
};
var author$project$GameData$Tab$idToString = author$project$GameData$Tab$Id$toString;
var author$project$GameData$Tab$name = A2(
	elm$core$Basics$composeR,
	function ($) {
		return $.eL;
	},
	author$project$GameData$Tab$idToString);
var author$project$GameData$Unit$idToString = author$project$GameData$Unit$Id$toString;
var author$project$GameData$Unit$name = A2(
	elm$core$Basics$composeR,
	function ($) {
		return $.eL;
	},
	author$project$GameData$Unit$idToString);
var author$project$GameData$Upgrade$idToString = author$project$GameData$Upgrade$Id$toString;
var author$project$GameData$Upgrade$name = A2(
	elm$core$Basics$composeR,
	function ($) {
		return $.eL;
	},
	author$project$GameData$Upgrade$idToString);
var elm$core$Basics$always = F2(
	function (a, _n0) {
		return a;
	});
var elm$core$Basics$apR = F2(
	function (x, f) {
		return f(x);
	});
var elm$core$Elm$JsArray$foldr = _JsArray_foldr;
var elm$core$Array$foldr = F3(
	function (func, baseCase, _n0) {
		var tree = _n0.c;
		var tail = _n0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3(elm$core$Elm$JsArray$foldr, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3(elm$core$Elm$JsArray$foldr, func, acc, values);
				}
			});
		return A3(
			elm$core$Elm$JsArray$foldr,
			helper,
			A3(elm$core$Elm$JsArray$foldr, func, baseCase, tail),
			tree);
	});
var elm$core$Basics$EQ = 1;
var elm$core$Basics$LT = 0;
var elm$core$List$cons = _List_cons;
var elm$core$Array$toList = function (array) {
	return A3(elm$core$Array$foldr, elm$core$List$cons, _List_Nil, array);
};
var elm$core$Basics$GT = 2;
var elm$core$Dict$foldr = F3(
	function (func, acc, t) {
		foldr:
		while (true) {
			if (t.$ === -2) {
				return acc;
			} else {
				var key = t.b;
				var value = t.c;
				var left = t.d;
				var right = t.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3(elm$core$Dict$foldr, func, acc, right)),
					$temp$t = left;
				func = $temp$func;
				acc = $temp$acc;
				t = $temp$t;
				continue foldr;
			}
		}
	});
var elm$core$Dict$toList = function (dict) {
	return A3(
		elm$core$Dict$foldr,
		F3(
			function (key, value, list) {
				return A2(
					elm$core$List$cons,
					_Utils_Tuple2(key, value),
					list);
			}),
		_List_Nil,
		dict);
};
var elm$core$Dict$keys = function (dict) {
	return A3(
		elm$core$Dict$foldr,
		F3(
			function (key, value, keyList) {
				return A2(elm$core$List$cons, key, keyList);
			}),
		_List_Nil,
		dict);
};
var elm$core$Set$toList = function (_n0) {
	var dict = _n0;
	return elm$core$Dict$keys(dict);
};
var elm$core$Basics$append = _Utils_append;
var elm$core$Basics$compare = _Utils_compare;
var elm$core$Dict$get = F2(
	function (targetKey, dict) {
		get:
		while (true) {
			if (dict.$ === -2) {
				return elm$core$Maybe$Nothing;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var _n1 = A2(elm$core$Basics$compare, targetKey, key);
				switch (_n1) {
					case 0:
						var $temp$targetKey = targetKey,
							$temp$dict = left;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
					case 1:
						return elm$core$Maybe$Just(value);
					default:
						var $temp$targetKey = targetKey,
							$temp$dict = right;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
				}
			}
		}
	});
var elm$core$Dict$RBEmpty_elm_builtin = {$: -2};
var elm$core$Dict$RBNode_elm_builtin = F5(
	function (a, b, c, d, e) {
		return {$: -1, a: a, b: b, c: c, d: d, e: e};
	});
var elm$core$Dict$map = F2(
	function (func, dict) {
		if (dict.$ === -2) {
			return elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			return A5(
				elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				A2(func, key, value),
				A2(elm$core$Dict$map, func, left),
				A2(elm$core$Dict$map, func, right));
		}
	});
var elm$core$Dict$Black = 1;
var elm$core$Basics$eq = _Utils_equal;
var elm$core$Basics$lt = _Utils_lt;
var elm$core$Dict$Red = 0;
var elm$core$Dict$balance = F5(
	function (color, key, value, left, right) {
		if ((right.$ === -1) && (!right.a)) {
			var _n1 = right.a;
			var rK = right.b;
			var rV = right.c;
			var rLeft = right.d;
			var rRight = right.e;
			if ((left.$ === -1) && (!left.a)) {
				var _n3 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					elm$core$Dict$RBNode_elm_builtin,
					0,
					key,
					value,
					A5(elm$core$Dict$RBNode_elm_builtin, 1, lK, lV, lLeft, lRight),
					A5(elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rLeft, rRight));
			} else {
				return A5(
					elm$core$Dict$RBNode_elm_builtin,
					color,
					rK,
					rV,
					A5(elm$core$Dict$RBNode_elm_builtin, 0, key, value, left, rLeft),
					rRight);
			}
		} else {
			if ((((left.$ === -1) && (!left.a)) && (left.d.$ === -1)) && (!left.d.a)) {
				var _n5 = left.a;
				var lK = left.b;
				var lV = left.c;
				var _n6 = left.d;
				var _n7 = _n6.a;
				var llK = _n6.b;
				var llV = _n6.c;
				var llLeft = _n6.d;
				var llRight = _n6.e;
				var lRight = left.e;
				return A5(
					elm$core$Dict$RBNode_elm_builtin,
					0,
					lK,
					lV,
					A5(elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
					A5(elm$core$Dict$RBNode_elm_builtin, 1, key, value, lRight, right));
			} else {
				return A5(elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
			}
		}
	});
var elm$core$Dict$getMin = function (dict) {
	getMin:
	while (true) {
		if ((dict.$ === -1) && (dict.d.$ === -1)) {
			var left = dict.d;
			var $temp$dict = left;
			dict = $temp$dict;
			continue getMin;
		} else {
			return dict;
		}
	}
};
var elm$core$Dict$moveRedLeft = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.e.d.$ === -1) && (!dict.e.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _n1 = dict.d;
			var lClr = _n1.a;
			var lK = _n1.b;
			var lV = _n1.c;
			var lLeft = _n1.d;
			var lRight = _n1.e;
			var _n2 = dict.e;
			var rClr = _n2.a;
			var rK = _n2.b;
			var rV = _n2.c;
			var rLeft = _n2.d;
			var _n3 = rLeft.a;
			var rlK = rLeft.b;
			var rlV = rLeft.c;
			var rlL = rLeft.d;
			var rlR = rLeft.e;
			var rRight = _n2.e;
			return A5(
				elm$core$Dict$RBNode_elm_builtin,
				0,
				rlK,
				rlV,
				A5(
					elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5(elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					rlL),
				A5(elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rlR, rRight));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _n4 = dict.d;
			var lClr = _n4.a;
			var lK = _n4.b;
			var lV = _n4.c;
			var lLeft = _n4.d;
			var lRight = _n4.e;
			var _n5 = dict.e;
			var rClr = _n5.a;
			var rK = _n5.b;
			var rV = _n5.c;
			var rLeft = _n5.d;
			var rRight = _n5.e;
			if (clr === 1) {
				return A5(
					elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5(elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5(elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5(elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5(elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var elm$core$Dict$moveRedRight = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.d.d.$ === -1) && (!dict.d.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _n1 = dict.d;
			var lClr = _n1.a;
			var lK = _n1.b;
			var lV = _n1.c;
			var _n2 = _n1.d;
			var _n3 = _n2.a;
			var llK = _n2.b;
			var llV = _n2.c;
			var llLeft = _n2.d;
			var llRight = _n2.e;
			var lRight = _n1.e;
			var _n4 = dict.e;
			var rClr = _n4.a;
			var rK = _n4.b;
			var rV = _n4.c;
			var rLeft = _n4.d;
			var rRight = _n4.e;
			return A5(
				elm$core$Dict$RBNode_elm_builtin,
				0,
				lK,
				lV,
				A5(elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
				A5(
					elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					lRight,
					A5(elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight)));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _n5 = dict.d;
			var lClr = _n5.a;
			var lK = _n5.b;
			var lV = _n5.c;
			var lLeft = _n5.d;
			var lRight = _n5.e;
			var _n6 = dict.e;
			var rClr = _n6.a;
			var rK = _n6.b;
			var rV = _n6.c;
			var rLeft = _n6.d;
			var rRight = _n6.e;
			if (clr === 1) {
				return A5(
					elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5(elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5(elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5(elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5(elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var elm$core$Dict$removeHelpPrepEQGT = F7(
	function (targetKey, dict, color, key, value, left, right) {
		if ((left.$ === -1) && (!left.a)) {
			var _n1 = left.a;
			var lK = left.b;
			var lV = left.c;
			var lLeft = left.d;
			var lRight = left.e;
			return A5(
				elm$core$Dict$RBNode_elm_builtin,
				color,
				lK,
				lV,
				lLeft,
				A5(elm$core$Dict$RBNode_elm_builtin, 0, key, value, lRight, right));
		} else {
			_n2$2:
			while (true) {
				if ((right.$ === -1) && (right.a === 1)) {
					if (right.d.$ === -1) {
						if (right.d.a === 1) {
							var _n3 = right.a;
							var _n4 = right.d;
							var _n5 = _n4.a;
							return elm$core$Dict$moveRedRight(dict);
						} else {
							break _n2$2;
						}
					} else {
						var _n6 = right.a;
						var _n7 = right.d;
						return elm$core$Dict$moveRedRight(dict);
					}
				} else {
					break _n2$2;
				}
			}
			return dict;
		}
	});
var elm$core$Dict$removeMin = function (dict) {
	if ((dict.$ === -1) && (dict.d.$ === -1)) {
		var color = dict.a;
		var key = dict.b;
		var value = dict.c;
		var left = dict.d;
		var lColor = left.a;
		var lLeft = left.d;
		var right = dict.e;
		if (lColor === 1) {
			if ((lLeft.$ === -1) && (!lLeft.a)) {
				var _n3 = lLeft.a;
				return A5(
					elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					elm$core$Dict$removeMin(left),
					right);
			} else {
				var _n4 = elm$core$Dict$moveRedLeft(dict);
				if (_n4.$ === -1) {
					var nColor = _n4.a;
					var nKey = _n4.b;
					var nValue = _n4.c;
					var nLeft = _n4.d;
					var nRight = _n4.e;
					return A5(
						elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						elm$core$Dict$removeMin(nLeft),
						nRight);
				} else {
					return elm$core$Dict$RBEmpty_elm_builtin;
				}
			}
		} else {
			return A5(
				elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				value,
				elm$core$Dict$removeMin(left),
				right);
		}
	} else {
		return elm$core$Dict$RBEmpty_elm_builtin;
	}
};
var elm$core$Dict$removeHelp = F2(
	function (targetKey, dict) {
		if (dict.$ === -2) {
			return elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_cmp(targetKey, key) < 0) {
				if ((left.$ === -1) && (left.a === 1)) {
					var _n4 = left.a;
					var lLeft = left.d;
					if ((lLeft.$ === -1) && (!lLeft.a)) {
						var _n6 = lLeft.a;
						return A5(
							elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2(elm$core$Dict$removeHelp, targetKey, left),
							right);
					} else {
						var _n7 = elm$core$Dict$moveRedLeft(dict);
						if (_n7.$ === -1) {
							var nColor = _n7.a;
							var nKey = _n7.b;
							var nValue = _n7.c;
							var nLeft = _n7.d;
							var nRight = _n7.e;
							return A5(
								elm$core$Dict$balance,
								nColor,
								nKey,
								nValue,
								A2(elm$core$Dict$removeHelp, targetKey, nLeft),
								nRight);
						} else {
							return elm$core$Dict$RBEmpty_elm_builtin;
						}
					}
				} else {
					return A5(
						elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						A2(elm$core$Dict$removeHelp, targetKey, left),
						right);
				}
			} else {
				return A2(
					elm$core$Dict$removeHelpEQGT,
					targetKey,
					A7(elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
			}
		}
	});
var elm$core$Dict$removeHelpEQGT = F2(
	function (targetKey, dict) {
		if (dict.$ === -1) {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_eq(targetKey, key)) {
				var _n1 = elm$core$Dict$getMin(right);
				if (_n1.$ === -1) {
					var minKey = _n1.b;
					var minValue = _n1.c;
					return A5(
						elm$core$Dict$balance,
						color,
						minKey,
						minValue,
						left,
						elm$core$Dict$removeMin(right));
				} else {
					return elm$core$Dict$RBEmpty_elm_builtin;
				}
			} else {
				return A5(
					elm$core$Dict$balance,
					color,
					key,
					value,
					left,
					A2(elm$core$Dict$removeHelp, targetKey, right));
			}
		} else {
			return elm$core$Dict$RBEmpty_elm_builtin;
		}
	});
var elm$core$Dict$remove = F2(
	function (key, dict) {
		var _n0 = A2(elm$core$Dict$removeHelp, key, dict);
		if ((_n0.$ === -1) && (!_n0.a)) {
			var _n1 = _n0.a;
			var k = _n0.b;
			var v = _n0.c;
			var l = _n0.d;
			var r = _n0.e;
			return A5(elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _n0;
			return x;
		}
	});
var elm$core$Basics$add = _Basics_add;
var elm$core$Basics$gt = _Utils_gt;
var elm$core$List$foldl = F3(
	function (func, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var x = list.a;
				var xs = list.b;
				var $temp$func = func,
					$temp$acc = A2(func, x, acc),
					$temp$list = xs;
				func = $temp$func;
				acc = $temp$acc;
				list = $temp$list;
				continue foldl;
			}
		}
	});
var elm$core$List$reverse = function (list) {
	return A3(elm$core$List$foldl, elm$core$List$cons, _List_Nil, list);
};
var elm$core$List$foldrHelper = F4(
	function (fn, acc, ctr, ls) {
		if (!ls.b) {
			return acc;
		} else {
			var a = ls.a;
			var r1 = ls.b;
			if (!r1.b) {
				return A2(fn, a, acc);
			} else {
				var b = r1.a;
				var r2 = r1.b;
				if (!r2.b) {
					return A2(
						fn,
						a,
						A2(fn, b, acc));
				} else {
					var c = r2.a;
					var r3 = r2.b;
					if (!r3.b) {
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(fn, c, acc)));
					} else {
						var d = r3.a;
						var r4 = r3.b;
						var res = (ctr > 500) ? A3(
							elm$core$List$foldl,
							fn,
							acc,
							elm$core$List$reverse(r4)) : A4(elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(
									fn,
									c,
									A2(fn, d, res))));
					}
				}
			}
		}
	});
var elm$core$List$foldr = F3(
	function (fn, acc, ls) {
		return A4(elm$core$List$foldrHelper, fn, acc, 0, ls);
	});
var elm$core$List$append = F2(
	function (xs, ys) {
		if (!ys.b) {
			return xs;
		} else {
			return A3(elm$core$List$foldr, elm$core$List$cons, ys, xs);
		}
	});
var elm$core$List$concat = function (lists) {
	return A3(elm$core$List$foldr, elm$core$List$append, _List_Nil, lists);
};
var elm$core$List$map = F2(
	function (f, xs) {
		return A3(
			elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A2(
						elm$core$List$cons,
						f(x),
						acc);
				}),
			_List_Nil,
			xs);
	});
var elm$core$List$concatMap = F2(
	function (f, list) {
		return elm$core$List$concat(
			A2(elm$core$List$map, f, list));
	});
var elm$core$List$maybeCons = F3(
	function (f, mx, xs) {
		var _n0 = f(mx);
		if (!_n0.$) {
			var x = _n0.a;
			return A2(elm$core$List$cons, x, xs);
		} else {
			return xs;
		}
	});
var elm$core$List$filterMap = F2(
	function (f, xs) {
		return A3(
			elm$core$List$foldr,
			elm$core$List$maybeCons(f),
			_List_Nil,
			xs);
	});
var elm$core$Maybe$map = F2(
	function (f, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return elm$core$Maybe$Just(
				f(value));
		} else {
			return elm$core$Maybe$Nothing;
		}
	});
var elm$core$Maybe$withDefault = F2(
	function (_default, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return value;
		} else {
			return _default;
		}
	});
var elm$core$String$toLower = _String_toLower;
var elm$core$Tuple$first = function (_n0) {
	var x = _n0.a;
	return x;
};
var elm$core$Tuple$mapSecond = F2(
	function (func, _n0) {
		var x = _n0.a;
		var y = _n0.b;
		return _Utils_Tuple2(
			x,
			func(y));
	});
var elm$core$Tuple$pair = F2(
	function (a, b) {
		return _Utils_Tuple2(a, b);
	});
var elm$core$Tuple$second = function (_n0) {
	var y = _n0.b;
	return y;
};
var elm$core$Dict$empty = elm$core$Dict$RBEmpty_elm_builtin;
var elm$core$Dict$insertHelp = F3(
	function (key, value, dict) {
		if (dict.$ === -2) {
			return A5(elm$core$Dict$RBNode_elm_builtin, 0, key, value, elm$core$Dict$RBEmpty_elm_builtin, elm$core$Dict$RBEmpty_elm_builtin);
		} else {
			var nColor = dict.a;
			var nKey = dict.b;
			var nValue = dict.c;
			var nLeft = dict.d;
			var nRight = dict.e;
			var _n1 = A2(elm$core$Basics$compare, key, nKey);
			switch (_n1) {
				case 0:
					return A5(
						elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						A3(elm$core$Dict$insertHelp, key, value, nLeft),
						nRight);
				case 1:
					return A5(elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
				default:
					return A5(
						elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						nLeft,
						A3(elm$core$Dict$insertHelp, key, value, nRight));
			}
		}
	});
var elm$core$Dict$insert = F3(
	function (key, value, dict) {
		var _n0 = A3(elm$core$Dict$insertHelp, key, value, dict);
		if ((_n0.$ === -1) && (!_n0.a)) {
			var _n1 = _n0.a;
			var k = _n0.b;
			var v = _n0.c;
			var l = _n0.d;
			var r = _n0.e;
			return A5(elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _n0;
			return x;
		}
	});
var elm_community$dict_extra$Dict$Extra$fromListBy = F2(
	function (keyfn, xs) {
		return A3(
			elm$core$List$foldl,
			F2(
				function (x, acc) {
					return A3(
						elm$core$Dict$insert,
						keyfn(x),
						x,
						acc);
				}),
			elm$core$Dict$empty,
			xs);
	});
var elm$core$Dict$update = F3(
	function (targetKey, alter, dictionary) {
		var _n0 = alter(
			A2(elm$core$Dict$get, targetKey, dictionary));
		if (!_n0.$) {
			var value = _n0.a;
			return A3(elm$core$Dict$insert, targetKey, value, dictionary);
		} else {
			return A2(elm$core$Dict$remove, targetKey, dictionary);
		}
	});
var elm_community$dict_extra$Dict$Extra$groupBy = F2(
	function (keyfn, list) {
		return A3(
			elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A3(
						elm$core$Dict$update,
						keyfn(x),
						A2(
							elm$core$Basics$composeR,
							elm$core$Maybe$map(
								elm$core$List$cons(x)),
							A2(
								elm$core$Basics$composeR,
								elm$core$Maybe$withDefault(
									_List_fromArray(
										[x])),
								elm$core$Maybe$Just)),
						acc);
				}),
			elm$core$Dict$empty,
			list);
	});
var author$project$GameData$createIndexes = function (l) {
	var unitsByName = A2(elm_community$dict_extra$Dict$Extra$fromListBy, author$project$GameData$Unit$name, l.k);
	var items_ = _Utils_ap(
		A2(elm$core$List$map, author$project$GameData$Item$Unit, l.k),
		_Utils_ap(
			A2(elm$core$List$map, author$project$GameData$Item$Upgrade, l.o),
			A2(elm$core$List$map, author$project$GameData$Item$Spell, l.s)));
	return {
		bL: A2(elm_community$dict_extra$Dict$Extra$fromListBy, author$project$GameData$Achievement$name, l.aQ),
		du: items_,
		b3: A2(
			elm$core$Dict$map,
			function (_n0) {
				return elm$core$List$map(elm$core$Tuple$second);
			},
			A2(
				elm_community$dict_extra$Dict$Extra$groupBy,
				A2(elm$core$Basics$composeR, elm$core$Tuple$first, author$project$GameData$Unit$idToString),
				A2(
					elm$core$List$concatMap,
					function (item) {
						return A2(
							elm$core$List$map,
							elm$core$Tuple$mapSecond(
								elm$core$Tuple$pair(item)),
							author$project$GameData$Item$cost(item));
					},
					items_))),
		b4: A2(elm_community$dict_extra$Dict$Extra$fromListBy, author$project$GameData$Item$name, items_),
		b5: A2(
			elm$core$Dict$map,
			elm$core$Basics$always(elm$core$Tuple$first),
			A2(
				elm_community$dict_extra$Dict$Extra$fromListBy,
				elm$core$Tuple$second,
				A2(
					elm$core$List$filterMap,
					function (item) {
						return A2(
							elm$core$Maybe$map,
							elm$core$Tuple$pair(item),
							author$project$GameData$Item$slug(item));
					},
					items_))),
		ch: A2(
			elm_community$dict_extra$Dict$Extra$fromListBy,
			A2(
				elm$core$Basics$composeR,
				function ($) {
					return $.eL;
				},
				author$project$GameData$Mtx$idToString),
			l.cg),
		cB: A2(elm_community$dict_extra$Dict$Extra$fromListBy, author$project$GameData$Spell$name, l.s),
		cC: A2(
			elm_community$dict_extra$Dict$Extra$fromListBy,
			A2(
				elm$core$Basics$composeR,
				function ($) {
					return $.cA;
				},
				elm$core$String$toLower),
			l.s),
		cD: A2(
			elm_community$dict_extra$Dict$Extra$groupBy,
			A2(
				elm$core$Basics$composeR,
				function ($) {
					return $.fM;
				},
				author$project$GameData$Tab$idToString),
			l.s),
		cI: A2(elm_community$dict_extra$Dict$Extra$fromListBy, author$project$GameData$Tab$name, l.bD),
		cL: unitsByName,
		cM: A2(
			elm_community$dict_extra$Dict$Extra$fromListBy,
			A2(
				elm$core$Basics$composeR,
				function ($) {
					return $.cA;
				},
				elm$core$String$toLower),
			l.k),
		cN: A2(
			elm$core$Dict$map,
			elm$core$Basics$always(elm$core$List$reverse),
			A2(
				elm_community$dict_extra$Dict$Extra$groupBy,
				A2(
					elm$core$Basics$composeR,
					function ($) {
						return $.fM;
					},
					author$project$GameData$Tab$idToString),
				l.k)),
		cO: A2(elm_community$dict_extra$Dict$Extra$fromListBy, author$project$GameData$Upgrade$name, l.o),
		d5: A2(
			elm$core$Dict$remove,
			'__none__',
			A2(
				elm_community$dict_extra$Dict$Extra$groupBy,
				function (u) {
					return A2(
						elm$core$Maybe$withDefault,
						'__none__',
						A2(
							elm$core$Maybe$map,
							A2(
								elm$core$Basics$composeR,
								function ($) {
									return $.fM;
								},
								author$project$GameData$Tab$idToString),
							A2(
								elm$core$Dict$get,
								author$project$GameData$Unit$idToString(u.d3),
								unitsByName)));
				},
				l.o)),
		cP: A2(
			elm_community$dict_extra$Dict$Extra$groupBy,
			A2(
				elm$core$Basics$composeR,
				function ($) {
					return $.d3;
				},
				author$project$GameData$Unit$idToString),
			l.o)
	};
};
var author$project$GameData$Achievement$Achievement = F4(
	function (id, points, visible, trigger) {
		return {eL: id, cs: points, fT: trigger, f$: visible};
	});
var author$project$GameData$Achievement$Event = function (a) {
	return {$: 1, a: a};
};
var author$project$GameData$Achievement$Expr = function (a) {
	return {$: 0, a: a};
};
var author$project$GameData$Achievement$Id$Id = elm$core$Basics$identity;
var elm$core$Basics$identity = function (x) {
	return x;
};
var elm$core$Array$branchFactor = 32;
var elm$core$Array$Array_elm_builtin = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var elm$core$Basics$ceiling = _Basics_ceiling;
var elm$core$Basics$fdiv = _Basics_fdiv;
var elm$core$Basics$logBase = F2(
	function (base, number) {
		return _Basics_log(number) / _Basics_log(base);
	});
var elm$core$Basics$toFloat = _Basics_toFloat;
var elm$core$Array$shiftStep = elm$core$Basics$ceiling(
	A2(elm$core$Basics$logBase, 2, elm$core$Array$branchFactor));
var elm$core$Elm$JsArray$empty = _JsArray_empty;
var elm$core$Array$empty = A4(elm$core$Array$Array_elm_builtin, 0, elm$core$Array$shiftStep, elm$core$Elm$JsArray$empty, elm$core$Elm$JsArray$empty);
var elm$core$Array$Leaf = function (a) {
	return {$: 1, a: a};
};
var elm$core$Array$SubTree = function (a) {
	return {$: 0, a: a};
};
var elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
var elm$core$Array$compressNodes = F2(
	function (nodes, acc) {
		compressNodes:
		while (true) {
			var _n0 = A2(elm$core$Elm$JsArray$initializeFromList, elm$core$Array$branchFactor, nodes);
			var node = _n0.a;
			var remainingNodes = _n0.b;
			var newAcc = A2(
				elm$core$List$cons,
				elm$core$Array$SubTree(node),
				acc);
			if (!remainingNodes.b) {
				return elm$core$List$reverse(newAcc);
			} else {
				var $temp$nodes = remainingNodes,
					$temp$acc = newAcc;
				nodes = $temp$nodes;
				acc = $temp$acc;
				continue compressNodes;
			}
		}
	});
var elm$core$Array$treeFromBuilder = F2(
	function (nodeList, nodeListSize) {
		treeFromBuilder:
		while (true) {
			var newNodeSize = elm$core$Basics$ceiling(nodeListSize / elm$core$Array$branchFactor);
			if (newNodeSize === 1) {
				return A2(elm$core$Elm$JsArray$initializeFromList, elm$core$Array$branchFactor, nodeList).a;
			} else {
				var $temp$nodeList = A2(elm$core$Array$compressNodes, nodeList, _List_Nil),
					$temp$nodeListSize = newNodeSize;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue treeFromBuilder;
			}
		}
	});
var elm$core$Basics$apL = F2(
	function (f, x) {
		return f(x);
	});
var elm$core$Basics$floor = _Basics_floor;
var elm$core$Basics$max = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) > 0) ? x : y;
	});
var elm$core$Basics$mul = _Basics_mul;
var elm$core$Basics$sub = _Basics_sub;
var elm$core$Elm$JsArray$length = _JsArray_length;
var elm$core$Array$builderToArray = F2(
	function (reverseNodeList, builder) {
		if (!builder.l) {
			return A4(
				elm$core$Array$Array_elm_builtin,
				elm$core$Elm$JsArray$length(builder.n),
				elm$core$Array$shiftStep,
				elm$core$Elm$JsArray$empty,
				builder.n);
		} else {
			var treeLen = builder.l * elm$core$Array$branchFactor;
			var depth = elm$core$Basics$floor(
				A2(elm$core$Basics$logBase, elm$core$Array$branchFactor, treeLen - 1));
			var correctNodeList = reverseNodeList ? elm$core$List$reverse(builder.p) : builder.p;
			var tree = A2(elm$core$Array$treeFromBuilder, correctNodeList, builder.l);
			return A4(
				elm$core$Array$Array_elm_builtin,
				elm$core$Elm$JsArray$length(builder.n) + treeLen,
				A2(elm$core$Basics$max, 5, depth * elm$core$Array$shiftStep),
				tree,
				builder.n);
		}
	});
var elm$core$Basics$False = 1;
var elm$core$Basics$idiv = _Basics_idiv;
var elm$core$Elm$JsArray$initialize = _JsArray_initialize;
var elm$core$Array$initializeHelp = F5(
	function (fn, fromIndex, len, nodeList, tail) {
		initializeHelp:
		while (true) {
			if (fromIndex < 0) {
				return A2(
					elm$core$Array$builderToArray,
					false,
					{p: nodeList, l: (len / elm$core$Array$branchFactor) | 0, n: tail});
			} else {
				var leaf = elm$core$Array$Leaf(
					A3(elm$core$Elm$JsArray$initialize, elm$core$Array$branchFactor, fromIndex, fn));
				var $temp$fn = fn,
					$temp$fromIndex = fromIndex - elm$core$Array$branchFactor,
					$temp$len = len,
					$temp$nodeList = A2(elm$core$List$cons, leaf, nodeList),
					$temp$tail = tail;
				fn = $temp$fn;
				fromIndex = $temp$fromIndex;
				len = $temp$len;
				nodeList = $temp$nodeList;
				tail = $temp$tail;
				continue initializeHelp;
			}
		}
	});
var elm$core$Basics$le = _Utils_le;
var elm$core$Basics$remainderBy = _Basics_remainderBy;
var elm$core$Array$initialize = F2(
	function (len, fn) {
		if (len <= 0) {
			return elm$core$Array$empty;
		} else {
			var tailLen = len % elm$core$Array$branchFactor;
			var tail = A3(elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
			var initialFromIndex = (len - tailLen) - elm$core$Array$branchFactor;
			return A5(elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
		}
	});
var elm$core$Result$Err = function (a) {
	return {$: 1, a: a};
};
var elm$core$Result$Ok = function (a) {
	return {$: 0, a: a};
};
var elm$core$Basics$True = 0;
var elm$core$Result$isOk = function (result) {
	if (!result.$) {
		return true;
	} else {
		return false;
	}
};
var elm$json$Json$Decode$Failure = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var elm$json$Json$Decode$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var elm$json$Json$Decode$Index = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var elm$json$Json$Decode$OneOf = function (a) {
	return {$: 2, a: a};
};
var elm$core$Basics$and = _Basics_and;
var elm$core$Basics$or = _Basics_or;
var elm$core$Char$toCode = _Char_toCode;
var elm$core$Char$isLower = function (_char) {
	var code = elm$core$Char$toCode(_char);
	return (97 <= code) && (code <= 122);
};
var elm$core$Char$isUpper = function (_char) {
	var code = elm$core$Char$toCode(_char);
	return (code <= 90) && (65 <= code);
};
var elm$core$Char$isAlpha = function (_char) {
	return elm$core$Char$isLower(_char) || elm$core$Char$isUpper(_char);
};
var elm$core$Char$isDigit = function (_char) {
	var code = elm$core$Char$toCode(_char);
	return (code <= 57) && (48 <= code);
};
var elm$core$Char$isAlphaNum = function (_char) {
	return elm$core$Char$isLower(_char) || (elm$core$Char$isUpper(_char) || elm$core$Char$isDigit(_char));
};
var elm$core$List$length = function (xs) {
	return A3(
		elm$core$List$foldl,
		F2(
			function (_n0, i) {
				return i + 1;
			}),
		0,
		xs);
};
var elm$core$List$map2 = _List_map2;
var elm$core$List$rangeHelp = F3(
	function (lo, hi, list) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(lo, hi) < 1) {
				var $temp$lo = lo,
					$temp$hi = hi - 1,
					$temp$list = A2(elm$core$List$cons, hi, list);
				lo = $temp$lo;
				hi = $temp$hi;
				list = $temp$list;
				continue rangeHelp;
			} else {
				return list;
			}
		}
	});
var elm$core$List$range = F2(
	function (lo, hi) {
		return A3(elm$core$List$rangeHelp, lo, hi, _List_Nil);
	});
var elm$core$List$indexedMap = F2(
	function (f, xs) {
		return A3(
			elm$core$List$map2,
			f,
			A2(
				elm$core$List$range,
				0,
				elm$core$List$length(xs) - 1),
			xs);
	});
var elm$core$String$all = _String_all;
var elm$core$String$fromInt = _String_fromNumber;
var elm$core$String$join = F2(
	function (sep, chunks) {
		return A2(
			_String_join,
			sep,
			_List_toArray(chunks));
	});
var elm$core$String$uncons = _String_uncons;
var elm$core$String$split = F2(
	function (sep, string) {
		return _List_fromArray(
			A2(_String_split, sep, string));
	});
var elm$json$Json$Decode$indent = function (str) {
	return A2(
		elm$core$String$join,
		'\n    ',
		A2(elm$core$String$split, '\n', str));
};
var elm$json$Json$Encode$encode = _Json_encode;
var elm$json$Json$Decode$errorOneOf = F2(
	function (i, error) {
		return '\n\n(' + (elm$core$String$fromInt(i + 1) + (') ' + elm$json$Json$Decode$indent(
			elm$json$Json$Decode$errorToString(error))));
	});
var elm$json$Json$Decode$errorToString = function (error) {
	return A2(elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
};
var elm$json$Json$Decode$errorToStringHelp = F2(
	function (error, context) {
		errorToStringHelp:
		while (true) {
			switch (error.$) {
				case 0:
					var f = error.a;
					var err = error.b;
					var isSimple = function () {
						var _n1 = elm$core$String$uncons(f);
						if (_n1.$ === 1) {
							return false;
						} else {
							var _n2 = _n1.a;
							var _char = _n2.a;
							var rest = _n2.b;
							return elm$core$Char$isAlpha(_char) && A2(elm$core$String$all, elm$core$Char$isAlphaNum, rest);
						}
					}();
					var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
					var $temp$error = err,
						$temp$context = A2(elm$core$List$cons, fieldName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 1:
					var i = error.a;
					var err = error.b;
					var indexName = '[' + (elm$core$String$fromInt(i) + ']');
					var $temp$error = err,
						$temp$context = A2(elm$core$List$cons, indexName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 2:
					var errors = error.a;
					if (!errors.b) {
						return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
							if (!context.b) {
								return '!';
							} else {
								return ' at json' + A2(
									elm$core$String$join,
									'',
									elm$core$List$reverse(context));
							}
						}();
					} else {
						if (!errors.b.b) {
							var err = errors.a;
							var $temp$error = err,
								$temp$context = context;
							error = $temp$error;
							context = $temp$context;
							continue errorToStringHelp;
						} else {
							var starter = function () {
								if (!context.b) {
									return 'Json.Decode.oneOf';
								} else {
									return 'The Json.Decode.oneOf at json' + A2(
										elm$core$String$join,
										'',
										elm$core$List$reverse(context));
								}
							}();
							var introduction = starter + (' failed in the following ' + (elm$core$String$fromInt(
								elm$core$List$length(errors)) + ' ways:'));
							return A2(
								elm$core$String$join,
								'\n\n',
								A2(
									elm$core$List$cons,
									introduction,
									A2(elm$core$List$indexedMap, elm$json$Json$Decode$errorOneOf, errors)));
						}
					}
				default:
					var msg = error.a;
					var json = error.b;
					var introduction = function () {
						if (!context.b) {
							return 'Problem with the given value:\n\n';
						} else {
							return 'Problem with the value at json' + (A2(
								elm$core$String$join,
								'',
								elm$core$List$reverse(context)) + ':\n\n    ');
						}
					}();
					return introduction + (elm$json$Json$Decode$indent(
						A2(elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
			}
		}
	});
var elm$json$Json$Decode$map = _Json_map1;
var elm$json$Json$Decode$string = _Json_decodeString;
var author$project$GameData$Achievement$Id$decoder = A2(elm$json$Json$Decode$map, elm$core$Basics$identity, elm$json$Json$Decode$string);
var author$project$Parser$Visibility$Val = function (a) {
	return {$: 2, a: a};
};
var author$project$Parser$Visibility$ExprStep0 = function (a) {
	return {$: 0, a: a};
};
var author$project$Parser$Visibility$ExprStepN = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var author$project$Parser$Visibility$Ops = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var author$project$Parser$Visibility$Order = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var author$project$Parser$Visibility$EQ = 2;
var author$project$Parser$Visibility$GT = 0;
var author$project$Parser$Visibility$GTE = 1;
var author$project$Parser$Visibility$LT = 5;
var author$project$Parser$Visibility$LTE = 4;
var author$project$Parser$Visibility$NE = 3;
var elm$parser$Parser$Advanced$Bad = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var elm$parser$Parser$Advanced$Good = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var elm$parser$Parser$Advanced$Parser = elm$core$Basics$identity;
var elm$parser$Parser$Advanced$map2 = F3(
	function (func, _n0, _n1) {
		var parseA = _n0;
		var parseB = _n1;
		return function (s0) {
			var _n2 = parseA(s0);
			if (_n2.$ === 1) {
				var p = _n2.a;
				var x = _n2.b;
				return A2(elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _n2.a;
				var a = _n2.b;
				var s1 = _n2.c;
				var _n3 = parseB(s1);
				if (_n3.$ === 1) {
					var p2 = _n3.a;
					var x = _n3.b;
					return A2(elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _n3.a;
					var b = _n3.b;
					var s2 = _n3.c;
					return A3(
						elm$parser$Parser$Advanced$Good,
						p1 || p2,
						A2(func, a, b),
						s2);
				}
			}
		};
	});
var elm$parser$Parser$Advanced$ignorer = F2(
	function (keepParser, ignoreParser) {
		return A3(elm$parser$Parser$Advanced$map2, elm$core$Basics$always, keepParser, ignoreParser);
	});
var elm$parser$Parser$ignorer = elm$parser$Parser$Advanced$ignorer;
var elm$parser$Parser$ExpectingKeyword = function (a) {
	return {$: 9, a: a};
};
var elm$parser$Parser$Advanced$Token = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var elm$core$Basics$negate = function (n) {
	return -n;
};
var elm$core$Basics$not = _Basics_not;
var elm$core$String$isEmpty = function (string) {
	return string === '';
};
var elm$parser$Parser$Advanced$AddRight = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var elm$parser$Parser$Advanced$DeadEnd = F4(
	function (row, col, problem, contextStack) {
		return {c5: col, er: contextStack, dG: problem, dT: row};
	});
var elm$parser$Parser$Advanced$Empty = {$: 0};
var elm$parser$Parser$Advanced$fromState = F2(
	function (s, x) {
		return A2(
			elm$parser$Parser$Advanced$AddRight,
			elm$parser$Parser$Advanced$Empty,
			A4(elm$parser$Parser$Advanced$DeadEnd, s.dT, s.c5, x, s.g));
	});
var elm$parser$Parser$Advanced$isSubChar = _Parser_isSubChar;
var elm$parser$Parser$Advanced$isSubString = _Parser_isSubString;
var elm$parser$Parser$Advanced$keyword = function (_n0) {
	var kwd = _n0.a;
	var expecting = _n0.b;
	var progress = !elm$core$String$isEmpty(kwd);
	return function (s) {
		var _n1 = A5(elm$parser$Parser$Advanced$isSubString, kwd, s.b, s.dT, s.c5, s.a);
		var newOffset = _n1.a;
		var newRow = _n1.b;
		var newCol = _n1.c;
		return (_Utils_eq(newOffset, -1) || (0 <= A3(
			elm$parser$Parser$Advanced$isSubChar,
			function (c) {
				return elm$core$Char$isAlphaNum(c) || (c === '_');
			},
			newOffset,
			s.a))) ? A2(
			elm$parser$Parser$Advanced$Bad,
			false,
			A2(elm$parser$Parser$Advanced$fromState, s, expecting)) : A3(
			elm$parser$Parser$Advanced$Good,
			progress,
			0,
			{c5: newCol, g: s.g, h: s.h, b: newOffset, dT: newRow, a: s.a});
	};
};
var elm$parser$Parser$keyword = function (kwd) {
	return elm$parser$Parser$Advanced$keyword(
		A2(
			elm$parser$Parser$Advanced$Token,
			kwd,
			elm$parser$Parser$ExpectingKeyword(kwd)));
};
var elm$parser$Parser$Advanced$Append = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var elm$parser$Parser$Advanced$oneOfHelp = F3(
	function (s0, bag, parsers) {
		oneOfHelp:
		while (true) {
			if (!parsers.b) {
				return A2(elm$parser$Parser$Advanced$Bad, false, bag);
			} else {
				var parse = parsers.a;
				var remainingParsers = parsers.b;
				var _n1 = parse(s0);
				if (!_n1.$) {
					var step = _n1;
					return step;
				} else {
					var step = _n1;
					var p = step.a;
					var x = step.b;
					if (p) {
						return step;
					} else {
						var $temp$s0 = s0,
							$temp$bag = A2(elm$parser$Parser$Advanced$Append, bag, x),
							$temp$parsers = remainingParsers;
						s0 = $temp$s0;
						bag = $temp$bag;
						parsers = $temp$parsers;
						continue oneOfHelp;
					}
				}
			}
		}
	});
var elm$parser$Parser$Advanced$oneOf = function (parsers) {
	return function (s) {
		return A3(elm$parser$Parser$Advanced$oneOfHelp, s, elm$parser$Parser$Advanced$Empty, parsers);
	};
};
var elm$parser$Parser$oneOf = elm$parser$Parser$Advanced$oneOf;
var elm$parser$Parser$Advanced$succeed = function (a) {
	return function (s) {
		return A3(elm$parser$Parser$Advanced$Good, false, a, s);
	};
};
var elm$parser$Parser$succeed = elm$parser$Parser$Advanced$succeed;
var author$project$Parser$Visibility$comparator = elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			elm$parser$Parser$ignorer,
			elm$parser$Parser$succeed(1),
			elm$parser$Parser$keyword('>=')),
			A2(
			elm$parser$Parser$ignorer,
			elm$parser$Parser$succeed(2),
			elm$parser$Parser$keyword('==')),
			A2(
			elm$parser$Parser$ignorer,
			elm$parser$Parser$succeed(3),
			elm$parser$Parser$keyword('/=')),
			A2(
			elm$parser$Parser$ignorer,
			elm$parser$Parser$succeed(4),
			elm$parser$Parser$keyword('<=')),
			A2(
			elm$parser$Parser$ignorer,
			elm$parser$Parser$succeed(5),
			elm$parser$Parser$keyword('<')),
			A2(
			elm$parser$Parser$ignorer,
			elm$parser$Parser$succeed(0),
			elm$parser$Parser$keyword('>'))
		]));
var author$project$Decimal$Decimal = elm$core$Basics$identity;
var author$project$Decimal$base = 10;
var author$project$Decimal$baseFloat = author$project$Decimal$base;
var author$project$Decimal$epsilonF = 1.0e-10;
var elm$core$Basics$isInfinite = _Basics_isInfinite;
var elm$core$Basics$pow = _Basics_pow;
var author$project$Decimal$sigTimesExp = F2(
	function (sig, dExp) {
		return ((!dExp) || elm$core$Basics$isInfinite(sig)) ? sig : (sig / A2(elm$core$Basics$pow, author$project$Decimal$base, dExp));
	});
var elm$core$Basics$abs = function (n) {
	return (n < 0) ? (-n) : n;
};
var author$project$Decimal$fromSigExp = F2(
	function (sig, exp) {
		if (!sig) {
			return {j: 0, i: sig};
		} else {
			var dExp = elm$core$Basics$floor(
				author$project$Decimal$epsilonF + A2(
					elm$core$Basics$logBase,
					author$project$Decimal$baseFloat,
					elm$core$Basics$abs(sig)));
			return {
				j: exp + dExp,
				i: A2(author$project$Decimal$sigTimesExp, sig, dExp)
			};
		}
	});
var author$project$Decimal$fromFloat = function (sig) {
	return A2(author$project$Decimal$fromSigExp, sig, 0);
};
var author$project$Decimal$fromInt = A2(elm$core$Basics$composeR, elm$core$Basics$toFloat, author$project$Decimal$fromFloat);
var elm$core$Result$fromMaybe = F2(
	function (err, maybe) {
		if (!maybe.$) {
			var v = maybe.a;
			return elm$core$Result$Ok(v);
		} else {
			return elm$core$Result$Err(err);
		}
	});
var elm$parser$Parser$ExpectingBinary = {$: 4};
var elm$parser$Parser$ExpectingFloat = {$: 5};
var elm$parser$Parser$ExpectingHex = {$: 2};
var elm$parser$Parser$ExpectingInt = {$: 1};
var elm$parser$Parser$ExpectingNumber = {$: 6};
var elm$parser$Parser$ExpectingOctal = {$: 3};
var elm$parser$Parser$Advanced$consumeBase = _Parser_consumeBase;
var elm$parser$Parser$Advanced$consumeBase16 = _Parser_consumeBase16;
var elm$core$String$slice = _String_slice;
var elm$core$String$toFloat = _String_toFloat;
var elm$parser$Parser$Advanced$bumpOffset = F2(
	function (newOffset, s) {
		return {c5: s.c5 + (newOffset - s.b), g: s.g, h: s.h, b: newOffset, dT: s.dT, a: s.a};
	});
var elm$parser$Parser$Advanced$chompBase10 = _Parser_chompBase10;
var elm$parser$Parser$Advanced$isAsciiCode = _Parser_isAsciiCode;
var elm$parser$Parser$Advanced$consumeExp = F2(
	function (offset, src) {
		if (A3(elm$parser$Parser$Advanced$isAsciiCode, 101, offset, src) || A3(elm$parser$Parser$Advanced$isAsciiCode, 69, offset, src)) {
			var eOffset = offset + 1;
			var expOffset = (A3(elm$parser$Parser$Advanced$isAsciiCode, 43, eOffset, src) || A3(elm$parser$Parser$Advanced$isAsciiCode, 45, eOffset, src)) ? (eOffset + 1) : eOffset;
			var newOffset = A2(elm$parser$Parser$Advanced$chompBase10, expOffset, src);
			return _Utils_eq(expOffset, newOffset) ? (-newOffset) : newOffset;
		} else {
			return offset;
		}
	});
var elm$parser$Parser$Advanced$consumeDotAndExp = F2(
	function (offset, src) {
		return A3(elm$parser$Parser$Advanced$isAsciiCode, 46, offset, src) ? A2(
			elm$parser$Parser$Advanced$consumeExp,
			A2(elm$parser$Parser$Advanced$chompBase10, offset + 1, src),
			src) : A2(elm$parser$Parser$Advanced$consumeExp, offset, src);
	});
var elm$parser$Parser$Advanced$finalizeInt = F5(
	function (invalid, handler, startOffset, _n0, s) {
		var endOffset = _n0.a;
		var n = _n0.b;
		if (handler.$ === 1) {
			var x = handler.a;
			return A2(
				elm$parser$Parser$Advanced$Bad,
				true,
				A2(elm$parser$Parser$Advanced$fromState, s, x));
		} else {
			var toValue = handler.a;
			return _Utils_eq(startOffset, endOffset) ? A2(
				elm$parser$Parser$Advanced$Bad,
				_Utils_cmp(s.b, startOffset) < 0,
				A2(elm$parser$Parser$Advanced$fromState, s, invalid)) : A3(
				elm$parser$Parser$Advanced$Good,
				true,
				toValue(n),
				A2(elm$parser$Parser$Advanced$bumpOffset, endOffset, s));
		}
	});
var elm$parser$Parser$Advanced$fromInfo = F4(
	function (row, col, x, context) {
		return A2(
			elm$parser$Parser$Advanced$AddRight,
			elm$parser$Parser$Advanced$Empty,
			A4(elm$parser$Parser$Advanced$DeadEnd, row, col, x, context));
	});
var elm$parser$Parser$Advanced$finalizeFloat = F6(
	function (invalid, expecting, intSettings, floatSettings, intPair, s) {
		var intOffset = intPair.a;
		var floatOffset = A2(elm$parser$Parser$Advanced$consumeDotAndExp, intOffset, s.a);
		if (floatOffset < 0) {
			return A2(
				elm$parser$Parser$Advanced$Bad,
				true,
				A4(elm$parser$Parser$Advanced$fromInfo, s.dT, s.c5 - (floatOffset + s.b), invalid, s.g));
		} else {
			if (_Utils_eq(s.b, floatOffset)) {
				return A2(
					elm$parser$Parser$Advanced$Bad,
					false,
					A2(elm$parser$Parser$Advanced$fromState, s, expecting));
			} else {
				if (_Utils_eq(intOffset, floatOffset)) {
					return A5(elm$parser$Parser$Advanced$finalizeInt, invalid, intSettings, s.b, intPair, s);
				} else {
					if (floatSettings.$ === 1) {
						var x = floatSettings.a;
						return A2(
							elm$parser$Parser$Advanced$Bad,
							true,
							A2(elm$parser$Parser$Advanced$fromState, s, invalid));
					} else {
						var toValue = floatSettings.a;
						var _n1 = elm$core$String$toFloat(
							A3(elm$core$String$slice, s.b, floatOffset, s.a));
						if (_n1.$ === 1) {
							return A2(
								elm$parser$Parser$Advanced$Bad,
								true,
								A2(elm$parser$Parser$Advanced$fromState, s, invalid));
						} else {
							var n = _n1.a;
							return A3(
								elm$parser$Parser$Advanced$Good,
								true,
								toValue(n),
								A2(elm$parser$Parser$Advanced$bumpOffset, floatOffset, s));
						}
					}
				}
			}
		}
	});
var elm$parser$Parser$Advanced$number = function (c) {
	return function (s) {
		if (A3(elm$parser$Parser$Advanced$isAsciiCode, 48, s.b, s.a)) {
			var zeroOffset = s.b + 1;
			var baseOffset = zeroOffset + 1;
			return A3(elm$parser$Parser$Advanced$isAsciiCode, 120, zeroOffset, s.a) ? A5(
				elm$parser$Parser$Advanced$finalizeInt,
				c.eT,
				c.eJ,
				baseOffset,
				A2(elm$parser$Parser$Advanced$consumeBase16, baseOffset, s.a),
				s) : (A3(elm$parser$Parser$Advanced$isAsciiCode, 111, zeroOffset, s.a) ? A5(
				elm$parser$Parser$Advanced$finalizeInt,
				c.eT,
				c.e8,
				baseOffset,
				A3(elm$parser$Parser$Advanced$consumeBase, 8, baseOffset, s.a),
				s) : (A3(elm$parser$Parser$Advanced$isAsciiCode, 98, zeroOffset, s.a) ? A5(
				elm$parser$Parser$Advanced$finalizeInt,
				c.eT,
				c.ei,
				baseOffset,
				A3(elm$parser$Parser$Advanced$consumeBase, 2, baseOffset, s.a),
				s) : A6(
				elm$parser$Parser$Advanced$finalizeFloat,
				c.eT,
				c.dg,
				c.eS,
				c.eH,
				_Utils_Tuple2(zeroOffset, 0),
				s)));
		} else {
			return A6(
				elm$parser$Parser$Advanced$finalizeFloat,
				c.eT,
				c.dg,
				c.eS,
				c.eH,
				A3(elm$parser$Parser$Advanced$consumeBase, 10, s.b, s.a),
				s);
		}
	};
};
var elm$parser$Parser$number = function (i) {
	return elm$parser$Parser$Advanced$number(
		{
			ei: A2(elm$core$Result$fromMaybe, elm$parser$Parser$ExpectingBinary, i.ei),
			dg: elm$parser$Parser$ExpectingNumber,
			eH: A2(elm$core$Result$fromMaybe, elm$parser$Parser$ExpectingFloat, i.eH),
			eJ: A2(elm$core$Result$fromMaybe, elm$parser$Parser$ExpectingHex, i.eJ),
			eS: A2(elm$core$Result$fromMaybe, elm$parser$Parser$ExpectingInt, i.eS),
			eT: elm$parser$Parser$ExpectingNumber,
			e8: A2(elm$core$Result$fromMaybe, elm$parser$Parser$ExpectingOctal, i.e8)
		});
};
var author$project$Parser$Visibility$decimal = elm$parser$Parser$number(
	{
		ei: elm$core$Maybe$Nothing,
		eH: elm$core$Maybe$Just(author$project$Decimal$fromFloat),
		eJ: elm$core$Maybe$Nothing,
		eS: elm$core$Maybe$Just(author$project$Decimal$fromInt),
		e8: elm$core$Maybe$Nothing
	});
var author$project$Parser$Visibility$DecimalVar = function (a) {
	return {$: 0, a: a};
};
var author$project$Parser$Visibility$Sum = function (a) {
	return {$: 1, a: a};
};
var elm$core$Set$Set_elm_builtin = elm$core$Basics$identity;
var elm$core$Set$empty = elm$core$Dict$empty;
var elm$parser$Parser$ExpectingVariable = {$: 7};
var elm$core$Dict$member = F2(
	function (key, dict) {
		var _n0 = A2(elm$core$Dict$get, key, dict);
		if (!_n0.$) {
			return true;
		} else {
			return false;
		}
	});
var elm$core$Set$member = F2(
	function (key, _n0) {
		var dict = _n0;
		return A2(elm$core$Dict$member, key, dict);
	});
var elm$parser$Parser$Advanced$varHelp = F7(
	function (isGood, offset, row, col, src, indent, context) {
		varHelp:
		while (true) {
			var newOffset = A3(elm$parser$Parser$Advanced$isSubChar, isGood, offset, src);
			if (_Utils_eq(newOffset, -1)) {
				return {c5: col, g: context, h: indent, b: offset, dT: row, a: src};
			} else {
				if (_Utils_eq(newOffset, -2)) {
					var $temp$isGood = isGood,
						$temp$offset = offset + 1,
						$temp$row = row + 1,
						$temp$col = 1,
						$temp$src = src,
						$temp$indent = indent,
						$temp$context = context;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					src = $temp$src;
					indent = $temp$indent;
					context = $temp$context;
					continue varHelp;
				} else {
					var $temp$isGood = isGood,
						$temp$offset = newOffset,
						$temp$row = row,
						$temp$col = col + 1,
						$temp$src = src,
						$temp$indent = indent,
						$temp$context = context;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					src = $temp$src;
					indent = $temp$indent;
					context = $temp$context;
					continue varHelp;
				}
			}
		}
	});
var elm$parser$Parser$Advanced$variable = function (i) {
	return function (s) {
		var firstOffset = A3(elm$parser$Parser$Advanced$isSubChar, i.fF, s.b, s.a);
		if (_Utils_eq(firstOffset, -1)) {
			return A2(
				elm$parser$Parser$Advanced$Bad,
				false,
				A2(elm$parser$Parser$Advanced$fromState, s, i.dg));
		} else {
			var s1 = _Utils_eq(firstOffset, -2) ? A7(elm$parser$Parser$Advanced$varHelp, i.eR, s.b + 1, s.dT + 1, 1, s.a, s.h, s.g) : A7(elm$parser$Parser$Advanced$varHelp, i.eR, firstOffset, s.dT, s.c5 + 1, s.a, s.h, s.g);
			var name = A3(elm$core$String$slice, s.b, s1.b, s.a);
			return A2(elm$core$Set$member, name, i.fr) ? A2(
				elm$parser$Parser$Advanced$Bad,
				false,
				A2(elm$parser$Parser$Advanced$fromState, s, i.dg)) : A3(elm$parser$Parser$Advanced$Good, true, name, s1);
		}
	};
};
var elm$parser$Parser$variable = function (i) {
	return elm$parser$Parser$Advanced$variable(
		{dg: elm$parser$Parser$ExpectingVariable, eR: i.eR, fr: i.fr, fF: i.fF});
};
var author$project$Parser$Visibility$label = elm$parser$Parser$variable(
	{
		eR: function (c) {
			return elm$core$Char$isAlphaNum(c) || (c === '_');
		},
		fr: elm$core$Set$empty,
		fF: elm$core$Char$isLower
	});
var elm$parser$Parser$Forbidden = 0;
var elm$parser$Parser$Advanced$keeper = F2(
	function (parseFunc, parseArg) {
		return A3(elm$parser$Parser$Advanced$map2, elm$core$Basics$apL, parseFunc, parseArg);
	});
var elm$parser$Parser$keeper = elm$parser$Parser$Advanced$keeper;
var elm$parser$Parser$Advanced$Forbidden = 0;
var elm$parser$Parser$Advanced$Mandatory = 2;
var elm$parser$Parser$Advanced$Optional = 1;
var elm$parser$Parser$toAdvancedTrailing = function (trailing) {
	switch (trailing) {
		case 0:
			return 0;
		case 1:
			return 1;
		default:
			return 2;
	}
};
var elm$parser$Parser$Expecting = function (a) {
	return {$: 0, a: a};
};
var elm$parser$Parser$toToken = function (str) {
	return A2(
		elm$parser$Parser$Advanced$Token,
		str,
		elm$parser$Parser$Expecting(str));
};
var elm$parser$Parser$Advanced$andThen = F2(
	function (callback, _n0) {
		var parseA = _n0;
		return function (s0) {
			var _n1 = parseA(s0);
			if (_n1.$ === 1) {
				var p = _n1.a;
				var x = _n1.b;
				return A2(elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _n1.a;
				var a = _n1.b;
				var s1 = _n1.c;
				var _n2 = callback(a);
				var parseB = _n2;
				var _n3 = parseB(s1);
				if (_n3.$ === 1) {
					var p2 = _n3.a;
					var x = _n3.b;
					return A2(elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _n3.a;
					var b = _n3.b;
					var s2 = _n3.c;
					return A3(elm$parser$Parser$Advanced$Good, p1 || p2, b, s2);
				}
			}
		};
	});
var elm$parser$Parser$Advanced$loopHelp = F4(
	function (p, state, callback, s0) {
		loopHelp:
		while (true) {
			var _n0 = callback(state);
			var parse = _n0;
			var _n1 = parse(s0);
			if (!_n1.$) {
				var p1 = _n1.a;
				var step = _n1.b;
				var s1 = _n1.c;
				if (!step.$) {
					var newState = step.a;
					var $temp$p = p || p1,
						$temp$state = newState,
						$temp$callback = callback,
						$temp$s0 = s1;
					p = $temp$p;
					state = $temp$state;
					callback = $temp$callback;
					s0 = $temp$s0;
					continue loopHelp;
				} else {
					var result = step.a;
					return A3(elm$parser$Parser$Advanced$Good, p || p1, result, s1);
				}
			} else {
				var p1 = _n1.a;
				var x = _n1.b;
				return A2(elm$parser$Parser$Advanced$Bad, p || p1, x);
			}
		}
	});
var elm$parser$Parser$Advanced$loop = F2(
	function (state, callback) {
		return function (s) {
			return A4(elm$parser$Parser$Advanced$loopHelp, false, state, callback, s);
		};
	});
var elm$parser$Parser$Advanced$map = F2(
	function (func, _n0) {
		var parse = _n0;
		return function (s0) {
			var _n1 = parse(s0);
			if (!_n1.$) {
				var p = _n1.a;
				var a = _n1.b;
				var s1 = _n1.c;
				return A3(
					elm$parser$Parser$Advanced$Good,
					p,
					func(a),
					s1);
			} else {
				var p = _n1.a;
				var x = _n1.b;
				return A2(elm$parser$Parser$Advanced$Bad, p, x);
			}
		};
	});
var elm$parser$Parser$Advanced$Done = function (a) {
	return {$: 1, a: a};
};
var elm$parser$Parser$Advanced$Loop = function (a) {
	return {$: 0, a: a};
};
var elm$parser$Parser$Advanced$revAlways = F2(
	function (_n0, b) {
		return b;
	});
var elm$parser$Parser$Advanced$skip = F2(
	function (iParser, kParser) {
		return A3(elm$parser$Parser$Advanced$map2, elm$parser$Parser$Advanced$revAlways, iParser, kParser);
	});
var elm$parser$Parser$Advanced$sequenceEndForbidden = F5(
	function (ender, ws, parseItem, sep, revItems) {
		var chompRest = function (item) {
			return A5(
				elm$parser$Parser$Advanced$sequenceEndForbidden,
				ender,
				ws,
				parseItem,
				sep,
				A2(elm$core$List$cons, item, revItems));
		};
		return A2(
			elm$parser$Parser$Advanced$skip,
			ws,
			elm$parser$Parser$Advanced$oneOf(
				_List_fromArray(
					[
						A2(
						elm$parser$Parser$Advanced$skip,
						sep,
						A2(
							elm$parser$Parser$Advanced$skip,
							ws,
							A2(
								elm$parser$Parser$Advanced$map,
								function (item) {
									return elm$parser$Parser$Advanced$Loop(
										A2(elm$core$List$cons, item, revItems));
								},
								parseItem))),
						A2(
						elm$parser$Parser$Advanced$map,
						function (_n0) {
							return elm$parser$Parser$Advanced$Done(
								elm$core$List$reverse(revItems));
						},
						ender)
					])));
	});
var elm$parser$Parser$Advanced$sequenceEndMandatory = F4(
	function (ws, parseItem, sep, revItems) {
		return elm$parser$Parser$Advanced$oneOf(
			_List_fromArray(
				[
					A2(
					elm$parser$Parser$Advanced$map,
					function (item) {
						return elm$parser$Parser$Advanced$Loop(
							A2(elm$core$List$cons, item, revItems));
					},
					A2(
						elm$parser$Parser$Advanced$ignorer,
						parseItem,
						A2(
							elm$parser$Parser$Advanced$ignorer,
							ws,
							A2(elm$parser$Parser$Advanced$ignorer, sep, ws)))),
					A2(
					elm$parser$Parser$Advanced$map,
					function (_n0) {
						return elm$parser$Parser$Advanced$Done(
							elm$core$List$reverse(revItems));
					},
					elm$parser$Parser$Advanced$succeed(0))
				]));
	});
var elm$parser$Parser$Advanced$sequenceEndOptional = F5(
	function (ender, ws, parseItem, sep, revItems) {
		var parseEnd = A2(
			elm$parser$Parser$Advanced$map,
			function (_n0) {
				return elm$parser$Parser$Advanced$Done(
					elm$core$List$reverse(revItems));
			},
			ender);
		return A2(
			elm$parser$Parser$Advanced$skip,
			ws,
			elm$parser$Parser$Advanced$oneOf(
				_List_fromArray(
					[
						A2(
						elm$parser$Parser$Advanced$skip,
						sep,
						A2(
							elm$parser$Parser$Advanced$skip,
							ws,
							elm$parser$Parser$Advanced$oneOf(
								_List_fromArray(
									[
										A2(
										elm$parser$Parser$Advanced$map,
										function (item) {
											return elm$parser$Parser$Advanced$Loop(
												A2(elm$core$List$cons, item, revItems));
										},
										parseItem),
										parseEnd
									])))),
						parseEnd
					])));
	});
var elm$parser$Parser$Advanced$sequenceEnd = F5(
	function (ender, ws, parseItem, sep, trailing) {
		var chompRest = function (item) {
			switch (trailing) {
				case 0:
					return A2(
						elm$parser$Parser$Advanced$loop,
						_List_fromArray(
							[item]),
						A4(elm$parser$Parser$Advanced$sequenceEndForbidden, ender, ws, parseItem, sep));
				case 1:
					return A2(
						elm$parser$Parser$Advanced$loop,
						_List_fromArray(
							[item]),
						A4(elm$parser$Parser$Advanced$sequenceEndOptional, ender, ws, parseItem, sep));
				default:
					return A2(
						elm$parser$Parser$Advanced$ignorer,
						A2(
							elm$parser$Parser$Advanced$skip,
							ws,
							A2(
								elm$parser$Parser$Advanced$skip,
								sep,
								A2(
									elm$parser$Parser$Advanced$skip,
									ws,
									A2(
										elm$parser$Parser$Advanced$loop,
										_List_fromArray(
											[item]),
										A3(elm$parser$Parser$Advanced$sequenceEndMandatory, ws, parseItem, sep))))),
						ender);
			}
		};
		return elm$parser$Parser$Advanced$oneOf(
			_List_fromArray(
				[
					A2(elm$parser$Parser$Advanced$andThen, chompRest, parseItem),
					A2(
					elm$parser$Parser$Advanced$map,
					function (_n0) {
						return _List_Nil;
					},
					ender)
				]));
	});
var elm$parser$Parser$Advanced$token = function (_n0) {
	var str = _n0.a;
	var expecting = _n0.b;
	var progress = !elm$core$String$isEmpty(str);
	return function (s) {
		var _n1 = A5(elm$parser$Parser$Advanced$isSubString, str, s.b, s.dT, s.c5, s.a);
		var newOffset = _n1.a;
		var newRow = _n1.b;
		var newCol = _n1.c;
		return _Utils_eq(newOffset, -1) ? A2(
			elm$parser$Parser$Advanced$Bad,
			false,
			A2(elm$parser$Parser$Advanced$fromState, s, expecting)) : A3(
			elm$parser$Parser$Advanced$Good,
			progress,
			0,
			{c5: newCol, g: s.g, h: s.h, b: newOffset, dT: newRow, a: s.a});
	};
};
var elm$parser$Parser$Advanced$sequence = function (i) {
	return A2(
		elm$parser$Parser$Advanced$skip,
		elm$parser$Parser$Advanced$token(i.fF),
		A2(
			elm$parser$Parser$Advanced$skip,
			i.fE,
			A5(
				elm$parser$Parser$Advanced$sequenceEnd,
				elm$parser$Parser$Advanced$token(i.ez),
				i.fE,
				i.eW,
				elm$parser$Parser$Advanced$token(i.fA),
				i.fS)));
};
var elm$parser$Parser$sequence = function (i) {
	return elm$parser$Parser$Advanced$sequence(
		{
			ez: elm$parser$Parser$toToken(i.ez),
			eW: i.eW,
			fA: elm$parser$Parser$toToken(i.fA),
			fE: i.fE,
			fF: elm$parser$Parser$toToken(i.fF),
			fS: elm$parser$Parser$toAdvancedTrailing(i.fS)
		});
};
var elm$parser$Parser$Advanced$chompWhileHelp = F5(
	function (isGood, offset, row, col, s0) {
		chompWhileHelp:
		while (true) {
			var newOffset = A3(elm$parser$Parser$Advanced$isSubChar, isGood, offset, s0.a);
			if (_Utils_eq(newOffset, -1)) {
				return A3(
					elm$parser$Parser$Advanced$Good,
					_Utils_cmp(s0.b, offset) < 0,
					0,
					{c5: col, g: s0.g, h: s0.h, b: offset, dT: row, a: s0.a});
			} else {
				if (_Utils_eq(newOffset, -2)) {
					var $temp$isGood = isGood,
						$temp$offset = offset + 1,
						$temp$row = row + 1,
						$temp$col = 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				} else {
					var $temp$isGood = isGood,
						$temp$offset = newOffset,
						$temp$row = row,
						$temp$col = col + 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				}
			}
		}
	});
var elm$parser$Parser$Advanced$chompWhile = function (isGood) {
	return function (s) {
		return A5(elm$parser$Parser$Advanced$chompWhileHelp, isGood, s.b, s.dT, s.c5, s);
	};
};
var elm$parser$Parser$Advanced$spaces = elm$parser$Parser$Advanced$chompWhile(
	function (c) {
		return (c === ' ') || ((c === '\n') || (c === '\r'));
	});
var elm$parser$Parser$spaces = elm$parser$Parser$Advanced$spaces;
var author$project$Parser$Visibility$decimalExpression = elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			elm$parser$Parser$keeper,
			elm$parser$Parser$succeed(author$project$Parser$Visibility$DecimalVar),
			author$project$Parser$Visibility$label),
			A2(
			elm$parser$Parser$keeper,
			elm$parser$Parser$succeed(author$project$Parser$Visibility$Sum),
			elm$parser$Parser$sequence(
				{ez: ')', eW: author$project$Parser$Visibility$label, fA: '+', fE: elm$parser$Parser$spaces, fF: '(', fS: 0}))
		]));
var author$project$Parser$Visibility$leaf = A2(
	elm$parser$Parser$keeper,
	A2(
		elm$parser$Parser$keeper,
		A2(
			elm$parser$Parser$keeper,
			elm$parser$Parser$succeed(author$project$Parser$Visibility$Order),
			A2(elm$parser$Parser$ignorer, author$project$Parser$Visibility$decimalExpression, elm$parser$Parser$spaces)),
		A2(elm$parser$Parser$ignorer, author$project$Parser$Visibility$comparator, elm$parser$Parser$spaces)),
	author$project$Parser$Visibility$decimal);
var author$project$Parser$Visibility$And = 0;
var author$project$Parser$Visibility$Or = 1;
var elm$parser$Parser$ExpectingSymbol = function (a) {
	return {$: 8, a: a};
};
var elm$parser$Parser$Advanced$symbol = elm$parser$Parser$Advanced$token;
var elm$parser$Parser$symbol = function (str) {
	return elm$parser$Parser$Advanced$symbol(
		A2(
			elm$parser$Parser$Advanced$Token,
			str,
			elm$parser$Parser$ExpectingSymbol(str)));
};
var author$project$Parser$Visibility$onlyOperator = function (op) {
	if (!op) {
		return A2(
			elm$parser$Parser$ignorer,
			elm$parser$Parser$succeed(0),
			elm$parser$Parser$symbol('&&'));
	} else {
		return A2(
			elm$parser$Parser$ignorer,
			elm$parser$Parser$succeed(1),
			elm$parser$Parser$symbol('||'));
	}
};
var author$project$Parser$Visibility$operator = elm$parser$Parser$oneOf(
	A2(
		elm$core$List$map,
		author$project$Parser$Visibility$onlyOperator,
		_List_fromArray(
			[0, 1])));
var elm$parser$Parser$Done = function (a) {
	return {$: 1, a: a};
};
var elm$parser$Parser$Loop = function (a) {
	return {$: 0, a: a};
};
var elm$parser$Parser$andThen = elm$parser$Parser$Advanced$andThen;
var elm$parser$Parser$Advanced$backtrackable = function (_n0) {
	var parse = _n0;
	return function (s0) {
		var _n1 = parse(s0);
		if (_n1.$ === 1) {
			var x = _n1.b;
			return A2(elm$parser$Parser$Advanced$Bad, false, x);
		} else {
			var a = _n1.b;
			var s1 = _n1.c;
			return A3(elm$parser$Parser$Advanced$Good, false, a, s1);
		}
	};
};
var elm$parser$Parser$backtrackable = elm$parser$Parser$Advanced$backtrackable;
var elm$parser$Parser$Advanced$lazy = function (thunk) {
	return function (s) {
		var _n0 = thunk(0);
		var parse = _n0;
		return parse(s);
	};
};
var elm$parser$Parser$lazy = elm$parser$Parser$Advanced$lazy;
var elm$parser$Parser$map = elm$parser$Parser$Advanced$map;
var elm$parser$Parser$toAdvancedStep = function (step) {
	if (!step.$) {
		var s = step.a;
		return elm$parser$Parser$Advanced$Loop(s);
	} else {
		var a = step.a;
		return elm$parser$Parser$Advanced$Done(a);
	}
};
var elm$parser$Parser$loop = F2(
	function (state, callback) {
		return A2(
			elm$parser$Parser$Advanced$loop,
			state,
			function (s) {
				return A2(
					elm$parser$Parser$map,
					elm$parser$Parser$toAdvancedStep,
					callback(s));
			});
	});
function author$project$Parser$Visibility$cyclic$expression() {
	var loop = function (step) {
		return elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					function () {
					var _n1 = function () {
						if (!step.$) {
							var e = step.a;
							return _Utils_Tuple2(
								elm$core$Maybe$Nothing,
								_List_fromArray(
									[e]));
						} else {
							var op = step.a;
							var exprs_ = step.b;
							return _Utils_Tuple2(
								elm$core$Maybe$Just(op),
								exprs_);
						}
					}();
					var lastOp = _n1.a;
					var exprs = _n1.b;
					return A2(
						elm$parser$Parser$keeper,
						A2(
							elm$parser$Parser$keeper,
							elm$parser$Parser$succeed(
								F2(
									function (op, expr) {
										return elm$parser$Parser$Loop(
											A2(
												author$project$Parser$Visibility$ExprStepN,
												op,
												A2(elm$core$List$cons, expr, exprs)));
									})),
							A2(
								elm$parser$Parser$ignorer,
								A2(
									elm$core$Maybe$withDefault,
									author$project$Parser$Visibility$operator,
									A2(elm$core$Maybe$map, author$project$Parser$Visibility$onlyOperator, lastOp)),
								elm$parser$Parser$spaces)),
						A2(
							elm$parser$Parser$ignorer,
							author$project$Parser$Visibility$cyclic$term(),
							elm$parser$Parser$spaces));
				}(),
					A2(
					elm$parser$Parser$map,
					elm$parser$Parser$Done,
					A2(
						elm$parser$Parser$map,
						function (_n3) {
							if (!step.$) {
								var expr = step.a;
								return expr;
							} else {
								var op = step.a;
								var exprs = step.b;
								return A2(author$project$Parser$Visibility$Ops, op, exprs);
							}
						},
						elm$parser$Parser$succeed(0)))
				]));
	};
	return A2(
		elm$parser$Parser$andThen,
		function (t) {
			return A2(
				elm$parser$Parser$loop,
				author$project$Parser$Visibility$ExprStep0(t),
				loop);
		},
		A2(
			elm$parser$Parser$keeper,
			elm$parser$Parser$succeed(elm$core$Basics$identity),
			A2(
				elm$parser$Parser$ignorer,
				author$project$Parser$Visibility$cyclic$term(),
				elm$parser$Parser$spaces)));
}
function author$project$Parser$Visibility$cyclic$term() {
	return elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				elm$parser$Parser$ignorer,
				A2(
					elm$parser$Parser$ignorer,
					elm$parser$Parser$succeed(
						author$project$Parser$Visibility$Val(true)),
					elm$parser$Parser$keyword('TRUE')),
				elm$parser$Parser$spaces),
				A2(
				elm$parser$Parser$ignorer,
				A2(
					elm$parser$Parser$ignorer,
					elm$parser$Parser$succeed(
						author$project$Parser$Visibility$Val(false)),
					elm$parser$Parser$keyword('FALSE')),
				elm$parser$Parser$spaces),
				elm$parser$Parser$backtrackable(author$project$Parser$Visibility$leaf),
				A2(
				elm$parser$Parser$keeper,
				A2(
					elm$parser$Parser$ignorer,
					A2(
						elm$parser$Parser$ignorer,
						elm$parser$Parser$succeed(elm$core$Basics$identity),
						elm$parser$Parser$symbol('(')),
					elm$parser$Parser$spaces),
				A2(
					elm$parser$Parser$ignorer,
					A2(
						elm$parser$Parser$ignorer,
						A2(
							elm$parser$Parser$ignorer,
							elm$parser$Parser$lazy(
								function (_n0) {
									return author$project$Parser$Visibility$cyclic$expression();
								}),
							elm$parser$Parser$spaces),
						elm$parser$Parser$symbol(')')),
					elm$parser$Parser$spaces))
			]));
}
var author$project$Parser$Visibility$expression = author$project$Parser$Visibility$cyclic$expression();
author$project$Parser$Visibility$cyclic$expression = function () {
	return author$project$Parser$Visibility$expression;
};
var author$project$Parser$Visibility$term = author$project$Parser$Visibility$cyclic$term();
author$project$Parser$Visibility$cyclic$term = function () {
	return author$project$Parser$Visibility$term;
};
var elm$parser$Parser$ExpectingEnd = {$: 10};
var elm$core$String$length = _String_length;
var elm$parser$Parser$Advanced$end = function (x) {
	return function (s) {
		return _Utils_eq(
			elm$core$String$length(s.a),
			s.b) ? A3(elm$parser$Parser$Advanced$Good, false, 0, s) : A2(
			elm$parser$Parser$Advanced$Bad,
			false,
			A2(elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var elm$parser$Parser$end = elm$parser$Parser$Advanced$end(elm$parser$Parser$ExpectingEnd);
var author$project$Parser$Visibility$parser = A2(
	elm$parser$Parser$keeper,
	A2(
		elm$parser$Parser$ignorer,
		elm$parser$Parser$succeed(elm$core$Basics$identity),
		elm$parser$Parser$spaces),
	A2(
		elm$parser$Parser$ignorer,
		A2(elm$parser$Parser$ignorer, author$project$Parser$Visibility$expression, elm$parser$Parser$spaces),
		elm$parser$Parser$end));
var elm$parser$Parser$DeadEnd = F3(
	function (row, col, problem) {
		return {c5: col, dG: problem, dT: row};
	});
var elm$parser$Parser$problemToDeadEnd = function (p) {
	return A3(elm$parser$Parser$DeadEnd, p.dT, p.c5, p.dG);
};
var elm$parser$Parser$Advanced$bagToList = F2(
	function (bag, list) {
		bagToList:
		while (true) {
			switch (bag.$) {
				case 0:
					return list;
				case 1:
					var bag1 = bag.a;
					var x = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2(elm$core$List$cons, x, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
				default:
					var bag1 = bag.a;
					var bag2 = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2(elm$parser$Parser$Advanced$bagToList, bag2, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
			}
		}
	});
var elm$parser$Parser$Advanced$run = F2(
	function (_n0, src) {
		var parse = _n0;
		var _n1 = parse(
			{c5: 1, g: _List_Nil, h: 1, b: 0, dT: 1, a: src});
		if (!_n1.$) {
			var value = _n1.b;
			return elm$core$Result$Ok(value);
		} else {
			var bag = _n1.b;
			return elm$core$Result$Err(
				A2(elm$parser$Parser$Advanced$bagToList, bag, _List_Nil));
		}
	});
var elm$parser$Parser$run = F2(
	function (parser, source) {
		var _n0 = A2(elm$parser$Parser$Advanced$run, parser, source);
		if (!_n0.$) {
			var a = _n0.a;
			return elm$core$Result$Ok(a);
		} else {
			var problems = _n0.a;
			return elm$core$Result$Err(
				A2(elm$core$List$map, elm$parser$Parser$problemToDeadEnd, problems));
		}
	});
var author$project$Parser$Visibility$parse = elm$parser$Parser$run(author$project$Parser$Visibility$parser);
var elm$json$Json$Decode$andThen = _Json_andThen;
var elm$json$Json$Decode$bool = _Json_decodeBool;
var elm$json$Json$Decode$fail = _Json_fail;
var elm$json$Json$Decode$oneOf = _Json_oneOf;
var elm$json$Json$Decode$succeed = _Json_succeed;
var elm$parser$Parser$deadEndsToString = function (deadEnds) {
	return 'TODO deadEndsToString';
};
var author$project$Parser$Visibility$fromJson = function () {
	var decode = function (str) {
		var _n0 = author$project$Parser$Visibility$parse(str);
		if (!_n0.$) {
			var expr = _n0.a;
			return elm$json$Json$Decode$succeed(expr);
		} else {
			var err = _n0.a;
			return elm$json$Json$Decode$fail(
				elm$parser$Parser$deadEndsToString(err));
		}
	};
	return elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(elm$json$Json$Decode$andThen, decode, elm$json$Json$Decode$string),
				A2(elm$json$Json$Decode$map, author$project$Parser$Visibility$Val, elm$json$Json$Decode$bool)
			]));
}();
var elm$json$Json$Decode$field = _Json_decodeField;
var elm$json$Json$Decode$int = _Json_decodeInt;
var elm$json$Json$Decode$list = _Json_decodeList;
var elm$json$Json$Decode$map2 = _Json_map2;
var elm$json$Json$Decode$map3 = _Json_map3;
var author$project$GameData$Achievement$decoder = A3(
	elm$json$Json$Decode$map2,
	F2(
		function (a, b) {
			return elm$core$List$concat(
				_List_fromArray(
					[a, b]));
		}),
	A2(
		elm$json$Json$Decode$field,
		'achievements',
		elm$json$Json$Decode$list(
			A2(
				elm$json$Json$Decode$andThen,
				function (id) {
					return A4(
						elm$json$Json$Decode$map3,
						author$project$GameData$Achievement$Achievement(id),
						A2(elm$json$Json$Decode$field, 'points', elm$json$Json$Decode$int),
						A2(elm$json$Json$Decode$field, 'visible', author$project$Parser$Visibility$fromJson),
						A2(
							elm$json$Json$Decode$field,
							'trigger',
							A2(elm$json$Json$Decode$map, author$project$GameData$Achievement$Expr, author$project$Parser$Visibility$fromJson)));
				},
				A2(elm$json$Json$Decode$field, 'name', author$project$GameData$Achievement$Id$decoder)))),
	A2(
		elm$json$Json$Decode$field,
		'achievements.events',
		elm$json$Json$Decode$list(
			A2(
				elm$json$Json$Decode$andThen,
				function (id) {
					return A4(
						elm$json$Json$Decode$map3,
						author$project$GameData$Achievement$Achievement(id),
						A2(elm$json$Json$Decode$field, 'points', elm$json$Json$Decode$int),
						A2(elm$json$Json$Decode$field, 'visible', author$project$Parser$Visibility$fromJson),
						A2(
							elm$json$Json$Decode$field,
							'event',
							A2(elm$json$Json$Decode$map, author$project$GameData$Achievement$Event, elm$json$Json$Decode$string)));
				},
				A2(elm$json$Json$Decode$field, 'name', author$project$GameData$Achievement$Id$decoder)))));
var author$project$GameData$Cost$FactorCost = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var author$project$GameData$Cost$FixedCost = function (a) {
	return {$: 0, a: a};
};
var author$project$GameData$Cost$costEntry = F3(
	function (unit, currency, count) {
		return _Utils_Tuple2(
			unit,
			_Utils_Tuple2(currency, count));
	});
var author$project$GameData$Unit$Id$Id = elm$core$Basics$identity;
var author$project$GameData$Unit$Id$decoder = A2(elm$json$Json$Decode$map, elm$core$Basics$identity, elm$json$Json$Decode$string);
var author$project$Parser$Stat$Val = function (a) {
	return {$: 1, a: a};
};
var author$project$Parser$Stat$Export = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var author$project$Parser$Stat$Let = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var author$project$Parser$Stat$Var = function (a) {
	return {$: 0, a: a};
};
var author$project$Parser$Stat$Add = 0;
var author$project$Parser$Stat$Div = 3;
var author$project$Parser$Stat$Exp = 4;
var author$project$Parser$Stat$Mul = 2;
var author$project$Parser$Stat$Sub = 1;
var author$project$Parser$Stat$binaryOperator = elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			elm$parser$Parser$ignorer,
			elm$parser$Parser$succeed(0),
			elm$parser$Parser$symbol('+')),
			A2(
			elm$parser$Parser$ignorer,
			elm$parser$Parser$succeed(1),
			elm$parser$Parser$symbol('-')),
			A2(
			elm$parser$Parser$ignorer,
			elm$parser$Parser$succeed(2),
			elm$parser$Parser$symbol('*')),
			A2(
			elm$parser$Parser$ignorer,
			elm$parser$Parser$succeed(3),
			elm$parser$Parser$symbol('/')),
			A2(
			elm$parser$Parser$ignorer,
			elm$parser$Parser$succeed(4),
			elm$parser$Parser$symbol('^'))
		]));
var author$project$Decimal$neg = function (_n0) {
	var a = _n0;
	return _Utils_update(
		a,
		{i: -a.i});
};
var author$project$Parser$Stat$unsignedDecimal = elm$parser$Parser$number(
	{
		ei: elm$core$Maybe$Nothing,
		eH: elm$core$Maybe$Just(author$project$Decimal$fromFloat),
		eJ: elm$core$Maybe$Nothing,
		eS: elm$core$Maybe$Just(author$project$Decimal$fromInt),
		e8: elm$core$Maybe$Nothing
	});
var author$project$Parser$Stat$decimal = elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			elm$parser$Parser$keeper,
			A2(
				elm$parser$Parser$ignorer,
				elm$parser$Parser$succeed(author$project$Decimal$neg),
				elm$parser$Parser$symbol('-')),
			author$project$Parser$Stat$unsignedDecimal),
			author$project$Parser$Stat$unsignedDecimal
		]));
var author$project$Parser$Stat$BinaryOp = F3(
	function (a, b, c) {
		return {$: 5, a: a, b: b, c: c};
	});
var author$project$Parser$Stat$precedence = function (op) {
	switch (op) {
		case 4:
			return 9;
		case 2:
			return 5;
		case 3:
			return 5;
		case 0:
			return 1;
		default:
			return 1;
	}
};
var elm$core$Basics$ge = _Utils_ge;
var author$project$Parser$Stat$finalize = F2(
	function (expr0, ops) {
		finalize:
		while (true) {
			if (!ops.b) {
				return expr0;
			} else {
				if (!ops.b.b) {
					var _n1 = ops.a;
					var op1 = _n1.a;
					var expr1 = _n1.b;
					return A3(author$project$Parser$Stat$BinaryOp, op1, expr0, expr1);
				} else {
					var _n2 = ops.a;
					var op1 = _n2.a;
					var expr1 = _n2.b;
					var tail = ops.b;
					var _n3 = tail.a;
					var op2 = _n3.a;
					if (_Utils_cmp(
						author$project$Parser$Stat$precedence(op1),
						author$project$Parser$Stat$precedence(op2)) > -1) {
						var $temp$expr0 = A3(author$project$Parser$Stat$BinaryOp, op1, expr0, expr1),
							$temp$ops = tail;
						expr0 = $temp$expr0;
						ops = $temp$ops;
						continue finalize;
					} else {
						return A3(
							author$project$Parser$Stat$BinaryOp,
							op1,
							expr0,
							A2(author$project$Parser$Stat$finalize, expr1, tail));
					}
				}
			}
		}
	});
var author$project$Parser$Stat$Function = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var elm$parser$Parser$Problem = function (a) {
	return {$: 12, a: a};
};
var elm$parser$Parser$Advanced$problem = function (x) {
	return function (s) {
		return A2(
			elm$parser$Parser$Advanced$Bad,
			false,
			A2(elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var elm$parser$Parser$problem = function (msg) {
	return elm$parser$Parser$Advanced$problem(
		elm$parser$Parser$Problem(msg));
};
var author$project$Parser$Stat$function = F2(
	function (fn, params) {
		switch (fn) {
			case 0:
				return elm$parser$Parser$succeed(
					A2(author$project$Parser$Stat$Function, fn, params));
			case 1:
				return elm$parser$Parser$succeed(
					A2(author$project$Parser$Stat$Function, fn, params));
			default:
				_n1$2:
				while (true) {
					if (params.b) {
						if (!params.b.b) {
							var val = params.a;
							return elm$parser$Parser$succeed(
								A2(author$project$Parser$Stat$Function, fn, params));
						} else {
							if (!params.b.b.b) {
								var val = params.a;
								var _n2 = params.b;
								var base = _n2.a;
								return elm$parser$Parser$succeed(
									A2(author$project$Parser$Stat$Function, fn, params));
							} else {
								break _n1$2;
							}
						}
					} else {
						break _n1$2;
					}
				}
				return elm$parser$Parser$problem(
					'invalid log() param count: ' + elm$core$String$fromInt(
						elm$core$List$length(params)));
		}
	});
var author$project$Parser$Stat$Log = 2;
var author$project$Parser$Stat$Max = 1;
var author$project$Parser$Stat$Min = 0;
var elm$core$Set$insert = F2(
	function (key, _n0) {
		var dict = _n0;
		return A3(elm$core$Dict$insert, key, 0, dict);
	});
var elm$core$Set$fromList = function (list) {
	return A3(elm$core$List$foldl, elm$core$Set$insert, elm$core$Set$empty, list);
};
var author$project$Parser$Stat$label = elm$parser$Parser$variable(
	{
		eR: function (c) {
			return elm$core$Char$isAlphaNum(c) || (c === '_');
		},
		fr: elm$core$Set$fromList(
			_List_fromArray(
				['let', 'in'])),
		fF: elm$core$Char$isLower
	});
var author$project$Parser$Stat$functionName = A2(
	elm$parser$Parser$andThen,
	function (name) {
		switch (name) {
			case 'min':
				return elm$parser$Parser$succeed(0);
			case 'max':
				return elm$parser$Parser$succeed(1);
			case 'log':
				return elm$parser$Parser$succeed(2);
			default:
				return elm$parser$Parser$problem('no such function: ' + name);
		}
	},
	author$project$Parser$Stat$label);
var elm$parser$Parser$UnexpectedChar = {$: 11};
var elm$parser$Parser$Advanced$chompIf = F2(
	function (isGood, expecting) {
		return function (s) {
			var newOffset = A3(elm$parser$Parser$Advanced$isSubChar, isGood, s.b, s.a);
			return _Utils_eq(newOffset, -1) ? A2(
				elm$parser$Parser$Advanced$Bad,
				false,
				A2(elm$parser$Parser$Advanced$fromState, s, expecting)) : (_Utils_eq(newOffset, -2) ? A3(
				elm$parser$Parser$Advanced$Good,
				true,
				0,
				{c5: 1, g: s.g, h: s.h, b: s.b + 1, dT: s.dT + 1, a: s.a}) : A3(
				elm$parser$Parser$Advanced$Good,
				true,
				0,
				{c5: s.c5 + 1, g: s.g, h: s.h, b: newOffset, dT: s.dT, a: s.a}));
		};
	});
var elm$parser$Parser$chompIf = function (isGood) {
	return A2(elm$parser$Parser$Advanced$chompIf, isGood, elm$parser$Parser$UnexpectedChar);
};
function author$project$Parser$Stat$cyclic$expression() {
	var loop = function (_n6) {
		var head = _n6.a;
		var revOps = _n6.b;
		return A2(
			elm$parser$Parser$keeper,
			A2(
				elm$parser$Parser$ignorer,
				elm$parser$Parser$succeed(elm$core$Basics$identity),
				elm$parser$Parser$spaces),
			elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						A2(
						elm$parser$Parser$keeper,
						A2(
							elm$parser$Parser$keeper,
							elm$parser$Parser$succeed(
								F2(
									function (op, expr) {
										return elm$parser$Parser$Loop(
											_Utils_Tuple2(
												head,
												A2(
													elm$core$List$cons,
													_Utils_Tuple2(op, expr),
													revOps)));
									})),
							A2(elm$parser$Parser$ignorer, author$project$Parser$Stat$binaryOperator, elm$parser$Parser$spaces)),
						author$project$Parser$Stat$cyclic$term()),
						elm$parser$Parser$succeed(
						elm$parser$Parser$Done(
							A2(
								author$project$Parser$Stat$finalize,
								head,
								elm$core$List$reverse(revOps))))
					])));
	};
	return A2(
		elm$parser$Parser$andThen,
		function (t) {
			return A2(
				elm$parser$Parser$loop,
				_Utils_Tuple2(t, _List_Nil),
				loop);
		},
		A2(
			elm$parser$Parser$keeper,
			elm$parser$Parser$succeed(elm$core$Basics$identity),
			author$project$Parser$Stat$cyclic$term()));
}
function author$project$Parser$Stat$cyclic$term() {
	return elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				elm$parser$Parser$keeper,
				A2(
					elm$parser$Parser$keeper,
					A2(
						elm$parser$Parser$ignorer,
						A2(
							elm$parser$Parser$ignorer,
							elm$parser$Parser$succeed(author$project$Parser$Stat$Let),
							elm$parser$Parser$keyword('let')),
						elm$parser$Parser$spaces),
					A2(
						elm$parser$Parser$ignorer,
						A2(
							elm$parser$Parser$ignorer,
							A2(
								elm$parser$Parser$ignorer,
								author$project$Parser$Stat$cyclic$bindings(),
								elm$parser$Parser$spaces),
							elm$parser$Parser$keyword('in')),
						elm$parser$Parser$spaces)),
				elm$parser$Parser$lazy(
					function (_n1) {
						return author$project$Parser$Stat$cyclic$expression();
					})),
				A2(
				elm$parser$Parser$andThen,
				function (_n3) {
					var name = _n3.a;
					var params = _n3.b;
					return A2(author$project$Parser$Stat$function, name, params);
				},
				A2(
					elm$parser$Parser$keeper,
					A2(
						elm$parser$Parser$keeper,
						elm$parser$Parser$succeed(elm$core$Tuple$pair),
						A2(
							elm$parser$Parser$ignorer,
							elm$parser$Parser$backtrackable(author$project$Parser$Stat$functionName),
							elm$parser$Parser$backtrackable(elm$parser$Parser$spaces))),
					elm$parser$Parser$sequence(
						{
							ez: ')',
							eW: elm$parser$Parser$lazy(
								function (_n2) {
									return author$project$Parser$Stat$cyclic$expression();
								}),
							fA: ',',
							fE: elm$parser$Parser$spaces,
							fF: '(',
							fS: 0
						}))),
				A2(
				elm$parser$Parser$keeper,
				A2(
					elm$parser$Parser$keeper,
					elm$parser$Parser$succeed(
						F2(
							function (name, fn) {
								return fn(name);
							})),
					author$project$Parser$Stat$label),
				elm$parser$Parser$oneOf(
					_List_fromArray(
						[
							A2(
							elm$parser$Parser$keeper,
							A2(
								elm$parser$Parser$ignorer,
								A2(
									elm$parser$Parser$ignorer,
									A2(
										elm$parser$Parser$ignorer,
										elm$parser$Parser$succeed(
											F2(
												function (expr, name) {
													return A2(author$project$Parser$Stat$Export, name, expr);
												})),
										elm$parser$Parser$backtrackable(elm$parser$Parser$spaces)),
									elm$parser$Parser$symbol(':')),
								elm$parser$Parser$spaces),
							elm$parser$Parser$lazy(
								function (_n4) {
									return author$project$Parser$Stat$cyclic$expression();
								})),
							elm$parser$Parser$succeed(author$project$Parser$Stat$Var)
						]))),
				A2(
				elm$parser$Parser$keeper,
				elm$parser$Parser$succeed(author$project$Parser$Stat$Val),
				author$project$Parser$Stat$decimal),
				A2(
				elm$parser$Parser$keeper,
				A2(
					elm$parser$Parser$ignorer,
					A2(
						elm$parser$Parser$ignorer,
						elm$parser$Parser$succeed(elm$core$Basics$identity),
						elm$parser$Parser$symbol('(')),
					elm$parser$Parser$spaces),
				A2(
					elm$parser$Parser$ignorer,
					A2(
						elm$parser$Parser$ignorer,
						elm$parser$Parser$lazy(
							function (_n5) {
								return author$project$Parser$Stat$cyclic$expression();
							}),
						elm$parser$Parser$spaces),
					elm$parser$Parser$symbol(')')))
			]));
}
function author$project$Parser$Stat$cyclic$bindings() {
	var loop = function (revBindings) {
		return elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					elm$parser$Parser$keeper,
					elm$parser$Parser$succeed(
						function (b) {
							return elm$parser$Parser$Loop(
								A2(elm$core$List$cons, b, revBindings));
						}),
					A2(
						elm$parser$Parser$ignorer,
						author$project$Parser$Stat$cyclic$binding(),
						elm$parser$Parser$spaces)),
					elm$parser$Parser$succeed(
					elm$parser$Parser$Done(
						elm$core$List$reverse(revBindings)))
				]));
	};
	return A2(
		elm$parser$Parser$andThen,
		function (b) {
			return A2(
				elm$parser$Parser$loop,
				_List_fromArray(
					[b]),
				loop);
		},
		A2(
			elm$parser$Parser$keeper,
			elm$parser$Parser$succeed(elm$core$Basics$identity),
			A2(
				elm$parser$Parser$ignorer,
				author$project$Parser$Stat$cyclic$binding(),
				elm$parser$Parser$spaces)));
}
function author$project$Parser$Stat$cyclic$binding() {
	return A2(
		elm$parser$Parser$keeper,
		A2(
			elm$parser$Parser$keeper,
			elm$parser$Parser$succeed(elm$core$Tuple$pair),
			A2(
				elm$parser$Parser$ignorer,
				A2(
					elm$parser$Parser$ignorer,
					A2(elm$parser$Parser$ignorer, author$project$Parser$Stat$label, elm$parser$Parser$spaces),
					elm$parser$Parser$symbol('=')),
				elm$parser$Parser$spaces)),
		A2(
			elm$parser$Parser$ignorer,
			A2(
				elm$parser$Parser$ignorer,
				elm$parser$Parser$lazy(
					function (_n0) {
						return author$project$Parser$Stat$cyclic$expression();
					}),
				elm$parser$Parser$spaces),
			elm$parser$Parser$chompIf(
				function (c) {
					return c === ';';
				})));
}
var author$project$Parser$Stat$expression = author$project$Parser$Stat$cyclic$expression();
author$project$Parser$Stat$cyclic$expression = function () {
	return author$project$Parser$Stat$expression;
};
var author$project$Parser$Stat$term = author$project$Parser$Stat$cyclic$term();
author$project$Parser$Stat$cyclic$term = function () {
	return author$project$Parser$Stat$term;
};
var author$project$Parser$Stat$bindings = author$project$Parser$Stat$cyclic$bindings();
author$project$Parser$Stat$cyclic$bindings = function () {
	return author$project$Parser$Stat$bindings;
};
var author$project$Parser$Stat$binding = author$project$Parser$Stat$cyclic$binding();
author$project$Parser$Stat$cyclic$binding = function () {
	return author$project$Parser$Stat$binding;
};
var author$project$Parser$Stat$parser = A2(
	elm$parser$Parser$keeper,
	A2(
		elm$parser$Parser$ignorer,
		elm$parser$Parser$succeed(elm$core$Basics$identity),
		elm$parser$Parser$spaces),
	A2(
		elm$parser$Parser$ignorer,
		A2(elm$parser$Parser$ignorer, author$project$Parser$Stat$expression, elm$parser$Parser$spaces),
		elm$parser$Parser$end));
var author$project$Parser$Stat$parse = elm$parser$Parser$run(author$project$Parser$Stat$parser);
var elm$json$Json$Decode$float = _Json_decodeFloat;
var author$project$Parser$Stat$fromJson = function () {
	var decode = function (str) {
		var _n0 = author$project$Parser$Stat$parse(str);
		if (!_n0.$) {
			var expr = _n0.a;
			return elm$json$Json$Decode$succeed(expr);
		} else {
			var err = _n0.a;
			return elm$json$Json$Decode$fail(
				elm$parser$Parser$deadEndsToString(err));
		}
	};
	return elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(elm$json$Json$Decode$andThen, decode, elm$json$Json$Decode$string),
				A2(
				elm$json$Json$Decode$map,
				A2(elm$core$Basics$composeR, author$project$Decimal$fromFloat, author$project$Parser$Stat$Val),
				elm$json$Json$Decode$float)
			]));
}();
var author$project$GameData$Cost$decoder = A2(
	elm$json$Json$Decode$map,
	A2(
		elm$core$Basics$composeR,
		elm_community$dict_extra$Dict$Extra$groupBy(elm$core$Tuple$first),
		elm$core$Dict$map(
			function (_n0) {
				return elm$core$List$map(elm$core$Tuple$second);
			})),
	A3(
		elm$json$Json$Decode$map2,
		elm$core$Basics$append,
		A2(
			elm$json$Json$Decode$field,
			'costs.fixed',
			elm$json$Json$Decode$list(
				A4(
					elm$json$Json$Decode$map3,
					author$project$GameData$Cost$costEntry,
					A2(elm$json$Json$Decode$field, 'name', elm$json$Json$Decode$string),
					A2(elm$json$Json$Decode$field, 'currency', author$project$GameData$Unit$Id$decoder),
					A2(
						elm$json$Json$Decode$field,
						'val',
						A2(elm$json$Json$Decode$map, author$project$GameData$Cost$FixedCost, author$project$Parser$Stat$fromJson))))),
		A2(
			elm$json$Json$Decode$field,
			'costs.factor',
			elm$json$Json$Decode$list(
				A4(
					elm$json$Json$Decode$map3,
					author$project$GameData$Cost$costEntry,
					A2(elm$json$Json$Decode$field, 'name', elm$json$Json$Decode$string),
					A2(elm$json$Json$Decode$field, 'currency', author$project$GameData$Unit$Id$decoder),
					A3(
						elm$json$Json$Decode$map2,
						F2(
							function (init, factor) {
								return (factor === 1) ? author$project$GameData$Cost$FixedCost(init) : A2(author$project$GameData$Cost$FactorCost, init, factor);
							}),
						A2(elm$json$Json$Decode$field, 'init', author$project$Parser$Stat$fromJson),
						A2(elm$json$Json$Decode$field, 'factor', elm$json$Json$Decode$float)))))));
var author$project$GameData$Mtx$Mtx = F6(
	function (id, priceUsdPaypal, count, paypalUrl, priceKreds, bulkBonus) {
		return {ek: bulkBonus, et: count, eL: id, fe: paypalUrl, fj: priceKreds, fk: priceUsdPaypal};
	});
var author$project$GameData$Mtx$PaypalUrls = F3(
	function (sandbox, elmBeta, prod) {
		return {ey: elmBeta, fl: prod, fx: sandbox};
	});
var author$project$GameData$Mtx$Id$Id = elm$core$Basics$identity;
var author$project$GameData$Mtx$Id$decoder = A2(elm$json$Json$Decode$map, elm$core$Basics$identity, elm$json$Json$Decode$string);
var elm$json$Json$Decode$map6 = _Json_map6;
var author$project$GameData$Mtx$decoder = A7(
	elm$json$Json$Decode$map6,
	author$project$GameData$Mtx$Mtx,
	A2(elm$json$Json$Decode$field, 'name', author$project$GameData$Mtx$Id$decoder),
	A2(elm$json$Json$Decode$field, 'price_usd_paypal', elm$json$Json$Decode$int),
	A2(elm$json$Json$Decode$field, 'pack.val', elm$json$Json$Decode$int),
	A4(
		elm$json$Json$Decode$map3,
		author$project$GameData$Mtx$PaypalUrls,
		A2(elm$json$Json$Decode$field, 'paypalSandboxUrl', elm$json$Json$Decode$string),
		A2(elm$json$Json$Decode$field, 'paypalElmSwarmsimDotComUrl', elm$json$Json$Decode$string),
		A2(elm$json$Json$Decode$field, 'paypalSwarmsimDotComUrl', elm$json$Json$Decode$string)),
	A2(elm$json$Json$Decode$field, 'price_kreds', elm$json$Json$Decode$int),
	A2(elm$json$Json$Decode$field, 'bulkbonus', elm$json$Json$Decode$float));
var author$project$Duration$Duration = elm$core$Basics$identity;
var author$project$Duration$fromMillis = elm$core$Basics$identity;
var author$project$Duration$units = {bf: ((1000 * 60) * 60) * 24, bl: (1000 * 60) * 60, aX: 1000 * 60, aE: 1000, bK: (((1000 * 60) * 60) * 24) * 365};
var author$project$Duration$fromSecs = A2(
	elm$core$Basics$composeR,
	elm$core$Basics$mul(author$project$Duration$units.aE),
	A2(elm$core$Basics$composeR, elm$core$Basics$floor, author$project$Duration$fromMillis));
var author$project$GameData$OnBuy$AddRandomUnits = function (a) {
	return {$: 3, a: a};
};
var author$project$GameData$OnBuy$AddRandomUnitsData = F4(
	function (child, minimum, chance, count) {
		return {eo: chance, eq: child, et: count, e1: minimum};
	});
var author$project$GameData$OnBuy$AddTime = function (a) {
	return {$: 2, a: a};
};
var author$project$GameData$OnBuy$Ascend = {$: 6};
var author$project$GameData$OnBuy$Cooldown = F2(
	function (group, val) {
		return {dn: group, d6: val};
	});
var author$project$GameData$OnBuy$MulUnits = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var author$project$GameData$OnBuy$Respec = F3(
	function (a, b, c) {
		return {$: 5, a: a, b: b, c: c};
	});
var author$project$GameData$OnBuy$AddUnits = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var author$project$GameData$OnBuy$AddUnitsCooldown = F3(
	function (a, b, c) {
		return {$: 4, a: a, b: b, c: c};
	});
var author$project$GameData$OnBuy$addUnits = F3(
	function (child, expr, cooldown) {
		if (cooldown.$ === 1) {
			return A2(author$project$GameData$OnBuy$AddUnits, child, expr);
		} else {
			var cd = cooldown.a;
			return A3(author$project$GameData$OnBuy$AddUnitsCooldown, child, expr, cd);
		}
	});
var elm$core$Basics$composeL = F3(
	function (g, f, x) {
		return g(
			f(x));
	});
var elm$json$Json$Decode$map4 = _Json_map4;
var elm$json$Json$Decode$maybe = function (decoder) {
	return elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(elm$json$Json$Decode$map, elm$core$Maybe$Just, decoder),
				elm$json$Json$Decode$succeed(elm$core$Maybe$Nothing)
			]));
};
var author$project$GameData$OnBuy$decoder = A2(
	elm$json$Json$Decode$map,
	A2(
		elm$core$Basics$composeR,
		elm_community$dict_extra$Dict$Extra$groupBy(elm$core$Tuple$first),
		elm$core$Dict$map(
			function (_n0) {
				return elm$core$List$map(elm$core$Tuple$second);
			})),
	A7(
		elm$json$Json$Decode$map6,
		F6(
			function (a, b, c, d, e, f) {
				return elm$core$List$concat(
					_List_fromArray(
						[a, b, c, d, e, f]));
			}),
		A2(
			elm$json$Json$Decode$field,
			'onBuy.addUnits',
			elm$json$Json$Decode$list(
				A3(
					elm$json$Json$Decode$map2,
					elm$core$Tuple$pair,
					A2(elm$json$Json$Decode$field, 'parent', elm$json$Json$Decode$string),
					A4(
						elm$json$Json$Decode$map3,
						author$project$GameData$OnBuy$addUnits,
						A2(elm$json$Json$Decode$field, 'child', author$project$GameData$Unit$Id$decoder),
						A2(elm$json$Json$Decode$field, 'val', author$project$Parser$Stat$fromJson),
						elm$json$Json$Decode$maybe(
							A3(
								elm$json$Json$Decode$map2,
								author$project$GameData$OnBuy$Cooldown,
								A2(elm$json$Json$Decode$field, 'cooldown.group', elm$json$Json$Decode$string),
								A2(
									elm$json$Json$Decode$field,
									'cooldown.sec',
									A2(elm$json$Json$Decode$map, author$project$Duration$fromSecs, elm$json$Json$Decode$float)))))))),
		A2(
			elm$json$Json$Decode$field,
			'onBuy.mulUnits',
			elm$json$Json$Decode$list(
				A3(
					elm$json$Json$Decode$map2,
					elm$core$Tuple$pair,
					A2(elm$json$Json$Decode$field, 'parent', elm$json$Json$Decode$string),
					A3(
						elm$json$Json$Decode$map2,
						author$project$GameData$OnBuy$MulUnits,
						A2(elm$json$Json$Decode$field, 'child', author$project$GameData$Unit$Id$decoder),
						A2(elm$json$Json$Decode$field, 'count', author$project$Parser$Stat$fromJson))))),
		A2(
			elm$json$Json$Decode$field,
			'onBuy.addTime',
			elm$json$Json$Decode$list(
				A3(
					elm$json$Json$Decode$map2,
					elm$core$Tuple$pair,
					A2(elm$json$Json$Decode$field, 'parent', elm$json$Json$Decode$string),
					A2(
						elm$json$Json$Decode$field,
						'secs',
						A2(elm$json$Json$Decode$map, author$project$GameData$OnBuy$AddTime, author$project$Parser$Stat$fromJson))))),
		A2(
			elm$json$Json$Decode$field,
			'onBuy.addRandomUnits',
			elm$json$Json$Decode$list(
				A3(
					elm$json$Json$Decode$map2,
					elm$core$Tuple$pair,
					A2(elm$json$Json$Decode$field, 'parent', elm$json$Json$Decode$string),
					A2(
						elm$json$Json$Decode$map,
						author$project$GameData$OnBuy$AddRandomUnits,
						A5(
							elm$json$Json$Decode$map4,
							author$project$GameData$OnBuy$AddRandomUnitsData,
							A2(elm$json$Json$Decode$field, 'child', author$project$GameData$Unit$Id$decoder),
							A2(elm$json$Json$Decode$field, 'minimum', elm$json$Json$Decode$int),
							A2(elm$json$Json$Decode$field, 'chance', author$project$Parser$Stat$fromJson),
							A2(elm$json$Json$Decode$field, 'count', author$project$Parser$Stat$fromJson)))))),
		A2(
			elm$json$Json$Decode$field,
			'onBuy.ascend',
			elm$json$Json$Decode$list(
				A2(
					elm$json$Json$Decode$map,
					function (p) {
						return _Utils_Tuple2(p, author$project$GameData$OnBuy$Ascend);
					},
					A2(elm$json$Json$Decode$field, 'parent', elm$json$Json$Decode$string)))),
		A2(
			elm$json$Json$Decode$field,
			'onBuy.respec',
			elm$json$Json$Decode$list(
				A3(
					elm$json$Json$Decode$map2,
					elm$core$Tuple$pair,
					A2(elm$json$Json$Decode$field, 'parent', elm$json$Json$Decode$string),
					A4(
						elm$json$Json$Decode$map3,
						author$project$GameData$OnBuy$Respec,
						A2(elm$json$Json$Decode$field, 'currency', author$project$GameData$Unit$Id$decoder),
						A2(elm$json$Json$Decode$field, 'rate', elm$json$Json$Decode$float),
						A2(
							elm$json$Json$Decode$field,
							'resetItems',
							A2(
								elm$json$Json$Decode$map,
								A2(
									elm$core$Basics$composeL,
									elm$core$Set$fromList,
									elm$core$String$split(',')),
								elm$json$Json$Decode$string))))))));
var author$project$GameData$OnBuy$Index = function (all) {
	return function (addUnits) {
		return function (mulUnits) {
			return function (addTime) {
				return function (addRandomUnits) {
					return function (addUnitsCooldown) {
						return function (respec) {
							return function (ascend) {
								return function (addUnitsByChild) {
									return function (mulUnitsByChild) {
										return function (addUnitsCooldownByChild) {
											return {bM: addRandomUnits, ea: addTime, bN: addUnits, bO: addUnitsByChild, bP: addUnitsCooldown, bQ: addUnitsCooldownByChild, ec: all, cX: ascend, ci: mulUnits, cj: mulUnitsByChild, dR: respec};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var author$project$GameData$OnBuy$indexEmpty = author$project$GameData$OnBuy$Index(_List_Nil)(_List_Nil)(_List_Nil)(_List_Nil)(_List_Nil)(_List_Nil)(_List_Nil)(false)(elm$core$Dict$empty)(elm$core$Dict$empty)(elm$core$Dict$empty);
var author$project$GameData$OnBuy$indexFromList = function (list) {
	var indexPush = F2(
		function (onBuy, index) {
			switch (onBuy.$) {
				case 0:
					var unitId = onBuy.a;
					var expr = onBuy.b;
					return _Utils_update(
						index,
						{
							bN: A2(
								elm$core$List$cons,
								_Utils_Tuple2(unitId, expr),
								index.bN),
							bO: A3(
								elm$core$Dict$insert,
								author$project$GameData$Unit$Id$toString(unitId),
								expr,
								index.bO)
						});
				case 1:
					var unitId = onBuy.a;
					var expr = onBuy.b;
					return _Utils_update(
						index,
						{
							ci: A2(
								elm$core$List$cons,
								_Utils_Tuple2(unitId, expr),
								index.ci),
							cj: A3(
								elm$core$Dict$insert,
								author$project$GameData$Unit$Id$toString(unitId),
								expr,
								index.cj)
						});
				case 2:
					var expr = onBuy.a;
					return _Utils_update(
						index,
						{
							ea: A2(elm$core$List$cons, expr, index.ea)
						});
				case 3:
					var data = onBuy.a;
					return _Utils_update(
						index,
						{
							bM: A2(elm$core$List$cons, data, index.bM)
						});
				case 4:
					var unitId = onBuy.a;
					var expr = onBuy.b;
					var cooldown = onBuy.c;
					return _Utils_update(
						index,
						{
							bP: A2(
								elm$core$List$cons,
								_Utils_Tuple3(unitId, expr, cooldown),
								index.bP),
							bQ: A3(
								elm$core$Dict$insert,
								author$project$GameData$Unit$Id$toString(unitId),
								_Utils_Tuple2(expr, cooldown),
								index.bQ)
						});
				case 5:
					var unitId = onBuy.a;
					var rate = onBuy.b;
					var resetItems = onBuy.c;
					return _Utils_update(
						index,
						{
							dR: A2(
								elm$core$List$cons,
								_Utils_Tuple3(unitId, rate, resetItems),
								index.dR)
						});
				default:
					return _Utils_update(
						index,
						{cX: true});
			}
		});
	return A3(
		elm$core$List$foldr,
		indexPush,
		_Utils_update(
			author$project$GameData$OnBuy$indexEmpty,
			{ec: list}),
		list);
};
var author$project$GameData$Spell$Spell = F6(
	function (id, cost, onBuy, slug, tab, visible) {
		return {es: cost, eL: id, e9: onBuy, cA: slug, fM: tab, f$: visible};
	});
var author$project$GameData$Spell$Id$Id = elm$core$Basics$identity;
var author$project$GameData$Spell$Id$decoder = A2(elm$json$Json$Decode$map, elm$core$Basics$identity, elm$json$Json$Decode$string);
var author$project$GameData$Tab$Id$Id = elm$core$Basics$identity;
var author$project$GameData$Tab$Id$decoder = A2(elm$json$Json$Decode$map, elm$core$Basics$identity, elm$json$Json$Decode$string);
var author$project$GameData$Spell$decoder = F2(
	function (cost, onBuy) {
		var builder = function (id) {
			return A4(
				elm$json$Json$Decode$map3,
				A3(
					author$project$GameData$Spell$Spell,
					id,
					cost(
						author$project$GameData$Spell$idToString(id)),
					author$project$GameData$OnBuy$indexFromList(
						onBuy(
							author$project$GameData$Spell$idToString(id)))),
				A2(elm$json$Json$Decode$field, 'slug', elm$json$Json$Decode$string),
				A2(elm$json$Json$Decode$field, 'tab', author$project$GameData$Tab$Id$decoder),
				A2(elm$json$Json$Decode$field, 'visible', author$project$Parser$Visibility$fromJson));
		};
		return A2(
			elm$json$Json$Decode$andThen,
			builder,
			A2(elm$json$Json$Decode$field, 'name', author$project$GameData$Spell$Id$decoder));
	});
var author$project$GameData$Tab$Tab = F4(
	function (id, unitId, secondaryUnitId, showAchievements) {
		return {eL: id, fy: secondaryUnitId, fB: showAchievements, d3: unitId};
	});
var author$project$GameData$Tab$decoder = function () {
	var builder = F3(
		function (id, unitId, secondaryUnitId) {
			return A2(
				elm$json$Json$Decode$map,
				A3(author$project$GameData$Tab$Tab, id, unitId, secondaryUnitId),
				A2(elm$json$Json$Decode$field, 'achievements', elm$json$Json$Decode$bool));
		});
	return A2(
		elm$json$Json$Decode$andThen,
		elm$core$Basics$identity,
		A4(
			elm$json$Json$Decode$map3,
			builder,
			A2(elm$json$Json$Decode$field, 'name', author$project$GameData$Tab$Id$decoder),
			A2(elm$json$Json$Decode$field, 'name', author$project$GameData$Unit$Id$decoder),
			elm$json$Json$Decode$maybe(
				A2(elm$json$Json$Decode$field, 'secondaryUnit', author$project$GameData$Unit$Id$decoder))));
}();
var NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom = elm$json$Json$Decode$map2(elm$core$Basics$apR);
var elm$json$Json$Decode$decodeValue = _Json_run;
var elm$json$Json$Decode$null = _Json_decodeNull;
var elm$json$Json$Decode$value = _Json_decodeValue;
var NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder = F3(
	function (pathDecoder, valDecoder, fallback) {
		var nullOr = function (decoder) {
			return elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						decoder,
						elm$json$Json$Decode$null(fallback)
					]));
		};
		var handleResult = function (input) {
			var _n0 = A2(elm$json$Json$Decode$decodeValue, pathDecoder, input);
			if (!_n0.$) {
				var rawValue = _n0.a;
				var _n1 = A2(
					elm$json$Json$Decode$decodeValue,
					nullOr(valDecoder),
					rawValue);
				if (!_n1.$) {
					var finalResult = _n1.a;
					return elm$json$Json$Decode$succeed(finalResult);
				} else {
					var finalErr = _n1.a;
					return elm$json$Json$Decode$fail(
						elm$json$Json$Decode$errorToString(finalErr));
				}
			} else {
				return elm$json$Json$Decode$succeed(fallback);
			}
		};
		return A2(elm$json$Json$Decode$andThen, handleResult, elm$json$Json$Decode$value);
	});
var NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional = F4(
	function (key, valDecoder, fallback, decoder) {
		return A2(
			NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A3(
				NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder,
				A2(elm$json$Json$Decode$field, key, elm$json$Json$Decode$value),
				valDecoder,
				fallback),
			decoder);
	});
var NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required = F3(
	function (key, valDecoder, decoder) {
		return A2(
			NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2(elm$json$Json$Decode$field, key, valDecoder),
			decoder);
	});
var author$project$GameData$Unit$Unit = function (id) {
	return function (cost) {
		return function (onBuy) {
			return function (slug) {
				return function (tab) {
					return function (init) {
						return function (ascendPreserve) {
							return function (tier) {
								return function (prod) {
									return function (warnfirst) {
										return function (visible) {
											return function (watchable) {
												return function (twins) {
													return function (minCount) {
														return function (maxCount) {
															return function (ordinal) {
																return {ef: ascendPreserve, es: cost, eL: id, eQ: init, eZ: maxCount, e$: minCount, e9: onBuy, bs: ordinal, fl: prod, cA: slug, fM: tab, fR: tier, fV: twins, f$: visible, f0: warnfirst, f1: watchable};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var author$project$GameData$Util$boolFromJson = function () {
	var decode = function (str) {
		var _n0 = elm$core$String$toLower(str);
		switch (_n0) {
			case 'false':
				return false;
			case '0':
				return false;
			case '':
				return false;
			default:
				return true;
		}
	};
	return A2(elm$json$Json$Decode$map, decode, elm$json$Json$Decode$string);
}();
var author$project$GameData$Util$decimalFromJson = A2(elm$json$Json$Decode$map, author$project$Decimal$fromFloat, elm$json$Json$Decode$float);
var author$project$GameData$Unit$decoder = F2(
	function (cost, onBuy) {
		var builder = function (id) {
			return A4(
				NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'maxCount',
				A2(elm$json$Json$Decode$map, elm$core$Maybe$Just, author$project$Parser$Stat$fromJson),
				elm$core$Maybe$Nothing,
				A4(
					NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'minCount',
					A2(elm$json$Json$Decode$map, elm$core$Maybe$Just, author$project$Parser$Stat$fromJson),
					elm$core$Maybe$Nothing,
					A4(
						NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'twins',
						A2(elm$json$Json$Decode$map, elm$core$Maybe$Just, author$project$Parser$Stat$fromJson),
						elm$core$Maybe$Nothing,
						A4(
							NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'watchable',
							elm$json$Json$Decode$bool,
							false,
							A3(
								NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'visible',
								author$project$Parser$Visibility$fromJson,
								A2(
									NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
									elm$json$Json$Decode$maybe(
										A3(
											elm$json$Json$Decode$map2,
											elm$core$Tuple$pair,
											A2(elm$json$Json$Decode$field, 'warnfirst.unittype', author$project$GameData$Unit$Id$decoder),
											A2(elm$json$Json$Decode$field, 'warnfirst.val', elm$json$Json$Decode$int))),
									A2(
										NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
										elm$json$Json$Decode$oneOf(
											_List_fromArray(
												[
													A2(
													elm$json$Json$Decode$map,
													elm$core$Maybe$Just,
													A3(
														NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'prod.expr',
														author$project$Parser$Stat$fromJson,
														A3(
															NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'prod.unittype',
															author$project$GameData$Unit$Id$decoder,
															elm$json$Json$Decode$succeed(elm$core$Tuple$pair)))),
													elm$json$Json$Decode$succeed(elm$core$Maybe$Nothing)
												])),
										A4(
											NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'tier',
											elm$json$Json$Decode$maybe(elm$json$Json$Decode$int),
											elm$core$Maybe$Nothing,
											A4(
												NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
												'ascendPreserve',
												author$project$GameData$Util$boolFromJson,
												false,
												A4(
													NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
													'init',
													elm$json$Json$Decode$maybe(author$project$GameData$Util$decimalFromJson),
													elm$core$Maybe$Nothing,
													A3(
														NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'tab',
														author$project$GameData$Tab$Id$decoder,
														A3(
															NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'slug',
															elm$json$Json$Decode$string,
															elm$json$Json$Decode$succeed(
																A3(
																	author$project$GameData$Unit$Unit,
																	id,
																	cost(
																		author$project$GameData$Unit$idToString(id)),
																	author$project$GameData$OnBuy$indexFromList(
																		onBuy(
																			author$project$GameData$Unit$idToString(id)))))))))))))))));
		};
		return A2(
			elm$json$Json$Decode$andThen,
			builder,
			A2(elm$json$Json$Decode$field, 'name', author$project$GameData$Unit$Id$decoder));
	});
var author$project$GameData$Upgrade$Upgrade = F9(
	function (id, cost, onBuy, unitId, unit, visible, buyGroup, maxLevel, isBulkBuyable) {
		return {el: buyGroup, es: cost, eL: id, eU: isBulkBuyable, e_: maxLevel, e9: onBuy, fX: unit, d3: unitId, f$: visible};
	});
var author$project$GameData$Upgrade$Id$Id = elm$core$Basics$identity;
var author$project$GameData$Upgrade$Id$decoder = A2(elm$json$Json$Decode$map, elm$core$Basics$identity, elm$json$Json$Decode$string);
var author$project$Parser$Visibility$and = author$project$Parser$Visibility$Ops(0);
var author$project$GameData$Upgrade$decoder = F3(
	function (cost, onBuy, unitFromId) {
		var builder = F2(
			function (id, unitId) {
				var _n0 = unitFromId(
					author$project$GameData$Unit$Id$toString(unitId));
				if (_n0.$ === 1) {
					return elm$json$Json$Decode$fail(
						'no such unitid for upgrade: ' + author$project$GameData$Unit$Id$toString(unitId));
				} else {
					var unit = _n0.a;
					return A5(
						elm$json$Json$Decode$map4,
						A5(
							author$project$GameData$Upgrade$Upgrade,
							id,
							cost(
								author$project$GameData$Upgrade$idToString(id)),
							author$project$GameData$OnBuy$indexFromList(
								onBuy(
									author$project$GameData$Upgrade$idToString(id))),
							unitId,
							unit),
						A2(
							elm$json$Json$Decode$field,
							'visible',
							A2(
								elm$json$Json$Decode$map,
								function (v) {
									return author$project$Parser$Visibility$and(
										_List_fromArray(
											[unit.f$, v]));
								},
								author$project$Parser$Visibility$fromJson)),
						A2(elm$json$Json$Decode$field, 'buyGroup', elm$json$Json$Decode$string),
						elm$json$Json$Decode$maybe(
							A2(elm$json$Json$Decode$field, 'maxLevel', author$project$GameData$Util$decimalFromJson)),
						A2(elm$json$Json$Decode$field, 'isBulkBuyable', elm$json$Json$Decode$bool));
				}
			});
		return A2(
			elm$json$Json$Decode$andThen,
			elm$core$Basics$identity,
			A3(
				elm$json$Json$Decode$map2,
				builder,
				A2(elm$json$Json$Decode$field, 'name', author$project$GameData$Upgrade$Id$decoder),
				A2(elm$json$Json$Decode$field, 'unit', author$project$GameData$Unit$Id$decoder)));
	});
var author$project$GameData$decoder = function () {
	var decode2 = F3(
		function (cost, onBuy, units_) {
			var unitsByName = A2(elm_community$dict_extra$Dict$Extra$fromListBy, author$project$GameData$Unit$name, units_);
			return A2(
				elm$json$Json$Decode$map,
				function (l) {
					return A2(
						author$project$GameData$GameData,
						l,
						author$project$GameData$createIndexes(l));
				},
				A7(
					elm$json$Json$Decode$map6,
					author$project$GameData$Lists,
					A2(
						elm$json$Json$Decode$field,
						'tabs',
						elm$json$Json$Decode$list(author$project$GameData$Tab$decoder)),
					elm$json$Json$Decode$succeed(units_),
					A2(
						elm$json$Json$Decode$field,
						'upgrades',
						elm$json$Json$Decode$list(
							A3(
								author$project$GameData$Upgrade$decoder,
								cost,
								onBuy,
								function (id) {
									return A2(elm$core$Dict$get, id, unitsByName);
								}))),
					A2(
						elm$json$Json$Decode$field,
						'spells',
						elm$json$Json$Decode$list(
							A2(author$project$GameData$Spell$decoder, cost, onBuy))),
					author$project$GameData$Achievement$decoder,
					A2(
						elm$json$Json$Decode$field,
						'mtx',
						elm$json$Json$Decode$list(author$project$GameData$Mtx$decoder))));
		});
	var decode1 = F2(
		function (costs, onBuys) {
			var onBuy = function (id) {
				return A2(
					elm$core$Maybe$withDefault,
					_List_Nil,
					A2(elm$core$Dict$get, id, onBuys));
			};
			var cost = function (id) {
				return A2(
					elm$core$Maybe$withDefault,
					_List_Nil,
					A2(elm$core$Dict$get, id, costs));
			};
			return A2(
				elm$json$Json$Decode$andThen,
				A2(decode2, cost, onBuy),
				A2(
					elm$json$Json$Decode$field,
					'units',
					A2(
						elm$json$Json$Decode$map,
						elm$core$List$indexedMap(
							F2(
								function (i, u) {
									return u(i);
								})),
						elm$json$Json$Decode$list(
							A2(author$project$GameData$Unit$decoder, cost, onBuy)))));
		});
	var decode0 = A2(
		elm$json$Json$Decode$andThen,
		elm$core$Basics$identity,
		A3(elm$json$Json$Decode$map2, decode1, author$project$GameData$Cost$decoder, author$project$GameData$OnBuy$decoder));
	return decode0;
}();
var author$project$GameData$Lang$LangSet = F2(
	function (raw_en_us, en_us) {
		return {dd: en_us, fo: raw_en_us};
	});
var author$project$JsonUtil$decodeResult = function (res) {
	if (!res.$) {
		var val = res.a;
		return elm$json$Json$Decode$succeed(val);
	} else {
		var err = res.a;
		return elm$json$Json$Decode$fail(err);
	}
};
var author$project$MessageFormat$Message = elm$core$Basics$identity;
var author$project$MessageFormat$Plural = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var author$project$MessageFormat$Select = F3(
	function (a, b, c) {
		return {$: 3, a: a, b: b, c: c};
	});
var author$project$MessageFormat$Var = function (a) {
	return {$: 1, a: a};
};
var author$project$MessageFormat$Text = function (a) {
	return {$: 0, a: a};
};
var elm$core$Basics$neq = _Utils_notEqual;
var elm$parser$Parser$chompWhile = elm$parser$Parser$Advanced$chompWhile;
var elm$parser$Parser$Advanced$mapChompedString = F2(
	function (func, _n0) {
		var parse = _n0;
		return function (s0) {
			var _n1 = parse(s0);
			if (_n1.$ === 1) {
				var p = _n1.a;
				var x = _n1.b;
				return A2(elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p = _n1.a;
				var a = _n1.b;
				var s1 = _n1.c;
				return A3(
					elm$parser$Parser$Advanced$Good,
					p,
					A2(
						func,
						A3(elm$core$String$slice, s0.b, s1.b, s0.a),
						a),
					s1);
			}
		};
	});
var elm$parser$Parser$Advanced$getChompedString = function (parser) {
	return A2(elm$parser$Parser$Advanced$mapChompedString, elm$core$Basics$always, parser);
};
var elm$parser$Parser$getChompedString = elm$parser$Parser$Advanced$getChompedString;
var author$project$MessageFormat$quotedText = function () {
	var loop = function (strings) {
		return elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					elm$parser$Parser$keeper,
					elm$parser$Parser$succeed(
						function (_n0) {
							return elm$parser$Parser$Loop(
								A2(elm$core$List$cons, '\'', strings));
						}),
					elm$parser$Parser$symbol('\'\'')),
					A2(
					elm$parser$Parser$keeper,
					elm$parser$Parser$succeed(
						function (str) {
							return elm$parser$Parser$Loop(
								A2(elm$core$List$cons, str, strings));
						}),
					elm$parser$Parser$getChompedString(
						A2(
							elm$parser$Parser$ignorer,
							A2(
								elm$parser$Parser$ignorer,
								elm$parser$Parser$succeed(0),
								elm$parser$Parser$chompIf(
									function (c) {
										return c !== '\'';
									})),
							elm$parser$Parser$chompWhile(
								function (c) {
									return c !== '\'';
								})))),
					A2(
					elm$parser$Parser$keeper,
					elm$parser$Parser$succeed(
						function (_n1) {
							return elm$parser$Parser$Done(
								function (s) {
									return (s === '') ? '\'' : s;
								}(
									A2(
										elm$core$String$join,
										'',
										elm$core$List$reverse(strings))));
						}),
					elm$parser$Parser$symbol('\''))
				]));
	};
	return A2(
		elm$parser$Parser$keeper,
		A2(
			elm$parser$Parser$ignorer,
			elm$parser$Parser$succeed(author$project$MessageFormat$Text),
			elm$parser$Parser$symbol('\'')),
		A2(elm$parser$Parser$loop, _List_Nil, loop));
}();
var author$project$MessageFormat$unquotedText = function () {
	var pred = function (c) {
		return (c !== '\'') && ((c !== '{') && ((c !== '}') && (c !== '#')));
	};
	return A2(
		elm$parser$Parser$map,
		author$project$MessageFormat$Text,
		elm$parser$Parser$getChompedString(
			A2(
				elm$parser$Parser$ignorer,
				A2(
					elm$parser$Parser$ignorer,
					elm$parser$Parser$succeed(0),
					elm$parser$Parser$chompIf(pred)),
				elm$parser$Parser$chompWhile(pred))));
}();
var elm$core$Dict$fromList = function (assocs) {
	return A3(
		elm$core$List$foldl,
		F2(
			function (_n0, dict) {
				var key = _n0.a;
				var value = _n0.b;
				return A3(elm$core$Dict$insert, key, value, dict);
			}),
		elm$core$Dict$empty,
		assocs);
};
var elm$core$Tuple$mapFirst = F2(
	function (func, _n0) {
		var x = _n0.a;
		var y = _n0.b;
		return _Utils_Tuple2(
			func(x),
			y);
	});
var elm$parser$Parser$Advanced$int = F2(
	function (expecting, invalid) {
		return elm$parser$Parser$Advanced$number(
			{
				ei: elm$core$Result$Err(invalid),
				dg: expecting,
				eH: elm$core$Result$Err(invalid),
				eJ: elm$core$Result$Err(invalid),
				eS: elm$core$Result$Ok(elm$core$Basics$identity),
				eT: invalid,
				e8: elm$core$Result$Err(invalid)
			});
	});
var elm$parser$Parser$int = A2(elm$parser$Parser$Advanced$int, elm$parser$Parser$ExpectingInt, elm$parser$Parser$ExpectingInt);
var author$project$MessageFormat$argument = function (isTopLevel) {
	return elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				elm$parser$Parser$ignorer,
				isTopLevel ? elm$parser$Parser$problem('invalid outer `#`') : elm$parser$Parser$succeed(
					author$project$MessageFormat$Var('#')),
				elm$parser$Parser$symbol('#')),
				A2(
				elm$parser$Parser$keeper,
				A2(
					elm$parser$Parser$keeper,
					A2(
						elm$parser$Parser$ignorer,
						A2(
							elm$parser$Parser$ignorer,
							elm$parser$Parser$succeed(
								F2(
									function (_var, tokenFn) {
										return tokenFn(_var);
									})),
							elm$parser$Parser$symbol('{')),
						elm$parser$Parser$spaces),
					A2(
						elm$parser$Parser$ignorer,
						elm$parser$Parser$variable(
							{
								eR: function (c) {
									return elm$core$Char$isAlphaNum(c) || ((c === '_') || (c === '.'));
								},
								fr: elm$core$Set$fromList(
									_List_fromArray(
										['plural', 'select', 'offset'])),
								fF: elm$core$Char$isAlpha
							}),
						elm$parser$Parser$spaces)),
				elm$parser$Parser$oneOf(
					_List_fromArray(
						[
							A2(
							elm$parser$Parser$ignorer,
							elm$parser$Parser$succeed(author$project$MessageFormat$Var),
							elm$parser$Parser$symbol('}')),
							A2(
							elm$parser$Parser$keeper,
							A2(
								elm$parser$Parser$ignorer,
								A2(
									elm$parser$Parser$ignorer,
									elm$parser$Parser$succeed(elm$core$Basics$identity),
									elm$parser$Parser$symbol(',')),
								elm$parser$Parser$spaces),
							elm$parser$Parser$oneOf(
								_List_fromArray(
									[
										A2(
										elm$parser$Parser$keeper,
										A2(
											elm$parser$Parser$ignorer,
											A2(
												elm$parser$Parser$ignorer,
												A2(
													elm$parser$Parser$ignorer,
													A2(
														elm$parser$Parser$ignorer,
														elm$parser$Parser$succeed(
															F2(
																function (_n7, key) {
																	var cases = _n7.a;
																	var other = _n7.b;
																	return A3(
																		author$project$MessageFormat$Plural,
																		key,
																		elm$core$Dict$fromList(
																			A2(
																				elm$core$List$map,
																				elm$core$Tuple$mapFirst(elm$core$String$fromInt),
																				cases)),
																		other);
																})),
														elm$parser$Parser$keyword('plural')),
													elm$parser$Parser$spaces),
												elm$parser$Parser$symbol(',')),
											elm$parser$Parser$spaces),
										A2(
											elm$parser$Parser$ignorer,
											A2(
												elm$parser$Parser$ignorer,
												author$project$MessageFormat$cyclic$pluralCases(),
												elm$parser$Parser$spaces),
											elm$parser$Parser$symbol('}'))),
										A2(
										elm$parser$Parser$keeper,
										A2(
											elm$parser$Parser$ignorer,
											A2(
												elm$parser$Parser$ignorer,
												A2(
													elm$parser$Parser$ignorer,
													A2(
														elm$parser$Parser$ignorer,
														elm$parser$Parser$succeed(
															F2(
																function (_n8, key) {
																	var cases = _n8.a;
																	var other = _n8.b;
																	return A3(
																		author$project$MessageFormat$Select,
																		key,
																		elm$core$Dict$fromList(cases),
																		other);
																})),
														elm$parser$Parser$keyword('select')),
													elm$parser$Parser$spaces),
												elm$parser$Parser$symbol(',')),
											elm$parser$Parser$spaces),
										A2(
											elm$parser$Parser$ignorer,
											A2(
												elm$parser$Parser$ignorer,
												author$project$MessageFormat$cyclic$selectCases(),
												elm$parser$Parser$spaces),
											elm$parser$Parser$symbol('}')))
									])))
						])))
			]));
};
var author$project$MessageFormat$message = function (isTopLevel) {
	var push = F2(
		function (tokens, token) {
			return elm$parser$Parser$Loop(
				A2(elm$core$List$cons, token, tokens));
		});
	var loop = function (tokens) {
		return elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					elm$parser$Parser$keeper,
					elm$parser$Parser$succeed(
						push(tokens)),
					author$project$MessageFormat$argument(isTopLevel)),
					A2(
					elm$parser$Parser$keeper,
					elm$parser$Parser$succeed(
						push(tokens)),
					author$project$MessageFormat$quotedText),
					A2(
					elm$parser$Parser$keeper,
					elm$parser$Parser$succeed(
						push(tokens)),
					author$project$MessageFormat$unquotedText),
					elm$parser$Parser$succeed(
					elm$parser$Parser$Done(
						elm$core$List$reverse(tokens)))
				]));
	};
	return A2(elm$parser$Parser$loop, _List_Nil, loop);
};
function author$project$MessageFormat$cyclic$pluralCase() {
	return elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				elm$parser$Parser$keeper,
				A2(
					elm$parser$Parser$ignorer,
					A2(
						elm$parser$Parser$ignorer,
						A2(
							elm$parser$Parser$ignorer,
							elm$parser$Parser$succeed(
								elm$core$Tuple$pair(0)),
							elm$parser$Parser$keyword('zero')),
						elm$parser$Parser$spaces),
					elm$parser$Parser$symbol('{')),
				A2(
					elm$parser$Parser$ignorer,
					elm$parser$Parser$lazy(
						function (_n3) {
							return author$project$MessageFormat$message(false);
						}),
					elm$parser$Parser$symbol('}'))),
				A2(
				elm$parser$Parser$keeper,
				A2(
					elm$parser$Parser$ignorer,
					A2(
						elm$parser$Parser$ignorer,
						A2(
							elm$parser$Parser$ignorer,
							elm$parser$Parser$succeed(
								elm$core$Tuple$pair(1)),
							elm$parser$Parser$keyword('one')),
						elm$parser$Parser$spaces),
					elm$parser$Parser$symbol('{')),
				A2(
					elm$parser$Parser$ignorer,
					elm$parser$Parser$lazy(
						function (_n4) {
							return author$project$MessageFormat$message(false);
						}),
					elm$parser$Parser$symbol('}'))),
				A2(
				elm$parser$Parser$keeper,
				A2(
					elm$parser$Parser$ignorer,
					A2(
						elm$parser$Parser$ignorer,
						A2(
							elm$parser$Parser$ignorer,
							elm$parser$Parser$succeed(
								elm$core$Tuple$pair(2)),
							elm$parser$Parser$keyword('two')),
						elm$parser$Parser$spaces),
					elm$parser$Parser$symbol('{')),
				A2(
					elm$parser$Parser$ignorer,
					elm$parser$Parser$lazy(
						function (_n5) {
							return author$project$MessageFormat$message(false);
						}),
					elm$parser$Parser$symbol('}'))),
				A2(
				elm$parser$Parser$keeper,
				A2(
					elm$parser$Parser$keeper,
					A2(
						elm$parser$Parser$ignorer,
						elm$parser$Parser$succeed(elm$core$Tuple$pair),
						elm$parser$Parser$symbol('=')),
					A2(
						elm$parser$Parser$ignorer,
						A2(elm$parser$Parser$ignorer, elm$parser$Parser$int, elm$parser$Parser$spaces),
						elm$parser$Parser$symbol('{'))),
				A2(
					elm$parser$Parser$ignorer,
					elm$parser$Parser$lazy(
						function (_n6) {
							return author$project$MessageFormat$message(false);
						}),
					elm$parser$Parser$symbol('}')))
			]));
}
function author$project$MessageFormat$cyclic$pluralCases() {
	var loop = function (cases) {
		return elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					elm$parser$Parser$keeper,
					elm$parser$Parser$succeed(
						function (c) {
							return elm$parser$Parser$Loop(
								A2(elm$core$List$cons, c, cases));
						}),
					A2(
						elm$parser$Parser$ignorer,
						author$project$MessageFormat$cyclic$pluralCase(),
						elm$parser$Parser$spaces)),
					A2(
					elm$parser$Parser$keeper,
					A2(
						elm$parser$Parser$ignorer,
						A2(
							elm$parser$Parser$ignorer,
							A2(
								elm$parser$Parser$ignorer,
								elm$parser$Parser$succeed(
									function (other) {
										return elm$parser$Parser$Done(
											_Utils_Tuple2(
												elm$core$List$reverse(cases),
												other));
									}),
								elm$parser$Parser$keyword('other')),
							elm$parser$Parser$spaces),
						elm$parser$Parser$symbol('{')),
					A2(
						elm$parser$Parser$ignorer,
						elm$parser$Parser$lazy(
							function (_n2) {
								return author$project$MessageFormat$message(false);
							}),
						elm$parser$Parser$symbol('}')))
				]));
	};
	return A2(elm$parser$Parser$loop, _List_Nil, loop);
}
function author$project$MessageFormat$cyclic$selectCases() {
	var loop = function (cases) {
		return elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					elm$parser$Parser$keeper,
					A2(
						elm$parser$Parser$ignorer,
						A2(
							elm$parser$Parser$ignorer,
							A2(
								elm$parser$Parser$ignorer,
								elm$parser$Parser$succeed(
									function (other) {
										return elm$parser$Parser$Done(
											_Utils_Tuple2(
												elm$core$List$reverse(cases),
												other));
									}),
								elm$parser$Parser$keyword('other')),
							elm$parser$Parser$spaces),
						elm$parser$Parser$symbol('{')),
					A2(
						elm$parser$Parser$ignorer,
						A2(
							elm$parser$Parser$ignorer,
							elm$parser$Parser$lazy(
								function (_n0) {
									return author$project$MessageFormat$message(false);
								}),
							elm$parser$Parser$symbol('}')),
						elm$parser$Parser$spaces)),
					A2(
					elm$parser$Parser$keeper,
					A2(
						elm$parser$Parser$keeper,
						elm$parser$Parser$succeed(
							F2(
								function (key, msg) {
									return elm$parser$Parser$Loop(
										A2(
											elm$core$List$cons,
											_Utils_Tuple2(key, msg),
											cases));
								})),
						A2(
							elm$parser$Parser$ignorer,
							A2(
								elm$parser$Parser$ignorer,
								elm$parser$Parser$variable(
									{
										eR: function (c) {
											return elm$core$Char$isAlphaNum(c) || ((c === '_') || (c === '.'));
										},
										fr: elm$core$Set$fromList(
											_List_fromArray(
												['other'])),
										fF: elm$core$Char$isAlphaNum
									}),
								elm$parser$Parser$spaces),
							elm$parser$Parser$symbol('{'))),
					A2(
						elm$parser$Parser$ignorer,
						A2(
							elm$parser$Parser$ignorer,
							elm$parser$Parser$lazy(
								function (_n1) {
									return author$project$MessageFormat$message(false);
								}),
							elm$parser$Parser$symbol('}')),
						elm$parser$Parser$spaces))
				]));
	};
	return A2(elm$parser$Parser$loop, _List_Nil, loop);
}
var author$project$MessageFormat$pluralCase = author$project$MessageFormat$cyclic$pluralCase();
author$project$MessageFormat$cyclic$pluralCase = function () {
	return author$project$MessageFormat$pluralCase;
};
var author$project$MessageFormat$pluralCases = author$project$MessageFormat$cyclic$pluralCases();
author$project$MessageFormat$cyclic$pluralCases = function () {
	return author$project$MessageFormat$pluralCases;
};
var author$project$MessageFormat$selectCases = author$project$MessageFormat$cyclic$selectCases();
author$project$MessageFormat$cyclic$selectCases = function () {
	return author$project$MessageFormat$selectCases;
};
var elm$core$Result$mapError = F2(
	function (f, result) {
		if (!result.$) {
			var v = result.a;
			return elm$core$Result$Ok(v);
		} else {
			var e = result.a;
			return elm$core$Result$Err(
				f(e));
		}
	});
var author$project$MessageFormat$parse = function (msg) {
	return A2(
		elm$core$Result$mapError,
		elm$parser$Parser$deadEndsToString,
		A2(
			elm$parser$Parser$run,
			A2(
				elm$parser$Parser$ignorer,
				author$project$MessageFormat$message(true),
				elm$parser$Parser$end),
			msg));
};
var author$project$GameData$Lang$messageDecoder = A2(
	elm$json$Json$Decode$andThen,
	A2(elm$core$Basics$composeR, author$project$MessageFormat$parse, author$project$JsonUtil$decodeResult),
	elm$json$Json$Decode$string);
var elm$json$Json$Decode$keyValuePairs = _Json_decodeKeyValuePairs;
var author$project$GameData$Lang$entryDecoder = A2(
	elm$json$Json$Decode$map,
	elm$core$Dict$fromList,
	elm$json$Json$Decode$keyValuePairs(
		A2(elm$json$Json$Decode$field, 'message', author$project$GameData$Lang$messageDecoder)));
var author$project$GameData$Lang$rawDecoder = elm$json$Json$Decode$keyValuePairs(
	elm$json$Json$Decode$keyValuePairs(elm$json$Json$Decode$string));
var author$project$GameData$Lang$decoder = A3(
	elm$json$Json$Decode$map2,
	author$project$GameData$Lang$LangSet,
	A2(elm$json$Json$Decode$field, 'en_us', author$project$GameData$Lang$rawDecoder),
	A2(elm$json$Json$Decode$field, 'en_us', author$project$GameData$Lang$entryDecoder));
var author$project$GameData$Lang$translatorDecoder = A3(elm$json$Json$Decode$map2, elm$core$Tuple$pair, author$project$GameData$Lang$entryDecoder, elm$json$Json$Decode$value);
var author$project$Main$GotInitialTime = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var author$project$Main$NotFound = function (a) {
	return {$: 0, a: a};
};
var author$project$GameData$lists = function (_n0) {
	var ls = _n0.a;
	return ls;
};
var elm$core$List$head = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return elm$core$Maybe$Just(x);
	} else {
		return elm$core$Maybe$Nothing;
	}
};
var author$project$GameData$homeTab = A2(
	elm$core$Basics$composeR,
	author$project$GameData$lists,
	A2(
		elm$core$Basics$composeR,
		function ($) {
			return $.bD;
		},
		elm$core$List$head));
var author$project$Main$Achievements = function (a) {
	return {$: 6, a: a};
};
var author$project$Main$Changelog = function (a) {
	return {$: 9, a: a};
};
var author$project$Main$Debug = function (a) {
	return {$: 1, a: a};
};
var author$project$Main$GotMtxHistoryMsg = function (a) {
	return {$: 38, a: a};
};
var author$project$Main$GotMtxShopMsg = function (a) {
	return {$: 32, a: a};
};
var author$project$Main$GotPaypalDoneMsg = function (a) {
	return {$: 42, a: a};
};
var author$project$Main$GotSpellMsg = function (a) {
	return {$: 31, a: a};
};
var author$project$Main$GotTabMsg = function (a) {
	return {$: 29, a: a};
};
var author$project$Main$GotTranslatorMsg = function (a) {
	return {$: 44, a: a};
};
var author$project$Main$GotUnitMsg = function (a) {
	return {$: 30, a: a};
};
var author$project$Main$Login = function (a) {
	return {$: 12, a: a};
};
var author$project$Main$MoreMenu = function (a) {
	return {$: 16, a: a};
};
var author$project$Main$MtxHistory = function (a) {
	return {$: 11, a: a};
};
var author$project$Main$MtxShop = function (a) {
	return {$: 2, a: a};
};
var author$project$Main$Options = function (a) {
	return {$: 7, a: a};
};
var author$project$Main$PaypalDone = function (a) {
	return {$: 15, a: a};
};
var author$project$Main$Register = function (a) {
	return {$: 13, a: a};
};
var author$project$Main$ResetPassword = function (a) {
	return {$: 14, a: a};
};
var author$project$Main$Spell = function (a) {
	return {$: 5, a: a};
};
var author$project$Main$Statistics = function (a) {
	return {$: 8, a: a};
};
var author$project$Main$Tab = function (a) {
	return {$: 3, a: a};
};
var author$project$Main$Translator = function (a) {
	return {$: 17, a: a};
};
var author$project$Main$Unit = function (a) {
	return {$: 4, a: a};
};
var author$project$Main$User = function (a) {
	return {$: 10, a: a};
};
var author$project$Page$Debug$unwrap = function (_n0) {
	var m = _n0;
	return m;
};
var author$project$Page$Debug$toSession = A2(
	elm$core$Basics$composeR,
	author$project$Page$Debug$unwrap,
	function ($) {
		return $.f;
	});
var author$project$Page$Login$toSession = function (_n0) {
	var m = _n0;
	return m.f;
};
var author$project$Page$MtxHistory$toSession = function (_n0) {
	var s = _n0.b;
	return s;
};
var author$project$Page$MtxShop$toSession = function (_n0) {
	var s = _n0.d;
	return s;
};
var author$project$Page$Options$toSession = function (_n0) {
	var m = _n0;
	return m.f;
};
var author$project$Page$PaypalDone$toSession = function (_n0) {
	var session = _n0.a;
	return session;
};
var author$project$Page$Register$toSession = function (_n0) {
	var m = _n0;
	return m.f;
};
var author$project$Page$ResetPassword$toSession = function (_n0) {
	var m = _n0;
	return m.f;
};
var author$project$Page$Spell$toSession = function (_n0) {
	var s = _n0.c;
	return s;
};
var author$project$Page$Tab$toSession = function (_n0) {
	var s = _n0.b;
	return s;
};
var author$project$Page$Translator$toSession = function (_n0) {
	var session = _n0.a;
	return session;
};
var author$project$Page$Unit$toSession = function (_n0) {
	var s = _n0.d;
	return s;
};
var author$project$Main$toSession = function (model) {
	switch (model.$) {
		case 0:
			var s = model.a;
			return s;
		case 1:
			var m = model.a;
			return author$project$Page$Debug$toSession(m);
		case 3:
			var m = model.a;
			return author$project$Page$Tab$toSession(m);
		case 4:
			var m = model.a;
			return author$project$Page$Unit$toSession(m);
		case 5:
			var m = model.a;
			return author$project$Page$Spell$toSession(m);
		case 2:
			var m = model.a;
			return author$project$Page$MtxShop$toSession(m);
		case 6:
			var s = model.a;
			return s;
		case 7:
			var m = model.a;
			return author$project$Page$Options$toSession(m);
		case 8:
			var s = model.a;
			return s;
		case 9:
			var s = model.a;
			return s;
		case 10:
			var s = model.a;
			return s;
		case 11:
			var m = model.a;
			return author$project$Page$MtxHistory$toSession(m);
		case 12:
			var m = model.a;
			return author$project$Page$Login$toSession(m);
		case 13:
			var m = model.a;
			return author$project$Page$Register$toSession(m);
		case 14:
			var m = model.a;
			return author$project$Page$ResetPassword$toSession(m);
		case 15:
			var m = model.a;
			return author$project$Page$PaypalDone$toSession(m);
		case 16:
			var s = model.a;
			return s;
		default:
			var m = model.a;
			return author$project$Page$Translator$toSession(m);
	}
};
var author$project$Game$Game = elm$core$Basics$identity;
var author$project$Duration$zero = 0;
var author$project$Duration$add = F2(
	function (_n0, _n1) {
		var a = _n0;
		var b = _n1;
		return a + b;
	});
var author$project$Game$unwrap = function (_n0) {
	var g = _n0;
	return g;
};
var author$project$Game$achievementPoints = A2(
	elm$core$Basics$composeR,
	author$project$Game$unwrap,
	function ($) {
		return $.aO;
	});
var author$project$Game$UnitsSnapshot$unwrap = function (_n0) {
	var s = _n0;
	return s;
};
var author$project$Game$UnitsSnapshot$toDict = A2(
	elm$core$Basics$composeR,
	author$project$Game$UnitsSnapshot$unwrap,
	function ($) {
		return $.aa;
	});
var elm_community$maybe_extra$Maybe$Extra$orElse = F2(
	function (ma, mb) {
		if (mb.$ === 1) {
			return ma;
		} else {
			return mb;
		}
	});
var author$project$Game$getVarDicts = F3(
	function (game, units_, name) {
		var g = game;
		return A2(
			elm_community$maybe_extra$Maybe$Extra$orElse,
			A2(elm$core$Dict$get, name, g.s),
			A2(
				elm_community$maybe_extra$Maybe$Extra$orElse,
				A2(elm$core$Dict$get, name, g.o),
				A2(
					elm$core$Dict$get,
					name,
					author$project$Game$UnitsSnapshot$toDict(units_))));
	});
var author$project$Decimal$mul = F2(
	function (_n0, _n1) {
		var a = _n0;
		var b = _n1;
		return A2(author$project$Decimal$fromSigExp, a.i * b.i, a.j + b.j);
	});
var author$project$Decimal$sigOfExp = F2(
	function (_n0, targetExp) {
		var sig = _n0.i;
		var exp = _n0.j;
		return A2(author$project$Decimal$sigTimesExp, sig, targetExp - exp);
	});
var author$project$Decimal$add = F2(
	function (da, db) {
		var a = da;
		var b = db;
		var exp = A2(elm$core$Basics$max, a.j, b.j);
		return A2(
			author$project$Decimal$fromSigExp,
			A2(author$project$Decimal$sigOfExp, da, exp) + A2(author$project$Decimal$sigOfExp, db, exp),
			exp);
	});
var author$project$Decimal$zero = author$project$Decimal$fromFloat(0);
var author$project$Decimal$sum = A2(elm$core$List$foldl, author$project$Decimal$add, author$project$Decimal$zero);
var author$project$Game$gameData = A2(
	elm$core$Basics$composeR,
	author$project$Game$unwrap,
	function ($) {
		return $.D;
	});
var author$project$Game$isResetOnAscend = function (item) {
	if (!item.$) {
		var u = item.a;
		return !u.ef;
	} else {
		return true;
	}
};
var author$project$Game$spellCount = function (id) {
	return A2(
		elm$core$Basics$composeR,
		author$project$Game$unwrap,
		A2(
			elm$core$Basics$composeR,
			function ($) {
				return $.s;
			},
			A2(
				elm$core$Basics$composeR,
				elm$core$Dict$get(
					author$project$GameData$Spell$idToString(id)),
				elm$core$Maybe$withDefault(author$project$Decimal$zero))));
};
var author$project$Game$units = A2(
	elm$core$Basics$composeR,
	author$project$Game$unwrap,
	function ($) {
		return $.k;
	});
var author$project$Game$UnitsSnapshot$countName = function (name) {
	return A2(
		elm$core$Basics$composeR,
		author$project$Game$UnitsSnapshot$toDict,
		A2(
			elm$core$Basics$composeR,
			elm$core$Dict$get(name),
			elm$core$Maybe$withDefault(author$project$Decimal$zero)));
};
var author$project$Game$UnitsSnapshot$count = function (id) {
	return author$project$Game$UnitsSnapshot$countName(
		author$project$GameData$Unit$idToString(id));
};
var author$project$Game$unitCount = function (id) {
	return A2(
		elm$core$Basics$composeR,
		author$project$Game$units,
		author$project$Game$UnitsSnapshot$count(id));
};
var author$project$Game$upgradeCountName = function (name) {
	return A2(
		elm$core$Basics$composeR,
		author$project$Game$unwrap,
		A2(
			elm$core$Basics$composeR,
			function ($) {
				return $.o;
			},
			A2(
				elm$core$Basics$composeR,
				elm$core$Dict$get(name),
				elm$core$Maybe$withDefault(author$project$Decimal$zero))));
};
var author$project$Game$upgradeCount = function (id) {
	return author$project$Game$upgradeCountName(
		author$project$GameData$Upgrade$idToString(id));
};
var author$project$Game$itemCount = function (id) {
	switch (id.$) {
		case 0:
			var i = id.a;
			return author$project$Game$unitCount(i);
		case 1:
			var i = id.a;
			return author$project$Game$upgradeCount(i);
		default:
			var i = id.a;
			return author$project$Game$spellCount(i);
	}
};
var author$project$GameData$indexes = function (_n0) {
	var is = _n0.b;
	return is;
};
var author$project$GameData$itemsByCost = function (id) {
	return A2(
		elm$core$Basics$composeR,
		author$project$GameData$indexes,
		A2(
			elm$core$Basics$composeR,
			function ($) {
				return $.b3;
			},
			A2(
				elm$core$Basics$composeR,
				elm$core$Dict$get(
					author$project$GameData$Unit$idToString(id)),
				elm$core$Maybe$withDefault(_List_Nil))));
};
var author$project$GameData$unitByName = function (name) {
	return A2(
		elm$core$Basics$composeR,
		author$project$GameData$indexes,
		A2(
			elm$core$Basics$composeR,
			function ($) {
				return $.cL;
			},
			elm$core$Dict$get(name)));
};
var author$project$Parser$Stat$EvalContext = F2(
	function (exports, out) {
		return {dh: exports, fd: out};
	});
var author$project$Decimal$div = F2(
	function (_n0, _n1) {
		var a = _n0;
		var b = _n1;
		return A2(author$project$Decimal$fromSigExp, a.i / b.i, a.j - b.j);
	});
var elm$core$Basics$e = _Basics_e;
var author$project$Decimal$ln10 = A2(elm$core$Basics$logBase, elm$core$Basics$e, 10);
var author$project$Decimal$log10 = function (_n0) {
	var sig = _n0.i;
	var exp = _n0.j;
	return A2(elm$core$Basics$logBase, 10, sig) + exp;
};
var author$project$Decimal$logBase = F2(
	function (base_, val) {
		return (author$project$Decimal$log10(val) * author$project$Decimal$ln10) / A2(elm$core$Basics$logBase, elm$core$Basics$e, base_);
	});
var author$project$Decimal$sub = F2(
	function (a, b) {
		return A2(
			author$project$Decimal$add,
			a,
			author$project$Decimal$neg(b));
	});
var author$project$Decimal$compare = F2(
	function (a, b) {
		var _n0 = A2(author$project$Decimal$sub, a, b);
		var sig = _n0.i;
		return (!sig) ? 1 : ((sig > 0) ? 2 : 0);
	});
var author$project$Decimal$gt = F2(
	function (a, b) {
		return A2(author$project$Decimal$compare, a, b) === 2;
	});
var author$project$Decimal$max = F2(
	function (a, b) {
		return A2(author$project$Decimal$gt, a, b) ? a : b;
	});
var author$project$Decimal$maximum = function (ds) {
	if (!ds.b) {
		return elm$core$Maybe$Nothing;
	} else {
		var head = ds.a;
		var tail = ds.b;
		return elm$core$Maybe$Just(
			A3(elm$core$List$foldl, author$project$Decimal$max, head, tail));
	}
};
var author$project$Decimal$lt = F2(
	function (a, b) {
		return !A2(author$project$Decimal$compare, a, b);
	});
var author$project$Decimal$min = F2(
	function (a, b) {
		return A2(author$project$Decimal$lt, a, b) ? a : b;
	});
var author$project$Decimal$minimum = function (ds) {
	if (!ds.b) {
		return elm$core$Maybe$Nothing;
	} else {
		var head = ds.a;
		var tail = ds.b;
		return elm$core$Maybe$Just(
			A3(elm$core$List$foldl, author$project$Decimal$min, head, tail));
	}
};
var author$project$Decimal$one = author$project$Decimal$fromFloat(1);
var elm$core$Basics$modBy = _Basics_modBy;
var author$project$Decimal$powBySquaring = function () {
	var loop = F3(
		function (y, x, n) {
			loop:
			while (true) {
				if (!n) {
					return y;
				} else {
					if (n === 1) {
						return A2(author$project$Decimal$mul, x, y);
					} else {
						if (!A2(elm$core$Basics$modBy, 2, n)) {
							var $temp$y = y,
								$temp$x = A2(author$project$Decimal$mul, x, x),
								$temp$n = (n / 2) | 0;
							y = $temp$y;
							x = $temp$x;
							n = $temp$n;
							continue loop;
						} else {
							var $temp$y = A2(author$project$Decimal$mul, x, y),
								$temp$x = A2(author$project$Decimal$mul, x, x),
								$temp$n = (n / 2) | 0;
							y = $temp$y;
							x = $temp$x;
							n = $temp$n;
							continue loop;
						}
					}
				}
			}
		});
	return loop(author$project$Decimal$one);
}();
var elm$core$Basics$truncate = _Basics_truncate;
var author$project$Decimal$powSmallFloat = F2(
	function (_n0, toExp) {
		var sig = _n0.i;
		var exp = _n0.j;
		var expMul = exp * toExp;
		var newExp = expMul | 0;
		var residue = expMul - newExp;
		var newSig = (!residue) ? A2(elm$core$Basics$pow, sig, toExp) : A2(
			elm$core$Basics$pow,
			10,
			(toExp * A2(elm$core$Basics$logBase, 10, sig)) + residue);
		return A2(author$project$Decimal$fromSigExp, newSig, newExp);
	});
var author$project$Decimal$reciprocal = function (_n0) {
	var sig = _n0.i;
	var exp = _n0.j;
	return A2(author$project$Decimal$fromSigExp, 1 / sig, -exp);
};
var author$project$Decimal$powFloat = F2(
	function (d, toExp) {
		var intExp = toExp | 0;
		var root = toExp - intExp;
		return ((!root) ? elm$core$Basics$identity : author$project$Decimal$mul(
			A2(author$project$Decimal$powSmallFloat, d, root)))(
			((toExp < 0) ? author$project$Decimal$reciprocal : elm$core$Basics$identity)(
				A2(
					author$project$Decimal$powBySquaring,
					d,
					elm$core$Basics$abs(intExp))));
	});
var author$project$Decimal$toFloat = function (_n0) {
	var sig = _n0.i;
	var exp = _n0.j;
	return sig * A2(elm$core$Basics$pow, author$project$Decimal$baseFloat, exp);
};
var author$project$Parser$Stat$EvalInternal = F3(
	function (error, exports, out) {
		return {eA: error, dh: exports, fd: out};
	});
var elm$core$Dict$foldl = F3(
	function (func, acc, dict) {
		foldl:
		while (true) {
			if (dict.$ === -2) {
				return acc;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3(elm$core$Dict$foldl, func, acc, left)),
					$temp$dict = right;
				func = $temp$func;
				acc = $temp$acc;
				dict = $temp$dict;
				continue foldl;
			}
		}
	});
var elm$core$Dict$union = F2(
	function (t1, t2) {
		return A3(elm$core$Dict$foldl, elm$core$Dict$insert, t2, t1);
	});
var elm_community$maybe_extra$Maybe$Extra$or = F2(
	function (ma, mb) {
		if (ma.$ === 1) {
			return mb;
		} else {
			return ma;
		}
	});
var author$project$Parser$Stat$evalInternal = F2(
	function (defaultVar, getVar) {
		var loop = F4(
			function (err0, exports0, env0, rule) {
				loop:
				while (true) {
					switch (rule.$) {
						case 1:
							var val = rule.a;
							return A3(author$project$Parser$Stat$EvalInternal, err0, exports0, val);
						case 0:
							var _var = rule.a;
							var _n1 = A2(
								elm_community$maybe_extra$Maybe$Extra$orElse,
								A2(elm$core$Dict$get, _var, env0),
								getVar(_var));
							if (!_n1.$) {
								var val = _n1.a;
								return A3(author$project$Parser$Stat$EvalInternal, err0, exports0, val);
							} else {
								return A3(
									author$project$Parser$Stat$EvalInternal,
									elm$core$Maybe$Just('no such var: ' + _var),
									exports0,
									defaultVar);
							}
						case 2:
							var binds = rule.a;
							var body = rule.b;
							var fold = F2(
								function (_n3, _n4) {
									var name = _n3.a;
									var expr = _n3.b;
									var error1 = _n4.a;
									var exports1 = _n4.b;
									var env1 = _n4.c;
									var ctx2 = A4(loop, error1, exports1, env1, expr);
									return _Utils_Tuple3(
										ctx2.eA,
										ctx2.dh,
										A3(elm$core$Dict$insert, name, ctx2.fd, env1));
								});
							var _n2 = A3(
								elm$core$List$foldl,
								fold,
								_Utils_Tuple3(err0, exports0, env0),
								binds);
							var err = _n2.a;
							var exports = _n2.b;
							var env = _n2.c;
							var $temp$err0 = err,
								$temp$exports0 = exports,
								$temp$env0 = env,
								$temp$rule = body;
							err0 = $temp$err0;
							exports0 = $temp$exports0;
							env0 = $temp$env0;
							rule = $temp$rule;
							continue loop;
						case 3:
							var name = rule.a;
							var body0 = rule.b;
							var ctx = A4(loop, err0, exports0, env0, body0);
							return _Utils_update(
								ctx,
								{
									dh: A3(elm$core$Dict$insert, name, ctx.fd, ctx.dh)
								});
						case 4:
							var fnEnum = rule.a;
							var params0 = rule.b;
							var fold = F2(
								function (expr, _n10) {
									var err1 = _n10.a;
									var exports1 = _n10.b;
									var revParams1 = _n10.c;
									var ctx = A4(loop, err1, exports1, env0, expr);
									return _Utils_Tuple3(
										ctx.eA,
										ctx.dh,
										A2(elm$core$List$cons, ctx.fd, revParams1));
								});
							var fn = function () {
								switch (fnEnum) {
									case 0:
										return A2(
											elm$core$Basics$composeR,
											author$project$Decimal$minimum,
											elm$core$Result$fromMaybe('cannot apply fn to empty list'));
									case 1:
										return A2(
											elm$core$Basics$composeR,
											author$project$Decimal$maximum,
											elm$core$Result$fromMaybe('cannot apply fn to empty list'));
									default:
										return function (params) {
											_n8$2:
											while (true) {
												if (params.b) {
													if (!params.b.b) {
														var val = params.a;
														return elm$core$Result$Ok(
															author$project$Decimal$fromFloat(
																A2(author$project$Decimal$logBase, 10, val)));
													} else {
														if (!params.b.b.b) {
															var val = params.a;
															var _n9 = params.b;
															var base = _n9.a;
															return elm$core$Result$Ok(
																author$project$Decimal$fromFloat(
																	A2(
																		author$project$Decimal$logBase,
																		author$project$Decimal$toFloat(base),
																		val)));
														} else {
															break _n8$2;
														}
													}
												} else {
													break _n8$2;
												}
											}
											return elm$core$Result$Err(
												'invalid log arg count (but the parser should have caught this - bug!) ' + elm$core$String$fromInt(
													elm$core$List$length(params)));
										};
								}
							}();
							var _n5 = A3(
								elm$core$List$foldl,
								fold,
								_Utils_Tuple3(err0, exports0, _List_Nil),
								params0);
							var err = _n5.a;
							var exports = _n5.b;
							var revParams = _n5.c;
							var _n6 = fn(
								elm$core$List$reverse(revParams));
							if (!_n6.$) {
								var out = _n6.a;
								return A3(author$project$Parser$Stat$EvalInternal, err, exports, out);
							} else {
								var err_ = _n6.a;
								return A3(
									author$project$Parser$Stat$EvalInternal,
									elm$core$Maybe$Just(
										A2(elm$core$Maybe$withDefault, err_, err)),
									exports,
									defaultVar);
							}
						default:
							var op = rule.a;
							var left = rule.b;
							var right = rule.c;
							var opFn = function () {
								switch (op) {
									case 0:
										return author$project$Decimal$add;
									case 1:
										return author$project$Decimal$sub;
									case 2:
										return author$project$Decimal$mul;
									case 3:
										return author$project$Decimal$div;
									default:
										return F2(
											function (base, exp) {
												return A2(
													author$project$Decimal$powFloat,
													base,
													author$project$Decimal$toFloat(exp));
											});
								}
							}();
							var ctx2 = A4(loop, err0, exports0, env0, right);
							var ctx1 = A4(loop, err0, exports0, env0, left);
							return A3(
								author$project$Parser$Stat$EvalInternal,
								A2(elm_community$maybe_extra$Maybe$Extra$or, ctx1.eA, ctx2.eA),
								A2(elm$core$Dict$union, ctx1.dh, ctx2.dh),
								A2(opFn, ctx1.fd, ctx2.fd));
					}
				}
			});
		return A3(loop, elm$core$Maybe$Nothing, elm$core$Dict$empty, elm$core$Dict$empty);
	});
var author$project$Parser$Stat$evalFullWithDefault = F3(
	function (defaultVar, getVar, expr) {
		var ctx = A3(author$project$Parser$Stat$evalInternal, defaultVar, getVar, expr);
		return A2(author$project$Parser$Stat$EvalContext, ctx.dh, ctx.fd);
	});
var author$project$Parser$Stat$evalWithDefault = F3(
	function (defaultVar, getVar, rule) {
		return A3(author$project$Parser$Stat$evalFullWithDefault, defaultVar, getVar, rule).fd;
	});
var elm$core$List$filter = F2(
	function (isGood, list) {
		return A3(
			elm$core$List$foldr,
			F2(
				function (x, xs) {
					return isGood(x) ? A2(elm$core$List$cons, x, xs) : xs;
				}),
			_List_Nil,
			list);
	});
var author$project$Game$spent = F2(
	function (name, game) {
		var gd = author$project$Game$gameData(game);
		var _n0 = A2(author$project$GameData$unitByName, name, gd);
		if (_n0.$ === 1) {
			return elm$core$Maybe$Nothing;
		} else {
			var unit = _n0.a;
			var evalCostTotal = function (_n4) {
				var parent = _n4.a;
				var cost = _n4.b;
				if (cost.$ === 1) {
					return author$project$Decimal$zero;
				} else {
					var expr = cost.a;
					return A2(
						author$project$Decimal$mul,
						A2(
							author$project$Game$itemCount,
							author$project$GameData$Item$id(parent),
							game),
						A3(
							author$project$Parser$Stat$evalWithDefault,
							author$project$Decimal$zero,
							A2(
								author$project$Game$getVarDicts,
								game,
								author$project$Game$units(game)),
							expr));
				}
			};
			var costs = A2(
				elm$core$List$filter,
				function (_n2) {
					var item = _n2.a;
					return author$project$Game$isResetOnAscend(item);
				},
				A2(author$project$GameData$itemsByCost, unit.eL, gd));
			if (!costs.b) {
				return elm$core$Maybe$Nothing;
			} else {
				return elm$core$Maybe$Just(
					author$project$Decimal$sum(
						A2(elm$core$List$map, evalCostTotal, costs)));
			}
		}
	});
var author$project$Game$UnitsSnapshot$velocities = A2(
	elm$core$Basics$composeR,
	author$project$Game$UnitsSnapshot$unwrap,
	function ($) {
		return $.cR;
	});
var elm$core$String$endsWith = _String_endsWith;
var author$project$Game$getVar = F3(
	function (game, units_, name) {
		return A2(
			elm_community$maybe_extra$Maybe$Extra$orElse,
			A2(elm$core$String$endsWith, '_velocity', name) ? A2(
				elm$core$Dict$get,
				A3(elm$core$String$slice, 0, -9, name),
				author$project$Game$UnitsSnapshot$velocities(units_)) : (A2(elm$core$String$endsWith, '_spent', name) ? A2(
				author$project$Game$spent,
				A3(elm$core$String$slice, 0, -6, name),
				game) : ((name === 'achievementpoints') ? elm$core$Maybe$Just(
				author$project$Decimal$fromInt(
					author$project$Game$achievementPoints(game).d6)) : elm$core$Maybe$Nothing)),
			A3(author$project$Game$getVarDicts, game, units_, name));
	});
var author$project$Game$getGameVar = function (g) {
	return A2(
		author$project$Game$getVar,
		g,
		author$project$Game$units(g));
};
var author$project$GameData$units = A2(
	elm$core$Basics$composeR,
	author$project$GameData$lists,
	function ($) {
		return $.k;
	});
var author$project$GameData$cappedUnits = A2(
	elm$core$Basics$composeR,
	author$project$GameData$units,
	elm$core$List$filterMap(
		function (u) {
			return A2(
				elm$core$Maybe$map,
				elm$core$Tuple$pair(u),
				u.eZ);
		}));
var author$project$Game$unitCaps = function (game) {
	return A2(
		elm$core$List$map,
		elm$core$Tuple$mapSecond(
			A2(
				author$project$Parser$Stat$evalWithDefault,
				author$project$Decimal$zero,
				author$project$Game$getGameVar(game))),
		author$project$GameData$cappedUnits(
			author$project$Game$gameData(game)));
};
var author$project$Game$UnitsSnapshot$UnitsSnapshot = elm$core$Basics$identity;
var author$project$Game$UnitsSnapshot$create = F4(
	function (now, counts, velocities_, visible) {
		return {bR: now, aa: counts, cR: velocities_, f$: visible};
	});
var author$project$Decimal$gte = F2(
	function (a, b) {
		return A2(author$project$Decimal$compare, a, b);
	});
var author$project$GameData$spells = A2(
	elm$core$Basics$composeR,
	author$project$GameData$lists,
	function ($) {
		return $.s;
	});
var author$project$GameData$upgrades = A2(
	elm$core$Basics$composeR,
	author$project$GameData$lists,
	function ($) {
		return $.o;
	});
var author$project$GameData$items = function (g) {
	return elm$core$List$concat(
		_List_fromArray(
			[
				A2(
				elm$core$List$map,
				author$project$GameData$Item$Unit,
				author$project$GameData$units(g)),
				A2(
				elm$core$List$map,
				author$project$GameData$Item$Upgrade,
				author$project$GameData$upgrades(g)),
				A2(
				elm$core$List$map,
				author$project$GameData$Item$Spell,
				author$project$GameData$spells(g))
			]));
};
var author$project$GameData$Item$visible = function (item) {
	switch (item.$) {
		case 0:
			var u = item.a;
			return u.f$;
		case 1:
			var u = item.a;
			return u.f$;
		default:
			var s = item.a;
			return s.f$;
	}
};
var author$project$Decimal$lte = F2(
	function (a, b) {
		return A2(author$project$Decimal$compare, a, b) !== 2;
	});
var author$project$Parser$Visibility$cmpToFn = function (cmp) {
	switch (cmp) {
		case 0:
			return author$project$Decimal$gt;
		case 1:
			return author$project$Decimal$gte;
		case 5:
			return author$project$Decimal$lt;
		case 4:
			return author$project$Decimal$lte;
		case 2:
			return elm$core$Basics$eq;
		default:
			return elm$core$Basics$neq;
	}
};
var elm$core$List$any = F2(
	function (isOkay, list) {
		any:
		while (true) {
			if (!list.b) {
				return false;
			} else {
				var x = list.a;
				var xs = list.b;
				if (isOkay(x)) {
					return true;
				} else {
					var $temp$isOkay = isOkay,
						$temp$list = xs;
					isOkay = $temp$isOkay;
					list = $temp$list;
					continue any;
				}
			}
		}
	});
var elm$core$List$all = F2(
	function (isOkay, list) {
		return !A2(
			elm$core$List$any,
			A2(elm$core$Basics$composeL, elm$core$Basics$not, isOkay),
			list);
	});
var author$project$Parser$Visibility$evalWithDefault = F3(
	function (defaultVar, getVar, rule) {
		switch (rule.$) {
			case 2:
				var val = rule.a;
				return val;
			case 1:
				var left0 = rule.a;
				var cmp = rule.b;
				var right = rule.c;
				var left1 = function () {
					if (!left0.$) {
						var name = left0.a;
						return A2(
							elm$core$Maybe$withDefault,
							defaultVar,
							getVar(name));
					} else {
						var names = left0.a;
						return author$project$Decimal$sum(
							A2(
								elm$core$List$map,
								A2(
									elm$core$Basics$composeR,
									getVar,
									elm$core$Maybe$withDefault(defaultVar)),
								names));
					}
				}();
				return A3(author$project$Parser$Visibility$cmpToFn, cmp, left1, right);
			default:
				if (!rule.a) {
					var _n2 = rule.a;
					var exprs = rule.b;
					return A2(
						elm$core$List$all,
						A2(author$project$Parser$Visibility$evalWithDefault, defaultVar, getVar),
						exprs);
				} else {
					var _n3 = rule.a;
					var exprs = rule.b;
					return A2(
						elm$core$List$any,
						A2(author$project$Parser$Visibility$evalWithDefault, defaultVar, getVar),
						exprs);
				}
		}
	});
var elm$core$Set$union = F2(
	function (_n0, _n1) {
		var dict1 = _n0;
		var dict2 = _n1;
		return A2(elm$core$Dict$union, dict1, dict2);
	});
var author$project$Parser$Visibility$evalSetWithDefault = F4(
	function (defaultVar, getVar, rules, alreadyVisible) {
		return A2(
			elm$core$Set$union,
			alreadyVisible,
			elm$core$Set$fromList(
				A2(
					elm$core$List$map,
					elm$core$Tuple$first,
					A2(
						elm$core$List$filter,
						elm$core$Tuple$second,
						A2(
							elm$core$List$map,
							elm$core$Tuple$mapSecond(
								A2(author$project$Parser$Visibility$evalWithDefault, defaultVar, getVar)),
							A2(
								elm$core$List$filter,
								function (_n0) {
									var name = _n0.a;
									return !A2(elm$core$Set$member, name, alreadyVisible);
								},
								rules))))));
	});
var elm$core$Maybe$map2 = F3(
	function (func, ma, mb) {
		if (ma.$ === 1) {
			return elm$core$Maybe$Nothing;
		} else {
			var a = ma.a;
			if (mb.$ === 1) {
				return elm$core$Maybe$Nothing;
			} else {
				var b = mb.a;
				return elm$core$Maybe$Just(
					A2(func, a, b));
			}
		}
	});
var elm$core$Dict$diff = F2(
	function (t1, t2) {
		return A3(
			elm$core$Dict$foldl,
			F3(
				function (k, v, t) {
					return A2(elm$core$Dict$remove, k, t);
				}),
			t1,
			t2);
	});
var elm$core$Set$diff = F2(
	function (_n0, _n1) {
		var dict1 = _n0;
		var dict2 = _n1;
		return A2(elm$core$Dict$diff, dict1, dict2);
	});
var author$project$Game$UnitsSnapshot$evalVisibility = F3(
	function (gameData, getVar, visible0) {
		var visRules = A2(
			elm$core$List$map,
			function (i) {
				return _Utils_Tuple2(
					author$project$GameData$Item$name(i),
					author$project$GameData$Item$visible(i));
			},
			author$project$GameData$items(gameData));
		var maxedUpgrades = elm$core$Set$fromList(
			A2(
				elm$core$List$map,
				author$project$GameData$Upgrade$name,
				A2(
					elm$core$List$filter,
					function (u) {
						return A2(
							elm$core$Maybe$withDefault,
							false,
							A3(
								elm$core$Maybe$map2,
								author$project$Decimal$gte,
								getVar(
									author$project$GameData$Upgrade$name(u)),
								u.e_));
					},
					author$project$GameData$upgrades(gameData))));
		return function (v) {
			return A2(elm$core$Set$diff, v, maxedUpgrades);
		}(
			A4(author$project$Parser$Visibility$evalSetWithDefault, author$project$Decimal$zero, getVar, visRules, visible0));
	});
var author$project$Duration$toMillis = function (_n0) {
	var n = _n0;
	return n;
};
var author$project$Duration$toSecs = function (f) {
	return author$project$Duration$toMillis(f) / author$project$Duration$units.aE;
};
var author$project$Polynomial$evaluateTerms = function (dur) {
	var t = author$project$Duration$toSecs(dur);
	var eval1 = F2(
		function (degree, term) {
			return A2(
				author$project$Decimal$mul,
				author$project$Decimal$fromFloat(
					A2(elm$core$Basics$pow, t, degree)),
				term);
		});
	return elm$core$List$indexedMap(eval1);
};
var author$project$Polynomial$evaluate = function (t) {
	return A2(
		elm$core$Basics$composeR,
		author$project$Polynomial$evaluateTerms(t),
		A2(elm$core$List$foldl, author$project$Decimal$add, author$project$Decimal$zero));
};
var elm$core$List$drop = F2(
	function (n, list) {
		drop:
		while (true) {
			if (n <= 0) {
				return list;
			} else {
				if (!list.b) {
					return list;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs;
					n = $temp$n;
					list = $temp$list;
					continue drop;
				}
			}
		}
	});
var author$project$Game$UnitsSnapshot$eval = F7(
	function (getVar, gameData, now, dt, polys, caps, visible0) {
		var velocities_ = A2(
			elm$core$Dict$map,
			function (_n2) {
				return A2(
					elm$core$Basics$composeR,
					elm$core$List$drop(1),
					author$project$Polynomial$evaluate(dt));
			},
			polys);
		var uncappedCounts = A2(
			elm$core$Dict$map,
			function (_n1) {
				return author$project$Polynomial$evaluate(dt);
			},
			polys);
		var applyCap = function (_n0) {
			var u = _n0.a;
			var max = _n0.b;
			return A2(
				elm$core$Dict$update,
				author$project$GameData$Unit$name(u),
				elm$core$Maybe$map(
					author$project$Decimal$min(max)));
		};
		var counts = A3(elm$core$List$foldl, applyCap, uncappedCounts, caps);
		var visible = A3(
			author$project$Game$UnitsSnapshot$evalVisibility,
			gameData,
			getVar(
				A4(author$project$Game$UnitsSnapshot$create, now, counts, velocities_, visible0)),
			visible0);
		return A4(author$project$Game$UnitsSnapshot$create, now, counts, velocities_, visible);
	});
var elm$time$Time$posixToMillis = function (_n0) {
	var millis = _n0;
	return millis;
};
var author$project$Duration$since = function (_n0) {
	var before = _n0.eh;
	var after = _n0.eb;
	return author$project$Duration$fromMillis(
		elm$time$Time$posixToMillis(after) - elm$time$Time$posixToMillis(before));
};
var author$project$Game$UnitsSnapshot$at = A2(
	elm$core$Basics$composeR,
	author$project$Game$UnitsSnapshot$unwrap,
	function ($) {
		return $.bR;
	});
var author$project$Game$UnitsSnapshot$since = F2(
	function (now, snapshot) {
		return author$project$Duration$since(
			{
				eb: now,
				eh: author$project$Game$UnitsSnapshot$at(snapshot)
			});
	});
var author$project$Game$evalUnits_ = F4(
	function (now, duration, visibleNames, game) {
		return A7(
			author$project$Game$UnitsSnapshot$eval,
			author$project$Game$getVar(game),
			author$project$Game$unwrap(game).D,
			now,
			A2(
				author$project$Duration$add,
				duration,
				A2(
					author$project$Game$UnitsSnapshot$since,
					now,
					author$project$Game$units(game))),
			author$project$Game$unwrap(game).aB,
			author$project$Game$unitCaps(game),
			visibleNames);
	});
var author$project$Game$UnitsSnapshot$visibleNames = A2(
	elm$core$Basics$composeR,
	author$project$Game$UnitsSnapshot$unwrap,
	function ($) {
		return $.f$;
	});
var author$project$Game$evalUnits = F2(
	function (now, game) {
		return A4(
			author$project$Game$evalUnits_,
			now,
			author$project$Duration$zero,
			author$project$Game$UnitsSnapshot$visibleNames(
				author$project$Game$units(game)),
			game);
	});
var elm_community$graph$Graph$Edge = F3(
	function (from, to, label) {
		return {dj: from, bn: label, aI: to};
	});
var elm_community$graph$Graph$Node = F2(
	function (id, label) {
		return {eL: id, bn: label};
	});
var elm_community$graph$Graph$Graph = elm$core$Basics$identity;
var elm_community$graph$Graph$NodeContext = F3(
	function (node, incoming, outgoing) {
		return {dr: incoming, K: node, cp: outgoing};
	});
var elm_community$intdict$IntDict$Empty = {$: 0};
var elm_community$intdict$IntDict$empty = elm_community$intdict$IntDict$Empty;
var elm_community$intdict$IntDict$Inner = function (a) {
	return {$: 2, a: a};
};
var elm_community$intdict$IntDict$size = function (dict) {
	switch (dict.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		default:
			var i = dict.a;
			return i.fC;
	}
};
var elm_community$intdict$IntDict$inner = F3(
	function (p, l, r) {
		var _n0 = _Utils_Tuple2(l, r);
		if (!_n0.a.$) {
			var _n1 = _n0.a;
			return r;
		} else {
			if (!_n0.b.$) {
				var _n2 = _n0.b;
				return l;
			} else {
				return elm_community$intdict$IntDict$Inner(
					{
						d: l,
						fi: p,
						e: r,
						fC: elm_community$intdict$IntDict$size(l) + elm_community$intdict$IntDict$size(r)
					});
			}
		}
	});
var elm$core$Bitwise$and = _Bitwise_and;
var elm$core$Bitwise$xor = _Bitwise_xor;
var elm$core$Bitwise$complement = _Bitwise_complement;
var elm$core$Bitwise$or = _Bitwise_or;
var elm$core$Bitwise$shiftRightZfBy = _Bitwise_shiftRightZfBy;
var elm_community$intdict$IntDict$highestBitSet = function (n) {
	var shiftOr = F2(
		function (i, shift) {
			return i | (i >>> shift);
		});
	var n1 = A2(shiftOr, n, 1);
	var n2 = A2(shiftOr, n1, 2);
	var n3 = A2(shiftOr, n2, 4);
	var n4 = A2(shiftOr, n3, 8);
	var n5 = A2(shiftOr, n4, 16);
	return n5 & (~(n5 >>> 1));
};
var elm_community$intdict$IntDict$signBit = elm_community$intdict$IntDict$highestBitSet(-1);
var elm_community$intdict$IntDict$isBranchingBitSet = function (p) {
	return A2(
		elm$core$Basics$composeR,
		elm$core$Bitwise$xor(elm_community$intdict$IntDict$signBit),
		A2(
			elm$core$Basics$composeR,
			elm$core$Bitwise$and(p.ap),
			elm$core$Basics$neq(0)));
};
var elm_community$intdict$IntDict$higherBitMask = function (branchingBit) {
	return branchingBit ^ (~(branchingBit - 1));
};
var elm_community$intdict$IntDict$lcp = F2(
	function (x, y) {
		var branchingBit = elm_community$intdict$IntDict$highestBitSet(x ^ y);
		var mask = elm_community$intdict$IntDict$higherBitMask(branchingBit);
		var prefixBits = x & mask;
		return {ap: branchingBit, G: prefixBits};
	});
var elm_community$intdict$IntDict$Leaf = function (a) {
	return {$: 1, a: a};
};
var elm_community$intdict$IntDict$leaf = F2(
	function (k, v) {
		return elm_community$intdict$IntDict$Leaf(
			{E: k, M: v});
	});
var elm_community$intdict$IntDict$prefixMatches = F2(
	function (p, n) {
		return _Utils_eq(
			n & elm_community$intdict$IntDict$higherBitMask(p.ap),
			p.G);
	});
var elm_community$intdict$IntDict$update = F3(
	function (key, alter, dict) {
		var join = F2(
			function (_n2, _n3) {
				var k1 = _n2.a;
				var l = _n2.b;
				var k2 = _n3.a;
				var r = _n3.b;
				var prefix = A2(elm_community$intdict$IntDict$lcp, k1, k2);
				return A2(elm_community$intdict$IntDict$isBranchingBitSet, prefix, k2) ? A3(elm_community$intdict$IntDict$inner, prefix, l, r) : A3(elm_community$intdict$IntDict$inner, prefix, r, l);
			});
		var alteredNode = function (mv) {
			var _n1 = alter(mv);
			if (!_n1.$) {
				var v = _n1.a;
				return A2(elm_community$intdict$IntDict$leaf, key, v);
			} else {
				return elm_community$intdict$IntDict$empty;
			}
		};
		switch (dict.$) {
			case 0:
				return alteredNode(elm$core$Maybe$Nothing);
			case 1:
				var l = dict.a;
				return _Utils_eq(l.E, key) ? alteredNode(
					elm$core$Maybe$Just(l.M)) : A2(
					join,
					_Utils_Tuple2(
						key,
						alteredNode(elm$core$Maybe$Nothing)),
					_Utils_Tuple2(l.E, dict));
			default:
				var i = dict.a;
				return A2(elm_community$intdict$IntDict$prefixMatches, i.fi, key) ? (A2(elm_community$intdict$IntDict$isBranchingBitSet, i.fi, key) ? A3(
					elm_community$intdict$IntDict$inner,
					i.fi,
					i.d,
					A3(elm_community$intdict$IntDict$update, key, alter, i.e)) : A3(
					elm_community$intdict$IntDict$inner,
					i.fi,
					A3(elm_community$intdict$IntDict$update, key, alter, i.d),
					i.e)) : A2(
					join,
					_Utils_Tuple2(
						key,
						alteredNode(elm$core$Maybe$Nothing)),
					_Utils_Tuple2(i.fi.G, dict));
		}
	});
var elm_community$intdict$IntDict$insert = F3(
	function (key, value, dict) {
		return A3(
			elm_community$intdict$IntDict$update,
			key,
			elm$core$Basics$always(
				elm$core$Maybe$Just(value)),
			dict);
	});
var elm_community$intdict$IntDict$get = F2(
	function (key, dict) {
		get:
		while (true) {
			switch (dict.$) {
				case 0:
					return elm$core$Maybe$Nothing;
				case 1:
					var l = dict.a;
					return _Utils_eq(l.E, key) ? elm$core$Maybe$Just(l.M) : elm$core$Maybe$Nothing;
				default:
					var i = dict.a;
					if (!A2(elm_community$intdict$IntDict$prefixMatches, i.fi, key)) {
						return elm$core$Maybe$Nothing;
					} else {
						if (A2(elm_community$intdict$IntDict$isBranchingBitSet, i.fi, key)) {
							var $temp$key = key,
								$temp$dict = i.e;
							key = $temp$key;
							dict = $temp$dict;
							continue get;
						} else {
							var $temp$key = key,
								$temp$dict = i.d;
							key = $temp$key;
							dict = $temp$dict;
							continue get;
						}
					}
			}
		}
	});
var elm_community$intdict$IntDict$member = F2(
	function (key, dict) {
		var _n0 = A2(elm_community$intdict$IntDict$get, key, dict);
		if (!_n0.$) {
			return true;
		} else {
			return false;
		}
	});
var elm_community$graph$Graph$fromNodesAndEdges = F2(
	function (nodes_, edges_) {
		var nodeRep = A3(
			elm$core$List$foldl,
			function (n) {
				return A2(
					elm_community$intdict$IntDict$insert,
					n.eL,
					A3(elm_community$graph$Graph$NodeContext, n, elm_community$intdict$IntDict$empty, elm_community$intdict$IntDict$empty));
			},
			elm_community$intdict$IntDict$empty,
			nodes_);
		var addEdge = F2(
			function (edge, rep) {
				var updateOutgoing = function (ctx) {
					return _Utils_update(
						ctx,
						{
							cp: A3(elm_community$intdict$IntDict$insert, edge.aI, edge.bn, ctx.cp)
						});
				};
				var updateIncoming = function (ctx) {
					return _Utils_update(
						ctx,
						{
							dr: A3(elm_community$intdict$IntDict$insert, edge.dj, edge.bn, ctx.dr)
						});
				};
				return A3(
					elm_community$intdict$IntDict$update,
					edge.aI,
					elm$core$Maybe$map(updateIncoming),
					A3(
						elm_community$intdict$IntDict$update,
						edge.dj,
						elm$core$Maybe$map(updateOutgoing),
						rep));
			});
		var addEdgeIfValid = F2(
			function (edge, rep) {
				return (A2(elm_community$intdict$IntDict$member, edge.dj, rep) && A2(elm_community$intdict$IntDict$member, edge.aI, rep)) ? A2(addEdge, edge, rep) : rep;
			});
		return A3(elm$core$List$foldl, addEdgeIfValid, nodeRep, edges_);
	});
var author$project$Game$ProductionGraph$graph = F2(
	function (gd, getVar) {
		var units = author$project$GameData$units(gd);
		var nodes = A2(
			elm$core$List$map,
			function (u) {
				return A2(elm_community$graph$Graph$Node, u.bs, u);
			},
			units);
		var byName = elm$core$Dict$fromList(
			A2(
				elm$core$List$map,
				function (n) {
					return _Utils_Tuple2(
						author$project$GameData$Unit$name(n.bn),
						n);
				},
				nodes));
		var edge = function (parent) {
			var _n0 = parent.fl;
			if (_n0.$ === 1) {
				return elm$core$Maybe$Nothing;
			} else {
				var _n1 = _n0.a;
				var childId = _n1.a;
				var prodExpr = _n1.b;
				var _n2 = A2(
					elm$core$Dict$get,
					author$project$GameData$Unit$idToString(childId),
					byName);
				if (_n2.$ === 1) {
					return elm$core$Maybe$Nothing;
				} else {
					var cnode = _n2.a;
					return elm$core$Maybe$Just(
						A3(
							elm_community$graph$Graph$Edge,
							parent.bs,
							cnode.eL,
							A3(author$project$Parser$Stat$evalWithDefault, author$project$Decimal$zero, getVar, prodExpr)));
				}
			}
		};
		var edges = A2(
			elm$core$List$filterMap,
			elm$core$Basics$identity,
			A2(elm$core$List$map, edge, units));
		return A2(elm_community$graph$Graph$fromNodesAndEdges, nodes, edges);
	});
var author$project$Game$buildGraph = function (g) {
	return A2(
		author$project$Game$ProductionGraph$graph,
		author$project$Game$gameData(g),
		author$project$Game$getGameVar(g));
};
var author$project$Decimal$flipDivFloat = F2(
	function (f, _n0) {
		var sig = _n0.i;
		var exp = _n0.j;
		return A2(author$project$Decimal$fromSigExp, sig / f, exp);
	});
var author$project$Game$ProductionGraph$fact = function () {
	var loop = F2(
		function (accum, n) {
			loop:
			while (true) {
				if (n <= 1) {
					return accum;
				} else {
					var $temp$accum = accum * n,
						$temp$n = n - 1;
					accum = $temp$accum;
					n = $temp$n;
					continue loop;
				}
			}
		});
	return loop(1);
}();
var author$project$Game$ProductionGraph$ParentAccum = F2(
	function (path, coeffs) {
		return {bd: coeffs, aA: path};
	});
var author$project$Game$ProductionGraph$path = function () {
	var tailrec = F3(
		function (accum, node, nodes) {
			tailrec:
			while (true) {
				if (!nodes.b) {
					return A2(elm$core$List$filterMap, elm$core$Basics$identity, accum);
				} else {
					var parent = nodes.a;
					var ancestors = nodes.b;
					var $temp$accum = A2(
						elm$core$List$cons,
						A2(elm_community$intdict$IntDict$get, parent.K.eL, node.cp),
						accum),
						$temp$node = parent,
						$temp$nodes = ancestors;
					accum = $temp$accum;
					node = $temp$node;
					nodes = $temp$nodes;
					continue tailrec;
				}
			}
		});
	return tailrec(_List_Nil);
}();
var author$project$Game$ProductionGraph$paths = function () {
	var tailrec = F4(
		function (accum, visited, node, unvisited) {
			tailrec:
			while (true) {
				if (!unvisited.b) {
					return accum;
				} else {
					var parent = unvisited.a;
					var ancestors = unvisited.b;
					var $temp$accum = A2(
						elm$core$List$cons,
						_Utils_Tuple2(
							parent,
							A2(
								author$project$Game$ProductionGraph$path,
								parent,
								A2(elm$core$List$cons, node, visited))),
						accum),
						$temp$visited = A2(elm$core$List$cons, node, visited),
						$temp$node = parent,
						$temp$unvisited = ancestors;
					accum = $temp$accum;
					visited = $temp$visited;
					node = $temp$node;
					unvisited = $temp$unvisited;
					continue tailrec;
				}
			}
		});
	return A2(tailrec, _List_Nil, _List_Nil);
}();
var elm$core$Maybe$andThen = F2(
	function (callback, maybeValue) {
		if (!maybeValue.$) {
			var value = maybeValue.a;
			return callback(value);
		} else {
			return elm$core$Maybe$Nothing;
		}
	});
var elm_community$graph$Graph$unGraph = function (graph) {
	var rep = graph;
	return rep;
};
var elm_community$graph$Graph$get = function (nodeId) {
	return A2(
		elm$core$Basics$composeR,
		elm_community$graph$Graph$unGraph,
		elm_community$intdict$IntDict$get(nodeId));
};
var elm_community$intdict$IntDict$findMax = function (dict) {
	findMax:
	while (true) {
		switch (dict.$) {
			case 0:
				return elm$core$Maybe$Nothing;
			case 1:
				var l = dict.a;
				return elm$core$Maybe$Just(
					_Utils_Tuple2(l.E, l.M));
			default:
				var i = dict.a;
				var $temp$dict = i.e;
				dict = $temp$dict;
				continue findMax;
		}
	}
};
var elm_community$intdict$IntDict$findMin = function (dict) {
	findMin:
	while (true) {
		switch (dict.$) {
			case 0:
				return elm$core$Maybe$Nothing;
			case 1:
				var l = dict.a;
				return elm$core$Maybe$Just(
					_Utils_Tuple2(l.E, l.M));
			default:
				var i = dict.a;
				var $temp$dict = i.d;
				dict = $temp$dict;
				continue findMin;
		}
	}
};
var elm_community$graph$Graph$nodeIdRange = function (graph) {
	return A2(
		elm$core$Maybe$andThen,
		function (_n0) {
			var min = _n0.a;
			return A2(
				elm$core$Maybe$andThen,
				function (_n1) {
					var max = _n1.a;
					return elm$core$Maybe$Just(
						_Utils_Tuple2(min, max));
				},
				elm_community$intdict$IntDict$findMax(
					elm_community$graph$Graph$unGraph(graph)));
		},
		elm_community$intdict$IntDict$findMin(
			elm_community$graph$Graph$unGraph(graph)));
};
var elm_community$intdict$IntDict$foldl = F3(
	function (f, acc, dict) {
		foldl:
		while (true) {
			switch (dict.$) {
				case 0:
					return acc;
				case 1:
					var l = dict.a;
					return A3(f, l.E, l.M, acc);
				default:
					var i = dict.a;
					var $temp$f = f,
						$temp$acc = A3(elm_community$intdict$IntDict$foldl, f, acc, i.d),
						$temp$dict = i.e;
					f = $temp$f;
					acc = $temp$acc;
					dict = $temp$dict;
					continue foldl;
			}
		}
	});
var elm_community$graph$Graph$applyEdgeDiff = F3(
	function (nodeId, diff, graphRep) {
		var updateOutgoingEdge = F2(
			function (upd, node) {
				return _Utils_update(
					node,
					{
						cp: A3(elm_community$intdict$IntDict$update, nodeId, upd, node.cp)
					});
			});
		var updateIncomingEdge = F2(
			function (upd, node) {
				return _Utils_update(
					node,
					{
						dr: A3(elm_community$intdict$IntDict$update, nodeId, upd, node.dr)
					});
			});
		var flippedFoldl = F3(
			function (f, dict, acc) {
				return A3(elm_community$intdict$IntDict$foldl, f, acc, dict);
			});
		var edgeUpdateToMaybe = function (edgeUpdate) {
			if (!edgeUpdate.$) {
				var lbl = edgeUpdate.a;
				return elm$core$Maybe$Just(lbl);
			} else {
				return elm$core$Maybe$Nothing;
			}
		};
		var updateAdjacency = F3(
			function (updateEdge, updatedId, edgeUpdate) {
				var updateLbl = updateEdge(
					elm$core$Basics$always(
						edgeUpdateToMaybe(edgeUpdate)));
				return A2(
					elm_community$intdict$IntDict$update,
					updatedId,
					elm$core$Maybe$map(updateLbl));
			});
		return A3(
			flippedFoldl,
			updateAdjacency(updateOutgoingEdge),
			diff.cp,
			A3(
				flippedFoldl,
				updateAdjacency(updateIncomingEdge),
				diff.dr,
				graphRep));
	});
var elm_community$graph$Graph$Insert = function (a) {
	return {$: 0, a: a};
};
var elm_community$graph$Graph$Remove = function (a) {
	return {$: 1, a: a};
};
var elm_community$graph$Graph$crashHack = function (msg) {
	crashHack:
	while (true) {
		var $temp$msg = msg;
		msg = $temp$msg;
		continue crashHack;
	}
};
var elm_community$graph$Graph$emptyDiff = {dr: elm_community$intdict$IntDict$empty, cp: elm_community$intdict$IntDict$empty};
var elm_community$graph$Graph$computeEdgeDiff = F2(
	function (old, _new) {
		var collectUpdates = F3(
			function (edgeUpdate, updatedId, label) {
				var replaceUpdate = function (old_) {
					var _n5 = _Utils_Tuple2(
						old_,
						edgeUpdate(label));
					if (!_n5.a.$) {
						if (_n5.a.a.$ === 1) {
							if (!_n5.b.$) {
								var oldLbl = _n5.a.a.a;
								var newLbl = _n5.b.a;
								return _Utils_eq(oldLbl, newLbl) ? elm$core$Maybe$Nothing : elm$core$Maybe$Just(
									elm_community$graph$Graph$Insert(newLbl));
							} else {
								return elm_community$graph$Graph$crashHack('Graph.computeEdgeDiff: Collected two removals for the same edge. This is an error in the implementation of Graph and you should file a bug report!');
							}
						} else {
							return elm_community$graph$Graph$crashHack('Graph.computeEdgeDiff: Collected inserts before removals. This is an error in the implementation of Graph and you should file a bug report!');
						}
					} else {
						var _n6 = _n5.a;
						var eu = _n5.b;
						return elm$core$Maybe$Just(eu);
					}
				};
				return A2(elm_community$intdict$IntDict$update, updatedId, replaceUpdate);
			});
		var collect = F3(
			function (edgeUpdate, adj, updates) {
				return A3(
					elm_community$intdict$IntDict$foldl,
					collectUpdates(edgeUpdate),
					updates,
					adj);
			});
		var _n0 = _Utils_Tuple2(old, _new);
		if (_n0.a.$ === 1) {
			if (_n0.b.$ === 1) {
				var _n1 = _n0.a;
				var _n2 = _n0.b;
				return elm_community$graph$Graph$emptyDiff;
			} else {
				var _n4 = _n0.a;
				var ins = _n0.b.a;
				return {
					dr: A3(collect, elm_community$graph$Graph$Insert, ins.cp, elm_community$intdict$IntDict$empty),
					cp: A3(collect, elm_community$graph$Graph$Insert, ins.dr, elm_community$intdict$IntDict$empty)
				};
			}
		} else {
			if (_n0.b.$ === 1) {
				var rem = _n0.a.a;
				var _n3 = _n0.b;
				return {
					dr: A3(collect, elm_community$graph$Graph$Remove, rem.cp, elm_community$intdict$IntDict$empty),
					cp: A3(collect, elm_community$graph$Graph$Remove, rem.dr, elm_community$intdict$IntDict$empty)
				};
			} else {
				var rem = _n0.a.a;
				var ins = _n0.b.a;
				return _Utils_eq(rem, ins) ? elm_community$graph$Graph$emptyDiff : {
					dr: A3(
						collect,
						elm_community$graph$Graph$Insert,
						ins.cp,
						A3(collect, elm_community$graph$Graph$Remove, rem.cp, elm_community$intdict$IntDict$empty)),
					cp: A3(
						collect,
						elm_community$graph$Graph$Insert,
						ins.dr,
						A3(collect, elm_community$graph$Graph$Remove, rem.dr, elm_community$intdict$IntDict$empty))
				};
			}
		}
	});
var elm_community$intdict$IntDict$filter = F2(
	function (predicate, dict) {
		var add = F3(
			function (k, v, d) {
				return A2(predicate, k, v) ? A3(elm_community$intdict$IntDict$insert, k, v, d) : d;
			});
		return A3(elm_community$intdict$IntDict$foldl, add, elm_community$intdict$IntDict$empty, dict);
	});
var elm_community$graph$Graph$update = F2(
	function (nodeId, updater) {
		var wrappedUpdater = function (rep) {
			var old = A2(elm_community$intdict$IntDict$get, nodeId, rep);
			var filterInvalidEdges = function (ctx) {
				return elm_community$intdict$IntDict$filter(
					F2(
						function (id, _n0) {
							return _Utils_eq(id, ctx.K.eL) || A2(elm_community$intdict$IntDict$member, id, rep);
						}));
			};
			var cleanUpEdges = function (ctx) {
				return _Utils_update(
					ctx,
					{
						dr: A2(filterInvalidEdges, ctx, ctx.dr),
						cp: A2(filterInvalidEdges, ctx, ctx.cp)
					});
			};
			var _new = A2(
				elm$core$Maybe$map,
				cleanUpEdges,
				updater(old));
			var diff = A2(elm_community$graph$Graph$computeEdgeDiff, old, _new);
			return A3(
				elm_community$intdict$IntDict$update,
				nodeId,
				elm$core$Basics$always(_new),
				A3(elm_community$graph$Graph$applyEdgeDiff, nodeId, diff, rep));
		};
		return A2(
			elm$core$Basics$composeR,
			elm_community$graph$Graph$unGraph,
			A2(elm$core$Basics$composeR, wrappedUpdater, elm$core$Basics$identity));
	});
var elm_community$graph$Graph$remove = F2(
	function (nodeId, graph) {
		return A3(
			elm_community$graph$Graph$update,
			nodeId,
			elm$core$Basics$always(elm$core$Maybe$Nothing),
			graph);
	});
var elm_community$graph$Graph$fold = F3(
	function (f, acc, graph) {
		var go = F2(
			function (acc1, graph1) {
				go:
				while (true) {
					var maybeContext = A2(
						elm$core$Maybe$andThen,
						function (id) {
							return A2(elm_community$graph$Graph$get, id, graph);
						},
						A2(
							elm$core$Maybe$map,
							elm$core$Tuple$first,
							elm_community$graph$Graph$nodeIdRange(graph1)));
					if (!maybeContext.$) {
						var ctx = maybeContext.a;
						var $temp$acc1 = A2(f, ctx, acc1),
							$temp$graph1 = A2(elm_community$graph$Graph$remove, ctx.K.eL, graph1);
						acc1 = $temp$acc1;
						graph1 = $temp$graph1;
						continue go;
					} else {
						return acc1;
					}
				}
			});
		return A2(go, acc, graph);
	});
var elm_community$intdict$IntDict$isEmpty = function (dict) {
	if (!dict.$) {
		return true;
	} else {
		return false;
	}
};
var author$project$Game$ProductionGraph$roots = function () {
	var fold = F2(
		function (nc, acc) {
			return elm_community$intdict$IntDict$isEmpty(nc.dr) ? A2(elm$core$List$cons, nc.K.eL, acc) : acc;
		});
	return A2(elm_community$graph$Graph$fold, fold, _List_Nil);
}();
var elm_community$intdict$IntDict$foldr = F3(
	function (f, acc, dict) {
		foldr:
		while (true) {
			switch (dict.$) {
				case 0:
					return acc;
				case 1:
					var l = dict.a;
					return A3(f, l.E, l.M, acc);
				default:
					var i = dict.a;
					var $temp$f = f,
						$temp$acc = A3(elm_community$intdict$IntDict$foldr, f, acc, i.e),
						$temp$dict = i.d;
					f = $temp$f;
					acc = $temp$acc;
					dict = $temp$dict;
					continue foldr;
			}
		}
	});
var elm_community$intdict$IntDict$keys = function (dict) {
	return A3(
		elm_community$intdict$IntDict$foldr,
		F3(
			function (key, value, keyList) {
				return A2(elm$core$List$cons, key, keyList);
			}),
		_List_Nil,
		dict);
};
var elm_community$graph$Graph$alongOutgoingEdges = function (ctx) {
	return elm_community$intdict$IntDict$keys(ctx.cp);
};
var elm_community$graph$Graph$guidedDfs = F5(
	function (selectNeighbors, visitNode, startingSeeds, startingAcc, startingGraph) {
		var go = F3(
			function (seeds, acc, graph) {
				go:
				while (true) {
					if (!seeds.b) {
						return _Utils_Tuple2(acc, graph);
					} else {
						var next = seeds.a;
						var seeds1 = seeds.b;
						var _n1 = A2(elm_community$graph$Graph$get, next, graph);
						if (_n1.$ === 1) {
							var $temp$seeds = seeds1,
								$temp$acc = acc,
								$temp$graph = graph;
							seeds = $temp$seeds;
							acc = $temp$acc;
							graph = $temp$graph;
							continue go;
						} else {
							var ctx = _n1.a;
							var _n2 = A2(visitNode, ctx, acc);
							var accAfterDiscovery = _n2.a;
							var finishNode = _n2.b;
							var _n3 = A3(
								go,
								selectNeighbors(ctx),
								accAfterDiscovery,
								A2(elm_community$graph$Graph$remove, next, graph));
							var accBeforeFinish = _n3.a;
							var graph1 = _n3.b;
							var accAfterFinish = finishNode(accBeforeFinish);
							var $temp$seeds = seeds1,
								$temp$acc = accAfterFinish,
								$temp$graph = graph1;
							seeds = $temp$seeds;
							acc = $temp$acc;
							graph = $temp$graph;
							continue go;
						}
					}
				}
			});
		return A3(go, startingSeeds, startingAcc, startingGraph);
	});
var author$project$Game$ProductionGraph$parentCoefficients = function (g) {
	var visitor = F2(
		function (nc, acc0) {
			return _Utils_Tuple2(
				_Utils_update(
					acc0,
					{
						bd: A3(
							elm$core$Dict$update,
							author$project$GameData$Unit$name(nc.K.bn),
							A2(
								elm$core$Basics$composeR,
								elm$core$Maybe$withDefault(_List_Nil),
								A2(
									elm$core$Basics$composeR,
									elm$core$Basics$append(
										A2(
											elm$core$List$map,
											elm$core$Tuple$mapFirst(
												A2(
													elm$core$Basics$composeR,
													function ($) {
														return $.K;
													},
													function ($) {
														return $.bn;
													})),
											A2(author$project$Game$ProductionGraph$paths, nc, acc0.aA))),
									elm$core$Maybe$Just)),
							acc0.bd),
						aA: A2(elm$core$List$cons, nc, acc0.aA)
					}),
				function (acc1) {
					return _Utils_update(
						acc1,
						{
							aA: A2(elm$core$List$drop, 1, acc1.aA)
						});
				});
		});
	return A3(
		elm$core$List$foldl,
		F2(
			function (root, accum) {
				return A5(
					elm_community$graph$Graph$guidedDfs,
					elm_community$graph$Graph$alongOutgoingEdges,
					visitor,
					_List_fromArray(
						[root]),
					accum,
					g).a;
			}),
		A2(author$project$Game$ProductionGraph$ParentAccum, _List_Nil, elm$core$Dict$empty),
		author$project$Game$ProductionGraph$roots(g)).bd;
};
var elm_community$graph$Graph$alongIncomingEdges = function (ctx) {
	return elm_community$intdict$IntDict$keys(ctx.dr);
};
var elm_community$graph$Graph$empty = elm_community$intdict$IntDict$empty;
var elm_community$graph$Graph$insert = F2(
	function (nodeContext, graph) {
		return A3(
			elm_community$graph$Graph$update,
			nodeContext.K.eL,
			elm$core$Basics$always(
				elm$core$Maybe$Just(nodeContext)),
			graph);
	});
var elm_community$graph$Graph$inducedSubgraph = F2(
	function (nodeIds_, graph) {
		var insertContextById = F2(
			function (nodeId, acc) {
				var _n0 = A2(elm_community$graph$Graph$get, nodeId, graph);
				if (!_n0.$) {
					var ctx = _n0.a;
					return A2(elm_community$graph$Graph$insert, ctx, acc);
				} else {
					return acc;
				}
			});
		return A3(elm$core$List$foldl, insertContextById, elm_community$graph$Graph$empty, nodeIds_);
	});
var elm_community$graph$Graph$nodeIds = A2(elm$core$Basics$composeR, elm_community$graph$Graph$unGraph, elm_community$intdict$IntDict$keys);
var author$project$Game$ProductionGraph$prune = F2(
	function (counts, g) {
		var visitor = F2(
			function (nodeCtx, preserved0) {
				return (A2(elm$core$Set$member, nodeCtx.K.eL, preserved0) || A2(
					elm$core$Dict$member,
					author$project$GameData$Unit$name(nodeCtx.K.bn),
					counts)) ? _Utils_Tuple2(
					A2(
						elm$core$Set$union,
						elm$core$Set$fromList(
							elm_community$intdict$IntDict$keys(nodeCtx.cp)),
						A2(elm$core$Set$insert, nodeCtx.K.eL, preserved0)),
					elm$core$Basics$identity) : _Utils_Tuple2(
					preserved0,
					function (preserved) {
						return A2(
							elm$core$List$any,
							function (k) {
								return A2(elm$core$Set$member, k, preserved);
							},
							elm_community$intdict$IntDict$keys(nodeCtx.dr)) ? A2(
							elm$core$Set$union,
							elm$core$Set$fromList(
								elm_community$intdict$IntDict$keys(nodeCtx.cp)),
							A2(elm$core$Set$insert, nodeCtx.K.eL, preserved)) : preserved;
					});
			});
		var preservedNodes = elm$core$Set$toList(
			A5(
				elm_community$graph$Graph$guidedDfs,
				elm_community$graph$Graph$alongIncomingEdges,
				visitor,
				elm$core$List$reverse(
					elm_community$graph$Graph$nodeIds(g)),
				elm$core$Set$empty,
				g).a);
		return A2(elm_community$graph$Graph$inducedSubgraph, preservedNodes, g);
	});
var elm$core$Array$bitMask = 4294967295 >>> (32 - elm$core$Array$shiftStep);
var elm$core$Elm$JsArray$unsafeGet = _JsArray_unsafeGet;
var elm$core$Array$getHelp = F3(
	function (shift, index, tree) {
		getHelp:
		while (true) {
			var pos = elm$core$Array$bitMask & (index >>> shift);
			var _n0 = A2(elm$core$Elm$JsArray$unsafeGet, pos, tree);
			if (!_n0.$) {
				var subTree = _n0.a;
				var $temp$shift = shift - elm$core$Array$shiftStep,
					$temp$index = index,
					$temp$tree = subTree;
				shift = $temp$shift;
				index = $temp$index;
				tree = $temp$tree;
				continue getHelp;
			} else {
				var values = _n0.a;
				return A2(elm$core$Elm$JsArray$unsafeGet, elm$core$Array$bitMask & index, values);
			}
		}
	});
var elm$core$Bitwise$shiftLeftBy = _Bitwise_shiftLeftBy;
var elm$core$Array$tailIndex = function (len) {
	return (len >>> 5) << 5;
};
var elm$core$Array$get = F2(
	function (index, _n0) {
		var len = _n0.a;
		var startShift = _n0.b;
		var tree = _n0.c;
		var tail = _n0.d;
		return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? elm$core$Maybe$Nothing : ((_Utils_cmp(
			index,
			elm$core$Array$tailIndex(len)) > -1) ? elm$core$Maybe$Just(
			A2(elm$core$Elm$JsArray$unsafeGet, elm$core$Array$bitMask & index, tail)) : elm$core$Maybe$Just(
			A3(elm$core$Array$getHelp, startShift, index, tree)));
	});
var elm$core$Array$repeat = F2(
	function (n, e) {
		return A2(
			elm$core$Array$initialize,
			n,
			function (_n0) {
				return e;
			});
	});
var elm$core$Elm$JsArray$unsafeSet = _JsArray_unsafeSet;
var elm$core$Array$setHelp = F4(
	function (shift, index, value, tree) {
		var pos = elm$core$Array$bitMask & (index >>> shift);
		var _n0 = A2(elm$core$Elm$JsArray$unsafeGet, pos, tree);
		if (!_n0.$) {
			var subTree = _n0.a;
			var newSub = A4(elm$core$Array$setHelp, shift - elm$core$Array$shiftStep, index, value, subTree);
			return A3(
				elm$core$Elm$JsArray$unsafeSet,
				pos,
				elm$core$Array$SubTree(newSub),
				tree);
		} else {
			var values = _n0.a;
			var newLeaf = A3(elm$core$Elm$JsArray$unsafeSet, elm$core$Array$bitMask & index, value, values);
			return A3(
				elm$core$Elm$JsArray$unsafeSet,
				pos,
				elm$core$Array$Leaf(newLeaf),
				tree);
		}
	});
var elm$core$Array$set = F3(
	function (index, value, array) {
		var len = array.a;
		var startShift = array.b;
		var tree = array.c;
		var tail = array.d;
		return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? array : ((_Utils_cmp(
			index,
			elm$core$Array$tailIndex(len)) > -1) ? A4(
			elm$core$Array$Array_elm_builtin,
			len,
			startShift,
			tree,
			A3(elm$core$Elm$JsArray$unsafeSet, elm$core$Array$bitMask & index, value, tail)) : A4(
			elm$core$Array$Array_elm_builtin,
			len,
			startShift,
			A4(elm$core$Array$setHelp, startShift, index, value, tree),
			tail));
	});
var elm$core$List$maximum = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return elm$core$Maybe$Just(
			A3(elm$core$List$foldl, elm$core$Basics$max, x, xs));
	} else {
		return elm$core$Maybe$Nothing;
	}
};
var author$project$Game$ProductionGraph$polynomials = F2(
	function (counts, g0) {
		var getCount = function (unitName) {
			return A2(
				elm$core$Maybe$withDefault,
				author$project$Decimal$zero,
				A2(elm$core$Dict$get, unitName, counts));
		};
		var toDegreeAndCoeff = function (_n1) {
			var unit = _n1.a;
			var ks = _n1.b;
			var numerator = A3(
				elm$core$List$foldl,
				author$project$Decimal$mul,
				author$project$Decimal$one,
				A2(
					elm$core$List$cons,
					getCount(
						author$project$GameData$Unit$name(unit)),
					ks));
			var degree = elm$core$List$length(ks);
			return _Utils_Tuple2(
				degree,
				A2(
					author$project$Decimal$flipDivFloat,
					author$project$Game$ProductionGraph$fact(degree),
					numerator));
		};
		var toPoly = F2(
			function (unit, ks) {
				var fold = F2(
					function (_n0, accum) {
						var degree = _n0.a;
						var coeff = _n0.b;
						return A3(
							elm$core$Array$set,
							degree,
							A2(
								author$project$Decimal$add,
								A2(
									elm$core$Maybe$withDefault,
									author$project$Decimal$zero,
									A2(elm$core$Array$get, degree, accum)),
								coeff),
							accum);
					});
				var degreeCoeffs = A2(
					elm$core$List$cons,
					_Utils_Tuple2(
						0,
						getCount(unit)),
					A2(elm$core$List$map, toDegreeAndCoeff, ks));
				var maxDegree = A2(
					elm$core$Maybe$withDefault,
					0,
					elm$core$List$maximum(
						A2(elm$core$List$map, elm$core$Tuple$first, degreeCoeffs)));
				return elm$core$Array$toList(
					A3(
						elm$core$List$foldl,
						fold,
						A2(elm$core$Array$repeat, maxDegree + 1, author$project$Decimal$zero),
						degreeCoeffs));
			});
		var g = A2(author$project$Game$ProductionGraph$prune, counts, g0);
		return A2(
			elm$core$Dict$map,
			toPoly,
			author$project$Game$ProductionGraph$parentCoefficients(g));
	});
var author$project$Game$buildPolynomials = function (units_) {
	return author$project$Game$ProductionGraph$polynomials(
		author$project$Game$UnitsSnapshot$toDict(units_));
};
var author$project$Game$rebuildGraph = function (game) {
	var g = game;
	var graph_ = author$project$Game$buildGraph(game);
	var poly = A2(author$project$Game$buildPolynomials, g.k, graph_);
	var game1 = _Utils_update(
		g,
		{aT: graph_, aB: poly});
	var g1 = game1;
	return _Utils_eq(
		author$project$Game$UnitsSnapshot$velocities(g.k),
		elm$core$Dict$empty) ? _Utils_update(
		g1,
		{
			k: A2(
				author$project$Game$evalUnits,
				author$project$Game$UnitsSnapshot$at(g.k),
				game1)
		}) : game1;
};
var author$project$Game$updateUnits = F2(
	function (units_, _n0) {
		var g = _n0;
		return author$project$Game$rebuildGraph(
			_Utils_update(
				g,
				{k: units_}));
	});
var author$project$Game$snapshotUnits = F2(
	function (now, game) {
		return A2(
			author$project$Game$updateUnits,
			A2(author$project$Game$evalUnits, now, game),
			game);
	});
var author$project$GameData$achievements = A2(
	elm$core$Basics$composeR,
	author$project$GameData$lists,
	function ($) {
		return $.aQ;
	});
var elm$core$List$sum = function (numbers) {
	return A3(elm$core$List$foldl, elm$core$Basics$add, 0, numbers);
};
var author$project$Game$Achievement$points = F2(
	function (gameData, dates) {
		var val = elm$core$List$sum(
			A2(
				elm$core$List$map,
				function ($) {
					return $.cs;
				},
				A2(
					elm$core$List$filter,
					function (a) {
						return A2(
							elm$core$Dict$member,
							author$project$GameData$Achievement$name(a),
							dates);
					},
					author$project$GameData$achievements(gameData))));
		var max = elm$core$List$sum(
			A2(
				elm$core$List$map,
				function ($) {
					return $.cs;
				},
				author$project$GameData$achievements(gameData)));
		return {dw: max, dC: val / max, d6: val};
	});
var author$project$Game$Achievement$Earned = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var author$project$Game$Achievement$Hidden = {$: 3};
var author$project$Game$Achievement$Masked = {$: 2};
var author$project$Game$Achievement$Visible = function (a) {
	return {$: 1, a: a};
};
var author$project$Game$Achievement$getVar = F2(
	function (game, name) {
		return A2(
			elm_community$maybe_extra$Maybe$Extra$orElse,
			A2(elm$core$Dict$get, name, game.o),
			A2(
				elm$core$Maybe$map,
				function ($) {
					return $.fU;
				},
				A2(elm$core$Dict$get, name, game.L.em)));
	});
var author$project$Game$Achievement$eval = function (game) {
	return A2(
		author$project$Parser$Visibility$evalWithDefault,
		author$project$Decimal$zero,
		author$project$Game$Achievement$getVar(game));
};
var author$project$Parser$Visibility$Progress = F4(
	function (name, percent, val, max) {
		return {dw: max, br: name, dC: percent, d6: val};
	});
var elm$core$Basics$clamp = F3(
	function (low, high, number) {
		return (_Utils_cmp(number, low) < 0) ? low : ((_Utils_cmp(number, high) > 0) ? high : number);
	});
var author$project$Parser$Visibility$progress = F2(
	function (getVar, rule) {
		var loop = F2(
			function (expr, ret) {
				switch (expr.$) {
					case 2:
						return ret;
					case 1:
						if ((!expr.a.$) && (expr.b === 1)) {
							var name = expr.a.a;
							var _n1 = expr.b;
							var right = expr.c;
							var val = A2(
								elm$core$Maybe$withDefault,
								author$project$Decimal$zero,
								getVar(name));
							var pct = A3(
								elm$core$Basics$clamp,
								0,
								1,
								author$project$Decimal$toFloat(
									A2(author$project$Decimal$div, val, right)));
							return A2(
								elm$core$List$cons,
								A4(author$project$Parser$Visibility$Progress, name, pct, val, right),
								ret);
						} else {
							return ret;
						}
					default:
						var exprs = expr.b;
						return A3(elm$core$List$foldl, loop, ret, exprs);
				}
			});
		return A2(loop, rule, _List_Nil);
	});
var author$project$Game$Achievement$progress = F2(
	function (game, achievement) {
		var _n0 = achievement.fT;
		if (!_n0.$) {
			var expr = _n0.a;
			return A2(
				author$project$Parser$Visibility$progress,
				author$project$Game$Achievement$getVar(game),
				expr);
		} else {
			return _List_Nil;
		}
	});
var author$project$Game$Achievement$status = F3(
	function (game, dates, achievement) {
		var _n0 = A2(
			elm$core$Dict$get,
			author$project$GameData$Achievement$name(achievement),
			dates);
		if (!_n0.$) {
			var date = _n0.a;
			return A2(
				author$project$Game$Achievement$Earned,
				date,
				A2(author$project$Game$Achievement$progress, game, achievement));
		} else {
			return A2(author$project$Game$Achievement$eval, game, achievement.f$) ? author$project$Game$Achievement$Visible(
				A2(author$project$Game$Achievement$progress, game, achievement)) : ((achievement.cs > 0) ? author$project$Game$Achievement$Masked : author$project$Game$Achievement$Hidden);
		}
	});
var author$project$Game$Achievement$statuses = F2(
	function (game, dates) {
		return A2(
			elm$core$List$map,
			function (a) {
				return _Utils_Tuple2(
					a,
					A3(author$project$Game$Achievement$status, game, dates, a));
			},
			author$project$GameData$achievements(game.D));
	});
var author$project$Game$Achievement$grantList = F3(
	function (_new, now, model) {
		if (!_new.b) {
			return model;
		} else {
			var first = _new.a;
			var rest = _new.b;
			var achievements = A2(
				elm$core$Dict$union,
				model.aQ,
				elm$core$Dict$fromList(
					A2(
						elm$core$List$map,
						function (a) {
							return _Utils_Tuple2(
								author$project$GameData$Achievement$name(a),
								now);
						},
						_new)));
			return _Utils_update(
				model,
				{
					aO: A2(author$project$Game$Achievement$points, model.D, achievements),
					aP: A2(author$project$Game$Achievement$statuses, model, achievements),
					aQ: achievements,
					A: function () {
						var _n1 = model.A;
						if (_n1.$ === 1) {
							return elm$core$Maybe$Just(
								_Utils_Tuple3(now, first, rest));
						} else {
							var _n2 = _n1.a;
							var time = _n2.a;
							var first0 = _n2.b;
							var rest0 = _n2.c;
							return elm$core$Maybe$Just(
								_Utils_Tuple3(
									time,
									first0,
									_Utils_ap(rest0, _new)));
						}
					}()
				});
		}
	});
var author$project$GameData$achievementByName = function (name) {
	return A2(
		elm$core$Basics$composeR,
		author$project$GameData$indexes,
		A2(
			elm$core$Basics$composeR,
			function ($) {
				return $.bL;
			},
			elm$core$Dict$get(name)));
};
var author$project$Game$Achievement$grant = F3(
	function (name, now, model) {
		var _n0 = A2(author$project$GameData$achievementByName, name, model.D);
		if (_n0.$ === 1) {
			return elm$core$Maybe$Nothing;
		} else {
			var achievement = _n0.a;
			return A2(elm$core$Dict$member, name, model.aQ) ? elm$core$Maybe$Just(model) : elm$core$Maybe$Just(
				A3(
					author$project$Game$Achievement$grantList,
					_List_fromArray(
						[achievement]),
					now,
					model));
		}
	});
var author$project$Game$grantAchievement = F2(
	function (name, now) {
		return A2(
			elm$core$Basics$composeR,
			author$project$Game$snapshotUnits(now),
			A2(
				elm$core$Basics$composeR,
				author$project$Game$unwrap,
				A2(
					elm$core$Basics$composeR,
					A2(author$project$Game$Achievement$grant, name, now),
					elm$core$Maybe$map(elm$core$Basics$identity))));
	});
var author$project$Session$unwrap = function (_n0) {
	var s = _n0;
	return s;
};
var krisajenkins$remotedata$RemoteData$Failure = function (a) {
	return {$: 2, a: a};
};
var krisajenkins$remotedata$RemoteData$Loading = {$: 1};
var krisajenkins$remotedata$RemoteData$NotAsked = {$: 0};
var krisajenkins$remotedata$RemoteData$Success = function (a) {
	return {$: 3, a: a};
};
var author$project$Session$GameLoader$toRemote = function (loader) {
	_n0$1:
	while (true) {
		if (loader.$ === 1) {
			var game = loader.a.ae;
			return krisajenkins$remotedata$RemoteData$Success(game);
		} else {
			switch (loader.b.$) {
				case 2:
					if (loader.a.$ === 1) {
						break _n0$1;
					} else {
						var err = loader.b.a;
						return krisajenkins$remotedata$RemoteData$Failure(err);
					}
				case 3:
					if (loader.a.$ === 1) {
						break _n0$1;
					} else {
						var val = loader.b.a;
						return krisajenkins$remotedata$RemoteData$Loading;
					}
				case 0:
					if (loader.a.$ === 1) {
						break _n0$1;
					} else {
						var _n1 = loader.b;
						return krisajenkins$remotedata$RemoteData$NotAsked;
					}
				default:
					if (loader.a.$ === 1) {
						break _n0$1;
					} else {
						var _n2 = loader.b;
						return krisajenkins$remotedata$RemoteData$Loading;
					}
			}
		}
	}
	var err = loader.a.a;
	return krisajenkins$remotedata$RemoteData$Failure(err);
};
var author$project$Session$game = A2(
	elm$core$Basics$composeR,
	author$project$Session$unwrap,
	A2(
		elm$core$Basics$composeR,
		function ($) {
			return $.ae;
		},
		author$project$Session$GameLoader$toRemote));
var author$project$Game$achievementsSortOrderToString = function (s) {
	if (!s) {
		return 'default';
	} else {
		return 'default';
	}
};
var elm$json$Json$Encode$bool = _Json_wrap;
var elm$json$Json$Encode$object = function (pairs) {
	return _Json_wrap(
		A3(
			elm$core$List$foldl,
			F2(
				function (_n0, obj) {
					var k = _n0.a;
					var v = _n0.b;
					return A3(_Json_addField, k, v, obj);
				}),
			_Json_emptyObject(0),
			pairs));
};
var elm$json$Json$Encode$string = _Json_wrap;
var author$project$Game$achievementsShownEncoder = function (a) {
	return elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'earned',
				elm$json$Json$Encode$bool(a.bU)),
				_Utils_Tuple2(
				'unearned',
				elm$json$Json$Encode$bool(a.cK)),
				_Utils_Tuple2(
				'masked',
				elm$json$Json$Encode$bool(a.ca)),
				_Utils_Tuple2(
				'order',
				elm$json$Json$Encode$string(
					author$project$Game$achievementsSortOrderToString(a.co))),
				_Utils_Tuple2(
				'reverse',
				elm$json$Json$Encode$bool(a.cw))
			]));
};
var author$project$Game$costUIToString = function (c) {
	if (!c) {
		return 'fancy';
	} else {
		return 'simple';
	}
};
var author$project$Game$velocityUIToString = function (c) {
	if (c === 1) {
		return 'fancy';
	} else {
		return 'hidden';
	}
};
var elm$json$Json$Encode$int = _Json_wrap;
var author$project$JsonUtil$posixEncoder = A2(elm$core$Basics$composeR, elm$time$Time$posixToMillis, elm$json$Json$Encode$int);
var elm$json$Json$Encode$dict = F3(
	function (toKey, toValue, dictionary) {
		return _Json_wrap(
			A3(
				elm$core$Dict$foldl,
				F3(
					function (key, value, obj) {
						return A3(
							_Json_addField,
							toKey(key),
							toValue(value),
							obj);
					}),
				_Json_emptyObject(0),
				dictionary));
	});
var author$project$Game$Achievement$encoder = A2(elm$json$Json$Encode$dict, elm$core$Basics$identity, author$project$JsonUtil$posixEncoder);
var author$project$Game$BuyN$encoder = function (_n0) {
	var dict = _n0;
	return A3(elm$json$Json$Encode$dict, elm$core$Basics$identity, elm$json$Json$Encode$string, dict);
};
var elm$json$Json$Encode$list = F2(
	function (func, entries) {
		return _Json_wrap(
			A3(
				elm$core$List$foldl,
				_Json_addEntry(func),
				_Json_emptyArray(0),
				entries));
	});
var author$project$Game$MtxHistory$setEncoder = A2(
	elm$core$Basics$composeR,
	elm$core$Set$toList,
	elm$json$Json$Encode$list(elm$json$Json$Encode$string));
var author$project$Game$MtxHistory$encoder = function (hist) {
	return elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'playfab',
				author$project$Game$MtxHistory$setEncoder(hist.al)),
				_Utils_Tuple2(
				'kongregate',
				author$project$Game$MtxHistory$setEncoder(hist.aU))
			]));
};
var author$project$Game$NumberFormat$toString = function (format) {
	switch (format) {
		case 0:
			return 'standard-decimal';
		case 1:
			return 'scientific-e';
		case 2:
			return 'engineering';
		case 3:
			return 'longScale';
		default:
			return 'alphabetic';
	}
};
var author$project$Game$NumberFormat$encoder = A2(elm$core$Basics$composeR, author$project$Game$NumberFormat$toString, elm$json$Json$Encode$string);
var author$project$Decimal$infiniteInt = elm$core$Basics$floor(1 / 0);
var elm$core$Basics$isNaN = _Basics_isNaN;
var elm$core$String$fromFloat = _String_fromNumber;
var author$project$Decimal$toString = function (d) {
	var sig = d.i;
	var exp = d.j;
	return ((elm$core$Basics$abs(exp) < 21) || (_Utils_eq(exp, author$project$Decimal$infiniteInt) || (elm$core$Basics$isInfinite(sig) || elm$core$Basics$isNaN(sig)))) ? elm$core$String$fromFloat(
		author$project$Decimal$toFloat(d)) : (elm$core$String$fromFloat(sig) + ('e' + elm$core$String$fromInt(exp)));
};
var author$project$JsonUtil$decimalEncoder = A2(elm$core$Basics$composeR, author$project$Decimal$toString, elm$json$Json$Encode$string);
var author$project$Game$Statistics$entryEncoder = function (item) {
	return elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'clicks',
				elm$json$Json$Encode$int(item.C)),
				_Utils_Tuple2(
				'num',
				author$project$JsonUtil$decimalEncoder(item.aY)),
				_Utils_Tuple2(
				'twinnum',
				author$project$JsonUtil$decimalEncoder(item.fU)),
				_Utils_Tuple2(
				'elapsedFirst',
				elm$json$Json$Encode$int(
					author$project$Duration$toMillis(item.bV)))
			]));
};
var author$project$Game$Statistics$encoder = function (stats) {
	return elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'clicks',
				elm$json$Json$Encode$int(stats.C)),
				_Utils_Tuple2(
				'byUnit',
				A3(elm$json$Json$Encode$dict, elm$core$Basics$identity, author$project$Game$Statistics$entryEncoder, stats.em)),
				_Utils_Tuple2(
				'byUpgrade',
				A3(elm$json$Json$Encode$dict, elm$core$Basics$identity, author$project$Game$Statistics$entryEncoder, stats.Z))
			]));
};
var author$project$Game$Theme$toString = function (theme) {
	switch (theme) {
		case 0:
			return 'default';
		case 1:
			return 'cerulean';
		case 2:
			return 'cosmo';
		case 3:
			return 'cyborg';
		case 4:
			return 'darkly';
		case 5:
			return 'flatly';
		case 6:
			return 'journal';
		case 7:
			return 'litera';
		case 8:
			return 'lumen';
		case 9:
			return 'lux';
		case 10:
			return 'materia';
		case 11:
			return 'minty';
		case 12:
			return 'pulse';
		case 13:
			return 'sandstone';
		case 14:
			return 'simplex';
		case 15:
			return 'sketchy';
		case 16:
			return 'slate';
		case 17:
			return 'solar';
		case 18:
			return 'spacelab';
		case 19:
			return 'superhero';
		case 20:
			return 'united';
		default:
			return 'yeti';
	}
};
var author$project$Game$Theme$encoder = A2(elm$core$Basics$composeR, author$project$Game$Theme$toString, elm$json$Json$Encode$string);
var author$project$Game$VelocityUnit$toString = function (format) {
	switch (format) {
		case 0:
			return 'sec';
		case 1:
			return 'min';
		case 2:
			return 'hr';
		case 3:
			return 'day';
		default:
			return 'warp';
	}
};
var author$project$Game$VelocityUnit$encoder = A2(elm$core$Basics$composeR, author$project$Game$VelocityUnit$toString, elm$json$Json$Encode$string);
var author$project$Game$Watched$toInt = function (w) {
	switch (w) {
		case 0:
			return -1;
		case 1:
			return 0;
		case 2:
			return 1;
		case 3:
			return 2;
		default:
			return 4;
	}
};
var author$project$Game$Watched$encoder = A2(elm$core$Basics$composeR, author$project$Game$Watched$toInt, elm$json$Json$Encode$int);
var author$project$Locale$toString = function (loc) {
	switch (loc) {
		case 0:
			return 'En_US';
		case 1:
			return 'En_Reverse';
		default:
			return 'En_UpsideDown';
	}
};
var author$project$Locale$encoder = A2(elm$core$Basics$composeR, author$project$Locale$toString, elm$json$Json$Encode$string);
var elm$json$Json$Encode$null = _Json_encodeNull;
var elm_community$maybe_extra$Maybe$Extra$unwrap = F3(
	function (d, f, m) {
		if (m.$ === 1) {
			return d;
		} else {
			var a = m.a;
			return f(a);
		}
	});
var author$project$Game$encoder = F2(
	function (now, _n0) {
		var g = _n0;
		return elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'persistVersion',
					elm$json$Json$Encode$int(1)),
					_Utils_Tuple2(
					'created',
					author$project$JsonUtil$posixEncoder(g.H)),
					_Utils_Tuple2(
					'snapshotted',
					author$project$JsonUtil$posixEncoder(
						author$project$Game$UnitsSnapshot$at(g.k))),
					_Utils_Tuple2(
					'encoded',
					author$project$JsonUtil$posixEncoder(now)),
					_Utils_Tuple2(
					'units',
					A3(
						elm$json$Json$Encode$dict,
						elm$core$Basics$identity,
						author$project$JsonUtil$decimalEncoder,
						author$project$Game$UnitsSnapshot$toDict(g.k))),
					_Utils_Tuple2(
					'upgrades',
					A3(elm$json$Json$Encode$dict, elm$core$Basics$identity, author$project$JsonUtil$decimalEncoder, g.o)),
					_Utils_Tuple2(
					'spells',
					A3(elm$json$Json$Encode$dict, elm$core$Basics$identity, author$project$JsonUtil$decimalEncoder, g.s)),
					_Utils_Tuple2(
					'locale',
					A3(elm_community$maybe_extra$Maybe$Extra$unwrap, elm$json$Json$Encode$null, author$project$Locale$encoder, g.av)),
					_Utils_Tuple2(
					'theme',
					author$project$Game$Theme$encoder(g.aG)),
					_Utils_Tuple2(
					'numberFormat',
					author$project$Game$NumberFormat$encoder(g.ay)),
					_Utils_Tuple2(
					'velocityUnit',
					author$project$Game$VelocityUnit$encoder(g.aL)),
					_Utils_Tuple2(
					'buyN',
					author$project$Game$BuyN$encoder(g.P)),
					_Utils_Tuple2(
					'watched',
					A3(elm$json$Json$Encode$dict, elm$core$Basics$identity, author$project$Game$Watched$encoder, g.an)),
					_Utils_Tuple2(
					'lastUnitByTab',
					A3(elm$json$Json$Encode$dict, elm$core$Basics$identity, elm$json$Json$Encode$string, g.S)),
					_Utils_Tuple2(
					'randomSeeds',
					A3(elm$json$Json$Encode$dict, elm$core$Basics$identity, elm$json$Json$Encode$int, g.W)),
					_Utils_Tuple2(
					'cooldown',
					A3(elm$json$Json$Encode$dict, elm$core$Basics$identity, author$project$JsonUtil$posixEncoder, g._)),
					_Utils_Tuple2(
					'statistics',
					author$project$Game$Statistics$encoder(g.L)),
					_Utils_Tuple2(
					'achievements',
					author$project$Game$Achievement$encoder(g.aQ)),
					_Utils_Tuple2(
					'costUI',
					elm$json$Json$Encode$string(
						author$project$Game$costUIToString(g.aq))),
					_Utils_Tuple2(
					'velocityUI',
					elm$json$Json$Encode$string(
						author$project$Game$velocityUIToString(g.aK))),
					_Utils_Tuple2(
					'achievementsShown',
					author$project$Game$achievementsShownEncoder(g.Y)),
					_Utils_Tuple2(
					'mtxHistory',
					author$project$Game$MtxHistory$encoder(g.U))
				]));
	});
var author$project$Ports$persistWrite = _Platform_outgoingPort('persistWrite', elm$core$Basics$identity);
var author$project$Game$persistWrite = F2(
	function (now, game) {
		return _Utils_Tuple2(
			game,
			author$project$Ports$persistWrite(
				A2(author$project$Game$encoder, now, game)));
	});
var author$project$Game$statistics = A2(
	elm$core$Basics$composeR,
	author$project$Game$unwrap,
	function ($) {
		return $.L;
	});
var author$project$Duration$toMinutes = function (f) {
	return author$project$Duration$toMillis(f) / author$project$Duration$units.aX;
};
var author$project$Kongregate$Stats$elapsedFirstMinutes = F2(
	function (name, dict) {
		return A2(
			elm$core$Maybe$map,
			A2(
				elm$core$Basics$composeR,
				function ($) {
					return $.bV;
				},
				A2(elm$core$Basics$composeR, author$project$Duration$toMinutes, elm$core$Basics$ceiling)),
			A2(elm$core$Dict$get, name, dict));
	});
var elm$core$Basics$min = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) < 0) ? x : y;
	});
var elm$core$Basics$round = _Basics_round;
var author$project$Kongregate$Stats$collect = F2(
	function (game, units) {
		return {
			aO: author$project$Game$achievementPoints(game).d6,
			bX: elm$core$Basics$round(
				author$project$Decimal$toFloat(
					A2(author$project$Game$upgradeCountName, 'expansion', game))),
			b_: elm$core$Basics$round(
				author$project$Decimal$toFloat(
					A2(author$project$Game$UnitsSnapshot$countName, 'ascension', units))),
			b$: elm$core$Basics$round(
				author$project$Decimal$toFloat(
					A2(author$project$Game$UnitsSnapshot$countName, 'hatchery', units))),
			cd: A2(
				author$project$Kongregate$Stats$elapsedFirstMinutes,
				'nexus5',
				author$project$Game$statistics(game).Z),
			ce: A2(
				author$project$Kongregate$Stats$elapsedFirstMinutes,
				'ascension',
				author$project$Game$statistics(game).em),
			cf: A2(
				author$project$Kongregate$Stats$elapsedFirstMinutes,
				'nexus1',
				author$project$Game$statistics(game).Z),
			ck: elm$core$List$sum(
				A2(
					elm$core$List$map,
					function (n) {
						return A2(
							elm$core$Basics$min,
							1,
							elm$core$Basics$round(
								author$project$Decimal$toFloat(
									A2(author$project$Game$upgradeCountName, n, game))));
					},
					_List_fromArray(
						['mutatehatchery', 'mutatebat', 'mutateclone', 'mutateswarmwarp', 'mutaterush', 'mutateeach', 'mutatefreq', 'mutatenexus', 'mutatearmy', 'mutatemeat'])))
		};
	});
var author$project$Kongregate$Stats$encoder = function (s) {
	return elm$json$Json$Encode$object(
		_Utils_ap(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'Hatcheries',
					elm$json$Json$Encode$int(s.b$)),
					_Utils_Tuple2(
					'Expansions',
					elm$json$Json$Encode$int(s.bX)),
					_Utils_Tuple2(
					'GameComplete',
					elm$json$Json$Encode$int(s.b_)),
					_Utils_Tuple2(
					'Mutations Unlocked',
					elm$json$Json$Encode$int(s.ck)),
					_Utils_Tuple2(
					'Achievement Points',
					elm$json$Json$Encode$int(s.aO))
				]),
			A2(
				elm$core$List$filterMap,
				function (_n0) {
					var key = _n0.a;
					var val = _n0.b;
					return A2(
						elm$core$Maybe$map,
						function (v) {
							return _Utils_Tuple2(
								key,
								elm$json$Json$Encode$int(v));
						},
						val);
				},
				_List_fromArray(
					[
						_Utils_Tuple2('Minutes to First Nexus', s.cf),
						_Utils_Tuple2('Minutes to Fifth Nexus', s.cd),
						_Utils_Tuple2('Minutes to First Ascension', s.ce)
					]))));
};
var author$project$Ports$Kongregate$kongregateSubmitStats = _Platform_outgoingPort('kongregateSubmitStats', elm$core$Basics$identity);
var author$project$Game$snapshotted = A2(elm$core$Basics$composeR, author$project$Game$units, author$project$Game$UnitsSnapshot$at);
var author$project$Session$now = A2(
	elm$core$Basics$composeR,
	author$project$Session$unwrap,
	function ($) {
		return $.cm;
	});
var author$project$Session$safeNow = function (g) {
	return A2(
		elm$core$Basics$composeR,
		author$project$Session$now,
		elm$core$Maybe$withDefault(
			author$project$Game$snapshotted(g)));
};
var elm$core$Platform$Cmd$batch = _Platform_batch;
var author$project$Session$persistWrite = F2(
	function (session, game0) {
		var _n0 = A2(
			author$project$Game$persistWrite,
			A2(author$project$Session$safeNow, game0, session),
			game0);
		var game1 = _n0.a;
		var cmd = _n0.b;
		return _Utils_Tuple2(
			game1,
			elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						cmd,
						author$project$Ports$Kongregate$kongregateSubmitStats(
						author$project$Kongregate$Stats$encoder(
							A2(
								author$project$Kongregate$Stats$collect,
								game1,
								author$project$Game$units(game1))))
					])));
	});
var author$project$Session$Session = elm$core$Basics$identity;
var author$project$Session$pushError = F2(
	function (message, _n0) {
		var session = _n0;
		return _Utils_update(
			session,
			{
				ab: A2(
					elm$core$List$cons,
					_Utils_Tuple2(message, session.cm),
					session.ab)
			});
	});
var author$project$Session$clearUnits = function (session) {
	var s = session;
	return _Utils_update(
		s,
		{az: elm$core$Dict$empty, a8: elm$core$Maybe$Nothing});
};
var author$project$Decimal$mulFloat = F2(
	function (f, _n0) {
		var sig = _n0.i;
		var exp = _n0.j;
		return A2(author$project$Decimal$fromSigExp, sig * f, exp);
	});
var author$project$DecimalDict$subEpsilon = 0.999999;
var author$project$Game$Order$Progress$CostMet = function (a) {
	return {$: 0, a: a};
};
var author$project$Game$Order$Progress$CostNotMet = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var author$project$Game$Order$Progress$DurationStats = F3(
	function (from, now, total) {
		return {dj: from, cm: now, d2: total};
	});
var author$project$Game$polynomials = A2(
	elm$core$Basics$composeR,
	author$project$Game$unwrap,
	function ($) {
		return $.aB;
	});
var author$project$Decimal$flipSub = F2(
	function (a, b) {
		return A2(author$project$Decimal$sub, b, a);
	});
var author$project$Duration$sub = F2(
	function (_n0, _n1) {
		var a = _n0;
		var b = _n1;
		return a - b;
	});
var author$project$Game$Order$Progress$estimateDurationBisectStep = F4(
	function (tolerance, fn, stepsLeft, _n0) {
		var top = _n0.bF;
		var bottom = _n0.bc;
		var fnBottom = _n0.bk;
		if (stepsLeft <= 0) {
			return elm$core$Maybe$Nothing;
		} else {
			var mid = author$project$Duration$fromMillis(
				elm$core$Basics$floor(
					author$project$Duration$toMillis(
						A2(author$project$Duration$add, top, bottom)) / 2));
			var fnMid = fn(mid);
			var diff = author$project$Duration$fromMillis(
				elm$core$Basics$floor(
					author$project$Duration$toMillis(
						A2(author$project$Duration$sub, top, bottom)) / 2));
			return (_Utils_eq(fnMid, author$project$Decimal$zero) || (_Utils_cmp(
				author$project$Duration$toMillis(diff),
				author$project$Duration$toMillis(tolerance)) < 0)) ? elm$core$Maybe$Just(mid) : A4(
				author$project$Game$Order$Progress$estimateDurationBisectStep,
				tolerance,
				fn,
				stepsLeft - 1,
				_Utils_eq(
					A2(author$project$Decimal$compare, fnMid, author$project$Decimal$zero),
					A2(author$project$Decimal$compare, fnBottom, author$project$Decimal$zero)) ? {bc: mid, bk: fnMid, bF: top} : {bc: bottom, bk: fnBottom, bF: mid});
		}
	});
var author$project$Game$Order$Progress$estimateDurationBisect = F2(
	function (poly, u) {
		var cost = u.es;
		var velocity = u.cS;
		var fn = function (t) {
			return A2(
				author$project$Decimal$flipSub,
				cost,
				A2(author$project$Polynomial$evaluate, t, poly));
		};
		return A4(
			author$project$Game$Order$Progress$estimateDurationBisectStep,
			author$project$Duration$fromMillis(100),
			fn,
			50,
			{
				bc: author$project$Duration$zero,
				bk: fn(author$project$Duration$zero),
				bF: author$project$Duration$fromSecs(((((999 * 365) * 24) * 60) * 60) * 1000)
			});
	});
var author$project$Decimal$toFiniteFloat = function (d) {
	var f = author$project$Decimal$toFloat(d);
	return (elm$core$Basics$isInfinite(f) || elm$core$Basics$isNaN(f)) ? elm$core$Maybe$Nothing : elm$core$Maybe$Just(f);
};
var author$project$Game$Order$Progress$estimateDurationLinear = function (_n0) {
	var cost = _n0.es;
	var bank = _n0.bb;
	var velocity = _n0.cS;
	return A2(author$project$Decimal$gt, velocity, author$project$Decimal$zero) ? A2(
		elm$core$Maybe$map,
		author$project$Duration$fromSecs,
		author$project$Decimal$toFiniteFloat(
			A2(
				author$project$Decimal$div,
				A2(author$project$Decimal$sub, cost, bank),
				velocity))) : elm$core$Maybe$Nothing;
};
var author$project$Game$UnitsSnapshot$velocity = function (id) {
	return A2(
		elm$core$Basics$composeR,
		author$project$Game$UnitsSnapshot$velocities,
		A2(
			elm$core$Basics$composeR,
			elm$core$Dict$get(
				author$project$GameData$Unit$idToString(id)),
			elm$core$Maybe$withDefault(author$project$Decimal$zero)));
};
var author$project$Game$Order$Progress$estimateDuration = F5(
	function (game, units, currency, cost, bank) {
		var velocity = A2(author$project$Game$UnitsSnapshot$velocity, currency, units);
		var ns = {bb: bank, es: cost, cS: velocity};
		var _n0 = A2(
			elm$core$Dict$get,
			author$project$GameData$Unit$idToString(currency),
			author$project$Game$polynomials(game));
		if (_n0.$ === 1) {
			return author$project$Game$Order$Progress$estimateDurationLinear(ns);
		} else {
			var poly = _n0.a;
			return (elm$core$List$length(poly) <= 2) ? author$project$Game$Order$Progress$estimateDurationLinear(ns) : A2(author$project$Game$Order$Progress$estimateDurationBisect, poly, ns);
		}
	});
var author$project$GameData$Item$resToDec = function (res) {
	if (!res.$) {
		var n = res.a;
		return author$project$Decimal$fromFloat(n);
	} else {
		var d = res.a;
		return d;
	}
};
var author$project$Game$Order$Progress$update = F4(
	function (game, units, order, mprogress) {
		var progress2Line = function (_n3) {
			var currency = _n3.a;
			var cost = _n3.b;
			var progress0 = function (_n2) {
				return elm$core$List$head(
					A2(
						elm$core$List$filter,
						function (p) {
							return _Utils_eq(p.bS, currency);
						},
						A2(elm$core$Maybe$withDefault, _List_Nil, mprogress)));
			};
			var bank = A2(author$project$Game$UnitsSnapshot$count, currency, units);
			var status = function () {
				if (order.ds || A2(
					author$project$Decimal$gte,
					bank,
					A2(author$project$Decimal$mulFloat, author$project$DecimalDict$subEpsilon, cost))) {
					return author$project$Game$Order$Progress$CostMet(
						author$project$Decimal$toFloat(
							A2(author$project$Decimal$div, cost, bank)));
				} else {
					var dur = function () {
						var _n0 = A2(
							elm$core$Maybe$map,
							function ($) {
								return $.cE;
							},
							progress0(0));
						if (((!_n0.$) && (_n0.a.$ === 1)) && (!_n0.a.b.$)) {
							var _n1 = _n0.a;
							var d = _n1.b.a;
							return elm$core$Maybe$Just(
								_Utils_update(
									d,
									{
										cm: author$project$Game$UnitsSnapshot$at(units)
									}));
						} else {
							return A2(
								elm$core$Maybe$map,
								A2(
									author$project$Game$Order$Progress$DurationStats,
									author$project$Game$UnitsSnapshot$at(
										author$project$Game$units(game)),
									author$project$Game$UnitsSnapshot$at(units)),
								A5(author$project$Game$Order$Progress$estimateDuration, game, units, currency, cost, bank));
						}
					}();
					return A2(
						author$project$Game$Order$Progress$CostNotMet,
						author$project$Decimal$toFloat(
							A2(author$project$Decimal$div, bank, cost)),
						dur);
				}
			}();
			return {bb: bank, es: cost, bS: currency, cE: status};
		};
		var costs = A2(
			author$project$Decimal$gt,
			author$project$GameData$Item$resToDec(order.d4),
			author$project$Decimal$zero) ? order.es : order.c6;
		return A2(elm$core$List$map, progress2Line, costs);
	});
var author$project$Game$Order$Progress$updates = F4(
	function (game, snapshot, orders, dict) {
		return A3(
			elm$core$List$foldl,
			function (o) {
				return A2(
					elm$core$Dict$update,
					author$project$GameData$Item$name(o.eW),
					A2(
						elm$core$Basics$composeR,
						A3(author$project$Game$Order$Progress$update, game, snapshot, o),
						elm$core$Maybe$Just));
			},
			dict,
			orders);
	});
var author$project$Session$evalUnits = F2(
	function (orders, session) {
		var s = session;
		var _n0 = _Utils_Tuple2(
			s.cm,
			author$project$Session$GameLoader$toRemote(s.ae));
		if ((!_n0.a.$) && (_n0.b.$ === 3)) {
			var t = _n0.a.a;
			var game_ = _n0.b.a;
			var units_ = A2(author$project$Game$evalUnits, t, game_);
			return _Utils_update(
				s,
				{
					az: A4(author$project$Game$Order$Progress$updates, game_, units_, orders, s.az),
					a8: elm$core$Maybe$Just(units_)
				});
		} else {
			return author$project$Session$clearUnits(session);
		}
	});
var author$project$Game$created = A2(
	elm$core$Basics$composeR,
	author$project$Game$unwrap,
	function ($) {
		return $.H;
	});
var author$project$Game$encoded = A2(
	elm$core$Basics$composeR,
	author$project$Game$unwrap,
	function ($) {
		return $.bj;
	});
var author$project$Session$welcomeBackCooldown = author$project$Duration$fromSecs(5 * 60);
var author$project$Session$isWelcomeBackCooledDown = function (dur) {
	return _Utils_cmp(
		author$project$Duration$toMillis(dur),
		author$project$Duration$toMillis(author$project$Session$welcomeBackCooldown)) > -1;
};
var author$project$Session$tryWelcomeBack = F2(
	function (t, g) {
		return author$project$Session$isWelcomeBackCooledDown(
			author$project$Duration$since(t)) ? elm$core$Maybe$Just(
			{
				eb: A2(author$project$Game$evalUnits, t.eb, g),
				eh: A2(author$project$Game$evalUnits, t.eh, g)
			}) : elm$core$Maybe$Nothing;
	});
var author$project$Session$tryWelcomeBackFromGame = F2(
	function (newGame, session) {
		var s = session;
		return _Utils_update(
			s,
			{
				a9: function () {
					var _n0 = author$project$Session$game(session);
					if (_n0.$ === 3) {
						var oldGame = _n0.a;
						return _Utils_eq(
							author$project$Game$created(newGame),
							author$project$Game$created(oldGame)) ? elm$core$Maybe$Nothing : A2(
							author$project$Session$tryWelcomeBack,
							{
								eb: A2(author$project$Session$safeNow, newGame, session),
								eh: author$project$Game$encoded(newGame)
							},
							newGame);
					} else {
						return A2(
							author$project$Session$tryWelcomeBack,
							{
								eb: A2(author$project$Session$safeNow, newGame, session),
								eh: author$project$Game$encoded(newGame)
							},
							newGame);
					}
				}()
			});
	});
var author$project$Session$GameLoader$Ready = function (a) {
	return {$: 1, a: a};
};
var author$project$Session$GameLoader$set = F2(
	function (game, loader) {
		if (loader.$ === 1) {
			var g = loader.a;
			return author$project$Session$GameLoader$Ready(
				_Utils_update(
					g,
					{ae: game}));
		} else {
			return author$project$Session$GameLoader$Ready(
				{ae: game, fW: elm$core$Maybe$Nothing});
		}
	});
var author$project$Session$GameLoader$undoableSet = F3(
	function (now, game, loader) {
		if (loader.$ === 1) {
			var g = loader.a;
			return author$project$Session$GameLoader$Ready(
				{
					ae: game,
					fW: elm$core$Maybe$Just(
						_Utils_Tuple2(now, g.ae))
				});
		} else {
			return author$project$Session$GameLoader$Ready(
				{ae: game, fW: elm$core$Maybe$Nothing});
		}
	});
var krisajenkins$remotedata$RemoteData$map = F2(
	function (f, data) {
		switch (data.$) {
			case 3:
				var value = data.a;
				return krisajenkins$remotedata$RemoteData$Success(
					f(value));
			case 1:
				return krisajenkins$remotedata$RemoteData$Loading;
			case 0:
				return krisajenkins$remotedata$RemoteData$NotAsked;
			default:
				var error = data.a;
				return krisajenkins$remotedata$RemoteData$Failure(error);
		}
	});
var krisajenkins$remotedata$RemoteData$withDefault = F2(
	function (_default, data) {
		if (data.$ === 3) {
			var x = data.a;
			return x;
		} else {
			return _default;
		}
	});
var krisajenkins$remotedata$RemoteData$toMaybe = A2(
	elm$core$Basics$composeR,
	krisajenkins$remotedata$RemoteData$map(elm$core$Maybe$Just),
	krisajenkins$remotedata$RemoteData$withDefault(elm$core$Maybe$Nothing));
var author$project$Session$setGame = F3(
	function (undoable, game_, session0) {
		return A2(
			author$project$Session$evalUnits,
			_List_Nil,
			(_Utils_eq(
				A2(
					elm$core$Maybe$map,
					A2(elm$core$Basics$composeR, author$project$Game$units, author$project$Game$UnitsSnapshot$at),
					krisajenkins$remotedata$RemoteData$toMaybe(
						author$project$Session$game(session0))),
				elm$core$Maybe$Just(
					author$project$Game$UnitsSnapshot$at(
						author$project$Game$units(game_)))) ? elm$core$Basics$identity : author$project$Session$clearUnits)(
				function (session) {
					var s = session;
					return undoable ? _Utils_update(
						s,
						{
							ae: A3(
								author$project$Session$GameLoader$undoableSet,
								A2(author$project$Session$safeNow, game_, session),
								game_,
								s.ae)
						}) : _Utils_update(
						s,
						{
							ae: A2(author$project$Session$GameLoader$set, game_, s.ae)
						});
				}(
					A2(author$project$Session$tryWelcomeBackFromGame, game_, session0))));
	});
var elm$core$Platform$Cmd$none = elm$core$Platform$Cmd$batch(_List_Nil);
var author$project$Session$grantAchievement = F2(
	function (name, session) {
		var _n0 = author$project$Session$game(session);
		if (_n0.$ === 3) {
			var g0 = _n0.a;
			var _n1 = A2(
				elm$core$Maybe$map,
				author$project$Session$persistWrite(session),
				A3(
					author$project$Game$grantAchievement,
					name,
					A2(author$project$Session$safeNow, g0, session),
					g0));
			if (!_n1.$) {
				var _n2 = _n1.a;
				var g1 = _n2.a;
				var cmd1 = _n2.b;
				return _Utils_Tuple2(
					A3(author$project$Session$setGame, true, g1, session),
					cmd1);
			} else {
				return _Utils_Tuple2(
					A2(author$project$Session$pushError, 'no such achievement: ' + name, session),
					elm$core$Platform$Cmd$none);
			}
		} else {
			return _Utils_Tuple2(session, elm$core$Platform$Cmd$none);
		}
	});
var author$project$Page$Changelog$create = author$project$Session$grantAchievement('changelog');
var author$project$Page$Debug$Model = elm$core$Basics$identity;
var author$project$Page$Debug$init = function (session0) {
	var _n0 = A2(author$project$Session$grantAchievement, 'debug', session0);
	var session = _n0.a;
	var cmd = _n0.b;
	return _Utils_Tuple2(
		{R: krisajenkins$remotedata$RemoteData$NotAsked, aS: elm$core$Maybe$Nothing, f: session},
		cmd);
};
var author$project$Page$Login$Model = elm$core$Basics$identity;
var author$project$Game$OfflineSync$createLocalGame = F2(
	function (game, mencoded_) {
		if (mencoded_.$ === 1) {
			return krisajenkins$remotedata$RemoteData$Success(elm$core$Maybe$Nothing);
		} else {
			var encoded_ = mencoded_.a;
			return A2(
				krisajenkins$remotedata$RemoteData$map,
				function (g) {
					return elm$core$Maybe$Just(
						{bj: encoded_, ae: g});
				},
				game);
		}
	});
var krisajenkins$remotedata$RemoteData$andThen = F2(
	function (f, data) {
		switch (data.$) {
			case 3:
				var a = data.a;
				return f(a);
			case 2:
				var e = data.a;
				return krisajenkins$remotedata$RemoteData$Failure(e);
			case 0:
				return krisajenkins$remotedata$RemoteData$NotAsked;
			default:
				return krisajenkins$remotedata$RemoteData$Loading;
		}
	});
var author$project$Game$OfflineSync$createRemoteGame = function (userRes) {
	return A2(
		krisajenkins$remotedata$RemoteData$andThen,
		function (muser) {
			if (muser.$ === 1) {
				return krisajenkins$remotedata$RemoteData$Success(elm$core$Maybe$Nothing);
			} else {
				if (muser.a.$ === 1) {
					var _n1 = muser.a;
					return krisajenkins$remotedata$RemoteData$Success(elm$core$Maybe$Nothing);
				} else {
					var _n2 = muser.a.a;
					var remoteGame_ = _n2.a;
					var encoded = _n2.b;
					switch (remoteGame_.$) {
						case 0:
							return krisajenkins$remotedata$RemoteData$Failure('user.game is empty');
						case 1:
							return krisajenkins$remotedata$RemoteData$Loading;
						case 2:
							var err = remoteGame_.a;
							return krisajenkins$remotedata$RemoteData$Failure(err);
						default:
							var game_ = remoteGame_.a;
							return krisajenkins$remotedata$RemoteData$Success(
								elm$core$Maybe$Just(
									{bj: encoded, ae: game_}));
					}
				}
			}
		},
		userRes);
};
var author$project$Game$stateDicts = function (_n0) {
	var g = _n0;
	return {H: g.H, s: g.s, L: g.L, k: g.k, o: g.o};
};
var author$project$Game$OfflineSync$Conflict = function (a) {
	return {$: 0, a: a};
};
var author$project$Game$OfflineSync$UseLocal = {$: 1};
var author$project$Game$OfflineSync$UseRemote = function (a) {
	return {$: 2, a: a};
};
var author$project$Game$OfflineSync$tryResolve = F2(
	function (remote, local) {
		var _n0 = _Utils_Tuple2(remote, local);
		if (_n0.a.$ === 1) {
			if (_n0.b.$ === 1) {
				var _n1 = _n0.a;
				var _n2 = _n0.b;
				return author$project$Game$OfflineSync$UseLocal;
			} else {
				var _n3 = _n0.a;
				var lsrc = _n0.b.a;
				return author$project$Game$OfflineSync$UseLocal;
			}
		} else {
			if (_n0.b.$ === 1) {
				var rsrc = _n0.a.a;
				var _n4 = _n0.b;
				return author$project$Game$OfflineSync$UseRemote(rsrc);
			} else {
				var rsrc = _n0.a.a;
				var lsrc = _n0.b.a;
				return _Utils_eq(rsrc.bj, lsrc.bj) ? author$project$Game$OfflineSync$UseLocal : ((!_Utils_eq(
					author$project$Game$created(rsrc.ae),
					author$project$Game$created(lsrc.ae))) ? author$project$Game$OfflineSync$Conflict(
					{b8: lsrc, cv: rsrc}) : (_Utils_eq(
					author$project$Game$stateDicts(rsrc.ae),
					author$project$Game$stateDicts(lsrc.ae)) ? author$project$Game$OfflineSync$UseLocal : author$project$Game$OfflineSync$Conflict(
					{b8: lsrc, cv: rsrc})));
			}
		}
	});
var krisajenkins$remotedata$RemoteData$andMap = F2(
	function (wrappedValue, wrappedFunction) {
		var _n0 = _Utils_Tuple2(wrappedFunction, wrappedValue);
		_n0$2:
		while (true) {
			_n0$3:
			while (true) {
				_n0$4:
				while (true) {
					_n0$5:
					while (true) {
						switch (_n0.a.$) {
							case 3:
								switch (_n0.b.$) {
									case 3:
										var f = _n0.a.a;
										var value = _n0.b.a;
										return krisajenkins$remotedata$RemoteData$Success(
											f(value));
									case 2:
										break _n0$2;
									case 1:
										break _n0$4;
									default:
										var _n4 = _n0.b;
										return krisajenkins$remotedata$RemoteData$NotAsked;
								}
							case 2:
								var error = _n0.a.a;
								return krisajenkins$remotedata$RemoteData$Failure(error);
							case 1:
								switch (_n0.b.$) {
									case 2:
										break _n0$2;
									case 1:
										break _n0$3;
									case 0:
										break _n0$3;
									default:
										break _n0$3;
								}
							default:
								switch (_n0.b.$) {
									case 2:
										break _n0$2;
									case 1:
										break _n0$4;
									case 0:
										break _n0$5;
									default:
										break _n0$5;
								}
						}
					}
					var _n3 = _n0.a;
					return krisajenkins$remotedata$RemoteData$NotAsked;
				}
				var _n2 = _n0.b;
				return krisajenkins$remotedata$RemoteData$Loading;
			}
			var _n1 = _n0.a;
			return krisajenkins$remotedata$RemoteData$Loading;
		}
		var error = _n0.b.a;
		return krisajenkins$remotedata$RemoteData$Failure(error);
	});
var krisajenkins$remotedata$RemoteData$map2 = F3(
	function (f, a, b) {
		return A2(
			krisajenkins$remotedata$RemoteData$andMap,
			b,
			A2(krisajenkins$remotedata$RemoteData$map, f, a));
	});
var author$project$Game$OfflineSync$rawCreate = F3(
	function (remote, localGame_, localExport_) {
		return A3(
			krisajenkins$remotedata$RemoteData$map2,
			author$project$Game$OfflineSync$tryResolve,
			author$project$Game$OfflineSync$createRemoteGame(remote),
			A2(author$project$Game$OfflineSync$createLocalGame, localGame_, localExport_));
	});
var author$project$PlayFab$User$unwrap = function (_n0) {
	var d = _n0;
	return d;
};
var author$project$PlayFab$User$fullGame = A2(
	elm$core$Basics$composeR,
	author$project$PlayFab$User$unwrap,
	function ($) {
		return $.ae;
	});
var author$project$Game$OfflineSync$create = F2(
	function (remoteRes, localRes) {
		return A2(
			author$project$Game$OfflineSync$rawCreate,
			A2(
				krisajenkins$remotedata$RemoteData$map,
				elm$core$Maybe$map(author$project$PlayFab$User$fullGame),
				remoteRes),
			author$project$Session$GameLoader$toRemote(localRes));
	});
var author$project$Game$OfflineSync$toLocalOverwrite = function (state) {
	if (state.$ === 2) {
		var src = state.a;
		return elm$core$Maybe$Just(src);
	} else {
		return elm$core$Maybe$Nothing;
	}
};
var author$project$PlayFab$Error$toMessages = function (error) {
	if (!error.$) {
		switch (error.a.$) {
			case 3:
				var e = error.a.a;
				return _List_fromArray(
					[e.eA]);
			case 0:
				var e = error.a.a;
				return _List_fromArray(
					[e]);
			case 2:
				var e = error.a.a;
				return _List_fromArray(
					[e]);
			default:
				var _n1 = error.a;
				var status = _n1.a;
				var e = _n1.b;
				return _List_fromArray(
					[
						'AuthError ' + (elm$core$String$fromInt(status) + (': ' + e))
					]);
		}
	} else {
		return _List_Nil;
	}
};
var author$project$PlayFab$Error$toString = A2(
	elm$core$Basics$composeR,
	elm$core$Maybe$Just,
	A2(
		elm$core$Basics$composeR,
		author$project$PlayFab$Error$toMessages,
		elm$core$String$join('\n')));
var author$project$Game$OfflineSync$toConflict = function (state) {
	if (!state.$) {
		var conflict = state.a;
		return elm$core$Maybe$Just(conflict);
	} else {
		return elm$core$Maybe$Nothing;
	}
};
var author$project$Cooldown$Ready = {$: 0};
var author$project$Session$emptyUserSyncState = {_: author$project$Cooldown$Ready, dO: krisajenkins$remotedata$RemoteData$NotAsked, dP: elm$core$Maybe$Nothing, d_: elm$core$Maybe$Nothing};
var author$project$Session$createUserState = F2(
	function (conflictState, user_) {
		return {
			fL: function () {
				var _n0 = A2(krisajenkins$remotedata$RemoteData$map, author$project$Game$OfflineSync$toConflict, conflictState);
				if ((_n0.$ === 3) && (!_n0.a.$)) {
					var conflict = _n0.a.a;
					return elm$core$Result$Err(conflict);
				} else {
					return elm$core$Result$Ok(author$project$Session$emptyUserSyncState);
				}
			}(),
			cQ: user_
		};
	});
var author$project$Session$GameLoader$fromGame = function (game) {
	return author$project$Session$GameLoader$Ready(
		{ae: game, fW: elm$core$Maybe$Nothing});
};
var krisajenkins$remotedata$RemoteData$mapError = F2(
	function (f, data) {
		switch (data.$) {
			case 3:
				var x = data.a;
				return krisajenkins$remotedata$RemoteData$Success(x);
			case 2:
				var e = data.a;
				return krisajenkins$remotedata$RemoteData$Failure(
					f(e));
			case 1:
				return krisajenkins$remotedata$RemoteData$Loading;
			default:
				return krisajenkins$remotedata$RemoteData$NotAsked;
		}
	});
var author$project$Session$setUser = F2(
	function (userRes, _n0) {
		var session = _n0;
		var conflictState = A3(
			author$project$Game$OfflineSync$create,
			A2(krisajenkins$remotedata$RemoteData$mapError, author$project$PlayFab$Error$toString, userRes),
			session.ae,
			session.ak);
		var remote = A2(
			elm$core$Maybe$andThen,
			author$project$Game$OfflineSync$toLocalOverwrite,
			krisajenkins$remotedata$RemoteData$toMaybe(conflictState));
		var userState_ = A2(
			krisajenkins$remotedata$RemoteData$map,
			elm$core$Maybe$map(
				author$project$Session$createUserState(conflictState)),
			userRes);
		return _Utils_update(
			session,
			{
				ae: A3(
					elm_community$maybe_extra$Maybe$Extra$unwrap,
					session.ae,
					A2(
						elm$core$Basics$composeR,
						function ($) {
							return $.ae;
						},
						author$project$Session$GameLoader$fromGame),
					remote),
				ak: A3(
					elm_community$maybe_extra$Maybe$Extra$unwrap,
					session.ak,
					A2(
						elm$core$Basics$composeR,
						function ($) {
							return $.bj;
						},
						elm$core$Maybe$Just),
					remote),
				cQ: userState_
			});
	});
var author$project$Session$userState = A2(
	elm$core$Basics$composeR,
	author$project$Session$unwrap,
	function ($) {
		return $.cQ;
	});
var author$project$Session$user = A2(
	elm$core$Basics$composeR,
	author$project$Session$userState,
	krisajenkins$remotedata$RemoteData$map(
		elm$core$Maybe$map(
			function ($) {
				return $.cQ;
			})));
var author$project$Session$clearUserError = function (session) {
	var _n0 = author$project$Session$user(session);
	if (_n0.$ === 2) {
		var err = _n0.a;
		return A2(
			author$project$Session$setUser,
			krisajenkins$remotedata$RemoteData$Success(elm$core$Maybe$Nothing),
			session);
	} else {
		return session;
	}
};
var author$project$Page$Login$create = function (session_) {
	return {
		bW: '',
		cq: '',
		bv: false,
		a$: krisajenkins$remotedata$RemoteData$NotAsked,
		f: author$project$Session$clearUserError(session_)
	};
};
var author$project$Page$MtxHistory$GotPlayFabInventory = function (a) {
	return {$: 2, a: a};
};
var author$project$Page$MtxHistory$KongregateInventory = function (a) {
	return {$: 1, a: a};
};
var author$project$Page$MtxHistory$Model = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var author$project$Page$MtxHistory$PlayFabInventory = function (a) {
	return {$: 0, a: a};
};
var author$project$PlayFab$Error$FormErrorData = F2(
	function (error, fields) {
		return {eA: error, eF: fields};
	});
var elm$json$Json$Decode$dict = function (decoder) {
	return A2(
		elm$json$Json$Decode$map,
		elm$core$Dict$fromList,
		elm$json$Json$Decode$keyValuePairs(decoder));
};
var author$project$PlayFab$formErrorFromJson = A3(
	elm$json$Json$Decode$map2,
	author$project$PlayFab$Error$FormErrorData,
	A2(elm$json$Json$Decode$field, 'errorMessage', elm$json$Json$Decode$string),
	A2(
		elm$json$Json$Decode$map,
		elm$core$Maybe$withDefault(elm$core$Dict$empty),
		elm$json$Json$Decode$maybe(
			A2(
				elm$json$Json$Decode$field,
				'errorDetails',
				elm$json$Json$Decode$dict(
					elm$json$Json$Decode$list(elm$json$Json$Decode$string))))));
var author$project$PlayFab$Error$FormError = function (a) {
	return {$: 3, a: a};
};
var author$project$PlayFab$Error$UnexpectedError = function (a) {
	return {$: 0, a: a};
};
var elm$json$Json$Decode$decodeString = _Json_runOnString;
var author$project$PlayFab$parseFormError = function (body) {
	var _n0 = A2(elm$json$Json$Decode$decodeString, author$project$PlayFab$formErrorFromJson, body);
	if (!_n0.$) {
		var details = _n0.a;
		return author$project$PlayFab$Error$FormError(details);
	} else {
		var err = _n0.a;
		return author$project$PlayFab$Error$UnexpectedError(
			elm$json$Json$Decode$errorToString(err));
	}
};
var author$project$PlayFab$Error$AuthError = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var author$project$PlayFab$Error$TransientError = function (a) {
	return {$: 2, a: a};
};
var elm$core$Maybe$isJust = function (maybe) {
	if (!maybe.$) {
		return true;
	} else {
		return false;
	}
};
var elm$core$Platform$sendToApp = _Platform_sendToApp;
var elm$core$Platform$sendToSelf = _Platform_sendToSelf;
var elm$core$Result$map = F2(
	function (func, ra) {
		if (!ra.$) {
			var a = ra.a;
			return elm$core$Result$Ok(
				func(a));
		} else {
			var e = ra.a;
			return elm$core$Result$Err(e);
		}
	});
var elm$http$Http$BadStatus_ = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var elm$http$Http$BadUrl_ = function (a) {
	return {$: 0, a: a};
};
var elm$http$Http$GoodStatus_ = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var elm$http$Http$NetworkError_ = {$: 2};
var elm$http$Http$Receiving = function (a) {
	return {$: 1, a: a};
};
var elm$http$Http$Sending = function (a) {
	return {$: 0, a: a};
};
var elm$http$Http$Timeout_ = {$: 1};
var elm$http$Http$expectStringResponse = F2(
	function (toMsg, toResult) {
		return A3(
			_Http_expect,
			'',
			elm$core$Basics$identity,
			A2(elm$core$Basics$composeR, toResult, toMsg));
	});
var author$project$PlayFab$expectJson = F2(
	function (toMsg, decoder) {
		return A2(
			elm$http$Http$expectStringResponse,
			toMsg,
			function (res) {
				switch (res.$) {
					case 0:
						var url = res.a;
						return elm$core$Result$Err(
							author$project$PlayFab$Error$UnexpectedError('bad url: ' + url));
					case 1:
						return elm$core$Result$Err(
							author$project$PlayFab$Error$TransientError('timeout'));
					case 2:
						return elm$core$Result$Err(
							author$project$PlayFab$Error$TransientError('network error'));
					case 3:
						var metadata = res.a;
						var body = res.b;
						return elm$core$Result$Err(
							function () {
								var _n1 = metadata.cF;
								switch (_n1) {
									case 400:
										return author$project$PlayFab$parseFormError(body);
									case 401:
										return A2(author$project$PlayFab$Error$AuthError, metadata.cF, body);
									case 403:
										return author$project$PlayFab$parseFormError(body);
									default:
										return author$project$PlayFab$Error$UnexpectedError(
											'bad status: ' + (elm$core$String$fromInt(metadata.cF) + ('\n\n' + body)));
								}
							}());
					default:
						var metadata = res.a;
						var body = res.b;
						return A2(
							elm$core$Result$mapError,
							function (err) {
								return author$project$PlayFab$Error$UnexpectedError(
									'body decode error: ' + elm$json$Json$Decode$errorToString(err));
							},
							A2(elm$json$Json$Decode$decodeString, decoder, body));
				}
			});
	});
var author$project$PlayFab$Inventory$InstanceId = elm$core$Basics$identity;
var author$project$PlayFab$Inventory$Item = F6(
	function (itemId, instanceId, purchaseDate, displayName, annotation, catalogVersion) {
		return {cW: annotation, en: catalogVersion, ew: displayName, b0: instanceId, eX: itemId, fm: purchaseDate};
	});
var author$project$PlayFab$Inventory$ItemId = elm$core$Basics$identity;
var rtfeldman$elm_iso8601_date_strings$Iso8601$fractionsOfASecondInMs = A2(
	elm$parser$Parser$andThen,
	function (str) {
		if (elm$core$String$length(str) <= 9) {
			var _n0 = elm$core$String$toFloat('0.' + str);
			if (!_n0.$) {
				var floatVal = _n0.a;
				return elm$parser$Parser$succeed(
					elm$core$Basics$round(floatVal * 1000));
			} else {
				return elm$parser$Parser$problem('Invalid float: \"' + (str + '\"'));
			}
		} else {
			return elm$parser$Parser$problem(
				'Expected at most 9 digits, but got ' + elm$core$String$fromInt(
					elm$core$String$length(str)));
		}
	},
	elm$parser$Parser$getChompedString(
		elm$parser$Parser$chompWhile(elm$core$Char$isDigit)));
var elm$time$Time$Posix = elm$core$Basics$identity;
var elm$time$Time$millisToPosix = elm$core$Basics$identity;
var rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts = F6(
	function (monthYearDayMs, hour, minute, second, ms, utcOffsetMinutes) {
		return elm$time$Time$millisToPosix((((monthYearDayMs + (((hour * 60) * 60) * 1000)) + (((minute - utcOffsetMinutes) * 60) * 1000)) + (second * 1000)) + ms);
	});
var elm$core$String$toInt = _String_toInt;
var rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt = function (quantity) {
	return A2(
		elm$parser$Parser$andThen,
		function (str) {
			if (_Utils_eq(
				elm$core$String$length(str),
				quantity)) {
				var _n0 = elm$core$String$toInt(str);
				if (!_n0.$) {
					var intVal = _n0.a;
					return elm$parser$Parser$succeed(intVal);
				} else {
					return elm$parser$Parser$problem('Invalid integer: \"' + (str + '\"'));
				}
			} else {
				return elm$parser$Parser$problem(
					'Expected ' + (elm$core$String$fromInt(quantity) + (' digits, but got ' + elm$core$String$fromInt(
						elm$core$String$length(str)))));
			}
		},
		elm$parser$Parser$getChompedString(
			elm$parser$Parser$chompWhile(elm$core$Char$isDigit)));
};
var rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear = 1970;
var rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay = function (day) {
	return elm$parser$Parser$problem(
		'Invalid day: ' + elm$core$String$fromInt(day));
};
var rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear = function (year) {
	return (!A2(elm$core$Basics$modBy, 4, year)) && (A2(elm$core$Basics$modBy, 100, year) || (!A2(elm$core$Basics$modBy, 400, year)));
};
var rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore = function (y1) {
	var y = y1 - 1;
	return (((y / 4) | 0) - ((y / 100) | 0)) + ((y / 400) | 0);
};
var rtfeldman$elm_iso8601_date_strings$Iso8601$msPerDay = 86400000;
var rtfeldman$elm_iso8601_date_strings$Iso8601$msPerYear = 31536000000;
var rtfeldman$elm_iso8601_date_strings$Iso8601$yearMonthDay = function (_n0) {
	var year = _n0.a;
	var month = _n0.b;
	var dayInMonth = _n0.c;
	if (dayInMonth < 0) {
		return rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth);
	} else {
		var succeedWith = function (extraMs) {
			var yearMs = rtfeldman$elm_iso8601_date_strings$Iso8601$msPerYear * (year - rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear);
			var days = ((month < 3) || (!rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear(year))) ? (dayInMonth - 1) : dayInMonth;
			var dayMs = rtfeldman$elm_iso8601_date_strings$Iso8601$msPerDay * (days + (rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore(year) - rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore(rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear)));
			return elm$parser$Parser$succeed((extraMs + yearMs) + dayMs);
		};
		switch (month) {
			case 1:
				return (dayInMonth > 31) ? rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(0);
			case 2:
				return ((dayInMonth > 29) || ((dayInMonth === 29) && (!rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear(year)))) ? rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(2678400000);
			case 3:
				return (dayInMonth > 31) ? rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(5097600000);
			case 4:
				return (dayInMonth > 30) ? rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(7776000000);
			case 5:
				return (dayInMonth > 31) ? rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(10368000000);
			case 6:
				return (dayInMonth > 30) ? rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(13046400000);
			case 7:
				return (dayInMonth > 31) ? rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(15638400000);
			case 8:
				return (dayInMonth > 31) ? rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(18316800000);
			case 9:
				return (dayInMonth > 30) ? rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(20995200000);
			case 10:
				return (dayInMonth > 31) ? rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(23587200000);
			case 11:
				return (dayInMonth > 30) ? rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(26265600000);
			case 12:
				return (dayInMonth > 31) ? rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(28857600000);
			default:
				return elm$parser$Parser$problem(
					'Invalid month: \"' + (elm$core$String$fromInt(month) + '\"'));
		}
	}
};
var rtfeldman$elm_iso8601_date_strings$Iso8601$monthYearDayInMs = A2(
	elm$parser$Parser$andThen,
	rtfeldman$elm_iso8601_date_strings$Iso8601$yearMonthDay,
	A2(
		elm$parser$Parser$keeper,
		A2(
			elm$parser$Parser$keeper,
			A2(
				elm$parser$Parser$keeper,
				elm$parser$Parser$succeed(
					F3(
						function (year, month, day) {
							return _Utils_Tuple3(year, month, day);
						})),
				A2(
					elm$parser$Parser$ignorer,
					rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(4),
					elm$parser$Parser$symbol('-'))),
			A2(
				elm$parser$Parser$ignorer,
				rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2),
				elm$parser$Parser$symbol('-'))),
		rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)));
var rtfeldman$elm_iso8601_date_strings$Iso8601$utcOffsetMinutesFromParts = F3(
	function (multiplier, hours, minutes) {
		return multiplier * ((hours * 60) + minutes);
	});
var rtfeldman$elm_iso8601_date_strings$Iso8601$iso8601 = A2(
	elm$parser$Parser$andThen,
	function (datePart) {
		return elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					elm$parser$Parser$keeper,
					A2(
						elm$parser$Parser$keeper,
						A2(
							elm$parser$Parser$keeper,
							A2(
								elm$parser$Parser$keeper,
								A2(
									elm$parser$Parser$keeper,
									A2(
										elm$parser$Parser$ignorer,
										elm$parser$Parser$succeed(
											rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts(datePart)),
										elm$parser$Parser$symbol('T')),
									A2(
										elm$parser$Parser$ignorer,
										rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2),
										elm$parser$Parser$symbol(':'))),
								A2(
									elm$parser$Parser$ignorer,
									rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2),
									elm$parser$Parser$symbol(':'))),
							rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
						elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									elm$parser$Parser$keeper,
									A2(
										elm$parser$Parser$ignorer,
										elm$parser$Parser$succeed(elm$core$Basics$identity),
										elm$parser$Parser$symbol('.')),
									rtfeldman$elm_iso8601_date_strings$Iso8601$fractionsOfASecondInMs),
									elm$parser$Parser$succeed(0)
								]))),
					elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								A2(
								elm$parser$Parser$map,
								function (_n0) {
									return 0;
								},
								elm$parser$Parser$symbol('Z')),
								A2(
								elm$parser$Parser$keeper,
								A2(
									elm$parser$Parser$keeper,
									A2(
										elm$parser$Parser$keeper,
										elm$parser$Parser$succeed(rtfeldman$elm_iso8601_date_strings$Iso8601$utcOffsetMinutesFromParts),
										elm$parser$Parser$oneOf(
											_List_fromArray(
												[
													A2(
													elm$parser$Parser$map,
													function (_n1) {
														return 1;
													},
													elm$parser$Parser$symbol('+')),
													A2(
													elm$parser$Parser$map,
													function (_n2) {
														return -1;
													},
													elm$parser$Parser$symbol('-'))
												]))),
									A2(
										elm$parser$Parser$ignorer,
										rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2),
										elm$parser$Parser$symbol(':'))),
								rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2))
							]))),
					A2(
					elm$parser$Parser$ignorer,
					elm$parser$Parser$succeed(
						A6(rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts, datePart, 0, 0, 0, 0, 0)),
					elm$parser$Parser$end)
				]));
	},
	rtfeldman$elm_iso8601_date_strings$Iso8601$monthYearDayInMs);
var rtfeldman$elm_iso8601_date_strings$Iso8601$toTime = function (str) {
	return A2(elm$parser$Parser$run, rtfeldman$elm_iso8601_date_strings$Iso8601$iso8601, str);
};
var rtfeldman$elm_iso8601_date_strings$Iso8601$decoder = A2(
	elm$json$Json$Decode$andThen,
	function (str) {
		var _n0 = rtfeldman$elm_iso8601_date_strings$Iso8601$toTime(str);
		if (_n0.$ === 1) {
			var deadEnds = _n0.a;
			return elm$json$Json$Decode$fail(
				elm$parser$Parser$deadEndsToString(deadEnds));
		} else {
			var time = _n0.a;
			return elm$json$Json$Decode$succeed(time);
		}
	},
	elm$json$Json$Decode$string);
var author$project$PlayFab$Inventory$decoder = A7(
	elm$json$Json$Decode$map6,
	author$project$PlayFab$Inventory$Item,
	A2(
		elm$json$Json$Decode$field,
		'ItemId',
		A2(elm$json$Json$Decode$map, elm$core$Basics$identity, elm$json$Json$Decode$string)),
	A2(
		elm$json$Json$Decode$field,
		'ItemInstanceId',
		A2(elm$json$Json$Decode$map, elm$core$Basics$identity, elm$json$Json$Decode$string)),
	A2(elm$json$Json$Decode$field, 'PurchaseDate', rtfeldman$elm_iso8601_date_strings$Iso8601$decoder),
	A2(elm$json$Json$Decode$field, 'DisplayName', elm$json$Json$Decode$string),
	A2(elm$json$Json$Decode$field, 'Annotation', elm$json$Json$Decode$string),
	A2(elm$json$Json$Decode$field, 'CatalogVersion', elm$json$Json$Decode$string));
var author$project$PlayFab$TitleId$encode = function (_n0) {
	var id = _n0;
	return elm$json$Json$Encode$string(id);
};
var author$project$PlayFab$TitleId$host = function (_n0) {
	var id = _n0;
	return 'https://' + (id + '.playfabapi.com');
};
var author$project$PlayFab$User$sessionTicket = A2(
	elm$core$Basics$composeR,
	author$project$PlayFab$User$unwrap,
	function ($) {
		return $.bz;
	});
var author$project$PlayFab$User$ticketToString = function (_n0) {
	var t = _n0;
	return t;
};
var elm$http$Http$Header = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var elm$http$Http$header = elm$http$Http$Header;
var elm$http$Http$jsonBody = function (value) {
	return A2(
		_Http_pair,
		'application/json',
		A2(elm$json$Json$Encode$encode, 0, value));
};
var elm$http$Http$Request = function (a) {
	return {$: 1, a: a};
};
var elm$core$Task$succeed = _Scheduler_succeed;
var elm$http$Http$State = F2(
	function (reqs, subs) {
		return {dN: reqs, dZ: subs};
	});
var elm$http$Http$init = elm$core$Task$succeed(
	A2(elm$http$Http$State, elm$core$Dict$empty, _List_Nil));
var elm$core$Task$andThen = _Scheduler_andThen;
var elm$core$Process$kill = _Scheduler_kill;
var elm$core$Process$spawn = _Scheduler_spawn;
var elm$http$Http$updateReqs = F3(
	function (router, cmds, reqs) {
		updateReqs:
		while (true) {
			if (!cmds.b) {
				return elm$core$Task$succeed(reqs);
			} else {
				var cmd = cmds.a;
				var otherCmds = cmds.b;
				if (!cmd.$) {
					var tracker = cmd.a;
					var _n2 = A2(elm$core$Dict$get, tracker, reqs);
					if (_n2.$ === 1) {
						var $temp$router = router,
							$temp$cmds = otherCmds,
							$temp$reqs = reqs;
						router = $temp$router;
						cmds = $temp$cmds;
						reqs = $temp$reqs;
						continue updateReqs;
					} else {
						var pid = _n2.a;
						return A2(
							elm$core$Task$andThen,
							function (_n3) {
								return A3(
									elm$http$Http$updateReqs,
									router,
									otherCmds,
									A2(elm$core$Dict$remove, tracker, reqs));
							},
							elm$core$Process$kill(pid));
					}
				} else {
					var req = cmd.a;
					return A2(
						elm$core$Task$andThen,
						function (pid) {
							var _n4 = req.aJ;
							if (_n4.$ === 1) {
								return A3(elm$http$Http$updateReqs, router, otherCmds, reqs);
							} else {
								var tracker = _n4.a;
								return A3(
									elm$http$Http$updateReqs,
									router,
									otherCmds,
									A3(elm$core$Dict$insert, tracker, pid, reqs));
							}
						},
						elm$core$Process$spawn(
							A3(
								_Http_toTask,
								router,
								elm$core$Platform$sendToApp(router),
								req)));
				}
			}
		}
	});
var elm$http$Http$onEffects = F4(
	function (router, cmds, subs, state) {
		return A2(
			elm$core$Task$andThen,
			function (reqs) {
				return elm$core$Task$succeed(
					A2(elm$http$Http$State, reqs, subs));
			},
			A3(elm$http$Http$updateReqs, router, cmds, state.dN));
	});
var elm$core$Task$map2 = F3(
	function (func, taskA, taskB) {
		return A2(
			elm$core$Task$andThen,
			function (a) {
				return A2(
					elm$core$Task$andThen,
					function (b) {
						return elm$core$Task$succeed(
							A2(func, a, b));
					},
					taskB);
			},
			taskA);
	});
var elm$core$Task$sequence = function (tasks) {
	return A3(
		elm$core$List$foldr,
		elm$core$Task$map2(elm$core$List$cons),
		elm$core$Task$succeed(_List_Nil),
		tasks);
};
var elm$http$Http$maybeSend = F4(
	function (router, desiredTracker, progress, _n0) {
		var actualTracker = _n0.a;
		var toMsg = _n0.b;
		return _Utils_eq(desiredTracker, actualTracker) ? elm$core$Maybe$Just(
			A2(
				elm$core$Platform$sendToApp,
				router,
				toMsg(progress))) : elm$core$Maybe$Nothing;
	});
var elm$http$Http$onSelfMsg = F3(
	function (router, _n0, state) {
		var tracker = _n0.a;
		var progress = _n0.b;
		return A2(
			elm$core$Task$andThen,
			function (_n1) {
				return elm$core$Task$succeed(state);
			},
			elm$core$Task$sequence(
				A2(
					elm$core$List$filterMap,
					A3(elm$http$Http$maybeSend, router, tracker, progress),
					state.dZ)));
	});
var elm$http$Http$Cancel = function (a) {
	return {$: 0, a: a};
};
var elm$http$Http$cmdMap = F2(
	function (func, cmd) {
		if (!cmd.$) {
			var tracker = cmd.a;
			return elm$http$Http$Cancel(tracker);
		} else {
			var r = cmd.a;
			return elm$http$Http$Request(
				{
					ao: r.ao,
					cZ: r.cZ,
					z: A2(_Http_mapExpect, func, r.z),
					as: r.as,
					aw: r.aw,
					aH: r.aH,
					aJ: r.aJ,
					B: r.B
				});
		}
	});
var elm$http$Http$MySub = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var elm$http$Http$subMap = F2(
	function (func, _n0) {
		var tracker = _n0.a;
		var toMsg = _n0.b;
		return A2(
			elm$http$Http$MySub,
			tracker,
			A2(elm$core$Basics$composeR, toMsg, func));
	});
_Platform_effectManagers['Http'] = _Platform_createManager(elm$http$Http$init, elm$http$Http$onEffects, elm$http$Http$onSelfMsg, elm$http$Http$cmdMap, elm$http$Http$subMap);
var elm$http$Http$command = _Platform_leaf('Http');
var elm$http$Http$subscription = _Platform_leaf('Http');
var elm$http$Http$request = function (r) {
	return elm$http$Http$command(
		elm$http$Http$Request(
			{ao: false, cZ: r.cZ, z: r.z, as: r.as, aw: r.aw, aH: r.aH, aJ: r.aJ, B: r.B}));
};
var elm$json$Json$Decode$at = F2(
	function (fields, decoder) {
		return A3(elm$core$List$foldr, elm$json$Json$Decode$field, decoder, fields);
	});
var author$project$PlayFab$inventory = F3(
	function (titleId, user, toMsg) {
		return elm$http$Http$request(
			{
				cZ: elm$http$Http$jsonBody(
					elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'TitleId',
								author$project$PlayFab$TitleId$encode(titleId))
							]))),
				z: A2(
					author$project$PlayFab$expectJson,
					toMsg,
					A2(
						elm$json$Json$Decode$at,
						_List_fromArray(
							['data', 'Inventory']),
						elm$json$Json$Decode$list(author$project$PlayFab$Inventory$decoder))),
				as: _List_fromArray(
					[
						A2(
						elm$http$Http$header,
						'X-Authentication',
						author$project$PlayFab$User$ticketToString(
							author$project$PlayFab$User$sessionTicket(user)))
					]),
				aw: 'POST',
				aH: elm$core$Maybe$Nothing,
				aJ: elm$core$Maybe$Nothing,
				B: author$project$PlayFab$TitleId$host(titleId) + '/Client/GetUserInventory'
			});
	});
var author$project$PlayFab$TitleId$TitleId = elm$core$Basics$identity;
var author$project$PlayFab$TitleId$endpoints = {bh: 'F810', fl: '7847'};
var author$project$PlayFab$TitleId$fromString = F2(
	function (env, str) {
		_n0$4:
		while (true) {
			if (!str.$) {
				switch (str.a) {
					case 'prod':
						return author$project$PlayFab$TitleId$endpoints.fl;
					case '7847':
						return author$project$PlayFab$TitleId$endpoints.fl;
					case 'dev':
						return author$project$PlayFab$TitleId$endpoints.bh;
					case 'F810':
						return author$project$PlayFab$TitleId$endpoints.bh;
					default:
						break _n0$4;
				}
			} else {
				break _n0$4;
			}
		}
		if (!env.$) {
			return author$project$PlayFab$TitleId$endpoints.fl;
		} else {
			return author$project$PlayFab$TitleId$endpoints.bh;
		}
	});
var author$project$Route$Config$PlayFab = 0;
var author$project$Route$Config$toString = function (c) {
	switch (c) {
		case 0:
			return 'playFab';
		case 1:
			return 'environment';
		case 2:
			return 'fools';
		case 3:
			return 'iframe';
		case 4:
			return 'paypalenv';
		default:
			return 'hostname';
	}
};
var author$project$Route$Config$get = function (k) {
	return elm$core$Dict$get(
		author$project$Route$Config$toString(k));
};
var author$project$Route$Config$Environment = 1;
var author$project$Session$query = A2(
	elm$core$Basics$composeR,
	author$project$Session$unwrap,
	function ($) {
		return $.fn;
	});
var author$project$Session$Environment$Unknown = function (a) {
	return {$: 2, a: a};
};
var author$project$Session$Environment$Development = {$: 1};
var author$project$Session$Environment$Production = {$: 0};
var author$project$Session$Environment$toString = function (env) {
	switch (env.$) {
		case 0:
			return 'production';
		case 1:
			return 'development';
		default:
			var str = env.a;
			return 'unknown: ' + str;
	}
};
var author$project$Session$Environment$byString = elm$core$Dict$fromList(
	A2(
		elm$core$List$map,
		function (s) {
			return _Utils_Tuple2(
				author$project$Session$Environment$toString(s),
				s);
		},
		_List_fromArray(
			[author$project$Session$Environment$Production, author$project$Session$Environment$Development])));
var author$project$Session$Environment$fromString = function (env) {
	return A2(
		elm$core$Maybe$withDefault,
		author$project$Session$Environment$Unknown(env),
		A2(elm$core$Dict$get, env, author$project$Session$Environment$byString));
};
var author$project$Session$environment = function (session) {
	var _n0 = A2(
		author$project$Route$Config$get,
		1,
		author$project$Session$query(session));
	if (_n0.$ === 1) {
		return author$project$Session$unwrap(session).de;
	} else {
		var env = _n0.a;
		return author$project$Session$Environment$fromString(env);
	}
};
var author$project$PlayFab$TitleId$fromSession = function (session) {
	return A2(
		author$project$PlayFab$TitleId$fromString,
		author$project$Session$environment(session),
		A2(
			author$project$Route$Config$get,
			0,
			author$project$Session$query(session)));
};
var author$project$Ports$Kongregate$kongregateRequestUserItemListReq = _Platform_outgoingPort(
	'kongregateRequestUserItemListReq',
	function ($) {
		return elm$json$Json$Encode$null;
	});
var author$project$Session$iframe = A2(
	elm$core$Basics$composeR,
	author$project$Session$unwrap,
	function ($) {
		return $.ag;
	});
var author$project$Page$MtxHistory$create = function (session) {
	var _n0 = author$project$Session$user(session);
	if ((_n0.$ === 3) && (!_n0.a.$)) {
		var user = _n0.a.a;
		var _n1 = author$project$Session$iframe(session);
		if (!_n1.$) {
			return _Utils_Tuple2(
				A2(
					author$project$Page$MtxHistory$Model,
					author$project$Page$MtxHistory$PlayFabInventory(krisajenkins$remotedata$RemoteData$Loading),
					session),
				A3(
					author$project$PlayFab$inventory,
					author$project$PlayFab$TitleId$fromSession(session),
					user,
					author$project$Page$MtxHistory$GotPlayFabInventory));
		} else {
			return _Utils_Tuple2(
				A2(
					author$project$Page$MtxHistory$Model,
					author$project$Page$MtxHistory$KongregateInventory(krisajenkins$remotedata$RemoteData$Loading),
					session),
				author$project$Ports$Kongregate$kongregateRequestUserItemListReq(0));
		}
	} else {
		var _n2 = author$project$Session$iframe(session);
		if (!_n2.$) {
			return _Utils_Tuple2(
				A2(
					author$project$Page$MtxHistory$Model,
					author$project$Page$MtxHistory$PlayFabInventory(krisajenkins$remotedata$RemoteData$NotAsked),
					session),
				elm$core$Platform$Cmd$none);
		} else {
			return _Utils_Tuple2(
				A2(
					author$project$Page$MtxHistory$Model,
					author$project$Page$MtxHistory$KongregateInventory(krisajenkins$remotedata$RemoteData$NotAsked),
					session),
				elm$core$Platform$Cmd$none);
		}
	}
};
var author$project$Page$MtxShop$PaypalPurchase = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var author$project$Game$setLastUnitByTab = F3(
	function (tab, unit, _n0) {
		var g = _n0;
		var update = function () {
			if (unit.$ === 1) {
				return elm$core$Dict$remove(tab);
			} else {
				var u = unit.a;
				return A2(elm$core$Dict$insert, tab, u);
			}
		}();
		return _Utils_update(
			g,
			{
				S: update(g.S)
			});
	});
var author$project$Page$MtxShop$GotPaypalNotify = function (a) {
	return {$: 4, a: a};
};
var author$project$Page$MtxShop$GotPlayFabInventory = function (a) {
	return {$: 1, a: a};
};
var author$project$Page$MtxShop$KongregateInventory = function (a) {
	return {$: 1, a: a};
};
var author$project$Page$MtxShop$Model = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var author$project$Page$MtxShop$PlayFabInventory = function (a) {
	return {$: 0, a: a};
};
var author$project$PlayFab$paypalNotify = F4(
	function (titleId, user, paypalTxnId, toMsg) {
		return elm$http$Http$request(
			{
				cZ: elm$http$Http$jsonBody(
					elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'TitleId',
								author$project$PlayFab$TitleId$encode(titleId)),
								_Utils_Tuple2(
								'FunctionName',
								elm$json$Json$Encode$string('paypalNotify')),
								_Utils_Tuple2(
								'FunctionParameter',
								elm$json$Json$Encode$object(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'tx',
											elm$json$Json$Encode$string(paypalTxnId))
										])))
							]))),
				z: A2(
					author$project$PlayFab$expectJson,
					toMsg,
					A2(
						elm$json$Json$Decode$andThen,
						function (_n0) {
							var state = _n0.a;
							var itemInstanceId = _n0.b;
							return (state === 'success') ? elm$json$Json$Decode$succeed(itemInstanceId) : elm$json$Json$Decode$fail('paypalNotify non-success state: ' + state);
						},
						A2(
							elm$json$Json$Decode$at,
							_List_fromArray(
								['data', 'FunctionResult']),
							A3(
								elm$json$Json$Decode$map2,
								elm$core$Tuple$pair,
								A2(elm$json$Json$Decode$field, 'state', elm$json$Json$Decode$string),
								A2(elm$json$Json$Decode$field, 'itemInstanceId', elm$json$Json$Decode$string))))),
				as: _List_fromArray(
					[
						A2(
						elm$http$Http$header,
						'X-Authentication',
						author$project$PlayFab$User$ticketToString(
							author$project$PlayFab$User$sessionTicket(user)))
					]),
				aw: 'POST',
				aH: elm$core$Maybe$Nothing,
				aJ: elm$core$Maybe$Nothing,
				B: author$project$PlayFab$TitleId$host(titleId) + '/Client/ExecuteCloudScript'
			});
	});
var author$project$Page$MtxShop$recreate = F3(
	function (tab, purchase, session0) {
		var notAsked = function () {
			var _n7 = author$project$Session$iframe(session0);
			if (!_n7.$) {
				return author$project$Page$MtxShop$PlayFabInventory(krisajenkins$remotedata$RemoteData$NotAsked);
			} else {
				return author$project$Page$MtxShop$KongregateInventory(krisajenkins$remotedata$RemoteData$NotAsked);
			}
		}();
		var _n0 = author$project$Session$game(session0);
		if (_n0.$ === 3) {
			var game0 = _n0.a;
			var _n1 = A2(
				author$project$Session$persistWrite,
				session0,
				A3(
					author$project$Game$setLastUnitByTab,
					tab,
					elm$core$Maybe$Just('crystal'),
					game0));
			var game = _n1.a;
			var cmd = _n1.b;
			var _n2 = author$project$Session$user(session0);
			if ((_n2.$ === 3) && (!_n2.a.$)) {
				var user = _n2.a.a;
				var _n3 = author$project$Session$iframe(session0);
				if (_n3.$ === 1) {
					var kong = _n3.a;
					return _Utils_Tuple2(
						A4(
							author$project$Page$MtxShop$Model,
							author$project$Page$MtxShop$KongregateInventory(krisajenkins$remotedata$RemoteData$Loading),
							tab,
							purchase,
							session0),
						elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									cmd,
									author$project$Ports$Kongregate$kongregateRequestUserItemListReq(0)
								])));
				} else {
					var loadInventory = _Utils_Tuple2(
						A4(
							author$project$Page$MtxShop$Model,
							author$project$Page$MtxShop$PlayFabInventory(krisajenkins$remotedata$RemoteData$Loading),
							tab,
							purchase,
							session0),
						elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									cmd,
									A3(
									author$project$PlayFab$inventory,
									author$project$PlayFab$TitleId$fromSession(session0),
									user,
									author$project$Page$MtxShop$GotPlayFabInventory)
								])));
					if ((!purchase.$) && (!purchase.a.$)) {
						var _n5 = purchase.a;
						var paypalStatus = _n5.a;
						var paypalReturnArgs = _n5.b;
						switch (paypalStatus.$) {
							case 0:
								return _Utils_Tuple2(
									A4(
										author$project$Page$MtxShop$Model,
										notAsked,
										tab,
										elm$core$Maybe$Just(
											A2(author$project$Page$MtxShop$PaypalPurchase, krisajenkins$remotedata$RemoteData$Loading, paypalReturnArgs)),
										session0),
									A4(
										author$project$PlayFab$paypalNotify,
										author$project$PlayFab$TitleId$fromSession(session0),
										user,
										paypalReturnArgs.bG,
										author$project$Page$MtxShop$GotPaypalNotify));
							case 1:
								return _Utils_Tuple2(
									A4(author$project$Page$MtxShop$Model, notAsked, tab, purchase, session0),
									elm$core$Platform$Cmd$none);
							default:
								return loadInventory;
						}
					} else {
						return loadInventory;
					}
				}
			} else {
				return _Utils_Tuple2(
					A4(author$project$Page$MtxShop$Model, notAsked, tab, purchase, session0),
					cmd);
			}
		} else {
			return _Utils_Tuple2(
				A4(author$project$Page$MtxShop$Model, notAsked, tab, purchase, session0),
				elm$core$Platform$Cmd$none);
		}
	});
var author$project$Page$MtxShop$create = F3(
	function (tab, paypalReturnArgs, session0) {
		return A3(
			author$project$Page$MtxShop$recreate,
			tab,
			A2(
				elm$core$Maybe$map,
				author$project$Page$MtxShop$PaypalPurchase(krisajenkins$remotedata$RemoteData$NotAsked),
				paypalReturnArgs),
			session0);
	});
var author$project$Page$Options$Model = elm$core$Basics$identity;
var author$project$Page$Options$create = function (session) {
	return {ah: krisajenkins$remotedata$RemoteData$NotAsked, f: session};
};
var author$project$Page$PaypalDone$GotSession = elm$core$Basics$identity;
var author$project$Page$PaypalDone$Model = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var author$project$Game$UnitsSnapshot$isNameVisible = function (name) {
	return A2(
		elm$core$Basics$composeR,
		author$project$Game$UnitsSnapshot$visibleNames,
		elm$core$Set$member(name));
};
var author$project$Route$MtxShop = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var elm$url$Url$percentEncode = _Url_percentEncode;
var elm$url$Url$Builder$QueryParameter = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var elm$url$Url$Builder$string = F2(
	function (key, value) {
		return A2(
			elm$url$Url$Builder$QueryParameter,
			elm$url$Url$percentEncode(key),
			elm$url$Url$percentEncode(value));
	});
var author$project$Route$paypalReturnArgsToBuilder = function (args) {
	return _List_fromArray(
		[
			A2(elm$url$Url$Builder$string, 'tx', args.bG)
		]);
};
var elm$core$List$singleton = function (value) {
	return _List_fromArray(
		[value]);
};
var author$project$Route$toBuilder = function (route) {
	switch (route.$) {
		case 0:
			return _Utils_Tuple2('/', _List_Nil);
		case 1:
			return _Utils_Tuple2('/debug', _List_Nil);
		case 2:
			var tab = route.a;
			return _Utils_Tuple2('/tab/' + tab, _List_Nil);
		case 3:
			var tab = route.a;
			var paypalReturnArgs = route.b;
			return _Utils_Tuple2(
				'/tab/' + (tab + '/unit/crystal'),
				A3(elm_community$maybe_extra$Maybe$Extra$unwrap, _List_Nil, author$project$Route$paypalReturnArgsToBuilder, paypalReturnArgs));
		case 4:
			var tab = route.a;
			var unit_ = route.b;
			var n = route.c.dz;
			return _Utils_Tuple2(
				'/tab/' + (tab + ('/unit/' + unit_)),
				A3(
					elm_community$maybe_extra$Maybe$Extra$unwrap,
					_List_Nil,
					A2(
						elm$core$Basics$composeR,
						elm$url$Url$Builder$string('n'),
						elm$core$List$singleton),
					n));
		case 5:
			var tab = route.a;
			var spell = route.b;
			return _Utils_Tuple2('/tab/' + (tab + ('/spell/' + spell)), _List_Nil);
		case 6:
			return _Utils_Tuple2('/achievements', _List_Nil);
		case 7:
			return _Utils_Tuple2('/options', _List_Nil);
		case 8:
			return _Utils_Tuple2('/statistics', _List_Nil);
		case 9:
			return _Utils_Tuple2('/changelog', _List_Nil);
		case 10:
			return _Utils_Tuple2('/auth/user', _List_Nil);
		case 11:
			return _Utils_Tuple2('/auth/user/orders', _List_Nil);
		case 12:
			return _Utils_Tuple2('/auth/login', _List_Nil);
		case 13:
			return _Utils_Tuple2('/auth/register', _List_Nil);
		case 14:
			return _Utils_Tuple2('/auth/password', _List_Nil);
		case 15:
			return _Utils_Tuple2('/paypal/error', _List_Nil);
		case 16:
			return _Utils_Tuple2('/moremenu', _List_Nil);
		default:
			return _Utils_Tuple2('/translator', _List_Nil);
	}
};
var author$project$Route$Feature$defaultValue = function (f) {
	switch (f) {
		case 4:
			return true;
		case 5:
			return true;
		default:
			return false;
	}
};
var author$project$Route$Feature$stringToBool = function (val) {
	switch (val) {
		case '0':
			return false;
		case '':
			return false;
		default:
			return true;
	}
};
var author$project$Route$Feature$toString = function (feature) {
	switch (feature) {
		case 0:
			return 'debug';
		case 1:
			return 'fps';
		case 2:
			return 'kongregate';
		case 3:
			return 'translator';
		case 4:
			return 'mtx';
		default:
			return 'mobileui';
	}
};
var author$project$Route$Feature$isActive = function (feature) {
	return A2(
		elm$core$Basics$composeR,
		elm$core$Dict$get(
			author$project$Route$Feature$toString(feature)),
		A2(
			elm_community$maybe_extra$Maybe$Extra$unwrap,
			author$project$Route$Feature$defaultValue(feature),
			author$project$Route$Feature$stringToBool));
};
var author$project$Route$Feature$Debug = 0;
var author$project$Route$Feature$Fps = 1;
var author$project$Route$Feature$Kongregate = 2;
var author$project$Route$Feature$MobileUI = 5;
var author$project$Route$Feature$Mtx = 4;
var author$project$Route$Feature$Translator = 3;
var author$project$Route$Feature$list = _List_fromArray(
	[0, 1, 2, 3, 4, 5]);
var author$project$Route$Feature$remove = function (f) {
	return elm$core$Dict$remove(
		author$project$Route$Feature$toString(f));
};
var author$project$Route$Feature$filterDefaults = function (query) {
	var fold = F2(
		function (f, q) {
			return _Utils_eq(
				A2(author$project$Route$Feature$isActive, f, q),
				author$project$Route$Feature$defaultValue(f)) ? A2(author$project$Route$Feature$remove, f, q) : q;
		});
	return A3(elm$core$List$foldl, fold, query, author$project$Route$Feature$list);
};
var author$project$Route$QueryDict$toQueryParameters = A2(
	elm$core$Basics$composeR,
	author$project$Route$Feature$filterDefaults,
	A2(
		elm$core$Basics$composeR,
		elm$core$Dict$toList,
		elm$core$List$map(
			function (_n0) {
				var k = _n0.a;
				var v = _n0.b;
				return A2(elm$url$Url$Builder$string, k, v);
			})));
var elm$url$Url$Builder$toQueryPair = function (_n0) {
	var key = _n0.a;
	var value = _n0.b;
	return key + ('=' + value);
};
var elm$url$Url$Builder$toQuery = function (parameters) {
	if (!parameters.b) {
		return '';
	} else {
		return '?' + A2(
			elm$core$String$join,
			'&',
			A2(elm$core$List$map, elm$url$Url$Builder$toQueryPair, parameters));
	}
};
var author$project$Route$toString = F2(
	function (query, route) {
		var _n0 = author$project$Route$toBuilder(route);
		var path = _n0.a;
		var qs = _n0.b;
		return _Utils_ap(
			path,
			elm$url$Url$Builder$toQuery(
				_Utils_ap(
					qs,
					author$project$Route$QueryDict$toQueryParameters(
						A2(elm$core$Dict$remove, 'n', query)))));
	});
var elm$browser$Browser$External = function (a) {
	return {$: 1, a: a};
};
var elm$browser$Browser$Internal = function (a) {
	return {$: 0, a: a};
};
var elm$browser$Browser$Dom$NotFound = elm$core$Basics$identity;
var elm$core$Basics$never = function (_n0) {
	never:
	while (true) {
		var nvr = _n0;
		var $temp$_n0 = nvr;
		_n0 = $temp$_n0;
		continue never;
	}
};
var elm$core$Task$Perform = elm$core$Basics$identity;
var elm$core$Task$init = elm$core$Task$succeed(0);
var elm$core$Task$map = F2(
	function (func, taskA) {
		return A2(
			elm$core$Task$andThen,
			function (a) {
				return elm$core$Task$succeed(
					func(a));
			},
			taskA);
	});
var elm$core$Task$spawnCmd = F2(
	function (router, _n0) {
		var task = _n0;
		return _Scheduler_spawn(
			A2(
				elm$core$Task$andThen,
				elm$core$Platform$sendToApp(router),
				task));
	});
var elm$core$Task$onEffects = F3(
	function (router, commands, state) {
		return A2(
			elm$core$Task$map,
			function (_n0) {
				return 0;
			},
			elm$core$Task$sequence(
				A2(
					elm$core$List$map,
					elm$core$Task$spawnCmd(router),
					commands)));
	});
var elm$core$Task$onSelfMsg = F3(
	function (_n0, _n1, _n2) {
		return elm$core$Task$succeed(0);
	});
var elm$core$Task$cmdMap = F2(
	function (tagger, _n0) {
		var task = _n0;
		return A2(elm$core$Task$map, tagger, task);
	});
_Platform_effectManagers['Task'] = _Platform_createManager(elm$core$Task$init, elm$core$Task$onEffects, elm$core$Task$onSelfMsg, elm$core$Task$cmdMap);
var elm$core$Task$command = _Platform_leaf('Task');
var elm$core$Task$perform = F2(
	function (toMessage, task) {
		return elm$core$Task$command(
			A2(elm$core$Task$map, toMessage, task));
	});
var elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
	switch (handler.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var elm$core$String$dropLeft = F2(
	function (n, string) {
		return (n < 1) ? string : A3(
			elm$core$String$slice,
			n,
			elm$core$String$length(string),
			string);
	});
var elm$core$String$startsWith = _String_startsWith;
var elm$url$Url$Http = 0;
var elm$url$Url$Https = 1;
var elm$core$String$indexes = _String_indexes;
var elm$core$String$left = F2(
	function (n, string) {
		return (n < 1) ? '' : A3(elm$core$String$slice, 0, n, string);
	});
var elm$core$String$contains = _String_contains;
var elm$url$Url$Url = F6(
	function (protocol, host, port_, path, query, fragment) {
		return {di: fragment, $7: host, aA: path, dF: port_, dK: protocol, fn: query};
	});
var elm$url$Url$chompBeforePath = F5(
	function (protocol, path, params, frag, str) {
		if (elm$core$String$isEmpty(str) || A2(elm$core$String$contains, '@', str)) {
			return elm$core$Maybe$Nothing;
		} else {
			var _n0 = A2(elm$core$String$indexes, ':', str);
			if (!_n0.b) {
				return elm$core$Maybe$Just(
					A6(elm$url$Url$Url, protocol, str, elm$core$Maybe$Nothing, path, params, frag));
			} else {
				if (!_n0.b.b) {
					var i = _n0.a;
					var _n1 = elm$core$String$toInt(
						A2(elm$core$String$dropLeft, i + 1, str));
					if (_n1.$ === 1) {
						return elm$core$Maybe$Nothing;
					} else {
						var port_ = _n1;
						return elm$core$Maybe$Just(
							A6(
								elm$url$Url$Url,
								protocol,
								A2(elm$core$String$left, i, str),
								port_,
								path,
								params,
								frag));
					}
				} else {
					return elm$core$Maybe$Nothing;
				}
			}
		}
	});
var elm$url$Url$chompBeforeQuery = F4(
	function (protocol, params, frag, str) {
		if (elm$core$String$isEmpty(str)) {
			return elm$core$Maybe$Nothing;
		} else {
			var _n0 = A2(elm$core$String$indexes, '/', str);
			if (!_n0.b) {
				return A5(elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
			} else {
				var i = _n0.a;
				return A5(
					elm$url$Url$chompBeforePath,
					protocol,
					A2(elm$core$String$dropLeft, i, str),
					params,
					frag,
					A2(elm$core$String$left, i, str));
			}
		}
	});
var elm$url$Url$chompBeforeFragment = F3(
	function (protocol, frag, str) {
		if (elm$core$String$isEmpty(str)) {
			return elm$core$Maybe$Nothing;
		} else {
			var _n0 = A2(elm$core$String$indexes, '?', str);
			if (!_n0.b) {
				return A4(elm$url$Url$chompBeforeQuery, protocol, elm$core$Maybe$Nothing, frag, str);
			} else {
				var i = _n0.a;
				return A4(
					elm$url$Url$chompBeforeQuery,
					protocol,
					elm$core$Maybe$Just(
						A2(elm$core$String$dropLeft, i + 1, str)),
					frag,
					A2(elm$core$String$left, i, str));
			}
		}
	});
var elm$url$Url$chompAfterProtocol = F2(
	function (protocol, str) {
		if (elm$core$String$isEmpty(str)) {
			return elm$core$Maybe$Nothing;
		} else {
			var _n0 = A2(elm$core$String$indexes, '#', str);
			if (!_n0.b) {
				return A3(elm$url$Url$chompBeforeFragment, protocol, elm$core$Maybe$Nothing, str);
			} else {
				var i = _n0.a;
				return A3(
					elm$url$Url$chompBeforeFragment,
					protocol,
					elm$core$Maybe$Just(
						A2(elm$core$String$dropLeft, i + 1, str)),
					A2(elm$core$String$left, i, str));
			}
		}
	});
var elm$url$Url$fromString = function (str) {
	return A2(elm$core$String$startsWith, 'http://', str) ? A2(
		elm$url$Url$chompAfterProtocol,
		0,
		A2(elm$core$String$dropLeft, 7, str)) : (A2(elm$core$String$startsWith, 'https://', str) ? A2(
		elm$url$Url$chompAfterProtocol,
		1,
		A2(elm$core$String$dropLeft, 8, str)) : elm$core$Maybe$Nothing);
};
var elm$browser$Browser$Navigation$pushUrl = _Browser_pushUrl;
var author$project$Route$pushUrl = F3(
	function (key, query, route) {
		return A2(
			elm$browser$Browser$Navigation$pushUrl,
			key,
			A2(author$project$Route$toString, query, route));
	});
var author$project$Session$nav = A2(
	elm$core$Basics$composeR,
	author$project$Session$unwrap,
	function ($) {
		return $.cl;
	});
var author$project$Page$PaypalDone$update = F2(
	function (msg, model0) {
		var session0 = model0.a;
		var args = model0.b;
		var session = msg;
		return _Utils_Tuple2(
			A2(author$project$Page$PaypalDone$Model, session, args),
			function () {
				var _n1 = author$project$Session$game(session);
				if (_n1.$ === 3) {
					var game = _n1.a;
					var tab = A2(
						author$project$Game$UnitsSnapshot$isNameVisible,
						'energy',
						author$project$Game$units(game)) ? 'energy' : 'all';
					return A3(
						author$project$Route$pushUrl,
						author$project$Session$nav(session),
						author$project$Session$query(session),
						A2(author$project$Route$MtxShop, tab, args));
				} else {
					return elm$core$Platform$Cmd$none;
				}
			}());
	});
var author$project$Page$PaypalDone$create = F3(
	function (session, status, args) {
		return A2(
			author$project$Page$PaypalDone$update,
			session,
			A2(author$project$Page$PaypalDone$Model, session, args));
	});
var author$project$Page$Register$Model = elm$core$Basics$identity;
var author$project$Page$Register$create = function (session_) {
	return {bW: '', cq: '', bu: '', bv: false, a$: krisajenkins$remotedata$RemoteData$NotAsked, f: session_};
};
var author$project$Page$ResetPassword$Model = elm$core$Basics$identity;
var author$project$PlayFab$User$email = A2(
	elm$core$Basics$composeR,
	author$project$PlayFab$User$unwrap,
	function ($) {
		return $.bW;
	});
var author$project$Page$ResetPassword$create = function (session_) {
	return {
		bW: function () {
			var _n0 = author$project$Session$user(session_);
			if ((_n0.$ === 3) && (!_n0.a.$)) {
				var user = _n0.a.a;
				return A2(
					elm$core$Maybe$withDefault,
					'',
					author$project$PlayFab$User$email(user));
			} else {
				return '';
			}
		}(),
		a$: krisajenkins$remotedata$RemoteData$NotAsked,
		f: session_
	};
};
var author$project$Page$Spell$Model = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var author$project$Page$Spell$create = F3(
	function (tab, spell, session0) {
		var _n0 = author$project$Session$game(session0);
		if (_n0.$ === 3) {
			var game0 = _n0.a;
			var _n1 = A2(
				author$project$Session$persistWrite,
				session0,
				A3(
					author$project$Game$setLastUnitByTab,
					tab,
					elm$core$Maybe$Just(spell),
					game0));
			var game = _n1.a;
			var cmd = _n1.b;
			return _Utils_Tuple2(
				A3(
					author$project$Page$Spell$Model,
					tab,
					spell,
					A3(author$project$Session$setGame, false, game, session0)),
				cmd);
		} else {
			return _Utils_Tuple2(
				A3(author$project$Page$Spell$Model, tab, spell, session0),
				elm$core$Platform$Cmd$none);
		}
	});
var author$project$Page$Tab$Model = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var author$project$Page$Tab$create = F2(
	function (tab, session0) {
		var _n0 = author$project$Session$game(session0);
		if (_n0.$ === 3) {
			var game0 = _n0.a;
			var _n1 = A2(
				author$project$Session$persistWrite,
				session0,
				A3(author$project$Game$setLastUnitByTab, tab, elm$core$Maybe$Nothing, game0));
			var game = _n1.a;
			var cmd = _n1.b;
			return _Utils_Tuple2(
				A2(
					author$project$Page$Tab$Model,
					tab,
					A3(author$project$Session$setGame, false, game, session0)),
				cmd);
		} else {
			return _Utils_Tuple2(
				A2(author$project$Page$Tab$Model, tab, session0),
				elm$core$Platform$Cmd$none);
		}
	});
var author$project$Page$Translator$Model = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var author$project$GameData$lang = F2(
	function (e0, _n0) {
		var l = _n0.c;
		if (e0.$ === 1) {
			return l;
		} else {
			var e = e0.a;
			return _Utils_update(
				l,
				{
					dd: A2(elm$core$Dict$union, e, l.dd)
				});
		}
	});
var author$project$Session$GameLoader$gameData = function (loader) {
	if (loader.$ === 1) {
		var game = loader.a.ae;
		return elm$core$Result$Ok(
			author$project$Game$gameData(game));
	} else {
		var gd = loader.a;
		return gd;
	}
};
var author$project$Session$gameData = A2(
	elm$core$Basics$composeR,
	author$project$Session$unwrap,
	A2(
		elm$core$Basics$composeR,
		function ($) {
			return $.ae;
		},
		author$project$Session$GameLoader$gameData));
var elm$core$Result$withDefault = F2(
	function (def, result) {
		if (!result.$) {
			var a = result.a;
			return a;
		} else {
			return def;
		}
	});
var author$project$Page$Translator$defaultText = A2(
	elm$core$Basics$composeR,
	author$project$Session$gameData,
	A2(
		elm$core$Basics$composeR,
		elm$core$Result$map(
			A2(
				elm$core$Basics$composeR,
				author$project$GameData$lang(elm$core$Maybe$Nothing),
				A2(
					elm$core$Basics$composeR,
					function ($) {
						return $.fo;
					},
					A2(
						elm$core$Basics$composeR,
						elm$core$List$map(
							elm$core$Tuple$mapSecond(
								A2(
									elm$core$Basics$composeR,
									elm$core$List$map(
										elm$core$Tuple$mapSecond(elm$json$Json$Encode$string)),
									elm$json$Json$Encode$object))),
						A2(
							elm$core$Basics$composeR,
							elm$json$Json$Encode$object,
							elm$json$Json$Encode$encode(2)))))),
		elm$core$Result$withDefault('{\n  \"header\": {\n    \"message\": \"Swarm Simulator\"\n  }\n}')));
var author$project$Session$translatorJson = A2(
	elm$core$Basics$composeR,
	author$project$Session$unwrap,
	A2(
		elm$core$Basics$composeR,
		function ($) {
			return $.cJ;
		},
		elm$core$Maybe$map(elm$core$Tuple$second)));
var author$project$Page$Translator$create = function (session) {
	var txt = A2(
		elm$core$Maybe$withDefault,
		author$project$Page$Translator$defaultText(session),
		A2(
			elm$core$Maybe$map,
			elm$json$Json$Encode$encode(2),
			author$project$Session$translatorJson(session)));
	return _Utils_Tuple2(
		A3(author$project$Page$Translator$Model, session, krisajenkins$remotedata$RemoteData$NotAsked, txt),
		elm$core$Platform$Cmd$none);
};
var author$project$Page$Unit$Model = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var author$project$Page$Unit$create = F4(
	function (tab, unit, ns, session0) {
		var _n0 = author$project$Session$game(session0);
		if (_n0.$ === 3) {
			var game0 = _n0.a;
			var _n1 = A2(
				author$project$Session$persistWrite,
				session0,
				A3(
					author$project$Game$setLastUnitByTab,
					tab,
					elm$core$Maybe$Just(unit),
					game0));
			var game = _n1.a;
			var cmd = _n1.b;
			return _Utils_Tuple2(
				A4(
					author$project$Page$Unit$Model,
					tab,
					unit,
					ns,
					A3(author$project$Session$setGame, false, game, session0)),
				cmd);
		} else {
			return _Utils_Tuple2(
				A4(author$project$Page$Unit$Model, tab, unit, ns, session0),
				elm$core$Platform$Cmd$none);
		}
	});
var author$project$Route$Tab = function (a) {
	return {$: 2, a: a};
};
var author$project$FrameRate$Empty = {$: 0};
var author$project$FrameRate$empty = author$project$FrameRate$Empty;
var author$project$Session$setQuery = F2(
	function (q, _n0) {
		var s = _n0;
		return _Utils_eq(s.fn, q) ? s : _Utils_update(
			s,
			{
				ad: A2(author$project$Route$Feature$isActive, 1, q) ? elm$core$Maybe$Just(
					A2(elm$core$Maybe$withDefault, author$project$FrameRate$empty, s.ad)) : elm$core$Maybe$Nothing,
				fn: q
			});
	});
var elm$core$Platform$Cmd$map = _Platform_map;
var elm$core$Result$toMaybe = function (result) {
	if (!result.$) {
		var v = result.a;
		return elm$core$Maybe$Just(v);
	} else {
		return elm$core$Maybe$Nothing;
	}
};
var elm$core$Tuple$mapBoth = F3(
	function (funcA, funcB, _n0) {
		var x = _n0.a;
		var y = _n0.b;
		return _Utils_Tuple2(
			funcA(x),
			funcB(y));
	});
var author$project$Main$changeRouteTo = F3(
	function (route, query, model) {
		changeRouteTo:
		while (true) {
			var session = A2(
				author$project$Session$setQuery,
				query,
				author$project$Main$toSession(model));
			if (route.$ === 1) {
				return _Utils_Tuple2(
					author$project$Main$NotFound(session),
					elm$core$Platform$Cmd$none);
			} else {
				switch (route.a.$) {
					case 0:
						var _n1 = route.a;
						var homeTab = A2(
							elm$core$Maybe$map,
							author$project$GameData$Tab$name,
							A2(
								elm$core$Maybe$andThen,
								author$project$GameData$homeTab,
								elm$core$Result$toMaybe(
									author$project$Session$gameData(session))));
						var $temp$route = A2(elm$core$Maybe$map, author$project$Route$Tab, homeTab),
							$temp$query = author$project$Session$query(session),
							$temp$model = model;
						route = $temp$route;
						query = $temp$query;
						model = $temp$model;
						continue changeRouteTo;
					case 1:
						var _n2 = route.a;
						return A2(author$project$Route$Feature$isActive, 0, query) ? A2(
							elm$core$Tuple$mapFirst,
							author$project$Main$Debug,
							author$project$Page$Debug$init(session)) : _Utils_Tuple2(
							author$project$Main$NotFound(session),
							elm$core$Platform$Cmd$none);
					case 2:
						var tabSlug = route.a.a;
						return A3(
							elm$core$Tuple$mapBoth,
							author$project$Main$Tab,
							elm$core$Platform$Cmd$map(author$project$Main$GotTabMsg),
							A2(author$project$Page$Tab$create, tabSlug, session));
					case 3:
						var _n3 = route.a;
						var tabName = _n3.a;
						var paypalReturnArgs = _n3.b;
						return A3(
							elm$core$Tuple$mapBoth,
							author$project$Main$MtxShop,
							elm$core$Platform$Cmd$map(author$project$Main$GotMtxShopMsg),
							A3(author$project$Page$MtxShop$create, tabName, paypalReturnArgs, session));
					case 4:
						var _n4 = route.a;
						var tabName = _n4.a;
						var unitName = _n4.b;
						var ns = _n4.c;
						return A3(
							elm$core$Tuple$mapBoth,
							author$project$Main$Unit,
							elm$core$Platform$Cmd$map(author$project$Main$GotUnitMsg),
							A4(author$project$Page$Unit$create, tabName, unitName, ns, session));
					case 5:
						var _n5 = route.a;
						var tabName = _n5.a;
						var spellName = _n5.b;
						return A3(
							elm$core$Tuple$mapBoth,
							author$project$Main$Spell,
							elm$core$Platform$Cmd$map(author$project$Main$GotSpellMsg),
							A3(author$project$Page$Spell$create, tabName, spellName, session));
					case 6:
						var _n6 = route.a;
						return _Utils_Tuple2(
							author$project$Main$Achievements(session),
							elm$core$Platform$Cmd$none);
					case 7:
						var _n7 = route.a;
						return _Utils_Tuple2(
							author$project$Main$Options(
								author$project$Page$Options$create(session)),
							elm$core$Platform$Cmd$none);
					case 8:
						var _n8 = route.a;
						return _Utils_Tuple2(
							author$project$Main$Statistics(session),
							elm$core$Platform$Cmd$none);
					case 9:
						var _n9 = route.a;
						return A2(
							elm$core$Tuple$mapFirst,
							author$project$Main$Changelog,
							author$project$Page$Changelog$create(session));
					case 10:
						var _n10 = route.a;
						return _Utils_Tuple2(
							author$project$Main$User(session),
							elm$core$Platform$Cmd$none);
					case 11:
						var _n11 = route.a;
						return A3(
							elm$core$Tuple$mapBoth,
							author$project$Main$MtxHistory,
							elm$core$Platform$Cmd$map(author$project$Main$GotMtxHistoryMsg),
							author$project$Page$MtxHistory$create(session));
					case 13:
						var _n12 = route.a;
						return _Utils_Tuple2(
							author$project$Main$Register(
								author$project$Page$Register$create(session)),
							elm$core$Platform$Cmd$none);
					case 12:
						var _n13 = route.a;
						return _Utils_Tuple2(
							author$project$Main$Login(
								author$project$Page$Login$create(session)),
							elm$core$Platform$Cmd$none);
					case 14:
						var _n14 = route.a;
						return _Utils_Tuple2(
							author$project$Main$ResetPassword(
								author$project$Page$ResetPassword$create(session)),
							elm$core$Platform$Cmd$none);
					case 15:
						var _n15 = route.a;
						var status = _n15.a;
						var args = _n15.b;
						return A3(
							elm$core$Tuple$mapBoth,
							author$project$Main$PaypalDone,
							elm$core$Platform$Cmd$map(author$project$Main$GotPaypalDoneMsg),
							A3(author$project$Page$PaypalDone$create, session, status, args));
					case 16:
						var _n16 = route.a;
						return _Utils_Tuple2(
							author$project$Main$MoreMenu(session),
							elm$core$Platform$Cmd$none);
					default:
						var _n17 = route.a;
						return A3(
							elm$core$Tuple$mapBoth,
							author$project$Main$Translator,
							elm$core$Platform$Cmd$map(author$project$Main$GotTranslatorMsg),
							author$project$Page$Translator$create(session));
				}
			}
		}
	});
var author$project$Main$GotUser = function (a) {
	return {$: 9, a: a};
};
var author$project$PlayFab$infoRequestParameters = elm$json$Json$Encode$object(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'GetUserData',
			elm$json$Json$Encode$bool(true)),
			_Utils_Tuple2(
			'GetUserReadOnlyData',
			elm$json$Json$Encode$bool(true)),
			_Utils_Tuple2(
			'GetUserAccountInfo',
			elm$json$Json$Encode$bool(true))
		]));
var author$project$PlayFab$User$decoderConfig = {bW: elm$core$Maybe$Nothing, fQ: elm$core$Maybe$Nothing};
var author$project$PlayFab$userDecoderConfig = author$project$PlayFab$User$decoderConfig;
var NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded = A2(elm$core$Basics$composeR, elm$json$Json$Decode$succeed, NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom);
var NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt = F4(
	function (path, valDecoder, fallback, decoder) {
		return A2(
			NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A3(
				NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder,
				A2(elm$json$Json$Decode$at, path, elm$json$Json$Decode$value),
				valDecoder,
				fallback),
			decoder);
	});
var NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt = F3(
	function (path, valDecoder, decoder) {
		return A2(
			NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2(elm$json$Json$Decode$at, path, valDecoder),
			decoder);
	});
var elm$json$Json$Decode$lazy = function (thunk) {
	return A2(
		elm$json$Json$Decode$andThen,
		thunk,
		elm$json$Json$Decode$succeed(0));
};
var author$project$PlayFab$ChunkedState$decoder = F2(
	function (prefix, nested) {
		var loop1 = function (i) {
			return A2(
				elm$json$Json$Decode$at,
				A2(
					elm$core$List$cons,
					_Utils_ap(
						prefix,
						elm$core$String$fromInt(i)),
					nested),
				elm$json$Json$Decode$string);
		};
		var loop = F2(
			function (i, chunks) {
				return elm$json$Json$Decode$oneOf(
					_List_fromArray(
						[
							A2(
							elm$json$Json$Decode$andThen,
							function (chunk) {
								return elm$json$Json$Decode$lazy(
									function (_n0) {
										return A2(
											loop,
											i + 1,
											A2(elm$core$List$cons, chunk, chunks));
									});
							},
							loop1(i)),
							elm$json$Json$Decode$succeed(chunks)
						]));
			});
		return A2(
			elm$json$Json$Decode$map,
			A2(
				elm$core$Basics$composeR,
				elm$core$List$reverse,
				elm$core$String$join('')),
			A2(
				elm$json$Json$Decode$andThen,
				function (s) {
					return A2(
						loop,
						1,
						_List_fromArray(
							[s]));
				},
				A2(
					elm$json$Json$Decode$at,
					A2(elm$core$List$cons, prefix, nested),
					elm$json$Json$Decode$string)));
	});
var author$project$PlayFab$User$Data = F7(
	function (id, sessionTicket, rememberId, role, email, displayName, game) {
		return {ew: displayName, bW: email, ae: game, eL: id, bw: rememberId, dS: role, bz: sessionTicket};
	});
var author$project$PlayFab$User$PlayerRole = 0;
var author$project$PlayFab$User$User = elm$core$Basics$identity;
var author$project$PlayFab$User$Id = elm$core$Basics$identity;
var author$project$PlayFab$User$idDecoder = A2(elm$json$Json$Decode$map, elm$core$Basics$identity, elm$json$Json$Decode$string);
var author$project$PlayFab$User$RememberId = elm$core$Basics$identity;
var author$project$PlayFab$User$rememberIdDecoder = A2(elm$json$Json$Decode$map, elm$core$Basics$identity, elm$json$Json$Decode$string);
var author$project$PlayFab$User$AdminRole = 1;
var author$project$PlayFab$User$roleDecoder = A2(
	elm$json$Json$Decode$andThen,
	function (str) {
		switch (str) {
			case 'admin':
				return elm$json$Json$Decode$succeed(1);
			case 'player':
				return elm$json$Json$Decode$succeed(0);
			default:
				var other = str;
				return elm$json$Json$Decode$fail('invalid role: ' + other);
		}
	},
	elm$json$Json$Decode$string);
var author$project$PlayFab$User$SessionTicket = elm$core$Basics$identity;
var author$project$PlayFab$User$sessionTicketDecoder = A2(elm$json$Json$Decode$map, elm$core$Basics$identity, elm$json$Json$Decode$string);
var author$project$PlayFab$User$stateKey = 'elm-state';
var author$project$PlayFab$User$decoder = function (r) {
	return A2(
		elm$json$Json$Decode$map,
		elm$core$Basics$identity,
		A2(
			NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			elm$json$Json$Decode$maybe(
				A2(
					elm$json$Json$Decode$at,
					_List_fromArray(
						['data', 'InfoResultPayload', 'UserData']),
					A2(
						elm$json$Json$Decode$map,
						elm$core$Tuple$pair(krisajenkins$remotedata$RemoteData$NotAsked),
						A2(
							author$project$PlayFab$ChunkedState$decoder,
							author$project$PlayFab$User$stateKey,
							_List_fromArray(
								['Value']))))),
			A2(
				NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
				elm$json$Json$Decode$oneOf(
					_List_fromArray(
						[
							A2(
							elm$json$Json$Decode$at,
							_List_fromArray(
								['data', 'InfoResultPayload', 'AccountInfo', 'PrivateInfo', 'Email']),
							elm$json$Json$Decode$string),
							A2(
							elm$json$Json$Decode$at,
							_List_fromArray(
								['data', 'InfoResultPayload', 'AccountInfo', 'Username']),
							elm$json$Json$Decode$string),
							A3(
							elm_community$maybe_extra$Maybe$Extra$unwrap,
							elm$json$Json$Decode$fail('no hardcoded email'),
							elm$json$Json$Decode$succeed,
							r.bW),
							A2(
							elm$json$Json$Decode$at,
							_List_fromArray(
								['data', 'PlayFabId']),
							elm$json$Json$Decode$string)
						])),
				A4(
					NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
					_List_fromArray(
						['data', 'InfoResultPayload', 'AccountInfo', 'PrivateInfo', 'Email']),
					A2(elm$json$Json$Decode$map, elm$core$Maybe$Just, elm$json$Json$Decode$string),
					r.bW,
					A4(
						NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
						_List_fromArray(
							['data', 'InfoResultPayload', 'UserReadOnlyData', 'role', 'Value']),
						author$project$PlayFab$User$roleDecoder,
						0,
						A4(
							NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
							_List_fromArray(
								['data', 'InfoResultPayload', 'AccountInfo', 'CustomIdInfo', 'CustomId']),
							A2(elm$json$Json$Decode$map, elm$core$Maybe$Just, author$project$PlayFab$User$rememberIdDecoder),
							elm$core$Maybe$Nothing,
							function () {
								var _n0 = r.fQ;
								if (_n0.$ === 1) {
									return A2(
										NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
										_List_fromArray(
											['data', 'SessionTicket']),
										author$project$PlayFab$User$sessionTicketDecoder);
								} else {
									var t = _n0.a;
									return NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded(t);
								}
							}()(
								A3(
									NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
									_List_fromArray(
										['data', 'PlayFabId']),
									author$project$PlayFab$User$idDecoder,
									elm$json$Json$Decode$succeed(author$project$PlayFab$User$Data)))))))));
};
var author$project$Session$Iframe$Kongregate$gameAuthTokenToFullString = function (_n0) {
	var t = _n0;
	return t;
};
var author$project$Session$Iframe$Kongregate$userIdToString = function (_n0) {
	var id = _n0;
	return id;
};
var elm$http$Http$post = function (r) {
	return elm$http$Http$request(
		{cZ: r.cZ, z: r.z, as: _List_Nil, aw: 'POST', aH: elm$core$Maybe$Nothing, aJ: elm$core$Maybe$Nothing, B: r.B});
};
var author$project$PlayFab$kongregateLogin = F4(
	function (id, kongId, kongAuthToken, toMsg) {
		return elm$http$Http$post(
			{
				cZ: elm$http$Http$jsonBody(
					elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'TitleId',
								author$project$PlayFab$TitleId$encode(id)),
								_Utils_Tuple2(
								'KongregateId',
								elm$json$Json$Encode$string(
									author$project$Session$Iframe$Kongregate$userIdToString(kongId))),
								_Utils_Tuple2(
								'AuthTicket',
								elm$json$Json$Encode$string(
									author$project$Session$Iframe$Kongregate$gameAuthTokenToFullString(kongAuthToken))),
								_Utils_Tuple2(
								'CreateAccount',
								elm$json$Json$Encode$bool(true)),
								_Utils_Tuple2('InfoRequestParameters', author$project$PlayFab$infoRequestParameters)
							]))),
				z: A2(
					author$project$PlayFab$expectJson,
					toMsg,
					author$project$PlayFab$User$decoder(author$project$PlayFab$userDecoderConfig)),
				B: author$project$PlayFab$TitleId$host(id) + '/Client/LoginWithKongregate'
			});
	});
var author$project$Ports$Kongregate$kongregateInit = _Platform_outgoingPort(
	'kongregateInit',
	function ($) {
		return elm$json$Json$Encode$null;
	});
var author$project$Session$Iframe$Kongregate = function (a) {
	return {$: 1, a: a};
};
var author$project$Route$Config$Iframe = 3;
var author$project$Session$Iframe$WWW = {$: 0};
var author$project$Session$Iframe$Kongregate$GameAuthToken = elm$core$Basics$identity;
var author$project$Session$Iframe$Kongregate$User = F4(
	function (userId, username, gameAuthToken, isGuest) {
		return {dk: gameAuthToken, eV: isGuest, bH: userId, fZ: username};
	});
var author$project$Session$Iframe$Kongregate$UserId = elm$core$Basics$identity;
var author$project$Session$Iframe$Kongregate$fromQuery = function (query) {
	return {
		ed: krisajenkins$remotedata$RemoteData$NotAsked,
		cQ: function () {
			var _n0 = _Utils_Tuple3(
				A2(elm$core$Dict$get, 'kongregate_user_id', query),
				A2(elm$core$Dict$get, 'kongregate_username', query),
				A2(elm$core$Dict$get, 'kongregate_game_auth_token', query));
			if (((!_n0.a.$) && (!_n0.b.$)) && (!_n0.c.$)) {
				var uid = _n0.a.a;
				var uname = _n0.b.a;
				var auth = _n0.c.a;
				return elm$core$Maybe$Just(
					A4(author$project$Session$Iframe$Kongregate$User, uid, uname, auth, uid === '0'));
			} else {
				return elm$core$Maybe$Nothing;
			}
		}()
	};
};
var author$project$Session$Iframe$kongregate = A2(elm$core$Basics$composeR, author$project$Session$Iframe$Kongregate$fromQuery, author$project$Session$Iframe$Kongregate);
var author$project$Session$Iframe$fromQuery = function (query) {
	if (A2(author$project$Route$Feature$isActive, 2, query)) {
		return author$project$Session$Iframe$kongregate(query);
	} else {
		var _n0 = A2(author$project$Route$Config$get, 3, query);
		if ((!_n0.$) && (_n0.a === 'kongregate')) {
			return author$project$Session$Iframe$kongregate(query);
		} else {
			return author$project$Session$Iframe$WWW;
		}
	}
};
var author$project$Main$initIframe = function (session) {
	var iframe = author$project$Session$Iframe$fromQuery(
		author$project$Session$query(session));
	if (iframe.$ === 1) {
		var kong = iframe.a;
		return _Utils_Tuple2(
			author$project$Session$Iframe$Kongregate(
				_Utils_update(
					kong,
					{ed: krisajenkins$remotedata$RemoteData$Loading})),
			elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						author$project$Ports$Kongregate$kongregateInit(0),
						function () {
						var _n1 = kong.cQ;
						if (!_n1.$) {
							var user = _n1.a;
							return user.eV ? elm$core$Platform$Cmd$none : A4(
								author$project$PlayFab$kongregateLogin,
								author$project$PlayFab$TitleId$fromSession(session),
								user.bH,
								user.dk,
								author$project$Main$GotUser);
						} else {
							return elm$core$Platform$Cmd$none;
						}
					}()
					])));
	} else {
		return _Utils_Tuple2(iframe, elm$core$Platform$Cmd$none);
	}
};
var author$project$Main$GotDebugMsg = function (a) {
	return {$: 28, a: a};
};
var author$project$Main$GotLoginMsg = function (a) {
	return {$: 39, a: a};
};
var author$project$Main$GotOptionsMsg = function (a) {
	return {$: 34, a: a};
};
var author$project$Main$GotRegisterMsg = function (a) {
	return {$: 40, a: a};
};
var author$project$Main$GotResetPasswordMsg = function (a) {
	return {$: 41, a: a};
};
var author$project$Page$Debug$GotSession = function (a) {
	return {$: 0, a: a};
};
var author$project$Game$debugNewAchievement = F3(
	function (now, achievement, _n0) {
		var g = _n0;
		return _Utils_update(
			g,
			{
				A: function () {
					var _n1 = g.A;
					if (_n1.$ === 1) {
						return elm$core$Maybe$Just(
							_Utils_Tuple3(now, achievement, _List_Nil));
					} else {
						var _n2 = _n1.a;
						var started = _n2.a;
						var first = _n2.b;
						var rest = _n2.c;
						return elm$core$Maybe$Just(
							_Utils_Tuple3(
								started,
								first,
								_Utils_ap(
									rest,
									_List_fromArray(
										[achievement]))));
					}
				}()
			});
	});
var author$project$Game$DecodeCreated = elm$core$Basics$identity;
var author$project$Game$DecodeEncoded = elm$core$Basics$identity;
var author$project$Game$DecodeNow = elm$core$Basics$identity;
var author$project$Game$DecodeSnapshotted = elm$core$Basics$identity;
var author$project$Game$HiddenVelocityUI = 0;
var author$project$Game$SimpleCostUI = 1;
var author$project$Game$AchievementsShown = F5(
	function (earned, unearned, masked, order, reverse) {
		return {bU: earned, ca: masked, co: order, cw: reverse, cK: unearned};
	});
var author$project$Game$AchievementsSortByDefault = 0;
var author$project$Game$AchievementsSortByCompletion = 1;
var author$project$Game$achievementsSortOrderByString = elm$core$Dict$fromList(
	A2(
		elm$core$List$map,
		function (o) {
			return _Utils_Tuple2(
				author$project$Game$achievementsSortOrderToString(o),
				o);
		},
		_List_fromArray(
			[0, 1])));
var author$project$Game$achievementsSortOrderFromString = function (name) {
	return A2(elm$core$Dict$get, name, author$project$Game$achievementsSortOrderByString);
};
var elm$json$Json$Decode$map5 = _Json_map5;
var author$project$Game$achievementsShownDecoder = A6(
	elm$json$Json$Decode$map5,
	author$project$Game$AchievementsShown,
	A2(elm$json$Json$Decode$field, 'earned', elm$json$Json$Decode$bool),
	A2(elm$json$Json$Decode$field, 'unearned', elm$json$Json$Decode$bool),
	A2(elm$json$Json$Decode$field, 'masked', elm$json$Json$Decode$bool),
	A2(
		elm$json$Json$Decode$field,
		'order',
		A2(
			elm$json$Json$Decode$map,
			A2(
				elm$core$Basics$composeR,
				author$project$Game$achievementsSortOrderFromString,
				elm$core$Maybe$withDefault(0)),
			elm$json$Json$Decode$string)),
	A2(elm$json$Json$Decode$field, 'reverse', elm$json$Json$Decode$bool));
var author$project$Game$FancyCostUI = 0;
var author$project$Game$costUIFromString = function (str) {
	switch (str) {
		case 'fancy':
			return 0;
		case 'simple':
			return 1;
		default:
			return 1;
	}
};
var author$project$Game$costUIDecoder = A2(elm$json$Json$Decode$map, author$project$Game$costUIFromString, elm$json$Json$Decode$string);
var author$project$Game$defaultAchievementsShown = {bU: true, ca: true, co: 0, cw: false, cK: true};
var author$project$Game$ProductionGraph$empty = A2(elm_community$graph$Graph$fromNodesAndEdges, _List_Nil, _List_Nil);
var author$project$Game$initFromDecoder = function (migration) {
	return function (gameData_) {
		return function (_n0) {
			return function (_n1) {
				return function (_n2) {
					return function (_n3) {
						return function (units_) {
							return function (upgrades) {
								return function (spells) {
									return function (locale_) {
										return function (theme_) {
											return function (numberFormat_) {
												return function (velocityUnit_) {
													return function (buyN_) {
														return function (watched_) {
															return function (lastUnitByTab_) {
																return function (randomSeeds_) {
																	return function (cooldown_) {
																		return function (statistics_) {
																			return function (achievements_) {
																				return function (costUI_) {
																					return function (velocityUI_) {
																						return function (achievementsShown_) {
																							return function (mtxHistory_) {
																								var now = _n0;
																								var created_ = _n1;
																								var snapshotted_ = _n2;
																								var encoded_ = _n3;
																								return author$project$Game$rebuildGraph(
																									migration(
																										function (g) {
																											return _Utils_update(
																												g,
																												{
																													aP: A2(author$project$Game$Achievement$statuses, g, achievements_)
																												});
																										}(
																											{
																												aO: A2(author$project$Game$Achievement$points, gameData_, achievements_),
																												aP: _List_Nil,
																												aQ: achievements_,
																												Y: achievementsShown_,
																												P: buyN_,
																												_: cooldown_,
																												aq: costUI_,
																												H: created_,
																												bj: encoded_,
																												D: gameData_,
																												aT: author$project$Game$ProductionGraph$empty,
																												S: lastUnitByTab_,
																												av: locale_,
																												U: mtxHistory_,
																												A: elm$core$Maybe$Nothing,
																												ay: numberFormat_,
																												aB: elm$core$Dict$empty,
																												W: randomSeeds_,
																												s: spells,
																												L: statistics_,
																												aG: theme_,
																												k: A4(author$project$Game$UnitsSnapshot$create, snapshotted_, units_, elm$core$Dict$empty, elm$core$Set$empty),
																												o: upgrades,
																												aK: velocityUI_,
																												aL: velocityUnit_,
																												an: watched_
																											})));
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var author$project$Game$UnitsSnapshot$mapCounts = F2(
	function (fn, _n0) {
		var data = _n0;
		return _Utils_update(
			data,
			{
				aa: fn(data.aa)
			});
	});
var author$project$GameData$spellByName = function (name) {
	return A2(
		elm$core$Basics$composeR,
		author$project$GameData$indexes,
		A2(
			elm$core$Basics$composeR,
			function ($) {
				return $.cB;
			},
			elm$core$Dict$get(name)));
};
var elm$core$Dict$filter = F2(
	function (isGood, dict) {
		return A3(
			elm$core$Dict$foldl,
			F3(
				function (k, v, d) {
					return A2(isGood, k, v) ? A3(elm$core$Dict$insert, k, v, d) : d;
				}),
			elm$core$Dict$empty,
			dict);
	});
var elm_community$maybe_extra$Maybe$Extra$isJust = function (m) {
	if (m.$ === 1) {
		return false;
	} else {
		return true;
	}
};
var author$project$Game$migrateFromV0 = function (_n0) {
	var g = _n0;
	var spellCounts = A2(
		elm$core$Dict$filter,
		F2(
			function (name, _n1) {
				return elm_community$maybe_extra$Maybe$Extra$isJust(
					A2(author$project$GameData$spellByName, name, g.D));
			}),
		g.o);
	return _Utils_update(
		g,
		{
			s: spellCounts,
			k: A2(
				author$project$Game$UnitsSnapshot$mapCounts,
				A2(
					elm$core$Basics$composeR,
					elm$core$Dict$remove('invisiblehatchery'),
					A2(
						elm$core$Dict$insert,
						'hatchery',
						A2(
							author$project$Decimal$add,
							author$project$Decimal$one,
							A2(
								elm$core$Maybe$withDefault,
								author$project$Decimal$zero,
								A2(elm$core$Dict$get, 'hatchery', g.o))))),
				g.k),
			o: function (d) {
				return A2(elm$core$Dict$diff, d, spellCounts);
			}(
				A2(elm$core$Dict$remove, 'hatchery', g.o))
		});
};
var author$project$Game$FancyVelocityUI = 1;
var author$project$Game$velocityUIFromString = function (str) {
	switch (str) {
		case 'hidden':
			return 0;
		case 'fancy':
			return 1;
		default:
			return 0;
	}
};
var author$project$Game$velocityUIDecoder = A2(elm$json$Json$Decode$map, author$project$Game$velocityUIFromString, elm$json$Json$Decode$string);
var author$project$JsonUtil$posixDecoder = elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(elm$json$Json$Decode$map, elm$time$Time$millisToPosix, elm$json$Json$Decode$int),
			rtfeldman$elm_iso8601_date_strings$Iso8601$decoder
		]));
var elm$core$Dict$values = function (dict) {
	return A3(
		elm$core$Dict$foldr,
		F3(
			function (key, value, valueList) {
				return A2(elm$core$List$cons, value, valueList);
			}),
		_List_Nil,
		dict);
};
var author$project$Game$Achievement$decoder = function () {
	var decoder0 = F2(
		function (started, dates) {
			return A2(
				elm$core$List$any,
				function (earned) {
					return _Utils_cmp(
						elm$time$Time$posixToMillis(started),
						earned) > 0;
				},
				elm$core$Dict$values(dates)) ? A2(
				elm$core$Dict$map,
				function (_n0) {
					return A2(
						elm$core$Basics$composeR,
						elm$core$Basics$add(
							elm$time$Time$posixToMillis(started)),
						elm$time$Time$millisToPosix);
				},
				dates) : A2(
				elm$core$Dict$map,
				function (_n1) {
					return elm$time$Time$millisToPosix;
				},
				dates);
		});
	return A3(
		elm$json$Json$Decode$map2,
		decoder0,
		elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2(
					elm$json$Json$Decode$at,
					_List_fromArray(
						['date', 'started']),
					author$project$JsonUtil$posixDecoder),
					A2(elm$json$Json$Decode$field, 'created', author$project$JsonUtil$posixDecoder)
				])),
		A2(
			elm$json$Json$Decode$field,
			'achievements',
			elm$json$Json$Decode$dict(elm$json$Json$Decode$int)));
}();
var author$project$Game$BuyN$Settings = elm$core$Basics$identity;
var author$project$Game$BuyN$empty = elm$core$Dict$empty;
var author$project$Game$MtxHistory$MtxHistory = F2(
	function (playfab, kongregate) {
		return {aU: kongregate, al: playfab};
	});
var author$project$Game$MtxHistory$objectSetDecoder = A2(
	elm$json$Json$Decode$map,
	A2(elm$core$Basics$composeR, elm$core$Dict$keys, elm$core$Set$fromList),
	elm$json$Json$Decode$dict(elm$json$Json$Decode$value));
var author$project$Game$MtxHistory$coffeeDecoder = A4(
	NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'kongregate',
	author$project$Game$MtxHistory$objectSetDecoder,
	elm$core$Set$empty,
	A4(
		NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
		_List_fromArray(
			['playfab', 'items']),
		author$project$Game$MtxHistory$objectSetDecoder,
		elm$core$Set$empty,
		elm$json$Json$Decode$succeed(author$project$Game$MtxHistory$MtxHistory)));
var author$project$Game$MtxHistory$empty = A2(author$project$Game$MtxHistory$MtxHistory, elm$core$Set$empty, elm$core$Set$empty);
var author$project$Game$NumberFormat$Alphabetic = 4;
var author$project$Game$NumberFormat$Engineering = 2;
var author$project$Game$NumberFormat$LongScale = 3;
var author$project$Game$NumberFormat$Scientific = 1;
var author$project$Game$NumberFormat$Standard = 0;
var author$project$Game$NumberFormat$list = _List_fromArray(
	[0, 1, 2, 3, 4]);
var author$project$Game$NumberFormat$byString = elm$core$Dict$fromList(
	A2(
		elm$core$List$map,
		function (f) {
			return _Utils_Tuple2(
				author$project$Game$NumberFormat$toString(f),
				f);
		},
		author$project$Game$NumberFormat$list));
var author$project$Game$NumberFormat$decoder = A2(
	elm$json$Json$Decode$andThen,
	function (name) {
		var _n0 = A2(elm$core$Dict$get, name, author$project$Game$NumberFormat$byString);
		if (!_n0.$) {
			var format = _n0.a;
			return elm$json$Json$Decode$succeed(format);
		} else {
			return elm$json$Json$Decode$fail('no such numberformat: ' + name);
		}
	},
	elm$json$Json$Decode$string);
var author$project$Game$NumberFormat$default = 0;
var author$project$Game$Statistics$Statistics = F3(
	function (clicks, byUnit, byUpgrade) {
		return {em: byUnit, Z: byUpgrade, C: clicks};
	});
var author$project$Game$Statistics$Entry = F4(
	function (clicks, num, twinnum, elapsedFirst) {
		return {C: clicks, bV: elapsedFirst, aY: num, fU: twinnum};
	});
var author$project$Decimal$fromString = function (str) {
	var _n0 = A2(elm$core$String$split, 'e', str);
	if ((_n0.b && _n0.b.b) && (!_n0.b.b.b)) {
		var sig = _n0.a;
		var _n1 = _n0.b;
		var exp = _n1.a;
		return A3(
			elm$core$Maybe$map2,
			author$project$Decimal$fromSigExp,
			elm$core$String$toFloat(sig),
			elm$core$String$toInt(exp));
	} else {
		return A2(
			elm$core$Maybe$map,
			author$project$Decimal$fromFloat,
			elm$core$String$toFloat(str));
	}
};
var author$project$JsonUtil$decimalDecoder = function () {
	var decode = function (s) {
		var _n0 = author$project$Decimal$fromString(s);
		if (!_n0.$) {
			var d = _n0.a;
			return elm$json$Json$Decode$succeed(d);
		} else {
			return elm$json$Json$Decode$fail('invalid decimal-string: ' + s);
		}
	};
	return A2(elm$json$Json$Decode$andThen, decode, elm$json$Json$Decode$string);
}();
var author$project$Game$Statistics$entryDecoder = A3(
	NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'elapsedFirst',
	A2(elm$json$Json$Decode$map, author$project$Duration$fromMillis, elm$json$Json$Decode$int),
	A2(
		NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2(elm$json$Json$Decode$field, 'twinnum', author$project$JsonUtil$decimalDecoder),
					A2(elm$json$Json$Decode$field, 'num', author$project$JsonUtil$decimalDecoder)
				])),
		A3(
			NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'num',
			author$project$JsonUtil$decimalDecoder,
			A3(
				NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'clicks',
				elm$json$Json$Decode$int,
				elm$json$Json$Decode$succeed(author$project$Game$Statistics$Entry)))));
var author$project$Game$Statistics$decoder = A4(
	elm$json$Json$Decode$map3,
	author$project$Game$Statistics$Statistics,
	A2(elm$json$Json$Decode$field, 'clicks', elm$json$Json$Decode$int),
	A2(
		elm$json$Json$Decode$field,
		'byUnit',
		elm$json$Json$Decode$dict(author$project$Game$Statistics$entryDecoder)),
	A2(
		elm$json$Json$Decode$field,
		'byUpgrade',
		elm$json$Json$Decode$dict(author$project$Game$Statistics$entryDecoder)));
var author$project$Game$Theme$Default = 0;
var author$project$Game$VelocityUnit$Day = 3;
var author$project$Game$VelocityUnit$Hour = 2;
var author$project$Game$VelocityUnit$Minute = 1;
var author$project$Game$VelocityUnit$Second = 0;
var author$project$Game$VelocityUnit$Swarmwarp = 4;
var author$project$Game$VelocityUnit$list = _List_fromArray(
	[0, 1, 2, 3, 4]);
var author$project$Game$VelocityUnit$byString = elm$core$Dict$fromList(
	A2(
		elm$core$List$map,
		function (f) {
			return _Utils_Tuple2(
				author$project$Game$VelocityUnit$toString(f),
				f);
		},
		author$project$Game$VelocityUnit$list));
var author$project$Game$VelocityUnit$decoder = A2(
	elm$json$Json$Decode$andThen,
	function (name) {
		var _n0 = A2(elm$core$Dict$get, name, author$project$Game$VelocityUnit$byString);
		if (!_n0.$) {
			var format = _n0.a;
			return elm$json$Json$Decode$succeed(format);
		} else {
			return elm$json$Json$Decode$fail('no such velocityUnit: ' + name);
		}
	},
	elm$json$Json$Decode$string);
var author$project$Game$VelocityUnit$default = 0;
var author$project$Game$Watched$boolToInt01 = function (b) {
	return b ? 1 : 0;
};
var author$project$Game$Watched$Cost1 = 2;
var author$project$Game$Watched$Cost2 = 3;
var author$project$Game$Watched$Cost4 = 4;
var author$project$Game$Watched$Hidden = 0;
var author$project$Game$Watched$Never = 1;
var author$project$Game$Watched$watches = _List_fromArray(
	[0, 1, 2, 3, 4]);
var author$project$Game$Watched$byInt = elm$core$Dict$fromList(
	A2(
		elm$core$List$map,
		function (w) {
			return _Utils_Tuple2(
				author$project$Game$Watched$toInt(w),
				w);
		},
		author$project$Game$Watched$watches));
var author$project$Game$Watched$fromInt = function (n) {
	return A2(elm$core$Dict$get, n, author$project$Game$Watched$byInt);
};
var author$project$JsonUtil$decodeMaybe = function (err) {
	return A2(
		elm$core$Basics$composeR,
		elm$core$Result$fromMaybe(err),
		author$project$JsonUtil$decodeResult);
};
var author$project$Game$Watched$decoder = A2(
	elm$json$Json$Decode$andThen,
	function (n) {
		var _n0 = author$project$Game$Watched$fromInt(n);
		if (_n0.$ === 1) {
			return elm$json$Json$Decode$fail(
				'invalid watched state: ' + elm$core$String$fromInt(n));
		} else {
			var w = _n0.a;
			return elm$json$Json$Decode$succeed(w);
		}
	},
	elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				elm$json$Json$Decode$int,
				A2(
				elm$json$Json$Decode$andThen,
				A2(
					elm$core$Basics$composeR,
					elm$core$String$toInt,
					author$project$JsonUtil$decodeMaybe('invalid watched value')),
				elm$json$Json$Decode$string),
				A2(elm$json$Json$Decode$map, author$project$Game$Watched$boolToInt01, elm$json$Json$Decode$bool)
			])));
var author$project$Game$decoder0 = F2(
	function (gameData_, now) {
		return A4(
			NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'mtx',
			author$project$Game$MtxHistory$coffeeDecoder,
			author$project$Game$MtxHistory$empty,
			A4(
				NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'achievementsShown',
				author$project$Game$achievementsShownDecoder,
				author$project$Game$defaultAchievementsShown,
				A4(
					NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'velocityUI',
					author$project$Game$velocityUIDecoder,
					0,
					A4(
						NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'costUI',
						author$project$Game$costUIDecoder,
						1,
						A2(
							NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
							author$project$Game$Achievement$decoder,
							A3(
								NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'statistics',
								author$project$Game$Statistics$decoder,
								A2(
									NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
									elm$core$Dict$empty,
									A2(
										NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
										elm$core$Dict$empty,
										A2(
											NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
											elm$core$Dict$empty,
											A4(
												NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
												'watched',
												elm$json$Json$Decode$dict(author$project$Game$Watched$decoder),
												elm$core$Dict$empty,
												A2(
													NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
													author$project$Game$BuyN$empty,
													A4(
														NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
														_List_fromArray(
															['options', 'velocityUnit']),
														author$project$Game$VelocityUnit$decoder,
														author$project$Game$VelocityUnit$default,
														A4(
															NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
															_List_fromArray(
																['options', 'notation']),
															author$project$Game$NumberFormat$decoder,
															author$project$Game$NumberFormat$default,
															A2(
																NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
																0,
																A2(
																	NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
																	elm$core$Maybe$Nothing,
																	A2(
																		NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
																		elm$core$Dict$empty,
																		A3(
																			NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'upgrades',
																			elm$json$Json$Decode$dict(author$project$JsonUtil$decimalDecoder),
																			A3(
																				NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'unittypes',
																				elm$json$Json$Decode$dict(author$project$JsonUtil$decimalDecoder),
																				A3(
																					NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
																					_List_fromArray(
																						['date', 'reified']),
																					A2(elm$json$Json$Decode$map, elm$core$Basics$identity, author$project$JsonUtil$posixDecoder),
																					A3(
																						NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
																						_List_fromArray(
																							['date', 'reified']),
																						A2(elm$json$Json$Decode$map, elm$core$Basics$identity, author$project$JsonUtil$posixDecoder),
																						A3(
																							NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
																							_List_fromArray(
																								['date', 'started']),
																							A2(elm$json$Json$Decode$map, elm$core$Basics$identity, author$project$JsonUtil$posixDecoder),
																							elm$json$Json$Decode$succeed(
																								A3(author$project$Game$initFromDecoder, author$project$Game$migrateFromV0, gameData_, now)))))))))))))))))))))));
	});
var author$project$Game$BuyN$decoder = A2(
	elm$json$Json$Decode$map,
	elm$core$Basics$identity,
	elm$json$Json$Decode$dict(elm$json$Json$Decode$string));
var author$project$Game$MtxHistory$setDecoder = A2(
	elm$json$Json$Decode$map,
	elm$core$Set$fromList,
	elm$json$Json$Decode$list(elm$json$Json$Decode$string));
var author$project$Game$MtxHistory$decoder = A4(
	NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'kongregate',
	author$project$Game$MtxHistory$setDecoder,
	elm$core$Set$empty,
	A4(
		NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'playfab',
		author$project$Game$MtxHistory$setDecoder,
		elm$core$Set$empty,
		elm$json$Json$Decode$succeed(author$project$Game$MtxHistory$MtxHistory)));
var author$project$Game$Theme$Cerulean = 1;
var author$project$Game$Theme$Cosmo = 2;
var author$project$Game$Theme$Cyborg = 3;
var author$project$Game$Theme$Darkly = 4;
var author$project$Game$Theme$Flatly = 5;
var author$project$Game$Theme$Journal = 6;
var author$project$Game$Theme$Litera = 7;
var author$project$Game$Theme$Lumen = 8;
var author$project$Game$Theme$Lux = 9;
var author$project$Game$Theme$Materia = 10;
var author$project$Game$Theme$Minty = 11;
var author$project$Game$Theme$Pulse = 12;
var author$project$Game$Theme$Sandstone = 13;
var author$project$Game$Theme$Simplex = 14;
var author$project$Game$Theme$Sketchy = 15;
var author$project$Game$Theme$Slate = 16;
var author$project$Game$Theme$Solar = 17;
var author$project$Game$Theme$Spacelab = 18;
var author$project$Game$Theme$Superhero = 19;
var author$project$Game$Theme$United = 20;
var author$project$Game$Theme$Yeti = 21;
var author$project$Game$Theme$list = _List_fromArray(
	[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21]);
var author$project$Game$Theme$byString = elm$core$Dict$fromList(
	A2(
		elm$core$List$map,
		function (theme) {
			return _Utils_Tuple2(
				author$project$Game$Theme$toString(theme),
				theme);
		},
		author$project$Game$Theme$list));
var author$project$Game$Theme$fromString = function (name) {
	return A2(elm$core$Dict$get, name, author$project$Game$Theme$byString);
};
var author$project$Game$Theme$decoder = function () {
	var decodeName = function (name) {
		var _n0 = author$project$Game$Theme$fromString(name);
		if (!_n0.$) {
			var theme = _n0.a;
			return elm$json$Json$Decode$succeed(theme);
		} else {
			return elm$json$Json$Decode$fail('no such theme: ' + name);
		}
	};
	return A2(elm$json$Json$Decode$andThen, decodeName, elm$json$Json$Decode$string);
}();
var author$project$Locale$En_Reverse = 1;
var author$project$Locale$En_US = 0;
var author$project$Locale$En_UpsideDown = 2;
var author$project$Locale$list = _List_fromArray(
	[0, 1, 2]);
var author$project$Locale$dict = elm$core$Dict$fromList(
	A2(
		elm$core$List$map,
		function (loc) {
			return _Utils_Tuple2(
				author$project$Locale$toString(loc),
				loc);
		},
		author$project$Locale$list));
var author$project$Locale$decoder = A2(
	elm$json$Json$Decode$andThen,
	function (str) {
		var _n0 = A2(elm$core$Dict$get, str, author$project$Locale$dict);
		if (!_n0.$) {
			var loc = _n0.a;
			return elm$json$Json$Decode$succeed(loc);
		} else {
			return elm$json$Json$Decode$fail('no such locale: ' + str);
		}
	},
	elm$json$Json$Decode$string);
var elm$json$Json$Decode$nullable = function (decoder) {
	return elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				elm$json$Json$Decode$null(elm$core$Maybe$Nothing),
				A2(elm$json$Json$Decode$map, elm$core$Maybe$Just, decoder)
			]));
};
var author$project$Game$decoder1 = F2(
	function (gameData_, now) {
		return A4(
			NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'mtxHistory',
			author$project$Game$MtxHistory$decoder,
			author$project$Game$MtxHistory$empty,
			A4(
				NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'achievementsShown',
				author$project$Game$achievementsShownDecoder,
				author$project$Game$defaultAchievementsShown,
				A4(
					NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'velocityUI',
					author$project$Game$velocityUIDecoder,
					0,
					A4(
						NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'costUI',
						author$project$Game$costUIDecoder,
						1,
						A2(
							NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
							author$project$Game$Achievement$decoder,
							A3(
								NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'statistics',
								author$project$Game$Statistics$decoder,
								A3(
									NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'cooldown',
									elm$json$Json$Decode$dict(author$project$JsonUtil$posixDecoder),
									A3(
										NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'randomSeeds',
										elm$json$Json$Decode$dict(elm$json$Json$Decode$int),
										A4(
											NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'lastUnitByTab',
											elm$json$Json$Decode$dict(elm$json$Json$Decode$string),
											elm$core$Dict$empty,
											A3(
												NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'watched',
												elm$json$Json$Decode$dict(author$project$Game$Watched$decoder),
												A3(
													NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'buyN',
													author$project$Game$BuyN$decoder,
													A4(
														NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
														'velocityUnit',
														author$project$Game$VelocityUnit$decoder,
														author$project$Game$VelocityUnit$default,
														A4(
															NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
															'numberFormat',
															author$project$Game$NumberFormat$decoder,
															author$project$Game$NumberFormat$default,
															A4(
																NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																'theme',
																author$project$Game$Theme$decoder,
																0,
																A3(
																	NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'locale',
																	elm$json$Json$Decode$nullable(author$project$Locale$decoder),
																	A3(
																		NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'spells',
																		elm$json$Json$Decode$dict(author$project$JsonUtil$decimalDecoder),
																		A3(
																			NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'upgrades',
																			elm$json$Json$Decode$dict(author$project$JsonUtil$decimalDecoder),
																			A3(
																				NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'units',
																				elm$json$Json$Decode$dict(author$project$JsonUtil$decimalDecoder),
																				A2(
																					NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
																					A2(
																						elm$json$Json$Decode$map,
																						elm$core$Basics$identity,
																						elm$json$Json$Decode$oneOf(
																							_List_fromArray(
																								[
																									A2(elm$json$Json$Decode$field, 'encoded', author$project$JsonUtil$posixDecoder),
																									A2(elm$json$Json$Decode$field, 'snapshotted', author$project$JsonUtil$posixDecoder)
																								]))),
																					A3(
																						NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																						'snapshotted',
																						A2(elm$json$Json$Decode$map, elm$core$Basics$identity, author$project$JsonUtil$posixDecoder),
																						A3(
																							NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																							'created',
																							A2(elm$json$Json$Decode$map, elm$core$Basics$identity, author$project$JsonUtil$posixDecoder),
																							elm$json$Json$Decode$succeed(
																								A3(author$project$Game$initFromDecoder, elm$core$Basics$identity, gameData_, now)))))))))))))))))))))));
	});
var elm$core$Array$fromListHelp = F3(
	function (list, nodeList, nodeListSize) {
		fromListHelp:
		while (true) {
			var _n0 = A2(elm$core$Elm$JsArray$initializeFromList, elm$core$Array$branchFactor, list);
			var jsArray = _n0.a;
			var remainingItems = _n0.b;
			if (_Utils_cmp(
				elm$core$Elm$JsArray$length(jsArray),
				elm$core$Array$branchFactor) < 0) {
				return A2(
					elm$core$Array$builderToArray,
					true,
					{p: nodeList, l: nodeListSize, n: jsArray});
			} else {
				var $temp$list = remainingItems,
					$temp$nodeList = A2(
					elm$core$List$cons,
					elm$core$Array$Leaf(jsArray),
					nodeList),
					$temp$nodeListSize = nodeListSize + 1;
				list = $temp$list;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue fromListHelp;
			}
		}
	});
var elm$core$Array$fromList = function (list) {
	if (!list.b) {
		return elm$core$Array$empty;
	} else {
		return A3(elm$core$Array$fromListHelp, list, _List_Nil, 0);
	}
};
var author$project$Game$decoder = F2(
	function (gameData_, now) {
		var versions = elm$core$Array$fromList(
			_List_fromArray(
				[author$project$Game$decoder0, author$project$Game$decoder1]));
		var selectVersion = function (ver) {
			return A3(
				elm_community$maybe_extra$Maybe$Extra$unwrap,
				elm$json$Json$Decode$fail('invalid persistVersion'),
				function (f) {
					return A2(f, gameData_, now);
				},
				A2(elm$core$Array$get, ver, versions));
		};
		return A2(
			elm$json$Json$Decode$andThen,
			elm$core$Basics$identity,
			A4(
				NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'persistVersion',
				elm$json$Json$Decode$int,
				0,
				elm$json$Json$Decode$succeed(selectVersion)));
	});
var author$project$Session$changelog = A2(
	elm$core$Basics$composeR,
	author$project$Session$unwrap,
	function ($) {
		return $.c4;
	});
var author$project$Session$GameLoader$NotReady = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var author$project$Session$GameLoader$empty = function (gd) {
	return A2(author$project$Session$GameLoader$NotReady, gd, krisajenkins$remotedata$RemoteData$Loading);
};
var author$project$Session$create = F4(
	function (args, nav_, gameData_, translator_) {
		return {
			c4: args.c4,
			de: author$project$Session$Environment$fromString(args.de),
			ab: _List_Nil,
			ad: elm$core$Maybe$Nothing,
			ae: author$project$Session$GameLoader$empty(gameData_),
			dp: args.dp,
			ag: author$project$Session$Iframe$WWW,
			bm: false,
			aW: elm$core$Maybe$Nothing,
			cl: nav_,
			cm: elm$core$Maybe$Nothing,
			az: elm$core$Dict$empty,
			ak: elm$core$Maybe$Nothing,
			fn: elm$core$Dict$empty,
			by: elm$core$Maybe$Nothing,
			a4: elm$core$Maybe$Nothing,
			cJ: translator_,
			a8: elm$core$Maybe$Nothing,
			cQ: krisajenkins$remotedata$RemoteData$NotAsked,
			d7: args.d7,
			a9: elm$core$Maybe$Nothing
		};
	});
var author$project$Route$Config$Hostname = 5;
var author$project$Session$hostname = function (session) {
	return A2(
		elm$core$Maybe$withDefault,
		author$project$Session$unwrap(session).dp,
		A2(
			author$project$Route$Config$get,
			5,
			author$project$Session$query(session)));
};
var author$project$GameData$initUnits = A2(
	elm$core$Basics$composeR,
	author$project$GameData$units,
	elm$core$List$filterMap(
		function (u) {
			return A2(
				elm$core$Maybe$map,
				elm$core$Tuple$pair(u),
				u.eQ);
		}));
var author$project$Game$initUnits = A2(
	elm$core$Basics$composeR,
	author$project$GameData$initUnits,
	A2(
		elm$core$Basics$composeR,
		elm$core$List$map(
			elm$core$Tuple$mapFirst(author$project$GameData$Unit$name)),
		elm$core$Dict$fromList));
var author$project$Game$Achievement$Points = F3(
	function (val, max, percent) {
		return {dw: max, dC: percent, d6: val};
	});
var author$project$Game$Achievement$emptyPoints = A3(author$project$Game$Achievement$Points, 0, 0, 0);
var author$project$Game$Statistics$empty = {em: elm$core$Dict$empty, Z: elm$core$Dict$empty, C: 0};
var author$project$Game$empty = F2(
	function (gameData_, created_) {
		return author$project$Game$rebuildGraph(
			{
				aO: author$project$Game$Achievement$emptyPoints,
				aP: _List_Nil,
				aQ: elm$core$Dict$empty,
				Y: author$project$Game$defaultAchievementsShown,
				P: author$project$Game$BuyN$empty,
				_: elm$core$Dict$empty,
				aq: 1,
				H: created_,
				bj: created_,
				D: gameData_,
				aT: author$project$Game$ProductionGraph$empty,
				S: elm$core$Dict$empty,
				av: elm$core$Maybe$Nothing,
				U: author$project$Game$MtxHistory$empty,
				A: elm$core$Maybe$Nothing,
				ay: author$project$Game$NumberFormat$default,
				aB: elm$core$Dict$empty,
				W: elm$core$Dict$empty,
				s: elm$core$Dict$empty,
				L: author$project$Game$Statistics$empty,
				aG: 0,
				k: A4(
					author$project$Game$UnitsSnapshot$create,
					created_,
					author$project$Game$initUnits(gameData_),
					elm$core$Dict$empty,
					elm$core$Set$empty),
				o: elm$core$Dict$empty,
				aK: 0,
				aL: author$project$Game$VelocityUnit$default,
				an: elm$core$Dict$empty
			});
	});
var author$project$Game$load = F3(
	function (gameData_, created_, maybeJson) {
		if (maybeJson.$ === 1) {
			return elm$core$Result$Ok(
				A2(author$project$Game$empty, gameData_, created_));
		} else {
			var json = maybeJson.a;
			return A2(
				elm$json$Json$Decode$decodeValue,
				A2(author$project$Game$decoder, gameData_, created_),
				json);
		}
	});
var author$project$Session$GameLoader$tryReady = F2(
	function (now, loader) {
		if (((!loader.$) && (!loader.a.$)) && (loader.b.$ === 3)) {
			var gd = loader.a.a;
			var maybeJson = loader.b.a;
			var _n1 = A2(
				elm$core$Maybe$map,
				author$project$Game$load(gd),
				now);
			if (!_n1.$) {
				var load = _n1.a;
				var _n2 = load(maybeJson);
				if (!_n2.$) {
					var game = _n2.a;
					return author$project$Session$GameLoader$Ready(
						{ae: game, fW: elm$core$Maybe$Nothing});
				} else {
					var err = _n2.a;
					return A2(
						author$project$Session$GameLoader$NotReady,
						elm$core$Result$Ok(gd),
						krisajenkins$remotedata$RemoteData$Failure(
							elm$json$Json$Decode$errorToString(err)));
				}
			} else {
				return loader;
			}
		} else {
			return loader;
		}
	});
var author$project$Session$GameLoader$setJson = F2(
	function (json, loader) {
		if (loader.$ === 1) {
			var game = loader.a.ae;
			return A2(
				author$project$Session$GameLoader$tryReady,
				elm$core$Maybe$Just(
					author$project$Game$snapshotted(game)),
				A2(
					author$project$Session$GameLoader$NotReady,
					elm$core$Result$Ok(
						author$project$Game$gameData(game)),
					json));
		} else {
			var gd = loader.a;
			return A2(author$project$Session$GameLoader$NotReady, gd, json);
		}
	});
var krisajenkins$remotedata$RemoteData$fromResult = function (result) {
	if (result.$ === 1) {
		var e = result.a;
		return krisajenkins$remotedata$RemoteData$Failure(e);
	} else {
		var x = result.a;
		return krisajenkins$remotedata$RemoteData$Success(x);
	}
};
var author$project$Session$setPersistRead = F2(
	function (r, session) {
		var s = session;
		var game_ = A2(
			author$project$Session$GameLoader$tryReady,
			s.cm,
			A2(
				author$project$Session$GameLoader$setJson,
				krisajenkins$remotedata$RemoteData$fromResult(r),
				s.ae));
		return function (_n1) {
			var ss = _n1;
			return _Utils_update(
				ss,
				{ae: game_});
		}(
			function () {
				var _n0 = author$project$Session$GameLoader$toRemote(game_);
				if (_n0.$ === 3) {
					var newGame = _n0.a;
					return author$project$Session$tryWelcomeBackFromGame(newGame);
				} else {
					return elm$core$Basics$identity;
				}
			}()(session));
	});
var author$project$Session$setServiceWorker = F2(
	function (event, _n0) {
		var session = _n0;
		return _Utils_update(
			session,
			{
				by: elm$core$Maybe$Just(event)
			});
	});
var author$project$Session$version = A2(
	elm$core$Basics$composeR,
	author$project$Session$unwrap,
	function ($) {
		return $.d7;
	});
var author$project$Session$ServiceWorker$OfflineInstalled = 1;
var author$project$Session$ServiceWorker$UpdateFound = 0;
var author$project$Session$ServiceWorker$UpdateInstalled = 2;
var author$project$Session$ServiceWorker$decoder = function () {
	var builder = function (status) {
		switch (status) {
			case 'update-found':
				return elm$json$Json$Decode$succeed(0);
			case 'update-installed':
				return elm$json$Json$Decode$succeed(2);
			case 'offline-installed':
				return elm$json$Json$Decode$succeed(1);
			case 'error':
				return A2(
					elm$json$Json$Decode$andThen,
					A2(
						elm$core$Basics$composeL,
						elm$json$Json$Decode$fail,
						elm$core$Basics$append('service worker error: ')),
					A2(elm$json$Json$Decode$field, 'error', elm$json$Json$Decode$string));
			default:
				return elm$json$Json$Decode$fail('service worker invalid status: ' + status);
		}
	};
	return A2(
		elm$json$Json$Decode$andThen,
		builder,
		A2(elm$json$Json$Decode$field, 'status', elm$json$Json$Decode$string));
}();
var elm$core$Result$andThen = F2(
	function (callback, result) {
		if (!result.$) {
			var value = result.a;
			return callback(value);
		} else {
			var msg = result.a;
			return elm$core$Result$Err(msg);
		}
	});
var krisajenkins$remotedata$RemoteData$succeed = krisajenkins$remotedata$RemoteData$Success;
var author$project$Page$Debug$update = F2(
	function (msg, _n0) {
		var model = _n0;
		switch (msg.$) {
			case 0:
				var s = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{f: s}),
					elm$core$Platform$Cmd$none);
			case 1:
				var json = msg.a;
				var _n2 = A2(elm$json$Json$Decode$decodeValue, author$project$Session$ServiceWorker$decoder, json);
				if (_n2.$ === 1) {
					var err = _n2.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								f: A2(
									author$project$Session$pushError,
									elm$json$Json$Decode$errorToString(err),
									model.f)
							}),
						elm$core$Platform$Cmd$none);
				} else {
					var event = _n2.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								f: A2(author$project$Session$setServiceWorker, event, model.f)
							}),
						elm$core$Platform$Cmd$none);
				}
			case 6:
				var s = model.f;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							f: A4(
								author$project$Session$create,
								{
									c4: author$project$Session$changelog(s),
									de: author$project$Session$Environment$toString(
										author$project$Session$environment(s)),
									dp: author$project$Session$hostname(s),
									d7: author$project$Session$version(s)
								},
								author$project$Session$nav(s),
								elm$core$Result$Err('debug: gamedata test error'),
								elm$core$Maybe$Nothing)
						}),
					elm$core$Platform$Cmd$none);
			case 7:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							f: A2(
								author$project$Session$setPersistRead,
								elm$core$Result$Err('debug: game-read test error'),
								model.f)
						}),
					elm$core$Platform$Cmd$none);
			case 8:
				var json = elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'debug',
							elm$json$Json$Encode$string('game-json test error'))
						]));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							f: A2(
								author$project$Session$setPersistRead,
								elm$core$Result$Ok(
									elm$core$Maybe$Just(json)),
								model.f)
						}),
					elm$core$Platform$Cmd$none);
			case 5:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							f: A2(author$project$Session$pushError, 'debug: session test error', model.f)
						}),
					elm$core$Platform$Cmd$none);
			case 2:
				var str = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aS: elm$core$Maybe$Just(str)
						}),
					elm$core$Platform$Cmd$none);
			case 3:
				var str = A2(elm$core$Maybe$withDefault, '', model.aS);
				var now = author$project$Session$now(model.f);
				var gameData = elm$core$Result$toMaybe(
					author$project$Session$gameData(model.f));
				var game1 = function () {
					var _n4 = A3(
						elm$core$Maybe$map2,
						F2(
							function (gd, t) {
								return A2(
									elm$json$Json$Decode$decodeString,
									A2(author$project$Game$decoder, gd, t),
									str);
							}),
						gameData,
						now);
					if (_n4.$ === 1) {
						return krisajenkins$remotedata$RemoteData$Loading;
					} else {
						if (_n4.a.$ === 1) {
							var err = _n4.a.a;
							return krisajenkins$remotedata$RemoteData$Failure(
								elm$json$Json$Decode$errorToString(err));
						} else {
							var g = _n4.a.a;
							return krisajenkins$remotedata$RemoteData$succeed(g);
						}
					}
				}();
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							R: A2(
								krisajenkins$remotedata$RemoteData$map,
								elm$core$Basics$always(0),
								game1),
							f: function () {
								if (game1.$ === 3) {
									var g = game1.a;
									return A3(author$project$Session$setGame, false, g, model.f);
								} else {
									return model.f;
								}
							}()
						}),
					elm$core$Platform$Cmd$none);
			default:
				var _n5 = _Utils_Tuple2(
					author$project$Session$game(model.f),
					A2(
						elm$core$Result$andThen,
						A2(
							elm$core$Basics$composeR,
							author$project$GameData$achievements,
							A2(
								elm$core$Basics$composeR,
								elm$core$List$head,
								elm$core$Result$fromMaybe('no achievements?'))),
						author$project$Session$gameData(model.f)));
				if ((_n5.a.$ === 3) && (!_n5.b.$)) {
					var game = _n5.a.a;
					var achievement = _n5.b.a;
					var game1 = A3(
						author$project$Game$debugNewAchievement,
						A2(author$project$Session$safeNow, game, model.f),
						achievement,
						game);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								f: A3(author$project$Session$setGame, false, game1, model.f)
							}),
						elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(model, elm$core$Platform$Cmd$none);
				}
		}
	});
var author$project$Page$Login$GotSession = function (a) {
	return {$: 0, a: a};
};
var author$project$Page$Login$LoginResponse = function (a) {
	return {$: 5, a: a};
};
var author$project$Page$Login$RememberMeResponse = function (a) {
	return {$: 6, a: a};
};
var author$project$PlayFab$emailLogin = F3(
	function (id, req, toMsg) {
		return elm$http$Http$post(
			{
				cZ: elm$http$Http$jsonBody(
					elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'TitleId',
								author$project$PlayFab$TitleId$encode(id)),
								_Utils_Tuple2(
								'Email',
								elm$json$Json$Encode$string(req.bW)),
								_Utils_Tuple2(
								'Password',
								elm$json$Json$Encode$string(req.cq)),
								_Utils_Tuple2('InfoRequestParameters', author$project$PlayFab$infoRequestParameters)
							]))),
				z: A2(
					author$project$PlayFab$expectJson,
					toMsg,
					author$project$PlayFab$User$decoder(author$project$PlayFab$userDecoderConfig)),
				B: author$project$PlayFab$TitleId$host(id) + '/Client/LoginWithEmailAddress'
			});
	});
var author$project$PlayFab$User$idToString = function (_n0) {
	var i = _n0;
	return i;
};
var elm$core$String$reverse = _String_reverse;
var author$project$PlayFab$User$generateRememberId = function (_n0) {
	var u = _n0;
	return A3(
		elm$core$String$slice,
		0,
		100,
		A2(
			elm$core$String$join,
			':::',
			_List_fromArray(
				[
					author$project$PlayFab$User$idToString(u.eL),
					elm$core$String$reverse(
					author$project$PlayFab$User$ticketToString(u.bz))
				])));
};
var author$project$PlayFab$User$rememberId = A2(
	elm$core$Basics$composeR,
	author$project$PlayFab$User$unwrap,
	function ($) {
		return $.bw;
	});
var author$project$PlayFab$User$rememberIdToFullString = function (_n0) {
	var r = _n0;
	return r;
};
var author$project$PlayFab$User$setRememberId = F2(
	function (rid, _n0) {
		var user = _n0;
		return _Utils_update(
			user,
			{bw: rid});
	});
var author$project$PlayFab$setRememberId = F3(
	function (id, user, toMsg) {
		var _n0 = author$project$PlayFab$User$rememberId(user);
		if (!_n0.$) {
			var rid = _n0.a;
			return elm$core$Platform$Cmd$none;
		} else {
			var rid = author$project$PlayFab$User$generateRememberId(user);
			return elm$http$Http$request(
				{
					cZ: elm$http$Http$jsonBody(
						elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'TitleId',
									author$project$PlayFab$TitleId$encode(id)),
									_Utils_Tuple2(
									'CustomId',
									elm$json$Json$Encode$string(
										author$project$PlayFab$User$rememberIdToFullString(rid)))
								]))),
					z: A2(
						author$project$PlayFab$expectJson,
						toMsg,
						elm$json$Json$Decode$succeed(
							A2(
								author$project$PlayFab$User$setRememberId,
								elm$core$Maybe$Just(rid),
								user))),
					as: _List_fromArray(
						[
							A2(
							elm$http$Http$header,
							'X-Authentication',
							author$project$PlayFab$User$ticketToString(
								author$project$PlayFab$User$sessionTicket(user)))
						]),
					aw: 'POST',
					aH: elm$core$Maybe$Nothing,
					aJ: elm$core$Maybe$Nothing,
					B: author$project$PlayFab$TitleId$host(id) + '/Client/LinkCustomId'
				});
		}
	});
var author$project$Ports$playfabDecodeSaveReq = _Platform_outgoingPort(
	'playfabDecodeSaveReq',
	function ($) {
		return elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'encoded',
					elm$json$Json$Encode$string($.bj)),
					_Utils_Tuple2(
					'userId',
					elm$json$Json$Encode$string($.bH))
				]));
	});
var author$project$PlayFab$User$decodeGameReq = function (_n0) {
	var u = _n0;
	var _n1 = u.ae;
	if ((!_n1.$) && (!_n1.a.a.$)) {
		var _n2 = _n1.a;
		var _n3 = _n2.a;
		var encoded = _n2.b;
		return _Utils_Tuple2(
			_Utils_update(
				u,
				{
					ae: elm$core$Maybe$Just(
						_Utils_Tuple2(krisajenkins$remotedata$RemoteData$Loading, encoded))
				}),
			author$project$Ports$playfabDecodeSaveReq(
				{
					bj: encoded,
					bH: author$project$PlayFab$User$idToString(u.eL)
				}));
	} else {
		return _Utils_Tuple2(u, elm$core$Platform$Cmd$none);
	}
};
var elm$core$Maybe$destruct = F3(
	function (_default, func, maybe) {
		if (!maybe.$) {
			var a = maybe.a;
			return func(a);
		} else {
			return _default;
		}
	});
var author$project$Ports$writeUserRememberId = _Platform_outgoingPort(
	'writeUserRememberId',
	function ($) {
		return A3(elm$core$Maybe$destruct, elm$json$Json$Encode$null, elm$json$Json$Encode$string, $);
	});
var author$project$Ports$writeUserSessionTicket = _Platform_outgoingPort(
	'writeUserSessionTicket',
	function ($) {
		return A3(elm$core$Maybe$destruct, elm$json$Json$Encode$null, elm$json$Json$Encode$string, $);
	});
var author$project$Route$Home = {$: 0};
var author$project$Session$setRawUser = F2(
	function (user_, _n0) {
		var session = _n0;
		return _Utils_update(
			session,
			{
				cQ: A2(
					krisajenkins$remotedata$RemoteData$map,
					elm$core$Maybe$map(
						function (u) {
							return _Utils_update(
								u,
								{cQ: user_});
						}),
					session.cQ)
			});
	});
var author$project$Page$Login$update = F2(
	function (msg, model0) {
		var model = model0;
		switch (msg.$) {
			case 0:
				var s = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{f: s}),
					elm$core$Platform$Cmd$none);
			case 2:
				var val = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bW: val}),
					elm$core$Platform$Cmd$none);
			case 3:
				var val = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cq: val}),
					elm$core$Platform$Cmd$none);
			case 4:
				var val = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bv: val}),
					elm$core$Platform$Cmd$none);
			case 1:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{a$: krisajenkins$remotedata$RemoteData$Loading}),
					A3(
						author$project$PlayFab$emailLogin,
						author$project$PlayFab$TitleId$fromSession(model.f),
						model,
						author$project$Page$Login$LoginResponse));
			case 5:
				var res = msg.a;
				var model1 = _Utils_update(
					model,
					{
						a$: krisajenkins$remotedata$RemoteData$fromResult(res)
					});
				if (!res.$) {
					var u0 = res.a;
					var _n2 = author$project$PlayFab$User$decodeGameReq(u0);
					var user = _n2.a;
					var cmd0 = _n2.b;
					return _Utils_Tuple2(
						_Utils_update(
							model1,
							{
								f: A2(
									author$project$Session$setUser,
									krisajenkins$remotedata$RemoteData$Success(
										elm$core$Maybe$Just(user)),
									model.f)
							}),
						elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									cmd0,
									author$project$Ports$writeUserSessionTicket(
									elm$core$Maybe$Just(
										author$project$PlayFab$User$ticketToString(
											author$project$PlayFab$User$sessionTicket(user)))),
									model.bv ? A3(
									author$project$PlayFab$setRememberId,
									author$project$PlayFab$TitleId$fromSession(model.f),
									user,
									author$project$Page$Login$RememberMeResponse) : A3(
									author$project$Route$pushUrl,
									author$project$Session$nav(model.f),
									author$project$Session$query(model.f),
									author$project$Route$Home)
								])));
				} else {
					return _Utils_Tuple2(model1, elm$core$Platform$Cmd$none);
				}
			default:
				var res = msg.a;
				if (!res.$) {
					var user = res.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								f: A2(author$project$Session$setRawUser, user, model.f)
							}),
						elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									author$project$Ports$writeUserRememberId(
									A2(
										elm$core$Maybe$map,
										author$project$PlayFab$User$rememberIdToFullString,
										author$project$PlayFab$User$rememberId(user))),
									A3(
									author$project$Route$pushUrl,
									author$project$Session$nav(model.f),
									author$project$Session$query(model.f),
									author$project$Route$Home)
								])));
				} else {
					return _Utils_Tuple2(model0, elm$core$Platform$Cmd$none);
				}
		}
	});
var author$project$Page$MtxHistory$GotSession = function (a) {
	return {$: 1, a: a};
};
var author$project$DecimalDict$add = F2(
	function (key, d) {
		return A2(
			elm$core$Dict$update,
			key,
			A2(
				elm$core$Basics$composeR,
				elm$core$Maybe$withDefault(author$project$Decimal$zero),
				A2(
					elm$core$Basics$composeR,
					author$project$Decimal$add(d),
					elm$core$Maybe$Just)));
	});
var author$project$Game$UnitsSnapshot$addName = F2(
	function (name, d) {
		return author$project$Game$UnitsSnapshot$mapCounts(
			A2(author$project$DecimalDict$add, name, d));
	});
var author$project$Game$updateMtxHistory = F2(
	function (_n0, game) {
		var crystals = _n0.a;
		var hist = _n0.b;
		var g = game;
		return (crystals <= 0) ? game : A2(
			author$project$Game$updateUnits,
			A3(
				author$project$Game$UnitsSnapshot$addName,
				'crystal',
				author$project$Decimal$fromInt(crystals),
				g.k),
			_Utils_update(
				g,
				{U: hist}));
	});
var author$project$Game$MtxHistory$ClientOnly = function (a) {
	return {$: 2, a: a};
};
var author$project$Game$MtxHistory$ServerOnly = function (a) {
	return {$: 0, a: a};
};
var author$project$Game$MtxHistory$Synced = function (a) {
	return {$: 1, a: a};
};
var author$project$Kongregate$Inventory$idToString = function (_n0) {
	var id = _n0;
	return elm$core$String$fromInt(id);
};
var author$project$Game$MtxHistory$kongInventoryStatus = F2(
	function (serverItems, hist) {
		var serverStatus = function (item) {
			return A2(
				elm$core$Set$member,
				author$project$Kongregate$Inventory$idToString(item.eL),
				hist.aU) ? author$project$Game$MtxHistory$Synced(item) : author$project$Game$MtxHistory$ServerOnly(item);
		};
		var clientOnly = A2(
			elm$core$List$map,
			author$project$Game$MtxHistory$ClientOnly,
			elm$core$Set$toList(
				A2(
					elm$core$Set$diff,
					hist.al,
					elm$core$Set$fromList(
						A2(
							elm$core$List$map,
							A2(
								elm$core$Basics$composeR,
								function ($) {
									return $.eL;
								},
								author$project$Kongregate$Inventory$idToString),
							serverItems)))));
		return _Utils_ap(
			A2(elm$core$List$map, serverStatus, serverItems),
			clientOnly);
	});
var author$project$GameData$mtxByName = function (name) {
	return A2(
		elm$core$Basics$composeR,
		author$project$GameData$indexes,
		A2(
			elm$core$Basics$composeR,
			function ($) {
				return $.ch;
			},
			elm$core$Dict$get(name)));
};
var author$project$GameData$mtxById = function (id) {
	return author$project$GameData$mtxByName(
		author$project$GameData$Mtx$idToString(id));
};
var author$project$Game$MtxHistory$updateKongInventory = F3(
	function (gd, serverItems, hist0) {
		var pending = A2(
			elm$core$List$filterMap,
			function (item) {
				return A2(
					elm$core$Maybe$map,
					function (mtx) {
						return _Utils_Tuple2(item, mtx.et);
					},
					A2(author$project$GameData$mtxById, item.eM, gd));
			},
			A2(
				elm$core$List$filterMap,
				function (status) {
					if (!status.$) {
						var item = status.a;
						return elm$core$Maybe$Just(item);
					} else {
						return elm$core$Maybe$Nothing;
					}
				},
				A2(author$project$Game$MtxHistory$kongInventoryStatus, serverItems, hist0)));
		return _Utils_Tuple2(
			elm$core$List$sum(
				A2(elm$core$List$map, elm$core$Tuple$second, pending)),
			_Utils_update(
				hist0,
				{
					aU: A2(
						elm$core$Set$union,
						elm$core$Set$fromList(
							A2(
								elm$core$List$map,
								A2(
									elm$core$Basics$composeR,
									elm$core$Tuple$first,
									A2(
										elm$core$Basics$composeR,
										function ($) {
											return $.eL;
										},
										author$project$Kongregate$Inventory$idToString)),
								pending)),
						hist0.aU)
				}));
	});
var author$project$Game$updateKongMtxHistory = F2(
	function (serverItems, game) {
		var g = game;
		return A2(
			author$project$Game$updateMtxHistory,
			A3(author$project$Game$MtxHistory$updateKongInventory, g.D, serverItems, g.U),
			game);
	});
var author$project$PlayFab$Inventory$instanceIdToString = function (_n0) {
	var id = _n0;
	return id;
};
var author$project$Game$MtxHistory$playfabInventoryStatus = F2(
	function (serverItems, hist) {
		var serverStatus = function (item) {
			return A2(
				elm$core$Set$member,
				author$project$PlayFab$Inventory$instanceIdToString(item.b0),
				hist.al) ? author$project$Game$MtxHistory$Synced(item) : author$project$Game$MtxHistory$ServerOnly(item);
		};
		var clientOnly = A2(
			elm$core$List$map,
			author$project$Game$MtxHistory$ClientOnly,
			elm$core$Set$toList(
				A2(
					elm$core$Set$diff,
					hist.al,
					elm$core$Set$fromList(
						A2(
							elm$core$List$map,
							A2(
								elm$core$Basics$composeR,
								function ($) {
									return $.b0;
								},
								author$project$PlayFab$Inventory$instanceIdToString),
							serverItems)))));
		return _Utils_ap(
			A2(elm$core$List$map, serverStatus, serverItems),
			clientOnly);
	});
var author$project$PlayFab$Inventory$itemIdToString = function (_n0) {
	var id = _n0;
	return id;
};
var author$project$Game$MtxHistory$updatePlayfabInventory = F3(
	function (gd, serverItems, hist0) {
		var pending = A2(
			elm$core$List$filterMap,
			function (item) {
				return A2(
					elm$core$Maybe$map,
					function (mtx) {
						return _Utils_Tuple2(item, mtx.et);
					},
					A2(
						author$project$GameData$mtxByName,
						author$project$PlayFab$Inventory$itemIdToString(item.eX),
						gd));
			},
			A2(
				elm$core$List$filterMap,
				function (status) {
					if (!status.$) {
						var item = status.a;
						return elm$core$Maybe$Just(item);
					} else {
						return elm$core$Maybe$Nothing;
					}
				},
				A2(author$project$Game$MtxHistory$playfabInventoryStatus, serverItems, hist0)));
		return _Utils_Tuple2(
			elm$core$List$sum(
				A2(elm$core$List$map, elm$core$Tuple$second, pending)),
			_Utils_update(
				hist0,
				{
					al: A2(
						elm$core$Set$union,
						elm$core$Set$fromList(
							A2(
								elm$core$List$map,
								A2(
									elm$core$Basics$composeR,
									elm$core$Tuple$first,
									A2(
										elm$core$Basics$composeR,
										function ($) {
											return $.b0;
										},
										author$project$PlayFab$Inventory$instanceIdToString)),
								pending)),
						hist0.al)
				}));
	});
var author$project$Game$updatePlayFabMtxHistory = F2(
	function (serverItems, game) {
		var g = game;
		return A2(
			author$project$Game$updateMtxHistory,
			A3(author$project$Game$MtxHistory$updatePlayfabInventory, g.D, serverItems, g.U),
			game);
	});
var author$project$Kongregate$Inventory$Id = elm$core$Basics$identity;
var author$project$Kongregate$Inventory$Item = F3(
	function (id, identifier, name) {
		return {eL: id, eM: identifier, br: name};
	});
var author$project$Kongregate$Inventory$itemDecoder = A4(
	elm$json$Json$Decode$map3,
	author$project$Kongregate$Inventory$Item,
	A2(
		elm$json$Json$Decode$field,
		'id',
		A2(elm$json$Json$Decode$map, elm$core$Basics$identity, elm$json$Json$Decode$int)),
	A2(elm$json$Json$Decode$field, 'identifier', author$project$GameData$Mtx$Id$decoder),
	A2(elm$json$Json$Decode$field, 'name', elm$json$Json$Decode$string));
var author$project$Kongregate$Inventory$decoder = A2(
	elm$json$Json$Decode$map,
	elm$core$List$reverse,
	elm$json$Json$Decode$list(author$project$Kongregate$Inventory$itemDecoder));
var author$project$Ports$Kongregate$kongregateShowRegistrationBox = _Platform_outgoingPort(
	'kongregateShowRegistrationBox',
	function ($) {
		return elm$json$Json$Encode$null;
	});
var author$project$Session$setKeyCombosHelp = F2(
	function (val, _n0) {
		var s = _n0;
		return _Utils_update(
			s,
			{bm: val});
	});
var author$project$Session$GameLoader$undoState = function (loader) {
	if (loader.$ === 1) {
		var g = loader.a;
		return g.fW;
	} else {
		return elm$core$Maybe$Nothing;
	}
};
var author$project$Session$GameLoader$undoSince = function (now) {
	return A2(
		elm$core$Basics$composeR,
		author$project$Session$GameLoader$undoState,
		elm$core$Maybe$map(
			A2(
				elm$core$Basics$composeR,
				elm$core$Tuple$first,
				function (b) {
					return author$project$Duration$since(
						{eb: now, eh: b});
				})));
};
var author$project$Session$GameLoader$undoStartDuration = author$project$Duration$fromSecs(30);
var elm_community$maybe_extra$Maybe$Extra$filter = F2(
	function (f, m) {
		var _n0 = A2(elm$core$Maybe$map, f, m);
		if ((!_n0.$) && _n0.a) {
			return m;
		} else {
			return elm$core$Maybe$Nothing;
		}
	});
var author$project$Session$GameLoader$undoDuration = F2(
	function (now, loader) {
		return A2(
			elm_community$maybe_extra$Maybe$Extra$filter,
			function (dur) {
				return author$project$Duration$toMillis(dur) >= 0;
			},
			A2(
				elm$core$Maybe$map,
				author$project$Duration$sub(author$project$Session$GameLoader$undoStartDuration),
				A2(author$project$Session$GameLoader$undoSince, now, loader)));
	});
var author$project$Session$GameLoader$undo = F2(
	function (now, loader) {
		var _n0 = _Utils_Tuple2(
			loader,
			A2(author$project$Session$GameLoader$undoDuration, now, loader));
		if ((_n0.a.$ === 1) && (!_n0.b.$)) {
			var g = _n0.a.a;
			var _n1 = g.fW;
			if (!_n1.$) {
				var _n2 = _n1.a;
				var game = _n2.b;
				return A2(
					elm$core$Tuple$mapFirst,
					function (pgame) {
						return author$project$Session$GameLoader$Ready(
							{ae: pgame, fW: elm$core$Maybe$Nothing});
					},
					A2(author$project$Game$persistWrite, now, game));
			} else {
				return _Utils_Tuple2(loader, elm$core$Platform$Cmd$none);
			}
		} else {
			return _Utils_Tuple2(loader, elm$core$Platform$Cmd$none);
		}
	});
var author$project$Session$undo = function (session0) {
	var s = session0;
	var _n0 = s.cm;
	if (!_n0.$) {
		var now_ = _n0.a;
		return A2(
			elm$core$Tuple$mapFirst,
			function (g) {
				return _Utils_update(
					s,
					{ae: g});
			},
			A2(author$project$Session$GameLoader$undo, now_, s.ae));
	} else {
		return _Utils_Tuple2(session0, elm$core$Platform$Cmd$none);
	}
};
var author$project$Game$UnitsSnapshot$isItemVisible = function (id) {
	return A2(
		elm$core$Basics$composeR,
		author$project$Game$UnitsSnapshot$visibleNames,
		elm$core$Set$member(
			author$project$GameData$Item$idToString(id)));
};
var author$project$Select$isBulkBuyable = function (item) {
	if (item.$ === 1) {
		var u = item.a;
		return u.eU;
	} else {
		return true;
	}
};
var author$project$GameData$Item$isWatchable = function (item) {
	switch (item.$) {
		case 2:
			return false;
		case 1:
			var u = item.a;
			return true;
		default:
			var u = item.a;
			return u.f1;
	}
};
var author$project$Game$watched = function (item) {
	return author$project$GameData$Item$isWatchable(item) ? A2(
		elm$core$Basics$composeR,
		author$project$Game$unwrap,
		A2(
			elm$core$Basics$composeR,
			function ($) {
				return $.an;
			},
			A2(
				elm$core$Basics$composeR,
				elm$core$Dict$get(
					author$project$GameData$Item$name(item)),
				A2(
					elm$core$Basics$composeR,
					elm$core$Maybe$withDefault(2),
					elm$core$Maybe$Just)))) : elm$core$Basics$always(elm$core$Maybe$Nothing);
};
var author$project$Game$BuyN$Percent = function (a) {
	return {$: 0, a: a};
};
var author$project$Decimal$roundableFloat = function (d) {
	var sig = d.i;
	var exp = d.j;
	return (exp > 8) ? elm$core$Result$Err(d) : elm$core$Result$Ok(
		author$project$Decimal$toFloat(d));
};
var author$project$Decimal$ceiling = A2(
	elm$core$Basics$composeR,
	author$project$Decimal$roundableFloat,
	elm$core$Result$map(elm$core$Basics$ceiling));
var author$project$Decimal$flipDiv = F2(
	function (a, b) {
		return A2(author$project$Decimal$div, b, a);
	});
var author$project$Decimal$floor = A2(
	elm$core$Basics$composeR,
	author$project$Decimal$roundableFloat,
	elm$core$Result$map(elm$core$Basics$floor));
var author$project$Game$snapItemCount = F3(
	function (id, snap, game) {
		if (!id.$) {
			var i = id.a;
			return A2(author$project$Game$UnitsSnapshot$count, i, snap);
		} else {
			return A2(author$project$Game$itemCount, id, game);
		}
	});
var elm$core$List$isEmpty = function (xs) {
	if (!xs.b) {
		return true;
	} else {
		return false;
	}
};
var author$project$Game$Order$applyMaxLevel = F4(
	function (game, snapshot, item, buyCount0) {
		switch (item.$) {
			case 1:
				var u = item.a;
				var maxBuyCount0 = A2(
					elm$core$Maybe$map,
					author$project$Decimal$flipSub(
						A3(
							author$project$Game$snapItemCount,
							author$project$GameData$Item$id(item),
							snapshot,
							game)),
					u.e_);
				var _n1 = _Utils_Tuple2(maxBuyCount0, buyCount0);
				if (_n1.a.$ === 1) {
					var _n2 = _n1.a;
					return buyCount0;
				} else {
					if (_n1.b.$ === 1) {
						var maxBuyCount = _n1.a.a;
						var d = _n1.b.a;
						return elm$core$Result$Err(
							A2(author$project$Decimal$min, d, maxBuyCount));
					} else {
						var maxBuyCount = _n1.a.a;
						var n = _n1.b.a;
						return elm$core$Result$Ok(
							A2(
								elm$core$Basics$min,
								n,
								elm$core$Basics$floor(
									author$project$Decimal$toFloat(maxBuyCount))));
					}
				}
			case 0:
				var u = item.a;
				return (u.e9.cX || (!elm$core$List$isEmpty(u.e9.dR))) ? elm$core$Result$Ok(1) : buyCount0;
			default:
				var s = item.a;
				return (s.e9.cX || (!elm$core$List$isEmpty(s.e9.dR))) ? elm$core$Result$Ok(1) : buyCount0;
		}
	});
var author$project$Game$Order$eval = F2(
	function (game, snapshot) {
		return A2(
			author$project$Parser$Stat$evalWithDefault,
			author$project$Decimal$zero,
			A2(author$project$Game$getVar, game, snapshot));
	});
var author$project$Game$Order$fromPercent1 = F5(
	function (game, snap, item, percent, _n0) {
		var currencyId = _n0.a;
		var cost = _n0.b;
		var currency = A2(
			author$project$Decimal$mulFloat,
			1 / author$project$DecimalDict$subEpsilon,
			A2(
				author$project$Decimal$mulFloat,
				percent,
				A2(author$project$Game$UnitsSnapshot$count, currencyId, snap)));
		if (!cost.$) {
			var costEach = cost.a;
			return A2(
				author$project$Decimal$flipDiv,
				A3(author$project$Game$Order$eval, game, snap, costEach),
				currency);
		} else {
			var costFirst = cost.a;
			var factor = cost.b;
			var count = A3(
				author$project$Game$snapItemCount,
				author$project$GameData$Item$id(item),
				snap,
				game);
			var _n2 = author$project$Decimal$toFiniteFloat(count);
			if (_n2.$ === 1) {
				return author$project$Decimal$zero;
			} else {
				var count0 = _n2.a;
				var costNext = A2(
					author$project$Decimal$mul,
					A2(
						author$project$Decimal$powFloat,
						author$project$Decimal$fromFloat(factor),
						count0),
					A3(author$project$Game$Order$eval, game, snap, costFirst));
				var deltaCount = A2(
					author$project$Decimal$logBase,
					factor,
					A2(
						author$project$Decimal$flipSub,
						A2(
							author$project$Decimal$flipDiv,
							costNext,
							A2(author$project$Decimal$mulFloat, 1 - factor, currency)),
						author$project$Decimal$one));
				return author$project$Decimal$fromFloat(deltaCount);
			}
		}
	});
var author$project$Game$Order$numBuyable = F4(
	function (game, snap, item, percent) {
		return author$project$Decimal$minimum(
			A2(
				elm$core$List$map,
				A4(
					author$project$Game$Order$fromPercent1,
					game,
					snap,
					item,
					A3(elm$core$Basics$clamp, 0, 1, percent)),
				author$project$GameData$Item$cost(item)));
	});
var author$project$Decimal$infinity = author$project$Decimal$fromFloat(1 / 0);
var author$project$Decimal$mulInt = function (i) {
	return author$project$Decimal$mulFloat(i);
};
var author$project$Game$Order$totalCost1 = F5(
	function (game, snapshot, item, deltaCount, _n0) {
		var currencyId = _n0.a;
		var cost = _n0.b;
		var _n1 = _Utils_Tuple2(deltaCount, cost);
		if (!_n1.a.$) {
			if (!_n1.b.$) {
				var n = _n1.a.a;
				var costEach = _n1.b.a;
				return A2(
					author$project$Decimal$mulInt,
					n,
					A3(author$project$Game$Order$eval, game, snapshot, costEach));
			} else {
				var n = _n1.a.a;
				var _n2 = _n1.b;
				var costFirst = _n2.a;
				var factor = _n2.b;
				var _n3 = author$project$Decimal$toFiniteFloat(
					A3(
						author$project$Game$snapItemCount,
						author$project$GameData$Item$id(item),
						snapshot,
						game));
				if (_n3.$ === 1) {
					return author$project$Decimal$infinity;
				} else {
					var count0 = _n3.a;
					var costNext = A2(
						author$project$Decimal$mul,
						A2(
							author$project$Decimal$powFloat,
							author$project$Decimal$fromFloat(factor),
							count0),
						A3(author$project$Game$Order$eval, game, snapshot, costFirst));
					return A2(
						author$project$Decimal$flipDivFloat,
						1 - factor,
						A2(
							author$project$Decimal$mul,
							A2(
								author$project$Decimal$flipSub,
								A2(
									author$project$Decimal$powFloat,
									author$project$Decimal$fromFloat(factor),
									n),
								author$project$Decimal$one),
							costNext));
				}
			}
		} else {
			if (!_n1.b.$) {
				var d = _n1.a.a;
				var costEach = _n1.b.a;
				return A2(
					author$project$Decimal$mul,
					d,
					A3(author$project$Game$Order$eval, game, snapshot, costEach));
			} else {
				var d = _n1.a.a;
				var _n4 = _n1.b;
				var costEach = _n4.a;
				return author$project$Decimal$infinity;
			}
		}
	});
var author$project$Game$Order$twinUnits = F3(
	function (game, snapshot, u) {
		return A3(
			elm_community$maybe_extra$Maybe$Extra$unwrap,
			author$project$Decimal$one,
			A2(author$project$Game$Order$eval, game, snapshot),
			u.fV);
	});
var author$project$Game$Order$twinMult = F3(
	function (game, snapshot, item) {
		if (!item.$) {
			var u = item.a;
			return A3(author$project$Game$Order$twinUnits, game, snapshot, u);
		} else {
			return author$project$Decimal$one;
		}
	});
var author$project$Game$Order$createUnsafe = F6(
	function (game, snapshot, item, request, isGuaranteed, untwinnedCount0) {
		var untwinnedCount = A4(author$project$Game$Order$applyMaxLevel, game, snapshot, item, untwinnedCount0);
		var twinnedCount = function () {
			if (untwinnedCount.$ === 1) {
				var d = untwinnedCount.a;
				return elm$core$Result$Err(
					A2(
						author$project$Decimal$mul,
						A3(author$project$Game$Order$twinMult, game, snapshot, item),
						d));
			} else {
				var n = untwinnedCount.a;
				return author$project$Decimal$floor(
					A2(
						author$project$Decimal$mul,
						A3(author$project$Game$Order$twinMult, game, snapshot, item),
						author$project$Decimal$fromInt(n)));
			}
		}();
		var isPossible = function () {
			if (A2(
				author$project$Decimal$lte,
				author$project$GameData$Item$resToDec(untwinnedCount0),
				author$project$Decimal$zero)) {
				return false;
			} else {
				if (!isGuaranteed.$) {
					var p = isGuaranteed.a;
					return p;
				} else {
					var _n3 = A4(author$project$Game$Order$numBuyable, game, snapshot, item, 1);
					if (!_n3.$) {
						var max = _n3.a;
						return A2(
							author$project$Decimal$lte,
							author$project$GameData$Item$resToDec(untwinnedCount),
							max);
					} else {
						return false;
					}
				}
			}
		}();
		var costNext = A2(
			elm$core$List$map,
			function (_n1) {
				var curr = _n1.a;
				var val = _n1.b;
				return _Utils_Tuple2(
					curr,
					A5(
						author$project$Game$Order$totalCost1,
						game,
						snapshot,
						item,
						elm$core$Result$Ok(1),
						_Utils_Tuple2(curr, val)));
			},
			author$project$GameData$Item$cost(item));
		var cost = A2(
			elm$core$List$map,
			function (_n0) {
				var curr = _n0.a;
				var val = _n0.b;
				return _Utils_Tuple2(
					curr,
					A5(
						author$project$Game$Order$totalCost1,
						game,
						snapshot,
						item,
						untwinnedCount,
						_Utils_Tuple2(curr, val)));
			},
			author$project$GameData$Item$cost(item));
		return {
			es: cost,
			c6: costNext,
			et: twinnedCount,
			ds: isPossible,
			eW: item,
			dO: request,
			cE: elm$core$Result$Ok(0),
			d4: untwinnedCount
		};
	});
var author$project$Game$UnitsSnapshot$isUnitVisible = function (id) {
	return A2(
		elm$core$Basics$composeR,
		author$project$Game$UnitsSnapshot$visibleNames,
		elm$core$Set$member(
			author$project$GameData$Unit$idToString(id)));
};
var author$project$Game$Order$isCostVisible = F2(
	function (snapshot, _n0) {
		var uid = _n0.a;
		return A2(author$project$Game$UnitsSnapshot$isUnitVisible, uid, snapshot);
	});
var author$project$Game$Order$create = F4(
	function (game, snapshot, item, request) {
		if (elm$core$List$isEmpty(
			author$project$GameData$Item$cost(item))) {
			return elm$core$Result$Err(
				'item has no costs defined: ' + author$project$GameData$Item$name(item));
		} else {
			if (!A2(
				author$project$Game$UnitsSnapshot$isItemVisible,
				author$project$GameData$Item$id(item),
				snapshot)) {
				return elm$core$Result$Err(
					'item is not visible: ' + author$project$GameData$Item$name(item));
			} else {
				if (!A2(
					elm$core$List$all,
					author$project$Game$Order$isCostVisible(snapshot),
					author$project$GameData$Item$cost(item))) {
					return elm$core$Result$Err(
						'some of the item\'s costs are not visible: ' + A2(
							elm$core$String$join,
							', ',
							A2(
								elm$core$List$map,
								A2(elm$core$Basics$composeR, elm$core$Tuple$first, author$project$GameData$Unit$idToString),
								A2(
									elm$core$List$filter,
									author$project$Game$Order$isCostVisible(snapshot),
									author$project$GameData$Item$cost(item)))));
				} else {
					switch (request.$) {
						case 0:
							var pct100 = request.a;
							var percent = pct100 / 100;
							var _n1 = A4(author$project$Game$Order$numBuyable, game, snapshot, item, percent);
							if (_n1.$ === 1) {
								return elm$core$Result$Err(
									'numBuyable: item has no costs defined: ' + author$project$GameData$Item$name(item));
							} else {
								var num = _n1.a;
								return elm$core$Result$Ok(
									A6(
										author$project$Game$Order$createUnsafe,
										game,
										snapshot,
										item,
										author$project$Game$BuyN$Percent(
											elm$core$Basics$floor(100 * percent)),
										elm$core$Maybe$Just(true),
										author$project$Decimal$floor(num)));
							}
						case 1:
							var val = request.a;
							return elm$core$Result$Ok(
								A6(
									author$project$Game$Order$createUnsafe,
									game,
									snapshot,
									item,
									request,
									elm$core$Maybe$Nothing,
									author$project$Decimal$floor(val)));
						case 3:
							var twinVal = request.a;
							var val = A2(
								author$project$Decimal$flipDiv,
								A3(author$project$Game$Order$twinMult, game, snapshot, item),
								twinVal);
							return elm$core$Result$Ok(
								A6(
									author$project$Game$Order$createUnsafe,
									game,
									snapshot,
									item,
									request,
									elm$core$Maybe$Nothing,
									author$project$Decimal$ceiling(val)));
						default:
							var targetVal = request.a;
							var rawVal = A2(
								author$project$Decimal$flipDiv,
								A3(author$project$Game$Order$twinMult, game, snapshot, item),
								A2(
									author$project$Decimal$flipSub,
									A3(
										author$project$Game$snapItemCount,
										author$project$GameData$Item$id(item),
										snapshot,
										game),
									targetVal));
							return elm$core$Result$Ok(
								A6(
									author$project$Game$Order$createUnsafe,
									game,
									snapshot,
									item,
									request,
									elm$core$Maybe$Nothing,
									author$project$Decimal$ceiling(
										A2(author$project$Decimal$max, author$project$Decimal$one, rawVal))));
					}
				}
			}
		}
	});
var author$project$Game$Order$fromPercent = F4(
	function (game, snap, item, percent) {
		return A4(
			author$project$Game$Order$create,
			game,
			snap,
			item,
			author$project$Game$BuyN$Percent(
				elm$core$Basics$floor(100 * percent)));
	});
var author$project$Select$itemWatchedOrder = F4(
	function (pct, game, snapshot, item) {
		var _n0 = A2(author$project$Game$watched, item, game);
		_n0$3:
		while (true) {
			if (!_n0.$) {
				switch (_n0.a) {
					case 2:
						var _n1 = _n0.a;
						return A4(author$project$Game$Order$fromPercent, game, snapshot, item, pct * 1);
					case 3:
						var _n2 = _n0.a;
						return A4(author$project$Game$Order$fromPercent, game, snapshot, item, (pct * 1) / 2);
					case 4:
						var _n3 = _n0.a;
						return A4(author$project$Game$Order$fromPercent, game, snapshot, item, (pct * 1) / 4);
					default:
						break _n0$3;
				}
			} else {
				break _n0$3;
			}
		}
		return elm$core$Result$Err('watched-order not possible');
	});
var author$project$Select$isItemWatchTriggered = F4(
	function (pct, game, snapshot, item) {
		return A2(
			elm$core$Result$withDefault,
			false,
			A2(
				elm$core$Result$map,
				function ($) {
					return $.ds;
				},
				A4(author$project$Select$itemWatchedOrder, pct, game, snapshot, item)));
	});
var author$project$Select$bulkBuyableItems = F3(
	function (pct, game, snapshot) {
		return A2(
			elm$core$List$filter,
			author$project$Select$isBulkBuyable,
			A2(
				elm$core$List$filter,
				A3(author$project$Select$isItemWatchTriggered, pct, game, snapshot),
				A2(
					elm$core$List$filter,
					function (i) {
						return A2(
							author$project$Game$UnitsSnapshot$isItemVisible,
							author$project$GameData$Item$id(i),
							snapshot);
					},
					author$project$GameData$items(
						author$project$Game$gameData(game)))));
	});
var author$project$Game$UnitsSnapshot$add = function (id) {
	return author$project$Game$UnitsSnapshot$addName(
		author$project$GameData$Unit$idToString(id));
};
var author$project$Game$addItemId = F3(
	function (id, count, _n0) {
		var g = _n0;
		return author$project$Game$rebuildGraph(
			function () {
				switch (id.$) {
					case 0:
						var u = id.a;
						return _Utils_update(
							g,
							{
								k: A3(author$project$Game$UnitsSnapshot$add, u, count, g.k)
							});
					case 1:
						var u = id.a;
						return _Utils_update(
							g,
							{
								o: A3(
									author$project$DecimalDict$add,
									author$project$GameData$Upgrade$idToString(u),
									count,
									g.o)
							});
					default:
						var u = id.a;
						return _Utils_update(
							g,
							{
								s: A3(
									author$project$DecimalDict$add,
									author$project$GameData$Spell$idToString(u),
									count,
									g.s)
							});
				}
			}());
	});
var author$project$Game$addItem = function (item) {
	return author$project$Game$addItemId(
		author$project$GameData$Item$id(item));
};
var author$project$GameData$Achievement$triggerExpression = function (achievement) {
	var _n0 = achievement.fT;
	if (!_n0.$) {
		var e = _n0.a;
		return elm$core$Maybe$Just(e);
	} else {
		return elm$core$Maybe$Nothing;
	}
};
var author$project$Game$Achievement$updateGame = F2(
	function (now, model) {
		var _new = A2(
			elm$core$List$filter,
			A2(
				elm$core$Basics$composeR,
				author$project$GameData$Achievement$triggerExpression,
				A2(
					elm_community$maybe_extra$Maybe$Extra$unwrap,
					false,
					author$project$Game$Achievement$eval(model))),
			A2(
				elm$core$List$filter,
				function (a) {
					return !A2(
						elm$core$Dict$member,
						author$project$GameData$Achievement$name(a),
						model.aQ);
				},
				author$project$GameData$achievements(model.D)));
		return A3(author$project$Game$Achievement$grantList, _new, now, model);
	});
var author$project$Game$Achievement$push = elm$core$Basics$always(author$project$Game$Achievement$updateGame);
var author$project$Game$Statistics$emptyEntry = function (dur) {
	return {C: 0, bV: dur, aY: author$project$Decimal$zero, fU: author$project$Decimal$zero};
};
var author$project$Game$Statistics$updateEntry = F3(
	function (sinceFirst, _n0, entry0) {
		var item = _n0.eW;
		var count = _n0.et;
		var untwinnedCount = _n0.d4;
		var entry = A2(
			elm$core$Maybe$withDefault,
			author$project$Game$Statistics$emptyEntry(sinceFirst),
			entry0);
		return _Utils_update(
			entry,
			{
				C: entry.C + 1,
				aY: A2(
					author$project$Decimal$add,
					entry.aY,
					author$project$GameData$Item$resToDec(untwinnedCount)),
				fU: A2(
					author$project$Decimal$add,
					entry.fU,
					author$project$GameData$Item$resToDec(count))
			});
	});
var author$project$Game$Statistics$push = F3(
	function (sinceFirst, order, statistics0) {
		var update = A2(
			elm$core$Basics$composeR,
			A2(author$project$Game$Statistics$updateEntry, sinceFirst, order),
			elm$core$Maybe$Just);
		var statistics = _Utils_update(
			statistics0,
			{C: statistics0.C + 1});
		var _n0 = order.eW;
		switch (_n0.$) {
			case 0:
				var unit = _n0.a;
				return _Utils_update(
					statistics,
					{
						em: A3(
							elm$core$Dict$update,
							author$project$GameData$Unit$name(unit),
							update,
							statistics.em)
					});
			case 1:
				var upgrade = _n0.a;
				return _Utils_update(
					statistics,
					{
						Z: A3(
							elm$core$Dict$update,
							author$project$GameData$Upgrade$name(upgrade),
							update,
							statistics.Z)
					});
			default:
				var spell = _n0.a;
				return _Utils_update(
					statistics,
					{
						Z: A3(
							elm$core$Dict$update,
							author$project$GameData$Spell$name(spell),
							update,
							statistics.Z)
					});
		}
	});
var author$project$Game$pushStatistics = F2(
	function (order, game) {
		var g = game;
		var sinceFirst = author$project$Duration$since(
			{
				eb: author$project$Game$snapshotted(game),
				eh: g.H
			});
		return A3(
			author$project$Game$Achievement$push,
			order,
			author$project$Game$snapshotted(game),
			_Utils_update(
				g,
				{
					L: A3(author$project$Game$Statistics$push, sinceFirst, order, g.L)
				}));
	});
var author$project$Game$refreshSnapshotUnits = function (game) {
	return A2(
		author$project$Game$snapshotUnits,
		author$project$Game$snapshotted(game),
		game);
};
var author$project$Game$UnitsSnapshot$update = F2(
	function (id, fn) {
		return author$project$Game$UnitsSnapshot$mapCounts(
			A2(
				elm$core$Dict$update,
				author$project$GameData$Unit$idToString(id),
				fn));
	});
var author$project$Game$BuyOrder$applyMinUnits = function (game) {
	var minUnits = A2(
		elm$core$List$filterMap,
		function (u) {
			return A2(
				elm$core$Maybe$map,
				elm$core$Tuple$pair(u),
				A2(
					elm_community$maybe_extra$Maybe$Extra$filter,
					elm$core$Basics$neq(author$project$Decimal$zero),
					A2(
						elm$core$Maybe$map,
						A2(
							author$project$Parser$Stat$evalWithDefault,
							author$project$Decimal$zero,
							author$project$Game$getGameVar(game)),
						u.e$)));
		},
		author$project$GameData$units(
			author$project$Game$gameData(game)));
	var fold = function (_n0) {
		var u = _n0.a;
		var minCount = _n0.b;
		return A2(
			author$project$Game$UnitsSnapshot$update,
			u.eL,
			A2(
				elm$core$Basics$composeR,
				A2(
					elm_community$maybe_extra$Maybe$Extra$unwrap,
					minCount,
					author$project$Decimal$max(minCount)),
				elm$core$Maybe$Just));
	};
	return A2(
		author$project$Game$updateUnits,
		A3(
			elm$core$List$foldl,
			fold,
			author$project$Game$units(game),
			minUnits),
		game);
};
var author$project$DecimalDict$sub = F4(
	function (err, key, d, dict) {
		var val0 = A2(
			elm$core$Maybe$withDefault,
			author$project$Decimal$zero,
			A2(elm$core$Dict$get, key, dict));
		return A2(
			author$project$Decimal$gte,
			val0,
			A2(author$project$Decimal$mulFloat, author$project$DecimalDict$subEpsilon, d)) ? elm$core$Result$Ok(
			A3(
				elm$core$Dict$insert,
				key,
				A2(
					author$project$Decimal$max,
					author$project$Decimal$zero,
					A2(author$project$Decimal$sub, val0, d)),
				dict)) : elm$core$Result$Err(err);
	});
var author$project$Game$UnitsSnapshot$sub = F3(
	function (id, d, _n0) {
		var data = _n0;
		var name = author$project$GameData$Unit$idToString(id);
		return A2(
			elm$core$Result$map,
			function (counts) {
				return _Utils_update(
					data,
					{aa: counts});
			},
			A4(author$project$DecimalDict$sub, 'not enough resources: ' + name, name, d, data.aa));
	});
var author$project$Game$BuyOrder$pay = F2(
	function (o, game) {
		return A2(
			elm$core$Result$map,
			function (units) {
				return A2(author$project$Game$updateUnits, units, game);
			},
			A3(
				elm$core$List$foldl,
				function (_n0) {
					var id = _n0.a;
					var c = _n0.b;
					return elm$core$Result$andThen(
						A2(author$project$Game$UnitsSnapshot$sub, id, c));
				},
				elm$core$Result$Ok(
					author$project$Game$units(game)),
				o.es));
	});
var author$project$Decimal$flipPowFloat = F2(
	function (exp, base_) {
		return A2(author$project$Decimal$powFloat, base_, exp);
	});
var author$project$Duration$max = F2(
	function (_n0, _n1) {
		var a = _n0;
		var b = _n1;
		return A2(elm$core$Basics$max, a, b);
	});
var author$project$Game$cooldownRemaining = F3(
	function (now, cooldown, game) {
		var _n0 = A2(
			elm$core$Dict$get,
			cooldown.dn,
			author$project$Game$unwrap(game)._);
		if (_n0.$ === 1) {
			return author$project$Duration$zero;
		} else {
			var at = _n0.a;
			return A2(
				author$project$Duration$max,
				author$project$Duration$zero,
				A2(
					author$project$Duration$sub,
					cooldown.d6,
					author$project$Duration$since(
						{eb: now, eh: at})));
		}
	});
var author$project$Game$isCooldownReady = F3(
	function (now, cooldown, game) {
		return author$project$Duration$toMillis(
			A3(author$project$Game$cooldownRemaining, now, cooldown, game)) <= 0;
	});
var author$project$Game$popCooldown = F2(
	function (cooldown, game) {
		var g = game;
		var now = author$project$Game$snapshotted(game);
		return A3(author$project$Game$isCooldownReady, now, cooldown, game) ? elm$core$Maybe$Just(
			_Utils_update(
				g,
				{
					_: A3(elm$core$Dict$insert, cooldown.dn, now, g._)
				})) : elm$core$Maybe$Nothing;
	});
var author$project$Game$skipTime = F2(
	function (duration, game) {
		return A4(
			author$project$Game$evalUnits_,
			author$project$Game$snapshotted(game),
			duration,
			author$project$Game$UnitsSnapshot$visibleNames(
				author$project$Game$units(game)),
			game);
	});
var elm$random$Random$Generator = elm$core$Basics$identity;
var elm$random$Random$Seed = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var elm$random$Random$next = function (_n0) {
	var state0 = _n0.a;
	var incr = _n0.b;
	return A2(elm$random$Random$Seed, ((state0 * 1664525) + incr) >>> 0, incr);
};
var elm$random$Random$peel = function (_n0) {
	var state = _n0.a;
	var word = (state ^ (state >>> ((state >>> 28) + 4))) * 277803737;
	return ((word >>> 22) ^ word) >>> 0;
};
var elm$random$Random$int = F2(
	function (a, b) {
		return function (seed0) {
			var _n0 = (_Utils_cmp(a, b) < 0) ? _Utils_Tuple2(a, b) : _Utils_Tuple2(b, a);
			var lo = _n0.a;
			var hi = _n0.b;
			var range = (hi - lo) + 1;
			if (!((range - 1) & range)) {
				return _Utils_Tuple2(
					(((range - 1) & elm$random$Random$peel(seed0)) >>> 0) + lo,
					elm$random$Random$next(seed0));
			} else {
				var threshhold = (((-range) >>> 0) % range) >>> 0;
				var accountForBias = function (seed) {
					accountForBias:
					while (true) {
						var x = elm$random$Random$peel(seed);
						var seedN = elm$random$Random$next(seed);
						if (_Utils_cmp(x, threshhold) < 0) {
							var $temp$seed = seedN;
							seed = $temp$seed;
							continue accountForBias;
						} else {
							return _Utils_Tuple2((x % range) + lo, seedN);
						}
					}
				};
				return accountForBias(seed0);
			}
		};
	});
var author$project$RandomUtil$seedInt = A2(
	elm$random$Random$int,
	(-1) * A2(elm$core$Basics$pow, 2, 31),
	A2(elm$core$Basics$pow, 2, 31));
var elm$core$Dict$sizeHelp = F2(
	function (n, dict) {
		sizeHelp:
		while (true) {
			if (dict.$ === -2) {
				return n;
			} else {
				var left = dict.d;
				var right = dict.e;
				var $temp$n = A2(elm$core$Dict$sizeHelp, n + 1, right),
					$temp$dict = left;
				n = $temp$n;
				dict = $temp$dict;
				continue sizeHelp;
			}
		}
	});
var elm$core$Dict$size = function (dict) {
	return A2(elm$core$Dict$sizeHelp, 0, dict);
};
var elm$random$Random$initialSeed = function (x) {
	var _n0 = elm$random$Random$next(
		A2(elm$random$Random$Seed, 0, 1013904223));
	var state1 = _n0.a;
	var incr = _n0.b;
	var state2 = (state1 + x) >>> 0;
	return elm$random$Random$next(
		A2(elm$random$Random$Seed, state2, incr));
};
var elm$random$Random$step = F2(
	function (_n0, seed) {
		var generator = _n0;
		return generator(seed);
	});
var author$project$Game$randomStep = F3(
	function (item, gen, _n0) {
		var g = _n0;
		var key = author$project$GameData$Item$name(item);
		var seed0 = elm$random$Random$initialSeed(
			A2(
				elm$core$Maybe$withDefault,
				elm$time$Time$posixToMillis(g.H) + elm$core$Dict$size(g.W),
				A2(elm$core$Dict$get, key, g.W)));
		var _n1 = A2(elm$random$Random$step, gen, seed0);
		var val = _n1.a;
		var seed1 = _n1.b;
		var _n2 = A2(elm$random$Random$step, author$project$RandomUtil$seedInt, seed1);
		var nextSeed = _n2.a;
		return _Utils_Tuple2(
			val,
			_Utils_update(
				g,
				{
					W: A3(elm$core$Dict$insert, key, nextSeed, g.W)
				}));
	});
var elm$random$Random$float = F2(
	function (a, b) {
		return function (seed0) {
			var seed1 = elm$random$Random$next(seed0);
			var range = elm$core$Basics$abs(b - a);
			var n1 = elm$random$Random$peel(seed1);
			var n0 = elm$random$Random$peel(seed0);
			var lo = (134217727 & n1) * 1.0;
			var hi = (67108863 & n0) * 1.0;
			var val = ((hi * 1.34217728e8) + lo) / 9.007199254740992e15;
			var scaled = (val * range) + a;
			return _Utils_Tuple2(
				scaled,
				elm$random$Random$next(seed1));
		};
	});
var elm$random$Random$map = F2(
	function (func, _n0) {
		var genA = _n0;
		return function (seed0) {
			var _n1 = genA(seed0);
			var a = _n1.a;
			var seed1 = _n1.b;
			return _Utils_Tuple2(
				func(a),
				seed1);
		};
	});
var author$project$RandomUtil$chance = function (threshold) {
	return A2(
		elm$random$Random$map,
		function (f) {
			return _Utils_cmp(f, threshold) < 1;
		},
		A2(elm$random$Random$float, 0, 1));
};
var author$project$Decimal$exponent = function (_n0) {
	var exp = _n0.j;
	return exp;
};
var author$project$Decimal$significand = function (_n0) {
	var sig = _n0.i;
	return sig;
};
var elm$random$Random$andThen = F2(
	function (callback, _n0) {
		var genA = _n0;
		return function (seed) {
			var _n1 = genA(seed);
			var result = _n1.a;
			var newSeed = _n1.b;
			var _n2 = callback(result);
			var genB = _n2;
			return genB(newSeed);
		};
	});
var author$project$RandomUtil$decimal = F2(
	function (min, max) {
		var minExp = author$project$Decimal$exponent(min);
		var maxExp = author$project$Decimal$exponent(max);
		return A2(
			elm$random$Random$andThen,
			function (exp) {
				var sigMin = _Utils_eq(exp, minExp) ? author$project$Decimal$significand(min) : 1;
				var sigMax = _Utils_eq(exp, maxExp) ? author$project$Decimal$significand(max) : 10;
				return A2(
					elm$random$Random$map,
					function (sig) {
						return A2(author$project$Decimal$fromSigExp, sig, exp);
					},
					A2(elm$random$Random$float, sigMin, sigMax));
			},
			A2(elm$random$Random$int, minExp, maxExp));
	});
var author$project$RandomUtil$nearDecimal = F3(
	function (mulMin, mulMax, d) {
		return A2(
			author$project$RandomUtil$decimal,
			A2(author$project$Decimal$mulFloat, mulMin, d),
			A2(author$project$Decimal$mulFloat, mulMax, d));
	});
var elm$random$Random$map2 = F3(
	function (func, _n0, _n1) {
		var genA = _n0;
		var genB = _n1;
		return function (seed0) {
			var _n2 = genA(seed0);
			var a = _n2.a;
			var seed1 = _n2.b;
			var _n3 = genB(seed1);
			var b = _n3.a;
			var seed2 = _n3.b;
			return _Utils_Tuple2(
				A2(func, a, b),
				seed2);
		};
	});
var elm$random$Random$pair = F2(
	function (genA, genB) {
		return A3(
			elm$random$Random$map2,
			F2(
				function (a, b) {
					return _Utils_Tuple2(a, b);
				}),
			genA,
			genB);
	});
var author$project$Game$OnBuy$addRandomUnitsOnBuy = F4(
	function (item, args, level, game0) {
		var getCount = function (name) {
			return _Utils_eq(
				name,
				author$project$GameData$Item$name(item)) ? elm$core$Maybe$Just(
				author$project$Decimal$fromInt(level)) : A2(author$project$Game$getGameVar, game0, name);
		};
		var randomCount0 = A3(author$project$Parser$Stat$evalWithDefault, author$project$Decimal$zero, getCount, args.et);
		var chance0 = author$project$Decimal$toFloat(
			A3(author$project$Parser$Stat$evalWithDefault, author$project$Decimal$zero, getCount, args.eo));
		var _n0 = A3(
			author$project$Game$randomStep,
			item,
			A2(
				elm$random$Random$pair,
				author$project$RandomUtil$chance(chance0),
				A3(author$project$RandomUtil$nearDecimal, 0.9, 1.1, randomCount0)),
			game0);
		var _n1 = _n0.a;
		var chance1 = _n1.a;
		var randomCount = _n1.b;
		var game1 = _n0.b;
		var chance = (_Utils_cmp(level, args.e1) > -1) && (chance1 || (!A2(elm$core$Basics$modBy, 8, level)));
		return chance ? A3(
			author$project$Game$addItemId,
			author$project$GameData$Item$Id$UnitId(args.eq),
			randomCount,
			game1) : game1;
	});
var author$project$Game$clearUI = function (_n0) {
	var g = _n0;
	return _Utils_update(
		g,
		{P: author$project$Game$BuyN$empty, S: elm$core$Dict$empty});
};
var author$project$Game$updateSpells = F2(
	function (spells, _n0) {
		var g = _n0;
		return _Utils_update(
			g,
			{s: spells});
	});
var author$project$Game$updateUpgrades = F2(
	function (ups, _n0) {
		var g = _n0;
		return _Utils_update(
			g,
			{o: ups});
	});
var author$project$Game$OnBuy$ascend = function (game) {
	var initUnits = elm$core$Dict$fromList(
		A2(
			elm$core$List$map,
			elm$core$Tuple$mapFirst(author$project$GameData$Unit$name),
			author$project$GameData$initUnits(
				author$project$Game$gameData(game))));
	var ascendPreserve = A2(
		elm$core$List$filter,
		function ($) {
			return $.ef;
		},
		author$project$GameData$units(
			author$project$Game$gameData(game)));
	var unitsDict = A2(
		elm$core$Dict$union,
		initUnits,
		elm$core$Dict$fromList(
			A2(
				elm$core$List$map,
				function (u) {
					return _Utils_Tuple2(
						author$project$GameData$Unit$name(u),
						A2(author$project$Game$unitCount, u.eL, game));
				},
				ascendPreserve)));
	return author$project$Game$clearUI(
		A2(
			author$project$Game$updateUnits,
			A4(
				author$project$Game$UnitsSnapshot$create,
				author$project$Game$snapshotted(game),
				unitsDict,
				elm$core$Dict$empty,
				elm$core$Set$empty),
			A2(
				author$project$Game$updateSpells,
				elm$core$Dict$empty,
				A2(author$project$Game$updateUpgrades, elm$core$Dict$empty, game))));
};
var author$project$Parser$Stat$variables = function (topExpr) {
	var loop = F2(
		function (expr, ret) {
			loop:
			while (true) {
				switch (expr.$) {
					case 1:
						return ret;
					case 0:
						var name = expr.a;
						return A2(elm$core$Set$insert, name, ret);
					case 2:
						var binds = expr.a;
						var body = expr.b;
						return A2(
							elm$core$Set$diff,
							A3(
								elm$core$List$foldl,
								loop,
								ret,
								A2(
									elm$core$List$cons,
									body,
									A2(elm$core$List$map, elm$core$Tuple$second, binds))),
							elm$core$Set$fromList(
								A2(elm$core$List$map, elm$core$Tuple$first, binds)));
					case 4:
						var params = expr.b;
						return A3(elm$core$List$foldl, loop, ret, params);
					case 3:
						var body = expr.b;
						var $temp$expr = body,
							$temp$ret = ret;
						expr = $temp$expr;
						ret = $temp$ret;
						continue loop;
					default:
						var left = expr.b;
						var right = expr.c;
						return A2(
							loop,
							right,
							A2(loop, left, ret));
				}
			}
		});
	return A2(loop, topExpr, elm$core$Set$empty);
};
var author$project$Game$OnBuy$onBuyAddUnits = F4(
	function (id, expr, dCount, game) {
		if (!A2(
			elm$core$Set$member,
			author$project$GameData$Unit$idToString(id),
			author$project$Parser$Stat$variables(expr))) {
			var units1 = A3(
				author$project$Game$UnitsSnapshot$add,
				id,
				A2(
					author$project$Decimal$mul,
					dCount,
					A3(
						author$project$Parser$Stat$evalWithDefault,
						author$project$Decimal$zero,
						author$project$Game$getGameVar(game),
						expr)),
				author$project$Game$units(game));
			return A2(author$project$Game$updateUnits, units1, game);
		} else {
			var loopAdd = F2(
				function (n, snap) {
					loopAdd:
					while (true) {
						if (n <= 0) {
							return snap;
						} else {
							var $temp$n = n - 1,
								$temp$snap = A3(
								author$project$Game$UnitsSnapshot$add,
								id,
								A3(
									author$project$Parser$Stat$evalWithDefault,
									author$project$Decimal$zero,
									A2(author$project$Game$getVar, game, snap),
									expr),
								snap);
							n = $temp$n;
							snap = $temp$snap;
							continue loopAdd;
						}
					}
				});
			var units1 = A2(
				loopAdd,
				elm$core$Basics$floor(
					author$project$Decimal$toFloat(dCount)),
				author$project$Game$units(game));
			return A2(author$project$Game$updateUnits, units1, game);
		}
	});
var author$project$Game$clearUnitsVisibility = function (game) {
	return A4(
		author$project$Game$evalUnits_,
		author$project$Game$snapshotted(game),
		author$project$Duration$zero,
		elm$core$Set$empty,
		game);
};
var author$project$Game$recalculateVisibility = function (game) {
	return A2(
		author$project$Game$updateUnits,
		author$project$Game$clearUnitsVisibility(game),
		game);
};
var author$project$Game$UnitsSnapshot$remove = function (id) {
	return author$project$Game$UnitsSnapshot$mapCounts(
		elm$core$Dict$remove(
			author$project$GameData$Unit$idToString(id)));
};
var author$project$Game$removeItemId = F2(
	function (id, _n0) {
		var g = _n0;
		return author$project$Game$rebuildGraph(
			function () {
				switch (id.$) {
					case 0:
						var u = id.a;
						return _Utils_update(
							g,
							{
								k: A2(author$project$Game$UnitsSnapshot$remove, u, g.k)
							});
					case 1:
						var u = id.a;
						return _Utils_update(
							g,
							{
								o: A2(
									elm$core$Dict$remove,
									author$project$GameData$Upgrade$idToString(u),
									g.o)
							});
					default:
						var u = id.a;
						return _Utils_update(
							g,
							{
								s: A2(
									elm$core$Dict$remove,
									author$project$GameData$Spell$idToString(u),
									g.s)
							});
				}
			}());
	});
var author$project$GameData$itemByName = function (name) {
	return A2(
		elm$core$Basics$composeR,
		author$project$GameData$indexes,
		A2(
			elm$core$Basics$composeR,
			function ($) {
				return $.b4;
			},
			elm$core$Dict$get(name)));
};
var author$project$Game$OnBuy$respecReset = F2(
	function (wipedNames, game) {
		return author$project$Game$recalculateVisibility(
			A3(
				elm$core$List$foldl,
				author$project$Game$removeItemId,
				game,
				A2(
					elm$core$List$map,
					author$project$GameData$Item$id,
					A2(
						elm$core$List$filterMap,
						function (name) {
							return A2(
								author$project$GameData$itemByName,
								name,
								author$project$Game$gameData(game));
						},
						elm$core$Set$toList(wipedNames)))));
	});
var author$project$Game$OnBuy$respecSortBy = function (item) {
	var n = function () {
		switch (item.$) {
			case 1:
				return 0;
			case 0:
				return 1;
			default:
				return 2;
		}
	}();
	return _Utils_Tuple2(
		n,
		author$project$GameData$Item$name(item));
};
var author$project$Game$BuyN$Value = function (a) {
	return {$: 1, a: a};
};
var author$project$Game$Order$fromCount = F3(
	function (game, snap, item) {
		return A2(
			elm$core$Basics$composeR,
			author$project$Game$BuyN$Value,
			A3(author$project$Game$Order$create, game, snap, item));
	});
var elm$core$List$sortBy = _List_sortBy;
var author$project$Game$OnBuy$respecSpent = F3(
	function (currency, resetNames, game0) {
		var loopSpent = F2(
			function (_n1, _n2) {
				var item = _n1.a;
				var count = _n1.b;
				var game = _n2.a;
				var orders = _n2.b;
				var _n0 = A4(
					author$project$Game$Order$fromCount,
					game,
					author$project$Game$units(game),
					item,
					count);
				if (_n0.$ === 1) {
					var err = _n0.a;
					return _Utils_Tuple2(game, orders);
				} else {
					var o = _n0.a;
					return _Utils_Tuple2(
						author$project$Game$refreshSnapshotUnits(
							A3(author$project$Game$addItem, item, count, game)),
						A2(elm$core$List$cons, o, orders));
				}
			});
		var gd = author$project$Game$gameData(game0);
		var resetCounts = A2(
			elm$core$List$map,
			function (resetItem) {
				return _Utils_Tuple2(
					resetItem,
					A2(
						author$project$Game$itemCount,
						author$project$GameData$Item$id(resetItem),
						game0));
			},
			A2(
				elm$core$List$filterMap,
				function (name) {
					return A2(author$project$GameData$itemByName, name, gd);
				},
				elm$core$Set$toList(resetNames)));
		var spentOrders = A3(
			elm$core$List$foldl,
			loopSpent,
			_Utils_Tuple2(
				A2(author$project$Game$OnBuy$respecReset, resetNames, game0),
				_List_Nil),
			A2(
				elm$core$List$sortBy,
				A2(elm$core$Basics$composeR, elm$core$Tuple$first, author$project$Game$OnBuy$respecSortBy),
				resetCounts)).b;
		return author$project$Decimal$sum(
			A2(
				elm$core$List$concatMap,
				A2(
					elm$core$Basics$composeR,
					function ($) {
						return $.es;
					},
					A2(
						elm$core$Basics$composeR,
						elm$core$List$filter(
							A2(
								elm$core$Basics$composeR,
								elm$core$Tuple$first,
								elm$core$Basics$eq(currency))),
						elm$core$List$map(elm$core$Tuple$second))),
				spentOrders));
	});
var author$project$Game$UnitsSnapshot$isTabVisible = function (id) {
	return A2(
		elm$core$Basics$composeR,
		author$project$Game$UnitsSnapshot$visibleNames,
		elm$core$Set$member(
			author$project$GameData$Tab$idToString(id)));
};
var author$project$DecimalDict$mul = F2(
	function (key, d) {
		return A2(
			elm$core$Dict$update,
			key,
			A2(
				elm$core$Basics$composeR,
				elm$core$Maybe$withDefault(author$project$Decimal$zero),
				A2(
					elm$core$Basics$composeR,
					author$project$Decimal$mul(d),
					elm$core$Maybe$Just)));
	});
var author$project$Game$UnitsSnapshot$mul = F2(
	function (id, d) {
		return author$project$Game$UnitsSnapshot$mapCounts(
			A2(
				author$project$DecimalDict$mul,
				author$project$GameData$Unit$idToString(id),
				d));
	});
var author$project$GameData$unitById = A2(elm$core$Basics$composeR, author$project$GameData$Unit$idToString, author$project$GameData$unitByName);
var author$project$Game$OnBuy$run1 = F4(
	function (item, count, trigger, game) {
		var dCount = author$project$GameData$Item$resToDec(count);
		switch (trigger.$) {
			case 0:
				var childUnit = trigger.a;
				var expr = trigger.b;
				return elm$core$Result$Ok(
					A4(author$project$Game$OnBuy$onBuyAddUnits, childUnit, expr, dCount, game));
			case 4:
				var unitId = trigger.a;
				var expr = trigger.b;
				var cooldown = trigger.c;
				var _n1 = A2(
					author$project$GameData$unitById,
					unitId,
					author$project$Game$gameData(game));
				if (_n1.$ === 1) {
					return elm$core$Result$Ok(game);
				} else {
					var unit = _n1.a;
					var units = author$project$Game$units(game);
					if (!(A2(author$project$Game$UnitsSnapshot$isUnitVisible, unitId, units) && A2(author$project$Game$UnitsSnapshot$isTabVisible, unit.fM, units))) {
						return elm$core$Result$Ok(game);
					} else {
						var _n2 = A2(author$project$Game$popCooldown, cooldown, game);
						if (_n2.$ === 1) {
							return elm$core$Result$Ok(game);
						} else {
							var game1 = _n2.a;
							return elm$core$Result$Ok(
								A4(author$project$Game$OnBuy$onBuyAddUnits, unitId, expr, author$project$Decimal$one, game1));
						}
					}
				}
			case 1:
				var childUnit = trigger.a;
				var expr = trigger.b;
				var units1 = A3(
					author$project$Game$UnitsSnapshot$mul,
					childUnit,
					A2(
						author$project$Decimal$flipPowFloat,
						author$project$Decimal$toFloat(dCount),
						A3(
							author$project$Parser$Stat$evalWithDefault,
							author$project$Decimal$zero,
							author$project$Game$getGameVar(game),
							expr)),
					author$project$Game$units(game));
				return elm$core$Result$Ok(
					A2(author$project$Game$updateUnits, units1, game));
			case 2:
				var expr = trigger.a;
				var dur = author$project$Duration$fromSecs(
					author$project$Decimal$toFloat(
						A2(
							author$project$Decimal$mul,
							dCount,
							A3(
								author$project$Parser$Stat$evalWithDefault,
								author$project$Decimal$zero,
								author$project$Game$getGameVar(game),
								expr))));
				return elm$core$Result$Ok(
					A2(
						author$project$Game$updateUnits,
						A2(author$project$Game$skipTime, dur, game),
						game));
			case 3:
				var args = trigger.a;
				if (!count.$) {
					var n = count.a;
					var start = elm$core$Basics$floor(
						author$project$Decimal$toFloat(
							A2(
								author$project$Game$itemCount,
								author$project$GameData$Item$id(item),
								game))) - n;
					var levels = A2(elm$core$List$range, start + 1, start + n);
					return elm$core$Result$Ok(
						A3(
							elm$core$List$foldl,
							A2(author$project$Game$OnBuy$addRandomUnitsOnBuy, item, args),
							game,
							levels));
				} else {
					var err = count;
					return elm$core$Result$Err('order.count is too large for AddRandomUnits');
				}
			case 6:
				return elm$core$Result$Ok(
					author$project$Game$OnBuy$ascend(game));
			default:
				var currency = trigger.a;
				var rate = trigger.b;
				var resetNames = trigger.c;
				var spent = A3(author$project$Game$OnBuy$respecSpent, currency, resetNames, game);
				var refunded = A2(author$project$Decimal$mulFloat, rate, spent);
				return elm$core$Result$Ok(
					A3(
						author$project$Game$addItemId,
						author$project$GameData$Item$Id$UnitId(currency),
						refunded,
						A2(author$project$Game$OnBuy$respecReset, resetNames, game)));
		}
	});
var author$project$GameData$Item$onBuy = function (item) {
	switch (item.$) {
		case 0:
			var u = item.a;
			return u.e9;
		case 1:
			var u = item.a;
			return u.e9;
		default:
			var u = item.a;
			return u.e9;
	}
};
var author$project$Game$OnBuy$run = F2(
	function (_n0, game) {
		var item = _n0.eW;
		var count = _n0.et;
		return A3(
			elm$core$List$foldl,
			function (onBuy) {
				return elm$core$Result$andThen(
					A3(author$project$Game$OnBuy$run1, item, count, onBuy));
			},
			elm$core$Result$Ok(game),
			author$project$GameData$Item$onBuy(item).ec);
	});
var author$project$Game$BuyOrder$buy = function (o) {
	return A2(
		elm$core$Basics$composeR,
		author$project$Game$BuyOrder$pay(o),
		A2(
			elm$core$Basics$composeR,
			elm$core$Result$map(
				A2(
					author$project$Game$addItem,
					o.eW,
					author$project$GameData$Item$resToDec(o.et))),
			A2(
				elm$core$Basics$composeR,
				elm$core$Result$andThen(
					author$project$Game$OnBuy$run(o)),
				A2(
					elm$core$Basics$composeR,
					elm$core$Result$map(
						A2(
							elm$core$Basics$composeR,
							author$project$Game$BuyOrder$applyMinUnits,
							author$project$Game$pushStatistics(o))),
					elm$core$Result$map(author$project$Game$refreshSnapshotUnits)))));
};
var author$project$View$TabNav$filterResult = F3(
	function (err, filterFn, res) {
		var _n0 = A2(elm$core$Result$map, filterFn, res);
		if ((!_n0.$) && (!_n0.a)) {
			return elm$core$Result$Err(err);
		} else {
			return res;
		}
	});
var author$project$View$TabNav$bulkUpgradeItemOrder = F3(
	function (pct, item, game) {
		return A3(
			author$project$View$TabNav$filterResult,
			'order not possible',
			function ($) {
				return $.ds;
			},
			A4(
				author$project$Select$itemWatchedOrder,
				pct,
				game,
				author$project$Game$units(game),
				item));
	});
var author$project$View$TabNav$buyBulkUpgradeItem = F4(
	function (now, pct, item, game0) {
		var game = A2(author$project$Game$snapshotUnits, now, game0);
		return A2(
			elm$core$Result$withDefault,
			game,
			A2(
				elm$core$Result$andThen,
				function (o) {
					return A2(author$project$Game$BuyOrder$buy, o, game);
				},
				A3(author$project$View$TabNav$bulkUpgradeItemOrder, pct, item, game)));
	});
var author$project$View$TabNav$bulkUpgrade = F2(
	function (pct, session) {
		var _n0 = author$project$Session$game(session);
		if (_n0.$ === 3) {
			var game0 = _n0.a;
			var now = A2(author$project$Session$safeNow, game0, session);
			var game = A2(author$project$Game$snapshotUnits, now, game0);
			var items = A3(
				author$project$Select$bulkBuyableItems,
				pct,
				game,
				author$project$Game$units(game));
			return A2(
				elm$core$Tuple$mapFirst,
				function (g) {
					return A3(author$project$Session$setGame, true, g, session);
				},
				A2(
					author$project$Session$persistWrite,
					session,
					A3(
						elm$core$List$foldl,
						A2(author$project$View$TabNav$buyBulkUpgradeItem, now, pct),
						game,
						items)));
		} else {
			return _Utils_Tuple2(session, elm$core$Platform$Cmd$none);
		}
	});
var author$project$View$TabNav$update = F2(
	function (msg, session) {
		switch (msg.$) {
			case 0:
				return author$project$Session$undo(session);
			case 1:
				return _Utils_Tuple2(
					session,
					author$project$Ports$Kongregate$kongregateShowRegistrationBox(0));
			case 2:
				var n = msg.a;
				return (!n) ? _Utils_Tuple2(session, elm$core$Platform$Cmd$none) : A2(author$project$View$TabNav$bulkUpgrade, 1, session);
			case 3:
				var n = msg.a;
				return (!n) ? _Utils_Tuple2(session, elm$core$Platform$Cmd$none) : A2(author$project$View$TabNav$bulkUpgrade, 0.25, session);
			default:
				return _Utils_Tuple2(
					A2(author$project$Session$setKeyCombosHelp, true, session),
					elm$core$Platform$Cmd$none);
		}
	});
var author$project$Page$MtxHistory$update = F2(
	function (msg, model) {
		var invReq = model.a;
		var session = model.b;
		switch (msg.$) {
			case 0:
				var submsg = msg.a;
				return A2(
					elm$core$Tuple$mapFirst,
					author$project$Page$MtxHistory$Model(invReq),
					A2(author$project$View$TabNav$update, submsg, session));
			case 1:
				var s = msg.a;
				_n1$2:
				while (true) {
					if (!invReq.$) {
						if (!invReq.a.$) {
							var _n2 = invReq.a;
							return author$project$Page$MtxHistory$create(s);
						} else {
							break _n1$2;
						}
					} else {
						if (!invReq.a.$) {
							var _n3 = invReq.a;
							return author$project$Page$MtxHistory$create(s);
						} else {
							break _n1$2;
						}
					}
				}
				return _Utils_Tuple2(
					A2(author$project$Page$MtxHistory$Model, invReq, s),
					elm$core$Platform$Cmd$none);
			case 2:
				var invRes = msg.a;
				var session1 = function () {
					var _n4 = _Utils_Tuple2(
						invRes,
						author$project$Session$game(session));
					if ((!_n4.a.$) && (_n4.b.$ === 3)) {
						var inv = _n4.a.a;
						var game = _n4.b.a;
						return A3(
							author$project$Session$setGame,
							false,
							A2(author$project$Game$updatePlayFabMtxHistory, inv, game),
							session);
					} else {
						return session;
					}
				}();
				return _Utils_Tuple2(
					A2(
						author$project$Page$MtxHistory$Model,
						author$project$Page$MtxHistory$PlayFabInventory(
							krisajenkins$remotedata$RemoteData$fromResult(invRes)),
						session1),
					elm$core$Platform$Cmd$none);
			default:
				var json = msg.a;
				var invRes = A2(
					elm$core$Result$mapError,
					elm$json$Json$Decode$errorToString,
					A2(elm$json$Json$Decode$decodeValue, author$project$Kongregate$Inventory$decoder, json.eu));
				var session1 = function () {
					var _n5 = _Utils_Tuple2(
						invRes,
						author$project$Session$game(session));
					if ((!_n5.a.$) && (_n5.b.$ === 3)) {
						var inv = _n5.a.a;
						var game = _n5.b.a;
						return A3(
							author$project$Session$setGame,
							false,
							A2(author$project$Game$updateKongMtxHistory, inv, game),
							session);
					} else {
						return session;
					}
				}();
				return _Utils_Tuple2(
					A2(
						author$project$Page$MtxHistory$Model,
						author$project$Page$MtxHistory$KongregateInventory(
							krisajenkins$remotedata$RemoteData$fromResult(invRes)),
						session1),
					elm$core$Platform$Cmd$none);
		}
	});
var author$project$Page$MtxShop$GotSession = function (a) {
	return {$: 0, a: a};
};
var author$project$Page$MtxShop$KongregatePurchase = function (a) {
	return {$: 1, a: a};
};
var author$project$Ports$Kongregate$kongregatePurchaseItemsReq = _Platform_outgoingPort('kongregatePurchaseItemsReq', elm$json$Json$Encode$string);
var author$project$Ports$Kongregate$kongregateShowKredPurchaseDialog = _Platform_outgoingPort(
	'kongregateShowKredPurchaseDialog',
	function ($) {
		return elm$json$Json$Encode$null;
	});
var author$project$Page$MtxShop$update = F2(
	function (msg, model) {
		var invRes0 = model.a;
		var tabName = model.b;
		var purchase = model.c;
		var session = model.d;
		switch (msg.$) {
			case 9:
				return _Utils_Tuple2(model, elm$core$Platform$Cmd$none);
			case 0:
				var s = msg.a;
				_n1$2:
				while (true) {
					if (!invRes0.$) {
						if (!invRes0.a.$) {
							var _n2 = invRes0.a;
							return A3(author$project$Page$MtxShop$recreate, tabName, purchase, s);
						} else {
							break _n1$2;
						}
					} else {
						if (!invRes0.a.$) {
							var _n3 = invRes0.a;
							return A3(author$project$Page$MtxShop$recreate, tabName, purchase, s);
						} else {
							break _n1$2;
						}
					}
				}
				return _Utils_Tuple2(
					A4(author$project$Page$MtxShop$Model, invRes0, tabName, purchase, s),
					elm$core$Platform$Cmd$none);
			case 4:
				var res = msg.a;
				if ((!purchase.$) && (!purchase.a.$)) {
					var _n5 = purchase.a;
					var paypalReturnArgs = _n5.b;
					return A3(
						author$project$Page$MtxShop$recreate,
						tabName,
						elm$core$Maybe$Just(
							A2(
								author$project$Page$MtxShop$PaypalPurchase,
								krisajenkins$remotedata$RemoteData$fromResult(res),
								paypalReturnArgs)),
						session);
				} else {
					return _Utils_Tuple2(
						A4(author$project$Page$MtxShop$Model, invRes0, tabName, purchase, session),
						elm$core$Platform$Cmd$none);
				}
			case 1:
				var invRes = msg.a;
				var session1 = function () {
					var _n6 = _Utils_Tuple2(
						invRes,
						author$project$Session$game(session));
					if ((!_n6.a.$) && (_n6.b.$ === 3)) {
						var inv = _n6.a.a;
						var game = _n6.b.a;
						return A3(
							author$project$Session$setGame,
							false,
							A2(author$project$Game$updatePlayFabMtxHistory, inv, game),
							session);
					} else {
						return session;
					}
				}();
				return _Utils_Tuple2(
					A4(
						author$project$Page$MtxShop$Model,
						author$project$Page$MtxShop$PlayFabInventory(
							krisajenkins$remotedata$RemoteData$fromResult(invRes)),
						tabName,
						purchase,
						session1),
					elm$core$Platform$Cmd$none);
			case 2:
				var json = msg.a;
				var invRes = A2(
					elm$core$Result$mapError,
					elm$json$Json$Decode$errorToString,
					A2(elm$json$Json$Decode$decodeValue, author$project$Kongregate$Inventory$decoder, json.eu));
				var session1 = function () {
					var _n7 = _Utils_Tuple2(
						invRes,
						author$project$Session$game(session));
					if ((!_n7.a.$) && (_n7.b.$ === 3)) {
						var inv = _n7.a.a;
						var game = _n7.b.a;
						return A3(
							author$project$Session$setGame,
							false,
							A2(author$project$Game$updateKongMtxHistory, inv, game),
							session);
					} else {
						return session;
					}
				}();
				return _Utils_Tuple2(
					A4(
						author$project$Page$MtxShop$Model,
						author$project$Page$MtxShop$KongregateInventory(
							krisajenkins$remotedata$RemoteData$fromResult(invRes)),
						tabName,
						purchase,
						session1),
					elm$core$Platform$Cmd$none);
			case 5:
				var route = msg.a;
				return _Utils_Tuple2(
					A4(author$project$Page$MtxShop$Model, invRes0, tabName, purchase, session),
					A3(
						author$project$Route$pushUrl,
						author$project$Session$nav(session),
						author$project$Session$query(session),
						route));
			case 6:
				return _Utils_Tuple2(
					model,
					author$project$Ports$Kongregate$kongregateShowKredPurchaseDialog(0));
			case 7:
				var mtx = msg.a;
				return _Utils_Tuple2(
					model,
					author$project$Ports$Kongregate$kongregatePurchaseItemsReq(
						author$project$GameData$Mtx$idToString(mtx.eL)));
			case 3:
				var success = msg.a.fK;
				var item = msg.a.eW;
				if (success) {
					var _n8 = author$project$Session$gameData(session);
					if (!_n8.$) {
						var gd = _n8.a;
						var _n9 = A2(author$project$GameData$mtxByName, item, gd);
						if (!_n9.$) {
							var mtx = _n9.a;
							return _Utils_Tuple2(
								A4(
									author$project$Page$MtxShop$Model,
									invRes0,
									tabName,
									elm$core$Maybe$Just(
										author$project$Page$MtxShop$KongregatePurchase(mtx)),
									session),
								author$project$Ports$Kongregate$kongregateRequestUserItemListReq(0));
						} else {
							return _Utils_Tuple2(model, elm$core$Platform$Cmd$none);
						}
					} else {
						return _Utils_Tuple2(model, elm$core$Platform$Cmd$none);
					}
				} else {
					return _Utils_Tuple2(model, elm$core$Platform$Cmd$none);
				}
			default:
				var submsg = msg.a;
				return A2(
					elm$core$Tuple$mapFirst,
					A3(author$project$Page$MtxShop$Model, invRes0, tabName, purchase),
					A2(author$project$View$TabNav$update, submsg, session));
		}
	});
var author$project$Page$Options$GotSession = function (a) {
	return {$: 0, a: a};
};
var author$project$Game$setLocale = F2(
	function (locale_, _n0) {
		var g = _n0;
		return _Utils_update(
			g,
			{
				av: elm$core$Maybe$Just(locale_)
			});
	});
var author$project$Game$setNumberFormat = F2(
	function (format, _n0) {
		var g = _n0;
		return _Utils_update(
			g,
			{ay: format});
	});
var author$project$Game$setTheme = F2(
	function (theme_, _n0) {
		var g = _n0;
		return _Utils_update(
			g,
			{aG: theme_});
	});
var author$project$Game$setVelocityUnit = F2(
	function (format, _n0) {
		var g = _n0;
		return _Utils_update(
			g,
			{aL: format});
	});
var author$project$Persist$readDecoder = function () {
	var builder = function (status) {
		switch (status) {
			case 'empty':
				return elm$json$Json$Decode$succeed(elm$core$Maybe$Nothing);
			case 'success':
				return A2(
					elm$json$Json$Decode$map,
					elm$core$Maybe$Just,
					A3(
						elm$json$Json$Decode$map2,
						elm$core$Tuple$pair,
						A2(elm$json$Json$Decode$field, 'value', elm$json$Json$Decode$value),
						A2(elm$json$Json$Decode$field, 'raw', elm$json$Json$Decode$string)));
			case 'error':
				return elm$json$Json$Decode$fail('persistRead javascript error');
			default:
				return elm$json$Json$Decode$fail('persistRead javascript unknown-status: ' + status);
		}
	};
	return A2(
		elm$json$Json$Decode$andThen,
		builder,
		A2(elm$json$Json$Decode$field, 'status', elm$json$Json$Decode$string));
}();
var author$project$Ports$persistImport = _Platform_outgoingPort('persistImport', elm$json$Json$Encode$string);
var elm$core$Result$map2 = F3(
	function (func, ra, rb) {
		if (ra.$ === 1) {
			var x = ra.a;
			return elm$core$Result$Err(x);
		} else {
			var a = ra.a;
			if (rb.$ === 1) {
				var x = rb.a;
				return elm$core$Result$Err(x);
			} else {
				var b = rb.a;
				return elm$core$Result$Ok(
					A2(func, a, b));
			}
		}
	});
var author$project$Session$resetGame = function (session0) {
	var session = session0;
	return A3(
		elm$core$Result$map2,
		F2(
			function (gd, t) {
				return _Utils_update(
					session,
					{
						ae: A2(
							author$project$Session$GameLoader$set,
							A2(author$project$Game$empty, gd, t),
							session.ae)
					});
			}),
		author$project$Session$gameData(session0),
		A2(elm$core$Result$fromMaybe, 'time not set', session.cm));
};
var author$project$Session$setPersistExport = F2(
	function (exp, _n0) {
		var session = _n0;
		return _Utils_update(
			session,
			{ak: exp});
	});
var author$project$Page$Options$update = F2(
	function (msg, model0) {
		var model = model0;
		switch (msg.$) {
			case 0:
				var s = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{f: s}),
					elm$core$Platform$Cmd$none);
			case 1:
				var _n1 = author$project$Session$resetGame(model.f);
				if (!_n1.$) {
					var session1 = _n1.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{f: session1}),
						A3(
							author$project$Route$pushUrl,
							author$project$Session$nav(model.f),
							author$project$Session$query(model.f),
							author$project$Route$Home));
				} else {
					var err = _n1.a;
					return _Utils_Tuple2(model0, elm$core$Platform$Cmd$none);
				}
			case 2:
				var locale = msg.a;
				var _n2 = author$project$Session$game(model.f);
				if (_n2.$ === 3) {
					var game = _n2.a;
					return A2(
						elm$core$Tuple$mapFirst,
						function (g) {
							return _Utils_update(
								model,
								{
									f: A3(author$project$Session$setGame, false, g, model.f)
								});
						},
						A2(
							author$project$Session$persistWrite,
							model.f,
							A2(author$project$Game$setLocale, locale, game)));
				} else {
					return _Utils_Tuple2(model0, elm$core$Platform$Cmd$none);
				}
			case 3:
				var theme = msg.a;
				var _n3 = author$project$Session$game(model.f);
				if (_n3.$ === 3) {
					var game = _n3.a;
					return A2(
						elm$core$Tuple$mapFirst,
						function (g) {
							return _Utils_update(
								model,
								{
									f: A3(author$project$Session$setGame, false, g, model.f)
								});
						},
						A2(
							author$project$Session$persistWrite,
							model.f,
							A2(author$project$Game$setTheme, theme, game)));
				} else {
					return _Utils_Tuple2(model0, elm$core$Platform$Cmd$none);
				}
			case 4:
				var format = msg.a;
				var _n4 = author$project$Session$game(model.f);
				if (_n4.$ === 3) {
					var game = _n4.a;
					return A2(
						elm$core$Tuple$mapFirst,
						function (g) {
							return _Utils_update(
								model,
								{
									f: A3(author$project$Session$setGame, false, g, model.f)
								});
						},
						A2(
							author$project$Session$persistWrite,
							model.f,
							A2(author$project$Game$setNumberFormat, format, game)));
				} else {
					return _Utils_Tuple2(model0, elm$core$Platform$Cmd$none);
				}
			case 5:
				var format = msg.a;
				var _n5 = author$project$Session$game(model.f);
				if (_n5.$ === 3) {
					var game = _n5.a;
					return A2(
						elm$core$Tuple$mapFirst,
						function (g) {
							return _Utils_update(
								model,
								{
									f: A3(author$project$Session$setGame, false, g, model.f)
								});
						},
						A2(
							author$project$Session$persistWrite,
							model.f,
							A2(author$project$Game$setVelocityUnit, format, game)));
				} else {
					return _Utils_Tuple2(model0, elm$core$Platform$Cmd$none);
				}
			case 6:
				var save = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ah: krisajenkins$remotedata$RemoteData$Loading,
							f: A2(
								author$project$Session$setPersistExport,
								elm$core$Maybe$Just(save),
								model.f)
						}),
					author$project$Ports$persistImport(save));
			case 7:
				var json = msg.a;
				var _n6 = A2(elm$json$Json$Decode$decodeValue, author$project$Persist$readDecoder, json);
				if (!_n6.$) {
					if (!_n6.a.$) {
						var _n7 = _n6.a.a;
						var r = _n7.a;
						var e = _n7.b;
						var session1 = A2(
							author$project$Session$setPersistExport,
							elm$core$Maybe$Just(e),
							A2(
								author$project$Session$setPersistRead,
								elm$core$Result$Ok(
									elm$core$Maybe$Just(r)),
								model.f));
						var _n8 = author$project$Session$game(session1);
						switch (_n8.$) {
							case 3:
								return A2(
									elm$core$Tuple$mapFirst,
									function (s) {
										return _Utils_update(
											model,
											{
												ah: krisajenkins$remotedata$RemoteData$succeed(0),
												f: s
											});
									},
									A2(author$project$Session$grantAchievement, 'import', session1));
							case 2:
								var err = _n8.a;
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											ah: krisajenkins$remotedata$RemoteData$Failure(err)
										}),
									elm$core$Platform$Cmd$none);
							default:
								return _Utils_Tuple2(model, elm$core$Platform$Cmd$none);
						}
					} else {
						var _n9 = _n6.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									ah: krisajenkins$remotedata$RemoteData$Failure('Imported save was empty?')
								}),
							elm$core$Platform$Cmd$none);
					}
				} else {
					var err = _n6.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								ah: krisajenkins$remotedata$RemoteData$Failure(
									elm$json$Json$Decode$errorToString(err))
							}),
						elm$core$Platform$Cmd$none);
				}
			default:
				var submsg = msg.a;
				return A2(
					elm$core$Tuple$mapFirst,
					function (s) {
						return _Utils_update(
							model,
							{f: s});
					},
					A2(author$project$View$TabNav$update, submsg, model.f));
		}
	});
var author$project$Page$Register$GotSession = function (a) {
	return {$: 0, a: a};
};
var author$project$Page$Register$RegisterResponse = function (a) {
	return {$: 6, a: a};
};
var author$project$Page$Register$RememberMeResponse = function (a) {
	return {$: 7, a: a};
};
var author$project$PlayFab$emailRegister = F3(
	function (id, req, toMsg) {
		return elm$http$Http$post(
			{
				cZ: elm$http$Http$jsonBody(
					elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'TitleId',
								author$project$PlayFab$TitleId$encode(id)),
								_Utils_Tuple2(
								'RequireBothUsernameAndEmail',
								elm$json$Json$Encode$bool(false)),
								_Utils_Tuple2(
								'Email',
								elm$json$Json$Encode$string(req.bW)),
								_Utils_Tuple2(
								'Password',
								elm$json$Json$Encode$string(req.cq)),
								_Utils_Tuple2('InfoRequestParameters', author$project$PlayFab$infoRequestParameters)
							]))),
				z: A2(
					author$project$PlayFab$expectJson,
					toMsg,
					author$project$PlayFab$User$decoder(
						_Utils_update(
							author$project$PlayFab$userDecoderConfig,
							{
								bW: elm$core$Maybe$Just(req.bW)
							}))),
				B: author$project$PlayFab$TitleId$host(id) + '/Client/RegisterPlayFabUser'
			});
	});
var elm$core$Dict$singleton = F2(
	function (key, value) {
		return A5(elm$core$Dict$RBNode_elm_builtin, 1, key, value, elm$core$Dict$RBEmpty_elm_builtin, elm$core$Dict$RBEmpty_elm_builtin);
	});
var author$project$Page$Register$update = F2(
	function (msg, model0) {
		var model = model0;
		switch (msg.$) {
			case 0:
				var s = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{f: s}),
					elm$core$Platform$Cmd$none);
			case 2:
				var val = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bW: val}),
					elm$core$Platform$Cmd$none);
			case 3:
				var val = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cq: val}),
					elm$core$Platform$Cmd$none);
			case 4:
				var val = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bu: val}),
					elm$core$Platform$Cmd$none);
			case 5:
				var val = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bv: val}),
					elm$core$Platform$Cmd$none);
			case 1:
				if (_Utils_eq(model.cq, model.bu)) {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{a$: krisajenkins$remotedata$RemoteData$Loading}),
						A3(
							author$project$PlayFab$emailRegister,
							author$project$PlayFab$TitleId$fromSession(model.f),
							model,
							author$project$Page$Register$RegisterResponse));
				} else {
					var res = krisajenkins$remotedata$RemoteData$Failure(
						author$project$PlayFab$Error$FormError(
							{
								eA: '',
								eF: A2(
									elm$core$Dict$singleton,
									'Password2',
									_List_fromArray(
										['Passwords do not match.']))
							}));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{a$: res}),
						elm$core$Platform$Cmd$none);
				}
			case 6:
				var res = msg.a;
				var model1 = _Utils_update(
					model,
					{
						a$: krisajenkins$remotedata$RemoteData$fromResult(res)
					});
				if (!res.$) {
					var u0 = res.a;
					var _n2 = author$project$PlayFab$User$decodeGameReq(u0);
					var user = _n2.a;
					var cmd0 = _n2.b;
					return _Utils_Tuple2(
						_Utils_update(
							model1,
							{
								f: A2(
									author$project$Session$setUser,
									krisajenkins$remotedata$RemoteData$Success(
										elm$core$Maybe$Just(user)),
									model.f)
							}),
						elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									cmd0,
									author$project$Ports$writeUserSessionTicket(
									elm$core$Maybe$Just(
										author$project$PlayFab$User$ticketToString(
											author$project$PlayFab$User$sessionTicket(user)))),
									model.bv ? A3(
									author$project$PlayFab$setRememberId,
									author$project$PlayFab$TitleId$fromSession(model.f),
									user,
									author$project$Page$Register$RememberMeResponse) : A3(
									author$project$Route$pushUrl,
									author$project$Session$nav(model.f),
									author$project$Session$query(model.f),
									author$project$Route$Home)
								])));
				} else {
					return _Utils_Tuple2(model1, elm$core$Platform$Cmd$none);
				}
			default:
				var res = msg.a;
				if (!res.$) {
					var user = res.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								f: A2(author$project$Session$setRawUser, user, model.f)
							}),
						elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									author$project$Ports$writeUserRememberId(
									A2(
										elm$core$Maybe$map,
										author$project$PlayFab$User$rememberIdToFullString,
										author$project$PlayFab$User$rememberId(user))),
									A3(
									author$project$Route$pushUrl,
									author$project$Session$nav(model.f),
									author$project$Session$query(model.f),
									author$project$Route$Home)
								])));
				} else {
					return _Utils_Tuple2(model0, elm$core$Platform$Cmd$none);
				}
		}
	});
var author$project$Page$ResetPassword$GotSession = function (a) {
	return {$: 0, a: a};
};
var author$project$Page$ResetPassword$Response = function (a) {
	return {$: 3, a: a};
};
var author$project$PlayFab$resetPassword = F3(
	function (id, req, toMsg) {
		return elm$http$Http$post(
			{
				cZ: elm$http$Http$jsonBody(
					elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'TitleId',
								author$project$PlayFab$TitleId$encode(id)),
								_Utils_Tuple2(
								'Email',
								elm$json$Json$Encode$string(req.bW))
							]))),
				z: A2(
					author$project$PlayFab$expectJson,
					toMsg,
					elm$json$Json$Decode$succeed(0)),
				B: author$project$PlayFab$TitleId$host(id) + '/Client/SendAccountRecoveryEmail'
			});
	});
var author$project$Page$ResetPassword$update = F2(
	function (msg, model0) {
		var model = model0;
		switch (msg.$) {
			case 0:
				var s = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{f: s}),
					elm$core$Platform$Cmd$none);
			case 2:
				var val = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bW: val}),
					elm$core$Platform$Cmd$none);
			case 1:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{a$: krisajenkins$remotedata$RemoteData$Loading}),
					A3(
						author$project$PlayFab$resetPassword,
						author$project$PlayFab$TitleId$fromSession(model.f),
						model,
						author$project$Page$ResetPassword$Response));
			default:
				var res = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							a$: krisajenkins$remotedata$RemoteData$fromResult(res)
						}),
					elm$core$Platform$Cmd$none);
		}
	});
var author$project$Page$Spell$GotSession = function (a) {
	return {$: 0, a: a};
};
var author$project$Game$BuyN$init1 = '100%';
var author$project$Game$BuyN$Target = function (a) {
	return {$: 2, a: a};
};
var author$project$Game$BuyN$TwinValue = function (a) {
	return {$: 3, a: a};
};
var author$project$Game$BuyN$parseNumber = A2(
	elm$parser$Parser$andThen,
	function (s) {
		var _n0 = author$project$Decimal$fromString(s);
		if (!_n0.$) {
			var d = _n0.a;
			return elm$parser$Parser$succeed(d);
		} else {
			return elm$parser$Parser$problem('not a decimal: ' + s);
		}
	},
	elm$parser$Parser$variable(
		{
			eR: function (c) {
				return elm$core$Char$isDigit(c) || ((c === 'e') || ((c === '.') || ((c === '-') || (c === '+'))));
			},
			fr: elm$core$Set$empty,
			fF: elm$core$Char$isDigit
		}));
var author$project$Game$BuyN$parser = elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			elm$parser$Parser$keeper,
			A2(
				elm$parser$Parser$ignorer,
				elm$parser$Parser$succeed(author$project$Game$BuyN$Target),
				elm$parser$Parser$symbol('@')),
			author$project$Game$BuyN$parseNumber),
			A2(
			elm$parser$Parser$keeper,
			A2(
				elm$parser$Parser$ignorer,
				elm$parser$Parser$succeed(author$project$Game$BuyN$TwinValue),
				elm$parser$Parser$symbol('=')),
			author$project$Game$BuyN$parseNumber),
			A2(
			elm$parser$Parser$map,
			function (_n0) {
				var n = _n0.a;
				var fn = _n0.b;
				return fn(n);
			},
			A2(
				elm$parser$Parser$keeper,
				A2(
					elm$parser$Parser$keeper,
					elm$parser$Parser$succeed(elm$core$Tuple$pair),
					author$project$Game$BuyN$parseNumber),
				A2(
					elm$parser$Parser$ignorer,
					elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								A2(
								elm$parser$Parser$ignorer,
								elm$parser$Parser$succeed(
									A2(
										elm$core$Basics$composeR,
										author$project$Decimal$toFloat,
										A2(elm$core$Basics$composeR, elm$core$Basics$floor, author$project$Game$BuyN$Percent))),
								elm$parser$Parser$symbol('%')),
								elm$parser$Parser$succeed(author$project$Game$BuyN$Value)
							])),
					elm$parser$Parser$end)))
		]));
var author$project$Game$BuyN$parse = A2(
	elm$core$Basics$composeR,
	elm$parser$Parser$run(author$project$Game$BuyN$parser),
	elm$core$Result$mapError(elm$parser$Parser$deadEndsToString));
var author$project$GameData$Item$buyGroup = function (item) {
	switch (item.$) {
		case 0:
			var u = item.a;
			return author$project$GameData$Unit$name(u);
		case 1:
			var u = item.a;
			return u.el;
		default:
			var u = item.a;
			return author$project$GameData$Spell$name(u);
	}
};
var author$project$Game$BuyN$get = F2(
	function (item, _n0) {
		var dict = _n0;
		var raw = A2(
			elm$core$Maybe$withDefault,
			author$project$Game$BuyN$init1,
			A2(
				elm$core$Dict$get,
				author$project$GameData$Item$buyGroup(item),
				dict));
		return _Utils_Tuple2(
			raw,
			author$project$Game$BuyN$parse(raw));
	});
var author$project$Game$buyN = function (item) {
	return A2(
		elm$core$Basics$composeR,
		author$project$Game$unwrap,
		A2(
			elm$core$Basics$composeR,
			function ($) {
				return $.P;
			},
			author$project$Game$BuyN$get(item)));
};
var author$project$Game$Order$createOnNonfatalError = F4(
	function (game, snapshot, item, err) {
		return function (o) {
			return _Utils_update(
				o,
				{
					cE: elm$core$Result$Err(err)
				});
		}(
			A6(
				author$project$Game$Order$createUnsafe,
				game,
				snapshot,
				item,
				author$project$Game$BuyN$Value(author$project$Decimal$one),
				elm$core$Maybe$Nothing,
				elm$core$Result$Ok(1)));
	});
var author$project$Game$Order$fromBuyN = F3(
	function (game, snapshot, item) {
		var _n0 = A2(author$project$Game$buyN, item, game).b;
		if (!_n0.$) {
			var request = _n0.a;
			return A4(author$project$Game$Order$create, game, snapshot, item, request);
		} else {
			var err = _n0.a;
			return elm$core$Result$Ok(
				A4(author$project$Game$Order$createOnNonfatalError, game, snapshot, item, err));
		}
	});
var author$project$Page$Spell$GotBuyNMsg = function (a) {
	return {$: 2, a: a};
};
var author$project$Route$Spell = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var author$project$GameData$spellBySlug = function (name) {
	return A2(
		elm$core$Basics$composeR,
		author$project$GameData$indexes,
		A2(
			elm$core$Basics$composeR,
			function ($) {
				return $.cC;
			},
			elm$core$Dict$get(
				elm$core$String$toLower(name))));
};
var author$project$Game$UnitsSnapshot$isSpellVisible = function (id) {
	return A2(
		elm$core$Basics$composeR,
		author$project$Game$UnitsSnapshot$visibleNames,
		elm$core$Set$member(
			author$project$GameData$Spell$idToString(id)));
};
var author$project$Select$isSpellVisible = F2(
	function (snapshot, u) {
		return A2(author$project$Game$UnitsSnapshot$isSpellVisible, u.eL, snapshot);
	});
var author$project$Select$spellBySlug = F3(
	function (spellSlug, game, snapshot) {
		return A2(
			elm_community$maybe_extra$Maybe$Extra$filter,
			author$project$Select$isSpellVisible(snapshot),
			A2(
				author$project$GameData$spellBySlug,
				spellSlug,
				author$project$Game$gameData(game)));
	});
var author$project$Session$units = A2(
	elm$core$Basics$composeR,
	author$project$Session$unwrap,
	function ($) {
		return $.a8;
	});
var author$project$Session$safeUnits = F2(
	function (g, session) {
		var _n0 = author$project$Session$units(session);
		if (!_n0.$) {
			var u = _n0.a;
			return u;
		} else {
			return A2(
				author$project$Game$evalUnits,
				A2(author$project$Session$safeNow, g, session),
				g);
		}
	});
var author$project$View$BuyN$ClickedBuy = function (a) {
	return {$: 1, a: a};
};
var author$project$Game$BuyN$insert = F3(
	function (item, val, _n0) {
		var dict = _n0;
		return A3(
			elm$core$Dict$insert,
			author$project$GameData$Item$buyGroup(item),
			val,
			dict);
	});
var author$project$Game$setBuyN = F3(
	function (item, val, _n0) {
		var g = _n0;
		return _Utils_update(
			g,
			{
				P: A3(author$project$Game$BuyN$insert, item, val, g.P)
			});
	});
var author$project$Game$setCostUI = F2(
	function (c, _n0) {
		var g = _n0;
		return _Utils_update(
			g,
			{aq: c});
	});
var author$project$View$BuyN$clickedBuy = F3(
	function (session, order, game) {
		return A2(
			elm$core$Result$map,
			author$project$Session$persistWrite(session),
			A2(
				author$project$Game$BuyOrder$buy,
				order,
				A2(
					author$project$Game$snapshotUnits,
					A2(author$project$Session$safeNow, game, session),
					game)));
	});
var author$project$Route$Unit = F3(
	function (a, b, c) {
		return {$: 4, a: a, b: b, c: c};
	});
var author$project$Route$unit = F2(
	function (tab, name) {
		return A3(
			author$project$Route$Unit,
			tab,
			name,
			{dz: elm$core$Maybe$Nothing});
	});
var author$project$View$BuyN$qsRedirectN = F2(
	function (session, route) {
		if (route.$ === 4) {
			var tab = route.a;
			var unit = route.b;
			var ns = route.c;
			var _n1 = ns.dz;
			if (_n1.$ === 1) {
				return elm$core$Platform$Cmd$none;
			} else {
				var n = _n1.a;
				return A3(
					author$project$Route$pushUrl,
					author$project$Session$nav(session),
					author$project$Session$query(session),
					A2(author$project$Route$unit, tab, unit));
			}
		} else {
			return elm$core$Platform$Cmd$none;
		}
	});
var author$project$View$BuyN$update = F4(
	function (route, msg, game0, session) {
		switch (msg.$) {
			case 0:
				var item = msg.a;
				var str = msg.b;
				var game = A3(author$project$Game$setBuyN, item, str, game0);
				return _Utils_Tuple2(
					A3(author$project$Session$setGame, false, game, session),
					A2(author$project$View$BuyN$qsRedirectN, session, route));
			case 1:
				var order = msg.a;
				if (order.ds) {
					var _n1 = A3(author$project$View$BuyN$clickedBuy, session, order, game0);
					if (!_n1.$) {
						var _n2 = _n1.a;
						var game = _n2.a;
						var cmd = _n2.b;
						return _Utils_Tuple2(
							A3(author$project$Session$setGame, true, game, session),
							cmd);
					} else {
						var err = _n1.a;
						return _Utils_Tuple2(
							A2(author$project$Session$pushError, err, session),
							elm$core$Platform$Cmd$none);
					}
				} else {
					return _Utils_Tuple2(session, elm$core$Platform$Cmd$none);
				}
			case 2:
				var order = msg.a;
				var pushUrl = A3(
					author$project$Route$pushUrl,
					author$project$Session$nav(session),
					author$project$Session$query(session),
					author$project$Route$Home);
				var _n3 = A3(author$project$View$BuyN$clickedBuy, session, order, game0);
				if (!_n3.$) {
					var _n4 = _n3.a;
					var game = _n4.a;
					var cmd = _n4.b;
					return _Utils_Tuple2(
						A3(author$project$Session$setGame, true, game, session),
						elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[cmd, pushUrl])));
				} else {
					var err = _n3.a;
					return _Utils_Tuple2(
						A2(author$project$Session$pushError, err, session),
						elm$core$Platform$Cmd$none);
				}
			case 3:
				var game = A2(author$project$Game$setCostUI, 0, game0);
				return _Utils_Tuple2(
					A3(author$project$Session$setGame, false, game, session),
					elm$core$Platform$Cmd$none);
			default:
				var game = A2(author$project$Game$setCostUI, 1, game0);
				return _Utils_Tuple2(
					A3(author$project$Session$setGame, false, game, session),
					elm$core$Platform$Cmd$none);
		}
	});
var author$project$Page$Spell$update = F2(
	function (msg, model) {
		var tabName = model.a;
		var spellName = model.b;
		var session = model.c;
		switch (msg.$) {
			case 0:
				var s = msg.a;
				return _Utils_Tuple2(
					A3(author$project$Page$Spell$Model, tabName, spellName, s),
					elm$core$Platform$Cmd$none);
			case 1:
				var route = msg.a;
				return _Utils_Tuple2(
					A3(author$project$Page$Spell$Model, tabName, spellName, session),
					A3(
						author$project$Route$pushUrl,
						author$project$Session$nav(session),
						author$project$Session$query(session),
						route));
			case 2:
				var submsg = msg.a;
				var _n1 = author$project$Session$game(session);
				if (_n1.$ === 3) {
					var game = _n1.a;
					return A3(
						elm$core$Tuple$mapBoth,
						A2(author$project$Page$Spell$Model, tabName, spellName),
						elm$core$Platform$Cmd$map(author$project$Page$Spell$GotBuyNMsg),
						A4(
							author$project$View$BuyN$update,
							A2(author$project$Route$Spell, tabName, spellName),
							submsg,
							game,
							session));
				} else {
					return _Utils_Tuple2(model, elm$core$Platform$Cmd$none);
				}
			case 3:
				var submsg = msg.a;
				return A2(
					elm$core$Tuple$mapFirst,
					A2(author$project$Page$Spell$Model, tabName, spellName),
					A2(author$project$View$TabNav$update, submsg, session));
			default:
				var _n2 = author$project$Session$game(session);
				if (_n2.$ === 3) {
					var game = _n2.a;
					var snapshot = A2(author$project$Session$safeUnits, game, session);
					var _n3 = A3(author$project$Select$spellBySlug, spellName, game, snapshot);
					if (!_n3.$) {
						var spell = _n3.a;
						var _n4 = A3(
							author$project$Game$Order$fromBuyN,
							game,
							snapshot,
							author$project$GameData$Item$Spell(spell));
						if (!_n4.$) {
							var order = _n4.a;
							return A3(
								elm$core$Tuple$mapBoth,
								A2(author$project$Page$Spell$Model, tabName, spellName),
								elm$core$Platform$Cmd$map(author$project$Page$Spell$GotBuyNMsg),
								A4(
									author$project$View$BuyN$update,
									A2(author$project$Route$Spell, tabName, spellName),
									author$project$View$BuyN$ClickedBuy(order),
									game,
									session));
						} else {
							return _Utils_Tuple2(model, elm$core$Platform$Cmd$none);
						}
					} else {
						return _Utils_Tuple2(model, elm$core$Platform$Cmd$none);
					}
				} else {
					return _Utils_Tuple2(model, elm$core$Platform$Cmd$none);
				}
		}
	});
var author$project$Page$Tab$GotSession = function (a) {
	return {$: 1, a: a};
};
var author$project$Page$Tab$update = F2(
	function (msg, model) {
		var tabSlug = model.a;
		var session = model.b;
		switch (msg.$) {
			case 0:
				var submsg = msg.a;
				return A2(
					elm$core$Tuple$mapFirst,
					author$project$Page$Tab$Model(tabSlug),
					A2(author$project$View$TabNav$update, submsg, session));
			case 1:
				var s = msg.a;
				return _Utils_Tuple2(
					A2(author$project$Page$Tab$Model, tabSlug, s),
					elm$core$Platform$Cmd$none);
			default:
				var route = msg.a;
				return _Utils_Tuple2(
					model,
					A3(
						author$project$Route$pushUrl,
						author$project$Session$nav(session),
						author$project$Session$query(session),
						route));
		}
	});
var author$project$Page$Translator$GotSession = function (a) {
	return {$: 0, a: a};
};
var author$project$Ports$translatorWrite = _Platform_outgoingPort('translatorWrite', elm$core$Basics$identity);
var author$project$Session$setTranslator = F2(
	function (t, _n0) {
		var s = _n0;
		return _Utils_update(
			s,
			{cJ: t});
	});
var author$project$Page$Translator$update = F2(
	function (msg, model) {
		var session = model.a;
		var status = model.b;
		var txt = model.c;
		switch (msg.$) {
			case 0:
				var s = msg.a;
				return _Utils_Tuple2(
					A3(author$project$Page$Translator$Model, s, status, txt),
					elm$core$Platform$Cmd$none);
			case 1:
				var submsg = msg.a;
				return A2(
					elm$core$Tuple$mapFirst,
					function (s) {
						return A3(author$project$Page$Translator$Model, s, status, txt);
					},
					A2(author$project$View$TabNav$update, submsg, session));
			default:
				var txt1 = msg.a;
				var _n1 = A2(elm$json$Json$Decode$decodeString, author$project$GameData$Lang$translatorDecoder, txt1);
				if (!_n1.$) {
					var t = _n1.a;
					var entry = t.a;
					var json = t.b;
					return _Utils_Tuple2(
						A3(
							author$project$Page$Translator$Model,
							A2(
								author$project$Session$setTranslator,
								elm$core$Maybe$Just(t),
								session),
							krisajenkins$remotedata$RemoteData$Success(0),
							txt1),
						author$project$Ports$translatorWrite(json));
				} else {
					var err = _n1.a;
					return _Utils_Tuple2(
						A3(
							author$project$Page$Translator$Model,
							session,
							krisajenkins$remotedata$RemoteData$Failure(
								elm$json$Json$Decode$errorToString(err)),
							txt1),
						elm$core$Platform$Cmd$none);
				}
		}
	});
var author$project$Page$Unit$GotSession = function (a) {
	return {$: 0, a: a};
};
var author$project$Page$Unit$GotBuyNMsg = function (a) {
	return {$: 2, a: a};
};
var author$project$Page$Unit$GotWatcherMsg = function (a) {
	return {$: 4, a: a};
};
var author$project$Game$setVelocityUI = F2(
	function (v, _n0) {
		var g = _n0;
		return _Utils_update(
			g,
			{aK: v});
	});
var author$project$Page$Unit$setVelocityUI = F2(
	function (v, model) {
		var tabName = model.a;
		var unitName = model.b;
		var ns = model.c;
		var session0 = model.d;
		var _n0 = author$project$Session$game(session0);
		if (_n0.$ === 3) {
			var game0 = _n0.a;
			var game = A2(author$project$Game$setVelocityUI, v, game0);
			var session = A3(author$project$Session$setGame, false, game, session0);
			return A4(author$project$Page$Unit$Model, tabName, unitName, ns, session);
		} else {
			return model;
		}
	});
var author$project$GameData$unitBySlug = function (name) {
	return A2(
		elm$core$Basics$composeR,
		author$project$GameData$indexes,
		A2(
			elm$core$Basics$composeR,
			function ($) {
				return $.cM;
			},
			elm$core$Dict$get(
				elm$core$String$toLower(name))));
};
var author$project$Select$isUnitVisible = F2(
	function (snapshot, u) {
		return A2(author$project$Game$UnitsSnapshot$isUnitVisible, u.eL, snapshot);
	});
var author$project$Select$unitBySlug = F3(
	function (unitSlug, game, snapshot) {
		return A2(
			elm$core$Maybe$map,
			function (u) {
				return _Utils_Tuple2(
					u,
					A2(author$project$Game$UnitsSnapshot$count, u.eL, snapshot));
			},
			A2(
				elm_community$maybe_extra$Maybe$Extra$filter,
				author$project$Select$isUnitVisible(snapshot),
				A2(
					author$project$GameData$unitBySlug,
					unitSlug,
					author$project$Game$gameData(game))));
	});
var author$project$Game$insertWatched = F3(
	function (item, val, game0) {
		var g = game0;
		return author$project$GameData$Item$isWatchable(item) ? _Utils_update(
			g,
			{
				an: A3(
					elm$core$Dict$insert,
					author$project$GameData$Item$name(item),
					val,
					g.an)
			}) : game0;
	});
var author$project$View$Watcher$update = F3(
	function (session, msg, game) {
		var item = msg.a;
		var watched = msg.b;
		return A2(
			author$project$Session$persistWrite,
			session,
			A3(author$project$Game$insertWatched, item, watched, game));
	});
var author$project$Page$Unit$update = F2(
	function (msg, model) {
		var tabName = model.a;
		var unitName = model.b;
		var ns = model.c;
		var session = model.d;
		switch (msg.$) {
			case 0:
				var s = msg.a;
				return _Utils_Tuple2(
					A4(author$project$Page$Unit$Model, tabName, unitName, ns, s),
					elm$core$Platform$Cmd$none);
			case 1:
				var route = msg.a;
				return _Utils_Tuple2(
					A4(author$project$Page$Unit$Model, tabName, unitName, ns, session),
					A3(
						author$project$Route$pushUrl,
						author$project$Session$nav(session),
						author$project$Session$query(session),
						route));
			case 2:
				var submsg = msg.a;
				var _n1 = author$project$Session$game(session);
				if (_n1.$ === 3) {
					var game = _n1.a;
					return A3(
						elm$core$Tuple$mapBoth,
						A3(author$project$Page$Unit$Model, tabName, unitName, ns),
						elm$core$Platform$Cmd$map(author$project$Page$Unit$GotBuyNMsg),
						A4(
							author$project$View$BuyN$update,
							A3(author$project$Route$Unit, tabName, unitName, ns),
							submsg,
							game,
							session));
				} else {
					return _Utils_Tuple2(model, elm$core$Platform$Cmd$none);
				}
			case 3:
				var submsg = msg.a;
				return A2(
					elm$core$Tuple$mapFirst,
					A3(author$project$Page$Unit$Model, tabName, unitName, ns),
					A2(author$project$View$TabNav$update, submsg, session));
			case 4:
				var submsg = msg.a;
				var _n2 = author$project$Session$game(session);
				if (_n2.$ === 3) {
					var game = _n2.a;
					return A3(
						elm$core$Tuple$mapBoth,
						function (g) {
							return A4(
								author$project$Page$Unit$Model,
								tabName,
								unitName,
								ns,
								A3(author$project$Session$setGame, false, g, session));
						},
						elm$core$Platform$Cmd$map(author$project$Page$Unit$GotWatcherMsg),
						A3(author$project$View$Watcher$update, session, submsg, game));
				} else {
					return _Utils_Tuple2(model, elm$core$Platform$Cmd$none);
				}
			case 5:
				var _n3 = author$project$Session$game(session);
				if (_n3.$ === 3) {
					var game = _n3.a;
					var snapshot = A2(author$project$Session$safeUnits, game, session);
					var _n4 = A3(author$project$Select$unitBySlug, unitName, game, snapshot);
					if (!_n4.$) {
						var _n5 = _n4.a;
						var unit = _n5.a;
						var _n6 = A3(
							author$project$Game$Order$fromBuyN,
							game,
							snapshot,
							author$project$GameData$Item$Unit(unit));
						if (!_n6.$) {
							var order = _n6.a;
							return A3(
								elm$core$Tuple$mapBoth,
								A3(author$project$Page$Unit$Model, tabName, unitName, ns),
								elm$core$Platform$Cmd$map(author$project$Page$Unit$GotBuyNMsg),
								A4(
									author$project$View$BuyN$update,
									A3(author$project$Route$Unit, tabName, unitName, ns),
									author$project$View$BuyN$ClickedBuy(order),
									game,
									session));
						} else {
							return _Utils_Tuple2(model, elm$core$Platform$Cmd$none);
						}
					} else {
						return _Utils_Tuple2(model, elm$core$Platform$Cmd$none);
					}
				} else {
					return _Utils_Tuple2(model, elm$core$Platform$Cmd$none);
				}
			case 6:
				return _Utils_Tuple2(
					A2(author$project$Page$Unit$setVelocityUI, 1, model),
					elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(
					A2(author$project$Page$Unit$setVelocityUI, 0, model),
					elm$core$Platform$Cmd$none);
		}
	});
var author$project$Main$updateSession = F2(
	function (session, model) {
		switch (model.$) {
			case 0:
				return _Utils_Tuple2(
					author$project$Main$NotFound(session),
					elm$core$Platform$Cmd$none);
			case 1:
				var m = model.a;
				return A3(
					elm$core$Tuple$mapBoth,
					author$project$Main$Debug,
					elm$core$Platform$Cmd$map(author$project$Main$GotDebugMsg),
					A2(
						author$project$Page$Debug$update,
						author$project$Page$Debug$GotSession(session),
						m));
			case 3:
				var m = model.a;
				return A3(
					elm$core$Tuple$mapBoth,
					author$project$Main$Tab,
					elm$core$Platform$Cmd$map(author$project$Main$GotTabMsg),
					A2(
						author$project$Page$Tab$update,
						author$project$Page$Tab$GotSession(session),
						m));
			case 4:
				var m = model.a;
				return A3(
					elm$core$Tuple$mapBoth,
					author$project$Main$Unit,
					elm$core$Platform$Cmd$map(author$project$Main$GotUnitMsg),
					A2(
						author$project$Page$Unit$update,
						author$project$Page$Unit$GotSession(session),
						m));
			case 5:
				var m = model.a;
				return A3(
					elm$core$Tuple$mapBoth,
					author$project$Main$Spell,
					elm$core$Platform$Cmd$map(author$project$Main$GotSpellMsg),
					A2(
						author$project$Page$Spell$update,
						author$project$Page$Spell$GotSession(session),
						m));
			case 2:
				var m = model.a;
				return A3(
					elm$core$Tuple$mapBoth,
					author$project$Main$MtxShop,
					elm$core$Platform$Cmd$map(author$project$Main$GotMtxShopMsg),
					A2(
						author$project$Page$MtxShop$update,
						author$project$Page$MtxShop$GotSession(session),
						m));
			case 6:
				return _Utils_Tuple2(
					author$project$Main$Achievements(session),
					elm$core$Platform$Cmd$none);
			case 7:
				var m = model.a;
				return A3(
					elm$core$Tuple$mapBoth,
					author$project$Main$Options,
					elm$core$Platform$Cmd$map(author$project$Main$GotOptionsMsg),
					A2(
						author$project$Page$Options$update,
						author$project$Page$Options$GotSession(session),
						m));
			case 8:
				return _Utils_Tuple2(
					author$project$Main$Statistics(session),
					elm$core$Platform$Cmd$none);
			case 9:
				return _Utils_Tuple2(
					author$project$Main$Changelog(session),
					elm$core$Platform$Cmd$none);
			case 10:
				return _Utils_Tuple2(
					author$project$Main$User(session),
					elm$core$Platform$Cmd$none);
			case 11:
				var m = model.a;
				return A3(
					elm$core$Tuple$mapBoth,
					author$project$Main$MtxHistory,
					elm$core$Platform$Cmd$map(author$project$Main$GotMtxHistoryMsg),
					A2(
						author$project$Page$MtxHistory$update,
						author$project$Page$MtxHistory$GotSession(session),
						m));
			case 12:
				var m = model.a;
				return A3(
					elm$core$Tuple$mapBoth,
					author$project$Main$Login,
					elm$core$Platform$Cmd$map(author$project$Main$GotLoginMsg),
					A2(
						author$project$Page$Login$update,
						author$project$Page$Login$GotSession(session),
						m));
			case 13:
				var m = model.a;
				return A3(
					elm$core$Tuple$mapBoth,
					author$project$Main$Register,
					elm$core$Platform$Cmd$map(author$project$Main$GotRegisterMsg),
					A2(
						author$project$Page$Register$update,
						author$project$Page$Register$GotSession(session),
						m));
			case 14:
				var m = model.a;
				return A3(
					elm$core$Tuple$mapBoth,
					author$project$Main$ResetPassword,
					elm$core$Platform$Cmd$map(author$project$Main$GotResetPasswordMsg),
					A2(
						author$project$Page$ResetPassword$update,
						author$project$Page$ResetPassword$GotSession(session),
						m));
			case 15:
				var s = model.a;
				return A3(
					elm$core$Tuple$mapBoth,
					author$project$Main$PaypalDone,
					elm$core$Platform$Cmd$map(author$project$Main$GotPaypalDoneMsg),
					A2(author$project$Page$PaypalDone$update, session, s));
			case 16:
				return _Utils_Tuple2(
					author$project$Main$MoreMenu(session),
					elm$core$Platform$Cmd$none);
			default:
				var m = model.a;
				return A3(
					elm$core$Tuple$mapBoth,
					author$project$Main$Translator,
					elm$core$Platform$Cmd$map(author$project$Main$GotTranslatorMsg),
					A2(
						author$project$Page$Translator$update,
						author$project$Page$Translator$GotSession(session),
						m));
		}
	});
var author$project$Main$mapSessionCmd = F3(
	function (mapMsg, fn, model0) {
		var _n0 = fn(
			author$project$Main$toSession(model0));
		var session1 = _n0.a;
		var cmd1 = _n0.b;
		var _n1 = A2(author$project$Main$updateSession, session1, model0);
		var model2 = _n1.a;
		var cmd2 = _n1.b;
		return _Utils_Tuple2(
			model2,
			elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(elm$core$Platform$Cmd$map, mapMsg, cmd1),
						cmd2
					])));
	});
var author$project$Route$Achievements = {$: 6};
var author$project$Route$Changelog = {$: 9};
var author$project$Route$Debug = {$: 1};
var author$project$Route$Login = {$: 12};
var author$project$Route$MoreMenu = {$: 16};
var author$project$Route$MtxHistory = {$: 11};
var author$project$Route$Options = {$: 7};
var author$project$Route$PaypalDone = F2(
	function (a, b) {
		return {$: 15, a: a, b: b};
	});
var author$project$Route$Register = {$: 13};
var author$project$Route$ResetPassword = {$: 14};
var author$project$Route$Statistics = {$: 8};
var author$project$Route$Translator = {$: 17};
var author$project$Route$User = {$: 10};
var elm$url$Url$percentDecode = _Url_percentDecode;
var elm$url$Url$Parser$Parser = elm$core$Basics$identity;
var elm$url$Url$Parser$State = F5(
	function (visited, unvisited, params, frag, value) {
		return {ac: frag, aj: params, X: unvisited, M: value, am: visited};
	});
var elm$url$Url$Parser$mapState = F2(
	function (func, _n0) {
		var visited = _n0.am;
		var unvisited = _n0.X;
		var params = _n0.aj;
		var frag = _n0.ac;
		var value = _n0.M;
		return A5(
			elm$url$Url$Parser$State,
			visited,
			unvisited,
			params,
			frag,
			func(value));
	});
var elm$url$Url$Parser$map = F2(
	function (subValue, _n0) {
		var parseArg = _n0;
		return function (_n1) {
			var visited = _n1.am;
			var unvisited = _n1.X;
			var params = _n1.aj;
			var frag = _n1.ac;
			var value = _n1.M;
			return A2(
				elm$core$List$map,
				elm$url$Url$Parser$mapState(value),
				parseArg(
					A5(elm$url$Url$Parser$State, visited, unvisited, params, frag, subValue)));
		};
	});
var elm$url$Url$Parser$custom = F2(
	function (tipe, stringToSomething) {
		return function (_n0) {
			var visited = _n0.am;
			var unvisited = _n0.X;
			var params = _n0.aj;
			var frag = _n0.ac;
			var value = _n0.M;
			if (!unvisited.b) {
				return _List_Nil;
			} else {
				var next = unvisited.a;
				var rest = unvisited.b;
				var _n2 = stringToSomething(next);
				if (!_n2.$) {
					var nextValue = _n2.a;
					return _List_fromArray(
						[
							A5(
							elm$url$Url$Parser$State,
							A2(elm$core$List$cons, next, visited),
							rest,
							params,
							frag,
							value(nextValue))
						]);
				} else {
					return _List_Nil;
				}
			}
		};
	});
var elm$url$Url$Parser$string = A2(elm$url$Url$Parser$custom, 'STRING', elm$core$Maybe$Just);
var author$project$Route$escString = A2(
	elm$url$Url$Parser$map,
	A2(
		elm$core$Basics$composeR,
		elm$core$String$toLower,
		function (s) {
			return A2(
				elm$core$Maybe$withDefault,
				s,
				elm$url$Url$percentDecode(s));
		}),
	elm$url$Url$Parser$string);
var author$project$Route$PaypalReturnArgs = function (tx) {
	return {bG: tx};
};
var elm$url$Url$Parser$Internal$Parser = elm$core$Basics$identity;
var elm$url$Url$Parser$Query$map = F2(
	function (func, _n0) {
		var a = _n0;
		return function (dict) {
			return func(
				a(dict));
		};
	});
var elm$url$Url$Parser$Query$custom = F2(
	function (key, func) {
		return function (dict) {
			return func(
				A2(
					elm$core$Maybe$withDefault,
					_List_Nil,
					A2(elm$core$Dict$get, key, dict)));
		};
	});
var elm$url$Url$Parser$Query$string = function (key) {
	return A2(
		elm$url$Url$Parser$Query$custom,
		key,
		function (stringList) {
			if (stringList.b && (!stringList.b.b)) {
				var str = stringList.a;
				return elm$core$Maybe$Just(str);
			} else {
				return elm$core$Maybe$Nothing;
			}
		});
};
var author$project$Route$paypalReturnArgsParser = A2(
	elm$url$Url$Parser$Query$map,
	elm$core$Maybe$map(author$project$Route$PaypalReturnArgs),
	elm$url$Url$Parser$Query$string('tx'));
var elm$url$Url$Parser$oneOf = function (parsers) {
	return function (state) {
		return A2(
			elm$core$List$concatMap,
			function (_n0) {
				var parser = _n0;
				return parser(state);
			},
			parsers);
	};
};
var elm$url$Url$Parser$query = function (_n0) {
	var queryParser = _n0;
	return function (_n1) {
		var visited = _n1.am;
		var unvisited = _n1.X;
		var params = _n1.aj;
		var frag = _n1.ac;
		var value = _n1.M;
		return _List_fromArray(
			[
				A5(
				elm$url$Url$Parser$State,
				visited,
				unvisited,
				params,
				frag,
				value(
					queryParser(params)))
			]);
	};
};
var elm$url$Url$Parser$slash = F2(
	function (_n0, _n1) {
		var parseBefore = _n0;
		var parseAfter = _n1;
		return function (state) {
			return A2(
				elm$core$List$concatMap,
				parseAfter,
				parseBefore(state));
		};
	});
var elm$url$Url$Parser$questionMark = F2(
	function (parser, queryParser) {
		return A2(
			elm$url$Url$Parser$slash,
			parser,
			elm$url$Url$Parser$query(queryParser));
	});
var elm$url$Url$Parser$s = function (str) {
	return function (_n0) {
		var visited = _n0.am;
		var unvisited = _n0.X;
		var params = _n0.aj;
		var frag = _n0.ac;
		var value = _n0.M;
		if (!unvisited.b) {
			return _List_Nil;
		} else {
			var next = unvisited.a;
			var rest = unvisited.b;
			return _Utils_eq(next, str) ? _List_fromArray(
				[
					A5(
					elm$url$Url$Parser$State,
					A2(elm$core$List$cons, next, visited),
					rest,
					params,
					frag,
					value)
				]) : _List_Nil;
		}
	};
};
var elm$url$Url$Parser$top = function (state) {
	return _List_fromArray(
		[state]);
};
var author$project$Route$parser = elm$url$Url$Parser$oneOf(
	_List_fromArray(
		[
			A2(elm$url$Url$Parser$map, author$project$Route$Home, elm$url$Url$Parser$top),
			A2(
			elm$url$Url$Parser$map,
			author$project$Route$Debug,
			elm$url$Url$Parser$s('debug')),
			A2(
			elm$url$Url$Parser$map,
			author$project$Route$Tab,
			A2(
				elm$url$Url$Parser$slash,
				elm$url$Url$Parser$s('tab'),
				author$project$Route$escString)),
			A2(
			elm$url$Url$Parser$map,
			author$project$Route$MtxShop,
			A2(
				elm$url$Url$Parser$slash,
				elm$url$Url$Parser$s('tab'),
				A2(
					elm$url$Url$Parser$slash,
					author$project$Route$escString,
					A2(
						elm$url$Url$Parser$slash,
						elm$url$Url$Parser$s('unit'),
						A2(
							elm$url$Url$Parser$questionMark,
							elm$url$Url$Parser$s('crystal'),
							author$project$Route$paypalReturnArgsParser))))),
			A2(
			elm$url$Url$Parser$map,
			author$project$Route$Unit,
			A2(
				elm$url$Url$Parser$slash,
				elm$url$Url$Parser$s('tab'),
				A2(
					elm$url$Url$Parser$slash,
					author$project$Route$escString,
					A2(
						elm$url$Url$Parser$slash,
						elm$url$Url$Parser$s('unit'),
						A2(
							elm$url$Url$Parser$questionMark,
							author$project$Route$escString,
							A2(
								elm$url$Url$Parser$Query$map,
								function (n) {
									return {dz: n};
								},
								elm$url$Url$Parser$Query$string('n'))))))),
			A2(
			elm$url$Url$Parser$map,
			author$project$Route$Spell,
			A2(
				elm$url$Url$Parser$slash,
				elm$url$Url$Parser$s('tab'),
				A2(
					elm$url$Url$Parser$slash,
					author$project$Route$escString,
					A2(
						elm$url$Url$Parser$slash,
						elm$url$Url$Parser$s('spell'),
						author$project$Route$escString)))),
			A2(
			elm$url$Url$Parser$map,
			author$project$Route$Achievements,
			elm$url$Url$Parser$s('achievements')),
			A2(
			elm$url$Url$Parser$map,
			author$project$Route$Options,
			elm$url$Url$Parser$s('options')),
			A2(
			elm$url$Url$Parser$map,
			author$project$Route$Statistics,
			elm$url$Url$Parser$s('statistics')),
			A2(
			elm$url$Url$Parser$map,
			author$project$Route$Changelog,
			elm$url$Url$Parser$s('changelog')),
			A2(
			elm$url$Url$Parser$map,
			author$project$Route$User,
			A2(
				elm$url$Url$Parser$slash,
				elm$url$Url$Parser$s('auth'),
				elm$url$Url$Parser$s('user'))),
			A2(
			elm$url$Url$Parser$map,
			author$project$Route$MtxHistory,
			A2(
				elm$url$Url$Parser$slash,
				elm$url$Url$Parser$s('auth'),
				A2(
					elm$url$Url$Parser$slash,
					elm$url$Url$Parser$s('user'),
					elm$url$Url$Parser$s('orders')))),
			A2(
			elm$url$Url$Parser$map,
			author$project$Route$Login,
			A2(
				elm$url$Url$Parser$slash,
				elm$url$Url$Parser$s('auth'),
				elm$url$Url$Parser$s('login'))),
			A2(
			elm$url$Url$Parser$map,
			author$project$Route$Register,
			A2(
				elm$url$Url$Parser$slash,
				elm$url$Url$Parser$s('auth'),
				elm$url$Url$Parser$s('register'))),
			A2(
			elm$url$Url$Parser$map,
			author$project$Route$ResetPassword,
			A2(
				elm$url$Url$Parser$slash,
				elm$url$Url$Parser$s('auth'),
				elm$url$Url$Parser$s('password'))),
			A2(
			elm$url$Url$Parser$map,
			author$project$Route$PaypalDone,
			A2(
				elm$url$Url$Parser$slash,
				elm$url$Url$Parser$s('paypal'),
				A2(elm$url$Url$Parser$questionMark, author$project$Route$escString, author$project$Route$paypalReturnArgsParser))),
			A2(
			elm$url$Url$Parser$map,
			author$project$Route$MoreMenu,
			elm$url$Url$Parser$s('moremenu')),
			A2(
			elm$url$Url$Parser$map,
			author$project$Route$Translator,
			elm$url$Url$Parser$s('translator'))
		]));
var elm$url$Url$Parser$getFirstMatch = function (states) {
	getFirstMatch:
	while (true) {
		if (!states.b) {
			return elm$core$Maybe$Nothing;
		} else {
			var state = states.a;
			var rest = states.b;
			var _n1 = state.X;
			if (!_n1.b) {
				return elm$core$Maybe$Just(state.M);
			} else {
				if ((_n1.a === '') && (!_n1.b.b)) {
					return elm$core$Maybe$Just(state.M);
				} else {
					var $temp$states = rest;
					states = $temp$states;
					continue getFirstMatch;
				}
			}
		}
	}
};
var elm$url$Url$Parser$removeFinalEmpty = function (segments) {
	if (!segments.b) {
		return _List_Nil;
	} else {
		if ((segments.a === '') && (!segments.b.b)) {
			return _List_Nil;
		} else {
			var segment = segments.a;
			var rest = segments.b;
			return A2(
				elm$core$List$cons,
				segment,
				elm$url$Url$Parser$removeFinalEmpty(rest));
		}
	}
};
var elm$url$Url$Parser$preparePath = function (path) {
	var _n0 = A2(elm$core$String$split, '/', path);
	if (_n0.b && (_n0.a === '')) {
		var segments = _n0.b;
		return elm$url$Url$Parser$removeFinalEmpty(segments);
	} else {
		var segments = _n0;
		return elm$url$Url$Parser$removeFinalEmpty(segments);
	}
};
var elm$url$Url$Parser$addToParametersHelp = F2(
	function (value, maybeList) {
		if (maybeList.$ === 1) {
			return elm$core$Maybe$Just(
				_List_fromArray(
					[value]));
		} else {
			var list = maybeList.a;
			return elm$core$Maybe$Just(
				A2(elm$core$List$cons, value, list));
		}
	});
var elm$url$Url$Parser$addParam = F2(
	function (segment, dict) {
		var _n0 = A2(elm$core$String$split, '=', segment);
		if ((_n0.b && _n0.b.b) && (!_n0.b.b.b)) {
			var rawKey = _n0.a;
			var _n1 = _n0.b;
			var rawValue = _n1.a;
			var _n2 = elm$url$Url$percentDecode(rawKey);
			if (_n2.$ === 1) {
				return dict;
			} else {
				var key = _n2.a;
				var _n3 = elm$url$Url$percentDecode(rawValue);
				if (_n3.$ === 1) {
					return dict;
				} else {
					var value = _n3.a;
					return A3(
						elm$core$Dict$update,
						key,
						elm$url$Url$Parser$addToParametersHelp(value),
						dict);
				}
			}
		} else {
			return dict;
		}
	});
var elm$url$Url$Parser$prepareQuery = function (maybeQuery) {
	if (maybeQuery.$ === 1) {
		return elm$core$Dict$empty;
	} else {
		var qry = maybeQuery.a;
		return A3(
			elm$core$List$foldr,
			elm$url$Url$Parser$addParam,
			elm$core$Dict$empty,
			A2(elm$core$String$split, '&', qry));
	}
};
var elm$url$Url$Parser$parse = F2(
	function (_n0, url) {
		var parser = _n0;
		return elm$url$Url$Parser$getFirstMatch(
			parser(
				A5(
					elm$url$Url$Parser$State,
					_List_Nil,
					elm$url$Url$Parser$preparePath(url.aA),
					elm$url$Url$Parser$prepareQuery(url.fn),
					url.di,
					elm$core$Basics$identity)));
	});
var author$project$Route$fromUrl = elm$url$Url$Parser$parse(author$project$Route$parser);
var author$project$Route$QueryDict$applyPath = function (path) {
	switch (path) {
		case '/debug':
			return A2(elm$core$Dict$insert, 'debug', '1');
		case '/translator':
			return A2(elm$core$Dict$insert, 'translator', '1');
		default:
			return elm$core$Basics$identity;
	}
};
var elm_community$maybe_extra$Maybe$Extra$traverse = function (f) {
	var step = F2(
		function (e, acc) {
			var _n0 = f(e);
			if (_n0.$ === 1) {
				return elm$core$Maybe$Nothing;
			} else {
				var x = _n0.a;
				return A2(
					elm$core$Maybe$map,
					elm$core$List$cons(x),
					acc);
			}
		});
	return A2(
		elm$core$List$foldr,
		step,
		elm$core$Maybe$Just(_List_Nil));
};
var elm_community$maybe_extra$Maybe$Extra$combine = elm_community$maybe_extra$Maybe$Extra$traverse(elm$core$Basics$identity);
var author$project$Route$QueryDict$fromString = function () {
	var parseEntry = function (entry) {
		var _n0 = elm_community$maybe_extra$Maybe$Extra$combine(
			A2(
				elm$core$List$map,
				elm$url$Url$percentDecode,
				A2(elm$core$String$split, '=', entry)));
		if ((((!_n0.$) && _n0.a.b) && _n0.a.b.b) && (!_n0.a.b.b.b)) {
			var _n1 = _n0.a;
			var k = _n1.a;
			var _n2 = _n1.b;
			var v = _n2.a;
			return elm$core$Maybe$Just(
				_Utils_Tuple2(k, v));
		} else {
			return elm$core$Maybe$Nothing;
		}
	};
	return A2(
		elm$core$Basics$composeR,
		elm$core$String$split('&'),
		A2(
			elm$core$Basics$composeR,
			elm$core$List$filterMap(parseEntry),
			elm$core$Dict$fromList));
}();
var author$project$Route$QueryDict$fromUrl = function (_n0) {
	var path = _n0.aA;
	var query = _n0.fn;
	return A2(
		author$project$Route$QueryDict$applyPath,
		path,
		A3(elm_community$maybe_extra$Maybe$Extra$unwrap, elm$core$Dict$empty, author$project$Route$QueryDict$fromString, query));
};
var author$project$Session$mapIframeCmd = F2(
	function (map, _n0) {
		var s = _n0;
		var _n1 = map(s.ag);
		var iframe_ = _n1.a;
		var cmd = _n1.b;
		return _Utils_Tuple2(
			_Utils_update(
				s,
				{ag: iframe_}),
			cmd);
	});
var elm$time$Time$Name = function (a) {
	return {$: 0, a: a};
};
var elm$time$Time$Offset = function (a) {
	return {$: 1, a: a};
};
var elm$time$Time$Zone = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var elm$time$Time$customZone = elm$time$Time$Zone;
var elm$time$Time$here = _Time_here(0);
var elm$time$Time$now = _Time_now(elm$time$Time$millisToPosix);
var author$project$Main$init = F3(
	function (flags, url, nav) {
		var translator = elm$core$Result$toMaybe(
			A2(elm$json$Json$Decode$decodeValue, author$project$GameData$Lang$translatorDecoder, flags.cJ));
		var langData = A2(elm$json$Json$Decode$decodeValue, author$project$GameData$Lang$decoder, flags.b6);
		var gameData = A2(
			elm$core$Result$mapError,
			elm$json$Json$Decode$errorToString,
			A3(
				elm$core$Result$map2,
				F2(
					function (ld, gd) {
						return gd(ld);
					}),
				langData,
				A2(elm$json$Json$Decode$decodeValue, author$project$GameData$decoder, flags.D)));
		var session0 = A4(author$project$Session$create, flags, nav, gameData, translator);
		var _n0 = A3(
			author$project$Main$changeRouteTo,
			author$project$Route$fromUrl(url),
			author$project$Route$QueryDict$fromUrl(url),
			author$project$Main$NotFound(session0));
		var model0 = _n0.a;
		var cmd0 = _n0.b;
		var _n1 = A3(
			author$project$Main$mapSessionCmd,
			elm$core$Basics$identity,
			function (s) {
				return A2(
					author$project$Session$mapIframeCmd,
					elm$core$Basics$always(
						author$project$Main$initIframe(s)),
					s);
			},
			model0);
		var model1 = _n1.a;
		var cmd1 = _n1.b;
		return _Utils_Tuple2(
			model1,
			elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						cmd0,
						cmd1,
						A2(
						elm$core$Task$perform,
						elm$core$Basics$identity,
						A3(elm$core$Task$map2, author$project$Main$GotInitialTime, elm$time$Time$here, elm$time$Time$now))
					])));
	});
var author$project$KeyCombo$Input = F2(
	function (key, isTextField) {
		return {dt: isTextField, E: key};
	});
var author$project$KeyCombo$isTextField = function (tagName) {
	var _n0 = elm$core$String$toLower(tagName);
	switch (_n0) {
		case 'input':
			return true;
		case 'textarea':
			return true;
		default:
			return false;
	}
};
var author$project$KeyCombo$isTextDecoder = A2(
	elm$json$Json$Decode$map,
	author$project$KeyCombo$isTextField,
	A2(
		elm$json$Json$Decode$at,
		_List_fromArray(
			['target', 'tagName']),
		elm$json$Json$Decode$string));
var author$project$KeyCombo$KeyCombo = F5(
	function (key, ctrlKey, altKey, shiftKey, metaKey) {
		return {ba: altKey, be: ctrlKey, E: key, bo: metaKey, dX: shiftKey};
	});
var author$project$KeyCombo$keyComboDecoder = A6(
	elm$json$Json$Decode$map5,
	author$project$KeyCombo$KeyCombo,
	A2(elm$json$Json$Decode$field, 'key', elm$json$Json$Decode$string),
	A2(elm$json$Json$Decode$field, 'ctrlKey', elm$json$Json$Decode$bool),
	A2(elm$json$Json$Decode$field, 'altKey', elm$json$Json$Decode$bool),
	A2(elm$json$Json$Decode$field, 'shiftKey', elm$json$Json$Decode$bool),
	A2(elm$json$Json$Decode$field, 'metaKey', elm$json$Json$Decode$bool));
var author$project$KeyCombo$inputDecoder = A3(elm$json$Json$Decode$map2, author$project$KeyCombo$Input, author$project$KeyCombo$keyComboDecoder, author$project$KeyCombo$isTextDecoder);
var author$project$Main$GotServiceWorkerEvent = function (a) {
	return {$: 7, a: a};
};
var author$project$Main$GotTime = function (a) {
	return {$: 4, a: a};
};
var author$project$Main$GotUserGame = function (a) {
	return {$: 10, a: a};
};
var author$project$Main$GotUserSessionTicket = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var author$project$Main$OnApiRequest = function (a) {
	return {$: 17, a: a};
};
var author$project$Main$OnKonami = {$: 15};
var author$project$Main$OnKongregateLogin = function (a) {
	return {$: 14, a: a};
};
var author$project$Main$OnLongPageOpen = {$: 13};
var author$project$Main$OnTranslatorRead = function (a) {
	return {$: 16, a: a};
};
var author$project$Main$OnUnload = {$: 12};
var author$project$Main$PersistExported = function (a) {
	return {$: 6, a: a};
};
var author$project$Main$PersistRead = function (a) {
	return {$: 5, a: a};
};
var author$project$KeyCombo$isAcceptedFromTextField = function (c) {
	return c.ba || (c.be || c.bo);
};
var author$project$KeyCombo$modToString = F2(
	function (val, str) {
		return val ? elm$core$Maybe$Just(str) : elm$core$Maybe$Nothing;
	});
var author$project$KeyCombo$toString = function (c) {
	return A2(
		elm$core$String$join,
		'+',
		A2(
			elm$core$List$filterMap,
			elm$core$Basics$identity,
			_List_fromArray(
				[
					A2(author$project$KeyCombo$modToString, c.bo, 'meta'),
					A2(author$project$KeyCombo$modToString, c.be, 'ctrl'),
					A2(author$project$KeyCombo$modToString, c.ba, 'alt'),
					elm$core$Maybe$Just(c.E)
				])));
};
var author$project$KeyCombo$getBinding = F2(
	function (input, _n0) {
		var byKey = _n0.c$;
		return (input.dt && (!author$project$KeyCombo$isAcceptedFromTextField(input.E))) ? elm$core$Maybe$Nothing : A2(
			elm$core$Dict$get,
			author$project$KeyCombo$toString(input.E),
			byKey);
	});
var author$project$KeyCombo$getMsg = function (input) {
	return A2(
		elm$core$Basics$composeR,
		author$project$KeyCombo$getBinding(input),
		elm$core$Maybe$map(
			function ($) {
				return $.bq;
			}));
};
var author$project$KeyCombo$Bindings = elm$core$Basics$identity;
var author$project$KeyCombo$bindings_ = function (l) {
	return {
		c$: elm$core$Dict$fromList(
			A2(
				elm$core$List$map,
				function (b) {
					return _Utils_Tuple2(
						author$project$KeyCombo$toString(b.E),
						b);
				},
				l)),
		b7: l
	};
};
var author$project$KeyCombo$emptyBindings = author$project$KeyCombo$bindings_(_List_Nil);
var author$project$KeyCombo$mapBinding = F2(
	function (fn, b) {
		return {
			E: b.E,
			bq: fn(b.bq),
			br: b.br
		};
	});
var author$project$KeyCombo$mapBindings = F2(
	function (fn, _n0) {
		var bs = _n0;
		return author$project$KeyCombo$bindings_(
			A2(
				elm$core$List$map,
				author$project$KeyCombo$mapBinding(fn),
				bs.b7));
	});
var author$project$KeyCombo$list = function (_n0) {
	var b = _n0;
	return b.b7;
};
var author$project$KeyCombo$union = F2(
	function (a, b) {
		return author$project$KeyCombo$bindings_(
			_Utils_ap(
				author$project$KeyCombo$list(a),
				author$project$KeyCombo$list(b)));
	});
var author$project$KeyCombo$Binding = F3(
	function (name, msg, key) {
		return {E: key, bq: msg, br: name};
	});
var author$project$KeyCombo$applyModFromString = F2(
	function (mod, c) {
		var _n0 = elm$core$String$toLower(mod);
		switch (_n0) {
			case 'ctrl':
				return elm$core$Result$Ok(
					_Utils_update(
						c,
						{be: true}));
			case 'alt':
				return elm$core$Result$Ok(
					_Utils_update(
						c,
						{ba: true}));
			case 'shift':
				return elm$core$Result$Ok(
					_Utils_update(
						c,
						{dX: true}));
			case 'meta':
				return elm$core$Result$Ok(
					_Utils_update(
						c,
						{bo: true}));
			default:
				return elm$core$Result$Err('not a modifier key: ' + mod);
		}
	});
var elm$core$String$replace = F3(
	function (before, after, string) {
		return A2(
			elm$core$String$join,
			after,
			A2(elm$core$String$split, before, string));
	});
var author$project$KeyCombo$fromString = function (str) {
	var _n0 = elm$core$List$reverse(
		A2(
			elm$core$String$split,
			'+',
			A3(elm$core$String$replace, ' ', '', str)));
	if (!_n0.b) {
		return elm$core$Result$Err('empty KeyCombo: ' + str);
	} else {
		var key = _n0.a;
		var mods = _n0.b;
		return A3(
			elm$core$List$foldl,
			function (c) {
				return elm$core$Result$andThen(
					author$project$KeyCombo$applyModFromString(c));
			},
			elm$core$Result$Ok(
				A5(author$project$KeyCombo$KeyCombo, key, false, false, false, false)),
			mods);
	}
};
var author$project$KeyCombo$bind = F3(
	function (key, name, msg) {
		return A2(
			elm$core$Result$map,
			A2(author$project$KeyCombo$Binding, name, msg),
			author$project$KeyCombo$fromString(key));
	});
var elm_community$result_extra$Result$Extra$combine = A2(
	elm$core$List$foldr,
	elm$core$Result$map2(elm$core$List$cons),
	elm$core$Result$Ok(_List_Nil));
var author$project$KeyCombo$bindings = A2(
	elm$core$Basics$composeR,
	elm_community$result_extra$Result$Extra$combine,
	elm$core$Result$map(author$project$KeyCombo$bindings_));
var author$project$Main$BulkUpgradeAll = {$: 21};
var author$project$Main$BulkUpgradeCheapest = {$: 22};
var author$project$Main$CloseModal = {$: 19};
var author$project$Main$RouteChanged = function (a) {
	return {$: 2, a: a};
};
var author$project$Main$ToggleKeyCombos = {$: 18};
var author$project$Main$Undo = {$: 20};
var author$project$Main$globalKeyBindings = author$project$KeyCombo$bindings(
	_List_fromArray(
		[
			A3(author$project$KeyCombo$bind, '?', 'nav.keycombos', author$project$Main$ToggleKeyCombos),
			A3(author$project$KeyCombo$bind, 'Escape', 'nav.closeModal', author$project$Main$CloseModal),
			A3(
			author$project$KeyCombo$bind,
			'm',
			'nav.meat',
			author$project$Main$RouteChanged(
				author$project$Route$Tab('meat'))),
			A3(
			author$project$KeyCombo$bind,
			'l',
			'nav.larva',
			author$project$Main$RouteChanged(
				author$project$Route$Tab('larva'))),
			A3(
			author$project$KeyCombo$bind,
			't',
			'nav.territory',
			author$project$Main$RouteChanged(
				author$project$Route$Tab('territory'))),
			A3(
			author$project$KeyCombo$bind,
			'e',
			'nav.energy',
			author$project$Main$RouteChanged(
				author$project$Route$Tab('energy'))),
			A3(
			author$project$KeyCombo$bind,
			'u',
			'nav.mutagen',
			author$project$Main$RouteChanged(
				author$project$Route$Tab('mutagen'))),
			A3(
			author$project$KeyCombo$bind,
			'a',
			'nav.all',
			author$project$Main$RouteChanged(
				author$project$Route$Tab('all'))),
			A3(
			author$project$KeyCombo$bind,
			'o',
			'nav.options',
			author$project$Main$RouteChanged(author$project$Route$Options)),
			A3(
			author$project$KeyCombo$bind,
			'y',
			'nav.achievements',
			author$project$Main$RouteChanged(author$project$Route$Achievements)),
			A3(
			author$project$KeyCombo$bind,
			'alt+y',
			'nav.statistics',
			author$project$Main$RouteChanged(author$project$Route$Statistics)),
			A3(
			author$project$KeyCombo$bind,
			'n',
			'nav.changelog',
			author$project$Main$RouteChanged(author$project$Route$Changelog)),
			A3(author$project$KeyCombo$bind, 'z', 'undo', author$project$Main$Undo),
			A3(author$project$KeyCombo$bind, 'alt+a', 'upgrade.all', author$project$Main$BulkUpgradeAll),
			A3(author$project$KeyCombo$bind, 'alt+c', 'upgrade.cheapest', author$project$Main$BulkUpgradeCheapest)
		]));
var author$project$Page$MtxShop$ClickedRoute = function (a) {
	return {$: 5, a: a};
};
var author$project$Page$MtxShop$Noop = {$: 9};
var author$project$Page$Unit$routeItem = F2(
	function (tabSlug, item) {
		switch (item.$) {
			case 2:
				var s = item.a;
				return A2(author$project$Route$Spell, tabSlug, s.cA);
			case 0:
				var u = item.a;
				return A2(author$project$Route$unit, tabSlug, u.cA);
			default:
				return author$project$Route$Home;
		}
	});
var author$project$GameData$itemBySlug = function (name) {
	return A2(
		elm$core$Basics$composeR,
		author$project$GameData$indexes,
		A2(
			elm$core$Basics$composeR,
			function ($) {
				return $.b5;
			},
			elm$core$Dict$get(
				elm$core$String$toLower(name))));
};
var author$project$Select$isItemVisible = F2(
	function (snapshot, u) {
		return A2(
			author$project$Game$UnitsSnapshot$isItemVisible,
			author$project$GameData$Item$id(u),
			snapshot);
	});
var author$project$Select$itemBySlug = F3(
	function (itemSlug, game, snapshot) {
		return A2(
			elm_community$maybe_extra$Maybe$Extra$filter,
			author$project$Select$isItemVisible(snapshot),
			A2(
				author$project$GameData$itemBySlug,
				itemSlug,
				author$project$Game$gameData(game)));
	});
var author$project$GameData$spellsByTabId = function (tab) {
	return A2(
		elm$core$Basics$composeR,
		author$project$GameData$indexes,
		A2(
			elm$core$Basics$composeR,
			function ($) {
				return $.cD;
			},
			A2(
				elm$core$Basics$composeR,
				elm$core$Dict$get(
					author$project$GameData$Tab$idToString(tab)),
				elm$core$Maybe$withDefault(_List_Nil))));
};
var author$project$GameData$spellsByTab = function (tab) {
	return author$project$GameData$spellsByTabId(tab.eL);
};
var author$project$Select$spellsByTab = F3(
	function (stab, game, snapshot) {
		if (stab.$ === 1) {
			return A2(
				elm$core$List$filter,
				author$project$Select$isSpellVisible(snapshot),
				author$project$GameData$spells(
					author$project$Game$gameData(game)));
		} else {
			var tab = stab.a;
			return A2(
				elm$core$List$filter,
				author$project$Select$isSpellVisible(snapshot),
				A2(
					author$project$GameData$spellsByTab,
					tab,
					author$project$Game$gameData(game)));
		}
	});
var author$project$GameData$tabBySlug = F2(
	function (name, _n0) {
		var is = _n0.b;
		return A2(
			elm$core$Dict$get,
			elm$core$String$toLower(name),
			is.cI);
	});
var author$project$Select$AllTab = {$: 1};
var author$project$Select$NormalTab = function (a) {
	return {$: 0, a: a};
};
var author$project$Select$isTabVisible = F2(
	function (snapshot, t) {
		return A2(author$project$Game$UnitsSnapshot$isTabVisible, t.eL, snapshot);
	});
var author$project$Select$tabBySlug = F3(
	function (tabSlug, game, snapshot) {
		return (tabSlug === 'all') ? elm$core$Maybe$Just(author$project$Select$AllTab) : A2(
			elm$core$Maybe$map,
			author$project$Select$NormalTab,
			A2(
				elm_community$maybe_extra$Maybe$Extra$filter,
				author$project$Select$isTabVisible(snapshot),
				A2(
					author$project$GameData$tabBySlug,
					tabSlug,
					author$project$Game$gameData(game))));
	});
var author$project$GameData$unitsByTabName = function (tab) {
	return A2(
		elm$core$Basics$composeR,
		author$project$GameData$indexes,
		A2(
			elm$core$Basics$composeR,
			function ($) {
				return $.cN;
			},
			A2(
				elm$core$Basics$composeR,
				elm$core$Dict$get(tab),
				elm$core$Maybe$withDefault(_List_Nil))));
};
var author$project$GameData$unitsByTabId = A2(elm$core$Basics$composeR, author$project$GameData$Tab$idToString, author$project$GameData$unitsByTabName);
var author$project$GameData$unitsByTab = function (tab) {
	return author$project$GameData$unitsByTabId(tab.eL);
};
var author$project$Select$unitEmpower = F2(
	function (game, u) {
		var upgradeName = author$project$GameData$Unit$idToString(u.eL) + 'empower';
		return elm$core$Basics$floor(
			author$project$Decimal$toFloat(
				A2(author$project$Game$upgradeCountName, upgradeName, game)));
	});
var author$project$Select$unitsByTab = F3(
	function (stab, game, snapshot) {
		return A2(
			elm$core$List$filter,
			author$project$Select$isUnitVisible(snapshot),
			function () {
				if (stab.$ === 1) {
					return author$project$GameData$units(
						author$project$Game$gameData(game));
				} else {
					var tab = stab.a;
					return A2(
						elm$core$List$map,
						elm$core$Tuple$second,
						A2(
							elm$core$List$sortBy,
							function (_n1) {
								var i = _n1.a;
								var u = _n1.b;
								return _Utils_Tuple2(
									(-1) * A2(author$project$Select$unitEmpower, game, u),
									i);
							},
							A2(
								elm$core$List$indexedMap,
								elm$core$Tuple$pair,
								A2(
									author$project$GameData$unitsByTab,
									tab,
									author$project$Game$gameData(game)))));
				}
			}());
	});
var elm_community$list_extra$List$Extra$findIndexHelp = F3(
	function (index, predicate, list) {
		findIndexHelp:
		while (true) {
			if (!list.b) {
				return elm$core$Maybe$Nothing;
			} else {
				var x = list.a;
				var xs = list.b;
				if (predicate(x)) {
					return elm$core$Maybe$Just(index);
				} else {
					var $temp$index = index + 1,
						$temp$predicate = predicate,
						$temp$list = xs;
					index = $temp$index;
					predicate = $temp$predicate;
					list = $temp$list;
					continue findIndexHelp;
				}
			}
		}
	});
var elm_community$list_extra$List$Extra$findIndex = elm_community$list_extra$List$Extra$findIndexHelp(0);
var elm_community$list_extra$List$Extra$getAt = F2(
	function (idx, xs) {
		return (idx < 0) ? elm$core$Maybe$Nothing : elm$core$List$head(
			A2(elm$core$List$drop, idx, xs));
	});
var author$project$Page$Unit$itemKeyBindings = F5(
	function (tabSlug, itemSlug, session, clickedBuyUnitMsg, clickedRouteMsg) {
		var _n0 = author$project$Session$game(session);
		if (_n0.$ === 3) {
			var game = _n0.a;
			var snap = author$project$Game$units(game);
			var _n1 = _Utils_Tuple2(
				A3(author$project$Select$tabBySlug, tabSlug, game, snap),
				A3(author$project$Select$itemBySlug, itemSlug, game, snap));
			if ((!_n1.a.$) && (!_n1.b.$)) {
				var stab = _n1.a.a;
				var item = _n1.b.a;
				var units = A3(author$project$Select$unitsByTab, stab, game, snap);
				var spells = A3(author$project$Select$spellsByTab, stab, game, snap);
				var items = _Utils_ap(
					A2(elm$core$List$map, author$project$GameData$Item$Spell, spells),
					A2(elm$core$List$map, author$project$GameData$Item$Unit, units));
				var itemIndex = A2(
					elm_community$list_extra$List$Extra$findIndex,
					function (i) {
						return _Utils_eq(
							author$project$GameData$Item$name(i),
							author$project$GameData$Item$name(item));
					},
					items);
				var next = A2(
					elm$core$Maybe$andThen,
					function (i) {
						return A2(elm_community$list_extra$List$Extra$getAt, i + 1, items);
					},
					itemIndex);
				var prev = A2(
					elm$core$Maybe$andThen,
					function (i) {
						return A2(elm_community$list_extra$List$Extra$getAt, i - 1, items);
					},
					itemIndex);
				return author$project$KeyCombo$bindings(
					_Utils_ap(
						A2(
							elm$core$List$filterMap,
							elm$core$Basics$identity,
							_List_fromArray(
								[
									A2(
									elm$core$Maybe$map,
									function (u) {
										return A3(
											author$project$KeyCombo$bind,
											'alt+ArrowUp',
											'nav.unit.prev',
											clickedRouteMsg(
												A2(author$project$Page$Unit$routeItem, tabSlug, u)));
									},
									prev),
									A2(
									elm$core$Maybe$map,
									function (u) {
										return A3(
											author$project$KeyCombo$bind,
											'alt+ArrowDown',
											'nav.unit.next',
											clickedRouteMsg(
												A2(author$project$Page$Unit$routeItem, tabSlug, u)));
									},
									next),
									elm$core$Maybe$Just(
									A3(author$project$KeyCombo$bind, 'alt+b', 'unit.buy', clickedBuyUnitMsg))
								])),
						_List_Nil));
			} else {
				return elm$core$Result$Err('no such tab/unit');
			}
		} else {
			return elm$core$Result$Err('game not loaded yet');
		}
	});
var author$project$Page$MtxShop$keyBindings = function (_n0) {
	var invRes = _n0.a;
	var tabSlug = _n0.b;
	var paypalReturnArgs = _n0.c;
	var session = _n0.d;
	return A5(author$project$Page$Unit$itemKeyBindings, tabSlug, 'crystal', session, author$project$Page$MtxShop$Noop, author$project$Page$MtxShop$ClickedRoute);
};
var author$project$Page$Spell$ClickedBuySpell = {$: 4};
var author$project$Page$Spell$ClickedRoute = function (a) {
	return {$: 1, a: a};
};
var author$project$Page$Spell$keyBindings = function (_n0) {
	var tabSlug = _n0.a;
	var spellSlug = _n0.b;
	var session = _n0.c;
	return A5(author$project$Page$Unit$itemKeyBindings, tabSlug, spellSlug, session, author$project$Page$Spell$ClickedBuySpell, author$project$Page$Spell$ClickedRoute);
};
var author$project$Page$Unit$ClickedBuyUnit = {$: 5};
var author$project$Page$Unit$ClickedRoute = function (a) {
	return {$: 1, a: a};
};
var author$project$Page$Unit$keyBindings = function (_n0) {
	var tabSlug = _n0.a;
	var unitSlug = _n0.b;
	var ns = _n0.c;
	var session = _n0.d;
	return A5(author$project$Page$Unit$itemKeyBindings, tabSlug, unitSlug, session, author$project$Page$Unit$ClickedBuyUnit, author$project$Page$Unit$ClickedRoute);
};
var author$project$Main$keyCombos = function (model) {
	var localKeyBindings = function () {
		switch (model.$) {
			case 4:
				var m = model.a;
				return A2(
					elm$core$Result$map,
					author$project$KeyCombo$mapBindings(author$project$Main$GotUnitMsg),
					author$project$Page$Unit$keyBindings(m));
			case 5:
				var m = model.a;
				return A2(
					elm$core$Result$map,
					author$project$KeyCombo$mapBindings(author$project$Main$GotSpellMsg),
					author$project$Page$Spell$keyBindings(m));
			case 2:
				var m = model.a;
				return A2(
					elm$core$Result$map,
					author$project$KeyCombo$mapBindings(author$project$Main$GotMtxShopMsg),
					author$project$Page$MtxShop$keyBindings(m));
			default:
				return elm$core$Result$Err('no local bindings');
		}
	}();
	return A2(
		author$project$KeyCombo$union,
		A2(elm$core$Result$withDefault, author$project$KeyCombo$emptyBindings, localKeyBindings),
		A2(elm$core$Result$withDefault, author$project$KeyCombo$emptyBindings, author$project$Main$globalKeyBindings));
};
var author$project$Main$onKeyCombo = F2(
	function (model, input) {
		return A2(
			author$project$KeyCombo$getMsg,
			input,
			author$project$Main$keyCombos(model));
	});
var author$project$Page$MtxHistory$GotKongregateInventory = function (a) {
	return {$: 3, a: a};
};
var author$project$Ports$Kongregate$kongregateRequestUserItemListRes = _Platform_incomingPort(
	'kongregateRequestUserItemListRes',
	A2(
		elm$json$Json$Decode$andThen,
		function (success) {
			return A2(
				elm$json$Json$Decode$andThen,
				function (data) {
					return elm$json$Json$Decode$succeed(
						{eu: data, fK: success});
				},
				A2(elm$json$Json$Decode$field, 'data', elm$json$Json$Decode$value));
		},
		A2(elm$json$Json$Decode$field, 'success', elm$json$Json$Decode$bool)));
var author$project$Page$MtxHistory$subscriptions = author$project$Ports$Kongregate$kongregateRequestUserItemListRes(author$project$Page$MtxHistory$GotKongregateInventory);
var author$project$Page$MtxShop$GotKongregateInventory = function (a) {
	return {$: 2, a: a};
};
var author$project$Page$MtxShop$GotKongregatePurchaseResult = function (a) {
	return {$: 3, a: a};
};
var author$project$Ports$Kongregate$kongregatePurchaseItemsRes = _Platform_incomingPort(
	'kongregatePurchaseItemsRes',
	A2(
		elm$json$Json$Decode$andThen,
		function (success) {
			return A2(
				elm$json$Json$Decode$andThen,
				function (item) {
					return elm$json$Json$Decode$succeed(
						{eW: item, fK: success});
				},
				A2(elm$json$Json$Decode$field, 'item', elm$json$Json$Decode$string));
		},
		A2(elm$json$Json$Decode$field, 'success', elm$json$Json$Decode$bool)));
var elm$core$Platform$Sub$batch = _Platform_batch;
var author$project$Page$MtxShop$subscriptions = elm$core$Platform$Sub$batch(
	_List_fromArray(
		[
			author$project$Ports$Kongregate$kongregateRequestUserItemListRes(author$project$Page$MtxShop$GotKongregateInventory),
			author$project$Ports$Kongregate$kongregatePurchaseItemsRes(author$project$Page$MtxShop$GotKongregatePurchaseResult)
		]));
var author$project$Page$Options$PersistImportRead = function (a) {
	return {$: 7, a: a};
};
var author$project$Ports$persistImportRead = _Platform_incomingPort('persistImportRead', elm$json$Json$Decode$value);
var author$project$Page$Options$subscriptions = function (model) {
	return author$project$Ports$persistImportRead(author$project$Page$Options$PersistImportRead);
};
var author$project$Ports$readUserSessionTicket = _Platform_incomingPort(
	'readUserSessionTicket',
	A2(
		elm$json$Json$Decode$andThen,
		function (sessionTicket) {
			return A2(
				elm$json$Json$Decode$andThen,
				function (rememberId) {
					return elm$json$Json$Decode$succeed(
						{bw: rememberId, bz: sessionTicket});
				},
				A2(
					elm$json$Json$Decode$field,
					'rememberId',
					elm$json$Json$Decode$oneOf(
						_List_fromArray(
							[
								elm$json$Json$Decode$null(elm$core$Maybe$Nothing),
								A2(elm$json$Json$Decode$map, elm$core$Maybe$Just, elm$json$Json$Decode$string)
							]))));
		},
		A2(
			elm$json$Json$Decode$field,
			'sessionTicket',
			elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						elm$json$Json$Decode$null(elm$core$Maybe$Nothing),
						A2(elm$json$Json$Decode$map, elm$core$Maybe$Just, elm$json$Json$Decode$string)
					])))));
var author$project$PlayFab$User$readUserSessionTicket = function (toMsg) {
	return author$project$Ports$readUserSessionTicket(
		function (res) {
			return toMsg(
				_Utils_Tuple2(
					A2(elm$core$Maybe$map, elm$core$Basics$identity, res.bz),
					A2(elm$core$Maybe$map, elm$core$Basics$identity, res.bw)));
		});
};
var author$project$Ports$apiRequest = _Platform_incomingPort('apiRequest', elm$json$Json$Decode$value);
var author$project$Ports$konami = _Platform_incomingPort(
	'konami',
	elm$json$Json$Decode$null(0));
var author$project$Ports$onUnload = _Platform_incomingPort(
	'onUnload',
	elm$json$Json$Decode$succeed(
		{}));
var author$project$Ports$persistExport = _Platform_incomingPort('persistExport', elm$json$Json$Decode$value);
var author$project$Ports$persistRead = _Platform_incomingPort('persistRead', elm$json$Json$Decode$value);
var author$project$Ports$playfabDecodeSaveRes = _Platform_incomingPort('playfabDecodeSaveRes', elm$json$Json$Decode$value);
var author$project$Ports$serviceWorker = _Platform_incomingPort('serviceWorker', elm$json$Json$Decode$value);
var author$project$Ports$translatorRead = _Platform_incomingPort('translatorRead', elm$json$Json$Decode$value);
var author$project$Ports$Kongregate$kongregateLogin = _Platform_incomingPort(
	'kongregateLogin',
	A2(
		elm$json$Json$Decode$andThen,
		function (username) {
			return A2(
				elm$json$Json$Decode$andThen,
				function (userId) {
					return A2(
						elm$json$Json$Decode$andThen,
						function (isGuest) {
							return A2(
								elm$json$Json$Decode$andThen,
								function (gameAuthToken) {
									return elm$json$Json$Decode$succeed(
										{dk: gameAuthToken, eV: isGuest, bH: userId, fZ: username});
								},
								A2(elm$json$Json$Decode$field, 'gameAuthToken', elm$json$Json$Decode$string));
						},
						A2(elm$json$Json$Decode$field, 'isGuest', elm$json$Json$Decode$bool));
				},
				A2(elm$json$Json$Decode$field, 'userId', elm$json$Json$Decode$string));
		},
		A2(elm$json$Json$Decode$field, 'username', elm$json$Json$Decode$string)));
var elm$browser$Browser$AnimationManager$Time = function (a) {
	return {$: 0, a: a};
};
var elm$browser$Browser$AnimationManager$State = F3(
	function (subs, request, oldTime) {
		return {cn: oldTime, dO: request, dZ: subs};
	});
var elm$browser$Browser$AnimationManager$init = elm$core$Task$succeed(
	A3(elm$browser$Browser$AnimationManager$State, _List_Nil, elm$core$Maybe$Nothing, 0));
var elm$browser$Browser$AnimationManager$now = _Browser_now(0);
var elm$browser$Browser$AnimationManager$rAF = _Browser_rAF(0);
var elm$browser$Browser$AnimationManager$onEffects = F3(
	function (router, subs, _n0) {
		var request = _n0.dO;
		var oldTime = _n0.cn;
		var _n1 = _Utils_Tuple2(request, subs);
		if (_n1.a.$ === 1) {
			if (!_n1.b.b) {
				var _n2 = _n1.a;
				return elm$browser$Browser$AnimationManager$init;
			} else {
				var _n4 = _n1.a;
				return A2(
					elm$core$Task$andThen,
					function (pid) {
						return A2(
							elm$core$Task$andThen,
							function (time) {
								return elm$core$Task$succeed(
									A3(
										elm$browser$Browser$AnimationManager$State,
										subs,
										elm$core$Maybe$Just(pid),
										time));
							},
							elm$browser$Browser$AnimationManager$now);
					},
					elm$core$Process$spawn(
						A2(
							elm$core$Task$andThen,
							elm$core$Platform$sendToSelf(router),
							elm$browser$Browser$AnimationManager$rAF)));
			}
		} else {
			if (!_n1.b.b) {
				var pid = _n1.a.a;
				return A2(
					elm$core$Task$andThen,
					function (_n3) {
						return elm$browser$Browser$AnimationManager$init;
					},
					elm$core$Process$kill(pid));
			} else {
				return elm$core$Task$succeed(
					A3(elm$browser$Browser$AnimationManager$State, subs, request, oldTime));
			}
		}
	});
var elm$browser$Browser$AnimationManager$onSelfMsg = F3(
	function (router, newTime, _n0) {
		var subs = _n0.dZ;
		var oldTime = _n0.cn;
		var send = function (sub) {
			if (!sub.$) {
				var tagger = sub.a;
				return A2(
					elm$core$Platform$sendToApp,
					router,
					tagger(
						elm$time$Time$millisToPosix(newTime)));
			} else {
				var tagger = sub.a;
				return A2(
					elm$core$Platform$sendToApp,
					router,
					tagger(newTime - oldTime));
			}
		};
		return A2(
			elm$core$Task$andThen,
			function (pid) {
				return A2(
					elm$core$Task$andThen,
					function (_n1) {
						return elm$core$Task$succeed(
							A3(
								elm$browser$Browser$AnimationManager$State,
								subs,
								elm$core$Maybe$Just(pid),
								newTime));
					},
					elm$core$Task$sequence(
						A2(elm$core$List$map, send, subs)));
			},
			elm$core$Process$spawn(
				A2(
					elm$core$Task$andThen,
					elm$core$Platform$sendToSelf(router),
					elm$browser$Browser$AnimationManager$rAF)));
	});
var elm$browser$Browser$AnimationManager$Delta = function (a) {
	return {$: 1, a: a};
};
var elm$browser$Browser$AnimationManager$subMap = F2(
	function (func, sub) {
		if (!sub.$) {
			var tagger = sub.a;
			return elm$browser$Browser$AnimationManager$Time(
				A2(elm$core$Basics$composeL, func, tagger));
		} else {
			var tagger = sub.a;
			return elm$browser$Browser$AnimationManager$Delta(
				A2(elm$core$Basics$composeL, func, tagger));
		}
	});
_Platform_effectManagers['Browser.AnimationManager'] = _Platform_createManager(elm$browser$Browser$AnimationManager$init, elm$browser$Browser$AnimationManager$onEffects, elm$browser$Browser$AnimationManager$onSelfMsg, 0, elm$browser$Browser$AnimationManager$subMap);
var elm$browser$Browser$AnimationManager$subscription = _Platform_leaf('Browser.AnimationManager');
var elm$browser$Browser$AnimationManager$onAnimationFrame = function (tagger) {
	return elm$browser$Browser$AnimationManager$subscription(
		elm$browser$Browser$AnimationManager$Time(tagger));
};
var elm$browser$Browser$Events$onAnimationFrame = elm$browser$Browser$AnimationManager$onAnimationFrame;
var elm$browser$Browser$Events$Document = 0;
var elm$browser$Browser$Events$MySub = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var elm$browser$Browser$Events$State = F2(
	function (subs, pids) {
		return {dE: pids, dZ: subs};
	});
var elm$browser$Browser$Events$init = elm$core$Task$succeed(
	A2(elm$browser$Browser$Events$State, _List_Nil, elm$core$Dict$empty));
var elm$browser$Browser$Events$nodeToKey = function (node) {
	if (!node) {
		return 'd_';
	} else {
		return 'w_';
	}
};
var elm$browser$Browser$Events$addKey = function (sub) {
	var node = sub.a;
	var name = sub.b;
	return _Utils_Tuple2(
		_Utils_ap(
			elm$browser$Browser$Events$nodeToKey(node),
			name),
		sub);
};
var elm$browser$Browser$Events$Event = F2(
	function (key, event) {
		return {df: event, E: key};
	});
var elm$browser$Browser$Events$spawn = F3(
	function (router, key, _n0) {
		var node = _n0.a;
		var name = _n0.b;
		var actualNode = function () {
			if (!node) {
				return _Browser_doc;
			} else {
				return _Browser_window;
			}
		}();
		return A2(
			elm$core$Task$map,
			function (value) {
				return _Utils_Tuple2(key, value);
			},
			A3(
				_Browser_on,
				actualNode,
				name,
				function (event) {
					return A2(
						elm$core$Platform$sendToSelf,
						router,
						A2(elm$browser$Browser$Events$Event, key, event));
				}));
	});
var elm$core$Dict$merge = F6(
	function (leftStep, bothStep, rightStep, leftDict, rightDict, initialResult) {
		var stepState = F3(
			function (rKey, rValue, _n0) {
				stepState:
				while (true) {
					var list = _n0.a;
					var result = _n0.b;
					if (!list.b) {
						return _Utils_Tuple2(
							list,
							A3(rightStep, rKey, rValue, result));
					} else {
						var _n2 = list.a;
						var lKey = _n2.a;
						var lValue = _n2.b;
						var rest = list.b;
						if (_Utils_cmp(lKey, rKey) < 0) {
							var $temp$rKey = rKey,
								$temp$rValue = rValue,
								$temp$_n0 = _Utils_Tuple2(
								rest,
								A3(leftStep, lKey, lValue, result));
							rKey = $temp$rKey;
							rValue = $temp$rValue;
							_n0 = $temp$_n0;
							continue stepState;
						} else {
							if (_Utils_cmp(lKey, rKey) > 0) {
								return _Utils_Tuple2(
									list,
									A3(rightStep, rKey, rValue, result));
							} else {
								return _Utils_Tuple2(
									rest,
									A4(bothStep, lKey, lValue, rValue, result));
							}
						}
					}
				}
			});
		var _n3 = A3(
			elm$core$Dict$foldl,
			stepState,
			_Utils_Tuple2(
				elm$core$Dict$toList(leftDict),
				initialResult),
			rightDict);
		var leftovers = _n3.a;
		var intermediateResult = _n3.b;
		return A3(
			elm$core$List$foldl,
			F2(
				function (_n4, result) {
					var k = _n4.a;
					var v = _n4.b;
					return A3(leftStep, k, v, result);
				}),
			intermediateResult,
			leftovers);
	});
var elm$browser$Browser$Events$onEffects = F3(
	function (router, subs, state) {
		var stepRight = F3(
			function (key, sub, _n6) {
				var deads = _n6.a;
				var lives = _n6.b;
				var news = _n6.c;
				return _Utils_Tuple3(
					deads,
					lives,
					A2(
						elm$core$List$cons,
						A3(elm$browser$Browser$Events$spawn, router, key, sub),
						news));
			});
		var stepLeft = F3(
			function (_n4, pid, _n5) {
				var deads = _n5.a;
				var lives = _n5.b;
				var news = _n5.c;
				return _Utils_Tuple3(
					A2(elm$core$List$cons, pid, deads),
					lives,
					news);
			});
		var stepBoth = F4(
			function (key, pid, _n2, _n3) {
				var deads = _n3.a;
				var lives = _n3.b;
				var news = _n3.c;
				return _Utils_Tuple3(
					deads,
					A3(elm$core$Dict$insert, key, pid, lives),
					news);
			});
		var newSubs = A2(elm$core$List$map, elm$browser$Browser$Events$addKey, subs);
		var _n0 = A6(
			elm$core$Dict$merge,
			stepLeft,
			stepBoth,
			stepRight,
			state.dE,
			elm$core$Dict$fromList(newSubs),
			_Utils_Tuple3(_List_Nil, elm$core$Dict$empty, _List_Nil));
		var deadPids = _n0.a;
		var livePids = _n0.b;
		var makeNewPids = _n0.c;
		return A2(
			elm$core$Task$andThen,
			function (pids) {
				return elm$core$Task$succeed(
					A2(
						elm$browser$Browser$Events$State,
						newSubs,
						A2(
							elm$core$Dict$union,
							livePids,
							elm$core$Dict$fromList(pids))));
			},
			A2(
				elm$core$Task$andThen,
				function (_n1) {
					return elm$core$Task$sequence(makeNewPids);
				},
				elm$core$Task$sequence(
					A2(elm$core$List$map, elm$core$Process$kill, deadPids))));
	});
var elm$browser$Browser$Events$onSelfMsg = F3(
	function (router, _n0, state) {
		var key = _n0.E;
		var event = _n0.df;
		var toMessage = function (_n2) {
			var subKey = _n2.a;
			var _n3 = _n2.b;
			var node = _n3.a;
			var name = _n3.b;
			var decoder = _n3.c;
			return _Utils_eq(subKey, key) ? A2(_Browser_decodeEvent, decoder, event) : elm$core$Maybe$Nothing;
		};
		var messages = A2(elm$core$List$filterMap, toMessage, state.dZ);
		return A2(
			elm$core$Task$andThen,
			function (_n1) {
				return elm$core$Task$succeed(state);
			},
			elm$core$Task$sequence(
				A2(
					elm$core$List$map,
					elm$core$Platform$sendToApp(router),
					messages)));
	});
var elm$browser$Browser$Events$subMap = F2(
	function (func, _n0) {
		var node = _n0.a;
		var name = _n0.b;
		var decoder = _n0.c;
		return A3(
			elm$browser$Browser$Events$MySub,
			node,
			name,
			A2(elm$json$Json$Decode$map, func, decoder));
	});
_Platform_effectManagers['Browser.Events'] = _Platform_createManager(elm$browser$Browser$Events$init, elm$browser$Browser$Events$onEffects, elm$browser$Browser$Events$onSelfMsg, 0, elm$browser$Browser$Events$subMap);
var elm$browser$Browser$Events$subscription = _Platform_leaf('Browser.Events');
var elm$browser$Browser$Events$on = F3(
	function (node, name, decoder) {
		return elm$browser$Browser$Events$subscription(
			A3(elm$browser$Browser$Events$MySub, node, name, decoder));
	});
var elm$browser$Browser$Events$onKeyDown = A2(elm$browser$Browser$Events$on, 0, 'keydown');
var elm$core$Platform$Sub$map = _Platform_map;
var elm$core$Platform$Sub$none = elm$core$Platform$Sub$batch(_List_Nil);
var elm$time$Time$Every = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var elm$time$Time$State = F2(
	function (taggers, processes) {
		return {dI: processes, d$: taggers};
	});
var elm$time$Time$init = elm$core$Task$succeed(
	A2(elm$time$Time$State, elm$core$Dict$empty, elm$core$Dict$empty));
var elm$time$Time$addMySub = F2(
	function (_n0, state) {
		var interval = _n0.a;
		var tagger = _n0.b;
		var _n1 = A2(elm$core$Dict$get, interval, state);
		if (_n1.$ === 1) {
			return A3(
				elm$core$Dict$insert,
				interval,
				_List_fromArray(
					[tagger]),
				state);
		} else {
			var taggers = _n1.a;
			return A3(
				elm$core$Dict$insert,
				interval,
				A2(elm$core$List$cons, tagger, taggers),
				state);
		}
	});
var elm$time$Time$setInterval = _Time_setInterval;
var elm$time$Time$spawnHelp = F3(
	function (router, intervals, processes) {
		if (!intervals.b) {
			return elm$core$Task$succeed(processes);
		} else {
			var interval = intervals.a;
			var rest = intervals.b;
			var spawnTimer = elm$core$Process$spawn(
				A2(
					elm$time$Time$setInterval,
					interval,
					A2(elm$core$Platform$sendToSelf, router, interval)));
			var spawnRest = function (id) {
				return A3(
					elm$time$Time$spawnHelp,
					router,
					rest,
					A3(elm$core$Dict$insert, interval, id, processes));
			};
			return A2(elm$core$Task$andThen, spawnRest, spawnTimer);
		}
	});
var elm$time$Time$onEffects = F3(
	function (router, subs, _n0) {
		var processes = _n0.dI;
		var rightStep = F3(
			function (_n6, id, _n7) {
				var spawns = _n7.a;
				var existing = _n7.b;
				var kills = _n7.c;
				return _Utils_Tuple3(
					spawns,
					existing,
					A2(
						elm$core$Task$andThen,
						function (_n5) {
							return kills;
						},
						elm$core$Process$kill(id)));
			});
		var newTaggers = A3(elm$core$List$foldl, elm$time$Time$addMySub, elm$core$Dict$empty, subs);
		var leftStep = F3(
			function (interval, taggers, _n4) {
				var spawns = _n4.a;
				var existing = _n4.b;
				var kills = _n4.c;
				return _Utils_Tuple3(
					A2(elm$core$List$cons, interval, spawns),
					existing,
					kills);
			});
		var bothStep = F4(
			function (interval, taggers, id, _n3) {
				var spawns = _n3.a;
				var existing = _n3.b;
				var kills = _n3.c;
				return _Utils_Tuple3(
					spawns,
					A3(elm$core$Dict$insert, interval, id, existing),
					kills);
			});
		var _n1 = A6(
			elm$core$Dict$merge,
			leftStep,
			bothStep,
			rightStep,
			newTaggers,
			processes,
			_Utils_Tuple3(
				_List_Nil,
				elm$core$Dict$empty,
				elm$core$Task$succeed(0)));
		var spawnList = _n1.a;
		var existingDict = _n1.b;
		var killTask = _n1.c;
		return A2(
			elm$core$Task$andThen,
			function (newProcesses) {
				return elm$core$Task$succeed(
					A2(elm$time$Time$State, newTaggers, newProcesses));
			},
			A2(
				elm$core$Task$andThen,
				function (_n2) {
					return A3(elm$time$Time$spawnHelp, router, spawnList, existingDict);
				},
				killTask));
	});
var elm$time$Time$onSelfMsg = F3(
	function (router, interval, state) {
		var _n0 = A2(elm$core$Dict$get, interval, state.d$);
		if (_n0.$ === 1) {
			return elm$core$Task$succeed(state);
		} else {
			var taggers = _n0.a;
			var tellTaggers = function (time) {
				return elm$core$Task$sequence(
					A2(
						elm$core$List$map,
						function (tagger) {
							return A2(
								elm$core$Platform$sendToApp,
								router,
								tagger(time));
						},
						taggers));
			};
			return A2(
				elm$core$Task$andThen,
				function (_n1) {
					return elm$core$Task$succeed(state);
				},
				A2(elm$core$Task$andThen, tellTaggers, elm$time$Time$now));
		}
	});
var elm$time$Time$subMap = F2(
	function (f, _n0) {
		var interval = _n0.a;
		var tagger = _n0.b;
		return A2(
			elm$time$Time$Every,
			interval,
			A2(elm$core$Basics$composeL, f, tagger));
	});
_Platform_effectManagers['Time'] = _Platform_createManager(elm$time$Time$init, elm$time$Time$onEffects, elm$time$Time$onSelfMsg, 0, elm$time$Time$subMap);
var elm$time$Time$subscription = _Platform_leaf('Time');
var elm$time$Time$every = F2(
	function (interval, tagger) {
		return elm$time$Time$subscription(
			A2(elm$time$Time$Every, interval, tagger));
	});
var author$project$Main$subscriptions = function (model) {
	return elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				elm$browser$Browser$Events$onAnimationFrame(author$project$Main$GotTime),
				author$project$Ports$persistRead(author$project$Main$PersistRead),
				author$project$Ports$persistExport(author$project$Main$PersistExported),
				author$project$Ports$serviceWorker(author$project$Main$GotServiceWorkerEvent),
				author$project$Ports$playfabDecodeSaveRes(author$project$Main$GotUserGame),
				author$project$Ports$onUnload(
				elm$core$Basics$always(author$project$Main$OnUnload)),
				author$project$Ports$apiRequest(author$project$Main$OnApiRequest),
				author$project$Ports$Kongregate$kongregateLogin(author$project$Main$OnKongregateLogin),
				author$project$Ports$translatorRead(author$project$Main$OnTranslatorRead),
				author$project$PlayFab$User$readUserSessionTicket(
				function (_n0) {
					var s = _n0.a;
					var r = _n0.b;
					return A2(author$project$Main$GotUserSessionTicket, s, r);
				}),
				author$project$Ports$konami(
				elm$core$Basics$always(author$project$Main$OnKonami)),
				elm$browser$Browser$Events$onKeyDown(
				A2(
					elm$json$Json$Decode$andThen,
					function (input) {
						var _n1 = A2(author$project$Main$onKeyCombo, model, input);
						if (_n1.$ === 1) {
							return elm$json$Json$Decode$fail('unmapped key combo');
						} else {
							var msg = _n1.a;
							return elm$json$Json$Decode$succeed(msg);
						}
					},
					author$project$KeyCombo$inputDecoder)),
				A2(
				elm$time$Time$every,
				((1000 * 60) * 60) * 11,
				elm$core$Basics$always(author$project$Main$OnLongPageOpen)),
				function () {
				switch (model.$) {
					case 7:
						var m = model.a;
						return A2(
							elm$core$Platform$Sub$map,
							author$project$Main$GotOptionsMsg,
							author$project$Page$Options$subscriptions(m));
					case 11:
						var m = model.a;
						return A2(elm$core$Platform$Sub$map, author$project$Main$GotMtxHistoryMsg, author$project$Page$MtxHistory$subscriptions);
					case 2:
						var m = model.a;
						return A2(elm$core$Platform$Sub$map, author$project$Main$GotMtxShopMsg, author$project$Page$MtxShop$subscriptions);
					default:
						return elm$core$Platform$Sub$none;
				}
			}()
			]));
};
var author$project$Game$achievementsDict = A2(
	elm$core$Basics$composeR,
	author$project$Game$unwrap,
	function ($) {
		return $.aQ;
	});
var author$project$Game$upgradesDict = A2(
	elm$core$Basics$composeR,
	author$project$Game$unwrap,
	function ($) {
		return $.o;
	});
var author$project$Api$gameEncoder = function (game) {
	return elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'created',
				author$project$JsonUtil$posixEncoder(
					author$project$Game$created(game))),
				_Utils_Tuple2(
				'units',
				A3(
					elm$json$Json$Encode$dict,
					elm$core$Basics$identity,
					author$project$JsonUtil$decimalEncoder,
					author$project$Game$UnitsSnapshot$toDict(
						author$project$Game$units(game)))),
				_Utils_Tuple2(
				'upgrades',
				A3(
					elm$json$Json$Encode$dict,
					elm$core$Basics$identity,
					author$project$JsonUtil$decimalEncoder,
					author$project$Game$upgradesDict(game))),
				_Utils_Tuple2(
				'statistics',
				author$project$Game$Statistics$encoder(
					author$project$Game$statistics(game))),
				_Utils_Tuple2(
				'achievements',
				author$project$Game$Achievement$encoder(
					author$project$Game$achievementsDict(game)))
			]));
};
var author$project$Api$Buy = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var author$project$Api$Get = {$: 0};
var author$project$Api$Nav = function (a) {
	return {$: 3, a: a};
};
var author$project$Api$Reset = {$: 4};
var author$project$Api$Undo = {$: 2};
var author$project$Api$requestDecoder = function () {
	var bodyDecoder = function (name) {
		return A2(
			elm$json$Json$Decode$field,
			'args',
			function () {
				switch (name) {
					case 'get':
						return elm$json$Json$Decode$succeed(author$project$Api$Get);
					case 'undo':
						return elm$json$Json$Decode$succeed(author$project$Api$Undo);
					case 'reset':
						return elm$json$Json$Decode$succeed(author$project$Api$Reset);
					case 'nav':
						return A2(
							elm$json$Json$Decode$map,
							author$project$Api$Nav,
							A2(elm$json$Json$Decode$field, 'path', elm$json$Json$Decode$string));
					case 'buy':
						return A3(
							elm$json$Json$Decode$map2,
							author$project$Api$Buy,
							A2(elm$json$Json$Decode$field, 'item', elm$json$Json$Decode$string),
							A2(
								elm$json$Json$Decode$field,
								'count',
								elm$json$Json$Decode$oneOf(
									_List_fromArray(
										[
											elm$json$Json$Decode$string,
											A2(elm$json$Json$Decode$map, elm$core$String$fromFloat, elm$json$Json$Decode$float)
										]))));
					default:
						return elm$json$Json$Decode$fail('no such api function: ' + name);
				}
			}());
	};
	return A2(
		elm$json$Json$Decode$andThen,
		bodyDecoder,
		A2(elm$json$Json$Decode$field, 'name', elm$json$Json$Decode$string));
}();
var author$project$Api$call = F3(
	function (requestId, req, session0) {
		var _n0 = author$project$Session$game(session0);
		if (_n0.$ === 3) {
			var game0 = _n0.a;
			var now = A2(author$project$Session$safeNow, game0, session0);
			var res = A2(
				elm$core$Basics$composeR,
				elm$core$Basics$append(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'requestId',
							elm$json$Json$Encode$string(requestId)),
							_Utils_Tuple2(
							'timestamp',
							author$project$JsonUtil$posixEncoder(now))
						])),
				elm$json$Json$Encode$object);
			var _n1 = A2(elm$json$Json$Decode$decodeValue, author$project$Api$requestDecoder, req);
			if (_n1.$ === 1) {
				var err = _n1.a;
				return elm$core$Result$Err(
					'swarmApi couldn\'t decode call: ' + elm$json$Json$Decode$errorToString(err));
			} else {
				var msg = _n1.a;
				switch (msg.$) {
					case 0:
						return elm$core$Result$Ok(
							_Utils_Tuple3(
								session0,
								elm$core$Platform$Cmd$none,
								res(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'game',
											author$project$Api$gameEncoder(
												A2(author$project$Game$snapshotUnits, now, game0)))
										]))));
					case 1:
						var itemName = msg.a;
						var count = msg.b;
						var _n3 = A2(
							author$project$GameData$itemByName,
							itemName,
							author$project$Game$gameData(game0));
						if (_n3.$ === 1) {
							return elm$core$Result$Err('no such item: ' + itemName);
						} else {
							var item = _n3.a;
							var game = A2(author$project$Game$snapshotUnits, now, game0);
							return A2(
								elm$core$Result$map,
								function (_n4) {
									var g = _n4.a;
									var cmd = _n4.b;
									return _Utils_Tuple3(
										A3(author$project$Session$setGame, true, g, session0),
										cmd,
										res(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'game',
													author$project$Api$gameEncoder(g))
												])));
								},
								A2(
									elm$core$Result$map,
									author$project$Session$persistWrite(session0),
									A2(
										elm$core$Result$andThen,
										function (o) {
											return A2(author$project$Game$BuyOrder$buy, o, game);
										},
										A3(
											author$project$Game$Order$fromBuyN,
											A3(author$project$Game$setBuyN, item, count, game),
											author$project$Game$units(game),
											item))));
						}
					case 2:
						var _n5 = author$project$Session$undo(session0);
						var session = _n5.a;
						var cmd = _n5.b;
						var response = function () {
							var _n6 = author$project$Session$game(session);
							if (_n6.$ === 3) {
								var g = _n6.a;
								return _List_fromArray(
									[
										_Utils_Tuple2(
										'game',
										author$project$Api$gameEncoder(g))
									]);
							} else {
								return _List_Nil;
							}
						}();
						return elm$core$Result$Ok(
							_Utils_Tuple3(
								session,
								cmd,
								res(response)));
					case 4:
						return A2(
							elm$core$Result$map,
							function (session) {
								return _Utils_Tuple3(
									session,
									elm$core$Platform$Cmd$none,
									res(_List_Nil));
							},
							author$project$Session$resetGame(session0));
					default:
						var path = msg.a;
						return elm$core$Result$Ok(
							_Utils_Tuple3(
								session0,
								A2(
									elm$browser$Browser$Navigation$pushUrl,
									author$project$Session$nav(session0),
									path),
								res(_List_Nil)));
				}
			}
		} else {
			return elm$core$Result$Err('game still loading. Try again in a moment.');
		}
	});
var author$project$Api$requestIdDecoder = A2(elm$json$Json$Decode$field, 'requestId', elm$json$Json$Decode$string);
var author$project$Ports$apiResponse = _Platform_outgoingPort('apiResponse', elm$core$Basics$identity);
var author$project$Api$update = F2(
	function (req, session0) {
		var _n0 = A2(elm$json$Json$Decode$decodeValue, author$project$Api$requestIdDecoder, req);
		if (_n0.$ === 1) {
			var err = _n0.a;
			return _Utils_Tuple2(
				A2(
					author$project$Session$pushError,
					'swarmApi couldn\'t decode requestId: ' + elm$json$Json$Decode$errorToString(err),
					session0),
				elm$core$Platform$Cmd$none);
		} else {
			var requestId = _n0.a;
			var _n1 = A3(author$project$Api$call, requestId, req, session0);
			if (_n1.$ === 1) {
				var err = _n1.a;
				return _Utils_Tuple2(
					session0,
					author$project$Ports$apiResponse(
						elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'requestId',
									elm$json$Json$Encode$string(requestId)),
									_Utils_Tuple2(
									'error',
									elm$json$Json$Encode$string(err))
								]))));
			} else {
				var _n2 = _n1.a;
				var session1 = _n2.a;
				var cmd1 = _n2.b;
				var res = _n2.c;
				var _n3 = A2(author$project$Session$grantAchievement, 'bot-api', session1);
				var session2 = _n3.a;
				var cmd2 = _n3.b;
				return _Utils_Tuple2(
					session2,
					elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								cmd1,
								cmd2,
								author$project$Ports$apiResponse(res)
							])));
			}
		}
	});
var author$project$Main$GotAchievementsMsg = function (a) {
	return {$: 33, a: a};
};
var author$project$Main$GotChangelogMsg = function (a) {
	return {$: 36, a: a};
};
var author$project$Main$GotErrorViewMsg = function (a) {
	return {$: 25, a: a};
};
var author$project$Main$GotHeaderMsg = function (a) {
	return {$: 23, a: a};
};
var author$project$Main$GotMoreMenuMsg = function (a) {
	return {$: 43, a: a};
};
var author$project$Main$GotOfflineSyncMsg = function (a) {
	return {$: 24, a: a};
};
var author$project$Main$GotStatisticsMsg = function (a) {
	return {$: 35, a: a};
};
var author$project$Main$GotUserMsg = function (a) {
	return {$: 37, a: a};
};
var author$project$Main$WrotePlayFabState = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var author$project$Page$Spell$visibleOrders = function (_n0) {
	var tabName = _n0.a;
	var spellName = _n0.b;
	var session = _n0.c;
	var _n1 = author$project$Session$game(session);
	if (_n1.$ === 3) {
		var game = _n1.a;
		var snapshot = A2(author$project$Session$safeUnits, game, session);
		var _n2 = A3(author$project$Select$spellBySlug, spellName, game, snapshot);
		if (!_n2.$) {
			var spell = _n2.a;
			var items = _List_fromArray(
				[
					author$project$GameData$Item$Spell(spell)
				]);
			return A2(
				elm$core$List$filterMap,
				A2(
					elm$core$Basics$composeR,
					A2(author$project$Game$Order$fromBuyN, game, snapshot),
					elm$core$Result$toMaybe),
				items);
		} else {
			return _List_Nil;
		}
	} else {
		return _List_Nil;
	}
};
var author$project$GameData$upgradesByUnitId = function (id) {
	return A2(
		elm$core$Basics$composeR,
		author$project$GameData$indexes,
		A2(
			elm$core$Basics$composeR,
			function ($) {
				return $.cP;
			},
			A2(
				elm$core$Basics$composeR,
				elm$core$Dict$get(
					author$project$GameData$Unit$idToString(id)),
				elm$core$Maybe$withDefault(_List_Nil))));
};
var author$project$Game$UnitsSnapshot$isUpgradeVisible = function (id) {
	return A2(
		elm$core$Basics$composeR,
		author$project$Game$UnitsSnapshot$visibleNames,
		elm$core$Set$member(
			author$project$GameData$Upgrade$idToString(id)));
};
var author$project$Select$isUpgradeIdVisible = F2(
	function (snapshot, id) {
		return A2(author$project$Game$UnitsSnapshot$isUpgradeVisible, id, snapshot);
	});
var author$project$Select$isUpgradeVisible = F2(
	function (snapshot, u) {
		return A2(author$project$Select$isUpgradeIdVisible, snapshot, u.eL);
	});
var author$project$Select$upgradesByUnitId = F3(
	function (id, game, snapshot) {
		return A2(
			elm$core$List$filter,
			author$project$Select$isUpgradeVisible(snapshot),
			A2(
				author$project$GameData$upgradesByUnitId,
				id,
				author$project$Game$gameData(game)));
	});
var author$project$Page$Unit$visibleOrders = function (_n0) {
	var tabName = _n0.a;
	var unitName = _n0.b;
	var ns = _n0.c;
	var session = _n0.d;
	var _n1 = author$project$Session$game(session);
	if (_n1.$ === 3) {
		var game0 = _n1.a;
		var snapshot = A2(author$project$Session$safeUnits, game0, session);
		var _n2 = A3(author$project$Select$unitBySlug, unitName, game0, snapshot);
		if (!_n2.$) {
			var _n3 = _n2.a;
			var unit = _n3.a;
			var game = function () {
				var _n4 = ns.dz;
				if (_n4.$ === 1) {
					return game0;
				} else {
					var buyN = _n4.a;
					return A3(
						author$project$Game$setBuyN,
						author$project$GameData$Item$Unit(unit),
						buyN,
						game0);
				}
			}();
			var upgrades = A3(author$project$Select$upgradesByUnitId, unit.eL, game, snapshot);
			var items = A2(
				elm$core$List$cons,
				author$project$GameData$Item$Unit(unit),
				A2(elm$core$List$map, author$project$GameData$Item$Upgrade, upgrades));
			return A2(
				elm$core$List$filterMap,
				A2(
					elm$core$Basics$composeR,
					A2(author$project$Game$Order$fromBuyN, game, snapshot),
					elm$core$Result$toMaybe),
				items);
		} else {
			return _List_Nil;
		}
	} else {
		return _List_Nil;
	}
};
var author$project$Main$evalUnitsOrders = function (model) {
	return elm$core$Maybe$Just(
		function () {
			switch (model.$) {
				case 4:
					var m = model.a;
					return author$project$Page$Unit$visibleOrders(m);
				case 5:
					var m = model.a;
					return author$project$Page$Spell$visibleOrders(m);
				default:
					return _List_Nil;
			}
		}());
};
var author$project$Main$mapSession = F2(
	function (map, model) {
		return A2(
			author$project$Main$updateSession,
			map(
				author$project$Main$toSession(model)),
			model);
	});
var author$project$Game$mapAchievementsShown = F2(
	function (fn, _n0) {
		var g = _n0;
		return _Utils_update(
			g,
			{
				Y: fn(g.Y)
			});
	});
var author$project$Session$mapGame = F3(
	function (undoable, fn, session) {
		var _n0 = author$project$Session$game(session);
		if (_n0.$ === 3) {
			var g = _n0.a;
			return A3(
				author$project$Session$setGame,
				undoable,
				fn(g),
				session);
		} else {
			return session;
		}
	});
var author$project$Page$Achievements$mapAchievementsShown = F2(
	function (fn, session) {
		return _Utils_Tuple2(
			A3(
				author$project$Session$mapGame,
				false,
				author$project$Game$mapAchievementsShown(fn),
				session),
			elm$core$Platform$Cmd$none);
	});
var author$project$Page$Achievements$update = F2(
	function (msg, session) {
		switch (msg.$) {
			case 0:
				var submsg = msg.a;
				return A2(author$project$View$TabNav$update, submsg, session);
			case 1:
				var achievement = msg.a;
				var _n1 = author$project$GameData$Achievement$name(achievement);
				if (_n1 === 'clickme') {
					return A2(author$project$Session$grantAchievement, 'clickme', session);
				} else {
					return _Utils_Tuple2(session, elm$core$Platform$Cmd$none);
				}
			case 2:
				return A2(
					author$project$Page$Achievements$mapAchievementsShown,
					function (s) {
						return _Utils_update(
							s,
							{bU: !s.bU});
					},
					session);
			case 3:
				return A2(
					author$project$Page$Achievements$mapAchievementsShown,
					function (s) {
						return _Utils_update(
							s,
							{cK: !s.cK});
					},
					session);
			case 4:
				return A2(
					author$project$Page$Achievements$mapAchievementsShown,
					function (s) {
						return _Utils_update(
							s,
							{ca: !s.ca});
					},
					session);
			case 5:
				var order = msg.a;
				return A2(
					author$project$Page$Achievements$mapAchievementsShown,
					function (s) {
						return _Utils_update(
							s,
							{co: order});
					},
					session);
			default:
				return A2(
					author$project$Page$Achievements$mapAchievementsShown,
					function (s) {
						return _Utils_update(
							s,
							{cw: !s.cw});
					},
					session);
		}
	});
var author$project$Page$Changelog$update = F2(
	function (msg, session) {
		var submsg = msg;
		return A2(author$project$View$TabNav$update, submsg, session);
	});
var author$project$Page$Statistics$update = F2(
	function (msg, session) {
		var submsg = msg;
		return A2(author$project$View$TabNav$update, submsg, session);
	});
var author$project$Page$User$LogoutResponse = function (a) {
	return {$: 2, a: a};
};
var author$project$Page$User$ManualPlayFabWriteResponse = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var author$project$PlayFab$clearRememberId = F3(
	function (id, user, toMsg) {
		var _n0 = author$project$PlayFab$User$rememberId(user);
		if (_n0.$ === 1) {
			return elm$core$Platform$Cmd$none;
		} else {
			var rid = _n0.a;
			return elm$http$Http$request(
				{
					cZ: elm$http$Http$jsonBody(
						elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'TitleId',
									author$project$PlayFab$TitleId$encode(id)),
									_Utils_Tuple2(
									'CustomId',
									elm$json$Json$Encode$string(
										author$project$PlayFab$User$rememberIdToFullString(rid)))
								]))),
					z: A2(
						author$project$PlayFab$expectJson,
						toMsg,
						elm$json$Json$Decode$succeed(
							A2(author$project$PlayFab$User$setRememberId, elm$core$Maybe$Nothing, user))),
					as: _List_fromArray(
						[
							A2(
							elm$http$Http$header,
							'X-Authentication',
							author$project$PlayFab$User$ticketToString(
								author$project$PlayFab$User$sessionTicket(user)))
						]),
					aw: 'POST',
					aH: elm$core$Maybe$Nothing,
					aJ: elm$core$Maybe$Nothing,
					B: author$project$PlayFab$TitleId$host(id) + '/Client/UnlinkCustomId'
				});
		}
	});
var author$project$PlayFab$ChunkedState$encoderSuffix = function (i) {
	return (!i) ? '' : elm$core$String$fromInt(i);
};
var elm_community$string_extra$String$Extra$breaker = F3(
	function (width, string, acc) {
		breaker:
		while (true) {
			if (string === '') {
				return elm$core$List$reverse(acc);
			} else {
				var $temp$width = width,
					$temp$string = A2(elm$core$String$dropLeft, width, string),
					$temp$acc = A2(
					elm$core$List$cons,
					A3(elm$core$String$slice, 0, width, string),
					acc);
				width = $temp$width;
				string = $temp$string;
				acc = $temp$acc;
				continue breaker;
			}
		}
	});
var elm_community$string_extra$String$Extra$break = F2(
	function (width, string) {
		return ((!width) || (string === '')) ? _List_fromArray(
			[string]) : A3(elm_community$string_extra$String$Extra$breaker, width, string, _List_Nil);
	});
var author$project$PlayFab$ChunkedState$encoder = function (_n0) {
	var prefix = _n0.fi;
	var size = _n0.fC;
	return A2(
		elm$core$Basics$composeR,
		elm_community$string_extra$String$Extra$break(size),
		A2(
			elm$core$Basics$composeR,
			elm$core$List$indexedMap(
				F2(
					function (i, chunk) {
						return _Utils_Tuple2(
							_Utils_ap(
								prefix,
								author$project$PlayFab$ChunkedState$encoderSuffix(i)),
							elm$json$Json$Encode$string(chunk));
					})),
			elm$json$Json$Encode$object));
};
var author$project$PlayFab$ChunkedState$encoderNextKey_ = F2(
	function (_n0, value) {
		var prefix = _n0.fi;
		var size = _n0.fC;
		var numChunks = A2(
			elm$core$Basics$max,
			1,
			elm$core$Basics$ceiling(
				elm$core$String$length(value) / size));
		return _Utils_ap(
			prefix,
			elm$core$String$fromInt(numChunks));
	});
var author$project$PlayFab$ChunkedState$encoderNextKey = F2(
	function (config, value) {
		return _Utils_Tuple2(
			A2(author$project$PlayFab$ChunkedState$encoder, config, value),
			A2(author$project$PlayFab$ChunkedState$encoderNextKey_, config, value));
	});
var author$project$PlayFab$writeState_ = F4(
	function (id, ticket, mstate, toMsg) {
		return elm$http$Http$request(
			{
				cZ: elm$http$Http$jsonBody(
					elm$json$Json$Encode$object(
						function () {
							if (!mstate.$) {
								var state = mstate.a;
								var _n1 = A2(
									author$project$PlayFab$ChunkedState$encoderNextKey,
									{fi: author$project$PlayFab$User$stateKey, fC: 10000},
									state);
								var data = _n1.a;
								var nextKey = _n1.b;
								return _List_fromArray(
									[
										_Utils_Tuple2('Data', data),
										_Utils_Tuple2(
										'KeysToRemove',
										A2(
											elm$json$Json$Encode$list,
											elm$json$Json$Encode$string,
											_List_fromArray(
												[nextKey])))
									]);
							} else {
								return _List_fromArray(
									[
										_Utils_Tuple2(
										'KeysToRemove',
										A2(
											elm$json$Json$Encode$list,
											elm$json$Json$Encode$string,
											_List_fromArray(
												[author$project$PlayFab$User$stateKey])))
									]);
							}
						}())),
				z: A2(
					author$project$PlayFab$expectJson,
					toMsg,
					elm$json$Json$Decode$succeed(0)),
				as: _List_fromArray(
					[
						A2(
						elm$http$Http$header,
						'X-Authentication',
						author$project$PlayFab$User$ticketToString(ticket))
					]),
				aw: 'POST',
				aH: elm$core$Maybe$Nothing,
				aJ: elm$core$Maybe$Nothing,
				B: author$project$PlayFab$TitleId$host(id) + '/Client/UpdateUserData'
			});
	});
var author$project$PlayFab$writeState = function (session) {
	var _n0 = author$project$Session$user(session);
	if ((_n0.$ === 3) && (!_n0.a.$)) {
		var user = _n0.a.a;
		return A2(
			author$project$PlayFab$writeState_,
			author$project$PlayFab$TitleId$fromSession(session),
			author$project$PlayFab$User$sessionTicket(user));
	} else {
		return F2(
			function (_n1, _n2) {
				return elm$core$Platform$Cmd$none;
			});
	}
};
var author$project$Session$logout = function (session) {
	return _Utils_Tuple2(
		A2(
			author$project$Session$setUser,
			krisajenkins$remotedata$RemoteData$Success(elm$core$Maybe$Nothing),
			session),
		elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					author$project$Ports$writeUserSessionTicket(elm$core$Maybe$Nothing),
					author$project$Ports$writeUserRememberId(elm$core$Maybe$Nothing)
				])));
};
var author$project$Session$offlineSync = A2(
	elm$core$Basics$composeR,
	author$project$Session$unwrap,
	A2(
		elm$core$Basics$composeR,
		function ($) {
			return $.cQ;
		},
		krisajenkins$remotedata$RemoteData$map(
			elm$core$Maybe$map(
				function ($) {
					return $.fL;
				}))));
var author$project$Session$persistExport = A2(
	elm$core$Basics$composeR,
	author$project$Session$unwrap,
	function ($) {
		return $.ak;
	});
var author$project$Session$pushWarning = F2(
	function (_n0, session) {
		return session;
	});
var author$project$Cooldown$Until = function (a) {
	return {$: 1, a: a};
};
var author$project$Cooldown$tick = F2(
	function (now, status) {
		if (status.$ === 1) {
			var until_ = status.a;
			return (_Utils_cmp(
				elm$time$Time$posixToMillis(now),
				elm$time$Time$posixToMillis(until_)) > -1) ? author$project$Cooldown$Ready : status;
		} else {
			return status;
		}
	});
var author$project$Duration$addPosix = F2(
	function (duration, now) {
		return elm$time$Time$millisToPosix(
			author$project$Duration$toMillis(duration) + elm$time$Time$posixToMillis(now));
	});
var author$project$Cooldown$trigger = F3(
	function (now, duration, cooldown) {
		var _n0 = A2(author$project$Cooldown$tick, now, cooldown);
		if (!_n0.$) {
			return elm$core$Maybe$Just(
				author$project$Cooldown$Until(
					A2(author$project$Duration$addPosix, duration, now)));
		} else {
			var until = _n0.a;
			return elm$core$Maybe$Nothing;
		}
	});
var author$project$Session$filterMapUserSync = F2(
	function (mapSync, session) {
		var s = session;
		var _n0 = s.cQ;
		if ((_n0.$ === 3) && (!_n0.a.$)) {
			var ustate0 = _n0.a.a;
			var _n1 = A2(elm$core$Result$map, mapSync, ustate0.fL);
			if ((!_n1.$) && (!_n1.a.$)) {
				var sync = _n1.a.a;
				return elm$core$Maybe$Just(
					_Utils_update(
						s,
						{
							cQ: krisajenkins$remotedata$RemoteData$Success(
								elm$core$Maybe$Just(
									_Utils_update(
										ustate0,
										{
											fL: elm$core$Result$Ok(sync)
										})))
						}));
			} else {
				return elm$core$Maybe$Nothing;
			}
		} else {
			return elm$core$Maybe$Nothing;
		}
	});
var author$project$Session$userSyncCooldownDuration = author$project$Duration$fromSecs(120);
var author$project$Session$userSyncRequest = F2(
	function (_n0, session) {
		var ignoreCooldown = _n0.eN;
		var _n1 = author$project$Session$now(session);
		if (_n1.$ === 1) {
			return elm$core$Maybe$Nothing;
		} else {
			var now_ = _n1.a;
			var req = F2(
				function (sync, cooldown) {
					return _Utils_update(
						sync,
						{
							_: cooldown,
							dO: krisajenkins$remotedata$RemoteData$Loading,
							dP: elm$core$Maybe$Just(now_)
						});
				});
			return A2(
				author$project$Session$filterMapUserSync,
				function (sync) {
					return ignoreCooldown ? elm$core$Maybe$Just(
						A2(
							req,
							sync,
							author$project$Cooldown$Until(
								A2(author$project$Duration$addPosix, author$project$Session$userSyncCooldownDuration, now_)))) : A2(
						elm$core$Maybe$map,
						req(sync),
						A3(author$project$Cooldown$trigger, now_, author$project$Session$userSyncCooldownDuration, sync._));
				},
				session);
		}
	});
var author$project$Session$mapUserSync = F2(
	function (mapSync, session) {
		return A2(
			elm$core$Maybe$withDefault,
			session,
			A2(
				author$project$Session$filterMapUserSync,
				A2(elm$core$Basics$composeR, mapSync, elm$core$Maybe$Just),
				session));
	});
var author$project$Session$userSyncResponse = F3(
	function (now_, res, session) {
		if (!res.$) {
			return _Utils_Tuple2(
				A2(
					author$project$Session$mapUserSync,
					function (sync) {
						return _Utils_update(
							sync,
							{
								dO: krisajenkins$remotedata$RemoteData$Success(0),
								d_: now_
							});
					},
					session),
				elm$core$Platform$Cmd$none);
		} else {
			if (res.a.$ === 1) {
				var err = res.a;
				return _Utils_Tuple2(
					A2(
						author$project$Session$setUser,
						krisajenkins$remotedata$RemoteData$Failure(err),
						A2(
							author$project$Session$mapUserSync,
							function (sync) {
								return _Utils_update(
									sync,
									{
										dO: krisajenkins$remotedata$RemoteData$Failure(
											author$project$PlayFab$Error$toString(err))
									});
							},
							session)),
					author$project$Ports$writeUserSessionTicket(elm$core$Maybe$Nothing));
			} else {
				var err = res.a;
				return _Utils_Tuple2(
					A2(
						author$project$Session$mapUserSync,
						function (sync) {
							return _Utils_update(
								sync,
								{
									dO: krisajenkins$remotedata$RemoteData$Failure(
										author$project$PlayFab$Error$toString(err))
								});
						},
						session),
					elm$core$Platform$Cmd$none);
			}
		}
	});
var author$project$Page$User$update = F2(
	function (msg, session) {
		switch (msg.$) {
			case 0:
				var submsg = msg.a;
				return A2(author$project$View$TabNav$update, submsg, session);
			case 1:
				var _n1 = author$project$Session$logout(session);
				var s = _n1.a;
				var cmd1 = _n1.b;
				return _Utils_Tuple2(
					s,
					function () {
						var _n2 = author$project$Session$user(session);
						if ((_n2.$ === 3) && (!_n2.a.$)) {
							var user = _n2.a.a;
							return elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										cmd1,
										A3(
										author$project$PlayFab$clearRememberId,
										author$project$PlayFab$TitleId$fromSession(session),
										user,
										author$project$Page$User$LogoutResponse)
									]));
						} else {
							return cmd1;
						}
					}());
			case 2:
				if (!msg.a.$) {
					var user = msg.a.a;
					return _Utils_Tuple2(
						A2(author$project$Session$setRawUser, user, session),
						elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						A2(
							author$project$Session$pushWarning,
							'LogoutResponse: ' + author$project$PlayFab$Error$toString(err),
							session),
						elm$core$Platform$Cmd$none);
				}
			case 3:
				var _n3 = author$project$Session$offlineSync(session);
				if (((_n3.$ === 3) && (!_n3.a.$)) && (!_n3.a.a.$)) {
					return _Utils_Tuple2(
						A2(
							elm$core$Maybe$withDefault,
							session,
							A2(
								author$project$Session$userSyncRequest,
								{eN: true},
								session)),
						A3(
							author$project$PlayFab$writeState,
							session,
							author$project$Session$persistExport(session),
							author$project$Page$User$ManualPlayFabWriteResponse(
								author$project$Session$now(session))));
				} else {
					return _Utils_Tuple2(session, elm$core$Platform$Cmd$none);
				}
			default:
				var now = msg.a;
				var res = msg.b;
				return A3(author$project$Session$userSyncResponse, now, res, session);
		}
	});
var author$project$Persist$exportDecoder = function () {
	var builder = function (status) {
		switch (status) {
			case 'empty':
				return elm$json$Json$Decode$succeed(elm$core$Maybe$Nothing);
			case 'success':
				return A2(
					elm$json$Json$Decode$map,
					elm$core$Maybe$Just,
					A2(elm$json$Json$Decode$field, 'value', elm$json$Json$Decode$string));
			default:
				return elm$json$Json$Decode$fail('persistRead javascript unknown-status: ' + status);
		}
	};
	return A2(
		elm$json$Json$Decode$andThen,
		builder,
		A2(elm$json$Json$Decode$field, 'status', elm$json$Json$Decode$string));
}();
var author$project$PlayFab$rememberIdLogin = F3(
	function (id, rememberId, toMsg) {
		return elm$http$Http$post(
			{
				cZ: elm$http$Http$jsonBody(
					elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'TitleId',
								author$project$PlayFab$TitleId$encode(id)),
								_Utils_Tuple2(
								'CustomId',
								elm$json$Json$Encode$string(
									author$project$PlayFab$User$rememberIdToFullString(rememberId))),
								_Utils_Tuple2('InfoRequestParameters', author$project$PlayFab$infoRequestParameters),
								_Utils_Tuple2(
								'CreateAccount',
								elm$json$Json$Encode$bool(false))
							]))),
				z: A2(
					author$project$PlayFab$expectJson,
					toMsg,
					author$project$PlayFab$User$decoder(author$project$PlayFab$userDecoderConfig)),
				B: author$project$PlayFab$TitleId$host(id) + '/Client/LoginWithCustomId'
			});
	});
var author$project$PlayFab$refreshAuth = F2(
	function (session, toMsg) {
		var titleId = author$project$PlayFab$TitleId$fromSession(session);
		var _n0 = author$project$Session$iframe(session);
		if (!_n0.$) {
			var _n1 = author$project$Session$user(session);
			if ((_n1.$ === 3) && (!_n1.a.$)) {
				var user = _n1.a.a;
				var _n2 = author$project$PlayFab$User$rememberId(user);
				if (!_n2.$) {
					var rid = _n2.a;
					return A3(author$project$PlayFab$rememberIdLogin, titleId, rid, toMsg);
				} else {
					return elm$core$Platform$Cmd$none;
				}
			} else {
				return elm$core$Platform$Cmd$none;
			}
		} else {
			var kong = _n0.a;
			var _n3 = kong.cQ;
			if (_n3.$ === 1) {
				return elm$core$Platform$Cmd$none;
			} else {
				var user = _n3.a;
				return user.eV ? elm$core$Platform$Cmd$none : A4(author$project$PlayFab$kongregateLogin, titleId, user.bH, user.dk, toMsg);
			}
		}
	});
var author$project$PlayFab$userFromTicket = F3(
	function (id, ticket, toMsg) {
		return elm$http$Http$request(
			{
				cZ: elm$http$Http$jsonBody(
					elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2('InfoRequestParameters', author$project$PlayFab$infoRequestParameters)
							]))),
				z: A2(
					author$project$PlayFab$expectJson,
					toMsg,
					author$project$PlayFab$User$decoder(
						_Utils_update(
							author$project$PlayFab$userDecoderConfig,
							{
								fQ: elm$core$Maybe$Just(ticket)
							}))),
				as: _List_fromArray(
					[
						A2(
						elm$http$Http$header,
						'X-Authentication',
						author$project$PlayFab$User$ticketToString(ticket))
					]),
				aw: 'POST',
				aH: elm$core$Maybe$Nothing,
				aJ: elm$core$Maybe$Nothing,
				B: author$project$PlayFab$TitleId$host(id) + '/Client/GetPlayerCombinedInfo'
			});
	});
var author$project$PlayFab$TitleId$toString = author$project$PlayFab$TitleId$host;
var author$project$PlayFab$User$gameDecoder = F2(
	function (gd, now) {
		var builder = function (status) {
			switch (status) {
				case 'empty':
					return elm$json$Json$Decode$fail('decoded empty user.game, but that should\'ve been dealt with earlier');
				case 'success':
					return A3(
						elm$json$Json$Decode$map2,
						elm$core$Tuple$pair,
						A2(
							elm$json$Json$Decode$field,
							'userId',
							A2(elm$json$Json$Decode$map, elm$core$Basics$identity, elm$json$Json$Decode$string)),
						A2(
							elm$json$Json$Decode$field,
							'value',
							A2(author$project$Game$decoder, gd, now)));
				case 'error':
					return elm$json$Json$Decode$fail('user.game javascript error');
				default:
					return elm$json$Json$Decode$fail('persistRead javascript unknown-status: ' + status);
			}
		};
		return A2(
			elm$json$Json$Decode$andThen,
			builder,
			A2(elm$json$Json$Decode$field, 'status', elm$json$Json$Decode$string));
	});
var author$project$PlayFab$User$id = A2(
	elm$core$Basics$composeR,
	author$project$PlayFab$User$unwrap,
	function ($) {
		return $.eL;
	});
var author$project$PlayFab$User$setGame = F2(
	function (mgame, _n0) {
		var u = _n0;
		var _n1 = u.ae;
		if ((!_n1.$) && (_n1.a.a.$ === 1)) {
			var _n2 = _n1.a;
			var _n3 = _n2.a;
			var encoded = _n2.b;
			if (mgame.$ === 1) {
				var err = mgame.a;
				return _Utils_update(
					u,
					{
						ae: elm$core$Maybe$Just(
							_Utils_Tuple2(
								krisajenkins$remotedata$RemoteData$Failure(err),
								encoded))
					});
			} else {
				var game_ = mgame.a;
				return _Utils_update(
					u,
					{
						ae: elm$core$Maybe$Just(
							_Utils_Tuple2(
								krisajenkins$remotedata$RemoteData$Success(game_),
								encoded))
					});
			}
		} else {
			return u;
		}
	});
var author$project$Ports$onUnloadWrite = _Platform_outgoingPort(
	'onUnloadWrite',
	function ($) {
		return elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'game',
					elm$core$Basics$identity($.ae)),
					_Utils_Tuple2(
					'playfabUrl',
					elm$json$Json$Encode$string($.ff))
				]));
	});
var author$project$Session$clearWelcomeBack = function (_n0) {
	var s = _n0;
	return _Utils_update(
		s,
		{a9: elm$core$Maybe$Nothing});
};
var author$project$Session$initTime = F3(
	function (loaded_, timezone_, _n0) {
		var session = _n0;
		return _Utils_update(
			session,
			{
				aW: A2(
					elm_community$maybe_extra$Maybe$Extra$or,
					session.aW,
					elm$core$Maybe$Just(loaded_)),
				cm: elm$core$Maybe$Just(loaded_),
				a4: A2(
					elm_community$maybe_extra$Maybe$Extra$or,
					session.a4,
					elm$core$Maybe$Just(timezone_))
			});
	});
var author$project$Session$mapIframe = F2(
	function (map, _n0) {
		var s = _n0;
		return _Utils_update(
			s,
			{
				ag: map(s.ag)
			});
	});
var author$project$FrameRate$Nonempty = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var author$project$FrameRate$window = 200;
var elm$core$List$takeReverse = F3(
	function (n, list, kept) {
		takeReverse:
		while (true) {
			if (n <= 0) {
				return kept;
			} else {
				if (!list.b) {
					return kept;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs,
						$temp$kept = A2(elm$core$List$cons, x, kept);
					n = $temp$n;
					list = $temp$list;
					kept = $temp$kept;
					continue takeReverse;
				}
			}
		}
	});
var elm$core$List$takeTailRec = F2(
	function (n, list) {
		return elm$core$List$reverse(
			A3(elm$core$List$takeReverse, n, list, _List_Nil));
	});
var elm$core$List$takeFast = F3(
	function (ctr, n, list) {
		if (n <= 0) {
			return _List_Nil;
		} else {
			var _n0 = _Utils_Tuple2(n, list);
			_n0$1:
			while (true) {
				_n0$5:
				while (true) {
					if (!_n0.b.b) {
						return list;
					} else {
						if (_n0.b.b.b) {
							switch (_n0.a) {
								case 1:
									break _n0$1;
								case 2:
									var _n2 = _n0.b;
									var x = _n2.a;
									var _n3 = _n2.b;
									var y = _n3.a;
									return _List_fromArray(
										[x, y]);
								case 3:
									if (_n0.b.b.b.b) {
										var _n4 = _n0.b;
										var x = _n4.a;
										var _n5 = _n4.b;
										var y = _n5.a;
										var _n6 = _n5.b;
										var z = _n6.a;
										return _List_fromArray(
											[x, y, z]);
									} else {
										break _n0$5;
									}
								default:
									if (_n0.b.b.b.b && _n0.b.b.b.b.b) {
										var _n7 = _n0.b;
										var x = _n7.a;
										var _n8 = _n7.b;
										var y = _n8.a;
										var _n9 = _n8.b;
										var z = _n9.a;
										var _n10 = _n9.b;
										var w = _n10.a;
										var tl = _n10.b;
										return (ctr > 1000) ? A2(
											elm$core$List$cons,
											x,
											A2(
												elm$core$List$cons,
												y,
												A2(
													elm$core$List$cons,
													z,
													A2(
														elm$core$List$cons,
														w,
														A2(elm$core$List$takeTailRec, n - 4, tl))))) : A2(
											elm$core$List$cons,
											x,
											A2(
												elm$core$List$cons,
												y,
												A2(
													elm$core$List$cons,
													z,
													A2(
														elm$core$List$cons,
														w,
														A3(elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
									} else {
										break _n0$5;
									}
							}
						} else {
							if (_n0.a === 1) {
								break _n0$1;
							} else {
								break _n0$5;
							}
						}
					}
				}
				return list;
			}
			var _n1 = _n0.b;
			var x = _n1.a;
			return _List_fromArray(
				[x]);
		}
	});
var elm$core$List$take = F2(
	function (n, list) {
		return A3(elm$core$List$takeFast, 0, n, list);
	});
var author$project$FrameRate$push = F2(
	function (now, fr) {
		if (!fr.$) {
			return A2(author$project$FrameRate$Nonempty, now, _List_Nil);
		} else {
			var prev = fr.a;
			var frames = fr.b;
			return A2(
				author$project$FrameRate$Nonempty,
				now,
				A2(
					elm$core$List$take,
					author$project$FrameRate$window,
					A2(
						elm$core$List$cons,
						author$project$Duration$since(
							{eb: now, eh: prev}),
						frames)));
		}
	});
var author$project$Game$expireNewAchievements = F2(
	function (now, game) {
		var g = game;
		var _n0 = g.A;
		if (_n0.$ === 1) {
			return game;
		} else {
			var _n1 = _n0.a;
			var started = _n1.a;
			var first = _n1.b;
			var rest = _n1.c;
			var expires = elm$time$Time$posixToMillis(started) + 5000;
			if (_Utils_cmp(
				elm$time$Time$posixToMillis(now),
				expires) > -1) {
				if (!rest.b) {
					return _Utils_update(
						g,
						{A: elm$core$Maybe$Nothing});
				} else {
					var next = rest.a;
					var rest1 = rest.b;
					return A2(
						author$project$Game$expireNewAchievements,
						now,
						_Utils_update(
							g,
							{
								A: elm$core$Maybe$Just(
									_Utils_Tuple3(
										elm$time$Time$millisToPosix(expires),
										next,
										rest1))
							}));
				}
			} else {
				return game;
			}
		}
	});
var author$project$Session$GameLoader$map = F2(
	function (fn, loader) {
		if (loader.$ === 1) {
			var g = loader.a;
			return author$project$Session$GameLoader$Ready(
				_Utils_update(
					g,
					{
						ae: fn(g.ae)
					}));
		} else {
			return loader;
		}
	});
var author$project$Session$setNow = F3(
	function (now_, p, _n0) {
		var session = _n0;
		return function () {
			var _n1 = p.eB;
			if (!_n1.$) {
				var os = _n1.a;
				return author$project$Session$evalUnits(os);
			} else {
				return author$project$Session$clearUnits;
			}
		}()(
			_Utils_update(
				session,
				{
					ad: A2(
						elm$core$Maybe$map,
						author$project$FrameRate$push(now_),
						session.ad),
					ae: A2(
						author$project$Session$GameLoader$map,
						author$project$Game$expireNewAchievements(now_),
						session.ae),
					cm: elm$core$Maybe$Just(now_)
				}));
	});
var author$project$Session$keyCombosHelp = A2(
	elm$core$Basics$composeR,
	author$project$Session$unwrap,
	function ($) {
		return $.bm;
	});
var author$project$Session$toggleKeyCombosHelp = function (s) {
	return A2(
		author$project$Session$setKeyCombosHelp,
		!author$project$Session$keyCombosHelp(s),
		s);
};
var author$project$Session$Iframe$mapKongregate = F2(
	function (map, iframe) {
		if (iframe.$ === 1) {
			var kong = iframe.a;
			return author$project$Session$Iframe$Kongregate(
				map(kong));
		} else {
			return iframe;
		}
	});
var author$project$Session$Iframe$Kongregate$update = F2(
	function (login, _n0) {
		return {
			ed: krisajenkins$remotedata$RemoteData$Success(0),
			cQ: elm$core$Maybe$Just(
				A4(author$project$Session$Iframe$Kongregate$User, login.bH, login.fZ, login.dk, login.eV))
		};
	});
var author$project$Session$dropError = function (_n0) {
	var session = _n0;
	return _Utils_update(
		session,
		{
			ab: A2(elm$core$List$drop, 1, session.ab)
		});
};
var author$project$View$Error$update = F2(
	function (msg, session) {
		if (!msg) {
			return _Utils_Tuple2(
				author$project$Session$dropError(session),
				elm$core$Platform$Cmd$none);
		} else {
			var _n1 = _Utils_Tuple2(
				author$project$Session$gameData(session),
				author$project$Session$now(session));
			if ((!_n1.a.$) && (!_n1.b.$)) {
				var gd = _n1.a.a;
				var now = _n1.b.a;
				return _Utils_Tuple2(
					A3(
						author$project$Session$setGame,
						true,
						A2(author$project$Game$empty, gd, now),
						session),
					elm$core$Platform$Cmd$none);
			} else {
				return _Utils_Tuple2(session, elm$core$Platform$Cmd$none);
			}
		}
	});
var author$project$Game$clearNewAchievements = function (_n0) {
	var g = _n0;
	return _Utils_update(
		g,
		{A: elm$core$Maybe$Nothing});
};
var elm$browser$Browser$Navigation$reload = _Browser_reload(false);
var author$project$View$Header$update = F2(
	function (msg, session) {
		if (!msg) {
			return _Utils_Tuple2(session, elm$browser$Browser$Navigation$reload);
		} else {
			var _n1 = author$project$Session$game(session);
			if (_n1.$ === 3) {
				var game = _n1.a;
				var game1 = author$project$Game$clearNewAchievements(game);
				return _Utils_Tuple2(
					A3(author$project$Session$setGame, false, game1, session),
					elm$core$Platform$Cmd$none);
			} else {
				return _Utils_Tuple2(session, elm$core$Platform$Cmd$none);
			}
		}
	});
var author$project$View$KeyCombo$update = F2(
	function (msg, session) {
		if (!msg) {
			return A2(author$project$Session$setKeyCombosHelp, false, session);
		} else {
			return session;
		}
	});
var author$project$Session$clearOfflineSyncConflict = function (_n0) {
	var s = _n0;
	return _Utils_update(
		s,
		{
			cQ: A2(
				krisajenkins$remotedata$RemoteData$map,
				elm$core$Maybe$map(
					function (u) {
						return _Utils_update(
							u,
							{
								fL: elm$core$Result$Ok(author$project$Session$emptyUserSyncState)
							});
					}),
				s.cQ)
		});
};
var author$project$Session$offlineSyncConflict = function (session) {
	var _n0 = author$project$Session$offlineSync(session);
	if (((_n0.$ === 3) && (!_n0.a.$)) && (_n0.a.a.$ === 1)) {
		var conflict = _n0.a.a.a;
		return elm$core$Maybe$Just(conflict);
	} else {
		return elm$core$Maybe$Nothing;
	}
};
var author$project$View$OfflineSync$update = F2(
	function (msg, session) {
		var _n0 = author$project$Session$offlineSyncConflict(session);
		if (!_n0.$) {
			var conflict = _n0.a;
			var resolvedSession = author$project$Session$clearOfflineSyncConflict(session);
			switch (msg) {
				case 0:
					return _Utils_Tuple2(resolvedSession, elm$core$Platform$Cmd$none);
				case 1:
					return _Utils_Tuple2(
						A3(author$project$Session$setGame, false, conflict.cv.ae, resolvedSession),
						elm$core$Platform$Cmd$none);
				default:
					return author$project$Session$logout(resolvedSession);
			}
		} else {
			return _Utils_Tuple2(session, elm$core$Platform$Cmd$none);
		}
	});
var author$project$View$WelcomeBack$update = F2(
	function (msg, session) {
		if (!msg) {
			return author$project$Session$clearWelcomeBack(session);
		} else {
			return session;
		}
	});
var elm$browser$Browser$Navigation$load = _Browser_load;
var elm$url$Url$addPort = F2(
	function (maybePort, starter) {
		if (maybePort.$ === 1) {
			return starter;
		} else {
			var port_ = maybePort.a;
			return starter + (':' + elm$core$String$fromInt(port_));
		}
	});
var elm$url$Url$addPrefixed = F3(
	function (prefix, maybeSegment, starter) {
		if (maybeSegment.$ === 1) {
			return starter;
		} else {
			var segment = maybeSegment.a;
			return _Utils_ap(
				starter,
				_Utils_ap(prefix, segment));
		}
	});
var elm$url$Url$toString = function (url) {
	var http = function () {
		var _n0 = url.dK;
		if (!_n0) {
			return 'http://';
		} else {
			return 'https://';
		}
	}();
	return A3(
		elm$url$Url$addPrefixed,
		'#',
		url.di,
		A3(
			elm$url$Url$addPrefixed,
			'?',
			url.fn,
			_Utils_ap(
				A2(
					elm$url$Url$addPort,
					url.dF,
					_Utils_ap(http, url.$7)),
				url.aA)));
};
var author$project$Main$update = F2(
	function (msg, model0) {
		switch (msg.$) {
			case 0:
				var url = msg.a;
				return A3(
					author$project$Main$changeRouteTo,
					author$project$Route$fromUrl(url),
					author$project$Route$QueryDict$fromUrl(url),
					model0);
			case 2:
				var route = msg.a;
				return _Utils_Tuple2(
					model0,
					A3(
						author$project$Route$pushUrl,
						author$project$Session$nav(
							author$project$Main$toSession(model0)),
						author$project$Session$query(
							author$project$Main$toSession(model0)),
						route));
			case 1:
				if (!msg.a.$) {
					var url = msg.a.a;
					return _Utils_Tuple2(
						model0,
						A2(
							elm$browser$Browser$Navigation$pushUrl,
							author$project$Session$nav(
								author$project$Main$toSession(model0)),
							elm$url$Url$toString(url)));
				} else {
					var href = msg.a.a;
					return _Utils_Tuple2(
						model0,
						elm$browser$Browser$Navigation$load(href));
				}
			case 3:
				var timezone = msg.a;
				var loaded = msg.b;
				return A2(
					author$project$Main$mapSession,
					A2(author$project$Session$initTime, loaded, timezone),
					model0);
			case 4:
				var now = msg.a;
				return A2(
					author$project$Main$mapSession,
					A2(
						author$project$Session$setNow,
						now,
						{
							eB: author$project$Main$evalUnitsOrders(model0)
						}),
					model0);
			case 5:
				var json = msg.a;
				var _n1 = function () {
					var _n2 = A2(elm$json$Json$Decode$decodeValue, author$project$Persist$readDecoder, json);
					if (!_n2.$) {
						if (!_n2.a.$) {
							var _n3 = _n2.a.a;
							var r = _n3.a;
							var e = _n3.b;
							return _Utils_Tuple2(
								elm$core$Result$Ok(
									elm$core$Maybe$Just(r)),
								elm$core$Maybe$Just(e));
						} else {
							var _n4 = _n2.a;
							return _Utils_Tuple2(
								elm$core$Result$Ok(elm$core$Maybe$Nothing),
								elm$core$Maybe$Nothing);
						}
					} else {
						var err = _n2.a;
						return _Utils_Tuple2(
							elm$core$Result$Err(
								elm$json$Json$Decode$errorToString(err)),
							elm$core$Maybe$Nothing);
					}
				}();
				var read = _n1.a;
				var export_ = _n1.b;
				return A2(
					author$project$Main$mapSession,
					A2(
						elm$core$Basics$composeR,
						author$project$Session$setPersistRead(read),
						author$project$Session$setPersistExport(export_)),
					model0);
			case 6:
				var json = msg.a;
				var _n5 = A2(elm$json$Json$Decode$decodeValue, author$project$Persist$exportDecoder, json);
				if (!_n5.$) {
					var x = _n5.a;
					var _n6 = A2(
						author$project$Main$mapSession,
						author$project$Session$setPersistExport(x),
						model0);
					var model1 = _n6.a;
					var cmd1 = _n6.b;
					var _n7 = author$project$Session$offlineSync(
						author$project$Main$toSession(model1));
					if (((_n7.$ === 3) && (!_n7.a.$)) && (!_n7.a.a.$)) {
						var now = author$project$Session$now(
							author$project$Main$toSession(model1));
						var _n8 = A3(
							author$project$Main$mapSessionCmd,
							elm$core$Basics$identity,
							function (session0) {
								var _n9 = A2(
									author$project$Session$userSyncRequest,
									{eN: false},
									session0);
								if (_n9.$ === 1) {
									return _Utils_Tuple2(session0, elm$core$Platform$Cmd$none);
								} else {
									var session = _n9.a;
									return _Utils_Tuple2(
										session,
										A3(
											author$project$PlayFab$writeState,
											session,
											x,
											author$project$Main$WrotePlayFabState(now)));
								}
							},
							model1);
						var model2 = _n8.a;
						var cmd2 = _n8.b;
						return _Utils_Tuple2(
							model2,
							elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[cmd1, cmd2])));
					} else {
						return _Utils_Tuple2(model1, cmd1);
					}
				} else {
					var err = _n5.a;
					return A2(
						author$project$Main$mapSession,
						author$project$Session$pushWarning(
							elm$json$Json$Decode$errorToString(err)),
						model0);
				}
			case 11:
				var now = msg.a;
				var res = msg.b;
				return A3(
					author$project$Main$mapSessionCmd,
					elm$core$Basics$identity,
					A2(author$project$Session$userSyncResponse, now, res),
					model0);
			case 7:
				var json = msg.a;
				var _n10 = A2(elm$json$Json$Decode$decodeValue, author$project$Session$ServiceWorker$decoder, json);
				if (!_n10.$) {
					var event = _n10.a;
					return A2(
						author$project$Main$updateSession,
						A2(
							author$project$Session$setServiceWorker,
							event,
							author$project$Main$toSession(model0)),
						model0);
				} else {
					var err = _n10.a;
					return A2(
						author$project$Main$mapSession,
						author$project$Session$pushWarning(
							elm$json$Json$Decode$errorToString(err)),
						model0);
				}
			case 8:
				var ticket = msg.a;
				var rememberId = msg.b;
				var _n11 = _Utils_Tuple2(rememberId, ticket);
				if (!_n11.a.$) {
					var r = _n11.a.a;
					return A2(
						elm$core$Tuple$mapSecond,
						function (cmd) {
							return elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										cmd,
										A3(
										author$project$PlayFab$rememberIdLogin,
										author$project$PlayFab$TitleId$fromSession(
											author$project$Main$toSession(model0)),
										r,
										author$project$Main$GotUser)
									]));
						},
						A2(
							author$project$Main$mapSession,
							author$project$Session$setUser(krisajenkins$remotedata$RemoteData$Loading),
							model0));
				} else {
					if (_n11.b.$ === 1) {
						var _n12 = _n11.a;
						var _n13 = _n11.b;
						return A2(
							author$project$Main$mapSession,
							author$project$Session$setUser(
								krisajenkins$remotedata$RemoteData$Success(elm$core$Maybe$Nothing)),
							model0);
					} else {
						var _n14 = _n11.a;
						var t = _n11.b.a;
						return A2(
							elm$core$Tuple$mapSecond,
							function (cmd) {
								return elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											cmd,
											A3(
											author$project$PlayFab$userFromTicket,
											author$project$PlayFab$TitleId$fromSession(
												author$project$Main$toSession(model0)),
											t,
											author$project$Main$GotUser)
										]));
							},
							A2(
								author$project$Main$mapSession,
								author$project$Session$setUser(krisajenkins$remotedata$RemoteData$Loading),
								model0));
					}
				}
			case 9:
				var user = msg.a;
				if (user.$ === 1) {
					var err = user.a;
					var _n16 = A2(
						author$project$Main$mapSession,
						author$project$Session$setUser(
							krisajenkins$remotedata$RemoteData$Failure(err)),
						model0);
					var model1 = _n16.a;
					var cmd1 = _n16.b;
					switch (err.$) {
						case 0:
							var errmsg = err.a;
							return A2(
								elm$core$Tuple$mapSecond,
								function (cmd2) {
									return elm$core$Platform$Cmd$batch(
										_List_fromArray(
											[cmd1, cmd2]));
								},
								A2(
									author$project$Main$mapSession,
									author$project$Session$pushWarning(errmsg),
									model1));
						case 1:
							return _Utils_Tuple2(
								model1,
								elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											cmd1,
											author$project$Ports$writeUserSessionTicket(elm$core$Maybe$Nothing)
										])));
						default:
							return _Utils_Tuple2(model1, cmd1);
					}
				} else {
					var u0 = user.a;
					var _n18 = author$project$PlayFab$User$decodeGameReq(u0);
					var u = _n18.a;
					var cmd0 = _n18.b;
					var _n19 = A2(
						author$project$Main$mapSession,
						author$project$Session$setUser(
							krisajenkins$remotedata$RemoteData$Success(
								elm$core$Maybe$Just(u))),
						model0);
					var model1 = _n19.a;
					var cmd1 = _n19.b;
					return _Utils_Tuple2(
						model1,
						elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[cmd0, cmd1])));
				}
			case 10:
				var json = msg.a;
				var session = author$project$Main$toSession(model0);
				var _n20 = _Utils_Tuple2(
					author$project$Session$gameData(session),
					author$project$Session$now(session));
				if ((!_n20.a.$) && (!_n20.b.$)) {
					var gd = _n20.a.a;
					var now = _n20.b.a;
					var _n21 = author$project$Session$user(session);
					if ((_n21.$ === 3) && (!_n21.a.$)) {
						var user = _n21.a.a;
						var _n22 = A2(
							elm$json$Json$Decode$decodeValue,
							A2(author$project$PlayFab$User$gameDecoder, gd, now),
							json);
						if (!_n22.$) {
							var _n23 = _n22.a;
							var userId = _n23.a;
							var game = _n23.b;
							return _Utils_eq(
								author$project$PlayFab$User$id(user),
								userId) ? A2(
								author$project$Main$mapSession,
								author$project$Session$setUser(
									krisajenkins$remotedata$RemoteData$Success(
										elm$core$Maybe$Just(
											A2(
												author$project$PlayFab$User$setGame,
												elm$core$Result$Ok(game),
												user)))),
								model0) : _Utils_Tuple2(model0, elm$core$Platform$Cmd$none);
						} else {
							var err = _n22.a;
							return A2(
								author$project$Main$mapSession,
								author$project$Session$setUser(
									krisajenkins$remotedata$RemoteData$Success(
										elm$core$Maybe$Just(
											A2(
												author$project$PlayFab$User$setGame,
												elm$core$Result$Err(
													elm$json$Json$Decode$errorToString(err)),
												user)))),
								model0);
						}
					} else {
						return _Utils_Tuple2(model0, elm$core$Platform$Cmd$none);
					}
				} else {
					return _Utils_Tuple2(model0, elm$core$Platform$Cmd$none);
				}
			case 12:
				return _Utils_Tuple2(
					model0,
					function () {
						var session = author$project$Main$toSession(model0);
						var _n24 = author$project$Session$offlineSync(session);
						if (((_n24.$ === 3) && (!_n24.a.$)) && (!_n24.a.a.$)) {
							var sync = _n24.a.a.a;
							var _n25 = author$project$Session$game(session);
							if (_n25.$ === 3) {
								var game = _n25.a;
								return author$project$Ports$onUnloadWrite(
									{
										ae: A2(
											author$project$Game$encoder,
											A2(author$project$Session$safeNow, game, session),
											game),
										ff: author$project$PlayFab$TitleId$toString(
											author$project$PlayFab$TitleId$fromSession(session))
									});
							} else {
								return elm$core$Platform$Cmd$none;
							}
						} else {
							return elm$core$Platform$Cmd$none;
						}
					}());
			case 13:
				return _Utils_Tuple2(
					model0,
					A2(
						author$project$PlayFab$refreshAuth,
						author$project$Main$toSession(model0),
						author$project$Main$GotUser));
			case 14:
				var login = msg.a;
				var _n26 = A2(
					author$project$Main$mapSession,
					author$project$Session$mapIframe(
						author$project$Session$Iframe$mapKongregate(
							author$project$Session$Iframe$Kongregate$update(login))),
					model0);
				var model1 = _n26.a;
				var cmd1 = _n26.b;
				var cmd2 = function () {
					var _n27 = _Utils_Tuple2(
						author$project$Session$iframe(
							author$project$Main$toSession(model0)),
						author$project$Session$iframe(
							author$project$Main$toSession(model1)));
					if ((_n27.a.$ === 1) && (_n27.b.$ === 1)) {
						var kong0 = _n27.a.a;
						var kong1 = _n27.b.a;
						var _n28 = _Utils_Tuple2(kong0.cQ, kong1.cQ);
						if ((!_n28.a.$) && (!_n28.b.$)) {
							var user0 = _n28.a.a;
							var user1 = _n28.b.a;
							return (!_Utils_eq(user0.bH, user1.bH)) ? A4(
								author$project$PlayFab$kongregateLogin,
								author$project$PlayFab$TitleId$fromSession(
									author$project$Main$toSession(model1)),
								user1.bH,
								user1.dk,
								author$project$Main$GotUser) : elm$core$Platform$Cmd$none;
						} else {
							return elm$core$Platform$Cmd$none;
						}
					} else {
						return elm$core$Platform$Cmd$none;
					}
				}();
				return _Utils_Tuple2(
					model1,
					elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[cmd1, cmd2])));
			case 15:
				return A3(
					author$project$Main$mapSessionCmd,
					elm$core$Basics$identity,
					author$project$Session$grantAchievement('konami'),
					model0);
			case 16:
				var json = msg.a;
				var _n29 = A2(elm$json$Json$Decode$decodeValue, author$project$GameData$Lang$translatorDecoder, json);
				if (!_n29.$) {
					var trans = _n29.a;
					return A2(
						author$project$Main$mapSession,
						author$project$Session$setTranslator(
							elm$core$Maybe$Just(trans)),
						model0);
				} else {
					var err = _n29.a;
					return _Utils_Tuple2(model0, elm$core$Platform$Cmd$none);
				}
			case 17:
				var req = msg.a;
				return A3(
					author$project$Main$mapSessionCmd,
					elm$core$Basics$identity,
					author$project$Api$update(req),
					model0);
			case 18:
				return A2(
					author$project$Main$mapSession,
					A2(elm$core$Basics$composeR, author$project$Session$toggleKeyCombosHelp, author$project$Session$clearWelcomeBack),
					model0);
			case 19:
				return A2(
					author$project$Main$mapSession,
					A2(
						elm$core$Basics$composeR,
						author$project$Session$setKeyCombosHelp(false),
						author$project$Session$clearWelcomeBack),
					model0);
			case 20:
				return A3(author$project$Main$mapSessionCmd, elm$core$Basics$identity, author$project$Session$undo, model0);
			case 21:
				return A3(
					author$project$Main$mapSessionCmd,
					elm$core$Basics$identity,
					author$project$View$TabNav$bulkUpgrade(1),
					model0);
			case 22:
				return A3(
					author$project$Main$mapSessionCmd,
					elm$core$Basics$identity,
					author$project$View$TabNav$bulkUpgrade(0.25),
					model0);
			case 23:
				var submsg = msg.a;
				return A3(
					author$project$Main$mapSessionCmd,
					author$project$Main$GotHeaderMsg,
					author$project$View$Header$update(submsg),
					model0);
			case 24:
				var submsg = msg.a;
				return A3(
					author$project$Main$mapSessionCmd,
					author$project$Main$GotOfflineSyncMsg,
					author$project$View$OfflineSync$update(submsg),
					model0);
			case 25:
				var submsg = msg.a;
				return A3(
					author$project$Main$mapSessionCmd,
					author$project$Main$GotErrorViewMsg,
					author$project$View$Error$update(submsg),
					model0);
			case 26:
				var submsg = msg.a;
				return A2(
					author$project$Main$mapSession,
					author$project$View$WelcomeBack$update(submsg),
					model0);
			case 27:
				var submsg = msg.a;
				return A2(
					author$project$Main$mapSession,
					author$project$View$KeyCombo$update(submsg),
					model0);
			case 28:
				var submsg = msg.a;
				if (model0.$ === 1) {
					var submodel = model0.a;
					return A3(
						elm$core$Tuple$mapBoth,
						author$project$Main$Debug,
						elm$core$Platform$Cmd$map(author$project$Main$GotDebugMsg),
						A2(author$project$Page$Debug$update, submsg, submodel));
				} else {
					return _Utils_Tuple2(model0, elm$core$Platform$Cmd$none);
				}
			case 29:
				var submsg = msg.a;
				if (model0.$ === 3) {
					var submodel = model0.a;
					return A3(
						elm$core$Tuple$mapBoth,
						author$project$Main$Tab,
						elm$core$Platform$Cmd$map(author$project$Main$GotTabMsg),
						A2(author$project$Page$Tab$update, submsg, submodel));
				} else {
					return _Utils_Tuple2(model0, elm$core$Platform$Cmd$none);
				}
			case 30:
				var submsg = msg.a;
				if (model0.$ === 4) {
					var submodel = model0.a;
					return A3(
						elm$core$Tuple$mapBoth,
						author$project$Main$Unit,
						elm$core$Platform$Cmd$map(author$project$Main$GotUnitMsg),
						A2(author$project$Page$Unit$update, submsg, submodel));
				} else {
					return _Utils_Tuple2(model0, elm$core$Platform$Cmd$none);
				}
			case 31:
				var submsg = msg.a;
				if (model0.$ === 5) {
					var submodel = model0.a;
					return A3(
						elm$core$Tuple$mapBoth,
						author$project$Main$Spell,
						elm$core$Platform$Cmd$map(author$project$Main$GotSpellMsg),
						A2(author$project$Page$Spell$update, submsg, submodel));
				} else {
					return _Utils_Tuple2(model0, elm$core$Platform$Cmd$none);
				}
			case 32:
				var submsg = msg.a;
				if (model0.$ === 2) {
					var submodel = model0.a;
					return A3(
						elm$core$Tuple$mapBoth,
						author$project$Main$MtxShop,
						elm$core$Platform$Cmd$map(author$project$Main$GotMtxShopMsg),
						A2(author$project$Page$MtxShop$update, submsg, submodel));
				} else {
					return _Utils_Tuple2(model0, elm$core$Platform$Cmd$none);
				}
			case 33:
				var submsg = msg.a;
				if (model0.$ === 6) {
					var submodel = model0.a;
					return A3(
						elm$core$Tuple$mapBoth,
						author$project$Main$Achievements,
						elm$core$Platform$Cmd$map(author$project$Main$GotAchievementsMsg),
						A2(author$project$Page$Achievements$update, submsg, submodel));
				} else {
					return _Utils_Tuple2(model0, elm$core$Platform$Cmd$none);
				}
			case 34:
				var submsg = msg.a;
				if (model0.$ === 7) {
					var submodel = model0.a;
					return A3(
						elm$core$Tuple$mapBoth,
						author$project$Main$Options,
						elm$core$Platform$Cmd$map(author$project$Main$GotOptionsMsg),
						A2(author$project$Page$Options$update, submsg, submodel));
				} else {
					return _Utils_Tuple2(model0, elm$core$Platform$Cmd$none);
				}
			case 35:
				var submsg = msg.a;
				if (model0.$ === 8) {
					var submodel = model0.a;
					return A3(
						elm$core$Tuple$mapBoth,
						author$project$Main$Statistics,
						elm$core$Platform$Cmd$map(author$project$Main$GotStatisticsMsg),
						A2(author$project$Page$Statistics$update, submsg, submodel));
				} else {
					return _Utils_Tuple2(model0, elm$core$Platform$Cmd$none);
				}
			case 36:
				var submsg = msg.a;
				if (model0.$ === 9) {
					var submodel = model0.a;
					return A3(
						elm$core$Tuple$mapBoth,
						author$project$Main$Changelog,
						elm$core$Platform$Cmd$map(author$project$Main$GotChangelogMsg),
						A2(author$project$Page$Changelog$update, submsg, submodel));
				} else {
					return _Utils_Tuple2(model0, elm$core$Platform$Cmd$none);
				}
			case 37:
				var submsg = msg.a;
				if (model0.$ === 10) {
					var submodel = model0.a;
					return A3(
						elm$core$Tuple$mapBoth,
						author$project$Main$User,
						elm$core$Platform$Cmd$map(author$project$Main$GotUserMsg),
						A2(author$project$Page$User$update, submsg, submodel));
				} else {
					return _Utils_Tuple2(model0, elm$core$Platform$Cmd$none);
				}
			case 38:
				var submsg = msg.a;
				if (model0.$ === 11) {
					var submodel = model0.a;
					return A3(
						elm$core$Tuple$mapBoth,
						author$project$Main$MtxHistory,
						elm$core$Platform$Cmd$map(author$project$Main$GotMtxHistoryMsg),
						A2(author$project$Page$MtxHistory$update, submsg, submodel));
				} else {
					return _Utils_Tuple2(model0, elm$core$Platform$Cmd$none);
				}
			case 39:
				var submsg = msg.a;
				if (model0.$ === 12) {
					var submodel = model0.a;
					return A3(
						elm$core$Tuple$mapBoth,
						author$project$Main$Login,
						elm$core$Platform$Cmd$map(author$project$Main$GotLoginMsg),
						A2(author$project$Page$Login$update, submsg, submodel));
				} else {
					return _Utils_Tuple2(model0, elm$core$Platform$Cmd$none);
				}
			case 40:
				var submsg = msg.a;
				if (model0.$ === 13) {
					var submodel = model0.a;
					return A3(
						elm$core$Tuple$mapBoth,
						author$project$Main$Register,
						elm$core$Platform$Cmd$map(author$project$Main$GotRegisterMsg),
						A2(author$project$Page$Register$update, submsg, submodel));
				} else {
					return _Utils_Tuple2(model0, elm$core$Platform$Cmd$none);
				}
			case 41:
				var submsg = msg.a;
				if (model0.$ === 14) {
					var submodel = model0.a;
					return A3(
						elm$core$Tuple$mapBoth,
						author$project$Main$ResetPassword,
						elm$core$Platform$Cmd$map(author$project$Main$GotResetPasswordMsg),
						A2(author$project$Page$ResetPassword$update, submsg, submodel));
				} else {
					return _Utils_Tuple2(model0, elm$core$Platform$Cmd$none);
				}
			case 42:
				var submsg = msg.a;
				if (model0.$ === 15) {
					var submodel = model0.a;
					return A3(
						elm$core$Tuple$mapBoth,
						author$project$Main$PaypalDone,
						elm$core$Platform$Cmd$map(author$project$Main$GotPaypalDoneMsg),
						A2(author$project$Page$PaypalDone$update, submsg, submodel));
				} else {
					return _Utils_Tuple2(model0, elm$core$Platform$Cmd$none);
				}
			case 43:
				var submsg = msg.a;
				if (model0.$ === 16) {
					var session = model0.a;
					return A3(
						elm$core$Tuple$mapBoth,
						author$project$Main$MoreMenu,
						elm$core$Platform$Cmd$map(author$project$Main$GotMoreMenuMsg),
						A2(author$project$View$TabNav$update, submsg, session));
				} else {
					return _Utils_Tuple2(model0, elm$core$Platform$Cmd$none);
				}
			default:
				var submsg = msg.a;
				if (model0.$ === 17) {
					var session = model0.a;
					return A3(
						elm$core$Tuple$mapBoth,
						author$project$Main$Translator,
						elm$core$Platform$Cmd$map(author$project$Main$GotTranslatorMsg),
						A2(author$project$Page$Translator$update, submsg, session));
				} else {
					return _Utils_Tuple2(model0, elm$core$Platform$Cmd$none);
				}
		}
	});
var author$project$Main$GotKeyCombosHelpMsg = function (a) {
	return {$: 27, a: a};
};
var author$project$Main$GotWelcomeBackMsg = function (a) {
	return {$: 26, a: a};
};
var author$project$Page$Achievements$GotTabNavMsg = function (a) {
	return {$: 0, a: a};
};
var author$project$Game$achievements = A2(
	elm$core$Basics$composeR,
	author$project$Game$unwrap,
	function ($) {
		return $.aP;
	});
var author$project$Game$achievementsShown = A2(
	elm$core$Basics$composeR,
	author$project$Game$unwrap,
	function ($) {
		return $.Y;
	});
var author$project$Page$Achievements$OnSetOptionsEarned = {$: 2};
var author$project$Page$Achievements$OnSetOptionsMasked = {$: 4};
var author$project$Page$Achievements$OnSetOptionsReverse = {$: 6};
var author$project$Page$Achievements$OnSetOptionsSortOrder = function (a) {
	return {$: 5, a: a};
};
var author$project$Page$Achievements$OnSetOptionsUnearned = {$: 3};
var author$project$Page$Achievements$isVisible = F2(
	function (options, status) {
		switch (status.$) {
			case 3:
				return false;
			case 2:
				return options.ca;
			case 1:
				return options.cK;
			default:
				return options.bU;
		}
	});
var author$project$Page$Achievements$percent = function (pct) {
	return elm$core$String$fromInt(
		elm$core$Basics$floor(pct * 100)) + '%';
};
var elm$core$List$minimum = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return elm$core$Maybe$Just(
			A3(elm$core$List$foldl, elm$core$Basics$min, x, xs));
	} else {
		return elm$core$Maybe$Nothing;
	}
};
var author$project$Page$Achievements$sortByCompletion = function (_n0) {
	var achievement = _n0.a;
	var status = _n0.b;
	switch (status.$) {
		case 0:
			return -1;
		case 1:
			var progressList = status.a;
			return A2(
				elm$core$Maybe$withDefault,
				1,
				elm$core$List$minimum(
					A2(
						elm$core$List$map,
						function ($) {
							return $.dC;
						},
						progressList)));
		case 2:
			return 2;
		default:
			return 3;
	}
};
var author$project$Page$Achievements$sortByDefault = function (_n0) {
	var achievement = _n0.a;
	var status = _n0.b;
	switch (status.$) {
		case 0:
			return -1;
		case 1:
			return 0;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var author$project$Page$Achievements$sort = function (order) {
	if (!order) {
		return elm$core$List$sortBy(author$project$Page$Achievements$sortByDefault);
	} else {
		return elm$core$List$sortBy(author$project$Page$Achievements$sortByCompletion);
	}
};
var author$project$Page$Achievements$OnAchievementClick = function (a) {
	return {$: 1, a: a};
};
var author$project$Page$Achievements$toProgdesc = F2(
	function (gameData, progs_) {
		var _n0 = elm$core$List$head(progs_);
		if (_n0.$ === 1) {
			return elm$core$Maybe$Nothing;
		} else {
			var p = _n0.a;
			var _n1 = A2(
				elm$core$Maybe$map,
				author$project$GameData$Item$id,
				A2(author$project$GameData$itemByName, p.br, gameData));
			if (_n1.$ === 1) {
				return elm$core$Maybe$Nothing;
			} else {
				var lid = _n1.a;
				return elm$core$Maybe$Just(
					_Utils_Tuple2(lid, p.dw));
			}
		}
	});
var elm$html$Html$i = _VirtualDom_node('i');
var elm$html$Html$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			_VirtualDom_property,
			key,
			elm$json$Json$Encode$string(string));
	});
var elm$html$Html$Attributes$class = elm$html$Html$Attributes$stringProperty('className');
var author$project$View$Icon$fas = function (name) {
	return A2(
		elm$html$Html$i,
		_List_fromArray(
			[
				elm$html$Html$Attributes$class('fas'),
				elm$html$Html$Attributes$class('fa-' + name)
			]),
		_List_Nil);
};
var author$project$View$Lang$AchievementDesc = F2(
	function (a, b) {
		return {$: 13, a: a, b: b};
	});
var author$project$View$Lang$AchievementLongDesc = function (a) {
	return {$: 14, a: a};
};
var author$project$View$Lang$AchievementName = function (a) {
	return {$: 12, a: a};
};
var author$project$View$Lang$ViewAchievementsEntryDate = function (a) {
	return {$: 106, a: a};
};
var author$project$View$Lang$ViewAchievementsEntryMasked = {$: 108};
var author$project$View$Lang$ViewAchievementsEntryProgress = F3(
	function (a, b, c) {
		return {$: 107, a: a, b: b, c: c};
	});
var elm$html$Html$div = _VirtualDom_node('div');
var elm$html$Html$h3 = _VirtualDom_node('h3');
var elm$html$Html$li = _VirtualDom_node('li');
var elm$html$Html$small = _VirtualDom_node('small');
var elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
var elm$html$Html$text = elm$virtual_dom$VirtualDom$text;
var elm$virtual_dom$VirtualDom$style = _VirtualDom_style;
var elm$html$Html$Attributes$style = elm$virtual_dom$VirtualDom$style;
var elm$virtual_dom$VirtualDom$Normal = function (a) {
	return {$: 0, a: a};
};
var elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
var elm$html$Html$Events$on = F2(
	function (event, decoder) {
		return A2(
			elm$virtual_dom$VirtualDom$on,
			event,
			elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var elm$html$Html$Events$onClick = function (msg) {
	return A2(
		elm$html$Html$Events$on,
		'click',
		elm$json$Json$Decode$succeed(msg));
};
var author$project$Page$Achievements$viewEntry = F5(
	function (gameData, lang, now, achievement, status) {
		switch (status.$) {
			case 3:
				return A2(elm$html$Html$div, _List_Nil, _List_Nil);
			case 2:
				return A2(
					elm$html$Html$li,
					_List_fromArray(
						[
							elm$html$Html$Attributes$class('list-group-item list-group-item-secondary')
						]),
					_List_fromArray(
						[
							A2(
							elm$html$Html$div,
							_List_fromArray(
								[
									elm$html$Html$Attributes$class('row'),
									elm$html$Html$Events$onClick(
									author$project$Page$Achievements$OnAchievementClick(achievement))
								]),
							_List_fromArray(
								[
									A2(
									elm$html$Html$div,
									_List_fromArray(
										[
											elm$html$Html$Attributes$class('icon col-2')
										]),
									_List_fromArray(
										[
											author$project$View$Icon$fas('question-circle')
										])),
									A2(
									elm$html$Html$div,
									_List_fromArray(
										[
											elm$html$Html$Attributes$class('body col-8')
										]),
									_List_fromArray(
										[
											A2(
											elm$html$Html$h3,
											_List_Nil,
											_List_fromArray(
												[
													lang.q(author$project$View$Lang$ViewAchievementsEntryMasked)
												]))
										])),
									A2(
									elm$html$Html$div,
									_List_fromArray(
										[
											elm$html$Html$Attributes$class('points col-2')
										]),
									_List_fromArray(
										[
											elm$html$Html$text(
											elm$core$String$fromInt(achievement.cs))
										]))
								]))
						]));
			case 1:
				var progs = status.a;
				return A2(
					elm$html$Html$li,
					_List_fromArray(
						[
							elm$html$Html$Attributes$class('list-group-item list-group-item-info')
						]),
					_List_fromArray(
						[
							A2(
							elm$html$Html$div,
							_List_fromArray(
								[
									elm$html$Html$Attributes$class('row')
								]),
							_List_fromArray(
								[
									A2(
									elm$html$Html$div,
									_List_fromArray(
										[
											elm$html$Html$Attributes$class('icon col-2')
										]),
									_List_fromArray(
										[
											author$project$View$Icon$fas('trophy')
										])),
									A2(
									elm$html$Html$div,
									_List_fromArray(
										[
											elm$html$Html$Attributes$class('body col-8')
										]),
									_List_fromArray(
										[
											A2(
											elm$html$Html$h3,
											_List_Nil,
											_List_fromArray(
												[
													lang.q(
													author$project$View$Lang$AchievementName(achievement.eL))
												])),
											A2(
											elm$html$Html$div,
											_List_Nil,
											_List_fromArray(
												[
													lang.q(
													A2(
														author$project$View$Lang$AchievementDesc,
														achievement.eL,
														A2(author$project$Page$Achievements$toProgdesc, gameData, progs)))
												])),
											A2(
											elm$html$Html$div,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													elm$html$Html$small,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															elm$html$Html$i,
															_List_Nil,
															_List_fromArray(
																[
																	lang.q(
																	author$project$View$Lang$AchievementLongDesc(achievement.eL))
																]))
														]))
												])),
											A2(
											elm$html$Html$div,
											_List_Nil,
											A2(
												elm$core$List$map,
												function (prog) {
													return A2(
														elm$html$Html$div,
														_List_fromArray(
															[
																elm$html$Html$Attributes$class('progress')
															]),
														_List_fromArray(
															[
																A2(
																elm$html$Html$div,
																_List_fromArray(
																	[
																		elm$html$Html$Attributes$class('progress-bar'),
																		A2(
																		elm$html$Html$Attributes$style,
																		'width',
																		author$project$Page$Achievements$percent(prog.dC))
																	]),
																_List_fromArray(
																	[
																		lang.q(
																		A3(author$project$View$Lang$ViewAchievementsEntryProgress, prog.dC, prog.d6, prog.dw))
																	]))
															]));
												},
												progs))
										])),
									A2(
									elm$html$Html$div,
									_List_fromArray(
										[
											elm$html$Html$Attributes$class('points col-2')
										]),
									_List_fromArray(
										[
											elm$html$Html$text(
											elm$core$String$fromInt(achievement.cs))
										]))
								]))
						]));
			default:
				var date = status.a;
				var progs = status.b;
				return A2(
					elm$html$Html$li,
					_List_fromArray(
						[
							elm$html$Html$Attributes$class('list-group-item list-group-item-success')
						]),
					_List_fromArray(
						[
							A2(
							elm$html$Html$div,
							_List_fromArray(
								[
									elm$html$Html$Attributes$class('row')
								]),
							_List_fromArray(
								[
									A2(
									elm$html$Html$div,
									_List_fromArray(
										[
											elm$html$Html$Attributes$class('icon col-2')
										]),
									_List_fromArray(
										[
											author$project$View$Icon$fas('trophy')
										])),
									A2(
									elm$html$Html$div,
									_List_fromArray(
										[
											elm$html$Html$Attributes$class('body col-8')
										]),
									_List_fromArray(
										[
											A2(
											elm$html$Html$h3,
											_List_Nil,
											_List_fromArray(
												[
													lang.q(
													author$project$View$Lang$AchievementName(achievement.eL))
												])),
											A2(
											elm$html$Html$div,
											_List_Nil,
											_List_fromArray(
												[
													lang.q(
													A2(
														author$project$View$Lang$AchievementDesc,
														achievement.eL,
														A2(author$project$Page$Achievements$toProgdesc, gameData, progs)))
												])),
											A2(
											elm$html$Html$div,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													elm$html$Html$small,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															elm$html$Html$i,
															_List_Nil,
															_List_fromArray(
																[
																	lang.q(
																	author$project$View$Lang$AchievementLongDesc(achievement.eL))
																]))
														]))
												])),
											A2(
											elm$html$Html$div,
											_List_Nil,
											_List_fromArray(
												[
													author$project$View$Icon$fas('check'),
													elm$html$Html$text(' '),
													lang.q(
													author$project$View$Lang$ViewAchievementsEntryDate(
														{bR: date, cm: now}))
												]))
										])),
									A2(
									elm$html$Html$div,
									_List_fromArray(
										[
											elm$html$Html$Attributes$class('points col-2')
										]),
									_List_fromArray(
										[
											elm$html$Html$text(
											'+' + elm$core$String$fromInt(achievement.cs))
										]))
								]))
						]));
		}
	});
var author$project$View$Lang$ViewAchievementsBonus = function (a) {
	return {$: 110, a: a};
};
var author$project$View$Lang$ViewAchievementsOptionsSort = {$: 115};
var author$project$View$Lang$ViewAchievementsOptionsSortCompletion = {$: 117};
var author$project$View$Lang$ViewAchievementsOptionsSortDefault = {$: 116};
var author$project$View$Lang$ViewAchievementsOptionsSortNotReversed = {$: 119};
var author$project$View$Lang$ViewAchievementsOptionsSortReversed = {$: 118};
var author$project$View$Lang$ViewAchievementsOptionsVisible = {$: 111};
var author$project$View$Lang$ViewAchievementsOptionsVisibleEarned = {$: 112};
var author$project$View$Lang$ViewAchievementsOptionsVisibleMasked = {$: 114};
var author$project$View$Lang$ViewAchievementsOptionsVisibleUnearned = {$: 113};
var author$project$View$Lang$ViewAchievementsProgress = function (a) {
	return {$: 105, a: a};
};
var author$project$View$Lang$ViewAchievementsTitle = function (a) {
	return {$: 104, a: a};
};
var author$project$Fools$After = 3;
var author$project$Fools$Invited = 0;
var author$project$Fools$Off = 2;
var author$project$Fools$On = 1;
var elm$time$Time$flooredDiv = F2(
	function (numerator, denominator) {
		return elm$core$Basics$floor(numerator / denominator);
	});
var elm$time$Time$toAdjustedMinutesHelp = F3(
	function (defaultOffset, posixMinutes, eras) {
		toAdjustedMinutesHelp:
		while (true) {
			if (!eras.b) {
				return posixMinutes + defaultOffset;
			} else {
				var era = eras.a;
				var olderEras = eras.b;
				if (_Utils_cmp(era.fF, posixMinutes) < 0) {
					return posixMinutes + era.b;
				} else {
					var $temp$defaultOffset = defaultOffset,
						$temp$posixMinutes = posixMinutes,
						$temp$eras = olderEras;
					defaultOffset = $temp$defaultOffset;
					posixMinutes = $temp$posixMinutes;
					eras = $temp$eras;
					continue toAdjustedMinutesHelp;
				}
			}
		}
	});
var elm$time$Time$toAdjustedMinutes = F2(
	function (_n0, time) {
		var defaultOffset = _n0.a;
		var eras = _n0.b;
		return A3(
			elm$time$Time$toAdjustedMinutesHelp,
			defaultOffset,
			A2(
				elm$time$Time$flooredDiv,
				elm$time$Time$posixToMillis(time),
				60000),
			eras);
	});
var elm$time$Time$toCivil = function (minutes) {
	var rawDay = A2(elm$time$Time$flooredDiv, minutes, 60 * 24) + 719468;
	var era = (((rawDay >= 0) ? rawDay : (rawDay - 146096)) / 146097) | 0;
	var dayOfEra = rawDay - (era * 146097);
	var yearOfEra = ((((dayOfEra - ((dayOfEra / 1460) | 0)) + ((dayOfEra / 36524) | 0)) - ((dayOfEra / 146096) | 0)) / 365) | 0;
	var dayOfYear = dayOfEra - (((365 * yearOfEra) + ((yearOfEra / 4) | 0)) - ((yearOfEra / 100) | 0));
	var mp = (((5 * dayOfYear) + 2) / 153) | 0;
	var month = mp + ((mp < 10) ? 3 : (-9));
	var year = yearOfEra + (era * 400);
	return {
		bf: (dayOfYear - ((((153 * mp) + 2) / 5) | 0)) + 1,
		dx: month,
		bK: year + ((month <= 2) ? 1 : 0)
	};
};
var elm$time$Time$toDay = F2(
	function (zone, time) {
		return elm$time$Time$toCivil(
			A2(elm$time$Time$toAdjustedMinutes, zone, time)).bf;
	});
var elm$time$Time$Apr = 3;
var elm$time$Time$Aug = 7;
var elm$time$Time$Dec = 11;
var elm$time$Time$Feb = 1;
var elm$time$Time$Jan = 0;
var elm$time$Time$Jul = 6;
var elm$time$Time$Jun = 5;
var elm$time$Time$Mar = 2;
var elm$time$Time$May = 4;
var elm$time$Time$Nov = 10;
var elm$time$Time$Oct = 9;
var elm$time$Time$Sep = 8;
var elm$time$Time$toMonth = F2(
	function (zone, time) {
		var _n0 = elm$time$Time$toCivil(
			A2(elm$time$Time$toAdjustedMinutes, zone, time)).dx;
		switch (_n0) {
			case 1:
				return 0;
			case 2:
				return 1;
			case 3:
				return 2;
			case 4:
				return 3;
			case 5:
				return 4;
			case 6:
				return 5;
			case 7:
				return 6;
			case 8:
				return 7;
			case 9:
				return 8;
			case 10:
				return 9;
			case 11:
				return 10;
			default:
				return 11;
		}
	});
var author$project$Fools$dateStatus = function (now) {
	var tz = A2(elm$time$Time$customZone, (-4) * 60, _List_Nil);
	var _n0 = _Utils_Tuple2(
		A2(elm$time$Time$toMonth, tz, now),
		A2(elm$time$Time$toDay, tz, now));
	_n0$3:
	while (true) {
		if (_n0.a === 3) {
			switch (_n0.b) {
				case 1:
					var _n1 = _n0.a;
					return 0;
				case 2:
					var _n2 = _n0.a;
					return 3;
				case 3:
					var _n3 = _n0.a;
					return 3;
				default:
					break _n0$3;
			}
		} else {
			break _n0$3;
		}
	}
	return 2;
};
var author$project$Route$Config$Fools = 2;
var author$project$Fools$status = function (session) {
	var _n0 = A2(
		author$project$Route$Config$get,
		2,
		author$project$Session$query(session));
	if (!_n0.$) {
		var fools = _n0.a;
		var _n1 = rtfeldman$elm_iso8601_date_strings$Iso8601$toTime(fools);
		if (!_n1.$) {
			var now = _n1.a;
			return author$project$Fools$dateStatus(now);
		} else {
			switch (fools) {
				case 'after':
					return 3;
				case 'invited':
					return 0;
				case 'off':
					return 2;
				case '':
					return 2;
				case '0':
					return 2;
				default:
					return 1;
			}
		}
	} else {
		var _n3 = author$project$Session$now(session);
		if (!_n3.$) {
			var now = _n3.a;
			return author$project$Fools$dateStatus(now);
		} else {
			return 2;
		}
	}
};
var author$project$Game$locale = A2(
	elm$core$Basics$composeR,
	author$project$Game$unwrap,
	function ($) {
		return $.av;
	});
var author$project$Session$translatorEntry = function (s) {
	return A2(
		author$project$Route$Feature$isActive,
		3,
		author$project$Session$query(s)) ? A2(
		elm$core$Maybe$map,
		elm$core$Tuple$first,
		author$project$Session$unwrap(s).cJ) : elm$core$Maybe$Nothing;
};
var author$project$Game$numberFormat = A2(
	elm$core$Basics$composeR,
	author$project$Game$unwrap,
	function ($) {
		return $.ay;
	});
var author$project$Game$velocityUnit = A2(
	elm$core$Basics$composeR,
	author$project$Game$unwrap,
	function ($) {
		return $.aL;
	});
var author$project$Game$velocityUnitSeconds = function (game) {
	var vu = author$project$Game$velocityUnit(game);
	switch (vu) {
		case 0:
			return elm$core$Result$Ok(1);
		case 1:
			return elm$core$Result$Ok(60);
		case 2:
			return elm$core$Result$Ok(60 * 60);
		case 3:
			return elm$core$Result$Ok((60 * 60) * 24);
		default:
			var _n1 = A2(
				author$project$GameData$spellByName,
				'swarmwarp',
				author$project$Game$gameData(game));
			if (_n1.$ === 1) {
				return elm$core$Result$Err('no spell named swarmwarp');
			} else {
				var spell = _n1.a;
				var _n2 = elm$core$List$head(spell.e9.ea);
				if (_n2.$ === 1) {
					return elm$core$Result$Err('swarmwarp doesn\'t add time');
				} else {
					var onBuy = _n2.a;
					return elm$core$Result$Ok(
						author$project$Decimal$toFloat(
							A3(
								author$project$Parser$Stat$evalWithDefault,
								author$project$Decimal$zero,
								author$project$Game$getGameVar(game),
								onBuy)));
				}
			}
	}
};
var author$project$View$Lang$gameContext = function (game) {
	return {
		ay: author$project$Game$numberFormat(game),
		o: author$project$Game$upgradesDict(game),
		cT: A2(
			elm$core$Result$withDefault,
			1,
			author$project$Game$velocityUnitSeconds(game)),
		aL: author$project$Game$velocityUnit(game)
	};
};
var author$project$View$Lang$Lang = F5(
	function (locale, rstr, rhtml, str, html) {
		return {q: html, av: locale, fu: rhtml, fw: rstr, fH: str};
	});
var author$project$View$Lang$silentText = F2(
	function (mapErr, res) {
		if (!res.$) {
			var val = res.a;
			return val;
		} else {
			var err = res.a;
			return mapErr('???' + (err + '???'));
		}
	});
var author$project$View$Lang$init = F3(
	function (locale, str, html) {
		return A5(
			author$project$View$Lang$Lang,
			locale,
			str,
			html,
			A2(
				elm$core$Basics$composeR,
				str,
				author$project$View$Lang$silentText(elm$core$Basics$identity)),
			A2(
				elm$core$Basics$composeR,
				html,
				author$project$View$Lang$silentText(elm$html$Html$text)));
	});
var elm$html$Html$a = _VirtualDom_node('a');
var elm$html$Html$b = _VirtualDom_node('b');
var elm$html$Html$img = _VirtualDom_node('img');
var elm$html$Html$Attributes$href = function (url) {
	return A2(
		elm$html$Html$Attributes$stringProperty,
		'href',
		_VirtualDom_noJavaScriptUri(url));
};
var elm$html$Html$Attributes$src = function (url) {
	return A2(
		elm$html$Html$Attributes$stringProperty,
		'src',
		_VirtualDom_noJavaScriptOrHtmlUri(url));
};
var author$project$Parser$Tutorial$evalElem = function (elem) {
	switch (elem.$) {
		case 0:
			var str = elem.a;
			return elm$html$Html$text(str);
		case 1:
			var href = elem.a.dq;
			var body = elem.a.cZ;
			return A2(
				elm$html$Html$a,
				_List_fromArray(
					[
						elm$html$Html$Attributes$href(href)
					]),
				author$project$Parser$Tutorial$cyclic$evalLine()(body));
		case 2:
			var alt = elem.a.cV;
			var name = elem.a.br;
			return A2(elm$core$String$startsWith, '/', name) ? A2(
				elm$html$Html$img,
				_List_fromArray(
					[
						elm$html$Html$Attributes$class('img-icon'),
						elm$html$Html$Attributes$src(name)
					]),
				_List_Nil) : author$project$View$Icon$fas(name);
		default:
			var body = elem.a;
			return A2(
				elm$html$Html$b,
				_List_Nil,
				author$project$Parser$Tutorial$cyclic$evalLine()(body));
	}
};
function author$project$Parser$Tutorial$cyclic$evalLine() {
	return elm$core$List$map(author$project$Parser$Tutorial$evalElem);
}
var author$project$Parser$Tutorial$evalLine = author$project$Parser$Tutorial$cyclic$evalLine();
author$project$Parser$Tutorial$cyclic$evalLine = function () {
	return author$project$Parser$Tutorial$evalLine;
};
var elm$html$Html$p = _VirtualDom_node('p');
var author$project$Parser$Tutorial$eval = elm$core$List$map(
	A2(
		elm$core$Basics$composeR,
		author$project$Parser$Tutorial$evalLine,
		elm$html$Html$p(_List_Nil)));
var elm$html$Html$span = _VirtualDom_node('span');
var author$project$Parser$Tutorial$evalSpan = elm$core$List$map(
	A2(
		elm$core$Basics$composeR,
		author$project$Parser$Tutorial$evalLine,
		elm$html$Html$span(_List_Nil)));
var author$project$Parser$Tutorial$expression = function (element) {
	return A2(
		elm$parser$Parser$andThen,
		function (first) {
			return A2(
				elm$parser$Parser$loop,
				_List_fromArray(
					[first]),
				function (revElements) {
					return elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								A2(
								elm$parser$Parser$keeper,
								elm$parser$Parser$succeed(
									function (elem) {
										return elm$parser$Parser$Loop(
											A2(elm$core$List$cons, elem, revElements));
									}),
								element),
								A2(
								elm$parser$Parser$map,
								function (_n0) {
									return elm$parser$Parser$Done(
										elm$core$List$reverse(revElements));
								},
								elm$parser$Parser$succeed(0))
							]));
				});
		},
		element);
};
var author$project$Parser$Tutorial$Bold = function (a) {
	return {$: 3, a: a};
};
var author$project$Parser$Tutorial$Link = function (a) {
	return {$: 1, a: a};
};
var author$project$Parser$Tutorial$Icon = function (a) {
	return {$: 2, a: a};
};
var author$project$Parser$Tutorial$Text = function (a) {
	return {$: 0, a: a};
};
var author$project$Parser$Tutorial$iconElement = A2(
	elm$parser$Parser$andThen,
	function (_n0) {
		return elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					elm$parser$Parser$keeper,
					A2(
						elm$parser$Parser$keeper,
						A2(
							elm$parser$Parser$ignorer,
							A2(
								elm$parser$Parser$ignorer,
								elm$parser$Parser$succeed(
									F2(
										function (alt, name) {
											return author$project$Parser$Tutorial$Icon(
												{cV: alt, br: name});
										})),
								elm$parser$Parser$symbol('[')),
							elm$parser$Parser$spaces),
						A2(
							elm$parser$Parser$ignorer,
							A2(
								elm$parser$Parser$ignorer,
								A2(
									elm$parser$Parser$ignorer,
									A2(
										elm$parser$Parser$ignorer,
										elm$parser$Parser$getChompedString(
											elm$parser$Parser$chompWhile(
												function (c) {
													return (c !== ' ') && (c !== ']');
												})),
										elm$parser$Parser$spaces),
									elm$parser$Parser$symbol(']')),
								elm$parser$Parser$symbol('[')),
							elm$parser$Parser$spaces)),
					A2(
						elm$parser$Parser$ignorer,
						A2(
							elm$parser$Parser$ignorer,
							elm$parser$Parser$getChompedString(
								elm$parser$Parser$chompWhile(
									function (c) {
										return (c !== ' ') && (c !== ']');
									})),
							elm$parser$Parser$spaces),
						elm$parser$Parser$symbol(']'))),
					elm$parser$Parser$succeed(
					author$project$Parser$Tutorial$Text('!'))
				]));
	},
	elm$parser$Parser$symbol('!'));
var author$project$Parser$Tutorial$textElement = A2(
	elm$parser$Parser$andThen,
	function (t) {
		return (t === '') ? elm$parser$Parser$problem('empty tutorial body') : elm$parser$Parser$succeed(
			author$project$Parser$Tutorial$Text(t));
	},
	A2(
		elm$parser$Parser$keeper,
		elm$parser$Parser$succeed(elm$core$Basics$identity),
		elm$parser$Parser$getChompedString(
			elm$parser$Parser$chompWhile(
				function (c) {
					return (c !== '\n') && ((c !== '*') && ((c !== '[') && ((c !== ']') && (c !== '!'))));
				}))));
var author$project$Parser$Tutorial$nestedElement = elm$parser$Parser$oneOf(
	_List_fromArray(
		[author$project$Parser$Tutorial$iconElement, author$project$Parser$Tutorial$textElement]));
var author$project$Parser$Tutorial$topElement = elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			elm$parser$Parser$keeper,
			A2(
				elm$parser$Parser$ignorer,
				elm$parser$Parser$succeed(author$project$Parser$Tutorial$Bold),
				elm$parser$Parser$symbol('*')),
			A2(
				elm$parser$Parser$ignorer,
				elm$parser$Parser$lazy(
					function (_n0) {
						return author$project$Parser$Tutorial$expression(author$project$Parser$Tutorial$nestedElement);
					}),
				elm$parser$Parser$symbol('*'))),
			A2(
			elm$parser$Parser$keeper,
			A2(
				elm$parser$Parser$keeper,
				A2(
					elm$parser$Parser$ignorer,
					elm$parser$Parser$succeed(
						F2(
							function (body, href) {
								return author$project$Parser$Tutorial$Link(
									{cZ: body, dq: href});
							})),
					elm$parser$Parser$symbol('[')),
				A2(
					elm$parser$Parser$ignorer,
					A2(
						elm$parser$Parser$ignorer,
						A2(
							elm$parser$Parser$ignorer,
							elm$parser$Parser$lazy(
								function (_n1) {
									return author$project$Parser$Tutorial$expression(author$project$Parser$Tutorial$nestedElement);
								}),
							elm$parser$Parser$symbol(']')),
						elm$parser$Parser$symbol('(')),
					elm$parser$Parser$spaces)),
			A2(
				elm$parser$Parser$ignorer,
				A2(
					elm$parser$Parser$ignorer,
					elm$parser$Parser$getChompedString(
						elm$parser$Parser$chompWhile(
							function (c) {
								return c !== ')';
							})),
					elm$parser$Parser$spaces),
				elm$parser$Parser$symbol(')'))),
			author$project$Parser$Tutorial$iconElement,
			author$project$Parser$Tutorial$textElement
		]));
var author$project$Parser$Tutorial$line = author$project$Parser$Tutorial$expression(author$project$Parser$Tutorial$topElement);
var elm$parser$Parser$Optional = 1;
var author$project$Parser$Tutorial$lines = A2(
	elm$parser$Parser$andThen,
	function (es) {
		return _Utils_eq(es, _List_Nil) ? elm$parser$Parser$problem('empty tutorial body') : elm$parser$Parser$succeed(es);
	},
	elm$parser$Parser$sequence(
		{
			ez: '',
			eW: author$project$Parser$Tutorial$line,
			fA: '\n',
			fE: elm$parser$Parser$succeed(0),
			fF: '',
			fS: 1
		}));
var author$project$Parser$Tutorial$parser = A2(
	elm$parser$Parser$keeper,
	elm$parser$Parser$succeed(elm$core$Basics$identity),
	A2(elm$parser$Parser$ignorer, author$project$Parser$Tutorial$lines, elm$parser$Parser$end));
var author$project$Parser$Tutorial$parse = A2(
	elm$core$Basics$composeR,
	elm$parser$Parser$run(author$project$Parser$Tutorial$parser),
	elm$core$Result$mapError(elm$parser$Parser$deadEndsToString));
var author$project$View$Lang$SpellLol = function (a) {
	return {$: 10, a: a};
};
var author$project$View$Lang$UnitLol = function (a) {
	return {$: 6, a: a};
};
var author$project$View$Lang$UpgradeLol = function (a) {
	return {$: 8, a: a};
};
var author$project$Game$Tutorial$toString = function (s) {
	switch (s) {
		case 0:
			return 'firstDrone';
		case 1:
			return 'moreDrones';
		case 2:
			return 'firstHatchery';
		case 3:
			return 'firstNotify';
		case 4:
			return 'firstQueen';
		case 5:
			return 'moreQueens';
		case 6:
			return 'firstTerritory';
		case 7:
			return 'moreTerritory';
		case 8:
			return 'firstExpansion';
		case 9:
			return 'moreExpansions';
		case 10:
			return 'firstAscension';
		default:
			return 'firstMutagen';
	}
};
var author$project$GameData$upgradeByName = function (name) {
	return A2(
		elm$core$Basics$composeR,
		author$project$GameData$indexes,
		A2(
			elm$core$Basics$composeR,
			function ($) {
				return $.cO;
			},
			elm$core$Dict$get(name)));
};
var author$project$MessageFormat$format = F2(
	function (getVar, _n0) {
		var tokens = _n0;
		var _eval = function (token) {
			switch (token.$) {
				case 0:
					var text = token.a;
					return elm$core$Result$Ok(text);
				case 1:
					var key = token.a;
					return getVar(key);
				case 2:
					var key = token.a;
					var cases = token.b;
					var other = token.c;
					return A2(
						elm$core$Result$andThen,
						function (n) {
							return A2(
								author$project$MessageFormat$format,
								function (nextKey) {
									return (nextKey === '#') ? elm$core$Result$Ok(n) : getVar(nextKey);
								},
								A2(
									elm$core$Maybe$withDefault,
									other,
									A2(elm$core$Dict$get, n, cases)));
						},
						getVar(key));
				default:
					var key = token.a;
					var cases = token.b;
					var other = token.c;
					return A2(
						elm$core$Result$andThen,
						function (n) {
							return A2(
								author$project$MessageFormat$format,
								getVar,
								A2(
									elm$core$Maybe$withDefault,
									other,
									A2(elm$core$Dict$get, n, cases)));
						},
						getVar(key));
			}
		};
		return A2(
			elm$core$Result$map,
			elm$core$String$join(''),
			elm_community$result_extra$Result$Extra$combine(
				A2(elm$core$List$map, _eval, tokens)));
	});
var author$project$View$Lang$velocitySecs = F2(
	function (item, ctx) {
		var _n0 = _Utils_Tuple2(item, ctx.aL);
		if ((_n0.a === 'energy') && (_n0.b === 4)) {
			var _n1 = _n0.b;
			return 1;
		} else {
			return ctx.cT;
		}
	});
var author$project$View$Lang$velocityUnit = F2(
	function (item, ctx) {
		var _n0 = _Utils_Tuple2(item, ctx.aL);
		if ((_n0.a === 'energy') && (_n0.b === 4)) {
			var _n1 = _n0.b;
			return 0;
		} else {
			return ctx.aL;
		}
	});
var elm$core$Result$map3 = F4(
	function (func, ra, rb, rc) {
		if (ra.$ === 1) {
			var x = ra.a;
			return elm$core$Result$Err(x);
		} else {
			var a = ra.a;
			if (rb.$ === 1) {
				var x = rb.a;
				return elm$core$Result$Err(x);
			} else {
				var b = rb.a;
				if (rc.$ === 1) {
					var x = rc.a;
					return elm$core$Result$Err(x);
				} else {
					var c = rc.a;
					return elm$core$Result$Ok(
						A3(func, a, b, c));
				}
			}
		}
	});
var elm$time$Time$toHour = F2(
	function (zone, time) {
		return A2(
			elm$core$Basics$modBy,
			24,
			A2(
				elm$time$Time$flooredDiv,
				A2(elm$time$Time$toAdjustedMinutes, zone, time),
				60));
	});
var elm$time$Time$toMillis = F2(
	function (_n0, time) {
		return A2(
			elm$core$Basics$modBy,
			1000,
			elm$time$Time$posixToMillis(time));
	});
var elm$time$Time$toMinute = F2(
	function (zone, time) {
		return A2(
			elm$core$Basics$modBy,
			60,
			A2(elm$time$Time$toAdjustedMinutes, zone, time));
	});
var elm$time$Time$toSecond = F2(
	function (_n0, time) {
		return A2(
			elm$core$Basics$modBy,
			60,
			A2(
				elm$time$Time$flooredDiv,
				elm$time$Time$posixToMillis(time),
				1000));
	});
var elm$time$Time$toYear = F2(
	function (zone, time) {
		return elm$time$Time$toCivil(
			A2(elm$time$Time$toAdjustedMinutes, zone, time)).bK;
	});
var elm$time$Time$utc = A2(elm$time$Time$Zone, 0, _List_Nil);
var rtfeldman$elm_iso8601_date_strings$Iso8601$fromMonth = function (month) {
	switch (month) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		case 6:
			return 7;
		case 7:
			return 8;
		case 8:
			return 9;
		case 9:
			return 10;
		case 10:
			return 11;
		default:
			return 12;
	}
};
var elm$core$String$cons = _String_cons;
var elm$core$String$fromChar = function (_char) {
	return A2(elm$core$String$cons, _char, '');
};
var elm$core$Bitwise$shiftRightBy = _Bitwise_shiftRightBy;
var elm$core$String$repeatHelp = F3(
	function (n, chunk, result) {
		return (n <= 0) ? result : A3(
			elm$core$String$repeatHelp,
			n >> 1,
			_Utils_ap(chunk, chunk),
			(!(n & 1)) ? result : _Utils_ap(result, chunk));
	});
var elm$core$String$repeat = F2(
	function (n, chunk) {
		return A3(elm$core$String$repeatHelp, n, chunk, '');
	});
var elm$core$String$padLeft = F3(
	function (n, _char, string) {
		return _Utils_ap(
			A2(
				elm$core$String$repeat,
				n - elm$core$String$length(string),
				elm$core$String$fromChar(_char)),
			string);
	});
var rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString = F2(
	function (digits, time) {
		return A3(
			elm$core$String$padLeft,
			digits,
			'0',
			elm$core$String$fromInt(time));
	});
var rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime = function (time) {
	return A2(
		rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		4,
		A2(elm$time$Time$toYear, elm$time$Time$utc, time)) + ('-' + (A2(
		rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		rtfeldman$elm_iso8601_date_strings$Iso8601$fromMonth(
			A2(elm$time$Time$toMonth, elm$time$Time$utc, time))) + ('-' + (A2(
		rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		A2(elm$time$Time$toDay, elm$time$Time$utc, time)) + ('T' + (A2(
		rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		A2(elm$time$Time$toHour, elm$time$Time$utc, time)) + (':' + (A2(
		rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		A2(elm$time$Time$toMinute, elm$time$Time$utc, time)) + (':' + (A2(
		rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		A2(elm$time$Time$toSecond, elm$time$Time$utc, time)) + ('.' + (A2(
		rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		3,
		A2(elm$time$Time$toMillis, elm$time$Time$utc, time)) + 'Z'))))))))))));
};
var author$project$View$Lang$toString = F6(
	function (messages, format, fools, gameData, ctx, txt) {
		var suffixes = F2(
			function (vars, fullname) {
				var _n20 = vars(fullname);
				if (!_n20.$) {
					var val = _n20.a;
					return elm$core$Result$Ok(val);
				} else {
					var err = _n20.a;
					var _n21 = A2(elm$core$String$split, '.', fullname);
					if (((_n21.b && _n21.b.b) && (_n21.b.a === 'roman')) && (!_n21.b.b.b)) {
						var name = _n21.a;
						var _n22 = _n21.b;
						if (!ctx.$) {
							var upgrades = ctx.a.o;
							var _n24 = A2(author$project$GameData$upgradeByName, name, gameData);
							if (_n24.$ === 1) {
								return elm$core$Result$Err(err);
							} else {
								return elm$core$Result$Ok(
									format.fv(
										A2(
											elm$core$Maybe$withDefault,
											0,
											A2(
												elm$core$Maybe$andThen,
												A2(elm$core$Basics$composeR, author$project$Decimal$floor, elm$core$Result$toMaybe),
												A2(elm$core$Dict$get, name, upgrades)))));
							}
						} else {
							return elm$core$Result$Err(err);
						}
					} else {
						return elm$core$Result$Err(err);
					}
				}
			});
		var foolsVar = _Utils_Tuple2(
			'fools',
			(fools === 1) ? '1' : '0');
		var _eval = F2(
			function (key, getVar) {
				return A2(
					elm$core$Result$andThen,
					author$project$MessageFormat$format(getVar),
					A2(
						elm$core$Result$fromMaybe,
						'no such message: ' + key,
						A2(elm$core$Dict$get, key, messages)));
			});
		var emptyVars = elm$core$Basics$always(
			elm$core$Result$Err('no vars'));
		var velocityLabel = function (df) {
			return A2(
				_eval,
				'velocityUnit.' + author$project$Game$VelocityUnit$toString(df),
				emptyVars);
		};
		var dictVars = function (dict) {
			return function (key) {
				return A2(
					elm$core$Result$fromMaybe,
					'no such var: ' + key,
					A2(elm$core$Dict$get, key, dict));
			};
		};
		var listVars = A2(elm$core$Basics$composeR, elm$core$Dict$fromList, dictVars);
		var spellLabel = F2(
			function (n, spellId) {
				return A2(
					_eval,
					'spell.' + (author$project$GameData$Spell$idToString(spellId) + '.label'),
					listVars(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'n',
								format.c(n)),
								foolsVar
							])));
			});
		var suffixedUnitLabel = F2(
			function (n, unitId) {
				return A2(
					_eval,
					'unit.' + (author$project$GameData$Unit$idToString(unitId) + '.label'),
					suffixes(
						listVars(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'n',
									format.c(n)),
									foolsVar,
									_Utils_Tuple2('suffix', '1')
								]))));
			});
		var unitLabel = F2(
			function (n, unitId) {
				return A2(
					_eval,
					'unit.' + (author$project$GameData$Unit$idToString(unitId) + '.label'),
					listVars(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'n',
								format.c(n)),
								foolsVar,
								_Utils_Tuple2('suffix', '0')
							])));
			});
		var unitListItem = F2(
			function (id, n) {
				return A2(
					elm$core$Result$andThen,
					function (label) {
						return A2(
							_eval,
							'unit.count',
							listVars(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'n',
										format.c(n)),
										_Utils_Tuple2('label', label)
									])));
					},
					A2(unitLabel, n, id));
			});
		var unitList = A2(
			elm$core$Basics$composeR,
			elm$core$List$map(
				function (_n19) {
					var id = _n19.a;
					var d = _n19.b;
					return A2(unitListItem, id, d);
				}),
			A2(
				elm$core$Basics$composeR,
				elm_community$result_extra$Result$Extra$combine,
				elm$core$Result$map(format.b7)));
		var upgradeLabel = function (upgradeId) {
			return A2(
				_eval,
				'upgrade.' + (author$project$GameData$Upgrade$idToString(upgradeId) + '.label'),
				listVars(
					_List_fromArray(
						[foolsVar])));
		};
		var itemLabel = F2(
			function (n, itemId) {
				switch (itemId.$) {
					case 0:
						var uid = itemId.a;
						return A2(unitLabel, n, uid);
					case 1:
						var uid = itemId.a;
						return upgradeLabel(uid);
					default:
						var uid = itemId.a;
						return A2(spellLabel, n, uid);
				}
			});
		var suffixedItemLabel = F2(
			function (n, itemId) {
				switch (itemId.$) {
					case 0:
						var uid = itemId.a;
						return A2(suffixedUnitLabel, n, uid);
					case 1:
						var uid = itemId.a;
						return upgradeLabel(uid);
					default:
						var uid = itemId.a;
						return A2(spellLabel, n, uid);
				}
			});
		var descriptionFormat = F2(
			function (varsFn0, name) {
				var varsFn = function (name_) {
					if (name_ === 'fools') {
						return elm$core$Result$Ok(
							(fools === 1) ? author$project$Decimal$one : author$project$Decimal$zero);
					} else {
						return varsFn0(name_);
					}
				};
				var _var = F2(
					function (chunks, fmt) {
						return A2(
							elm$core$Result$map,
							fmt,
							varsFn(
								A2(
									elm$core$String$join,
									'.',
									elm$core$List$reverse(chunks))));
					});
				var _n15 = elm$core$List$reverse(
					A2(elm$core$String$split, '.', name));
				_n15$6:
				while (true) {
					if (_n15.b) {
						switch (_n15.a) {
							case 'decimal':
								var chunks = _n15.b;
								return A2(_var, chunks, format.c);
							case 'smallDecimal':
								var chunks = _n15.b;
								return A2(_var, chunks, format.bB);
							case 'percent1':
								var chunks = _n15.b;
								return A2(
									_var,
									chunks,
									A2(elm$core$Basics$composeR, author$project$Decimal$toFloat, format.cr));
							case 'percent':
								var chunks = _n15.b;
								return A2(
									_var,
									chunks,
									A2(elm$core$Basics$composeR, author$project$Decimal$toFloat, format.dC));
							case 'longDuration':
								var chunks = _n15.b;
								return A2(
									_var,
									chunks,
									A2(
										elm$core$Basics$composeR,
										author$project$Decimal$toFloat,
										A2(elm$core$Basics$composeR, author$project$Duration$fromSecs, format.b9)));
							case 'shortDuration':
								var chunks = _n15.b;
								return A2(
									_var,
									chunks,
									A2(
										elm$core$Basics$composeR,
										author$project$Decimal$toFloat,
										A2(elm$core$Basics$composeR, author$project$Duration$fromSecs, format.bA)));
							default:
								break _n15$6;
						}
					} else {
						break _n15$6;
					}
				}
				return A2(
					elm$core$Result$map,
					format.c,
					varsFn(name));
			});
		switch (txt.$) {
			case 4:
				var d = txt.a;
				return elm$core$Result$Ok(
					format.c(d));
			case 0:
				return A2(_eval, 'title', emptyVars);
			case 1:
				return A2(_eval, 'header', emptyVars);
			case 2:
				var fps = txt.a;
				var max = txt.b.dw;
				var avg = txt.b.eg;
				return A2(
					_eval,
					'frameRate',
					listVars(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'fps',
								format.eS(fps)),
								_Utils_Tuple2(
								'max',
								format.eS(
									author$project$Duration$toMillis(max))),
								_Utils_Tuple2(
								'avg',
								format.eS(
									author$project$Duration$toMillis(avg)))
							])));
			case 3:
				return A2(_eval, 'updateNow', emptyVars);
			case 5:
				var varsFn = txt.a;
				var unitId = txt.b;
				return A2(
					_eval,
					'unit.' + (author$project$GameData$Unit$idToString(unitId) + '.desc'),
					descriptionFormat(varsFn));
			case 7:
				var varsFn = txt.a;
				var upgradeId = txt.b;
				return A2(
					_eval,
					'upgrade.' + (author$project$GameData$Upgrade$idToString(upgradeId) + '.desc'),
					descriptionFormat(varsFn));
			case 9:
				var varsFn = txt.a;
				var spellId = txt.b;
				return A2(
					_eval,
					'spell.' + (author$project$GameData$Spell$idToString(spellId) + '.desc'),
					descriptionFormat(varsFn));
			case 6:
				var unitId = txt.a;
				return A2(
					_eval,
					'unit.' + (author$project$GameData$Unit$idToString(unitId) + '.lol'),
					emptyVars);
			case 8:
				var upgradeId = txt.a;
				return A2(
					_eval,
					'upgrade.' + (author$project$GameData$Upgrade$idToString(upgradeId) + '.lol'),
					emptyVars);
			case 10:
				var spellId = txt.a;
				return A2(
					_eval,
					'spell.' + (author$project$GameData$Spell$idToString(spellId) + '.lol'),
					emptyVars);
			case 11:
				var n = txt.a;
				var itemId = txt.b;
				return A2(itemLabel, n, itemId);
			case 12:
				var achieveId = txt.a;
				return A2(
					_eval,
					'achievement.' + (author$project$GameData$Achievement$idToString(achieveId) + '.label'),
					emptyVars);
			case 13:
				if (!txt.b.$) {
					var achieveId = txt.a;
					var _n1 = txt.b.a;
					var itemId = _n1.a;
					var threshold = _n1.b;
					var type_ = function () {
						switch (itemId.$) {
							case 0:
								return 'unit';
							case 1:
								return 'upgrade';
							default:
								return 'spell';
						}
					}();
					var key = 'achievement.' + (author$project$GameData$Item$idToString(itemId) + '.desc');
					return A2(
						elm$core$Result$andThen,
						function (vars) {
							return A2(elm$core$Dict$member, key, messages) ? A2(
								_eval,
								key,
								listVars(vars)) : A2(
								_eval,
								'achievement.desc.' + type_,
								listVars(vars));
						},
						A2(
							elm$core$Result$map,
							function (label) {
								return _List_fromArray(
									[
										_Utils_Tuple2('label', label),
										_Utils_Tuple2(
										'threshold',
										format.c(threshold))
									]);
							},
							A2(itemLabel, threshold, itemId)));
				} else {
					var achieveId = txt.a;
					var mItem = txt.b;
					return A2(
						elm$core$Result$andThen,
						function (varList) {
							return A2(
								_eval,
								'achievement.' + (author$project$GameData$Achievement$idToString(achieveId) + '.desc'),
								listVars(varList));
						},
						function () {
							if (!mItem.$) {
								var _n4 = mItem.a;
								var itemId = _n4.a;
								var threshold = _n4.b;
								return A2(
									elm$core$Result$map,
									function (label) {
										return _List_fromArray(
											[
												_Utils_Tuple2('label', label),
												_Utils_Tuple2(
												'threshold',
												format.c(threshold))
											]);
									},
									A2(itemLabel, threshold, itemId));
							} else {
								return elm$core$Result$Ok(_List_Nil);
							}
						}());
				}
			case 14:
				var achieveId = txt.a;
				return elm$core$Result$Ok(
					A2(
						elm$core$Result$withDefault,
						'',
						A2(
							_eval,
							'achievement.' + (author$project$GameData$Achievement$idToString(achieveId) + '.longdesc'),
							emptyVars)));
			case 15:
				return A2(_eval, 'view.error.title', emptyVars);
			case 16:
				var at = txt.a.bR;
				var now = txt.a.cm;
				return A2(
					_eval,
					'view.error.time',
					listVars(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'at',
								format.ev(at))
							])));
			case 17:
				return A2(_eval, 'view.error.time.unknown', emptyVars);
			case 18:
				var n = txt.a;
				return A2(
					_eval,
					'view.error.more',
					listVars(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'n',
								format.eS(n))
							])));
			case 19:
				return A2(_eval, 'view.error.closeButton', emptyVars);
			case 20:
				return A2(_eval, 'view.error.game.load', emptyVars);
			case 21:
				return A2(_eval, 'view.error.game.export', emptyVars);
			case 22:
				return A2(_eval, 'view.error.game.bug', emptyVars);
			case 23:
				return A2(_eval, 'view.error.game.reportButton', emptyVars);
			case 24:
				return A2(_eval, 'view.error.game.resetButton', emptyVars);
			case 25:
				var id = txt.a;
				return A2(suffixedUnitLabel, author$project$Decimal$one, id);
			case 26:
				var id = txt.a;
				return A2(spellLabel, author$project$Decimal$one, id);
			case 27:
				return A2(_eval, 'view.unitSidebar.achievementPoints', emptyVars);
			case 28:
				var d = txt.a;
				return elm$core$Result$Ok(
					format.Q(d));
			case 29:
				var unit = txt.a;
				var v = txt.b;
				var vs = A3(
					elm_community$maybe_extra$Maybe$Extra$unwrap,
					1,
					author$project$View$Lang$velocitySecs(
						author$project$GameData$Unit$name(unit)),
					ctx);
				var formatter = A2(author$project$Decimal$lt, v, author$project$Decimal$one) ? format.fD : format.Q;
				return A2(
					elm$core$Result$andThen,
					function (vu) {
						return A2(
							_eval,
							'view.tab.velocity',
							listVars(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'velocity',
										formatter(
											A2(author$project$Decimal$mulFloat, vs, v))),
										_Utils_Tuple2(
										'velocityUnit',
										author$project$Game$VelocityUnit$toString(
											A3(
												elm_community$maybe_extra$Maybe$Extra$unwrap,
												author$project$Game$VelocityUnit$default,
												author$project$View$Lang$velocityUnit(
													author$project$GameData$Unit$name(unit)),
												ctx)))
									])));
					},
					velocityLabel(
						A3(
							elm_community$maybe_extra$Maybe$Extra$unwrap,
							author$project$Game$VelocityUnit$default,
							author$project$View$Lang$velocityUnit(
								author$project$GameData$Unit$name(unit)),
							ctx)));
			case 30:
				var unitId = txt.a;
				return A2(suffixedUnitLabel, author$project$Decimal$one, unitId);
			case 31:
				var n = txt.a;
				var unitId = txt.b;
				return A2(
					elm$core$Result$andThen,
					function (label) {
						return A2(
							_eval,
							'view.unit.count',
							listVars(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'n',
										format.c(n)),
										_Utils_Tuple2(
										'name',
										author$project$GameData$Unit$idToString(unitId)),
										_Utils_Tuple2('label', label)
									])));
					},
					A2(suffixedUnitLabel, n, unitId));
			case 32:
				var n = txt.a;
				var cap = txt.b;
				var unitId = txt.c;
				return A2(
					elm$core$Result$andThen,
					function (label) {
						return A2(
							_eval,
							'view.unit.count.capped',
							listVars(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'n',
										format.c(n)),
										_Utils_Tuple2(
										'cap',
										format.c(cap)),
										_Utils_Tuple2(
										'name',
										author$project$GameData$Unit$idToString(unitId)),
										_Utils_Tuple2('label', label)
									])));
					},
					A2(suffixedUnitLabel, n, unitId));
			case 33:
				var prod = txt.a;
				var vs = A3(
					elm_community$maybe_extra$Maybe$Extra$unwrap,
					1,
					author$project$View$Lang$velocitySecs(
						author$project$GameData$Unit$idToString(prod.dJ.eL)),
					ctx);
				var formatter = A2(author$project$Decimal$lt, prod.cY, author$project$Decimal$one) ? format.bB : format.c;
				return A2(
					elm$core$Result$andThen,
					elm$core$Basics$identity,
					A3(
						elm$core$Result$map2,
						F2(
							function (label, vu) {
								return A2(
									_eval,
									'view.unit.prod.each',
									listVars(
										_List_fromArray(
											[
												_Utils_Tuple2('label', label),
												_Utils_Tuple2('velocityUnit', vu),
												_Utils_Tuple2(
												'each',
												formatter(
													A2(author$project$Decimal$mulFloat, vs, prod.db))),
												_Utils_Tuple2(
												'bonus',
												format.bB(prod.c_))
											])));
							}),
						A2(unitLabel, prod.db, prod.dJ.eL),
						velocityLabel(
							A3(
								elm_community$maybe_extra$Maybe$Extra$unwrap,
								author$project$Game$VelocityUnit$default,
								author$project$View$Lang$velocityUnit(
									author$project$GameData$Unit$idToString(prod.dJ.eL)),
								ctx))));
			case 34:
				var prod = txt.a;
				var vs = A3(
					elm_community$maybe_extra$Maybe$Extra$unwrap,
					1,
					author$project$View$Lang$velocitySecs(
						author$project$GameData$Unit$idToString(prod.dJ.eL)),
					ctx);
				var formatter = A2(author$project$Decimal$lt, prod.cY, author$project$Decimal$one) ? format.bB : format.c;
				return A2(
					elm$core$Result$andThen,
					elm$core$Basics$identity,
					A3(
						elm$core$Result$map2,
						F2(
							function (label, vu) {
								return A2(
									_eval,
									'view.unit.prod.total',
									listVars(
										_List_fromArray(
											[
												_Utils_Tuple2('label', label),
												_Utils_Tuple2('velocityUnit', vu),
												_Utils_Tuple2(
												'total',
												formatter(
													A2(author$project$Decimal$mulFloat, vs, prod.d2))),
												_Utils_Tuple2(
												'bonus',
												format.c(prod.c_))
											])));
							}),
						A2(unitLabel, prod.d2, prod.dJ.eL),
						velocityLabel(
							A3(
								elm_community$maybe_extra$Maybe$Extra$unwrap,
								author$project$Game$VelocityUnit$default,
								author$project$View$Lang$velocityUnit(
									author$project$GameData$Unit$idToString(prod.dJ.eL)),
								ctx))));
			case 35:
				var n0 = txt.a;
				var unitId = txt.b;
				var costs0 = txt.c;
				return A2(
					elm$core$Result$andThen,
					elm$core$Basics$identity,
					A3(
						elm$core$Result$map2,
						F2(
							function (label, costs) {
								return A2(
									_eval,
									'view.unit.buyCost',
									listVars(
										_List_fromArray(
											[
												_Utils_Tuple2('label', label),
												_Utils_Tuple2('costs', costs),
												_Utils_Tuple2(
												'n',
												format.c(
													author$project$GameData$Item$resToDec(n0))),
												_Utils_Tuple2(
												'name',
												author$project$GameData$Unit$idToString(unitId))
											])));
							}),
						A2(
							suffixedUnitLabel,
							author$project$GameData$Item$resToDec(n0),
							unitId),
						unitList(costs0)));
			case 36:
				return A2(_eval, 'view.unit.upgrades.title', emptyVars);
			case 37:
				var n = txt.a;
				var upgradeId = txt.b;
				return A2(
					elm$core$Result$andThen,
					function (label) {
						return A2(
							_eval,
							'view.unit.upgrade.header',
							listVars(
								_List_fromArray(
									[
										_Utils_Tuple2('label', label),
										_Utils_Tuple2(
										'n',
										format.c(n))
									])));
					},
					upgradeLabel(upgradeId));
			case 38:
				var costs0 = txt.a;
				return A2(
					elm$core$Result$andThen,
					function (costs) {
						return A2(
							_eval,
							'view.unit.upgrade.buyCost',
							listVars(
								_List_fromArray(
									[
										_Utils_Tuple2('costs', costs)
									])));
					},
					unitList(costs0));
			case 39:
				var n0 = txt.a;
				return A2(
					_eval,
					'view.unit.buyN',
					listVars(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'n',
								format.c(
									author$project$GameData$Item$resToDec(n0)))
							])));
			case 40:
				return A2(_eval, 'view.unit.cantBuy', emptyVars);
			case 41:
				return A2(_eval, 'view.unit.ascend', emptyVars);
			case 42:
				var unitId = txt.a;
				var velocity = txt.b;
				var vs = A3(
					elm_community$maybe_extra$Maybe$Extra$unwrap,
					1,
					author$project$View$Lang$velocitySecs(
						author$project$GameData$Unit$idToString(unitId)),
					ctx);
				return A2(
					elm$core$Result$andThen,
					elm$core$Basics$identity,
					A3(
						elm$core$Result$map2,
						F2(
							function (label, vu) {
								return A2(
									_eval,
									'view.unit.velocity',
									listVars(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'velocity',
												format.c(
													A2(author$project$Decimal$mulFloat, vs, velocity))),
												_Utils_Tuple2('label', label),
												_Utils_Tuple2('velocityUnit', vu)
											])));
							}),
						A2(unitLabel, author$project$Decimal$zero, unitId),
						velocityLabel(
							A3(
								elm_community$maybe_extra$Maybe$Extra$unwrap,
								author$project$Game$VelocityUnit$default,
								author$project$View$Lang$velocityUnit(
									author$project$GameData$Unit$idToString(unitId)),
								ctx))));
			case 43:
				var unitId = txt.a;
				var rate = txt.b.cu;
				var percentPerCost = txt.b.dD;
				var vs = A3(
					elm_community$maybe_extra$Maybe$Extra$unwrap,
					1,
					author$project$View$Lang$velocitySecs(
						author$project$GameData$Unit$idToString(unitId)),
					ctx);
				var entry = F2(
					function (id, percent) {
						return A2(
							elm$core$Result$andThen,
							function (label) {
								return A2(
									_eval,
									'view.unit.hatchableRate.percent',
									listVars(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'percent',
												format.dC(percent)),
												_Utils_Tuple2('label', label)
											])));
							},
							A2(unitLabel, author$project$Decimal$one, id));
					});
				var list = A2(
					elm$core$Basics$composeR,
					elm$core$List$map(
						function (_n5) {
							var id = _n5.a;
							var pct = _n5.b;
							return A2(entry, id, pct);
						}),
					A2(
						elm$core$Basics$composeR,
						elm_community$result_extra$Result$Extra$combine,
						elm$core$Result$map(format.b7)));
				return A2(
					elm$core$Result$andThen,
					elm$core$Basics$identity,
					A4(
						elm$core$Result$map3,
						F3(
							function (label, percents, vu) {
								return A2(
									_eval,
									'view.unit.hatchableRate',
									listVars(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'rate',
												format.c(
													A2(author$project$Decimal$mulFloat, vs, rate))),
												_Utils_Tuple2('label', label),
												_Utils_Tuple2('velocityUnit', vu),
												_Utils_Tuple2('percentList', percents)
											])));
							}),
						A2(unitLabel, author$project$Decimal$zero, unitId),
						list(percentPerCost),
						velocityLabel(
							A3(
								elm_community$maybe_extra$Maybe$Extra$unwrap,
								author$project$Game$VelocityUnit$default,
								author$project$View$Lang$velocityUnit(
									author$project$GameData$Unit$idToString(unitId)),
								ctx))));
			case 44:
				var spellId = txt.a;
				return A2(spellLabel, author$project$Decimal$one, spellId);
			case 45:
				var n0 = txt.a;
				var spellId = txt.b;
				var costs0 = txt.c;
				return A2(
					elm$core$Result$andThen,
					elm$core$Basics$identity,
					A3(
						elm$core$Result$map2,
						F2(
							function (label, costs) {
								return A2(
									_eval,
									'view.spell.buyCost',
									listVars(
										_List_fromArray(
											[
												_Utils_Tuple2('label', label),
												_Utils_Tuple2('costs', costs),
												_Utils_Tuple2(
												'n',
												format.c(
													author$project$GameData$Item$resToDec(n0))),
												_Utils_Tuple2(
												'name',
												author$project$GameData$Spell$idToString(spellId))
											])));
							}),
						A2(
							spellLabel,
							author$project$GameData$Item$resToDec(n0),
							spellId),
						unitList(costs0)));
			case 46:
				return A2(_eval, 'view.ascend.plot', emptyVars);
			case 47:
				var n0 = txt.a;
				var costs0 = txt.b;
				var getVar = txt.c;
				return A2(
					elm$core$Result$andThen,
					elm$core$Basics$identity,
					A2(
						elm$core$Result$map,
						function (costs) {
							var vars = listVars(
								_List_fromArray(
									[
										_Utils_Tuple2('costs', costs),
										_Utils_Tuple2(
										'n',
										format.c(
											author$project$GameData$Item$resToDec(n0)))
									]));
							return A2(
								_eval,
								'view.unit.buyCost.ascend',
								function (key) {
									var _n6 = vars(key);
									if (!_n6.$) {
										var val = _n6.a;
										return elm$core$Result$Ok(val);
									} else {
										var err = _n6.a;
										return elm$core$Result$Ok(
											format.c(
												A2(
													elm$core$Maybe$withDefault,
													author$project$Decimal$zero,
													getVar(key))));
									}
								});
						},
						unitList(costs0)));
			case 48:
				var diff = txt.a;
				return A2(
					_eval,
					'view.ascend.progress.capDiff',
					listVars(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'diff',
								format.c(diff))
							])));
			case 49:
				var unitId = txt.a;
				var n = txt.b;
				var p = txt.c;
				return A2(
					elm$core$Result$andThen,
					function (label) {
						var _n7 = _Utils_Tuple2(p.c1, p.c7);
						if (!_n7.a.$) {
							var capPct = _n7.a.a;
							return A2(
								_eval,
								'view.tabnav.count.capped',
								listVars(
									_List_fromArray(
										[
											_Utils_Tuple2('label', label),
											_Utils_Tuple2(
											'n',
											format.Q(n)),
											_Utils_Tuple2(
											'capPct',
											format.dC(capPct))
										])));
						} else {
							if (!_n7.b.$) {
								var _n8 = _n7.a;
								var n2 = _n7.b.a;
								return A2(
									_eval,
									'view.tabnav.count.precount',
									listVars(
										_List_fromArray(
											[
												_Utils_Tuple2('label', label),
												_Utils_Tuple2(
												'n',
												format.Q(n)),
												_Utils_Tuple2(
												'n2',
												format.Q(n2))
											])));
							} else {
								return A2(
									_eval,
									'view.tabnav.count.uncapped',
									listVars(
										_List_fromArray(
											[
												_Utils_Tuple2('label', label),
												_Utils_Tuple2(
												'n',
												format.Q(n))
											])));
							}
						}
					},
					A2(unitLabel, n, unitId));
			case 50:
				var unitId = txt.a;
				return A2(unitLabel, author$project$Decimal$one, unitId);
			case 51:
				var n = txt.a;
				return elm$core$Result$Ok(
					format.Q(n));
			case 52:
				var n = txt.a;
				var p = txt.b;
				var _n9 = _Utils_Tuple2(p.c1, p.c7);
				if (!_n9.a.$) {
					var capPct = _n9.a.a;
					return A2(
						_eval,
						'view.tabnav.count.capped',
						listVars(
							_List_fromArray(
								[
									_Utils_Tuple2('label', ''),
									_Utils_Tuple2('n', ''),
									_Utils_Tuple2(
									'capPct',
									format.dC(capPct))
								])));
				} else {
					if (!_n9.b.$) {
						var _n10 = _n9.a;
						var n2 = _n9.b.a;
						return A2(
							_eval,
							'view.tabnav.count.precount',
							listVars(
								_List_fromArray(
									[
										_Utils_Tuple2('label', ''),
										_Utils_Tuple2('n', ''),
										_Utils_Tuple2(
										'n2',
										format.Q(n2))
									])));
					} else {
						return elm$core$Result$Ok('\u00a0');
					}
				}
			case 53:
				return A2(_eval, 'view.tabnav.more', emptyVars);
			case 54:
				var n = txt.a;
				return A2(
					_eval,
					'view.tabnav.buyAll',
					listVars(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'n',
								format.eS(n))
							])));
			case 55:
				var n = txt.a;
				return A2(
					_eval,
					'view.tabnav.buyCheapest',
					listVars(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'n',
								format.eS(n))
							])));
			case 56:
				return A2(_eval, 'view.tabnav.undo', emptyVars);
			case 57:
				var dur = txt.a;
				return A2(
					_eval,
					'view.tabnav.undo.duration',
					listVars(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'duration',
								format.eS(
									elm$core$Basics$floor(
										author$project$Duration$toSecs(dur))))
							])));
			case 58:
				return A2(_eval, 'view.tabnav.options', emptyVars);
			case 59:
				return A2(_eval, 'view.tabnav.achievements', emptyVars);
			case 60:
				return A2(_eval, 'view.tabnav.statistics', emptyVars);
			case 61:
				return A2(_eval, 'view.tabnav.changelog', emptyVars);
			case 62:
				return A2(_eval, 'view.tabnav.community', emptyVars);
			case 63:
				return A2(_eval, 'view.tabnav.feedback', emptyVars);
			case 64:
				return A2(_eval, 'view.tabnav.bugReport', emptyVars);
			case 65:
				return A2(_eval, 'view.tabnav.allUnits', emptyVars);
			case 66:
				return A2(_eval, 'view.tabnav.login', emptyVars);
			case 67:
				return A2(_eval, 'view.tabnav.register', emptyVars);
			case 68:
				return A2(_eval, 'view.tabnav.hotkeys', emptyVars);
			case 69:
				return A2(_eval, 'view.tabnav.user.loading', emptyVars);
			case 70:
				return A2(_eval, 'view.tabnav.user.error', emptyVars);
			case 71:
				return A2(_eval, 'view.tabnav.user.conflict', emptyVars);
			case 72:
				return A2(_eval, 'view.tabnav.user.konglogin', emptyVars);
			case 73:
				return A2(_eval, 'view.options.title', emptyVars);
			case 74:
				return A2(_eval, 'view.options.export', emptyVars);
			case 75:
				return A2(_eval, 'view.options.export.empty', emptyVars);
			case 76:
				return A2(_eval, 'view.options.reset.link', emptyVars);
			case 77:
				return A2(_eval, 'view.options.reset.warning', emptyVars);
			case 78:
				return A2(_eval, 'view.options.reset.cancel', emptyVars);
			case 79:
				return A2(_eval, 'view.options.reset.confirm', emptyVars);
			case 80:
				return A2(_eval, 'view.options.reset.helpTranslate', emptyVars);
			case 81:
				var locale = txt.a;
				return A2(
					_eval,
					'locale.' + author$project$Locale$toString(locale),
					emptyVars);
			case 82:
				var theme = txt.a;
				return A2(
					_eval,
					'view.options.theme',
					listVars(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'theme',
								author$project$Game$Theme$toString(theme))
							])));
			case 83:
				var nf = txt.a;
				return A2(
					_eval,
					'numberFormat.' + author$project$Game$NumberFormat$toString(nf),
					emptyVars);
			case 84:
				var df = txt.a;
				return A2(
					_eval,
					'view.options.velocityUnit.' + author$project$Game$VelocityUnit$toString(df),
					emptyVars);
			case 86:
				var nextDebug = txt.a;
				return nextDebug ? A2(_eval, 'view.options.debug.enable', emptyVars) : A2(_eval, 'view.options.debug.disable', emptyVars);
			case 85:
				var nextFps = txt.a;
				return nextFps ? A2(_eval, 'view.options.fps.enable', emptyVars) : A2(_eval, 'view.options.fps.disable', emptyVars);
			case 87:
				return A2(_eval, 'view.options.analytics.desc', emptyVars);
			case 88:
				return A2(_eval, 'view.options.analytics.optOutLink', emptyVars);
			case 89:
				return A2(_eval, 'view.options.analytics.privacyLink', emptyVars);
			case 90:
				return A2(_eval, 'view.statistics.title', emptyVars);
			case 91:
				return A2(_eval, 'view.statistics.label.name', emptyVars);
			case 92:
				return A2(_eval, 'view.statistics.label.created', emptyVars);
			case 93:
				return A2(_eval, 'view.statistics.label.clicks', emptyVars);
			case 94:
				return A2(_eval, 'view.statistics.label.rawCount', emptyVars);
			case 95:
				return A2(_eval, 'view.statistics.label.twinCount', emptyVars);
			case 97:
				var duration = txt.a;
				return elm$core$Result$Ok(
					format.bA(duration));
			case 96:
				var n = txt.a;
				return elm$core$Result$Ok(
					format.eS(n));
			case 98:
				var d = txt.a;
				return elm$core$Result$Ok(
					format.c(d));
			case 99:
				return A2(_eval, 'view.statistics.label.persist.size', emptyVars);
			case 100:
				var mn = txt.a;
				if (mn.$ === 1) {
					return A2(_eval, 'view.statistics.persist.size.empty', emptyVars);
				} else {
					var n = mn.a;
					return A2(
						_eval,
						'view.statistics.persist.size',
						listVars(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'n',
									format.eS(n))
								])));
				}
			case 101:
				return A2(_eval, 'view.statistics.label.persist.created', emptyVars);
			case 103:
				var now = txt.a.cm;
				var created = txt.a.H;
				return A2(
					_eval,
					'view.statistics.persist.created',
					listVars(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'ago',
								format.bA(
									author$project$Duration$since(
										{eb: now, eh: created}))),
								_Utils_Tuple2(
								'created',
								rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime(created))
							])));
			case 102:
				var id = txt.a;
				return A2(itemLabel, author$project$Decimal$one, id);
			case 104:
				var points = txt.a;
				return A2(
					_eval,
					'view.achievements.title',
					listVars(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'points',
								format.eS(points))
							])));
			case 105:
				var pct = txt.a;
				return A2(
					_eval,
					'view.achievements.progress',
					listVars(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'pct',
								format.dC(pct))
							])));
			case 106:
				var at = txt.a.bR;
				var now = txt.a.cm;
				return A2(
					_eval,
					'view.achievements.entry.earned',
					listVars(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'at',
								A2(format.fq, at, now))
							])));
			case 107:
				var pct = txt.a;
				var count = txt.b;
				var total = txt.c;
				return A2(
					_eval,
					'view.achievements.entry.progress',
					listVars(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'pct',
								format.dC(pct)),
								_Utils_Tuple2(
								'count',
								format.c(count)),
								_Utils_Tuple2(
								'total',
								format.c(total))
							])));
			case 108:
				return A2(_eval, 'view.achievements.entry.masked', emptyVars);
			case 109:
				return A2(_eval, 'view.achievements.entry.unlocked', emptyVars);
			case 110:
				var bonus = txt.a;
				return A2(
					_eval,
					'view.achievements.bonus',
					listVars(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'bonus',
								format.cr(bonus))
							])));
			case 111:
				return A2(_eval, 'view.achievements.options.visible', emptyVars);
			case 112:
				return A2(_eval, 'view.achievements.options.visible.earned', emptyVars);
			case 113:
				return A2(_eval, 'view.achievements.options.visible.unearned', emptyVars);
			case 114:
				return A2(_eval, 'view.achievements.options.visible.masked', emptyVars);
			case 115:
				return A2(_eval, 'view.achievements.options.order', emptyVars);
			case 116:
				return A2(_eval, 'view.achievements.options.order.default', emptyVars);
			case 117:
				return A2(_eval, 'view.achievements.options.order.completion', emptyVars);
			case 118:
				return A2(_eval, 'view.achievements.options.reverse.true', emptyVars);
			case 119:
				return A2(_eval, 'view.achievements.options.reverse.false', emptyVars);
			case 120:
				var n0 = txt.a;
				var itemId = txt.b;
				return A2(
					elm$core$Result$andThen,
					elm$core$Basics$identity,
					A2(
						elm$core$Result$map,
						function (label) {
							return A2(
								_eval,
								'view.cost.min',
								listVars(
									_List_fromArray(
										[
											_Utils_Tuple2('label', label),
											_Utils_Tuple2(
											'n',
											format.c(
												author$project$GameData$Item$resToDec(n0))),
											_Utils_Tuple2(
											'name',
											author$project$GameData$Item$idToString(itemId))
										])));
						},
						A2(
							suffixedItemLabel,
							author$project$GameData$Item$resToDec(n0),
							itemId)));
			case 121:
				var currency = txt.a.bS;
				var cost = txt.a.es;
				var pct = txt.b;
				return A2(
					elm$core$Result$andThen,
					function (label) {
						return A2(
							_eval,
							'view.cost.met',
							listVars(
								_List_fromArray(
									[
										_Utils_Tuple2('currency', label),
										_Utils_Tuple2(
										'cost',
										format.c(cost)),
										_Utils_Tuple2(
										'percent',
										format.dC(pct))
									])));
					},
					A2(unitLabel, cost, currency));
			case 122:
				var currency = txt.a.bS;
				var cost = txt.a.es;
				var pct = txt.b;
				var duration = txt.c;
				return A2(
					elm$core$Result$andThen,
					function (label) {
						if (duration.$ === 1) {
							return A2(
								_eval,
								'view.cost.notmet',
								listVars(
									_List_fromArray(
										[
											_Utils_Tuple2('currency', label),
											_Utils_Tuple2(
											'cost',
											format.c(cost)),
											_Utils_Tuple2(
											'percent',
											format.dC(pct))
										])));
						} else {
							var d = duration.a;
							return A2(
								_eval,
								'view.cost.notmet.duration',
								listVars(
									_List_fromArray(
										[
											_Utils_Tuple2('currency', label),
											_Utils_Tuple2(
											'cost',
											format.c(cost)),
											_Utils_Tuple2(
											'percent',
											format.dC(pct)),
											_Utils_Tuple2(
											'duration',
											format.bA(d))
										])));
						}
					},
					A2(unitLabel, cost, currency));
			case 123:
				return A2(_eval, 'view.fools.invited.lol', emptyVars);
			case 124:
				return A2(_eval, 'view.fools.invited.title', emptyVars);
			case 125:
				return A2(_eval, 'view.fools.invited.body', emptyVars);
			case 126:
				return A2(_eval, 'view.fools.invited.link', emptyVars);
			case 127:
				return A2(_eval, 'view.fools.on.lol', emptyVars);
			case 128:
				return A2(_eval, 'view.fools.on.title', emptyVars);
			case 129:
				return A2(_eval, 'view.fools.on.body', emptyVars);
			case 130:
				return A2(_eval, 'view.fools.on.link', emptyVars);
			case 131:
				return A2(_eval, 'view.fools.after.title', emptyVars);
			case 132:
				return A2(_eval, 'view.fools.after.link', emptyVars);
			case 133:
				return A2(_eval, 'view.conflict.title', emptyVars);
			case 134:
				return A2(_eval, 'view.conflict.desc', emptyVars);
			case 135:
				return A2(_eval, 'view.conflict.export.local', emptyVars);
			case 136:
				return A2(_eval, 'view.conflict.export.remote', emptyVars);
			case 137:
				var created = txt.a;
				return A2(
					_eval,
					'view.conflict.game.created',
					listVars(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'created',
								rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime(created))
							])));
			case 139:
				return A2(_eval, 'view.conflict.button.local', emptyVars);
			case 140:
				return A2(_eval, 'view.conflict.button.logout', emptyVars);
			case 141:
				return A2(_eval, 'view.conflict.button.remote', emptyVars);
			case 138:
				var encoded = txt.a;
				return A2(
					_eval,
					'view.conflict.game.encoded',
					listVars(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'encoded',
								rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime(encoded))
							])));
			case 142:
				return A2(_eval, 'view.login.title', emptyVars);
			case 143:
				return A2(_eval, 'view.login.field.email', emptyVars);
			case 144:
				return A2(_eval, 'view.login.field.password', emptyVars);
			case 145:
				return A2(_eval, 'view.login.field.rememberme', emptyVars);
			case 146:
				return A2(_eval, 'view.login.submit', emptyVars);
			case 147:
				return A2(_eval, 'view.login.link.register', emptyVars);
			case 148:
				return A2(_eval, 'view.login.link.resetpassword', emptyVars);
			case 149:
				return A2(_eval, 'view.register.title', emptyVars);
			case 150:
				return A2(_eval, 'view.register.field.email', emptyVars);
			case 151:
				return A2(_eval, 'view.register.field.password', emptyVars);
			case 152:
				return A2(_eval, 'view.register.field.password2', emptyVars);
			case 153:
				return A2(_eval, 'view.register.field.rememberme', emptyVars);
			case 154:
				return A2(_eval, 'view.register.submit', emptyVars);
			case 155:
				return A2(_eval, 'view.register.link.login', emptyVars);
			case 156:
				return A2(_eval, 'view.user.anonymous', emptyVars);
			case 157:
				return A2(_eval, 'view.user.anonymous.login', emptyVars);
			case 158:
				return A2(_eval, 'view.user.anonymous.register', emptyVars);
			case 159:
				return A2(_eval, 'view.user.title', emptyVars);
			case 160:
				return A2(_eval, 'view.user.desc.push1', emptyVars);
			case 161:
				var dur = txt.a;
				return A2(
					_eval,
					'view.user.desc.push2',
					listVars(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'duration',
								format.bE(dur))
							])));
			case 162:
				var dur = txt.a;
				return A2(
					_eval,
					'view.user.push.success',
					listVars(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'succeeded',
								format.bE(dur))
							])));
			case 163:
				var dur = txt.a;
				return A2(
					_eval,
					'view.user.push.failure',
					listVars(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'requested',
								format.bE(dur))
							])));
			case 164:
				return A2(_eval, 'view.user.push.none', emptyVars);
			case 165:
				var err = txt.a;
				return A2(
					_eval,
					'view.user.push.error',
					listVars(
						_List_fromArray(
							[
								_Utils_Tuple2('error', err)
							])));
			case 166:
				return A2(_eval, 'view.user.push.cooldown.ready', emptyVars);
			case 167:
				var dur = txt.a;
				var pct = txt.b;
				return A2(
					_eval,
					'view.user.push.cooldown.notready',
					listVars(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'requested',
								format.bE(dur)),
								_Utils_Tuple2(
								'percent',
								format.dC(pct))
							])));
			case 168:
				return A2(_eval, 'view.user.button.forcepush', emptyVars);
			case 169:
				return A2(_eval, 'view.user.button.logout', emptyVars);
			case 170:
				return A2(_eval, 'view.user.button.password', emptyVars);
			case 171:
				return A2(_eval, 'view.resetpassword.title', emptyVars);
			case 172:
				return A2(_eval, 'view.resetpassword.field.email', emptyVars);
			case 173:
				return A2(_eval, 'view.resetpassword.submit', emptyVars);
			case 174:
				return A2(_eval, 'view.welcomeback.title', emptyVars);
			case 175:
				var dur = txt.a;
				return A2(
					_eval,
					'view.welcomeback.body',
					listVars(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'duration',
								format.b9(dur))
							])));
			case 176:
				return A2(_eval, 'view.welcomeback.lol', emptyVars);
			case 178:
				return A2(_eval, 'view.welcomeback.close', emptyVars);
			case 177:
				var unit = txt.a;
				var count = txt.b;
				return A2(
					elm$core$Result$andThen,
					function (label) {
						return A2(
							_eval,
							'view.welcomeback.entry',
							listVars(
								_List_fromArray(
									[
										_Utils_Tuple2('label', label),
										_Utils_Tuple2(
										'count',
										format.c(count))
									])));
					},
					A2(unitLabel, count, unit));
			case 179:
				var query = txt.a;
				var step = txt.b;
				var unitUrl = function (name) {
					return A2(
						elm$core$Maybe$map,
						function (u) {
							return A2(
								author$project$Route$unit,
								author$project$GameData$Tab$idToString(u.fM),
								author$project$GameData$Unit$name(u));
						},
						A2(author$project$GameData$unitByName, name, gameData));
				};
				var getVar = function (_var) {
					var _n13 = A2(elm$core$String$split, '.', _var);
					if (((_n13.b && (_n13.a === 'url')) && _n13.b.b) && (!_n13.b.b.b)) {
						var _n14 = _n13.b;
						var unit = _n14.a;
						return A2(
							elm$core$Result$fromMaybe,
							'no such unit: ' + unit,
							A2(
								elm$core$Maybe$map,
								author$project$Route$toString(query),
								unitUrl(unit)));
					} else {
						return elm$core$Result$Err('unknown var: ' + _var);
					}
				};
				return A2(
					_eval,
					'view.tutorial.' + author$project$Game$Tutorial$toString(step),
					getVar);
			case 180:
				var cost = txt.a.es;
				var count = txt.a.et;
				return A2(
					_eval,
					'view.mtx.paypal.button',
					listVars(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'cost',
								format.e3(cost)),
								_Utils_Tuple2(
								'count',
								format.bZ(count))
							])));
			case 181:
				var cost = txt.a.es;
				var count = txt.a.et;
				return A2(
					_eval,
					'view.mtx.kong.button',
					listVars(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'cost',
								'![][/images/kred_single.png]' + format.bZ(cost)),
								_Utils_Tuple2(
								'count',
								format.bZ(count))
							])));
			case 182:
				return A2(_eval, 'view.changelog.title', emptyVars);
			case 183:
				return A2(_eval, 'view.changelog.source', emptyVars);
			case 184:
				return A2(_eval, 'view.changelog.scarybee', emptyVars);
			case 185:
				return A2(_eval, 'view.notfound', emptyVars);
			case 186:
				return A2(_eval, 'view.mtxhistory.title', emptyVars);
			case 187:
				return A2(_eval, 'view.mtxhistory.col.kongid', emptyVars);
			case 188:
				return A2(_eval, 'view.mtxhistory.col.order', emptyVars);
			case 189:
				return A2(_eval, 'view.mtxhistory.col.added', emptyVars);
			case 190:
				return A2(_eval, 'view.mtxhistory.col.date', emptyVars);
			case 191:
				return A2(_eval, 'view.mtxhistory.col.playfabid', emptyVars);
			case 192:
				return A2(_eval, 'view.mtxhistory.col.paypaltx', emptyVars);
			case 193:
				return A2(_eval, 'view.mtxhistory.added.yes', emptyVars);
			case 194:
				return A2(_eval, 'view.mtxhistory.added.no', emptyVars);
			case 195:
				return A2(_eval, 'view.mtxshop.convert', emptyVars);
			case 196:
				return A2(_eval, 'view.mtxshop.history', emptyVars);
			case 197:
				return A2(_eval, 'view.mtxshop.confirmed', emptyVars);
			case 198:
				var tx = txt.a;
				return A2(
					_eval,
					'view.mtxshop.paypaltx',
					listVars(
						_List_fromArray(
							[
								_Utils_Tuple2('tx', tx)
							])));
			case 199:
				return A2(_eval, 'view.mtxshop.buykreds', emptyVars);
			case 200:
				return A2(_eval, 'view.mtxshop.support', emptyVars);
			case 201:
				return A2(_eval, 'view.mtxshop.login', emptyVars);
			case 202:
				return A2(_eval, 'view.energy.linkcrystals', emptyVars);
			case 203:
				return A2(_eval, 'view.buyn.format.link', emptyVars);
			case 204:
				return A2(_eval, 'view.buyn.format.title', emptyVars);
			case 205:
				return A2(_eval, 'view.buyn.format.close', emptyVars);
			case 206:
				return A2(_eval, 'view.usererror.loggedout', emptyVars);
			case 207:
				return A2(_eval, 'view.usererror.loggedout.remember', emptyVars);
			case 208:
				var unit = txt.a;
				var val = txt.b;
				return A2(
					elm$core$Result$andThen,
					function (label) {
						return A2(
							_eval,
							'description.mutantmeat.prod',
							listVars(
								_List_fromArray(
									[
										_Utils_Tuple2('label', label),
										_Utils_Tuple2(
										'val',
										format.cr(
											author$project$Decimal$toFloat(val)))
									])));
					},
					A2(unitLabel, author$project$Decimal$infinity, unit));
			case 209:
				var unit = txt.a;
				var pct = txt.b;
				return A2(
					elm$core$Result$andThen,
					function (label) {
						return A2(
							_eval,
							'description.territory.legend.entry',
							listVars(
								_List_fromArray(
									[
										_Utils_Tuple2('label', label),
										_Utils_Tuple2(
										'percent',
										format.dC(pct))
									])));
					},
					A2(unitLabel, author$project$Decimal$one, unit));
			case 211:
				var item = txt.a;
				var chance = txt.b.eo;
				var count = txt.b.et;
				return A2(
					elm$core$Result$andThen,
					function (label) {
						return A2(
							_eval,
							'description.hatchery.mutagen',
							listVars(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'chance',
										format.dC(chance)),
										_Utils_Tuple2(
										'count',
										format.c(count)),
										_Utils_Tuple2('label', label)
									])));
					},
					A2(itemLabel, author$project$Decimal$one, item));
			case 212:
				return A2(_eval, 'description.hatchery.mutagen.lol', emptyVars);
			case 213:
				var item = txt.a;
				var count = txt.b.et;
				var threshold = txt.b.d0;
				return A2(
					elm$core$Result$andThen,
					function (label) {
						return A2(
							_eval,
							'description.hatchery.mutagen.unlock',
							listVars(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'count',
										format.c(count)),
										_Utils_Tuple2(
										'threshold',
										format.c(threshold)),
										_Utils_Tuple2('label', label)
									])));
					},
					A2(itemLabel, count, item));
			case 210:
				var item = txt.a;
				var cooldown = txt.b._;
				var count = txt.b.et;
				return A2(
					elm$core$Result$andThen,
					function (label) {
						return A2(
							_eval,
							'description.hatchery.crystal.' + (_Utils_eq(cooldown, author$project$Duration$zero) ? 'now' : 'cooldown'),
							listVars(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'cooldown',
										format.b9(cooldown)),
										_Utils_Tuple2(
										'count',
										format.c(count)),
										_Utils_Tuple2('label', label)
									])));
					},
					A2(itemLabel, author$project$Decimal$one, item));
			case 214:
				return A2(_eval, 'unit.cocoon.desc1', emptyVars);
			case 215:
				var query = txt.a;
				return A2(
					_eval,
					'unit.cocoon.desc2',
					listVars(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'url.clonelarvae',
								A2(
									author$project$Route$toString,
									query,
									A2(author$project$Route$Spell, 'energy', 'clone-larvae')))
							])));
			case 216:
				var query = txt.a;
				var capHref = txt.b;
				var varsFn = txt.c;
				return A2(
					_eval,
					'unit.cocoon.desc3',
					function (name) {
						return (name === 'url.cocoon') ? A2(
							elm$core$Result$map,
							author$project$Route$toString(query),
							capHref) : A2(descriptionFormat, varsFn, name);
					});
			case 217:
				var varsFn = txt.a;
				return A2(
					_eval,
					'spell.clonelarvae.desc1',
					descriptionFormat(varsFn));
			case 218:
				var query = txt.a;
				var capHref = txt.b;
				var varsFn = txt.c;
				return A2(
					_eval,
					'spell.clonelarvae.desc2',
					function (name) {
						return (name === 'url.cocoon') ? A2(
							elm$core$Result$map,
							author$project$Route$toString(query),
							capHref) : A2(descriptionFormat, varsFn, name);
					});
			case 219:
				var varsFn = txt.a;
				return A2(
					_eval,
					'spell.clonelarvae.desc3',
					descriptionFormat(varsFn));
			default:
				var name = txt.a;
				return A2(_eval, 'keyCombo.' + name, emptyVars);
		}
	});
var elm$html$Html$Attributes$title = elm$html$Html$Attributes$stringProperty('title');
var elm_community$result_extra$Result$Extra$unwrap = F3(
	function (defaultValue, okFunc, result) {
		if (!result.$) {
			var ok = result.a;
			return okFunc(ok);
		} else {
			return defaultValue;
		}
	});
var elm_explorations$markdown$Markdown$defaultOptions = {
	c8: elm$core$Maybe$Nothing,
	dl: elm$core$Maybe$Just(
		{ej: false, fO: false}),
	dV: true,
	dY: false
};
var elm_explorations$markdown$Markdown$toHtmlWith = _Markdown_toHtml;
var elm_explorations$markdown$Markdown$toHtml = elm_explorations$markdown$Markdown$toHtmlWith(elm_explorations$markdown$Markdown$defaultOptions);
var author$project$View$Lang$toHtml = F6(
	function (messages, format, fools, gameData, ctx, txt) {
		switch (txt.$) {
			case 129:
				return A2(
					elm$core$Result$map,
					elm_explorations$markdown$Markdown$toHtml(_List_Nil),
					A6(author$project$View$Lang$toString, messages, format, fools, gameData, ctx, txt));
			case 179:
				return A2(
					elm$core$Result$map,
					A2(
						elm$core$Basics$composeR,
						author$project$Parser$Tutorial$eval,
						elm$html$Html$div(_List_Nil)),
					A2(
						elm$core$Result$andThen,
						author$project$Parser$Tutorial$parse,
						A6(author$project$View$Lang$toString, messages, format, fools, gameData, ctx, txt)));
			case 181:
				return A2(
					elm$core$Result$map,
					A2(
						elm$core$Basics$composeR,
						author$project$Parser$Tutorial$evalSpan,
						elm$html$Html$span(_List_Nil)),
					A2(
						elm$core$Result$andThen,
						author$project$Parser$Tutorial$parse,
						A6(author$project$View$Lang$toString, messages, format, fools, gameData, ctx, txt)));
			case 184:
				return A2(
					elm$core$Result$map,
					elm_explorations$markdown$Markdown$toHtml(_List_Nil),
					A6(author$project$View$Lang$toString, messages, format, fools, gameData, ctx, txt));
			case 215:
				return A2(
					elm$core$Result$map,
					A2(
						elm$core$Basics$composeR,
						author$project$Parser$Tutorial$evalSpan,
						elm$html$Html$span(_List_Nil)),
					A2(
						elm$core$Result$andThen,
						author$project$Parser$Tutorial$parse,
						A6(author$project$View$Lang$toString, messages, format, fools, gameData, ctx, txt)));
			case 216:
				return A2(
					elm$core$Result$map,
					A2(
						elm$core$Basics$composeR,
						author$project$Parser$Tutorial$evalSpan,
						elm$html$Html$span(_List_Nil)),
					A2(
						elm$core$Result$andThen,
						author$project$Parser$Tutorial$parse,
						A6(author$project$View$Lang$toString, messages, format, fools, gameData, ctx, txt)));
			case 218:
				return A2(
					elm$core$Result$map,
					A2(
						elm$core$Basics$composeR,
						author$project$Parser$Tutorial$evalSpan,
						elm$html$Html$span(_List_Nil)),
					A2(
						elm$core$Result$andThen,
						author$project$Parser$Tutorial$parse,
						A6(author$project$View$Lang$toString, messages, format, fools, gameData, ctx, txt)));
			case 5:
				var id = txt.b;
				return A3(
					elm$core$Result$map2,
					F2(
						function (desc, lol) {
							return A2(
								elm$html$Html$div,
								_List_fromArray(
									[
										elm$html$Html$Attributes$title(lol)
									]),
								A2(
									elm$core$List$map,
									function (s) {
										return A2(
											elm$html$Html$p,
											_List_fromArray(
												[
													elm$html$Html$Attributes$class(
													'desc-' + author$project$GameData$Unit$idToString(id))
												]),
											_List_fromArray(
												[
													elm$html$Html$text(s)
												]));
									},
									A2(elm$core$String$split, '\n', desc)));
						}),
					A6(author$project$View$Lang$toString, messages, format, fools, gameData, ctx, txt),
					A6(
						author$project$View$Lang$toString,
						messages,
						format,
						fools,
						gameData,
						ctx,
						author$project$View$Lang$UnitLol(id)));
			case 7:
				var id = txt.b;
				return A2(
					elm$core$Result$map,
					function (desc) {
						return A2(
							elm$html$Html$div,
							A3(
								elm_community$result_extra$Result$Extra$unwrap,
								_List_Nil,
								function (lol) {
									return _List_fromArray(
										[
											elm$html$Html$Attributes$title(lol)
										]);
								},
								A6(
									author$project$View$Lang$toString,
									messages,
									format,
									fools,
									gameData,
									ctx,
									author$project$View$Lang$UpgradeLol(id))),
							A2(
								elm$core$List$map,
								function (s) {
									return A2(
										elm$html$Html$p,
										_List_fromArray(
											[
												elm$html$Html$Attributes$class(
												'desc-' + author$project$GameData$Upgrade$idToString(id))
											]),
										_List_fromArray(
											[
												elm$html$Html$text(s)
											]));
								},
								A2(elm$core$String$split, '\n', desc)));
					},
					A6(author$project$View$Lang$toString, messages, format, fools, gameData, ctx, txt));
			case 9:
				var id = txt.b;
				return A3(
					elm$core$Result$map2,
					F2(
						function (desc, lol) {
							return A2(
								elm$html$Html$div,
								_List_fromArray(
									[
										elm$html$Html$Attributes$title(lol)
									]),
								A2(
									elm$core$List$map,
									function (s) {
										return A2(
											elm$html$Html$p,
											_List_fromArray(
												[
													elm$html$Html$Attributes$class(
													'desc-' + author$project$GameData$Spell$idToString(id))
												]),
											_List_fromArray(
												[
													elm$html$Html$text(s)
												]));
									},
									A2(elm$core$String$split, '\n', desc)));
						}),
					A6(author$project$View$Lang$toString, messages, format, fools, gameData, ctx, txt),
					A6(
						author$project$View$Lang$toString,
						messages,
						format,
						fools,
						gameData,
						ctx,
						author$project$View$Lang$SpellLol(id)));
			default:
				return A2(
					elm$core$Result$map,
					elm$html$Html$text,
					A6(author$project$View$Lang$toString, messages, format, fools, gameData, ctx, txt));
		}
	});
var author$project$Duration$ColonsConfig = function (showMillis) {
	return {cy: showMillis};
};
var author$project$Duration$defaultColonsConfig = author$project$Duration$ColonsConfig(false);
var author$project$Duration$toMillisF = A2(elm$core$Basics$composeR, author$project$Duration$toMillis, elm$core$Basics$toFloat);
var author$project$Duration$units1 = {bf: 24, bl: 60, aX: 60, aE: 1000, bK: 365};
var author$project$Duration$getDays = function (d) {
	return A2(
		elm$core$Basics$modBy,
		author$project$Duration$units1.bK,
		elm$core$Basics$floor(
			author$project$Duration$toMillisF(d) / author$project$Duration$units.bf));
};
var author$project$Duration$getHours = function (d) {
	return A2(
		elm$core$Basics$modBy,
		author$project$Duration$units1.bf,
		elm$core$Basics$floor(
			author$project$Duration$toMillisF(d) / author$project$Duration$units.bl));
};
var author$project$Duration$getMillis = function (d) {
	return A2(
		elm$core$Basics$modBy,
		author$project$Duration$units.aE,
		author$project$Duration$toMillis(d));
};
var author$project$Duration$getMins = function (d) {
	return A2(
		elm$core$Basics$modBy,
		author$project$Duration$units1.bl,
		elm$core$Basics$floor(
			author$project$Duration$toMillisF(d) / author$project$Duration$units.aX));
};
var author$project$Duration$getSecs = function (d) {
	return A2(
		elm$core$Basics$modBy,
		author$project$Duration$units1.aX,
		elm$core$Basics$floor(
			author$project$Duration$toMillisF(d) / author$project$Duration$units.aE));
};
var author$project$Duration$getYears = function (d) {
	return elm$core$Basics$floor(
		author$project$Duration$toMillisF(d) / author$project$Duration$units.bK);
};
var author$project$Duration$getFields = function (d) {
	return {
		I: author$project$Duration$getDays(d),
		au: author$project$Duration$getHours(d),
		bp: author$project$Duration$getMillis(d),
		ax: author$project$Duration$getMins(d),
		a0: author$project$Duration$getSecs(d),
		N: author$project$Duration$getYears(d)
	};
};
var author$project$Duration$pad0 = function (n) {
	return A2(
		elm$core$Basics$composeR,
		elm$core$String$fromInt,
		A2(elm$core$String$padLeft, n, '0'));
};
var author$project$Duration$toStringColons = F2(
	function (c, d) {
		var f = author$project$Duration$getFields(d);
		return A2(
			elm$core$String$join,
			':',
			(f.N > 1000) ? _Utils_ap(
				_List_fromArray(
					['????', '???', '??', '??', '??']),
				c.cy ? _List_fromArray(
					['????']) : _List_Nil) : _Utils_ap(
				(f.N > 0) ? _List_fromArray(
					[
						elm$core$String$fromInt(f.N),
						A2(author$project$Duration$pad0, 3, f.I)
					]) : ((f.I > 0) ? _List_fromArray(
					[
						elm$core$String$fromInt(f.I)
					]) : _List_Nil),
				_Utils_ap(
					_List_fromArray(
						[
							A2(author$project$Duration$pad0, 2, f.au),
							A2(author$project$Duration$pad0, 2, f.ax),
							A2(author$project$Duration$pad0, 2, f.a0)
						]),
					c.cy ? _List_fromArray(
						[
							A2(author$project$Duration$pad0, 4, f.bp)
						]) : _List_Nil)));
	});
var author$project$Duration$toString = author$project$Duration$toStringColons(author$project$Duration$defaultColonsConfig);
var author$project$Duration$toStringDHMS = function (d) {
	var f = author$project$Duration$getFields(d);
	return (f.N >= 1000000) ? '???? y' : ((f.N >= 10) ? (elm$core$String$fromInt(f.I) + 'y') : ((f.N > 0) ? (elm$core$String$fromInt(f.N) + ('y ' + (elm$core$String$fromInt(f.I) + 'd'))) : ((f.I > 0) ? (elm$core$String$fromInt(f.I) + ('d ' + (elm$core$String$fromInt(f.au) + 'h'))) : ((f.au > 0) ? (elm$core$String$fromInt(f.au) + ('h ' + (elm$core$String$fromInt(f.ax) + 'm'))) : ((f.ax > 0) ? (elm$core$String$fromInt(f.ax) + ('m ' + (elm$core$String$fromInt(f.a0) + 's'))) : (elm$core$String$fromInt(f.a0) + ('s ' + (elm$core$String$fromInt(f.bp) + 'ms'))))))));
};
var author$project$View$Lang$En_US$date = rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime;
var author$project$NumberSuffix2$Config$suffixScientific = function (digits) {
	return (digits <= 3) ? '' : ('e' + elm$core$String$fromInt(digits));
};
var author$project$NumberSuffix2$Locale$usLocale = {bT: '.', bg: 2, e5: '-', e6: '', fg: '', fh: '', fP: ','};
var author$project$NumberSuffix2$Config$scientificConfig = {
	af: author$project$NumberSuffix2$Config$suffixScientific,
	av: author$project$NumberSuffix2$Locale$usLocale,
	e0: 5,
	cz: 3,
	cH: elm$core$Basics$always(elm$core$String$fromFloat),
	a2: 1
};
var author$project$NumberSuffix2$Config$suffixEngineering = function (digits) {
	return (digits <= 3) ? '' : ('E' + elm$core$String$fromInt(((digits / 3) | 0) * 3));
};
var author$project$NumberSuffix2$Config$getListSuffix = F2(
	function (suffixes, digits) {
		var _n0 = A2(elm$core$Array$get, (digits / 3) | 0, suffixes);
		if (!_n0.$) {
			var s = _n0.a;
			return s;
		} else {
			return author$project$NumberSuffix2$Config$suffixEngineering(digits);
		}
	});
var author$project$NumberSuffixData$standard = elm$core$Array$fromList(
	_List_fromArray(
		['', ' thousand', ' million', ' billion', ' trillion', ' quadrillion', ' quintillion', ' sextillion', ' septillion', ' octillion', ' nonillion', ' decillion', ' undecillion', ' duodecillion', ' tredecillion', ' quattuordecillion', ' quinquadecillion', ' sedecillion', ' septendecillion', ' octodecillion', ' novendecillion', ' vigintillion', ' unvigintillion', ' duovigintillion', ' tresvigintillion', ' quattuorvigintillion', ' quinquavigintillion', ' sesvigintillion', ' septemvigintillion', ' octovigintillion', ' novemvigintillion', ' trigintillion', ' untrigintillion', ' duotrigintillion', ' trestrigintillion', ' quattuortrigintillion', ' quinquatrigintillion', ' sestrigintillion', ' septentrigintillion', ' octotrigintillion', ' noventrigintillion', ' quadragintillion', ' unquadragintillion', ' duoquadragintillion', ' tresquadragintillion', ' quattuorquadragintillion', ' quinquaquadragintillion', ' sesquadragintillion', ' septenquadragintillion', ' octoquadragintillion', ' novenquadragintillion', ' quinquagintillion', ' unquinquagintillion', ' duoquinquagintillion', ' tresquinquagintillion', ' quattuorquinquagintillion', ' quinquaquinquagintillion', ' sesquinquagintillion', ' septenquinquagintillion', ' octoquinquagintillion', ' novenquinquagintillion', ' sexagintillion', ' unsexagintillion', ' duosexagintillion', ' tresexagintillion', ' quattuorsexagintillion', ' quinquasexagintillion', ' sesexagintillion', ' septensexagintillion', ' octosexagintillion', ' novensexagintillion', ' septuagintillion', ' unseptuagintillion', ' duoseptuagintillion', ' treseptuagintillion', ' quattuorseptuagintillion', ' quinquaseptuagintillion', ' seseptuagintillion', ' septenseptuagintillion', ' octoseptuagintillion', ' novenseptuagintillion', ' octogintillion', ' unoctogintillion', ' duooctogintillion']));
var author$project$NumberSuffix2$Config$suffixStandard = author$project$NumberSuffix2$Config$getListSuffix(author$project$NumberSuffixData$standard);
var author$project$NumberSuffix2$Config$standardConfig = {
	af: author$project$NumberSuffix2$Config$suffixStandard,
	av: author$project$NumberSuffix2$Locale$usLocale,
	e0: 5,
	cz: 3,
	cH: elm$core$Basics$always(elm$core$String$fromFloat),
	a2: 3
};
var elm$core$Char$fromCode = _Char_fromCode;
var author$project$NumberSuffixData$aToZ = A2(
	elm$core$List$map,
	elm$core$Char$fromCode,
	A2(
		elm$core$List$range,
		elm$core$Char$toCode('a'),
		elm$core$Char$toCode('z')));
var elm$core$String$fromList = _String_fromList;
var author$project$NumberSuffixData$aaToZz = A2(
	elm$core$List$concatMap,
	function (first) {
		return A2(
			elm$core$List$map,
			function (last) {
				return elm$core$String$fromList(
					_List_fromArray(
						[first, last]));
			},
			author$project$NumberSuffixData$aToZ);
	},
	author$project$NumberSuffixData$aToZ);
var author$project$NumberSuffixData$standardShort = elm$core$Array$fromList(
	_List_fromArray(
		['', 'K', 'M', 'B', 'T', 'Qa', 'Qi', 'Sx', 'Sp', 'Oc', 'No', 'Dc', 'UDc', 'DDc', 'TDc', 'QaDc', 'QiDc', 'SxDc', 'SpDc', 'ODc', 'NDc', 'Vi', 'UVi', 'DVi', 'TVi', 'QaVi', 'QiVi', 'SxVi', 'SpVi', 'OVi', 'NVi', 'Tg', 'UTg', 'DTg', 'TTg', 'QaTg', 'QiTg', 'SxTg', 'SpTg', 'OTg', 'NTg', 'Qd', 'UQd', 'DQd', 'TQd', 'QaQd', 'QiQd', 'SxQd', 'SpQd', 'OQd', 'NQd', 'Qq', 'UQq', 'DQq', 'TQq', 'QaQq', 'QiQq', 'SxQq', 'SpQq', 'OQq', 'NQq', 'Sg', 'USg', 'DSg', 'TSg', 'QaSg', 'QiSg', 'SxSg', 'SpSg', 'OSg', 'NSg', 'St', 'USt', 'DSt', 'TSt', 'QaSt', 'QiSt', 'SxSt', 'SpSt', 'OSt', 'NSt', 'Og', 'UOg', 'DOg', 'TOg', 'QaOg', 'QiOg', 'SxOg', 'SpOg', 'OOg', 'NOg']));
var elm$core$Elm$JsArray$appendN = _JsArray_appendN;
var elm$core$Elm$JsArray$slice = _JsArray_slice;
var elm$core$Array$appendHelpBuilder = F2(
	function (tail, builder) {
		var tailLen = elm$core$Elm$JsArray$length(tail);
		var notAppended = (elm$core$Array$branchFactor - elm$core$Elm$JsArray$length(builder.n)) - tailLen;
		var appended = A3(elm$core$Elm$JsArray$appendN, elm$core$Array$branchFactor, builder.n, tail);
		return (notAppended < 0) ? {
			p: A2(
				elm$core$List$cons,
				elm$core$Array$Leaf(appended),
				builder.p),
			l: builder.l + 1,
			n: A3(elm$core$Elm$JsArray$slice, notAppended, tailLen, tail)
		} : ((!notAppended) ? {
			p: A2(
				elm$core$List$cons,
				elm$core$Array$Leaf(appended),
				builder.p),
			l: builder.l + 1,
			n: elm$core$Elm$JsArray$empty
		} : {p: builder.p, l: builder.l, n: appended});
	});
var elm$core$Elm$JsArray$push = _JsArray_push;
var elm$core$Elm$JsArray$singleton = _JsArray_singleton;
var elm$core$Array$insertTailInTree = F4(
	function (shift, index, tail, tree) {
		var pos = elm$core$Array$bitMask & (index >>> shift);
		if (_Utils_cmp(
			pos,
			elm$core$Elm$JsArray$length(tree)) > -1) {
			if (shift === 5) {
				return A2(
					elm$core$Elm$JsArray$push,
					elm$core$Array$Leaf(tail),
					tree);
			} else {
				var newSub = elm$core$Array$SubTree(
					A4(elm$core$Array$insertTailInTree, shift - elm$core$Array$shiftStep, index, tail, elm$core$Elm$JsArray$empty));
				return A2(elm$core$Elm$JsArray$push, newSub, tree);
			}
		} else {
			var value = A2(elm$core$Elm$JsArray$unsafeGet, pos, tree);
			if (!value.$) {
				var subTree = value.a;
				var newSub = elm$core$Array$SubTree(
					A4(elm$core$Array$insertTailInTree, shift - elm$core$Array$shiftStep, index, tail, subTree));
				return A3(elm$core$Elm$JsArray$unsafeSet, pos, newSub, tree);
			} else {
				var newSub = elm$core$Array$SubTree(
					A4(
						elm$core$Array$insertTailInTree,
						shift - elm$core$Array$shiftStep,
						index,
						tail,
						elm$core$Elm$JsArray$singleton(value)));
				return A3(elm$core$Elm$JsArray$unsafeSet, pos, newSub, tree);
			}
		}
	});
var elm$core$Array$unsafeReplaceTail = F2(
	function (newTail, _n0) {
		var len = _n0.a;
		var startShift = _n0.b;
		var tree = _n0.c;
		var tail = _n0.d;
		var originalTailLen = elm$core$Elm$JsArray$length(tail);
		var newTailLen = elm$core$Elm$JsArray$length(newTail);
		var newArrayLen = len + (newTailLen - originalTailLen);
		if (_Utils_eq(newTailLen, elm$core$Array$branchFactor)) {
			var overflow = _Utils_cmp(newArrayLen >>> elm$core$Array$shiftStep, 1 << startShift) > 0;
			if (overflow) {
				var newShift = startShift + elm$core$Array$shiftStep;
				var newTree = A4(
					elm$core$Array$insertTailInTree,
					newShift,
					len,
					newTail,
					elm$core$Elm$JsArray$singleton(
						elm$core$Array$SubTree(tree)));
				return A4(elm$core$Array$Array_elm_builtin, newArrayLen, newShift, newTree, elm$core$Elm$JsArray$empty);
			} else {
				return A4(
					elm$core$Array$Array_elm_builtin,
					newArrayLen,
					startShift,
					A4(elm$core$Array$insertTailInTree, startShift, len, newTail, tree),
					elm$core$Elm$JsArray$empty);
			}
		} else {
			return A4(elm$core$Array$Array_elm_builtin, newArrayLen, startShift, tree, newTail);
		}
	});
var elm$core$Array$appendHelpTree = F2(
	function (toAppend, array) {
		var len = array.a;
		var tree = array.c;
		var tail = array.d;
		var itemsToAppend = elm$core$Elm$JsArray$length(toAppend);
		var notAppended = (elm$core$Array$branchFactor - elm$core$Elm$JsArray$length(tail)) - itemsToAppend;
		var appended = A3(elm$core$Elm$JsArray$appendN, elm$core$Array$branchFactor, tail, toAppend);
		var newArray = A2(elm$core$Array$unsafeReplaceTail, appended, array);
		if (notAppended < 0) {
			var nextTail = A3(elm$core$Elm$JsArray$slice, notAppended, itemsToAppend, toAppend);
			return A2(elm$core$Array$unsafeReplaceTail, nextTail, newArray);
		} else {
			return newArray;
		}
	});
var elm$core$Elm$JsArray$foldl = _JsArray_foldl;
var elm$core$Array$builderFromArray = function (_n0) {
	var len = _n0.a;
	var tree = _n0.c;
	var tail = _n0.d;
	var helper = F2(
		function (node, acc) {
			if (!node.$) {
				var subTree = node.a;
				return A3(elm$core$Elm$JsArray$foldl, helper, acc, subTree);
			} else {
				return A2(elm$core$List$cons, node, acc);
			}
		});
	return {
		p: A3(elm$core$Elm$JsArray$foldl, helper, _List_Nil, tree),
		l: (len / elm$core$Array$branchFactor) | 0,
		n: tail
	};
};
var elm$core$Array$append = F2(
	function (a, _n0) {
		var aTail = a.d;
		var bLen = _n0.a;
		var bTree = _n0.c;
		var bTail = _n0.d;
		if (_Utils_cmp(bLen, elm$core$Array$branchFactor * 4) < 1) {
			var foldHelper = F2(
				function (node, array) {
					if (!node.$) {
						var tree = node.a;
						return A3(elm$core$Elm$JsArray$foldl, foldHelper, array, tree);
					} else {
						var leaf = node.a;
						return A2(elm$core$Array$appendHelpTree, leaf, array);
					}
				});
			return A2(
				elm$core$Array$appendHelpTree,
				bTail,
				A3(elm$core$Elm$JsArray$foldl, foldHelper, a, bTree));
		} else {
			var foldHelper = F2(
				function (node, builder) {
					if (!node.$) {
						var tree = node.a;
						return A3(elm$core$Elm$JsArray$foldl, foldHelper, builder, tree);
					} else {
						var leaf = node.a;
						return A2(elm$core$Array$appendHelpBuilder, leaf, builder);
					}
				});
			return A2(
				elm$core$Array$builderToArray,
				true,
				A2(
					elm$core$Array$appendHelpBuilder,
					bTail,
					A3(
						elm$core$Elm$JsArray$foldl,
						foldHelper,
						elm$core$Array$builderFromArray(a),
						bTree)));
		}
	});
var elm$core$Array$sliceLeft = F2(
	function (from, array) {
		var len = array.a;
		var tree = array.c;
		var tail = array.d;
		if (!from) {
			return array;
		} else {
			if (_Utils_cmp(
				from,
				elm$core$Array$tailIndex(len)) > -1) {
				return A4(
					elm$core$Array$Array_elm_builtin,
					len - from,
					elm$core$Array$shiftStep,
					elm$core$Elm$JsArray$empty,
					A3(
						elm$core$Elm$JsArray$slice,
						from - elm$core$Array$tailIndex(len),
						elm$core$Elm$JsArray$length(tail),
						tail));
			} else {
				var skipNodes = (from / elm$core$Array$branchFactor) | 0;
				var helper = F2(
					function (node, acc) {
						if (!node.$) {
							var subTree = node.a;
							return A3(elm$core$Elm$JsArray$foldr, helper, acc, subTree);
						} else {
							var leaf = node.a;
							return A2(elm$core$List$cons, leaf, acc);
						}
					});
				var leafNodes = A3(
					elm$core$Elm$JsArray$foldr,
					helper,
					_List_fromArray(
						[tail]),
					tree);
				var nodesToInsert = A2(elm$core$List$drop, skipNodes, leafNodes);
				if (!nodesToInsert.b) {
					return elm$core$Array$empty;
				} else {
					var head = nodesToInsert.a;
					var rest = nodesToInsert.b;
					var firstSlice = from - (skipNodes * elm$core$Array$branchFactor);
					var initialBuilder = {
						p: _List_Nil,
						l: 0,
						n: A3(
							elm$core$Elm$JsArray$slice,
							firstSlice,
							elm$core$Elm$JsArray$length(head),
							head)
					};
					return A2(
						elm$core$Array$builderToArray,
						true,
						A3(elm$core$List$foldl, elm$core$Array$appendHelpBuilder, initialBuilder, rest));
				}
			}
		}
	});
var elm$core$Array$fetchNewTail = F4(
	function (shift, end, treeEnd, tree) {
		fetchNewTail:
		while (true) {
			var pos = elm$core$Array$bitMask & (treeEnd >>> shift);
			var _n0 = A2(elm$core$Elm$JsArray$unsafeGet, pos, tree);
			if (!_n0.$) {
				var sub = _n0.a;
				var $temp$shift = shift - elm$core$Array$shiftStep,
					$temp$end = end,
					$temp$treeEnd = treeEnd,
					$temp$tree = sub;
				shift = $temp$shift;
				end = $temp$end;
				treeEnd = $temp$treeEnd;
				tree = $temp$tree;
				continue fetchNewTail;
			} else {
				var values = _n0.a;
				return A3(elm$core$Elm$JsArray$slice, 0, elm$core$Array$bitMask & end, values);
			}
		}
	});
var elm$core$Array$hoistTree = F3(
	function (oldShift, newShift, tree) {
		hoistTree:
		while (true) {
			if ((_Utils_cmp(oldShift, newShift) < 1) || (!elm$core$Elm$JsArray$length(tree))) {
				return tree;
			} else {
				var _n0 = A2(elm$core$Elm$JsArray$unsafeGet, 0, tree);
				if (!_n0.$) {
					var sub = _n0.a;
					var $temp$oldShift = oldShift - elm$core$Array$shiftStep,
						$temp$newShift = newShift,
						$temp$tree = sub;
					oldShift = $temp$oldShift;
					newShift = $temp$newShift;
					tree = $temp$tree;
					continue hoistTree;
				} else {
					return tree;
				}
			}
		}
	});
var elm$core$Array$sliceTree = F3(
	function (shift, endIdx, tree) {
		var lastPos = elm$core$Array$bitMask & (endIdx >>> shift);
		var _n0 = A2(elm$core$Elm$JsArray$unsafeGet, lastPos, tree);
		if (!_n0.$) {
			var sub = _n0.a;
			var newSub = A3(elm$core$Array$sliceTree, shift - elm$core$Array$shiftStep, endIdx, sub);
			return (!elm$core$Elm$JsArray$length(newSub)) ? A3(elm$core$Elm$JsArray$slice, 0, lastPos, tree) : A3(
				elm$core$Elm$JsArray$unsafeSet,
				lastPos,
				elm$core$Array$SubTree(newSub),
				A3(elm$core$Elm$JsArray$slice, 0, lastPos + 1, tree));
		} else {
			return A3(elm$core$Elm$JsArray$slice, 0, lastPos, tree);
		}
	});
var elm$core$Array$sliceRight = F2(
	function (end, array) {
		var len = array.a;
		var startShift = array.b;
		var tree = array.c;
		var tail = array.d;
		if (_Utils_eq(end, len)) {
			return array;
		} else {
			if (_Utils_cmp(
				end,
				elm$core$Array$tailIndex(len)) > -1) {
				return A4(
					elm$core$Array$Array_elm_builtin,
					end,
					startShift,
					tree,
					A3(elm$core$Elm$JsArray$slice, 0, elm$core$Array$bitMask & end, tail));
			} else {
				var endIdx = elm$core$Array$tailIndex(end);
				var depth = elm$core$Basics$floor(
					A2(
						elm$core$Basics$logBase,
						elm$core$Array$branchFactor,
						A2(elm$core$Basics$max, 1, endIdx - 1)));
				var newShift = A2(elm$core$Basics$max, 5, depth * elm$core$Array$shiftStep);
				return A4(
					elm$core$Array$Array_elm_builtin,
					end,
					newShift,
					A3(
						elm$core$Array$hoistTree,
						startShift,
						newShift,
						A3(elm$core$Array$sliceTree, startShift, endIdx, tree)),
					A4(elm$core$Array$fetchNewTail, startShift, end, endIdx, tree));
			}
		}
	});
var elm$core$Array$translateIndex = F2(
	function (index, _n0) {
		var len = _n0.a;
		var posIndex = (index < 0) ? (len + index) : index;
		return (posIndex < 0) ? 0 : ((_Utils_cmp(posIndex, len) > 0) ? len : posIndex);
	});
var elm$core$Array$slice = F3(
	function (from, to, array) {
		var correctTo = A2(elm$core$Array$translateIndex, to, array);
		var correctFrom = A2(elm$core$Array$translateIndex, from, array);
		return (_Utils_cmp(correctFrom, correctTo) > 0) ? elm$core$Array$empty : A2(
			elm$core$Array$sliceLeft,
			correctFrom,
			A2(elm$core$Array$sliceRight, correctTo, array));
	});
var author$project$NumberSuffixData$alphabetic = A2(
	elm$core$Array$append,
	A3(elm$core$Array$slice, 0, 5, author$project$NumberSuffixData$standardShort),
	elm$core$Array$fromList(author$project$NumberSuffixData$aaToZz));
var author$project$NumberSuffix2$Config$suffixAlphabetic = author$project$NumberSuffix2$Config$getListSuffix(author$project$NumberSuffixData$alphabetic);
var author$project$NumberSuffixData$longScale = elm$core$Array$fromList(
	_List_fromArray(
		['', ' thousand', ' million', ' milliard', ' billion', ' billiard', ' trillion', ' trilliard', ' quadrillion', ' quadrilliard', ' quintillion', ' quintilliard', ' sextillion', ' sextilliard', ' septillion', ' septilliard', ' octillion', ' octilliard', ' nonillion', ' nonilliard', ' decillion', ' decilliard', ' undecillion', ' undecilliard', ' duodecillion', ' duodecilliard', ' tredecillion', ' tredecilliard', ' quattuordecillion', ' quattuordecilliard', ' quinquadecillion', ' quinquadecilliard', ' sedecillion', ' sedecilliard', ' septendecillion', ' septendecilliard', ' octodecillion', ' octodecilliard', ' novendecillion', ' novendecilliard', ' vigintillion', ' vigintilliard', ' unvigintillion', ' unvigintilliard', ' duovigintillion', ' duovigintilliard', ' tresvigintillion', ' tresvigintilliard', ' quattuorvigintillion', ' quattuorvigintilliard', ' quinquavigintillion', ' quinquavigintilliard', ' sesvigintillion', ' sesvigintilliard', ' septemvigintillion', ' septemvigintilliard', ' octovigintillion', ' octovigintilliard', ' novemvigintillion', ' novemvigintilliard', ' trigintillion', ' trigintilliard', ' untrigintillion', ' untrigintilliard', ' duotrigintillion', ' duotrigintilliard', ' trestrigintillion', ' trestrigintilliard', ' quattuortrigintillion', ' quattuortrigintilliard', ' quinquatrigintillion', ' quinquatrigintilliard', ' sestrigintillion', ' sestrigintilliard', ' septentrigintillion', ' septentrigintilliard', ' octotrigintillion', ' octotrigintilliard', ' noventrigintillion', ' noventrigintilliard', ' quadragintillion', ' quadragintilliard', ' unquadragintillion', ' unquadragintilliard']));
var author$project$NumberSuffix2$Config$suffixLongScale = author$project$NumberSuffix2$Config$getListSuffix(author$project$NumberSuffixData$longScale);
var author$project$Game$NumberFormat$toConfig = function (format) {
	switch (format) {
		case 0:
			return author$project$NumberSuffix2$Config$standardConfig;
		case 1:
			return author$project$NumberSuffix2$Config$scientificConfig;
		case 2:
			return _Utils_update(
				author$project$NumberSuffix2$Config$standardConfig,
				{af: author$project$NumberSuffix2$Config$suffixEngineering});
		case 3:
			return _Utils_update(
				author$project$NumberSuffix2$Config$standardConfig,
				{af: author$project$NumberSuffix2$Config$suffixLongScale});
		default:
			return _Utils_update(
				author$project$NumberSuffix2$Config$standardConfig,
				{af: author$project$NumberSuffix2$Config$suffixAlphabetic});
	}
};
var author$project$NumberSuffix2$sign = F3(
	function (loc, p, s) {
		return p.e4 ? _Utils_ap(
			loc.e5,
			_Utils_ap(s, loc.e6)) : _Utils_ap(
			loc.fg,
			_Utils_ap(s, loc.fh));
	});
var elm$core$String$padRight = F3(
	function (n, _char, string) {
		return _Utils_ap(
			string,
			A2(
				elm$core$String$repeat,
				n - elm$core$String$length(string),
				elm$core$String$fromChar(_char)));
	});
var author$project$NumberSuffix2$significantDigits = F3(
	function (cfg, numWholeDigits, digits) {
		return A2(
			elm$core$String$left,
			cfg.cz,
			A3(
				elm$core$String$padRight,
				A2(elm$core$Basics$max, numWholeDigits, cfg.cz),
				'0',
				digits));
	});
var author$project$NumberSuffix2$toSuffixedString = F2(
	function (cfg, p) {
		var exp = ((p.j / cfg.a2) | 0) * cfg.a2;
		var numWholeDigits = (1 + p.j) - exp;
		var digits = A3(author$project$NumberSuffix2$significantDigits, cfg, numWholeDigits, p.c9);
		var sig = (_Utils_cmp(
			numWholeDigits,
			elm$core$String$length(digits)) > -1) ? A3(elm$core$String$padRight, numWholeDigits, '0', digits) : _Utils_ap(
			A2(elm$core$String$left, numWholeDigits, digits),
			_Utils_ap(
				cfg.av.bT,
				A2(elm$core$String$dropLeft, numWholeDigits, digits)));
		return _Utils_ap(
			A3(author$project$NumberSuffix2$sign, cfg.av, p, sig),
			cfg.af(p.j));
	});
var author$project$NumberSuffix2$splitLengthRight = function (len) {
	var loop = F2(
		function (accum, s) {
			loop:
			while (true) {
				if (_Utils_cmp(
					elm$core$String$length(s),
					len) < 1) {
					return A2(elm$core$List$cons, s, accum);
				} else {
					var $temp$accum = A2(
						elm$core$List$cons,
						A2(elm$core$String$left, len, s),
						accum),
						$temp$s = A2(elm$core$String$dropLeft, len, s);
					accum = $temp$accum;
					s = $temp$s;
					continue loop;
				}
			}
		});
	return A2(
		elm$core$Basics$composeR,
		elm$core$String$reverse,
		A2(
			elm$core$Basics$composeR,
			loop(_List_Nil),
			elm$core$List$map(elm$core$String$reverse)));
};
var author$project$NumberSuffix2$separateThousands = function (cfg) {
	return A2(
		elm$core$Basics$composeR,
		author$project$NumberSuffix2$splitLengthRight(3),
		elm$core$String$join(cfg.av.fP));
};
var author$project$NumberSuffix2$toUnsuffixedString = F2(
	function (cfg, p) {
		var numWholeDigits = 1 + p.j;
		var wholeDigits = A2(
			elm$core$String$left,
			numWholeDigits,
			A3(elm$core$String$padRight, numWholeDigits, '0', p.c9));
		return A3(
			author$project$NumberSuffix2$sign,
			cfg.av,
			p,
			A2(author$project$NumberSuffix2$separateThousands, cfg, wholeDigits));
	});
var author$project$NumberSuffix2$toString = F2(
	function (cfg, p) {
		return (_Utils_cmp(p.j, cfg.e0) > -1) ? A2(author$project$NumberSuffix2$toSuffixedString, cfg, p) : A2(author$project$NumberSuffix2$toUnsuffixedString, cfg, p);
	});
var author$project$NumberSuffix2$Parsed$error = {c9: '', j: 0, e4: false};
var author$project$NumberSuffix2$Parsed$trimLeadingZeros = function (s) {
	trimLeadingZeros:
	while (true) {
		var _n0 = elm$core$String$uncons(s);
		if ((!_n0.$) && ('0' === _n0.a.a)) {
			if (_n0.a.b === '') {
				var _n1 = _n0.a;
				return s;
			} else {
				var _n2 = _n0.a;
				var digits = _n2.b;
				var $temp$s = digits;
				s = $temp$s;
				continue trimLeadingZeros;
			}
		} else {
			return s;
		}
	}
};
var author$project$NumberSuffix2$Parsed$trimZeros = A2(
	elm$core$Basics$composeR,
	author$project$NumberSuffix2$Parsed$trimLeadingZeros,
	A2(
		elm$core$Basics$composeR,
		elm$core$String$reverse,
		A2(elm$core$Basics$composeR, author$project$NumberSuffix2$Parsed$trimLeadingZeros, elm$core$String$reverse)));
var author$project$NumberSuffix2$Parsed$normalize = function (p) {
	var digits = author$project$NumberSuffix2$Parsed$trimZeros(p.c9);
	return _Utils_update(
		p,
		{
			c9: digits,
			e4: (digits === '0') ? false : p.e4
		});
};
var elm$core$String$dropRight = F2(
	function (n, string) {
		return (n < 1) ? string : A3(elm$core$String$slice, 0, -n, string);
	});
var author$project$NumberSuffix2$Parsed$trimSign = F2(
	function (loc, s) {
		return (A2(elm$core$String$startsWith, loc.e5, s) && A2(elm$core$String$endsWith, loc.e6, s)) ? A2(
			elm$core$String$dropRight,
			elm$core$String$length(loc.e6),
			A2(
				elm$core$String$dropLeft,
				elm$core$String$length(loc.e5),
				s)) : ((A2(elm$core$String$startsWith, loc.fg, s) && A2(elm$core$String$endsWith, loc.fh, s)) ? A2(
			elm$core$String$dropRight,
			elm$core$String$length(loc.fh),
			A2(
				elm$core$String$dropLeft,
				elm$core$String$length(loc.fg),
				s)) : s);
	});
var elm$core$String$filter = _String_filter;
var author$project$NumberSuffix2$Parsed$parseSignificand = F2(
	function (loc, s) {
		return A2(
			elm$core$Maybe$map,
			function (exp) {
				return {
					c9: A2(
						elm$core$String$filter,
						elm$core$Char$isDigit,
						A2(author$project$NumberSuffix2$Parsed$trimSign, loc, s)),
					j: exp,
					e4: A2(elm$core$String$startsWith, loc.e5, s) && A2(elm$core$String$endsWith, loc.e6, s)
				};
			},
			function () {
				var _n0 = A2(
					elm$core$String$split,
					loc.bT,
					A2(author$project$NumberSuffix2$Parsed$trimSign, loc, s));
				_n0$2:
				while (true) {
					if (_n0.b) {
						if (!_n0.b.b) {
							var _int = _n0.a;
							return elm$core$Maybe$Just(
								elm$core$String$length(
									A2(
										elm$core$String$filter,
										elm$core$Char$isDigit,
										author$project$NumberSuffix2$Parsed$trimLeadingZeros(_int))) - 1);
						} else {
							if (!_n0.b.b.b) {
								var _int = _n0.a;
								var _n1 = _n0.b;
								return elm$core$Maybe$Just(
									elm$core$String$length(
										A2(
											elm$core$String$filter,
											elm$core$Char$isDigit,
											author$project$NumberSuffix2$Parsed$trimLeadingZeros(_int))) - 1);
							} else {
								break _n0$2;
							}
						}
					} else {
						break _n0$2;
					}
				}
				return elm$core$Maybe$Nothing;
			}());
	});
var author$project$NumberSuffix2$Parsed$parseString = F2(
	function (loc, s) {
		return A2(
			elm$core$Maybe$map,
			author$project$NumberSuffix2$Parsed$normalize,
			function () {
				var _n0 = A2(elm$core$String$split, 'e', s);
				_n0$2:
				while (true) {
					if (_n0.b) {
						if (!_n0.b.b) {
							var sig = _n0.a;
							return A2(author$project$NumberSuffix2$Parsed$parseSignificand, loc, sig);
						} else {
							if (!_n0.b.b.b) {
								var sig = _n0.a;
								var _n1 = _n0.b;
								var exp = _n1.a;
								return A3(
									elm$core$Maybe$map2,
									F2(
										function (p, e) {
											return _Utils_update(
												p,
												{j: p.j + e});
										}),
									A2(author$project$NumberSuffix2$Parsed$parseSignificand, loc, sig),
									elm$core$String$toInt(exp));
							} else {
								break _n0$2;
							}
						}
					} else {
						break _n0$2;
					}
				}
				return elm$core$Maybe$Nothing;
			}());
	});
var author$project$NumberSuffix2$Parsed$parseFloat = function (cfg) {
	return A2(
		elm$core$Basics$composeR,
		cfg.cH(cfg.cz),
		A2(
			elm$core$Basics$composeR,
			author$project$NumberSuffix2$Parsed$parseString(cfg.av),
			elm$core$Maybe$withDefault(author$project$NumberSuffix2$Parsed$error)));
};
var author$project$NumberSuffix2$Parsed$parseSigExp = F3(
	function (cfg, sig, exp) {
		var parsedSig = A2(author$project$NumberSuffix2$Parsed$parseFloat, cfg, sig);
		return _Utils_update(
			parsedSig,
			{j: parsedSig.j + exp});
	});
var author$project$NumberSuffix2$formatSigExp = F2(
	function (cfg, sig) {
		return A2(
			elm$core$Basics$composeR,
			A2(author$project$NumberSuffix2$Parsed$parseSigExp, cfg, sig),
			author$project$NumberSuffix2$toString(cfg));
	});
var author$project$NumberSuffix2$Round$sigfigsToPrecision = F2(
	function (sigfigs, val) {
		var _n0 = A2(author$project$NumberSuffix2$Parsed$parseFloat, author$project$NumberSuffix2$Config$standardConfig, val);
		var exp = _n0.j;
		return sigfigs - exp;
	});
var author$project$NumberSuffix2$Round$round = F3(
	function (roundFromDecimal, sigfigs, val) {
		return A2(
			roundFromDecimal,
			A2(author$project$NumberSuffix2$Round$sigfigsToPrecision, sigfigs, val) - 1,
			val);
	});
var elm$core$String$foldr = _String_foldr;
var elm$core$String$toList = function (string) {
	return A3(elm$core$String$foldr, elm$core$List$cons, _List_Nil, string);
};
var myrho$elm_round$Round$addSign = F2(
	function (signed, str) {
		var isNotZero = A2(
			elm$core$List$any,
			function (c) {
				return (c !== '0') && (c !== '.');
			},
			elm$core$String$toList(str));
		return _Utils_ap(
			(signed && isNotZero) ? '-' : '',
			str);
	});
var myrho$elm_round$Round$increaseNum = function (_n0) {
	var head = _n0.a;
	var tail = _n0.b;
	if (head === '9') {
		var _n1 = elm$core$String$uncons(tail);
		if (_n1.$ === 1) {
			return '01';
		} else {
			var headtail = _n1.a;
			return A2(
				elm$core$String$cons,
				'0',
				myrho$elm_round$Round$increaseNum(headtail));
		}
	} else {
		var c = elm$core$Char$toCode(head);
		return ((c >= 48) && (c < 57)) ? A2(
			elm$core$String$cons,
			elm$core$Char$fromCode(c + 1),
			tail) : '0';
	}
};
var myrho$elm_round$Round$splitComma = function (str) {
	var _n0 = A2(elm$core$String$split, '.', str);
	if (_n0.b) {
		if (_n0.b.b) {
			var before = _n0.a;
			var _n1 = _n0.b;
			var after = _n1.a;
			return _Utils_Tuple2(before, after);
		} else {
			var before = _n0.a;
			return _Utils_Tuple2(before, '0');
		}
	} else {
		return _Utils_Tuple2('0', '0');
	}
};
var myrho$elm_round$Round$toDecimal = function (fl) {
	var _n0 = A2(
		elm$core$String$split,
		'e',
		elm$core$String$fromFloat(
			elm$core$Basics$abs(fl)));
	if (_n0.b) {
		if (_n0.b.b) {
			var num = _n0.a;
			var _n1 = _n0.b;
			var exp = _n1.a;
			var e = A2(
				elm$core$Maybe$withDefault,
				0,
				elm$core$String$toInt(
					A2(elm$core$String$startsWith, '+', exp) ? A2(elm$core$String$dropLeft, 1, exp) : exp));
			var _n2 = myrho$elm_round$Round$splitComma(num);
			var before = _n2.a;
			var after = _n2.b;
			var total = _Utils_ap(before, after);
			var zeroed = (e < 0) ? A2(
				elm$core$Maybe$withDefault,
				'0',
				A2(
					elm$core$Maybe$map,
					function (_n3) {
						var a = _n3.a;
						var b = _n3.b;
						return a + ('.' + b);
					},
					A2(
						elm$core$Maybe$map,
						elm$core$Tuple$mapFirst(elm$core$String$fromChar),
						elm$core$String$uncons(
							_Utils_ap(
								A2(
									elm$core$String$repeat,
									elm$core$Basics$abs(e),
									'0'),
								total))))) : A3(elm$core$String$padRight, e + 1, '0', total);
			return _Utils_ap(
				(fl < 0) ? '-' : '',
				zeroed);
		} else {
			var num = _n0.a;
			return _Utils_ap(
				(fl < 0) ? '-' : '',
				num);
		}
	} else {
		return '';
	}
};
var myrho$elm_round$Round$roundFun = F3(
	function (functor, s, fl) {
		if (elm$core$Basics$isInfinite(fl) || elm$core$Basics$isNaN(fl)) {
			return elm$core$String$fromFloat(fl);
		} else {
			var signed = fl < 0;
			var _n0 = myrho$elm_round$Round$splitComma(
				myrho$elm_round$Round$toDecimal(
					elm$core$Basics$abs(fl)));
			var before = _n0.a;
			var after = _n0.b;
			var r = elm$core$String$length(before) + s;
			var normalized = _Utils_ap(
				A2(elm$core$String$repeat, (-r) + 1, '0'),
				A3(
					elm$core$String$padRight,
					r,
					'0',
					_Utils_ap(before, after)));
			var totalLen = elm$core$String$length(normalized);
			var roundDigitIndex = A2(elm$core$Basics$max, 1, r);
			var increase = A2(
				functor,
				signed,
				A3(elm$core$String$slice, roundDigitIndex, totalLen, normalized));
			var remains = A3(elm$core$String$slice, 0, roundDigitIndex, normalized);
			var num = increase ? elm$core$String$reverse(
				A2(
					elm$core$Maybe$withDefault,
					'1',
					A2(
						elm$core$Maybe$map,
						myrho$elm_round$Round$increaseNum,
						elm$core$String$uncons(
							elm$core$String$reverse(remains))))) : remains;
			var numLen = elm$core$String$length(num);
			var numZeroed = (num === '0') ? num : ((s <= 0) ? _Utils_ap(
				num,
				A2(
					elm$core$String$repeat,
					elm$core$Basics$abs(s),
					'0')) : ((_Utils_cmp(
				s,
				elm$core$String$length(after)) < 0) ? (A3(elm$core$String$slice, 0, numLen - s, num) + ('.' + A3(elm$core$String$slice, numLen - s, numLen, num))) : _Utils_ap(
				before + '.',
				A3(elm$core$String$padRight, s, '0', after))));
			return A2(myrho$elm_round$Round$addSign, signed, numZeroed);
		}
	});
var myrho$elm_round$Round$round = myrho$elm_round$Round$roundFun(
	F2(
		function (signed, str) {
			var _n0 = elm$core$String$uncons(str);
			if (_n0.$ === 1) {
				return false;
			} else {
				if ('5' === _n0.a.a) {
					if (_n0.a.b === '') {
						var _n1 = _n0.a;
						return !signed;
					} else {
						var _n2 = _n0.a;
						return true;
					}
				} else {
					var _n3 = _n0.a;
					var _int = _n3.a;
					return function (i) {
						return ((i > 53) && signed) || ((i >= 53) && (!signed));
					}(
						elm$core$Char$toCode(_int));
				}
			}
		}));
var author$project$View$Lang$En_US$decimal = F2(
	function (nf, d) {
		var config = author$project$Game$NumberFormat$toConfig(nf);
		return A3(
			author$project$NumberSuffix2$formatSigExp,
			_Utils_update(
				config,
				{
					cz: 5,
					cH: author$project$NumberSuffix2$Round$round(myrho$elm_round$Round$round)
				}),
			author$project$Decimal$significand(d),
			author$project$Decimal$exponent(d));
	});
var author$project$NumberSuffixData$longScaleShort = elm$core$Array$fromList(
	_List_fromArray(
		['', 'K', 'M', 'Md', 'B', 'Bd', 'T', 'Td', 'Qa', 'Qad', 'Qi', 'Qid', 'Sx', 'Sxd', 'Sp', 'Spd', 'Oc', 'Od', 'No', 'Nd', 'Dc', 'Dd', 'UDc', 'UDd', 'DDc', 'DDd', 'TDc', 'TDd', 'QaDc', 'QaDd', 'QiDc', 'QiDd', 'SxDc', 'SxDd', 'SpDc', 'SpDd', 'ODc', 'ODd', 'NDc', 'NDd', 'Vi', 'Vd', 'UVi', 'UVd', 'DVi', 'DVd', 'TVi', 'TVd', 'QaVi', 'QaVd', 'QiVi', 'QiVd', 'SxVi', 'SxVd', 'SpVi', 'SpVd', 'OVi', 'OVd', 'NVi', 'NVd', 'Tg', 'TD', 'UTg', 'UTD', 'DTg', 'DTD', 'TTg', 'TTD', 'QaTg', 'QaTD', 'QiTg', 'QiTD', 'SxTg', 'SxTD', 'SpTg', 'SpTD', 'OTg', 'OTD', 'NTg', 'NTD', 'Qd', 'QD', 'UQd', 'UQD', 'DQd', 'DQD', 'TQd', 'TQD', 'QaQd', 'QaQD']));
var author$project$NumberSuffix2$Config$suffixLongScaleShort = author$project$NumberSuffix2$Config$getListSuffix(author$project$NumberSuffixData$longScaleShort);
var author$project$NumberSuffix2$Config$suffixStandardShort = author$project$NumberSuffix2$Config$getListSuffix(author$project$NumberSuffixData$standardShort);
var author$project$Game$NumberFormat$toShortConfig = function (format) {
	switch (format) {
		case 0:
			return _Utils_update(
				author$project$NumberSuffix2$Config$standardConfig,
				{af: author$project$NumberSuffix2$Config$suffixStandardShort});
		case 1:
			return author$project$NumberSuffix2$Config$scientificConfig;
		case 2:
			return _Utils_update(
				author$project$NumberSuffix2$Config$standardConfig,
				{af: author$project$NumberSuffix2$Config$suffixEngineering});
		case 3:
			return _Utils_update(
				author$project$NumberSuffix2$Config$standardConfig,
				{af: author$project$NumberSuffix2$Config$suffixLongScaleShort});
		default:
			return _Utils_update(
				author$project$NumberSuffix2$Config$standardConfig,
				{af: author$project$NumberSuffix2$Config$suffixAlphabetic});
	}
};
var author$project$View$Lang$En_US$decimalShort = F2(
	function (nf, d) {
		var config = author$project$Game$NumberFormat$toShortConfig(nf);
		return A3(
			author$project$NumberSuffix2$formatSigExp,
			_Utils_update(
				config,
				{
					cH: author$project$NumberSuffix2$Round$round(myrho$elm_round$Round$round)
				}),
			author$project$Decimal$significand(d),
			author$project$Decimal$exponent(d));
	});
var author$project$NumberSuffix2$Parsed$parseInt = function (cfg) {
	return A2(
		elm$core$Basics$composeR,
		elm$core$Basics$toFloat,
		author$project$NumberSuffix2$Parsed$parseFloat(cfg));
};
var author$project$NumberSuffix2$formatInt = function (cfg) {
	return A2(
		elm$core$Basics$composeR,
		author$project$NumberSuffix2$Parsed$parseInt(cfg),
		author$project$NumberSuffix2$toString(cfg));
};
var author$project$View$Lang$En_US$fullInt = function (nf) {
	var config = author$project$Game$NumberFormat$toConfig(nf);
	return author$project$NumberSuffix2$formatInt(
		_Utils_update(
			config,
			{e0: 999999999999}));
};
var author$project$View$Lang$En_US$int = function (nf) {
	var config = author$project$Game$NumberFormat$toConfig(nf);
	return author$project$NumberSuffix2$formatInt(config);
};
var author$project$View$Lang$En_US$list = function (vals) {
	var _n0 = elm$core$List$reverse(vals);
	if (!_n0.b) {
		return 'nothing';
	} else {
		if (!_n0.b.b) {
			var c1 = _n0.a;
			return c1;
		} else {
			if (!_n0.b.b.b) {
				var c2 = _n0.a;
				var _n1 = _n0.b;
				var c1 = _n1.a;
				return c1 + (' and ' + c2);
			} else {
				var last = _n0.a;
				var heads = _n0.b;
				return A2(
					elm$core$String$join,
					', ',
					elm$core$List$reverse(heads)) + (', and ' + last);
			}
		}
	}
};
var author$project$View$Lang$En_US$longDuration = function (dur) {
	var ms = author$project$Duration$toMillis(dur);
	var seconds = (ms / 1000) | 0;
	var minutes = (seconds / 60) | 0;
	var hours = (minutes / 60) | 0;
	var days = (hours / 24) | 0;
	var years = (days / 365) | 0;
	return (years > 0) ? (elm$core$String$fromInt(years) + ' years') : ((days > 0) ? (elm$core$String$fromInt(days) + ' days') : ((hours > 0) ? (elm$core$String$fromInt(hours) + ' hours') : ((minutes > 0) ? (elm$core$String$fromInt(minutes) + ' minutes') : (elm$core$String$fromInt(seconds) + ' seconds'))));
};
var author$project$View$Lang$En_US$money = F2(
	function (nf, cents) {
		var pre = (cents / 100) | 0;
		var post = A2(elm$core$Basics$modBy, 100, cents);
		return '$' + (A2(author$project$View$Lang$En_US$int, nf, pre) + ('.' + elm$core$String$fromInt(post)));
	});
var author$project$View$Lang$En_US$percent = F2(
	function (nf, pct) {
		return A2(
			author$project$View$Lang$En_US$int,
			nf,
			elm$core$Basics$round(pct * 100)) + '%';
	});
var author$project$View$Lang$En_US$percent1 = F2(
	function (nf, pct) {
		return A2(author$project$View$Lang$En_US$percent, nf, pct - 1);
	});
var author$project$View$Lang$En_US$reldate = F2(
	function (at, now) {
		return rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime(at);
	});
var author$project$Romanize$digits = _List_fromArray(
	[
		_Utils_Tuple2('M', 1000),
		_Utils_Tuple2('CM', 900),
		_Utils_Tuple2('D', 500),
		_Utils_Tuple2('CD', 400),
		_Utils_Tuple2('C', 100),
		_Utils_Tuple2('XC', 90),
		_Utils_Tuple2('L', 50),
		_Utils_Tuple2('XL', 40),
		_Utils_Tuple2('X', 10),
		_Utils_Tuple2('IX', 9),
		_Utils_Tuple2('V', 5),
		_Utils_Tuple2('IV', 4),
		_Utils_Tuple2('I', 1)
	]);
var elm_community$list_extra$List$Extra$find = F2(
	function (predicate, list) {
		find:
		while (true) {
			if (!list.b) {
				return elm$core$Maybe$Nothing;
			} else {
				var first = list.a;
				var rest = list.b;
				if (predicate(first)) {
					return elm$core$Maybe$Just(first);
				} else {
					var $temp$predicate = predicate,
						$temp$list = rest;
					predicate = $temp$predicate;
					list = $temp$list;
					continue find;
				}
			}
		}
	});
var author$project$Romanize$loop = F2(
	function (num, ret) {
		loop:
		while (true) {
			var _n0 = A2(
				elm_community$list_extra$List$Extra$find,
				function (_n1) {
					var limit = _n1.b;
					return _Utils_cmp(num, limit) > -1;
				},
				author$project$Romanize$digits);
			if (!_n0.$) {
				var _n2 = _n0.a;
				var digit = _n2.a;
				var limit = _n2.b;
				var $temp$num = num - limit,
					$temp$ret = A2(elm$core$List$cons, digit, ret);
				num = $temp$num;
				ret = $temp$ret;
				continue loop;
			} else {
				return ret;
			}
		}
	});
var author$project$Romanize$romanize = function (num) {
	return A2(
		elm$core$String$join,
		'',
		elm$core$List$reverse(
			A2(author$project$Romanize$loop, num, _List_Nil)));
};
var author$project$View$Lang$En_US$romanize = function (n) {
	return (!n) ? '' : (' ' + author$project$Romanize$romanize(1 + n));
};
var cuducos$elm_format_number$Helpers$FormattedNumber = F5(
	function (original, integers, decimals, prefix, suffix) {
		return {bg: decimals, b1: integers, dA: original, fi: prefix, bC: suffix};
	});
var cuducos$elm_format_number$Helpers$Negative = 2;
var cuducos$elm_format_number$Helpers$Positive = 0;
var cuducos$elm_format_number$Helpers$Zero = 1;
var elm$core$String$concat = function (strings) {
	return A2(elm$core$String$join, '', strings);
};
var cuducos$elm_format_number$Helpers$classify = function (formatted) {
	var onlyZeros = A2(
		elm$core$String$all,
		function (_char) {
			return _char === '0';
		},
		elm$core$String$concat(
			A2(
				elm$core$List$append,
				formatted.b1,
				elm$core$List$singleton(
					A2(elm$core$Maybe$withDefault, '', formatted.bg)))));
	return onlyZeros ? 1 : ((formatted.dA < 0) ? 2 : 0);
};
var elm$core$String$right = F2(
	function (n, string) {
		return (n < 1) ? '' : A3(
			elm$core$String$slice,
			-n,
			elm$core$String$length(string),
			string);
	});
var cuducos$elm_format_number$Helpers$splitThousands = function (integers) {
	var reversedSplitThousands = function (value) {
		return (elm$core$String$length(value) > 3) ? A2(
			elm$core$List$cons,
			A2(elm$core$String$right, 3, value),
			reversedSplitThousands(
				A2(elm$core$String$dropRight, 3, value))) : _List_fromArray(
			[value]);
	};
	return elm$core$List$reverse(
		reversedSplitThousands(integers));
};
var cuducos$elm_format_number$Helpers$parse = F2(
	function (locale, original) {
		var parts = A2(
			elm$core$String$split,
			'.',
			A2(myrho$elm_round$Round$round, locale.bg, original));
		var integers = cuducos$elm_format_number$Helpers$splitThousands(
			A2(
				elm$core$String$filter,
				elm$core$Char$isDigit,
				A2(
					elm$core$Maybe$withDefault,
					'0',
					elm$core$List$head(parts))));
		var decimals = elm$core$List$head(
			A2(elm$core$List$drop, 1, parts));
		var partial = A5(cuducos$elm_format_number$Helpers$FormattedNumber, original, integers, decimals, '', '');
		var _n0 = cuducos$elm_format_number$Helpers$classify(partial);
		switch (_n0) {
			case 2:
				return _Utils_update(
					partial,
					{fi: locale.e5, bC: locale.e6});
			case 0:
				return _Utils_update(
					partial,
					{fi: locale.fg, bC: locale.fh});
			default:
				return partial;
		}
	});
var cuducos$elm_format_number$Helpers$stringfy = F2(
	function (locale, formatted) {
		var integers = A2(elm$core$String$join, locale.fP, formatted.b1);
		var decimals = function () {
			var _n0 = formatted.bg;
			if (!_n0.$) {
				var digits = _n0.a;
				return _Utils_ap(locale.bT, digits);
			} else {
				return '';
			}
		}();
		return elm$core$String$concat(
			_List_fromArray(
				[formatted.fi, integers, decimals, formatted.bC]));
	});
var cuducos$elm_format_number$FormatNumber$format = F2(
	function (locale, number_) {
		return A2(
			cuducos$elm_format_number$Helpers$stringfy,
			locale,
			A2(cuducos$elm_format_number$Helpers$parse, locale, number_));
	});
var cuducos$elm_format_number$FormatNumber$Locales$Locale = F7(
	function (decimals, thousandSeparator, decimalSeparator, negativePrefix, negativeSuffix, positivePrefix, positiveSuffix) {
		return {bT: decimalSeparator, bg: decimals, e5: negativePrefix, e6: negativeSuffix, fg: positivePrefix, fh: positiveSuffix, fP: thousandSeparator};
	});
var cuducos$elm_format_number$FormatNumber$Locales$usLocale = A7(cuducos$elm_format_number$FormatNumber$Locales$Locale, 2, ',', '.', '−', '', '', '');
var author$project$View$Lang$En_US$smallDecimalFormatter = F3(
	function (defaultFormatter, nf, d) {
		return A2(
			author$project$Decimal$lte,
			d,
			author$project$Decimal$fromInt(100)) ? A2(
			cuducos$elm_format_number$FormatNumber$format,
			cuducos$elm_format_number$FormatNumber$Locales$usLocale,
			author$project$Decimal$toFloat(d)) : A2(defaultFormatter, nf, d);
	});
var author$project$View$Lang$En_US$formatter = function (numberFormat) {
	return {
		ev: author$project$View$Lang$En_US$date,
		c: author$project$View$Lang$En_US$decimal(numberFormat),
		Q: author$project$View$Lang$En_US$decimalShort(numberFormat),
		bZ: author$project$View$Lang$En_US$fullInt(numberFormat),
		eS: author$project$View$Lang$En_US$int(numberFormat),
		b7: author$project$View$Lang$En_US$list,
		av: 0,
		b9: author$project$View$Lang$En_US$longDuration,
		e3: author$project$View$Lang$En_US$money(numberFormat),
		dC: author$project$View$Lang$En_US$percent(numberFormat),
		cr: author$project$View$Lang$En_US$percent1(numberFormat),
		fq: author$project$View$Lang$En_US$reldate,
		fv: author$project$View$Lang$En_US$romanize,
		bA: author$project$Duration$toStringDHMS,
		bB: A2(author$project$View$Lang$En_US$smallDecimalFormatter, author$project$View$Lang$En_US$decimal, numberFormat),
		fD: A2(author$project$View$Lang$En_US$smallDecimalFormatter, author$project$View$Lang$En_US$decimalShort, numberFormat),
		bE: author$project$Duration$toString
	};
};
var author$project$View$Lang$localeToLang = F5(
	function (gameData, fools, ctx, translator, locale) {
		var numberFormat = A3(
			elm_community$maybe_extra$Maybe$Extra$unwrap,
			author$project$Game$NumberFormat$default,
			function ($) {
				return $.ay;
			},
			ctx);
		var f = {
			dd: author$project$View$Lang$En_US$formatter(numberFormat)
		};
		switch (locale) {
			case 0:
				return A3(
					author$project$View$Lang$init,
					locale,
					A5(
						author$project$View$Lang$toString,
						A2(author$project$GameData$lang, translator, gameData).dd,
						f.dd,
						fools,
						gameData,
						ctx),
					A5(
						author$project$View$Lang$toHtml,
						A2(author$project$GameData$lang, translator, gameData).dd,
						f.dd,
						fools,
						gameData,
						ctx));
			case 1:
				return A3(
					author$project$View$Lang$init,
					locale,
					A2(
						elm$core$Basics$composeR,
						A5(
							author$project$View$Lang$toString,
							A2(author$project$GameData$lang, translator, gameData).dd,
							f.dd,
							fools,
							gameData,
							ctx),
						elm$core$Result$map(elm$core$String$reverse)),
					A2(
						elm$core$Basics$composeR,
						A5(
							author$project$View$Lang$toHtml,
							A2(author$project$GameData$lang, translator, gameData).dd,
							f.dd,
							fools,
							gameData,
							ctx),
						elm$core$Result$map(
							function (c) {
								return A2(
									elm$html$Html$span,
									_List_fromArray(
										[
											elm$html$Html$Attributes$class('lang-backwards')
										]),
									_List_fromArray(
										[c]));
							})));
			default:
				return A3(
					author$project$View$Lang$init,
					locale,
					A5(
						author$project$View$Lang$toString,
						A2(author$project$GameData$lang, translator, gameData).dd,
						f.dd,
						fools,
						gameData,
						ctx),
					A2(
						elm$core$Basics$composeR,
						A5(
							author$project$View$Lang$toHtml,
							A2(author$project$GameData$lang, translator, gameData).dd,
							f.dd,
							fools,
							gameData,
							ctx),
						elm$core$Result$map(
							function (c) {
								return A2(
									elm$html$Html$span,
									_List_fromArray(
										[
											elm$html$Html$Attributes$class('lang-upside-down')
										]),
									_List_fromArray(
										[c]));
							})));
		}
	});
var author$project$View$Lang$gameToLang = F2(
	function (session, game) {
		return A5(
			author$project$View$Lang$localeToLang,
			author$project$Game$gameData(game),
			author$project$Fools$status(session),
			elm$core$Maybe$Just(
				author$project$View$Lang$gameContext(game)),
			author$project$Session$translatorEntry(session),
			A2(
				elm$core$Maybe$withDefault,
				0,
				author$project$Game$locale(game)));
	});
var elm$core$List$intersperse = F2(
	function (sep, xs) {
		if (!xs.b) {
			return _List_Nil;
		} else {
			var hd = xs.a;
			var tl = xs.b;
			var step = F2(
				function (x, rest) {
					return A2(
						elm$core$List$cons,
						sep,
						A2(elm$core$List$cons, x, rest));
				});
			var spersed = A3(elm$core$List$foldr, step, _List_Nil, tl);
			return A2(elm$core$List$cons, hd, spersed);
		}
	});
var elm$html$Html$form = _VirtualDom_node('form');
var elm$html$Html$h2 = _VirtualDom_node('h2');
var elm$html$Html$hr = _VirtualDom_node('hr');
var elm$html$Html$input = _VirtualDom_node('input');
var elm$html$Html$label = _VirtualDom_node('label');
var elm$html$Html$ul = _VirtualDom_node('ul');
var elm$html$Html$Attributes$boolProperty = F2(
	function (key, bool) {
		return A2(
			_VirtualDom_property,
			key,
			elm$json$Json$Encode$bool(bool));
	});
var elm$html$Html$Attributes$checked = elm$html$Html$Attributes$boolProperty('checked');
var elm$html$Html$Attributes$name = elm$html$Html$Attributes$stringProperty('name');
var elm$html$Html$Attributes$type_ = elm$html$Html$Attributes$stringProperty('type');
var elm$virtual_dom$VirtualDom$lazy5 = _VirtualDom_lazy5;
var elm$html$Html$Lazy$lazy5 = elm$virtual_dom$VirtualDom$lazy5;
var author$project$Page$Achievements$viewReady = F2(
	function (session, game) {
		var points = author$project$Game$achievementPoints(game);
		var options = author$project$Game$achievementsShown(game);
		var lang = A2(author$project$View$Lang$gameToLang, session, game);
		var bonus = A2(
			elm$core$Maybe$map,
			author$project$Decimal$toFloat,
			A2(
				elm$core$Maybe$andThen,
				function (_n2) {
					var prod = _n2.b;
					return A2(
						elm$core$Dict$get,
						'achievementbonus',
						A3(
							author$project$Parser$Stat$evalFullWithDefault,
							author$project$Decimal$zero,
							author$project$Game$getGameVar(game),
							prod).dh);
				},
				A2(
					elm$core$Maybe$andThen,
					function ($) {
						return $.fl;
					},
					A2(
						author$project$GameData$unitByName,
						'hatchery',
						author$project$Game$gameData(game)))));
		return _List_fromArray(
			[
				A2(
				elm$html$Html$h2,
				_List_Nil,
				_List_fromArray(
					[
						lang.q(
						author$project$View$Lang$ViewAchievementsTitle(points.d6))
					])),
				A2(
				elm$html$Html$div,
				_List_fromArray(
					[
						elm$html$Html$Attributes$class('progress')
					]),
				_List_fromArray(
					[
						A2(
						elm$html$Html$div,
						_List_fromArray(
							[
								elm$html$Html$Attributes$class('progress-bar bg-success'),
								A2(
								elm$html$Html$Attributes$style,
								'width',
								author$project$Page$Achievements$percent(points.dC))
							]),
						_List_fromArray(
							[
								lang.q(
								author$project$View$Lang$ViewAchievementsProgress(points.dC))
							]))
					])),
				function () {
				var sortRadio = F2(
					function (sortBy, body) {
						return A2(
							elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									elm$html$Html$input,
									_List_fromArray(
										[
											elm$html$Html$Attributes$type_('radio'),
											elm$html$Html$Attributes$name('sort'),
											elm$html$Html$Attributes$checked(
											_Utils_eq(options.co, sortBy)),
											elm$html$Html$Events$onClick(
											author$project$Page$Achievements$OnSetOptionsSortOrder(sortBy))
										]),
									_List_Nil),
									lang.q(body)
								]));
					});
				var checkbox = F3(
					function (val, msg, body) {
						return A2(
							elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									elm$html$Html$input,
									_List_fromArray(
										[
											elm$html$Html$Attributes$type_('checkbox'),
											elm$html$Html$Attributes$checked(val),
											elm$html$Html$Events$onClick(msg)
										]),
									_List_Nil),
									lang.q(body)
								]));
					});
				return A2(
					elm$html$Html$form,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							elm$html$Html$div,
							_List_Nil,
							A2(
								elm$core$List$intersperse,
								elm$html$Html$text(' '),
								_List_fromArray(
									[
										lang.q(author$project$View$Lang$ViewAchievementsOptionsVisible),
										A3(checkbox, options.bU, author$project$Page$Achievements$OnSetOptionsEarned, author$project$View$Lang$ViewAchievementsOptionsVisibleEarned),
										A3(checkbox, options.cK, author$project$Page$Achievements$OnSetOptionsUnearned, author$project$View$Lang$ViewAchievementsOptionsVisibleUnearned),
										A3(checkbox, options.ca, author$project$Page$Achievements$OnSetOptionsMasked, author$project$View$Lang$ViewAchievementsOptionsVisibleMasked)
									]))),
							A2(
							elm$html$Html$div,
							_List_Nil,
							A2(
								elm$core$List$intersperse,
								elm$html$Html$text(' '),
								_List_fromArray(
									[
										lang.q(author$project$View$Lang$ViewAchievementsOptionsSort),
										A2(sortRadio, 0, author$project$View$Lang$ViewAchievementsOptionsSortDefault),
										A2(sortRadio, 1, author$project$View$Lang$ViewAchievementsOptionsSortCompletion),
										A3(
										checkbox,
										options.cw,
										author$project$Page$Achievements$OnSetOptionsReverse,
										options.cw ? author$project$View$Lang$ViewAchievementsOptionsSortReversed : author$project$View$Lang$ViewAchievementsOptionsSortNotReversed)
									])))
						]));
			}(),
				function () {
				if (bonus.$ === 1) {
					return A2(elm$html$Html$div, _List_Nil, _List_Nil);
				} else {
					var b = bonus.a;
					return A2(
						elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								lang.q(
								author$project$View$Lang$ViewAchievementsBonus(b))
							]));
				}
			}(),
				A2(elm$html$Html$hr, _List_Nil, _List_Nil),
				A2(
				elm$html$Html$ul,
				_List_fromArray(
					[
						elm$html$Html$Attributes$class('achievements list-group')
					]),
				A2(
					elm$core$List$map,
					function (_n1) {
						var a = _n1.a;
						var s = _n1.b;
						return A6(
							elm$html$Html$Lazy$lazy5,
							author$project$Page$Achievements$viewEntry,
							author$project$Game$gameData(game),
							lang,
							author$project$Game$snapshotted(game),
							a,
							s);
					},
					(options.cw ? elm$core$List$reverse : elm$core$Basics$identity)(
						A2(
							author$project$Page$Achievements$sort,
							options.co,
							A2(
								elm$core$List$filter,
								A2(
									elm$core$Basics$composeR,
									elm$core$Tuple$second,
									author$project$Page$Achievements$isVisible(options)),
								author$project$Game$achievements(game))))))
			]);
	});
var author$project$Game$lastUnitByTab = F2(
	function (tab, _n0) {
		var g = _n0;
		var _n1 = A2(
			elm$core$Dict$get,
			author$project$GameData$Tab$Id$toString(tab),
			g.S);
		if (!_n1.$) {
			var name = _n1.a;
			var _n2 = _Utils_Tuple2(
				A2(author$project$GameData$unitBySlug, name, g.D),
				A2(author$project$GameData$spellBySlug, name, g.D));
			if (!_n2.a.$) {
				var unit = _n2.a.a;
				return A2(
					author$project$Route$unit,
					author$project$GameData$Tab$Id$toString(tab),
					name);
			} else {
				if (!_n2.b.$) {
					var spell = _n2.b.a;
					return A2(
						author$project$Route$Spell,
						author$project$GameData$Tab$Id$toString(tab),
						name);
				} else {
					return author$project$Route$Tab(
						author$project$GameData$Tab$Id$toString(tab));
				}
			}
		} else {
			return author$project$Route$Tab(
				author$project$GameData$Tab$Id$toString(tab));
		}
	});
var author$project$Game$flipLastUnitByTab = F2(
	function (game, id) {
		return A2(author$project$Game$lastUnitByTab, id, game);
	});
var author$project$GameData$tabs = A2(
	elm$core$Basics$composeR,
	author$project$GameData$lists,
	function ($) {
		return $.bD;
	});
var author$project$View$Device$Desktop = 0;
var author$project$View$Device$Mobile = 1;
var author$project$View$Device$onlyDesktopCls = elm$html$Html$Attributes$class('d-none d-md-block');
var author$project$View$Device$onlyDesktop = elm$html$Html$div(
	_List_fromArray(
		[author$project$View$Device$onlyDesktopCls]));
var author$project$View$Device$onlyMobileCls = elm$html$Html$Attributes$class('d-block d-md-none');
var author$project$View$Device$onlyMobile = elm$html$Html$div(
	_List_fromArray(
		[author$project$View$Device$onlyMobileCls]));
var author$project$Route$href = F2(
	function (query, route) {
		return elm$html$Html$Attributes$href(
			A2(author$project$Route$toString, query, route));
	});
var author$project$View$Lang$ViewTabMore = {$: 53};
var author$project$Session$undoDuration = function (_n0) {
	var s = _n0;
	return A2(
		elm$core$Maybe$andThen,
		function (now_) {
			return A2(author$project$Session$GameLoader$undoDuration, now_, s.ae);
		},
		s.cm);
};
var author$project$View$Icon$fab = function (name) {
	return A2(
		elm$html$Html$i,
		_List_fromArray(
			[
				elm$html$Html$Attributes$class('fab'),
				elm$html$Html$Attributes$class('fa-' + name)
			]),
		_List_Nil);
};
var author$project$View$Icon$far = function (name) {
	return A2(
		elm$html$Html$i,
		_List_fromArray(
			[
				elm$html$Html$Attributes$class('far'),
				elm$html$Html$Attributes$class('fa-' + name)
			]),
		_List_Nil);
};
var author$project$View$Lang$ItemName = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var author$project$View$Lang$ViewTabAchievements = {$: 59};
var author$project$View$Lang$ViewTabAllUnits = {$: 65};
var author$project$View$Lang$ViewTabBugReport = {$: 64};
var author$project$View$Lang$ViewTabBuyAll = function (a) {
	return {$: 54, a: a};
};
var author$project$View$Lang$ViewTabBuyCheapest = function (a) {
	return {$: 55, a: a};
};
var author$project$View$Lang$ViewTabChangelog = {$: 61};
var author$project$View$Lang$ViewTabCommunity = {$: 62};
var author$project$View$Lang$ViewTabFeedback = {$: 63};
var author$project$View$Lang$ViewTabHotkeys = {$: 68};
var author$project$View$Lang$ViewTabOptions = {$: 58};
var author$project$View$Lang$ViewTabStatistics = {$: 60};
var author$project$View$Lang$ViewTabUndo = {$: 56};
var author$project$View$Lang$ViewTabUndoDuration = function (a) {
	return {$: 57, a: a};
};
var author$project$View$TabNav$BulkUpgradeAll = function (a) {
	return {$: 2, a: a};
};
var author$project$View$TabNav$BulkUpgradeCheapest = function (a) {
	return {$: 3, a: a};
};
var author$project$View$TabNav$OpenKeyComboHelp = {$: 4};
var author$project$View$TabNav$Undo = {$: 0};
var author$project$PlayFab$User$displayName = function (iframe) {
	if (iframe.$ === 1) {
		var m = iframe.a;
		var _n1 = m.cQ;
		if (!_n1.$) {
			var user = _n1.a;
			return elm$core$Basics$always(user.fZ);
		} else {
			return A2(
				elm$core$Basics$composeR,
				author$project$PlayFab$User$unwrap,
				function ($) {
					return $.ew;
				});
		}
	} else {
		return A2(
			elm$core$Basics$composeR,
			author$project$PlayFab$User$unwrap,
			function ($) {
				return $.ew;
			});
	}
};
var author$project$PlayFab$User$role = A2(
	elm$core$Basics$composeR,
	author$project$PlayFab$User$unwrap,
	function ($) {
		return $.dS;
	});
var author$project$View$Icon$loading = author$project$View$Icon$fas('spinner fa-spin');
var author$project$View$Lang$ViewTabLogin = {$: 66};
var author$project$View$Lang$ViewTabNavUserConflict = {$: 71};
var author$project$View$Lang$ViewTabNavUserError = {$: 70};
var author$project$View$Lang$ViewTabNavUserKongLogin = {$: 72};
var author$project$View$Lang$ViewTabNavUserLoading = {$: 69};
var author$project$View$Lang$ViewTabRegister = {$: 67};
var author$project$View$TabNav$KongregateShowRegistrationBox = {$: 1};
var author$project$View$TabNav$viewUserButtons = F2(
	function (session, game) {
		var query = author$project$Session$query(session);
		var lang = A2(author$project$View$Lang$gameToLang, session, game);
		var _n0 = author$project$Session$iframe(session);
		if (!_n0.$) {
			var _n1 = author$project$Session$userState(session);
			switch (_n1.$) {
				case 0:
					return _List_Nil;
				case 1:
					return _List_fromArray(
						[
							A2(
							elm$html$Html$a,
							_List_fromArray(
								[
									elm$html$Html$Attributes$class('dropdown-item'),
									A2(author$project$Route$href, query, author$project$Route$Login)
								]),
							_List_fromArray(
								[
									author$project$View$Icon$loading,
									elm$html$Html$text(' '),
									lang.q(author$project$View$Lang$ViewTabNavUserLoading)
								]))
						]);
				case 2:
					var err = _n1.a;
					return _List_fromArray(
						[
							A2(
							elm$html$Html$a,
							_List_fromArray(
								[
									elm$html$Html$Attributes$class('dropdown-item'),
									A2(author$project$Route$href, query, author$project$Route$Login),
									elm$html$Html$Attributes$title(
									author$project$PlayFab$Error$toString(err))
								]),
							_List_fromArray(
								[
									author$project$View$Icon$fas('user-times'),
									elm$html$Html$text(' '),
									lang.q(author$project$View$Lang$ViewTabNavUserError)
								]))
						]);
				default:
					if (_n1.a.$ === 1) {
						var _n2 = _n1.a;
						return _List_fromArray(
							[
								A2(
								elm$html$Html$a,
								_List_fromArray(
									[
										elm$html$Html$Attributes$class('dropdown-item'),
										A2(author$project$Route$href, query, author$project$Route$Login)
									]),
								_List_fromArray(
									[
										author$project$View$Icon$fas('user'),
										elm$html$Html$text(' '),
										lang.q(author$project$View$Lang$ViewTabLogin)
									])),
								A2(
								elm$html$Html$a,
								_List_fromArray(
									[
										elm$html$Html$Attributes$class('dropdown-item'),
										A2(author$project$Route$href, query, author$project$Route$Register)
									]),
								_List_fromArray(
									[
										author$project$View$Icon$fas('user-plus'),
										elm$html$Html$text(' '),
										lang.q(author$project$View$Lang$ViewTabRegister)
									]))
							]);
					} else {
						var ustate = _n1.a.a;
						var user = ustate.cQ;
						var _n3 = ustate.fL;
						if (_n3.$ === 1) {
							var conflict = _n3.a;
							return _List_fromArray(
								[
									A2(
									elm$html$Html$a,
									_List_fromArray(
										[
											elm$html$Html$Attributes$class('dropdown-item'),
											A2(author$project$Route$href, query, author$project$Route$User)
										]),
									_List_fromArray(
										[
											author$project$View$Icon$fas('user-times'),
											elm$html$Html$text(' '),
											lang.q(author$project$View$Lang$ViewTabNavUserConflict)
										]))
								]);
						} else {
							var sync = _n3.a;
							var prefix = function () {
								var _n4 = author$project$PlayFab$User$role(user);
								if (_n4 === 1) {
									return _List_fromArray(
										[
											author$project$View$Icon$fas('user-lock'),
											elm$html$Html$text(' (admin) ')
										]);
								} else {
									return _List_fromArray(
										[
											author$project$View$Icon$fas('user'),
											elm$html$Html$text(' ')
										]);
								}
							}();
							return _List_fromArray(
								[
									A2(
									elm$html$Html$a,
									_List_fromArray(
										[
											elm$html$Html$Attributes$class('dropdown-item'),
											A2(author$project$Route$href, query, author$project$Route$User)
										]),
									_Utils_ap(
										prefix,
										_List_fromArray(
											[
												elm$html$Html$text(
												A2(
													author$project$PlayFab$User$displayName,
													author$project$Session$iframe(session),
													user))
											])))
								]);
						}
					}
			}
		} else {
			var kong = _n0.a;
			var guest = _List_fromArray(
				[
					A2(
					elm$html$Html$a,
					_List_fromArray(
						[
							elm$html$Html$Attributes$class('dropdown-item'),
							elm$html$Html$Attributes$href('#'),
							elm$html$Html$Events$onClick(author$project$View$TabNav$KongregateShowRegistrationBox)
						]),
					_List_fromArray(
						[
							author$project$View$Icon$fas('user-plus'),
							elm$html$Html$text(' '),
							lang.q(author$project$View$Lang$ViewTabNavUserKongLogin)
						]))
				]);
			var _n5 = kong.cQ;
			if (!_n5.$) {
				var user = _n5.a;
				return user.eV ? guest : _List_fromArray(
					[
						A2(
						elm$html$Html$a,
						_List_fromArray(
							[
								elm$html$Html$Attributes$class('dropdown-item'),
								A2(author$project$Route$href, query, author$project$Route$User)
							]),
						_List_fromArray(
							[
								author$project$View$Icon$fas('user'),
								elm$html$Html$text(' '),
								elm$html$Html$text(user.fZ)
							]))
					]);
			} else {
				return guest;
			}
		}
	});
var elm$html$Html$button = _VirtualDom_node('button');
var elm$html$Html$Attributes$disabled = elm$html$Html$Attributes$boolProperty('disabled');
var elm$html$Html$Attributes$target = elm$html$Html$Attributes$stringProperty('target');
var author$project$View$TabNav$viewMoreDropdownEntries = F3(
	function (session, game, snap) {
		var query = author$project$Session$query(session);
		var lang = A2(author$project$View$Lang$gameToLang, session, game);
		var feedbackUrl = 'https://docs.google.com/forms/d/e/1FAIpQLSfffiBB3W9PIoVW-dV1v-2LggyjL4Iws5xezM_B3pw4ci4EJw/viewform?usp=pp_url&entry.1808064759=' + A2(
			elm$core$Maybe$withDefault,
			'(empty)',
			author$project$Session$persistExport(session));
		var buyCheapestList = A3(author$project$Select$bulkBuyableItems, 0.25, game, snap);
		var buyAllList = A3(author$project$Select$bulkBuyableItems, 1, game, snap);
		return elm$core$List$concat(
			A2(
				elm$core$List$intersperse,
				_List_fromArray(
					[
						A2(
						elm$html$Html$div,
						_List_fromArray(
							[
								elm$html$Html$Attributes$class('dropdown-divider')
							]),
						_List_Nil)
					]),
				A2(
					elm$core$List$filter,
					A2(elm$core$Basics$composeR, elm$core$List$isEmpty, elm$core$Basics$not),
					_List_fromArray(
						[
							_List_fromArray(
							[
								A2(
								elm$html$Html$button,
								_List_fromArray(
									[
										elm$html$Html$Attributes$class('dropdown-item'),
										elm$html$Html$Attributes$disabled(
										!elm$core$List$length(buyAllList)),
										elm$html$Html$Events$onClick(
										author$project$View$TabNav$BulkUpgradeAll(
											elm$core$List$length(buyAllList))),
										elm$html$Html$Attributes$title(
										A2(
											elm$core$String$join,
											', ',
											A2(
												elm$core$List$map,
												A2(
													elm$core$Basics$composeL,
													A2(
														elm$core$Basics$composeL,
														lang.fH,
														author$project$View$Lang$ItemName(author$project$Decimal$one)),
													author$project$GameData$Item$id),
												buyAllList)))
									]),
								_List_fromArray(
									[
										author$project$View$Icon$fas('arrow-alt-circle-up'),
										elm$html$Html$text(' '),
										lang.q(
										author$project$View$Lang$ViewTabBuyAll(
											elm$core$List$length(buyAllList)))
									])),
								A2(
								elm$html$Html$button,
								_List_fromArray(
									[
										elm$html$Html$Attributes$class('dropdown-item'),
										elm$html$Html$Attributes$disabled(
										!elm$core$List$length(buyCheapestList)),
										elm$html$Html$Events$onClick(
										author$project$View$TabNav$BulkUpgradeCheapest(
											elm$core$List$length(buyCheapestList))),
										elm$html$Html$Attributes$title(
										A2(
											elm$core$String$join,
											', ',
											A2(
												elm$core$List$map,
												A2(
													elm$core$Basics$composeL,
													A2(
														elm$core$Basics$composeL,
														lang.fH,
														author$project$View$Lang$ItemName(author$project$Decimal$one)),
													author$project$GameData$Item$id),
												buyCheapestList)))
									]),
								_List_fromArray(
									[
										author$project$View$Icon$far('arrow-alt-circle-up'),
										elm$html$Html$text(' '),
										lang.q(
										author$project$View$Lang$ViewTabBuyCheapest(
											elm$core$List$length(buyCheapestList)))
									])),
								function () {
								var _n0 = author$project$Session$undoDuration(session);
								if (_n0.$ === 1) {
									return A2(
										elm$html$Html$button,
										_List_fromArray(
											[
												elm$html$Html$Attributes$class('dropdown-item'),
												elm$html$Html$Attributes$disabled(true)
											]),
										_List_fromArray(
											[
												author$project$View$Icon$fas('undo'),
												elm$html$Html$text(' '),
												lang.q(author$project$View$Lang$ViewTabUndo)
											]));
								} else {
									var duration = _n0.a;
									return A2(
										elm$html$Html$button,
										_List_fromArray(
											[
												elm$html$Html$Attributes$class('dropdown-item'),
												elm$html$Html$Events$onClick(author$project$View$TabNav$Undo)
											]),
										_List_fromArray(
											[
												author$project$View$Icon$fas('undo'),
												elm$html$Html$text(' '),
												lang.q(
												author$project$View$Lang$ViewTabUndoDuration(duration))
											]));
								}
							}()
							]),
							A2(author$project$View$TabNav$viewUserButtons, session, game),
							_List_fromArray(
							[
								A2(
								elm$html$Html$a,
								_List_fromArray(
									[
										elm$html$Html$Attributes$class('dropdown-item'),
										A2(author$project$Route$href, query, author$project$Route$Options)
									]),
								_List_fromArray(
									[
										author$project$View$Icon$fas('cog'),
										elm$html$Html$text(' '),
										lang.q(author$project$View$Lang$ViewTabOptions)
									])),
								A2(
								elm$html$Html$a,
								_List_fromArray(
									[
										elm$html$Html$Attributes$class('dropdown-item'),
										A2(author$project$Route$href, query, author$project$Route$Achievements)
									]),
								_List_fromArray(
									[
										author$project$View$Icon$fas('trophy'),
										elm$html$Html$text(' '),
										lang.q(author$project$View$Lang$ViewTabAchievements)
									])),
								A2(
								elm$html$Html$a,
								_List_fromArray(
									[
										elm$html$Html$Attributes$class('dropdown-item'),
										A2(author$project$Route$href, query, author$project$Route$Statistics)
									]),
								_List_fromArray(
									[
										author$project$View$Icon$fas('chart-bar'),
										elm$html$Html$text(' '),
										lang.q(author$project$View$Lang$ViewTabStatistics)
									])),
								A2(
								elm$html$Html$a,
								_List_fromArray(
									[
										elm$html$Html$Attributes$class('dropdown-item'),
										A2(author$project$Route$href, query, author$project$Route$Changelog)
									]),
								_List_fromArray(
									[
										author$project$View$Icon$fas('book'),
										elm$html$Html$text(' '),
										lang.q(author$project$View$Lang$ViewTabChangelog)
									])),
								A2(
								elm$html$Html$a,
								_List_fromArray(
									[
										elm$html$Html$Attributes$class('dropdown-item'),
										elm$html$Html$Attributes$href('https://www.reddit.com/r/swarmsim'),
										elm$html$Html$Attributes$target('_blank')
									]),
								_List_fromArray(
									[
										author$project$View$Icon$fab('reddit'),
										elm$html$Html$text(' '),
										lang.q(author$project$View$Lang$ViewTabCommunity)
									])),
								A2(
								elm$html$Html$a,
								_List_fromArray(
									[
										elm$html$Html$Attributes$class('dropdown-item'),
										elm$html$Html$Attributes$href(feedbackUrl),
										elm$html$Html$Attributes$target('_blank')
									]),
								_List_fromArray(
									[
										author$project$View$Icon$fas('comment'),
										elm$html$Html$text(' '),
										lang.q(author$project$View$Lang$ViewTabFeedback)
									])),
								A2(
								elm$html$Html$a,
								_List_fromArray(
									[
										elm$html$Html$Attributes$class('dropdown-item'),
										elm$html$Html$Attributes$href(feedbackUrl),
										elm$html$Html$Attributes$target('_blank')
									]),
								_List_fromArray(
									[
										author$project$View$Icon$fas('bug'),
										elm$html$Html$text(' '),
										lang.q(author$project$View$Lang$ViewTabBugReport)
									])),
								A2(
								elm$html$Html$a,
								_List_fromArray(
									[
										elm$html$Html$Attributes$class('dropdown-item'),
										A2(
										author$project$Route$href,
										query,
										author$project$Route$Tab('all'))
									]),
								_List_fromArray(
									[
										author$project$View$Icon$far('list-alt'),
										elm$html$Html$text(' '),
										lang.q(author$project$View$Lang$ViewTabAllUnits)
									])),
								A2(
								elm$html$Html$button,
								_List_fromArray(
									[
										elm$html$Html$Attributes$class('dropdown-item'),
										author$project$View$Device$onlyDesktopCls,
										elm$html$Html$Events$onClick(author$project$View$TabNav$OpenKeyComboHelp)
									]),
								_List_fromArray(
									[
										author$project$View$Icon$fas('keyboard'),
										elm$html$Html$text(' '),
										lang.q(author$project$View$Lang$ViewTabHotkeys)
									]))
							]),
							A2(author$project$Route$Feature$isActive, 0, query) ? _List_fromArray(
							[
								A2(
								elm$html$Html$a,
								_List_fromArray(
									[
										elm$html$Html$Attributes$class('dropdown-item'),
										A2(author$project$Route$href, query, author$project$Route$Debug)
									]),
								_List_fromArray(
									[
										author$project$View$Icon$fas('tools'),
										elm$html$Html$text(' '),
										elm$html$Html$text(' Debugging tools')
									]))
							]) : _List_Nil,
							A2(author$project$Route$Feature$isActive, 3, query) ? _List_fromArray(
							[
								A2(
								elm$html$Html$a,
								_List_fromArray(
									[
										elm$html$Html$Attributes$class('dropdown-item'),
										A2(author$project$Route$href, query, author$project$Route$Translator)
									]),
								_List_fromArray(
									[
										author$project$View$Icon$fas('language'),
										elm$html$Html$text(' '),
										elm$html$Html$text(' Translating tools')
									]))
							]) : _List_Nil
						]))));
	});
var elm$virtual_dom$VirtualDom$attribute = F2(
	function (key, value) {
		return A2(
			_VirtualDom_attribute,
			_VirtualDom_noOnOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var elm$html$Html$Attributes$attribute = elm$virtual_dom$VirtualDom$attribute;
var elm$html$Html$Attributes$id = elm$html$Html$Attributes$stringProperty('id');
var author$project$View$TabNav$viewMoreTab = F4(
	function (device, session, game, snap) {
		var query = author$project$Session$query(session);
		var lang = A2(author$project$View$Lang$gameToLang, session, game);
		if (!device) {
			return A2(
				elm$html$Html$li,
				_List_fromArray(
					[
						elm$html$Html$Attributes$class('nav-item')
					]),
				_List_fromArray(
					[
						A2(
						elm$html$Html$div,
						_List_fromArray(
							[
								elm$html$Html$Attributes$class('dropdown')
							]),
						_List_fromArray(
							[
								A2(
								elm$html$Html$button,
								_List_fromArray(
									[
										elm$html$Html$Attributes$class('nav-link dropdown-toggle btn btn-link'),
										elm$html$Html$Attributes$id('more-tab'),
										A2(elm$html$Html$Attributes$attribute, 'data-toggle', 'dropdown'),
										A2(elm$html$Html$Attributes$attribute, 'role', 'button'),
										A2(elm$html$Html$Attributes$attribute, 'aria-haspopup', 'true')
									]),
								_List_fromArray(
									[
										lang.q(author$project$View$Lang$ViewTabMore)
									])),
								A2(
								elm$html$Html$div,
								_List_fromArray(
									[
										elm$html$Html$Attributes$class('dropdown-menu'),
										A2(elm$html$Html$Attributes$attribute, 'aria-labelledby', 'more-tab')
									]),
								A3(author$project$View$TabNav$viewMoreDropdownEntries, session, game, snap))
							]))
					]));
		} else {
			return A2(
				elm$html$Html$li,
				_List_fromArray(
					[
						elm$html$Html$Attributes$class('nav-item mobile-tab-nav')
					]),
				_List_fromArray(
					[
						A2(
						elm$html$Html$a,
						_List_fromArray(
							[
								elm$html$Html$Attributes$class('nav-link'),
								A2(author$project$Route$href, query, author$project$Route$MoreMenu)
							]),
						_List_fromArray(
							[
								A2(
								elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										elm$html$Html$text('\u00a0')
									])),
								A2(
								elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										lang.q(author$project$View$Lang$ViewTabMore)
									])),
								A2(
								elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										elm$html$Html$text('\u00a0')
									]))
							]))
					]));
		}
	});
var author$project$Select$isUnitSidebarAscendTriggered = F3(
	function (unit, game, snapshot) {
		return unit.e9.cX && A2(
			elm$core$Result$withDefault,
			false,
			A2(
				elm$core$Result$map,
				function ($) {
					return $.ds;
				},
				A4(
					author$project$Game$Order$fromPercent,
					game,
					snapshot,
					author$project$GameData$Item$Unit(unit),
					1)));
	});
var author$project$Select$isTabAscendTriggered = F3(
	function (tab, game, snapshot) {
		return A2(
			elm$core$List$any,
			function (u) {
				return A3(author$project$Select$isUnitSidebarAscendTriggered, u, game, snapshot);
			},
			A3(
				author$project$Select$unitsByTab,
				author$project$Select$NormalTab(tab),
				game,
				snapshot));
	});
var author$project$Select$isUnitSidebarWatchTriggered = F3(
	function (unit, game, snapshot) {
		return A2(
			elm$core$List$any,
			A3(author$project$Select$isItemWatchTriggered, 1, game, snapshot),
			A2(
				elm$core$List$cons,
				author$project$GameData$Item$Unit(unit),
				A2(
					elm$core$List$map,
					author$project$GameData$Item$Upgrade,
					A3(author$project$Select$upgradesByUnitId, unit.eL, game, snapshot))));
	});
var author$project$Select$isTabWatchTriggered = F3(
	function (tab, game, snapshot) {
		return A2(
			elm$core$List$any,
			function (u) {
				return A3(author$project$Select$isUnitSidebarWatchTriggered, u, game, snapshot);
			},
			A3(
				author$project$Select$unitsByTab,
				author$project$Select$NormalTab(tab),
				game,
				snapshot));
	});
var author$project$View$Lang$ViewTabCount = F3(
	function (a, b, c) {
		return {$: 49, a: a, b: b, c: c};
	});
var author$project$View$Lang$ViewTabMobileCount = function (a) {
	return {$: 51, a: a};
};
var author$project$View$Lang$ViewTabMobileName = function (a) {
	return {$: 50, a: a};
};
var author$project$View$Lang$ViewTabMobileSecondary = F2(
	function (a, b) {
		return {$: 52, a: a, b: b};
	});
var elm$html$Html$Attributes$classList = function (classes) {
	return elm$html$Html$Attributes$class(
		A2(
			elm$core$String$join,
			' ',
			A2(
				elm$core$List$map,
				elm$core$Tuple$first,
				A2(elm$core$List$filter, elm$core$Tuple$second, classes))));
};
var author$project$View$TabNav$viewTab = F8(
	function (device, lastUnit, lang, query, activeTab, game, snap, tab) {
		var isWatchTriggered = A3(author$project$Select$isTabWatchTriggered, tab, game, snap);
		var isAscendTriggered = A3(author$project$Select$isTabAscendTriggered, tab, game, snap);
		var watchIcon = _Utils_ap(
			isWatchTriggered ? _List_fromArray(
				[
					elm$html$Html$text(' '),
					author$project$View$Icon$fas('arrow-alt-circle-up'),
					elm$html$Html$text(' ')
				]) : _List_Nil,
			isAscendTriggered ? _List_fromArray(
				[
					elm$html$Html$text(' '),
					author$project$View$Icon$fas('rocket'),
					elm$html$Html$text(' ')
				]) : _List_Nil);
		var isActive = _Utils_eq(
			elm$core$Maybe$Just(tab.eL),
			activeTab);
		var route = isActive ? author$project$Route$Tab(
			author$project$GameData$Tab$name(tab)) : lastUnit(tab.eL);
		var count2 = A2(
			elm$core$Maybe$map,
			function (id2) {
				return A2(author$project$Game$UnitsSnapshot$count, id2, snap);
			},
			tab.fy);
		var count = A2(author$project$Game$UnitsSnapshot$count, tab.d3, snap);
		var cap = A2(
			elm$core$Maybe$map,
			function (capExpr) {
				return A3(
					author$project$Parser$Stat$evalWithDefault,
					author$project$Decimal$zero,
					author$project$Game$getGameVar(game),
					capExpr);
			},
			A2(
				elm$core$Maybe$andThen,
				function ($) {
					return $.eZ;
				},
				A2(
					author$project$GameData$unitByName,
					author$project$GameData$Unit$idToString(tab.d3),
					author$project$Game$gameData(game))));
		var capPct = A2(
			elm$core$Maybe$map,
			function (cap_) {
				return A2(
					elm$core$Maybe$withDefault,
					1,
					author$project$Decimal$toFiniteFloat(
						A2(author$project$Decimal$div, count, cap_)));
			},
			cap);
		if (device === 1) {
			return A2(
				elm$html$Html$li,
				_List_fromArray(
					[
						elm$html$Html$Attributes$class('nav-item mobile-tab-nav')
					]),
				_List_fromArray(
					[
						A2(
						elm$html$Html$a,
						_List_fromArray(
							[
								elm$html$Html$Attributes$class('nav-link'),
								elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('active', isActive)
									])),
								A2(author$project$Route$href, query, route)
							]),
						_List_fromArray(
							[
								A2(
								elm$html$Html$span,
								_List_fromArray(
									[
										elm$html$Html$Attributes$class('tab-icon-resource'),
										elm$html$Html$Attributes$class(
										'tab-icon-' + author$project$GameData$Tab$name(tab)),
										elm$html$Html$Attributes$class(
										'icon-' + author$project$GameData$Tab$name(tab))
									]),
								_List_Nil),
								A2(
								elm$html$Html$div,
								_List_fromArray(
									[
										elm$html$Html$Attributes$class('mobile-tab-name')
									]),
								_Utils_ap(
									watchIcon,
									_List_fromArray(
										[
											lang.q(
											author$project$View$Lang$ViewTabMobileName(tab.d3))
										]))),
								A2(
								elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										lang.q(
										author$project$View$Lang$ViewTabMobileCount(count))
									])),
								A2(
								elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										lang.q(
										A2(
											author$project$View$Lang$ViewTabMobileSecondary,
											count,
											{c1: capPct, c7: count2}))
									]))
							]))
					]));
		} else {
			return A2(
				elm$html$Html$li,
				_List_fromArray(
					[
						elm$html$Html$Attributes$class('nav-item')
					]),
				_List_fromArray(
					[
						A2(
						elm$html$Html$a,
						_List_fromArray(
							[
								elm$html$Html$Attributes$class('nav-link'),
								elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('active', isActive)
									])),
								A2(author$project$Route$href, query, route)
							]),
						_Utils_ap(
							_List_fromArray(
								[
									A2(
									elm$html$Html$span,
									_List_fromArray(
										[
											elm$html$Html$Attributes$class('tab-icon-resource'),
											elm$html$Html$Attributes$class(
											'tab-icon-' + author$project$GameData$Tab$name(tab)),
											elm$html$Html$Attributes$class(
											'icon-' + author$project$GameData$Tab$name(tab))
										]),
									_List_Nil),
									lang.q(
									A3(
										author$project$View$Lang$ViewTabCount,
										tab.d3,
										count,
										{c1: capPct, c7: count2}))
								]),
							watchIcon))
					]));
		}
	});
var author$project$View$TabNav$view = F4(
	function (activeTab, session, game, snap) {
		var tabs = A2(
			elm$core$List$filter,
			function (t) {
				return A2(author$project$Game$UnitsSnapshot$isTabVisible, t.eL, snap);
			},
			author$project$GameData$tabs(
				author$project$Game$gameData(game)));
		var query = author$project$Session$query(session);
		var lang = A2(author$project$View$Lang$gameToLang, session, game);
		var getLastUnit = author$project$Game$flipLastUnitByTab(game);
		return A2(author$project$Route$Feature$isActive, 5, query) ? _List_fromArray(
			[
				author$project$View$Device$onlyDesktop(
				_List_fromArray(
					[
						A2(
						elm$html$Html$ul,
						_List_fromArray(
							[
								elm$html$Html$Attributes$class('nav nav-tabs')
							]),
						_Utils_ap(
							A2(
								elm$core$List$map,
								A7(author$project$View$TabNav$viewTab, 0, getLastUnit, lang, query, activeTab, game, snap),
								tabs),
							_List_fromArray(
								[
									A4(author$project$View$TabNav$viewMoreTab, 0, session, game, snap)
								])))
					])),
				author$project$View$Device$onlyMobile(
				_List_fromArray(
					[
						A2(
						elm$html$Html$ul,
						_List_fromArray(
							[
								elm$html$Html$Attributes$class('nav nav-tabs nav-fill')
							]),
						_Utils_ap(
							A2(
								elm$core$List$map,
								A7(author$project$View$TabNav$viewTab, 1, getLastUnit, lang, query, activeTab, game, snap),
								tabs),
							_List_fromArray(
								[
									A4(author$project$View$TabNav$viewMoreTab, 1, session, game, snap)
								])))
					]))
			]) : _List_fromArray(
			[
				A2(
				elm$html$Html$ul,
				_List_fromArray(
					[
						elm$html$Html$Attributes$class('nav nav-tabs')
					]),
				_Utils_ap(
					A2(
						elm$core$List$map,
						A7(author$project$View$TabNav$viewTab, 0, getLastUnit, lang, query, activeTab, game, snap),
						tabs),
					_List_fromArray(
						[
							A4(author$project$View$TabNav$viewMoreTab, 0, session, game, snap)
						])))
			]);
	});
var author$project$View$TabNav$viewFromGame = F3(
	function (activeTab, session, game) {
		return A4(
			author$project$View$TabNav$view,
			activeTab,
			session,
			game,
			A2(author$project$Session$safeUnits, game, session));
	});
var elm$virtual_dom$VirtualDom$map = _VirtualDom_map;
var elm$html$Html$map = elm$virtual_dom$VirtualDom$map;
var author$project$Page$Achievements$view = F2(
	function (session, game) {
		return _Utils_ap(
			A2(
				elm$core$List$map,
				elm$html$Html$map(author$project$Page$Achievements$GotTabNavMsg),
				A3(author$project$View$TabNav$viewFromGame, elm$core$Maybe$Nothing, session, game)),
			A2(author$project$Page$Achievements$viewReady, session, game));
	});
var author$project$Page$Changelog$GotTabNavMsg = elm$core$Basics$identity;
var author$project$View$Lang$ViewChangelogScarybee = {$: 184};
var author$project$View$Lang$ViewChangelogSource = {$: 183};
var author$project$View$Lang$ViewChangelogTitle = {$: 182};
var elm$html$Html$h1 = _VirtualDom_node('h1');
var elm$html$Html$Attributes$rel = _VirtualDom_attribute('rel');
var author$project$Page$Changelog$viewReady = F2(
	function (session, game) {
		var lang = A2(author$project$View$Lang$gameToLang, session, game);
		return _List_fromArray(
			[
				A2(
				elm$html$Html$h1,
				_List_Nil,
				_List_fromArray(
					[
						lang.q(author$project$View$Lang$ViewChangelogTitle)
					])),
				A2(
				elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						elm$html$Html$a,
						_List_fromArray(
							[
								elm$html$Html$Attributes$target('_blank'),
								elm$html$Html$Attributes$rel('noopener'),
								elm$html$Html$Attributes$href('https://gitlab.com/erosson/swarm-elm')
							]),
						_List_fromArray(
							[
								author$project$View$Icon$fas('code'),
								elm$html$Html$text(' '),
								lang.q(author$project$View$Lang$ViewChangelogSource)
							]))
					])),
				A2(
				elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						lang.q(author$project$View$Lang$ViewChangelogScarybee)
					])),
				A2(elm$html$Html$hr, _List_Nil, _List_Nil),
				A2(
				elm_explorations$markdown$Markdown$toHtml,
				_List_Nil,
				author$project$Session$changelog(session))
			]);
	});
var author$project$Page$Changelog$view = F2(
	function (session, game) {
		return _Utils_ap(
			A2(
				elm$core$List$map,
				elm$html$Html$map(elm$core$Basics$identity),
				A3(author$project$View$TabNav$viewFromGame, elm$core$Maybe$Nothing, session, game)),
			A2(author$project$Page$Changelog$viewReady, session, game));
	});
var author$project$Page$Debug$FakedBrokenGameJson = {$: 8};
var author$project$Page$Debug$FakedBrokenGameRead = {$: 7};
var author$project$Page$Debug$FakedBrokenGamedata = {$: 6};
var author$project$Page$Debug$FakedSessionError = {$: 5};
var author$project$Page$Debug$PushAchievement = {$: 4};
var elm$html$Html$h5 = _VirtualDom_node('h5');
var author$project$Page$Debug$viewEventDebug = F2(
	function (session, game) {
		return _List_fromArray(
			[
				A2(
				elm$html$Html$h5,
				_List_fromArray(
					[
						elm$html$Html$Attributes$class('card-header')
					]),
				_List_fromArray(
					[
						elm$html$Html$text('Event simulator')
					])),
				A2(
				elm$html$Html$div,
				_List_fromArray(
					[
						elm$html$Html$Attributes$class('card-body')
					]),
				_List_fromArray(
					[
						A2(
						elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								elm$html$Html$button,
								_List_fromArray(
									[
										elm$html$Html$Attributes$class('btn btn-info'),
										elm$html$Html$Events$onClick(author$project$Page$Debug$PushAchievement)
									]),
								_List_fromArray(
									[
										elm$html$Html$text('debug achievement toast')
									]))
							])),
						A2(
						elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								elm$html$Html$button,
								_List_fromArray(
									[
										elm$html$Html$Attributes$class('btn btn-warning'),
										elm$html$Html$Events$onClick(author$project$Page$Debug$FakedSessionError)
									]),
								_List_fromArray(
									[
										elm$html$Html$text('debug session error')
									])),
								elm$html$Html$text(' generic ignorable top-level error message')
							])),
						A2(
						elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								elm$html$Html$button,
								_List_fromArray(
									[
										elm$html$Html$Attributes$class('btn btn-danger'),
										elm$html$Html$Events$onClick(author$project$Page$Debug$FakedBrokenGamedata)
									]),
								_List_fromArray(
									[
										elm$html$Html$text('debug broken gamedata')
									])),
								elm$html$Html$text(' spreadsheet data, including Lang/i18n, is bogus')
							])),
						A2(
						elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								elm$html$Html$button,
								_List_fromArray(
									[
										elm$html$Html$Attributes$class('btn btn-danger'),
										elm$html$Html$Events$onClick(author$project$Page$Debug$FakedBrokenGameRead)
									]),
								_List_fromArray(
									[
										elm$html$Html$text('debug broken game-read')
									])),
								elm$html$Html$text(' player progress isn\'t json, or isn\'t accessible')
							])),
						A2(
						elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								elm$html$Html$button,
								_List_fromArray(
									[
										elm$html$Html$Attributes$class('btn btn-danger'),
										elm$html$Html$Events$onClick(author$project$Page$Debug$FakedBrokenGameJson)
									]),
								_List_fromArray(
									[
										elm$html$Html$text('debug broken game-json')
									])),
								elm$html$Html$text(' player progress json is bogus')
							]))
					]))
			]);
	});
var author$project$Fools$toString = function (s) {
	switch (s) {
		case 0:
			return 'invited foolin\'';
		case 1:
			return 'yes foolin\'';
		case 3:
			return 'after foolin\'';
		default:
			return 'no foolin\'';
	}
};
var author$project$Route$Config$enum = function (c) {
	switch (c) {
		case 0:
			return _List_fromArray(
				['dev', 'prod']);
		case 1:
			return _List_fromArray(
				['development', 'production']);
		case 2:
			return _List_fromArray(
				['off', 'on', 'after']);
		case 3:
			return _List_fromArray(
				['www', 'kongregate']);
		case 4:
			return _List_fromArray(
				['production', 'sandbox', 'none']);
		default:
			return _List_fromArray(
				['localhost', 'www.swarmsim.com', 'elm.swarmsim.com']);
	}
};
var author$project$Route$Config$nextEnum = F2(
	function (c, value) {
		var values = author$project$Route$Config$enum(c);
		var rvalues = elm$core$List$reverse(values);
		var valuesMap = elm$core$Dict$fromList(
			A3(
				elm$core$List$map2,
				elm$core$Tuple$pair,
				rvalues,
				A2(
					elm$core$List$cons,
					elm$core$Maybe$Nothing,
					A2(elm$core$List$map, elm$core$Maybe$Just, rvalues))));
		if (value.$ === 1) {
			return elm$core$List$head(values);
		} else {
			var v = value.a;
			return A2(
				elm$core$Maybe$andThen,
				elm$core$Basics$identity,
				A2(elm$core$Dict$get, v, valuesMap));
		}
	});
var author$project$Route$Config$insert = function (k) {
	return elm$core$Dict$insert(
		author$project$Route$Config$toString(k));
};
var author$project$Route$Config$remove = function (k) {
	return elm$core$Dict$remove(
		author$project$Route$Config$toString(k));
};
var author$project$Route$Config$set = F2(
	function (k, mv) {
		if (mv.$ === 1) {
			return author$project$Route$Config$remove(k);
		} else {
			var v = mv.a;
			return A2(author$project$Route$Config$insert, k, v);
		}
	});
var author$project$Route$Config$setNextEnum = F2(
	function (c, d) {
		return A3(
			author$project$Route$Config$set,
			c,
			A2(
				author$project$Route$Config$nextEnum,
				c,
				A2(author$project$Route$Config$get, c, d)),
			d);
	});
var elm$html$Html$code = _VirtualDom_node('code');
var elm$html$Html$td = _VirtualDom_node('td');
var elm$html$Html$tr = _VirtualDom_node('tr');
var author$project$Page$Debug$viewConfigRow = F4(
	function (desc, title_, query, _n0) {
		var config = _n0.a;
		var fancyval = _n0.b;
		return A2(
			elm$html$Html$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					elm$html$Html$td,
					_List_fromArray(
						[
							elm$html$Html$Attributes$title(desc + (': ' + title_))
						]),
					_List_fromArray(
						[
							elm$html$Html$text(desc)
						])),
					A2(
					elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							elm$html$Html$a,
							_List_fromArray(
								[
									elm$html$Html$Attributes$class('card-link'),
									A2(
									author$project$Route$href,
									A2(author$project$Route$Config$setNextEnum, config, query),
									author$project$Route$Debug)
								]),
							_List_fromArray(
								[
									elm$html$Html$text('?'),
									elm$html$Html$text(
									author$project$Route$Config$toString(config))
								]))
						])),
					A2(
					elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							var _n1 = A2(author$project$Route$Config$get, config, query);
							if (_n1.$ === 1) {
								return A2(
									elm$html$Html$b,
									_List_fromArray(
										[
											elm$html$Html$Attributes$class('empty'),
											elm$html$Html$Attributes$title('(none)')
										]),
									_List_fromArray(
										[
											elm$html$Html$text('∅')
										]));
							} else {
								var s = _n1.a;
								return A2(
									elm$html$Html$code,
									_List_Nil,
									_List_fromArray(
										[
											elm$html$Html$text(s)
										]));
							}
						}()
						])),
					A2(
					elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							elm$html$Html$code,
							_List_Nil,
							_List_fromArray(
								[
									elm$html$Html$text(fancyval)
								]))
						]))
				]));
	});
var author$project$Route$Feature$insert = F2(
	function (f, b) {
		return _Utils_eq(
			b,
			author$project$Route$Feature$defaultValue(f)) ? author$project$Route$Feature$remove(f) : A2(
			elm$core$Dict$insert,
			author$project$Route$Feature$toString(f),
			b ? '1' : '0');
	});
var author$project$Route$Feature$toggle = F2(
	function (f, d) {
		return A3(
			author$project$Route$Feature$insert,
			f,
			!A2(author$project$Route$Feature$isActive, f, d),
			d);
	});
var author$project$Page$Debug$viewFlagRow = F4(
	function (desc, title_, query, feature) {
		return A2(
			elm$html$Html$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					elm$html$Html$td,
					_List_fromArray(
						[
							elm$html$Html$Attributes$title(desc + (' flag: ' + title_))
						]),
					_List_fromArray(
						[
							elm$html$Html$text(desc)
						])),
					A2(
					elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							elm$html$Html$a,
							_List_fromArray(
								[
									elm$html$Html$Attributes$class('card-link'),
									A2(
									author$project$Route$href,
									A2(author$project$Route$Feature$toggle, feature, query),
									author$project$Route$Debug)
								]),
							_List_fromArray(
								[
									elm$html$Html$text('?'),
									elm$html$Html$text(
									author$project$Route$Feature$toString(feature))
								]))
						])),
					A2(
					elm$html$Html$td,
					_List_Nil,
					A2(author$project$Route$Feature$isActive, feature, query) ? _List_fromArray(
						[
							A2(
							elm$html$Html$span,
							_List_fromArray(
								[
									elm$html$Html$Attributes$class('active')
								]),
							_List_fromArray(
								[
									author$project$View$Icon$fas('check')
								]))
						]) : _List_fromArray(
						[
							A2(
							elm$html$Html$span,
							_List_fromArray(
								[
									elm$html$Html$Attributes$class('inactive')
								]),
							_List_fromArray(
								[
									author$project$View$Icon$fas('times')
								]))
						])),
					A2(elm$html$Html$td, _List_Nil, _List_Nil)
				]));
	});
var author$project$Route$Config$PaypalEnv = 4;
var author$project$Route$Feature$debugs = _List_fromArray(
	[0, 1, 3]);
var author$project$Route$Feature$temps = _List_fromArray(
	[4, 5]);
var author$project$Session$PaypalEnv$ElmBeta = 1;
var author$project$Session$PaypalEnv$None = 3;
var author$project$Session$PaypalEnv$Production = 0;
var author$project$Session$PaypalEnv$Sandbox = 2;
var author$project$Session$PaypalEnv$fromQuery = F4(
	function (env, iframe, hostname, query) {
		var _n0 = A2(author$project$Route$Config$get, 4, query);
		_n0$4:
		while (true) {
			if (!_n0.$) {
				switch (_n0.a) {
					case 'production':
						return 0;
					case 'sandbox':
						return 2;
					case 'elm-beta':
						return 1;
					case 'none':
						return 3;
					default:
						break _n0$4;
				}
			} else {
				break _n0$4;
			}
		}
		if (iframe.$ === 1) {
			return 3;
		} else {
			switch (env.$) {
				case 0:
					switch (hostname) {
						case 'elm.swarmsim.com':
							return 1;
						case 'www.swarmsim.com':
							return 0;
						case 'swarmsim.com':
							return 0;
						default:
							return 0;
					}
				case 1:
					return 2;
				default:
					return 2;
			}
		}
	});
var author$project$Session$paypalEnv = function (session) {
	return A4(
		author$project$Session$PaypalEnv$fromQuery,
		author$project$Session$environment(session),
		author$project$Session$iframe(session),
		author$project$Session$hostname(session),
		author$project$Session$query(session));
};
var author$project$PlayFab$User$defaultRole = 0;
var author$project$Session$userRole = A2(
	elm$core$Basics$composeR,
	author$project$Session$user,
	krisajenkins$remotedata$RemoteData$map(
		A2(
			elm$core$Basics$composeR,
			elm$core$Maybe$map(author$project$PlayFab$User$role),
			elm$core$Maybe$withDefault(author$project$PlayFab$User$defaultRole))));
var author$project$Session$Iframe$toString = function (env) {
	if (!env.$) {
		return 'www';
	} else {
		return 'kongregate';
	}
};
var author$project$Session$PaypalEnv$toString = function (env) {
	switch (env) {
		case 0:
			return 'production';
		case 1:
			return 'elm-beta';
		case 2:
			return 'sandbox';
		default:
			return 'none';
	}
};
var elm$html$Html$table = _VirtualDom_node('table');
var elm$html$Html$th = _VirtualDom_node('th');
var author$project$Page$Debug$viewFlagLinks = F2(
	function (session, game) {
		var query = author$project$Session$query(session);
		return _List_fromArray(
			[
				A2(
				elm$html$Html$h5,
				_List_fromArray(
					[
						elm$html$Html$Attributes$class('card-header')
					]),
				_List_fromArray(
					[
						elm$html$Html$text('Flags 🏁🏴\u200d☠️🏳️\u200d🌈🚩')
					])),
				A2(
				elm$html$Html$div,
				_List_fromArray(
					[
						elm$html$Html$Attributes$class('card-body')
					]),
				_List_fromArray(
					[
						A2(
						elm$html$Html$table,
						_List_fromArray(
							[
								elm$html$Html$Attributes$class('flags')
							]),
						_Utils_ap(
							_List_fromArray(
								[
									A2(
									elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											elm$html$Html$text('Flag type')
										])),
									A2(
									elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											elm$html$Html$text('Querystring')
										])),
									A2(
									elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											elm$html$Html$text('')
										])),
									A2(
									elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											elm$html$Html$text('Value')
										]))
								]),
							_Utils_ap(
								A2(
									elm$core$List$map,
									A3(author$project$Page$Debug$viewFlagRow, 'feature', 'temporary', query),
									author$project$Route$Feature$temps),
								_Utils_ap(
									A2(
										elm$core$List$map,
										A3(author$project$Page$Debug$viewConfigRow, 'debug', 'permanent', query),
										_List_fromArray(
											[
												_Utils_Tuple2(
												2,
												author$project$Fools$toString(
													author$project$Fools$status(session)))
											])),
									_Utils_ap(
										A2(
											elm$core$List$map,
											A3(author$project$Page$Debug$viewFlagRow, 'debug', 'permanent', query),
											author$project$Route$Feature$debugs),
										function () {
											var _n0 = author$project$Session$userRole(session);
											if ((_n0.$ === 3) && (_n0.a === 1)) {
												var _n1 = _n0.a;
												return _Utils_ap(
													_List_Nil,
													_Utils_ap(
														A2(
															elm$core$List$map,
															A3(author$project$Page$Debug$viewConfigRow, 'env', 'permanent, hidden from non-admins', query),
															_List_fromArray(
																[
																	_Utils_Tuple2(
																	0,
																	author$project$PlayFab$TitleId$toString(
																		author$project$PlayFab$TitleId$fromSession(session))),
																	_Utils_Tuple2(
																	1,
																	author$project$Session$Environment$toString(
																		author$project$Session$environment(session))),
																	_Utils_Tuple2(
																	3,
																	author$project$Session$Iframe$toString(
																		author$project$Session$iframe(session))),
																	_Utils_Tuple2(
																	4,
																	author$project$Session$PaypalEnv$toString(
																		author$project$Session$paypalEnv(session))),
																	_Utils_Tuple2(
																	5,
																	author$project$Session$hostname(session))
																])),
														A2(
															elm$core$List$map,
															A3(author$project$Page$Debug$viewFlagRow, 'env', 'permanent flag, hidden from non-admins', query),
															_List_fromArray(
																[2]))));
											} else {
												return _List_Nil;
											}
										}())))))
					]))
			]);
	});
var elm$html$Html$pre = _VirtualDom_node('pre');
var author$project$Page$Debug$viewGameState = F2(
	function (session, game) {
		return _List_fromArray(
			[
				A2(
				elm$html$Html$h5,
				_List_fromArray(
					[
						elm$html$Html$Attributes$class('card-header')
					]),
				_List_fromArray(
					[
						elm$html$Html$text('Game state')
					])),
				A2(
				elm$html$Html$div,
				_List_fromArray(
					[
						elm$html$Html$Attributes$class('card-body')
					]),
				_List_fromArray(
					[
						A2(
						elm$html$Html$pre,
						_List_Nil,
						_List_fromArray(
							[
								elm$html$Html$text(
								A2(
									elm$json$Json$Encode$encode,
									2,
									A2(
										author$project$Game$encoder,
										A2(author$project$Session$safeNow, game, session),
										game)))
							]))
					]))
			]);
	});
var author$project$Page$Debug$SaveStateConfirmed = {$: 3};
var author$project$Page$Debug$SaveStateInput = function (a) {
	return {$: 2, a: a};
};
var author$project$View$NotReady$viewRemoteInline = function (remote) {
	switch (remote.$) {
		case 0:
			return _List_Nil;
		case 1:
			return _List_fromArray(
				[author$project$View$Icon$loading]);
		case 2:
			var err = remote.a;
			return _List_fromArray(
				[
					elm$html$Html$text(err)
				]);
		default:
			var html = remote.a;
			return html;
	}
};
var elm$core$String$lines = _String_lines;
var elm$html$Html$textarea = _VirtualDom_node('textarea');
var elm$html$Html$Attributes$rows = function (n) {
	return A2(
		_VirtualDom_attribute,
		'rows',
		elm$core$String$fromInt(n));
};
var elm$html$Html$Events$onBlur = function (msg) {
	return A2(
		elm$html$Html$Events$on,
		'blur',
		elm$json$Json$Decode$succeed(msg));
};
var elm$html$Html$Events$alwaysStop = function (x) {
	return _Utils_Tuple2(x, true);
};
var elm$virtual_dom$VirtualDom$MayStopPropagation = function (a) {
	return {$: 1, a: a};
};
var elm$html$Html$Events$stopPropagationOn = F2(
	function (event, decoder) {
		return A2(
			elm$virtual_dom$VirtualDom$on,
			event,
			elm$virtual_dom$VirtualDom$MayStopPropagation(decoder));
	});
var elm$html$Html$Events$targetValue = A2(
	elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'value']),
	elm$json$Json$Decode$string);
var elm$html$Html$Events$onInput = function (tagger) {
	return A2(
		elm$html$Html$Events$stopPropagationOn,
		'input',
		A2(
			elm$json$Json$Decode$map,
			elm$html$Html$Events$alwaysStop,
			A2(elm$json$Json$Decode$map, tagger, elm$html$Html$Events$targetValue)));
};
var krisajenkins$remotedata$RemoteData$isFailure = function (data) {
	if (data.$ === 2) {
		var x = data.a;
		return true;
	} else {
		return false;
	}
};
var krisajenkins$remotedata$RemoteData$isSuccess = function (data) {
	if (data.$ === 3) {
		var x = data.a;
		return true;
	} else {
		return false;
	}
};
var author$project$Page$Debug$viewGameStateEditor = F2(
	function (_n0, game) {
		var m = _n0;
		var now = A2(author$project$Session$safeNow, game, m.f);
		var pnow = elm$time$Time$posixToMillis(now);
		var content = function () {
			var _n1 = m.aS;
			if (_n1.$ === 1) {
				return A2(
					elm$json$Json$Encode$encode,
					2,
					A2(author$project$Game$encoder, now, game));
			} else {
				if (_n1.a === '') {
					return A2(
						elm$json$Json$Encode$encode,
						2,
						A2(author$project$Game$encoder, now, game));
				} else {
					var str = _n1.a;
					return str;
				}
			}
		}();
		return _List_fromArray(
			[
				A2(
				elm$html$Html$h5,
				_List_fromArray(
					[
						elm$html$Html$Attributes$class('card-header')
					]),
				_List_fromArray(
					[
						elm$html$Html$text('Game state editor')
					])),
				A2(
				elm$html$Html$div,
				_List_fromArray(
					[
						elm$html$Html$Attributes$class('card-body')
					]),
				_List_fromArray(
					[
						A2(
						elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								elm$html$Html$text('the time is now '),
								A2(
								elm$html$Html$code,
								_List_Nil,
								_List_fromArray(
									[
										elm$html$Html$text(
										elm$core$String$fromInt(
											pnow - A2(elm$core$Basics$modBy, 5000, pnow)))
									])),
								elm$html$Html$text(' + '),
								elm$html$Html$text(
								elm$core$String$fromInt(
									A2(elm$core$Basics$modBy, 5000, pnow)))
							])),
						A2(
						elm$html$Html$textarea,
						_List_fromArray(
							[
								elm$html$Html$Attributes$class('alert'),
								A2(elm$html$Html$Attributes$style, 'width', '100%'),
								elm$html$Html$Attributes$rows(
								elm$core$List$length(
									elm$core$String$lines(content))),
								elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'alert-success',
										krisajenkins$remotedata$RemoteData$isSuccess(m.R)),
										_Utils_Tuple2(
										'alert-danger',
										krisajenkins$remotedata$RemoteData$isFailure(m.R)),
										_Utils_Tuple2(
										'alert-secondary',
										!(krisajenkins$remotedata$RemoteData$isSuccess(m.R) || krisajenkins$remotedata$RemoteData$isFailure(m.R)))
									])),
								elm$html$Html$Events$onInput(author$project$Page$Debug$SaveStateInput),
								elm$html$Html$Events$onBlur(author$project$Page$Debug$SaveStateConfirmed)
							]),
						_List_fromArray(
							[
								elm$html$Html$text(content)
							])),
						A2(
						elm$html$Html$pre,
						_List_Nil,
						author$project$View$NotReady$viewRemoteInline(
							A2(
								krisajenkins$remotedata$RemoteData$map,
								elm$core$Basics$always(_List_Nil),
								m.R)))
					]))
			]);
	});
var author$project$Page$Debug$FakedServiceWorkerEvent = function (a) {
	return {$: 1, a: a};
};
var author$project$Page$Debug$serviceWorkerButton = F3(
	function (label, attrs, event) {
		return A2(
			elm$html$Html$button,
			_Utils_ap(
				attrs,
				_List_fromArray(
					[
						elm$html$Html$Attributes$class('btn'),
						elm$html$Html$Events$onClick(
						author$project$Page$Debug$FakedServiceWorkerEvent(event))
					])),
			_List_fromArray(
				[
					elm$html$Html$text(label)
				]));
	});
var author$project$Page$Debug$serviceWorkerStatusButton = F2(
	function (status, attrs) {
		return A3(
			author$project$Page$Debug$serviceWorkerButton,
			status,
			attrs,
			elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'status',
						elm$json$Json$Encode$string(status))
					])));
	});
var author$project$Page$Debug$viewServiceWorkerDebug = F2(
	function (session, game) {
		return _List_fromArray(
			[
				A2(
				elm$html$Html$h5,
				_List_fromArray(
					[
						elm$html$Html$Attributes$class('card-header')
					]),
				_List_fromArray(
					[
						elm$html$Html$text('Service worker event simulator')
					])),
				A2(
				elm$html$Html$div,
				_List_fromArray(
					[
						elm$html$Html$Attributes$class('card-body')
					]),
				_List_fromArray(
					[
						A2(
						author$project$Page$Debug$serviceWorkerStatusButton,
						'update-found',
						_List_fromArray(
							[
								elm$html$Html$Attributes$class('btn-info')
							])),
						A2(
						author$project$Page$Debug$serviceWorkerStatusButton,
						'update-installed',
						_List_fromArray(
							[
								elm$html$Html$Attributes$class('btn-info')
							])),
						A2(
						author$project$Page$Debug$serviceWorkerStatusButton,
						'offline-installed',
						_List_fromArray(
							[
								elm$html$Html$Attributes$class('btn-info')
							])),
						A3(
						author$project$Page$Debug$serviceWorkerButton,
						'error',
						_List_fromArray(
							[
								elm$html$Html$Attributes$class('btn-warning')
							]),
						elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'status',
									elm$json$Json$Encode$string('error')),
									_Utils_Tuple2(
									'error',
									elm$json$Json$Encode$string('debug tools test error'))
								])))
					]))
			]);
	});
var author$project$Session$Iframe$Kongregate$gameAuthTokenToString = function (_n0) {
	var t = _n0;
	return A2(elm$core$String$left, 5, t) + ('...' + A2(elm$core$String$right, 5, t));
};
var author$project$Page$Debug$viewStaticData = F2(
	function (session, game) {
		return _List_fromArray(
			[
				A2(
				elm$html$Html$h5,
				_List_fromArray(
					[
						elm$html$Html$Attributes$class('card-header')
					]),
				_List_fromArray(
					[
						elm$html$Html$text('Static data')
					])),
				A2(
				elm$html$Html$div,
				_List_fromArray(
					[
						elm$html$Html$Attributes$class('card-body')
					]),
				_List_fromArray(
					[
						A2(
						elm$html$Html$a,
						_List_fromArray(
							[
								elm$html$Html$Attributes$class('card-link'),
								elm$html$Html$Attributes$target('_blank'),
								elm$html$Html$Attributes$href('/gamedata.ods')
							]),
						_List_fromArray(
							[
								elm$html$Html$text('gamedata.ods (libreoffice spreadsheet)')
							])),
						A2(
						elm$html$Html$a,
						_List_fromArray(
							[
								elm$html$Html$Attributes$class('card-link'),
								elm$html$Html$Attributes$target('_blank'),
								elm$html$Html$Attributes$href('/gamedata.json')
							]),
						_List_fromArray(
							[
								elm$html$Html$text('gamedata.json')
							])),
						A2(
						elm$html$Html$a,
						_List_fromArray(
							[
								elm$html$Html$Attributes$class('card-link'),
								elm$html$Html$Attributes$target('_blank'),
								elm$html$Html$Attributes$href('/version.json')
							]),
						_List_fromArray(
							[
								elm$html$Html$text('version.json')
							])),
						A2(
						elm$html$Html$a,
						_List_fromArray(
							[
								elm$html$Html$Attributes$class('card-link'),
								elm$html$Html$Attributes$target('_blank'),
								elm$html$Html$Attributes$href('/lang/en-us.json')
							]),
						_List_fromArray(
							[
								elm$html$Html$text('lang/en-us.json')
							])),
						A2(
						elm$html$Html$div,
						_List_Nil,
						function () {
							var _n0 = author$project$Session$iframe(session);
							if (!_n0.$) {
								return _List_Nil;
							} else {
								var kong = _n0.a;
								return _List_fromArray(
									[
										A2(
										elm$html$Html$div,
										_List_Nil,
										_List_fromArray(
											[
												elm$html$Html$text('kongregate_api: '),
												A2(
												elm$html$Html$code,
												_List_Nil,
												function () {
													var _n1 = kong.ed;
													switch (_n1.$) {
														case 0:
															return _List_fromArray(
																[
																	elm$html$Html$text('notasked')
																]);
														case 1:
															return _List_fromArray(
																[author$project$View$Icon$loading]);
														case 2:
															var err = _n1.a;
															return _List_fromArray(
																[
																	elm$html$Html$text('failure: '),
																	elm$html$Html$text(err)
																]);
														default:
															return _List_fromArray(
																[
																	elm$html$Html$text('ready')
																]);
													}
												}())
											])),
										A2(
										elm$html$Html$div,
										_List_Nil,
										_List_fromArray(
											[
												elm$html$Html$text('kongregate_user: '),
												A2(
												elm$html$Html$code,
												_List_Nil,
												function () {
													var _n2 = kong.cQ;
													if (_n2.$ === 1) {
														return _List_fromArray(
															[
																elm$html$Html$text('(none)')
															]);
													} else {
														var user = _n2.a;
														return A2(
															elm$core$List$map,
															elm$html$Html$text,
															A2(
																elm$core$List$intersperse,
																', ',
																_List_fromArray(
																	[
																		author$project$Session$Iframe$Kongregate$userIdToString(user.bH),
																		user.fZ,
																		author$project$Session$Iframe$Kongregate$gameAuthTokenToString(user.dk),
																		user.eV ? 'guest' : 'not-guest'
																	])));
													}
												}())
											]))
									]);
							}
						}())
					]))
			]);
	});
var author$project$Page$Debug$view = F2(
	function (_n0, game) {
		var m = _n0;
		var role = author$project$Session$userRole(m.f);
		return _Utils_ap(
			_List_fromArray(
				[
					A2(
					elm$html$Html$h3,
					_List_Nil,
					_List_fromArray(
						[
							elm$html$Html$text('Debugging Tools')
						])),
					A2(
					elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							elm$html$Html$text('Here are some of the developer\'s debugging tools! They\'re now visible even in production - have fun.')
						])),
					A2(
					elm$html$Html$p,
					_List_Nil,
					function () {
						_n1$2:
						while (true) {
							switch (role.$) {
								case 3:
									if (role.a === 1) {
										var _n2 = role.a;
										return _List_fromArray(
											[
												A2(
												elm$html$Html$a,
												_List_fromArray(
													[
														elm$html$Html$Attributes$target('_blank'),
														elm$html$Html$Attributes$href('https://youtu.be/AJKx1XDBqNo?t=12')
													]),
												_List_fromArray(
													[
														elm$html$Html$text('You\'re an admin! ')
													])),
												elm$html$Html$text('You can edit your saved game below, too.')
											]);
									} else {
										break _n1$2;
									}
								case 1:
									return _List_fromArray(
										[author$project$View$Icon$loading]);
								default:
									break _n1$2;
							}
						}
						return _List_fromArray(
							[
								elm$html$Html$text('The cheaty admin tools like save-editing and time-skipping aren\'t here ('),
								A2(
								elm$html$Html$a,
								_List_fromArray(
									[
										A2(
										author$project$Route$href,
										author$project$Session$query(m.f),
										author$project$Route$Login)
									]),
								_List_fromArray(
									[
										elm$html$Html$text('unless you\'re an admin')
									])),
								elm$html$Html$text(').')
							]);
					}())
				]),
			A2(
				elm$core$List$map,
				elm$html$Html$div(
					_List_fromArray(
						[
							elm$html$Html$Attributes$class('card')
						])),
				_List_fromArray(
					[
						A2(author$project$Page$Debug$viewFlagLinks, m.f, game),
						A2(author$project$Page$Debug$viewStaticData, m.f, game),
						A2(author$project$Page$Debug$viewEventDebug, m.f, game),
						A2(author$project$Page$Debug$viewServiceWorkerDebug, m.f, game),
						function () {
						if ((role.$ === 3) && (role.a === 1)) {
							var _n4 = role.a;
							return A2(author$project$Page$Debug$viewGameStateEditor, m, game);
						} else {
							return A2(author$project$Page$Debug$viewGameState, m.f, game);
						}
					}()
					])));
	});
var author$project$Page$Login$InputEmail = function (a) {
	return {$: 2, a: a};
};
var author$project$Page$Login$InputPassword = function (a) {
	return {$: 3, a: a};
};
var author$project$Page$Login$InputRemember = function (a) {
	return {$: 4, a: a};
};
var author$project$Page$Login$Submit = {$: 1};
var author$project$PlayFab$errorField = F2(
	function (error, field) {
		if ((!error.$) && (error.a.$ === 3)) {
			var formError = error.a.a;
			var _n1 = A2(elm$core$Dict$get, field, formError.eF);
			if (!_n1.$) {
				var errs = _n1.a;
				return errs;
			} else {
				return _List_Nil;
			}
		} else {
			return _List_Nil;
		}
	});
var author$project$View$FormUtil$error = function (errors) {
	return A2(
		elm$html$Html$div,
		_List_Nil,
		A2(
			elm$core$List$map,
			function (e) {
				return A2(
					elm$html$Html$div,
					_List_fromArray(
						[
							elm$html$Html$Attributes$class('invalid-feedback'),
							A2(elm$html$Html$Attributes$style, 'display', 'block')
						]),
					_List_fromArray(
						[
							elm$html$Html$text(e)
						]));
			},
			errors));
};
var author$project$View$FormUtil$failure = function (res) {
	if (res.$ === 2) {
		var e = res.a;
		return elm$core$Maybe$Just(e);
	} else {
		return elm$core$Maybe$Nothing;
	}
};
var author$project$View$FormUtil$field = F4(
	function (errors, element, attrs, content) {
		if (!errors.b) {
			return _List_fromArray(
				[
					A2(element, attrs, content)
				]);
		} else {
			return _List_fromArray(
				[
					A2(
					element,
					_Utils_ap(
						attrs,
						_List_fromArray(
							[
								elm$html$Html$Attributes$class('is-invalid')
							])),
					content),
					A2(
					elm$html$Html$div,
					_List_fromArray(
						[
							elm$html$Html$Attributes$class('invalid-feedback')
						]),
					A2(
						elm$core$List$map,
						function (err) {
							return A2(
								elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										elm$html$Html$text(err)
									]));
						},
						errors))
				]);
		}
	});
var author$project$View$Lang$ViewLoginFieldEmail = {$: 143};
var author$project$View$Lang$ViewLoginFieldPassword = {$: 144};
var author$project$View$Lang$ViewLoginFieldRememberMe = {$: 145};
var author$project$View$Lang$ViewLoginLinkRegister = {$: 147};
var author$project$View$Lang$ViewLoginLinkResetPassword = {$: 148};
var author$project$View$Lang$ViewLoginSubmit = {$: 146};
var author$project$View$Lang$ViewLoginTitle = {$: 142};
var author$project$View$Lang$gameDataToLang = F2(
	function (session, gd) {
		var locale = A2(
			elm$core$Maybe$withDefault,
			0,
			A2(
				elm$core$Maybe$andThen,
				author$project$Game$locale,
				krisajenkins$remotedata$RemoteData$toMaybe(
					author$project$Session$game(session))));
		return A5(
			author$project$View$Lang$localeToLang,
			gd,
			author$project$Fools$status(session),
			elm$core$Maybe$Nothing,
			author$project$Session$translatorEntry(session),
			locale);
	});
var elm$html$Html$Attributes$for = elm$html$Html$Attributes$stringProperty('htmlFor');
var elm$html$Html$Attributes$value = elm$html$Html$Attributes$stringProperty('value');
var elm$html$Html$Events$targetChecked = A2(
	elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'checked']),
	elm$json$Json$Decode$bool);
var elm$html$Html$Events$onCheck = function (tagger) {
	return A2(
		elm$html$Html$Events$on,
		'change',
		A2(elm$json$Json$Decode$map, tagger, elm$html$Html$Events$targetChecked));
};
var elm$html$Html$Events$alwaysPreventDefault = function (msg) {
	return _Utils_Tuple2(msg, true);
};
var elm$virtual_dom$VirtualDom$MayPreventDefault = function (a) {
	return {$: 2, a: a};
};
var elm$html$Html$Events$preventDefaultOn = F2(
	function (event, decoder) {
		return A2(
			elm$virtual_dom$VirtualDom$on,
			event,
			elm$virtual_dom$VirtualDom$MayPreventDefault(decoder));
	});
var elm$html$Html$Events$onSubmit = function (msg) {
	return A2(
		elm$html$Html$Events$preventDefaultOn,
		'submit',
		A2(
			elm$json$Json$Decode$map,
			elm$html$Html$Events$alwaysPreventDefault,
			elm$json$Json$Decode$succeed(msg)));
};
var author$project$Page$Login$view = F2(
	function (_n0, gd) {
		var model = _n0;
		var qs = author$project$Session$query(model.f);
		var lang = A2(author$project$View$Lang$gameDataToLang, model.f, gd);
		var error = author$project$View$FormUtil$failure(model.a$);
		return _List_fromArray(
			[
				A2(
				elm$html$Html$h3,
				_List_Nil,
				_List_fromArray(
					[
						lang.q(author$project$View$Lang$ViewLoginTitle)
					])),
				A2(
				elm$html$Html$form,
				_List_fromArray(
					[
						elm$html$Html$Events$onSubmit(author$project$Page$Login$Submit)
					]),
				_List_fromArray(
					[
						A2(
						elm$html$Html$div,
						_List_fromArray(
							[
								elm$html$Html$Attributes$class('form-group')
							]),
						A2(
							elm$core$List$cons,
							A2(
								elm$html$Html$label,
								_List_fromArray(
									[
										elm$html$Html$Attributes$for('playfab-login-email')
									]),
								_List_fromArray(
									[
										lang.q(author$project$View$Lang$ViewLoginFieldEmail)
									])),
							A4(
								author$project$View$FormUtil$field,
								A2(author$project$PlayFab$errorField, error, 'Email'),
								elm$html$Html$input,
								_List_fromArray(
									[
										elm$html$Html$Attributes$type_('email'),
										elm$html$Html$Attributes$id('playfab-login-email'),
										elm$html$Html$Attributes$class('form-control'),
										elm$html$Html$Attributes$value(model.bW),
										elm$html$Html$Events$onInput(author$project$Page$Login$InputEmail)
									]),
								_List_Nil))),
						A2(
						elm$html$Html$div,
						_List_fromArray(
							[
								elm$html$Html$Attributes$class('form-group')
							]),
						A2(
							elm$core$List$cons,
							A2(
								elm$html$Html$label,
								_List_fromArray(
									[
										elm$html$Html$Attributes$for('playfab-login-password')
									]),
								_List_fromArray(
									[
										lang.q(author$project$View$Lang$ViewLoginFieldPassword)
									])),
							A4(
								author$project$View$FormUtil$field,
								A2(author$project$PlayFab$errorField, error, 'Password'),
								elm$html$Html$input,
								_List_fromArray(
									[
										elm$html$Html$Attributes$type_('password'),
										elm$html$Html$Attributes$id('playfab-login-password'),
										elm$html$Html$Attributes$class('form-control'),
										elm$html$Html$Attributes$value(model.cq),
										elm$html$Html$Events$onInput(author$project$Page$Login$InputPassword)
									]),
								_List_Nil))),
						A2(
						elm$html$Html$div,
						_List_fromArray(
							[
								elm$html$Html$Attributes$class('form-group form-check')
							]),
						_List_fromArray(
							[
								A2(
								elm$html$Html$input,
								_List_fromArray(
									[
										elm$html$Html$Attributes$type_('checkbox'),
										elm$html$Html$Attributes$id('playfab-login-remember'),
										elm$html$Html$Attributes$class('form-check-input'),
										elm$html$Html$Attributes$checked(model.bv),
										elm$html$Html$Events$onCheck(author$project$Page$Login$InputRemember)
									]),
								_List_Nil),
								A2(
								elm$html$Html$label,
								_List_fromArray(
									[
										elm$html$Html$Attributes$for('playfab-login-remember'),
										elm$html$Html$Attributes$class('form-check-label')
									]),
								_List_fromArray(
									[
										lang.q(author$project$View$Lang$ViewLoginFieldRememberMe)
									]))
							])),
						author$project$View$FormUtil$error(
						author$project$PlayFab$Error$toMessages(error)),
						function () {
						var _n1 = model.a$;
						switch (_n1.$) {
							case 1:
								return A2(
									elm$html$Html$button,
									_List_fromArray(
										[
											elm$html$Html$Attributes$type_('submit'),
											elm$html$Html$Attributes$class('btn btn-primary disabled'),
											elm$html$Html$Attributes$disabled(true)
										]),
									_List_fromArray(
										[
											author$project$View$Icon$loading,
											elm$html$Html$text(' '),
											lang.q(author$project$View$Lang$ViewLoginSubmit)
										]));
							case 3:
								return A2(
									elm$html$Html$button,
									_List_fromArray(
										[
											elm$html$Html$Attributes$type_('submit'),
											elm$html$Html$Attributes$class('btn btn-success')
										]),
									_List_fromArray(
										[
											lang.q(author$project$View$Lang$ViewLoginSubmit)
										]));
							case 2:
								return A2(
									elm$html$Html$button,
									_List_fromArray(
										[
											elm$html$Html$Attributes$type_('submit'),
											elm$html$Html$Attributes$class('btn btn-danger')
										]),
									_List_fromArray(
										[
											lang.q(author$project$View$Lang$ViewLoginSubmit)
										]));
							default:
								return A2(
									elm$html$Html$button,
									_List_fromArray(
										[
											elm$html$Html$Attributes$type_('submit'),
											elm$html$Html$Attributes$class('btn btn-primary')
										]),
									_List_fromArray(
										[
											lang.q(author$project$View$Lang$ViewLoginSubmit)
										]));
						}
					}()
					])),
				A2(
				elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						elm$html$Html$a,
						_List_fromArray(
							[
								elm$html$Html$Attributes$class('btn btn-link'),
								A2(author$project$Route$href, qs, author$project$Route$Register)
							]),
						_List_fromArray(
							[
								lang.q(author$project$View$Lang$ViewLoginLinkRegister)
							]))
					])),
				A2(
				elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						elm$html$Html$a,
						_List_fromArray(
							[
								elm$html$Html$Attributes$class('btn btn-link'),
								A2(author$project$Route$href, qs, author$project$Route$ResetPassword)
							]),
						_List_fromArray(
							[
								lang.q(author$project$View$Lang$ViewLoginLinkResetPassword)
							]))
					]))
			]);
	});
var author$project$Page$MtxHistory$GotTabNavMsg = function (a) {
	return {$: 0, a: a};
};
var author$project$Game$mtxHistory = A2(
	elm$core$Basics$composeR,
	author$project$Game$unwrap,
	function ($) {
		return $.U;
	});
var author$project$View$Lang$ViewMtxHistoryAddedNo = {$: 194};
var author$project$View$Lang$ViewMtxHistoryAddedYes = {$: 193};
var author$project$Page$MtxHistory$viewKongServerItem = F4(
	function (session, lang, isSynced, item) {
		return A2(
			elm$html$Html$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							elm$html$Html$text(
							author$project$Kongregate$Inventory$idToString(item.eL))
						])),
					A2(
					elm$html$Html$td,
					_List_fromArray(
						[
							elm$html$Html$Attributes$title(
							author$project$GameData$Mtx$idToString(item.eM))
						]),
					_List_fromArray(
						[
							elm$html$Html$text(item.br)
						])),
					isSynced ? A2(
					elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							author$project$View$Icon$fas('check'),
							elm$html$Html$text(' '),
							lang.q(author$project$View$Lang$ViewMtxHistoryAddedYes)
						])) : A2(
					elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							author$project$View$Icon$fas('exclamation-triangle'),
							elm$html$Html$text(' '),
							lang.q(author$project$View$Lang$ViewMtxHistoryAddedNo)
						]))
				]));
	});
var author$project$Page$MtxHistory$viewKongItem = F3(
	function (session, lang, status) {
		switch (status.$) {
			case 0:
				var item = status.a;
				return A4(author$project$Page$MtxHistory$viewKongServerItem, session, lang, false, item);
			case 1:
				var item = status.a;
				return A4(author$project$Page$MtxHistory$viewKongServerItem, session, lang, true, item);
			default:
				var id = status.a;
				return A2(
					elm$html$Html$tr,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							elm$html$Html$td,
							_List_Nil,
							_List_fromArray(
								[
									elm$html$Html$text(id)
								])),
							A2(
							elm$html$Html$td,
							_List_Nil,
							_List_fromArray(
								[
									elm$html$Html$text('???')
								])),
							A2(
							elm$html$Html$td,
							_List_Nil,
							_List_fromArray(
								[
									author$project$View$Icon$fas('check'),
									elm$html$Html$text(' '),
									lang.q(author$project$View$Lang$ViewMtxHistoryAddedYes)
								]))
						]));
		}
	});
var author$project$View$Lang$ViewMtxHistoryColAdded = {$: 189};
var author$project$View$Lang$ViewMtxHistoryColKongId = {$: 187};
var author$project$View$Lang$ViewMtxHistoryColOrder = {$: 188};
var elm$virtual_dom$VirtualDom$property = F2(
	function (key, value) {
		return A2(
			_VirtualDom_property,
			_VirtualDom_noInnerHtmlOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var elm$html$Html$Attributes$property = elm$virtual_dom$VirtualDom$property;
var author$project$Page$MtxHistory$viewKongItems = F3(
	function (session, lang, items) {
		return _List_fromArray(
			[
				A2(
				elm$html$Html$table,
				_List_fromArray(
					[
						A2(
						elm$html$Html$Attributes$property,
						'border',
						elm$json$Json$Encode$string('1'))
					]),
				A2(
					elm$core$List$cons,
					A2(
						elm$html$Html$tr,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								elm$html$Html$th,
								_List_Nil,
								_List_fromArray(
									[
										lang.q(author$project$View$Lang$ViewMtxHistoryColKongId)
									])),
								A2(
								elm$html$Html$th,
								_List_Nil,
								_List_fromArray(
									[
										lang.q(author$project$View$Lang$ViewMtxHistoryColOrder)
									])),
								A2(
								elm$html$Html$th,
								_List_Nil,
								_List_fromArray(
									[
										lang.q(author$project$View$Lang$ViewMtxHistoryColAdded)
									]))
							])),
					A2(
						elm$core$List$map,
						A2(author$project$Page$MtxHistory$viewKongItem, session, lang),
						items)))
			]);
	});
var author$project$Page$MtxHistory$dateFormatter = function (posix) {
	var pad = function (n) {
		return (n < 10) ? ('0' + elm$core$String$fromInt(n)) : elm$core$String$fromInt(n);
	};
	var months = _List_fromArray(
		['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']);
	var monthToInt = function (m) {
		switch (m) {
			case 0:
				return 0;
			case 1:
				return 1;
			case 2:
				return 2;
			case 3:
				return 3;
			case 4:
				return 4;
			case 5:
				return 5;
			case 6:
				return 6;
			case 7:
				return 7;
			case 8:
				return 8;
			case 9:
				return 9;
			case 10:
				return 10;
			default:
				return 11;
		}
	};
	var month = A2(
		elm$core$Maybe$withDefault,
		'Jan',
		elm$core$List$head(
			A2(
				elm$core$List$drop,
				monthToInt(
					A2(elm$time$Time$toMonth, elm$time$Time$utc, posix)),
				months)));
	return elm$core$String$fromInt(
		A2(elm$time$Time$toYear, elm$time$Time$utc, posix)) + (' ' + (month + (' ' + (pad(
		A2(elm$time$Time$toDay, elm$time$Time$utc, posix)) + (', ' + (pad(
		A2(elm$time$Time$toHour, elm$time$Time$utc, posix)) + (':' + (pad(
		A2(elm$time$Time$toMinute, elm$time$Time$utc, posix)) + ' UTC'))))))));
};
var author$project$PlayFab$Inventory$paypalTxnId = A2(
	elm$core$Basics$composeR,
	function ($) {
		return $.cW;
	},
	A2(elm$core$String$replace, 'paypal tx=', ''));
var author$project$Page$MtxHistory$viewPlayfabServerItem = F4(
	function (session, lang, synced, item) {
		var paypalUrl = function () {
			var _n0 = author$project$Session$paypalEnv(session);
			if (!_n0) {
				return 'https://www.paypal.com/activity/payment/' + author$project$PlayFab$Inventory$paypalTxnId(item);
			} else {
				return 'https://www.sandbox.paypal.com/activity/payment/' + author$project$PlayFab$Inventory$paypalTxnId(item);
			}
		}();
		return A2(
			elm$html$Html$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							elm$html$Html$text(
							author$project$Page$MtxHistory$dateFormatter(item.fm))
						])),
					A2(
					elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							elm$html$Html$text(
							author$project$PlayFab$Inventory$instanceIdToString(item.b0))
						])),
					A2(
					elm$html$Html$td,
					_List_fromArray(
						[
							elm$html$Html$Attributes$title(
							author$project$PlayFab$Inventory$itemIdToString(item.eX))
						]),
					_List_fromArray(
						[
							elm$html$Html$text(item.ew)
						])),
					A2(
					elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							elm$html$Html$a,
							_List_fromArray(
								[
									elm$html$Html$Attributes$target('_blank'),
									elm$html$Html$Attributes$href(paypalUrl)
								]),
							_List_fromArray(
								[
									elm$html$Html$text(
									author$project$PlayFab$Inventory$paypalTxnId(item))
								]))
						])),
					A2(
					elm$html$Html$td,
					_List_Nil,
					synced ? _List_fromArray(
						[
							author$project$View$Icon$fas('check'),
							elm$html$Html$text(' '),
							lang.q(author$project$View$Lang$ViewMtxHistoryAddedYes)
						]) : _List_fromArray(
						[
							author$project$View$Icon$fas('exclamation-triangle'),
							elm$html$Html$text(' '),
							lang.q(author$project$View$Lang$ViewMtxHistoryAddedNo)
						]))
				]));
	});
var author$project$Page$MtxHistory$viewPlayfabItem = F3(
	function (session, lang, status) {
		switch (status.$) {
			case 0:
				var item = status.a;
				return A4(author$project$Page$MtxHistory$viewPlayfabServerItem, session, lang, false, item);
			case 1:
				var item = status.a;
				return A4(author$project$Page$MtxHistory$viewPlayfabServerItem, session, lang, true, item);
			default:
				var id = status.a;
				return A2(
					elm$html$Html$tr,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							elm$html$Html$td,
							_List_Nil,
							_List_fromArray(
								[
									elm$html$Html$text('???')
								])),
							A2(
							elm$html$Html$td,
							_List_Nil,
							_List_fromArray(
								[
									elm$html$Html$text(id)
								])),
							A2(
							elm$html$Html$td,
							_List_Nil,
							_List_fromArray(
								[
									elm$html$Html$text('???')
								])),
							A2(
							elm$html$Html$td,
							_List_Nil,
							_List_fromArray(
								[
									elm$html$Html$text('???')
								])),
							A2(
							elm$html$Html$td,
							_List_Nil,
							_List_fromArray(
								[
									author$project$View$Icon$fas('check'),
									elm$html$Html$text(' '),
									lang.q(author$project$View$Lang$ViewMtxHistoryAddedYes)
								]))
						]));
		}
	});
var author$project$View$Lang$ViewMtxHistoryColDate = {$: 190};
var author$project$View$Lang$ViewMtxHistoryColPayPalTx = {$: 192};
var author$project$View$Lang$ViewMtxHistoryColPlayFabId = {$: 191};
var author$project$Page$MtxHistory$viewPlayfabItems = F3(
	function (session, lang, items) {
		return _List_fromArray(
			[
				A2(
				elm$html$Html$table,
				_List_fromArray(
					[
						A2(
						elm$html$Html$Attributes$property,
						'border',
						elm$json$Json$Encode$string('1'))
					]),
				A2(
					elm$core$List$cons,
					A2(
						elm$html$Html$tr,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								elm$html$Html$th,
								_List_Nil,
								_List_fromArray(
									[
										lang.q(author$project$View$Lang$ViewMtxHistoryColDate)
									])),
								A2(
								elm$html$Html$th,
								_List_Nil,
								_List_fromArray(
									[
										lang.q(author$project$View$Lang$ViewMtxHistoryColPlayFabId)
									])),
								A2(
								elm$html$Html$th,
								_List_Nil,
								_List_fromArray(
									[
										lang.q(author$project$View$Lang$ViewMtxHistoryColOrder)
									])),
								A2(
								elm$html$Html$th,
								_List_Nil,
								_List_fromArray(
									[
										lang.q(author$project$View$Lang$ViewMtxHistoryColPayPalTx)
									])),
								A2(
								elm$html$Html$th,
								_List_Nil,
								_List_fromArray(
									[
										lang.q(author$project$View$Lang$ViewMtxHistoryColAdded)
									]))
							])),
					A2(
						elm$core$List$map,
						A2(author$project$Page$MtxHistory$viewPlayfabItem, session, lang),
						items)))
			]);
	});
var author$project$View$Lang$ViewMtxHistoryTitle = {$: 186};
var author$project$Page$MtxHistory$viewReady = F3(
	function (_n0, game, ustate) {
		var invReq = _n0.a;
		var session = _n0.b;
		var user = ustate.cQ;
		var userId = author$project$PlayFab$User$idToString(
			author$project$PlayFab$User$id(user));
		var titleId = author$project$PlayFab$TitleId$fromSession(session);
		var lang = A2(author$project$View$Lang$gameToLang, session, game);
		return _List_fromArray(
			[
				A2(
				elm$html$Html$h1,
				_List_Nil,
				_List_fromArray(
					[
						lang.q(author$project$View$Lang$ViewMtxHistoryTitle)
					])),
				A2(
				elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						elm$html$Html$text(
						A2(
							author$project$PlayFab$User$displayName,
							author$project$Session$iframe(session),
							user)),
						elm$html$Html$text(' #'),
						elm$html$Html$text(userId)
					])),
				function () {
				if (!invReq.$) {
					var req = invReq.a;
					switch (req.$) {
						case 3:
							var serverItems = req.a;
							return A2(
								elm$html$Html$div,
								_List_Nil,
								A3(
									author$project$Page$MtxHistory$viewPlayfabItems,
									session,
									lang,
									A2(
										author$project$Game$MtxHistory$playfabInventoryStatus,
										serverItems,
										author$project$Game$mtxHistory(game))));
						case 2:
							var err = req.a;
							return A2(
								elm$html$Html$div,
								_List_fromArray(
									[
										elm$html$Html$Attributes$class('alert alert-danger')
									]),
								_List_fromArray(
									[
										elm$html$Html$text(
										author$project$PlayFab$Error$toString(err))
									]));
						default:
							return author$project$View$Icon$loading;
					}
				} else {
					var req = invReq.a;
					switch (req.$) {
						case 3:
							var serverItems = req.a;
							return A2(
								elm$html$Html$div,
								_List_Nil,
								A3(
									author$project$Page$MtxHistory$viewKongItems,
									session,
									lang,
									A2(
										author$project$Game$MtxHistory$kongInventoryStatus,
										serverItems,
										author$project$Game$mtxHistory(game))));
						case 2:
							var err = req.a;
							return A2(
								elm$html$Html$div,
								_List_fromArray(
									[
										elm$html$Html$Attributes$class('alert alert-danger')
									]),
								_List_fromArray(
									[
										elm$html$Html$text(err)
									]));
						default:
							return author$project$View$Icon$loading;
					}
				}
			}()
			]);
	});
var author$project$View$Lang$ViewUserAnonymous = {$: 156};
var author$project$View$Lang$ViewUserAnonymousLogin = {$: 157};
var author$project$View$Lang$ViewUserAnonymousRegister = {$: 158};
var author$project$Page$MtxHistory$viewBody = F2(
	function (model, game) {
		var session = model.b;
		var lang = A2(author$project$View$Lang$gameToLang, session, game);
		var _n0 = author$project$Session$userState(session);
		switch (_n0.$) {
			case 0:
				return _List_Nil;
			case 1:
				return _List_fromArray(
					[author$project$View$Icon$loading]);
			case 2:
				var err = _n0.a;
				return _List_fromArray(
					[
						A2(
						elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								elm$html$Html$text(
								author$project$PlayFab$Error$toString(err))
							]))
					]);
			default:
				if (_n0.a.$ === 1) {
					var _n1 = _n0.a;
					return _List_fromArray(
						[
							A2(
							elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									lang.q(author$project$View$Lang$ViewUserAnonymous)
								])),
							A2(
							elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											elm$html$Html$a,
											_List_fromArray(
												[
													elm$html$Html$Attributes$class('btn btn-link'),
													A2(
													author$project$Route$href,
													author$project$Session$query(session),
													author$project$Route$Login)
												]),
											_List_fromArray(
												[
													lang.q(author$project$View$Lang$ViewUserAnonymousLogin)
												]))
										])),
									A2(
									elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											elm$html$Html$a,
											_List_fromArray(
												[
													elm$html$Html$Attributes$class('btn btn-link'),
													A2(
													author$project$Route$href,
													author$project$Session$query(session),
													author$project$Route$Register)
												]),
											_List_fromArray(
												[
													lang.q(author$project$View$Lang$ViewUserAnonymousRegister)
												]))
										]))
								]))
						]);
				} else {
					var ustate = _n0.a.a;
					return A3(author$project$Page$MtxHistory$viewReady, model, game, ustate);
				}
		}
	});
var author$project$Page$MtxHistory$view = F2(
	function (model, game) {
		var session = model.b;
		return _Utils_ap(
			A2(
				elm$core$List$map,
				elm$html$Html$map(author$project$Page$MtxHistory$GotTabNavMsg),
				A3(author$project$View$TabNav$viewFromGame, elm$core$Maybe$Nothing, session, game)),
			A2(author$project$Page$MtxHistory$viewBody, model, game));
	});
var author$project$Page$MtxShop$GotTabNavMsg = function (a) {
	return {$: 8, a: a};
};
var author$project$Game$UnitsSnapshot$production = F4(
	function (parent, gameData, getVar, snapshot) {
		var _n0 = parent.fl;
		if (_n0.$ === 1) {
			return elm$core$Maybe$Nothing;
		} else {
			var _n1 = _n0.a;
			var id = _n1.a;
			var prodExpr = _n1.b;
			var _n2 = A2(
				author$project$GameData$unitByName,
				author$project$GameData$Unit$idToString(id),
				gameData);
			if (_n2.$ === 1) {
				return elm$core$Maybe$Nothing;
			} else {
				var child = _n2.a;
				var ctx = A3(
					author$project$Parser$Stat$evalFullWithDefault,
					author$project$Decimal$zero,
					getVar(snapshot),
					prodExpr);
				var each = ctx.fd;
				var total = A2(
					author$project$Decimal$mul,
					each,
					A2(author$project$Game$UnitsSnapshot$count, parent.eL, snapshot));
				var bonus = A2(
					elm$core$Maybe$withDefault,
					author$project$Decimal$zero,
					A2(elm$core$Dict$get, 'bonus', ctx.dh));
				var base = A2(
					elm$core$Maybe$withDefault,
					author$project$Decimal$zero,
					A2(elm$core$Dict$get, 'base', ctx.dh));
				return elm$core$Maybe$Just(
					{cY: base, c_: bonus, db: each, dJ: child, d2: total});
			}
		}
	});
var author$project$Game$production = F2(
	function (unit, game) {
		return A3(
			author$project$Game$UnitsSnapshot$production,
			unit,
			author$project$Game$gameData(game),
			author$project$Game$getVar(game));
	});
var author$project$View$Description$Hatchery$crystalStats = F2(
	function (session, game) {
		var units = author$project$Game$units(game);
		return A2(
			elm$core$Basics$composeR,
			elm$core$List$head,
			elm$core$Maybe$andThen(
				function (_n0) {
					var crystalId = _n0.a;
					var countExpr = _n0.b;
					var cooldownMax = _n0.c;
					return (A2(author$project$Game$UnitsSnapshot$isUnitVisible, crystalId, units) && A2(author$project$Game$UnitsSnapshot$isNameVisible, 'energy', units)) ? elm$core$Maybe$Just(
						{
							_: A3(
								author$project$Game$cooldownRemaining,
								A2(author$project$Session$safeNow, game, session),
								cooldownMax,
								game),
							et: A3(
								author$project$Parser$Stat$evalWithDefault,
								author$project$Decimal$zero,
								author$project$Game$getGameVar(game),
								countExpr)
						}) : elm$core$Maybe$Nothing;
				}));
	});
var author$project$GameData$Cost$toExpr = function (cost) {
	if (!cost.$) {
		var expr = cost.a;
		return expr;
	} else {
		var expr = cost.a;
		return expr;
	}
};
var author$project$Parser$Stat$parseDecimal = author$project$Parser$Stat$Val;
var author$project$Parser$Stat$parseFloat = A2(elm$core$Basics$composeR, author$project$Decimal$fromFloat, author$project$Parser$Stat$parseDecimal);
var author$project$Parser$Stat$parseInt = A2(elm$core$Basics$composeR, author$project$Decimal$fromInt, author$project$Parser$Stat$parseDecimal);
var author$project$View$DescriptionVars$getExpr = F3(
	function (game, item, field) {
		switch (field.$) {
			case 1:
				var name = field.a;
				return A2(
					elm$core$Result$fromMaybe,
					'no such item.cost: ' + name,
					A2(
						elm$core$Maybe$map,
						A2(elm$core$Basics$composeR, elm$core$Tuple$second, author$project$GameData$Cost$toExpr),
						A2(
							elm_community$list_extra$List$Extra$find,
							A2(
								elm$core$Basics$composeR,
								elm$core$Tuple$first,
								A2(
									elm$core$Basics$composeR,
									author$project$GameData$Unit$idToString,
									elm$core$Basics$eq(name))),
							author$project$GameData$Item$cost(item))));
			case 0:
				if (!item.$) {
					var unit = item.a;
					return A2(
						elm$core$Result$fromMaybe,
						'unit has no production: ' + author$project$GameData$Item$name(item),
						A2(elm$core$Maybe$map, elm$core$Tuple$second, unit.fl));
				} else {
					return elm$core$Result$Err(
						'non-units cannot have production: ' + author$project$GameData$Item$name(item));
				}
			case 3:
				if (!item.$) {
					var unit = item.a;
					return elm$core$Result$Ok(
						author$project$Parser$Stat$parseDecimal(
							A2(
								author$project$Game$UnitsSnapshot$velocity,
								unit.eL,
								author$project$Game$units(game))));
				} else {
					return elm$core$Result$Err(
						'non-units cannot have velocity: ' + author$project$GameData$Item$name(item));
				}
			case 2:
				return elm$core$Result$Ok(
					author$project$Parser$Stat$parseDecimal(
						A2(
							author$project$Game$itemCount,
							author$project$GameData$Item$id(item),
							game)));
			case 4:
				if (!item.$) {
					var unit = item.a;
					return A2(
						elm$core$Result$fromMaybe,
						'unit has no maxCount: ' + author$project$GameData$Unit$name(unit),
						unit.eZ);
				} else {
					return elm$core$Result$Err(
						'non-units cannot have maxcount: ' + author$project$GameData$Item$name(item));
				}
			case 5:
				var name = field.a;
				return A2(
					elm$core$Result$fromMaybe,
					'no OnBuy.AddUnits: ' + name,
					A2(
						elm$core$Dict$get,
						name,
						author$project$GameData$Item$onBuy(item).bO));
			case 6:
				var name = field.a;
				return A2(
					elm$core$Result$fromMaybe,
					'no OnBuy.MulUnits: ' + name,
					A2(
						elm$core$Dict$get,
						name,
						author$project$GameData$Item$onBuy(item).cj));
			case 7:
				return A2(
					elm$core$Result$fromMaybe,
					'no OnBuy.AddTime',
					elm$core$List$head(
						author$project$GameData$Item$onBuy(item).ea));
			case 8:
				return A2(
					elm$core$Result$fromMaybe,
					'no OnBuy.Random',
					A2(
						elm$core$Maybe$map,
						A2(
							elm$core$Basics$composeR,
							function ($) {
								return $.e1;
							},
							author$project$Parser$Stat$parseInt),
						elm$core$List$head(
							author$project$GameData$Item$onBuy(item).bM)));
			case 9:
				return A2(
					elm$core$Result$fromMaybe,
					'no OnBuy.Random',
					A2(
						elm$core$Maybe$map,
						function ($) {
							return $.eo;
						},
						elm$core$List$head(
							author$project$GameData$Item$onBuy(item).bM)));
			case 10:
				return A2(
					elm$core$Result$fromMaybe,
					'no OnBuy.Random',
					A2(
						elm$core$Maybe$map,
						function ($) {
							return $.et;
						},
						elm$core$List$head(
							author$project$GameData$Item$onBuy(item).bM)));
			case 13:
				var name = field.a;
				return A2(
					elm$core$Result$fromMaybe,
					'no OnBuy.Cooldown: ' + name,
					A2(
						elm$core$Maybe$map,
						elm$core$Tuple$first,
						A2(
							elm$core$Dict$get,
							name,
							author$project$GameData$Item$onBuy(item).bQ)));
			case 11:
				var name = field.a;
				return A2(
					elm$core$Result$fromMaybe,
					'no OnBuy.Cooldown: ' + name,
					A2(
						elm$core$Maybe$map,
						A2(
							elm$core$Basics$composeR,
							elm$core$Tuple$second,
							A2(
								elm$core$Basics$composeR,
								function ($) {
									return $.d6;
								},
								A2(elm$core$Basics$composeR, author$project$Duration$toMillis, author$project$Parser$Stat$parseInt))),
						A2(
							elm$core$Dict$get,
							name,
							author$project$GameData$Item$onBuy(item).bQ)));
			case 12:
				var name = field.a;
				var now = author$project$Game$snapshotted(game);
				return A2(
					elm$core$Result$fromMaybe,
					'no OnBuy.Cooldown: ' + name,
					A2(
						elm$core$Maybe$map,
						function (_n4) {
							var cooldown = _n4.b;
							return author$project$Parser$Stat$parseInt(
								author$project$Duration$toMillis(
									A3(author$project$Game$cooldownRemaining, now, cooldown, game)));
						},
						A2(
							elm$core$Dict$get,
							name,
							author$project$GameData$Item$onBuy(item).bQ)));
			default:
				return A2(
					elm$core$Result$fromMaybe,
					'no OnBuy.Respec',
					A2(
						elm$core$Maybe$map,
						A2(
							elm$core$Basics$composeR,
							function (_n5) {
								var rate = _n5.b;
								return rate;
							},
							author$project$Parser$Stat$parseFloat),
						elm$core$List$head(
							author$project$GameData$Item$onBuy(item).dR)));
		}
	});
var author$project$View$DescriptionVars$eval = F3(
	function (game, itemName, field) {
		var _n0 = A2(
			author$project$GameData$itemByName,
			itemName,
			author$project$Game$gameData(game));
		if (_n0.$ === 1) {
			return elm$core$Result$Err('no such item: ' + itemName);
		} else {
			var item = _n0.a;
			return A2(
				elm$core$Result$map,
				A2(
					author$project$Parser$Stat$evalFullWithDefault,
					author$project$Decimal$zero,
					author$project$Game$getGameVar(game)),
				A3(author$project$View$DescriptionVars$getExpr, game, item, field));
		}
	});
var author$project$View$DescriptionVars$evalField = F3(
	function (game, itemName, field) {
		return A2(
			elm$core$Result$map,
			function ($) {
				return $.fd;
			},
			A3(author$project$View$DescriptionVars$eval, game, itemName, field));
	});
var author$project$View$DescriptionVars$evalLabel = F4(
	function (game, itemName, field, labelName) {
		return A2(
			elm$core$Result$andThen,
			A2(
				elm$core$Basics$composeR,
				function ($) {
					return $.dh;
				},
				A2(
					elm$core$Basics$composeR,
					elm$core$Dict$get(labelName),
					elm$core$Result$fromMaybe('no such label: ' + labelName))),
			A3(author$project$View$DescriptionVars$eval, game, itemName, field));
	});
var author$project$View$DescriptionVars$Cost = function (a) {
	return {$: 1, a: a};
};
var author$project$View$DescriptionVars$Count = {$: 2};
var author$project$View$DescriptionVars$MaxCount = {$: 4};
var author$project$View$DescriptionVars$OnBuyAddTime = {$: 7};
var author$project$View$DescriptionVars$OnBuyAddUnits = function (a) {
	return {$: 5, a: a};
};
var author$project$View$DescriptionVars$OnBuyAddUnitsCooldownCount = function (a) {
	return {$: 13, a: a};
};
var author$project$View$DescriptionVars$OnBuyAddUnitsCooldownDuration = function (a) {
	return {$: 11, a: a};
};
var author$project$View$DescriptionVars$OnBuyAddUnitsCooldownRemaining = function (a) {
	return {$: 12, a: a};
};
var author$project$View$DescriptionVars$OnBuyMulUnits = function (a) {
	return {$: 6, a: a};
};
var author$project$View$DescriptionVars$OnBuyRandomChance = {$: 9};
var author$project$View$DescriptionVars$OnBuyRandomCount = {$: 10};
var author$project$View$DescriptionVars$OnBuyRandomMinimum = {$: 8};
var author$project$View$DescriptionVars$OnBuyRespecRate = {$: 14};
var author$project$View$DescriptionVars$Prod = {$: 0};
var author$project$View$DescriptionVars$Var = F3(
	function (itemName, field, label) {
		return {bY: field, b2: itemName, bn: label};
	});
var author$project$View$DescriptionVars$Velocity = {$: 3};
var author$project$View$DescriptionVars$parseVar = function (name) {
	var fromTail = F2(
		function (tail, var0) {
			if (!tail.b) {
				return elm$core$Result$Ok(
					var0(elm$core$Maybe$Nothing));
			} else {
				if (!tail.b.b) {
					var label = tail.a;
					return elm$core$Result$Ok(
						var0(
							elm$core$Maybe$Just(label)));
				} else {
					return elm$core$Result$Err('invalid var: ' + name);
				}
			}
		});
	var _n0 = A2(elm$core$String$split, '.', name);
	_n0$15:
	while (true) {
		if (_n0.b && _n0.b.b) {
			switch (_n0.b.a) {
				case 'prod':
					var itemName = _n0.a;
					var _n1 = _n0.b;
					var tail = _n1.b;
					return A2(
						fromTail,
						tail,
						A2(author$project$View$DescriptionVars$Var, itemName, author$project$View$DescriptionVars$Prod));
				case 'cost':
					if (_n0.b.b.b) {
						var itemName = _n0.a;
						var _n2 = _n0.b;
						var _n3 = _n2.b;
						var cost = _n3.a;
						var tail = _n3.b;
						return A2(
							fromTail,
							tail,
							A2(
								author$project$View$DescriptionVars$Var,
								itemName,
								author$project$View$DescriptionVars$Cost(cost)));
					} else {
						break _n0$15;
					}
				case 'velocity':
					var itemName = _n0.a;
					var _n4 = _n0.b;
					var tail = _n4.b;
					return A2(
						fromTail,
						tail,
						A2(author$project$View$DescriptionVars$Var, itemName, author$project$View$DescriptionVars$Velocity));
				case 'maxCount':
					var itemName = _n0.a;
					var _n5 = _n0.b;
					var tail = _n5.b;
					return A2(
						fromTail,
						tail,
						A2(author$project$View$DescriptionVars$Var, itemName, author$project$View$DescriptionVars$MaxCount));
				case 'add':
					if (_n0.b.b.b) {
						var itemName = _n0.a;
						var _n6 = _n0.b;
						var _n7 = _n6.b;
						var unitName = _n7.a;
						var tail = _n7.b;
						return A2(
							fromTail,
							tail,
							A2(
								author$project$View$DescriptionVars$Var,
								itemName,
								author$project$View$DescriptionVars$OnBuyAddUnits(unitName)));
					} else {
						break _n0$15;
					}
				case 'mul':
					if (_n0.b.b.b) {
						var itemName = _n0.a;
						var _n8 = _n0.b;
						var _n9 = _n8.b;
						var unitName = _n9.a;
						var tail = _n9.b;
						return A2(
							fromTail,
							tail,
							A2(
								author$project$View$DescriptionVars$Var,
								itemName,
								author$project$View$DescriptionVars$OnBuyMulUnits(unitName)));
					} else {
						break _n0$15;
					}
				case 'time':
					var itemName = _n0.a;
					var _n10 = _n0.b;
					var tail = _n10.b;
					return A2(
						fromTail,
						tail,
						A2(author$project$View$DescriptionVars$Var, itemName, author$project$View$DescriptionVars$OnBuyAddTime));
				case 'random':
					if (_n0.b.b.b) {
						switch (_n0.b.b.a) {
							case 'minimum':
								var itemName = _n0.a;
								var _n11 = _n0.b;
								var _n12 = _n11.b;
								var tail = _n12.b;
								return A2(
									fromTail,
									tail,
									A2(author$project$View$DescriptionVars$Var, itemName, author$project$View$DescriptionVars$OnBuyRandomMinimum));
							case 'chance':
								var itemName = _n0.a;
								var _n13 = _n0.b;
								var _n14 = _n13.b;
								var tail = _n14.b;
								return A2(
									fromTail,
									tail,
									A2(author$project$View$DescriptionVars$Var, itemName, author$project$View$DescriptionVars$OnBuyRandomChance));
							case 'count':
								var itemName = _n0.a;
								var _n15 = _n0.b;
								var _n16 = _n15.b;
								var tail = _n16.b;
								return A2(
									fromTail,
									tail,
									A2(author$project$View$DescriptionVars$Var, itemName, author$project$View$DescriptionVars$OnBuyRandomCount));
							default:
								break _n0$15;
						}
					} else {
						break _n0$15;
					}
				case 'cooldown':
					if (_n0.b.b.b && _n0.b.b.b.b) {
						switch (_n0.b.b.b.a) {
							case 'duration':
								var itemName = _n0.a;
								var _n17 = _n0.b;
								var _n18 = _n17.b;
								var unitName = _n18.a;
								var _n19 = _n18.b;
								var tail = _n19.b;
								return A2(
									fromTail,
									tail,
									A2(
										author$project$View$DescriptionVars$Var,
										itemName,
										author$project$View$DescriptionVars$OnBuyAddUnitsCooldownDuration(unitName)));
							case 'remaining':
								var itemName = _n0.a;
								var _n20 = _n0.b;
								var _n21 = _n20.b;
								var unitName = _n21.a;
								var _n22 = _n21.b;
								var tail = _n22.b;
								return A2(
									fromTail,
									tail,
									A2(
										author$project$View$DescriptionVars$Var,
										itemName,
										author$project$View$DescriptionVars$OnBuyAddUnitsCooldownRemaining(unitName)));
							case 'count':
								var itemName = _n0.a;
								var _n23 = _n0.b;
								var _n24 = _n23.b;
								var unitName = _n24.a;
								var _n25 = _n24.b;
								var tail = _n25.b;
								return A2(
									fromTail,
									tail,
									A2(
										author$project$View$DescriptionVars$Var,
										itemName,
										author$project$View$DescriptionVars$OnBuyAddUnitsCooldownCount(unitName)));
							default:
								break _n0$15;
						}
					} else {
						break _n0$15;
					}
				case 'respec':
					if (_n0.b.b.b && (_n0.b.b.a === 'rate')) {
						var itemName = _n0.a;
						var _n26 = _n0.b;
						var _n27 = _n26.b;
						var tail = _n27.b;
						return A2(
							fromTail,
							tail,
							A2(author$project$View$DescriptionVars$Var, itemName, author$project$View$DescriptionVars$OnBuyRespecRate));
					} else {
						break _n0$15;
					}
				case 'count':
					var itemName = _n0.a;
					var _n28 = _n0.b;
					var tail = _n28.b;
					return A2(
						fromTail,
						tail,
						A2(author$project$View$DescriptionVars$Var, itemName, author$project$View$DescriptionVars$Count));
				default:
					break _n0$15;
			}
		} else {
			break _n0$15;
		}
	}
	return elm$core$Result$Err('invalid var: ' + name);
};
var author$project$View$DescriptionVars$evalVar = function (game) {
	return A2(
		elm$core$Basics$composeR,
		author$project$View$DescriptionVars$parseVar,
		elm$core$Result$andThen(
			function (_n0) {
				var itemName = _n0.b2;
				var field = _n0.bY;
				var label = _n0.bn;
				if (label.$ === 1) {
					return A3(author$project$View$DescriptionVars$evalField, game, itemName, field);
				} else {
					var l = label.a;
					return A4(author$project$View$DescriptionVars$evalLabel, game, itemName, field, l);
				}
			}));
};
var author$project$View$Lang$DescHatcheryCrystals = F2(
	function (a, b) {
		return {$: 210, a: a, b: b};
	});
var author$project$View$Lang$UnitDesc = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var author$project$Page$MtxShop$viewDescription = F4(
	function (session, game, unit, count) {
		var lang = A2(author$project$View$Lang$gameToLang, session, game);
		var hatchery = A2(
			author$project$GameData$unitByName,
			'hatchery',
			author$project$Game$gameData(game));
		var hatcheryTimer = A2(
			elm$core$Maybe$andThen,
			function (h) {
				return A3(author$project$View$Description$Hatchery$crystalStats, session, game, h.e9.bP);
			},
			hatchery);
		return _List_fromArray(
			[
				lang.q(
				A2(
					author$project$View$Lang$UnitDesc,
					author$project$View$DescriptionVars$evalVar(game),
					unit.eL)),
				A2(
				elm$html$Html$p,
				_List_Nil,
				A2(
					elm$core$Maybe$withDefault,
					_List_Nil,
					A3(
						elm$core$Maybe$map2,
						F2(
							function (h, t) {
								return _List_fromArray(
									[
										lang.q(
										A2(
											author$project$View$Lang$DescHatcheryCrystals,
											author$project$GameData$Item$Id$UnitId(h.eL),
											t))
									]);
							}),
						hatchery,
						hatcheryTimer)))
			]);
	});
var author$project$GameData$mtxs = A2(
	elm$core$Basics$composeR,
	author$project$GameData$lists,
	function ($) {
		return $.cg;
	});
var author$project$Page$MtxShop$ClickedKongBuyKreds = {$: 6};
var author$project$Page$MtxShop$ClickedKongBuyMtx = function (a) {
	return {$: 7, a: a};
};
var author$project$View$Lang$ViewMtxKongButton = function (a) {
	return {$: 181, a: a};
};
var author$project$Page$MtxShop$viewKongMtx = F4(
	function (session, game, user, mtx) {
		var lang = A2(author$project$View$Lang$gameToLang, session, game);
		return A2(
			elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					elm$html$Html$button,
					_List_fromArray(
						[
							elm$html$Html$Attributes$class('btn btn-outline-primary'),
							elm$html$Html$Events$onClick(
							author$project$Page$MtxShop$ClickedKongBuyMtx(mtx))
						]),
					_List_fromArray(
						[
							lang.q(
							author$project$View$Lang$ViewMtxKongButton(
								{es: mtx.fj, et: mtx.et}))
						]))
				]));
	});
var author$project$View$Lang$ViewMtxShopBuyKreds = {$: 199};
var author$project$View$Lang$ViewMtxShopLogin = {$: 201};
var author$project$View$Lang$ViewMtxShopSupport = {$: 200};
var author$project$Page$MtxShop$viewKongMtxs = F2(
	function (session, game) {
		var mtxs = author$project$GameData$mtxs(
			author$project$Game$gameData(game));
		var lang = A2(author$project$View$Lang$gameToLang, session, game);
		var _n0 = author$project$Session$user(session);
		switch (_n0.$) {
			case 3:
				if (!_n0.a.$) {
					var user = _n0.a.a;
					return A2(
						author$project$Route$Feature$isActive,
						4,
						author$project$Session$query(session)) ? _List_fromArray(
						[
							A2(
							elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									elm$html$Html$button,
									_List_fromArray(
										[
											elm$html$Html$Attributes$class('btn btn-outline-primary'),
											elm$html$Html$Events$onClick(author$project$Page$MtxShop$ClickedKongBuyKreds)
										]),
									_List_fromArray(
										[
											A2(
											elm$html$Html$img,
											_List_fromArray(
												[
													elm$html$Html$Attributes$class('img-icon'),
													elm$html$Html$Attributes$src('/images/kred_stack.png')
												]),
											_List_Nil),
											elm$html$Html$text(' '),
											lang.q(author$project$View$Lang$ViewMtxShopBuyKreds)
										]))
								])),
							A2(
							elm$html$Html$div,
							_List_Nil,
							A2(
								elm$core$List$map,
								A3(author$project$Page$MtxShop$viewKongMtx, session, game, user),
								mtxs)),
							A2(
							elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									elm$html$Html$i,
									_List_Nil,
									_List_fromArray(
										[
											lang.q(author$project$View$Lang$ViewMtxShopSupport)
										]))
								]))
						]) : _List_fromArray(
						[
							A2(
							elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									elm$html$Html$i,
									_List_Nil,
									_List_fromArray(
										[
											elm$html$Html$text('Crystal purchases will return soon!')
										]))
								]))
						]);
				} else {
					var _n1 = _n0.a;
					return _List_fromArray(
						[
							A2(
							elm$html$Html$div,
							_List_fromArray(
								[
									elm$html$Html$Attributes$class('alert alert-danger')
								]),
							_List_fromArray(
								[
									A2(
									elm$html$Html$a,
									_List_fromArray(
										[
											A2(
											author$project$Route$href,
											author$project$Session$query(session),
											author$project$Route$Login)
										]),
									_List_fromArray(
										[
											lang.q(author$project$View$Lang$ViewMtxShopLogin)
										]))
								]))
						]);
				}
			case 2:
				var err = _n0.a;
				return _List_fromArray(
					[
						A2(
						elm$html$Html$div,
						_List_fromArray(
							[
								elm$html$Html$Attributes$class('alert alert-danger')
							]),
						_List_fromArray(
							[
								elm$html$Html$text(
								author$project$PlayFab$Error$toString(err))
							]))
					]);
			default:
				return _List_fromArray(
					[author$project$View$Icon$loading]);
		}
	});
var author$project$Session$PaypalEnv$urlSuffix = function (userId) {
	var custom = A2(
		elm$json$Json$Encode$encode,
		0,
		elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'playfabId',
					elm$json$Json$Encode$string(
						author$project$PlayFab$User$idToString(userId)))
				])));
	return A3(
		elm$core$String$replace,
		'?',
		'&',
		elm$url$Url$Builder$toQuery(
			_List_fromArray(
				[
					A2(elm$url$Url$Builder$string, 'custom', custom)
				])));
};
var author$project$Session$PaypalEnv$url = F2(
	function (paypalEnv, userId) {
		return A2(
			elm$core$Basics$composeR,
			function ($) {
				return $.fe;
			},
			A2(
				elm$core$Basics$composeR,
				function () {
					switch (paypalEnv) {
						case 0:
							return function ($) {
								return $.fl;
							};
						case 1:
							return function ($) {
								return $.ey;
							};
						case 2:
							return function ($) {
								return $.fx;
							};
						default:
							return function ($) {
								return $.fx;
							};
					}
				}(),
				function (u) {
					return _Utils_ap(
						u,
						author$project$Session$PaypalEnv$urlSuffix(userId));
				}));
	});
var author$project$View$Lang$ViewMtxPaypalButton = function (a) {
	return {$: 180, a: a};
};
var author$project$Page$MtxShop$viewPaypalMtx = F4(
	function (session, game, user, mtx) {
		var lang = A2(author$project$View$Lang$gameToLang, session, game);
		return A2(
			elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					elm$html$Html$a,
					_List_fromArray(
						[
							elm$html$Html$Attributes$class('btn btn-outline-primary'),
							elm$html$Html$Attributes$href(
							A3(
								author$project$Session$PaypalEnv$url,
								author$project$Session$paypalEnv(session),
								author$project$PlayFab$User$id(user),
								mtx))
						]),
					_List_fromArray(
						[
							lang.q(
							author$project$View$Lang$ViewMtxPaypalButton(
								{es: mtx.fk, et: mtx.et}))
						]))
				]));
	});
var author$project$Page$MtxShop$viewPaypalMtxs = F2(
	function (session, game) {
		var mtxs = author$project$GameData$mtxs(
			author$project$Game$gameData(game));
		var lang = A2(author$project$View$Lang$gameToLang, session, game);
		var _n0 = author$project$Session$user(session);
		switch (_n0.$) {
			case 3:
				if (!_n0.a.$) {
					var user = _n0.a.a;
					return A2(
						author$project$Route$Feature$isActive,
						4,
						author$project$Session$query(session)) ? _List_fromArray(
						[
							A2(
							elm$html$Html$div,
							_List_Nil,
							A2(
								elm$core$List$map,
								A3(author$project$Page$MtxShop$viewPaypalMtx, session, game, user),
								mtxs)),
							A2(
							elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									elm$html$Html$i,
									_List_Nil,
									_List_fromArray(
										[
											lang.q(author$project$View$Lang$ViewMtxShopSupport)
										]))
								]))
						]) : _List_fromArray(
						[
							A2(
							elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									elm$html$Html$i,
									_List_Nil,
									_List_fromArray(
										[
											elm$html$Html$text('Crystal purchases will return soon!')
										]))
								]))
						]);
				} else {
					var _n1 = _n0.a;
					return _List_fromArray(
						[
							A2(
							elm$html$Html$div,
							_List_fromArray(
								[
									elm$html$Html$Attributes$class('alert alert-danger')
								]),
							_List_fromArray(
								[
									A2(
									elm$html$Html$a,
									_List_fromArray(
										[
											A2(
											author$project$Route$href,
											author$project$Session$query(session),
											author$project$Route$Login)
										]),
									_List_fromArray(
										[
											lang.q(author$project$View$Lang$ViewMtxShopLogin)
										]))
								]))
						]);
				}
			case 2:
				var err = _n0.a;
				return _List_fromArray(
					[
						A2(
						elm$html$Html$div,
						_List_fromArray(
							[
								elm$html$Html$Attributes$class('alert alert-danger')
							]),
						_List_fromArray(
							[
								elm$html$Html$text(
								author$project$PlayFab$Error$toString(err))
							]))
					]);
			default:
				return _List_fromArray(
					[author$project$View$Icon$loading]);
		}
	});
var author$project$Page$MtxShop$viewMtxs = F2(
	function (session, game) {
		var _n0 = author$project$Session$iframe(session);
		if (!_n0.$) {
			return A2(author$project$Page$MtxShop$viewPaypalMtxs, session, game);
		} else {
			var kong = _n0.a;
			return A2(author$project$Page$MtxShop$viewKongMtxs, session, game);
		}
	});
var author$project$View$Lang$ViewMtxShopConfirmed = {$: 197};
var author$project$View$Lang$ViewMtxShopPaypalTx = function (a) {
	return {$: 198, a: a};
};
var elm$html$Html$h6 = _VirtualDom_node('h6');
var author$project$Page$MtxShop$viewPaypalResult = F3(
	function (session, game, purchase) {
		var lang = A2(author$project$View$Lang$gameToLang, session, game);
		if (purchase.$ === 1) {
			return _List_Nil;
		} else {
			if (purchase.a.$ === 1) {
				var mtx = purchase.a.a;
				return _List_fromArray(
					[
						A2(
						elm$html$Html$div,
						_List_fromArray(
							[
								elm$html$Html$Attributes$class('alert alert-success')
							]),
						_List_fromArray(
							[
								A2(
								elm$html$Html$h6,
								_List_Nil,
								_List_fromArray(
									[
										lang.q(author$project$View$Lang$ViewMtxShopConfirmed)
									]))
							]))
					]);
			} else {
				var _n1 = purchase.a;
				var res = _n1.a;
				var args = _n1.b;
				var paypalUrl = function () {
					var _n3 = author$project$Session$paypalEnv(session);
					if (!_n3) {
						return 'https://www.paypal.com/activity/payment/' + args.bG;
					} else {
						return 'https://www.sandbox.paypal.com/activity/payment/' + args.bG;
					}
				}();
				var txnHref = A2(
					elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							elm$html$Html$a,
							_List_fromArray(
								[
									elm$html$Html$Attributes$href(paypalUrl),
									elm$html$Html$Attributes$target('_blank')
								]),
							_List_fromArray(
								[
									lang.q(
									author$project$View$Lang$ViewMtxShopPaypalTx(args.bG))
								]))
						]));
				switch (res.$) {
					case 3:
						var instanceId = res.a;
						return _List_fromArray(
							[
								A2(
								elm$html$Html$div,
								_List_fromArray(
									[
										elm$html$Html$Attributes$class('alert alert-success')
									]),
								_List_fromArray(
									[
										A2(
										elm$html$Html$h6,
										_List_Nil,
										_List_fromArray(
											[
												lang.q(author$project$View$Lang$ViewMtxShopConfirmed)
											])),
										txnHref
									]))
							]);
					case 2:
						var err = res.a;
						return _List_fromArray(
							[
								A2(
								elm$html$Html$div,
								_List_fromArray(
									[
										elm$html$Html$Attributes$class('alert alert-danger')
									]),
								_List_fromArray(
									[
										elm$html$Html$text(
										author$project$PlayFab$Error$toString(err)),
										txnHref
									]))
							]);
					default:
						return _List_fromArray(
							[
								A2(
								elm$html$Html$div,
								_List_fromArray(
									[
										elm$html$Html$Attributes$class('alert alert-info')
									]),
								_List_fromArray(
									[
										A2(
										elm$html$Html$p,
										_List_Nil,
										_List_fromArray(
											[author$project$View$Icon$loading])),
										txnHref
									]))
							]);
				}
			}
		}
	});
var author$project$Select$tabToSlug = function (stab) {
	if (stab.$ === 1) {
		return 'all';
	} else {
		var tab = stab.a;
		return author$project$GameData$Tab$name(tab);
	}
};
var author$project$View$Device$onlyMobileInline = elm$html$Html$span(
	_List_fromArray(
		[
			elm$html$Html$Attributes$class('d-inline d-md-none')
		]));
var author$project$View$Lang$ViewMtxShopConvert = {$: 195};
var author$project$View$Lang$ViewMtxShopHistory = {$: 196};
var author$project$View$Lang$ViewUnitCount = F2(
	function (a, b) {
		return {$: 31, a: a, b: b};
	});
var author$project$View$Lang$ViewUnitHeader = function (a) {
	return {$: 30, a: a};
};
var krisajenkins$remotedata$RemoteData$isLoading = function (data) {
	if (data.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var author$project$Page$MtxShop$viewUnit = F8(
	function (stab, session, game, snapshot, unit, count, invRes, purchase) {
		var tabSlug = author$project$Select$tabToSlug(stab);
		var query = author$project$Session$query(session);
		var production = A3(author$project$Game$production, unit, game, snapshot);
		var order = A3(
			author$project$Game$Order$fromBuyN,
			game,
			snapshot,
			author$project$GameData$Item$Unit(unit));
		var lang = A2(author$project$View$Lang$gameToLang, session, game);
		return _Utils_ap(
			_List_fromArray(
				[
					A2(
					elm$html$Html$h3,
					_List_Nil,
					_List_fromArray(
						[
							A2(author$project$Route$Feature$isActive, 5, query) ? author$project$View$Device$onlyMobileInline(
							_List_fromArray(
								[
									A2(
									elm$html$Html$a,
									_List_fromArray(
										[
											A2(
											author$project$Route$href,
											query,
											author$project$Route$Tab(tabSlug))
										]),
									_List_fromArray(
										[
											author$project$View$Icon$fas('bars'),
											elm$html$Html$text(' ')
										]))
								])) : A2(elm$html$Html$span, _List_Nil, _List_Nil),
							lang.q(
							author$project$View$Lang$ViewUnitHeader(unit.eL))
						])),
					A2(
					elm$html$Html$div,
					_List_fromArray(
						[
							elm$html$Html$Attributes$class('desc-icon-resource'),
							elm$html$Html$Attributes$class(
							'desc-icon-' + author$project$GameData$Unit$name(unit)),
							elm$html$Html$Attributes$class(
							'icon-' + author$project$GameData$Unit$name(unit))
						]),
					_List_Nil)
				]),
			_Utils_ap(
				A4(author$project$Page$MtxShop$viewDescription, session, game, unit, count),
				_Utils_ap(
					_List_fromArray(
						[
							A2(
							elm$html$Html$p,
							_List_Nil,
							A2(
								elm$core$List$cons,
								lang.q(
									A2(author$project$View$Lang$ViewUnitCount, count, unit.eL)),
								function () {
									_n0$2:
									while (true) {
										if (!invRes.$) {
											if (invRes.a.$ === 1) {
												var _n1 = invRes.a;
												return _List_fromArray(
													[author$project$View$Icon$loading]);
											} else {
												break _n0$2;
											}
										} else {
											if (invRes.a.$ === 1) {
												var _n2 = invRes.a;
												return _List_fromArray(
													[author$project$View$Icon$loading]);
											} else {
												break _n0$2;
											}
										}
									}
									return krisajenkins$remotedata$RemoteData$isLoading(
										author$project$Session$user(session)) ? _List_fromArray(
										[author$project$View$Icon$loading]) : _List_Nil;
								}()))
						]),
					_Utils_ap(
						A3(author$project$Page$MtxShop$viewPaypalResult, session, game, purchase),
						_Utils_ap(
							A2(author$project$Page$MtxShop$viewMtxs, session, game),
							_List_fromArray(
								[
									A2(
									elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											elm$html$Html$a,
											_List_fromArray(
												[
													elm$html$Html$Attributes$class('btn btn-link'),
													A2(
													author$project$Route$href,
													query,
													A2(author$project$Route$unit, 'energy', 'energy'))
												]),
											_List_fromArray(
												[
													lang.q(author$project$View$Lang$ViewMtxShopConvert)
												]))
										])),
									A2(
									elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											elm$html$Html$a,
											_List_fromArray(
												[
													elm$html$Html$Attributes$class('btn btn-link'),
													A2(author$project$Route$href, query, author$project$Route$MtxHistory)
												]),
											_List_fromArray(
												[
													lang.q(author$project$View$Lang$ViewMtxShopHistory)
												]))
										]))
								]))))));
	});
var author$project$Select$unwrapTab = function (stab) {
	if (!stab.$) {
		var tab = stab.a;
		return elm$core$Maybe$Just(tab);
	} else {
		return elm$core$Maybe$Nothing;
	}
};
var author$project$Game$graph = A2(
	elm$core$Basics$composeR,
	author$project$Game$unwrap,
	function ($) {
		return $.aT;
	});
var elm_community$graph$Graph$DOT$Styles = F4(
	function (rankdir, graph, node, edge) {
		return {dc: edge, aT: graph, K: node, dL: rankdir};
	});
var elm_community$graph$Graph$DOT$TB = 0;
var elm_community$graph$Graph$DOT$defaultStyles = A4(elm_community$graph$Graph$DOT$Styles, 0, '', '', '');
var elm$core$Dict$isEmpty = function (dict) {
	if (dict.$ === -2) {
		return true;
	} else {
		return false;
	}
};
var elm$core$List$sortWith = _List_sortWith;
var elm_community$graph$Graph$edges = function (graph) {
	var flippedFoldl = F3(
		function (f, dict, list) {
			return A3(elm_community$intdict$IntDict$foldl, f, list, dict);
		});
	var prependEdges = F2(
		function (node1, ctx) {
			return A2(
				flippedFoldl,
				F2(
					function (node2, e) {
						return elm$core$List$cons(
							{dj: node1, bn: e, aI: node2});
					}),
				ctx.cp);
		});
	return A3(
		flippedFoldl,
		prependEdges,
		elm_community$graph$Graph$unGraph(graph),
		_List_Nil);
};
var elm_community$intdict$IntDict$values = function (dict) {
	return A3(
		elm_community$intdict$IntDict$foldr,
		F3(
			function (key, value, valueList) {
				return A2(elm$core$List$cons, value, valueList);
			}),
		_List_Nil,
		dict);
};
var elm_community$graph$Graph$nodes = A2(
	elm$core$Basics$composeR,
	elm_community$graph$Graph$unGraph,
	A2(
		elm$core$Basics$composeR,
		elm_community$intdict$IntDict$values,
		elm$core$List$map(
			function ($) {
				return $.K;
			})));
var elm_community$graph$Graph$DOT$outputWithStylesAndAttributes = F4(
	function (styles, nodeAttrs, edgeAttrs, graph) {
		var rankDirToString = function (r) {
			switch (r) {
				case 0:
					return 'TB';
				case 1:
					return 'LR';
				case 2:
					return 'BT';
				default:
					return 'RL';
			}
		};
		var nodes = elm_community$graph$Graph$nodes(graph);
		var encode = A2(
			elm$core$Basics$composeR,
			elm$json$Json$Encode$string,
			elm$json$Json$Encode$encode(0));
		var edges = function () {
			var compareEdge = F2(
				function (a, b) {
					var _n1 = A2(elm$core$Basics$compare, a.dj, b.dj);
					switch (_n1) {
						case 0:
							return 0;
						case 2:
							return 2;
						default:
							return A2(elm$core$Basics$compare, a.aI, b.aI);
					}
				});
			return A2(
				elm$core$List$sortWith,
				compareEdge,
				elm_community$graph$Graph$edges(graph));
		}();
		var attrAssocs = A2(
			elm$core$Basics$composeR,
			elm$core$Dict$toList,
			A2(
				elm$core$Basics$composeR,
				elm$core$List$map(
					function (_n0) {
						var k = _n0.a;
						var v = _n0.b;
						return k + ('=' + encode(v));
					}),
				elm$core$String$join(', ')));
		var makeAttrs = function (d) {
			return elm$core$Dict$isEmpty(d) ? '' : (' [' + (attrAssocs(d) + ']'));
		};
		var edge = function (e) {
			return '  ' + (elm$core$String$fromInt(e.dj) + (' -> ' + (elm$core$String$fromInt(e.aI) + makeAttrs(
				edgeAttrs(e.bn)))));
		};
		var edgesString = A2(
			elm$core$String$join,
			'\n',
			A2(elm$core$List$map, edge, edges));
		var node = function (n) {
			return '  ' + (elm$core$String$fromInt(n.eL) + makeAttrs(
				nodeAttrs(n.bn)));
		};
		var nodesString = A2(
			elm$core$String$join,
			'\n',
			A2(elm$core$List$map, node, nodes));
		return A2(
			elm$core$String$join,
			'\n',
			_List_fromArray(
				[
					'digraph G {',
					'  rankdir=' + rankDirToString(styles.dL),
					'  graph [' + (styles.aT + ']'),
					'  node [' + (styles.K + ']'),
					'  edge [' + (styles.dc + ']'),
					'',
					edgesString,
					'',
					nodesString,
					'}'
				]));
	});
var elm_community$graph$Graph$DOT$outputWithStyles = F4(
	function (styles, mapNode, mapEdge, graph) {
		var labelOnly = function (maybeLabel) {
			if (maybeLabel.$ === 1) {
				return elm$core$Dict$empty;
			} else {
				var l = maybeLabel.a;
				return A2(elm$core$Dict$singleton, 'label', l);
			}
		};
		return A4(
			elm_community$graph$Graph$DOT$outputWithStylesAndAttributes,
			styles,
			A2(elm$core$Basics$composeL, labelOnly, mapNode),
			A2(elm$core$Basics$composeL, labelOnly, mapEdge),
			graph);
	});
var author$project$Game$ProductionGraph$toDOTString = function (g) {
	var style0 = elm_community$graph$Graph$DOT$defaultStyles;
	return A4(
		elm_community$graph$Graph$DOT$outputWithStyles,
		style0,
		A2(
			elm$core$Basics$composeR,
			function ($) {
				return $.cA;
			},
			elm$core$Maybe$Just),
		A2(elm$core$Basics$composeR, author$project$Decimal$toString, elm$core$Maybe$Just),
		g);
};
var author$project$Game$ProductionGraph$toDOTUrl = A2(
	elm$core$Basics$composeR,
	author$project$Game$ProductionGraph$toDOTString,
	A2(
		elm$core$Basics$composeR,
		elm$url$Url$percentEncode,
		elm$core$Basics$append('https://dreampuf.github.io/GraphvizOnline/#')));
var author$project$GameData$upgradesByUnit = function (unit) {
	return author$project$GameData$upgradesByUnitId(unit.eL);
};
var author$project$View$ItemDebug$viewOnBuyDebug = F3(
	function (game, snapshot, item) {
		var body = F3(
			function (child, label, exprs) {
				var ctxs = A2(
					elm$core$List$map,
					A2(
						author$project$Parser$Stat$evalFullWithDefault,
						author$project$Decimal$zero,
						author$project$Game$getGameVar(game)),
					exprs);
				return A2(
					elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							elm$html$Html$text(child),
							elm$html$Html$text(', '),
							elm$html$Html$text(label),
							A2(
							elm$html$Html$ul,
							_List_Nil,
							A2(
								elm$core$List$map,
								function (ctx) {
									return A2(
										elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[
												elm$html$Html$text(
												author$project$Decimal$toString(ctx.fd)),
												A2(
												elm$html$Html$ul,
												_List_Nil,
												A2(
													elm$core$List$map,
													function (_n1) {
														var n = _n1.a;
														var d = _n1.b;
														return A2(
															elm$html$Html$li,
															_List_Nil,
															_List_fromArray(
																[
																	elm$html$Html$text(n),
																	elm$html$Html$text(': '),
																	elm$html$Html$text(
																	author$project$Decimal$toString(d))
																]));
													},
													elm$core$Dict$toList(ctx.dh)))
											]));
								},
								ctxs))
						]));
			});
		return A2(
			elm$core$List$map,
			function (onBuy) {
				switch (onBuy.$) {
					case 0:
						var child = onBuy.a;
						var expr = onBuy.b;
						return A3(
							body,
							author$project$GameData$Unit$idToString(child),
							'add',
							_List_fromArray(
								[expr]));
					case 4:
						var child = onBuy.a;
						var expr = onBuy.b;
						var cooldown = onBuy.c;
						var label = 'addCooldown: ' + (author$project$Duration$toString(
							A3(
								author$project$Game$cooldownRemaining,
								author$project$Game$UnitsSnapshot$at(snapshot),
								cooldown,
								game)) + (' (cooldown.group: ' + (cooldown.dn + ')')));
						return A3(
							body,
							author$project$GameData$Unit$idToString(child),
							label,
							_List_fromArray(
								[expr]));
					case 1:
						var child = onBuy.a;
						var expr = onBuy.b;
						return A3(
							body,
							author$project$GameData$Unit$idToString(child),
							'mul',
							_List_fromArray(
								[expr]));
					case 2:
						var expr = onBuy.a;
						return A3(
							body,
							'ALL',
							'time',
							_List_fromArray(
								[expr]));
					case 3:
						var args = onBuy.a;
						return A3(
							body,
							author$project$GameData$Unit$idToString(args.eq),
							'addRandom',
							_List_fromArray(
								[args.eo, args.et]));
					case 6:
						return A3(body, 'ALL', 'ascend', _List_Nil);
					default:
						var currency = onBuy.a;
						var rate = onBuy.b;
						return A3(
							body,
							author$project$GameData$Unit$idToString(currency),
							'respec',
							_List_Nil);
				}
			},
			author$project$GameData$Item$onBuy(item).ec);
	});
var elm_community$graph$Graph$Tree$MkTree = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var elm_community$graph$Graph$Tree$empty = A2(elm_community$graph$Graph$Tree$MkTree, 0, elm$core$Maybe$Nothing);
var elm_community$graph$Graph$Tree$isEmpty = function (tree) {
	return _Utils_eq(tree, elm_community$graph$Graph$Tree$empty);
};
var elm_community$graph$Graph$Tree$size = function (tree) {
	var n = tree.a;
	return n;
};
var elm_community$graph$Graph$Tree$inner = F2(
	function (label, children) {
		var nonEmptyChildren = A2(
			elm$core$List$filter,
			A2(elm$core$Basics$composeL, elm$core$Basics$not, elm_community$graph$Graph$Tree$isEmpty),
			children);
		var totalSize = A3(
			elm$core$List$foldl,
			A2(elm$core$Basics$composeL, elm$core$Basics$add, elm_community$graph$Graph$Tree$size),
			1,
			nonEmptyChildren);
		return A2(
			elm_community$graph$Graph$Tree$MkTree,
			totalSize,
			elm$core$Maybe$Just(
				_Utils_Tuple2(label, nonEmptyChildren)));
	});
var elm_community$graph$Graph$dfsForest = F2(
	function (seeds, graph) {
		var visitNode = F2(
			function (ctx, trees) {
				return _Utils_Tuple2(
					_List_Nil,
					function (children) {
						return A2(
							elm$core$List$cons,
							A2(elm_community$graph$Graph$Tree$inner, ctx, children),
							trees);
					});
			});
		return elm$core$List$reverse(
			A5(elm_community$graph$Graph$guidedDfs, elm_community$graph$Graph$alongOutgoingEdges, visitNode, seeds, _List_Nil, graph).a);
	});
var elm_community$graph$Graph$dfsTree = F2(
	function (seed, graph) {
		var _n0 = A2(
			elm_community$graph$Graph$dfsForest,
			_List_fromArray(
				[seed]),
			graph);
		if (!_n0.b) {
			return elm_community$graph$Graph$Tree$empty;
		} else {
			if (!_n0.b.b) {
				var tree = _n0.a;
				return tree;
			} else {
				return elm_community$graph$Graph$crashHack('dfsTree: There can\'t be more than one DFS tree. This invariant is violated, please report this bug.');
			}
		}
	});
var elm_community$graph$Graph$Tree$listForTraversal = F2(
	function (traversal, tree) {
		var f = F3(
			function (label, children, rest) {
				return A2(
					elm$core$Basics$composeR,
					elm$core$List$cons(label),
					rest);
			});
		var acc = elm$core$Basics$identity;
		return A4(traversal, f, acc, tree, _List_Nil);
	});
var elm_community$graph$Graph$Tree$root = function (tree) {
	var maybe = tree.b;
	return maybe;
};
var elm_community$graph$Graph$Tree$preOrder = F3(
	function (visit, acc, tree) {
		var folder = F2(
			function (b, a) {
				return A3(elm_community$graph$Graph$Tree$preOrder, visit, a, b);
			});
		var _n0 = elm_community$graph$Graph$Tree$root(tree);
		if (_n0.$ === 1) {
			return acc;
		} else {
			var _n1 = _n0.a;
			var label = _n1.a;
			var children = _n1.b;
			return A3(
				elm$core$List$foldl,
				folder,
				A3(visit, label, children, acc),
				children);
		}
	});
var elm_community$graph$Graph$Tree$preOrderList = elm_community$graph$Graph$Tree$listForTraversal(elm_community$graph$Graph$Tree$preOrder);
var author$project$Game$ProductionGraph$unitChildren = F2(
	function (u, g) {
		var nodeIds = A2(
			elm$core$List$map,
			A2(
				elm$core$Basics$composeR,
				function ($) {
					return $.K;
				},
				function ($) {
					return $.eL;
				}),
			elm_community$graph$Graph$Tree$preOrderList(
				A2(elm_community$graph$Graph$dfsTree, u.bs, g)));
		return A2(elm_community$graph$Graph$inducedSubgraph, nodeIds, g);
	});
var elm_community$intdict$IntDict$map = F2(
	function (f, dict) {
		switch (dict.$) {
			case 0:
				return elm_community$intdict$IntDict$empty;
			case 1:
				var l = dict.a;
				return A2(
					elm_community$intdict$IntDict$leaf,
					l.E,
					A2(f, l.E, l.M));
			default:
				var i = dict.a;
				return A3(
					elm_community$intdict$IntDict$inner,
					i.fi,
					A2(elm_community$intdict$IntDict$map, f, i.d),
					A2(elm_community$intdict$IntDict$map, f, i.e));
		}
	});
var elm_community$graph$Graph$reverseEdges = function () {
	var updateContext = F2(
		function (nodeId, ctx) {
			return _Utils_update(
				ctx,
				{dr: ctx.cp, cp: ctx.dr});
		});
	return A2(
		elm$core$Basics$composeR,
		elm_community$graph$Graph$unGraph,
		A2(
			elm$core$Basics$composeR,
			elm_community$intdict$IntDict$map(updateContext),
			elm$core$Basics$identity));
}();
var author$project$Game$ProductionGraph$unitParents = function (u) {
	return A2(
		elm$core$Basics$composeR,
		elm_community$graph$Graph$reverseEdges,
		A2(
			elm$core$Basics$composeR,
			author$project$Game$ProductionGraph$unitChildren(u),
			elm_community$graph$Graph$reverseEdges));
};
var author$project$Polynomial$formatCoefficients = F2(
	function (numFormat, poly) {
		var format1 = F2(
			function (degree, term) {
				return (_Utils_eq(term, author$project$Decimal$one) && degree) ? '' : numFormat(term);
			});
		return A2(
			elm$core$List$indexedMap,
			format1,
			_Utils_eq(poly, _List_Nil) ? _List_fromArray(
				[author$project$Decimal$zero]) : poly);
	});
var author$project$View$Lang$DebugDecimal = function (a) {
	return {$: 4, a: a};
};
var elm$html$Html$sup = _VirtualDom_node('sup');
var author$project$View$ItemDebug$viewPoly = function (lang) {
	var render = F2(
		function (degree, coeff) {
			return A2(
				elm$html$Html$span,
				((coeff === '0') && degree) ? _List_fromArray(
					[
						elm$html$Html$Attributes$class('zeropoly')
					]) : _List_Nil,
				A2(
					elm$core$List$cons,
					elm$html$Html$text(coeff),
					function () {
						switch (degree) {
							case 0:
								return _List_fromArray(
									[
										elm$html$Html$text('')
									]);
							case 1:
								return _List_fromArray(
									[
										elm$html$Html$text('t + ')
									]);
							default:
								return _List_fromArray(
									[
										elm$html$Html$text(' t'),
										A2(
										elm$html$Html$sup,
										_List_Nil,
										_List_fromArray(
											[
												elm$html$Html$text(
												elm$core$String$fromInt(degree))
											])),
										elm$html$Html$text(' + ')
									]);
						}
					}()));
		});
	return A2(
		elm$core$Basics$composeR,
		author$project$Polynomial$formatCoefficients(
			A2(elm$core$Basics$composeR, author$project$View$Lang$DebugDecimal, lang.fH)),
		A2(
			elm$core$Basics$composeR,
			elm$core$List$indexedMap(render),
			elm$core$List$reverse));
};
var author$project$View$ItemDebug$viewPolynomialAndGraph = F4(
	function (session, game, snapshot, unit) {
		var poly = A2(
			elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				elm$core$Dict$get,
				author$project$GameData$Unit$name(unit),
				author$project$Game$polynomials(game)));
		var lang = A2(author$project$View$Lang$gameToLang, session, game);
		var graph = A2(
			author$project$Game$ProductionGraph$unitParents,
			unit,
			author$project$Game$graph(game));
		var coeffs = A2(
			elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				elm$core$Dict$get,
				author$project$GameData$Unit$name(unit),
				author$project$Game$ProductionGraph$parentCoefficients(graph)));
		return A2(
			elm$html$Html$li,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					elm$html$Html$a,
					_List_fromArray(
						[
							elm$html$Html$Attributes$target('_blank'),
							elm$html$Html$Attributes$href(
							author$project$Game$ProductionGraph$toDOTUrl(graph))
						]),
					_List_fromArray(
						[
							elm$html$Html$text(unit.cA)
						])),
					elm$html$Html$text(' = '),
					A2(
					elm$html$Html$code,
					_List_Nil,
					A2(author$project$View$ItemDebug$viewPoly, lang, poly))
				]));
	});
var elm$html$Html$br = _VirtualDom_node('br');
var author$project$View$ItemDebug$view = F4(
	function (session, game, snapshot, items) {
		if (A2(
			author$project$Route$Feature$isActive,
			0,
			author$project$Session$query(session))) {
			var t = author$project$Duration$since(
				{
					eb: author$project$Game$UnitsSnapshot$at(snapshot),
					eh: author$project$Game$snapshotted(game)
				});
			var graph = author$project$Game$graph(game);
			return _List_fromArray(
				[
					A2(
					elm$html$Html$div,
					_List_fromArray(
						[
							elm$html$Html$Attributes$class('card')
						]),
					_List_fromArray(
						[
							A2(
							elm$html$Html$h6,
							_List_fromArray(
								[
									elm$html$Html$Attributes$class('card-header')
								]),
							_List_fromArray(
								[
									elm$html$Html$text('ItemDebug view')
								])),
							A2(
							elm$html$Html$div,
							_List_fromArray(
								[
									elm$html$Html$Attributes$class('card-body')
								]),
							_List_fromArray(
								[
									A2(
									elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											elm$html$Html$text('in the polynomials below, '),
											elm$html$Html$text('t = '),
											A2(
											elm$html$Html$code,
											_List_Nil,
											_List_fromArray(
												[
													elm$html$Html$text(
													elm$core$String$fromFloat(
														author$project$Duration$toSecs(t)))
												])),
											A2(elm$html$Html$br, _List_Nil, _List_Nil),
											elm$html$Html$text('(alternately, t = '),
											A2(
											elm$html$Html$code,
											_List_Nil,
											_List_fromArray(
												[
													elm$html$Html$text(
													author$project$Duration$toStringDHMS(t))
												])),
											elm$html$Html$text(' or '),
											A2(
											elm$html$Html$code,
											_List_Nil,
											_List_fromArray(
												[
													elm$html$Html$text(
													author$project$Duration$toString(t))
												])),
											elm$html$Html$text(')')
										])),
									A2(
									elm$html$Html$ul,
									_List_Nil,
									elm$core$List$concat(
										A2(
											elm$core$List$map,
											function (item) {
												switch (item.$) {
													case 0:
														var unit = item.a;
														return _List_fromArray(
															[
																A4(author$project$View$ItemDebug$viewPolynomialAndGraph, session, game, snapshot, unit)
															]);
													case 2:
														var spell = item.a;
														return _List_Nil;
													default:
														var upgrade = item.a;
														return _List_Nil;
												}
											},
											items))),
									A2(
									elm$html$Html$a,
									_List_fromArray(
										[
											elm$html$Html$Attributes$target('_blank'),
											elm$html$Html$Attributes$href(
											author$project$Game$ProductionGraph$toDOTUrl(graph))
										]),
									_List_fromArray(
										[
											elm$html$Html$text('full unit production graph')
										])),
									A2(elm$html$Html$hr, _List_Nil, _List_Nil),
									elm$html$Html$text('on-buy effects:'),
									A2(
									elm$html$Html$ul,
									_List_Nil,
									elm$core$List$concat(
										A2(
											elm$core$List$map,
											function (item) {
												switch (item.$) {
													case 0:
														var unit = item.a;
														return A2(
															elm$core$List$cons,
															A2(
																elm$html$Html$li,
																_List_Nil,
																A2(
																	elm$core$List$cons,
																	elm$html$Html$text(
																		author$project$GameData$Item$name(item)),
																	A3(author$project$View$ItemDebug$viewOnBuyDebug, game, snapshot, item))),
															A2(
																elm$core$List$map,
																function (up) {
																	return A2(
																		elm$html$Html$li,
																		_List_Nil,
																		A2(
																			elm$core$List$cons,
																			elm$html$Html$text(
																				author$project$GameData$Upgrade$name(up)),
																			A3(
																				author$project$View$ItemDebug$viewOnBuyDebug,
																				game,
																				snapshot,
																				author$project$GameData$Item$Upgrade(up))));
																},
																A2(
																	author$project$GameData$upgradesByUnit,
																	unit,
																	author$project$Game$gameData(game))));
													case 2:
														var spell = item.a;
														return _List_fromArray(
															[
																A2(
																elm$html$Html$li,
																_List_Nil,
																A2(
																	elm$core$List$cons,
																	elm$html$Html$text(
																		author$project$GameData$Item$name(item)),
																	A3(author$project$View$ItemDebug$viewOnBuyDebug, game, snapshot, item)))
															]);
													default:
														var upgrade = item.a;
														return _List_Nil;
												}
											},
											items)))
								]))
						]))
				]);
		} else {
			return _List_Nil;
		}
	});
var author$project$View$Lang$ViewErrorTitle = {$: 15};
var author$project$View$NotReady$viewResult = F3(
	function (session, gd, res) {
		if (!res.$) {
			var html = res.a;
			return html;
		} else {
			var err = res.a;
			var lang = A2(author$project$View$Lang$gameDataToLang, session, gd);
			return _List_fromArray(
				[
					A2(
					elm$html$Html$h1,
					_List_Nil,
					_List_fromArray(
						[
							lang.q(author$project$View$Lang$ViewErrorTitle)
						])),
					A2(
					elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							elm$html$Html$text(err)
						]))
				]);
		}
	});
var author$project$Select$unitCountsByTab = F3(
	function (stab, game, snapshot) {
		return A2(
			elm$core$List$map,
			function (u) {
				return _Utils_Tuple2(
					u,
					A2(author$project$Game$UnitsSnapshot$count, u.eL, snapshot));
			},
			A3(author$project$Select$unitsByTab, stab, game, snapshot));
	});
var author$project$View$Lang$ViewUnitSidebarAchievementPoints = {$: 27};
var author$project$View$Lang$ViewUnitSidebarCount = function (a) {
	return {$: 28, a: a};
};
var author$project$View$UnitSidebar$viewAchievementsEntry = F3(
	function (clickMsg, session, game) {
		var query = author$project$Session$query(session);
		var points = author$project$Game$achievementPoints(game);
		var lang = A2(author$project$View$Lang$gameToLang, session, game);
		return A2(
			elm$html$Html$tr,
			_List_fromArray(
				[
					elm$html$Html$Events$onClick(
					clickMsg(author$project$Route$Achievements)),
					A2(elm$html$Html$Attributes$style, 'cursor', 'pointer')
				]),
			_List_fromArray(
				[
					A2(
					elm$html$Html$td,
					_List_fromArray(
						[
							elm$html$Html$Attributes$class('upgradable-icon')
						]),
					_List_Nil),
					A2(
					elm$html$Html$td,
					_List_fromArray(
						[
							elm$html$Html$Attributes$class('item-name')
						]),
					_List_fromArray(
						[
							A2(
							elm$html$Html$a,
							_List_fromArray(
								[
									A2(author$project$Route$href, query, author$project$Route$Achievements)
								]),
							_List_fromArray(
								[
									A2(
									elm$html$Html$span,
									_List_fromArray(
										[
											elm$html$Html$Attributes$class('float-left'),
											elm$html$Html$Attributes$class('list-label')
										]),
									_List_fromArray(
										[
											A2(
											elm$html$Html$span,
											_List_fromArray(
												[
													elm$html$Html$Attributes$class('list-icon-resource icon-achievements')
												]),
											_List_Nil),
											lang.q(author$project$View$Lang$ViewUnitSidebarAchievementPoints)
										])),
									A2(
									elm$html$Html$span,
									_List_fromArray(
										[
											elm$html$Html$Attributes$class('float-right')
										]),
									_List_fromArray(
										[
											lang.q(
											author$project$View$Lang$ViewUnitSidebarCount(
												author$project$Decimal$fromInt(points.d6)))
										]))
								]))
						]))
				]));
	});
var author$project$View$Lang$ViewUnitSidebarSpellName = function (a) {
	return {$: 26, a: a};
};
var author$project$View$UnitSidebar$viewSpellEntry = F7(
	function (clickMsg, stab, active, session, game, snapshot, spell) {
		var tabSlug = author$project$Select$tabToSlug(stab);
		var query = author$project$Session$query(session);
		var lang = A2(author$project$View$Lang$gameToLang, session, game);
		return A2(
			elm$html$Html$tr,
			_List_fromArray(
				[
					elm$html$Html$Events$onClick(
					clickMsg(
						A2(author$project$Route$Spell, tabSlug, spell.cA))),
					A2(elm$html$Html$Attributes$style, 'cursor', 'pointer'),
					elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'table-active',
							_Utils_eq(
								author$project$GameData$Spell$name(spell),
								author$project$GameData$Item$name(active)))
						]))
				]),
			_List_fromArray(
				[
					A2(
					elm$html$Html$td,
					_List_fromArray(
						[
							elm$html$Html$Attributes$class('upgradable-icon')
						]),
					_List_Nil),
					A2(
					elm$html$Html$td,
					_List_fromArray(
						[
							elm$html$Html$Attributes$class('item-name')
						]),
					_List_fromArray(
						[
							A2(
							elm$html$Html$a,
							_List_fromArray(
								[
									A2(
									author$project$Route$href,
									query,
									A2(author$project$Route$Spell, tabSlug, spell.cA))
								]),
							_List_fromArray(
								[
									A2(
									elm$html$Html$span,
									_List_fromArray(
										[
											elm$html$Html$Attributes$class('float-left'),
											elm$html$Html$Attributes$class('list-label')
										]),
									_List_fromArray(
										[
											A2(
											elm$html$Html$span,
											_List_fromArray(
												[
													elm$html$Html$Attributes$class('list-icon-resource'),
													elm$html$Html$Attributes$class(
													'icon-' + author$project$GameData$Spell$name(spell))
												]),
											_List_Nil),
											lang.q(
											author$project$View$Lang$ViewUnitSidebarSpellName(spell.eL)),
											elm$html$Html$text(' ')
										])),
									A2(
									elm$html$Html$span,
									_List_fromArray(
										[
											elm$html$Html$Attributes$class('float-right')
										]),
									_List_Nil)
								]))
						]))
				]));
	});
var author$project$View$Icon$upgradable = author$project$View$Icon$fas('arrow-alt-circle-up');
var author$project$View$Lang$ViewUnitSidebarUnitName = function (a) {
	return {$: 25, a: a};
};
var author$project$View$UnitSidebar$viewUnitEntry = F7(
	function (clickMsg, stab, active, session, game, snapshot, _n0) {
		var unit = _n0.a;
		var count = _n0.b;
		var tabSlug = author$project$Select$tabToSlug(stab);
		var query = author$project$Session$query(session);
		var lang = A2(author$project$View$Lang$gameToLang, session, game);
		var isWatchTriggered = A3(author$project$Select$isUnitSidebarWatchTriggered, unit, game, snapshot);
		var isAscendTriggered = A3(author$project$Select$isUnitSidebarAscendTriggered, unit, game, snapshot);
		return A2(
			elm$html$Html$tr,
			_List_fromArray(
				[
					elm$html$Html$Events$onClick(
					clickMsg(
						A2(author$project$Route$unit, tabSlug, unit.cA))),
					A2(elm$html$Html$Attributes$style, 'cursor', 'pointer'),
					elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'table-active',
							_Utils_eq(
								author$project$GameData$Unit$name(unit),
								author$project$GameData$Item$name(active)))
						]))
				]),
			_List_fromArray(
				[
					A2(
					elm$html$Html$td,
					_List_fromArray(
						[
							elm$html$Html$Attributes$class('upgradable-icon')
						]),
					_Utils_ap(
						isWatchTriggered ? _List_fromArray(
							[author$project$View$Icon$upgradable]) : _List_Nil,
						isAscendTriggered ? _List_fromArray(
							[
								author$project$View$Icon$fas('rocket')
							]) : _List_Nil)),
					A2(
					elm$html$Html$td,
					_List_fromArray(
						[
							elm$html$Html$Attributes$class('item-name')
						]),
					_List_fromArray(
						[
							A2(
							elm$html$Html$a,
							_List_fromArray(
								[
									A2(
									author$project$Route$href,
									query,
									A2(author$project$Route$unit, tabSlug, unit.cA))
								]),
							_List_fromArray(
								[
									A2(
									elm$html$Html$span,
									_List_fromArray(
										[
											elm$html$Html$Attributes$class('float-left'),
											elm$html$Html$Attributes$class('list-label')
										]),
									_List_fromArray(
										[
											A2(
											elm$html$Html$span,
											_List_fromArray(
												[
													elm$html$Html$Attributes$class('list-icon-resource'),
													elm$html$Html$Attributes$class(
													'icon-' + author$project$GameData$Unit$name(unit))
												]),
											_List_Nil),
											lang.q(
											author$project$View$Lang$ViewUnitSidebarUnitName(unit.eL)),
											elm$html$Html$text(' ')
										])),
									A2(
									elm$html$Html$span,
									_List_fromArray(
										[
											elm$html$Html$Attributes$class('float-right')
										]),
									_List_fromArray(
										[
											lang.q(
											author$project$View$Lang$ViewUnitSidebarCount(count))
										]))
								]))
						]))
				]));
	});
var elm$html$Html$tbody = _VirtualDom_node('tbody');
var author$project$View$UnitSidebar$viewSidebar = F7(
	function (clickMsg, stab, item, session, game, snapshot, content) {
		var units = A3(author$project$Select$unitCountsByTab, stab, game, snapshot);
		var spells = A3(author$project$Select$spellsByTab, stab, game, snapshot);
		var achieves = function () {
			if (stab.$ === 1) {
				return true;
			} else {
				var tab = stab.a;
				return tab.fB;
			}
		}();
		return _List_fromArray(
			[
				A2(
				elm$html$Html$table,
				_List_fromArray(
					[
						elm$html$Html$Attributes$class('table sidebar'),
						elm$html$Html$Attributes$class('table-hover')
					]),
				_List_fromArray(
					[
						A2(
						elm$html$Html$tbody,
						_List_Nil,
						_Utils_ap(
							(achieves && (author$project$Game$achievementPoints(game).d6 > 0)) ? _List_fromArray(
								[
									A3(author$project$View$UnitSidebar$viewAchievementsEntry, clickMsg, session, game)
								]) : _List_Nil,
							_Utils_ap(
								A2(
									elm$core$List$map,
									A6(author$project$View$UnitSidebar$viewSpellEntry, clickMsg, stab, item, session, game, snapshot),
									spells),
								A2(
									elm$core$List$map,
									A6(author$project$View$UnitSidebar$viewUnitEntry, clickMsg, stab, item, session, game, snapshot),
									units))))
					]))
			]);
	});
var author$project$View$UnitSidebar$wrap = F7(
	function (clickMsg, stab, item, session, game, snapshot, content) {
		return A2(
			author$project$Route$Feature$isActive,
			5,
			author$project$Session$query(session)) ? _List_fromArray(
			[
				A2(
				elm$html$Html$div,
				_List_fromArray(
					[
						elm$html$Html$Attributes$class('row')
					]),
				_List_fromArray(
					[
						A2(
						elm$html$Html$div,
						_List_fromArray(
							[
								elm$html$Html$Attributes$class('col-12 col-lg-9 col-md-8 order-2')
							]),
						content),
						A2(
						elm$html$Html$div,
						_List_fromArray(
							[
								elm$html$Html$Attributes$class('col-12 col-lg-3 col-md-4 order-1')
							]),
						_List_fromArray(
							[
								author$project$View$Device$onlyDesktop(
								A7(author$project$View$UnitSidebar$viewSidebar, clickMsg, stab, item, session, game, snapshot, content))
							]))
					]))
			]) : _List_fromArray(
			[
				A2(
				elm$html$Html$div,
				_List_fromArray(
					[
						elm$html$Html$Attributes$class('row')
					]),
				_List_fromArray(
					[
						A2(
						elm$html$Html$div,
						_List_fromArray(
							[
								elm$html$Html$Attributes$class('col-lg-9 col-md-8 col-sm-7 order-2'),
								elm$html$Html$Attributes$class('col-xs-12 order-xs-1')
							]),
						content),
						A2(
						elm$html$Html$div,
						_List_fromArray(
							[
								elm$html$Html$Attributes$class('col-lg-3 col-md-4 col-sm-5 order-1'),
								elm$html$Html$Attributes$class('col-xs-12 order-xs-1')
							]),
						A7(author$project$View$UnitSidebar$viewSidebar, clickMsg, stab, item, session, game, snapshot, content))
					]))
			]);
	});
var author$project$Page$MtxShop$view = F2(
	function (_n0, game) {
		var invRes = _n0.a;
		var tabSlug = _n0.b;
		var purchase = _n0.c;
		var session = _n0.d;
		return A3(
			author$project$View$NotReady$viewResult,
			session,
			author$project$Game$gameData(game),
			function () {
				var snap = A2(author$project$Session$safeUnits, game, session);
				var _n1 = _Utils_Tuple2(
					A3(author$project$Select$tabBySlug, tabSlug, game, snap),
					A3(author$project$Select$unitBySlug, 'crystal', game, snap));
				if (!_n1.a.$) {
					if (!_n1.b.$) {
						var stab = _n1.a.a;
						var _n2 = _n1.b.a;
						var unit = _n2.a;
						var count = _n2.b;
						return elm$core$Result$Ok(
							_Utils_ap(
								A2(
									elm$core$List$map,
									elm$html$Html$map(author$project$Page$MtxShop$GotTabNavMsg),
									A4(
										author$project$View$TabNav$view,
										A2(
											elm$core$Maybe$map,
											function ($) {
												return $.eL;
											},
											author$project$Select$unwrapTab(stab)),
										session,
										game,
										snap)),
								_Utils_ap(
									A7(
										author$project$View$UnitSidebar$wrap,
										author$project$Page$MtxShop$ClickedRoute,
										stab,
										author$project$GameData$Item$Unit(unit),
										session,
										game,
										snap,
										A8(author$project$Page$MtxShop$viewUnit, stab, session, game, snap, unit, count, invRes, purchase)),
									A4(
										author$project$View$ItemDebug$view,
										session,
										game,
										snap,
										_List_fromArray(
											[
												author$project$GameData$Item$Unit(unit)
											])))));
					} else {
						var _n4 = _n1.b;
						return elm$core$Result$Err('no such unit');
					}
				} else {
					var _n3 = _n1.a;
					return elm$core$Result$Err('no such tab');
				}
			}());
	});
var author$project$View$Lang$ViewNotFound = {$: 185};
var author$project$Page$NotFound$view = F2(
	function (session, game) {
		var lang = A2(author$project$View$Lang$gameToLang, session, game);
		return _List_fromArray(
			[
				lang.q(author$project$View$Lang$ViewNotFound)
			]);
	});
var author$project$Page$Options$GotTabNavMsg = function (a) {
	return {$: 8, a: a};
};
var author$project$Session$loaded = A2(
	elm$core$Basics$composeR,
	author$project$Session$unwrap,
	function ($) {
		return $.aW;
	});
var author$project$Page$Options$viewDebug = F2(
	function (session, game) {
		var now = A2(author$project$Session$safeNow, game, session);
		var snapshotted = author$project$Duration$since(
			{
				eb: now,
				eh: author$project$Game$snapshotted(game)
			});
		var loaded = A2(
			elm$core$Maybe$map,
			function (t) {
				return author$project$Duration$since(
					{eb: now, eh: t});
			},
			author$project$Session$loaded(session));
		var created = author$project$Duration$since(
			{
				eb: now,
				eh: author$project$Game$created(game)
			});
		return _List_fromArray(
			[
				A2(elm$html$Html$hr, _List_Nil, _List_Nil),
				A2(
				elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						elm$html$Html$text(
						'since created: ' + author$project$Duration$toString(created))
					])),
				A2(
				elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						elm$html$Html$text(
						'since page loaded: ' + A3(elm_community$maybe_extra$Maybe$Extra$unwrap, '???', author$project$Duration$toString, loaded))
					])),
				A2(
				elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						elm$html$Html$text(
						'since snapshotted (reified): ' + author$project$Duration$toString(snapshotted))
					]))
			]);
	});
var author$project$Game$theme = A2(
	elm$core$Basics$composeR,
	author$project$Game$unwrap,
	function ($) {
		return $.aG;
	});
var author$project$Page$Options$ImportedSave = function (a) {
	return {$: 6, a: a};
};
var author$project$Page$Options$UpdatedLocale = function (a) {
	return {$: 2, a: a};
};
var author$project$Page$Options$UpdatedNumberFormat = function (a) {
	return {$: 4, a: a};
};
var author$project$Page$Options$UpdatedTheme = function (a) {
	return {$: 3, a: a};
};
var author$project$Page$Options$UpdatedVelocityUnit = function (a) {
	return {$: 5, a: a};
};
var author$project$Page$Options$resetModalId = 'reset-modal';
var author$project$Page$Options$ClickedResetConfirm = {$: 1};
var author$project$View$Lang$ViewOptionsResetSaveCancel = {$: 78};
var author$project$View$Lang$ViewOptionsResetSaveConfirm = {$: 79};
var author$project$View$Lang$ViewOptionsResetSaveWarning = {$: 77};
var elm$html$Html$Attributes$tabindex = function (n) {
	return A2(
		_VirtualDom_attribute,
		'tabIndex',
		elm$core$String$fromInt(n));
};
var author$project$Page$Options$viewResetModal = function (lang) {
	var example = function (n) {
		return elm$html$Html$text('\"' + (n + '\"'));
	};
	return A2(
		elm$html$Html$div,
		_List_fromArray(
			[
				elm$html$Html$Attributes$class('modal fade bg-danger'),
				elm$html$Html$Attributes$id(author$project$Page$Options$resetModalId),
				elm$html$Html$Attributes$tabindex(-1),
				A2(elm$html$Html$Attributes$attribute, 'role', 'dialog'),
				A2(elm$html$Html$Attributes$attribute, 'aria-hidden', 'true')
			]),
		_List_fromArray(
			[
				A2(
				elm$html$Html$div,
				_List_fromArray(
					[
						elm$html$Html$Attributes$class('modal-dialog'),
						A2(elm$html$Html$Attributes$attribute, 'role', 'document')
					]),
				_List_fromArray(
					[
						A2(
						elm$html$Html$div,
						_List_fromArray(
							[
								elm$html$Html$Attributes$class('modal-content')
							]),
						_List_fromArray(
							[
								A2(
								elm$html$Html$div,
								_List_fromArray(
									[
										elm$html$Html$Attributes$class('modal-header')
									]),
								_List_fromArray(
									[
										A2(
										elm$html$Html$h5,
										_List_fromArray(
											[
												elm$html$Html$Attributes$class('modal-title')
											]),
										_List_fromArray(
											[
												author$project$View$Icon$fas('exclamation-triangle')
											])),
										A2(
										elm$html$Html$button,
										_List_fromArray(
											[
												elm$html$Html$Attributes$class('close'),
												A2(elm$html$Html$Attributes$attribute, 'data-dismiss', 'modal'),
												A2(elm$html$Html$Attributes$attribute, 'aria-label', 'close')
											]),
										_List_fromArray(
											[
												elm$html$Html$text('×')
											]))
									])),
								A2(
								elm$html$Html$div,
								_List_fromArray(
									[
										elm$html$Html$Attributes$class('modal-body')
									]),
								_List_fromArray(
									[
										A2(
										elm$html$Html$p,
										_List_Nil,
										_List_fromArray(
											[
												lang.q(author$project$View$Lang$ViewOptionsResetSaveWarning)
											])),
										A2(
										elm$html$Html$button,
										_List_fromArray(
											[
												elm$html$Html$Attributes$class('btn btn-primary'),
												A2(elm$html$Html$Attributes$attribute, 'data-dismiss', 'modal'),
												A2(elm$html$Html$Attributes$attribute, 'aria-label', 'close')
											]),
										_List_fromArray(
											[
												lang.q(author$project$View$Lang$ViewOptionsResetSaveCancel)
											])),
										A2(elm$html$Html$br, _List_Nil, _List_Nil),
										A2(elm$html$Html$br, _List_Nil, _List_Nil),
										A2(elm$html$Html$br, _List_Nil, _List_Nil),
										A2(elm$html$Html$br, _List_Nil, _List_Nil),
										A2(elm$html$Html$br, _List_Nil, _List_Nil),
										A2(
										elm$html$Html$button,
										_List_fromArray(
											[
												elm$html$Html$Attributes$class('btn btn-danger'),
												A2(elm$html$Html$Attributes$attribute, 'data-dismiss', 'modal'),
												elm$html$Html$Events$onClick(author$project$Page$Options$ClickedResetConfirm)
											]),
										_List_fromArray(
											[
												author$project$View$Icon$fas('skull'),
												elm$html$Html$text(' '),
												lang.q(author$project$View$Lang$ViewOptionsResetSaveConfirm),
												elm$html$Html$text(' '),
												author$project$View$Icon$fas('skull')
											]))
									])),
								A2(
								elm$html$Html$div,
								_List_fromArray(
									[
										elm$html$Html$Attributes$class('modal-footer')
									]),
								_List_Nil)
							]))
					]))
			]));
};
var author$project$Route$Feature$activate = F2(
	function (f, d) {
		return A3(author$project$Route$Feature$insert, f, true, d);
	});
var author$project$Route$Feature$deactivate = F2(
	function (f, d) {
		return A3(author$project$Route$Feature$insert, f, false, d);
	});
var author$project$View$Lang$ViewOptionsAnalyticsDesc = {$: 87};
var author$project$View$Lang$ViewOptionsAnalyticsOptOutLink = {$: 88};
var author$project$View$Lang$ViewOptionsAnalyticsPrivacyLink = {$: 89};
var author$project$View$Lang$ViewOptionsExport = {$: 74};
var author$project$View$Lang$ViewOptionsHelpTranslate = {$: 80};
var author$project$View$Lang$ViewOptionsLocale = function (a) {
	return {$: 81, a: a};
};
var author$project$View$Lang$ViewOptionsNotYetSaved = {$: 75};
var author$project$View$Lang$ViewOptionsNumberFormat = function (a) {
	return {$: 83, a: a};
};
var author$project$View$Lang$ViewOptionsResetSaveLink = {$: 76};
var author$project$View$Lang$ViewOptionsTheme = function (a) {
	return {$: 82, a: a};
};
var author$project$View$Lang$ViewOptionsTitle = {$: 73};
var author$project$View$Lang$ViewOptionsToggleDebug = function (a) {
	return {$: 86, a: a};
};
var author$project$View$Lang$ViewOptionsToggleFps = function (a) {
	return {$: 85, a: a};
};
var author$project$View$Lang$ViewOptionsVelocityUnit = function (a) {
	return {$: 84, a: a};
};
var author$project$Page$Options$viewReady = F2(
	function (_n0, game) {
		var session = _n0.f;
		var importStatus = _n0.ah;
		var query = author$project$Session$query(session);
		var persistExport = author$project$Session$persistExport(session);
		var lang = A2(author$project$View$Lang$gameToLang, session, game);
		return _List_fromArray(
			[
				A2(
				elm$html$Html$h3,
				_List_Nil,
				_List_fromArray(
					[
						lang.q(author$project$View$Lang$ViewOptionsTitle)
					])),
				A2(
				elm$html$Html$div,
				_List_fromArray(
					[
						elm$html$Html$Attributes$class('form-group')
					]),
				_List_fromArray(
					[
						A2(author$project$Route$Feature$isActive, 1, query) ? A2(
						elm$html$Html$a,
						_List_fromArray(
							[
								A2(
								author$project$Route$href,
								A2(author$project$Route$Feature$deactivate, 1, query),
								author$project$Route$Options),
								elm$html$Html$Attributes$class('btn btn-primary fps-disable')
							]),
						_List_fromArray(
							[
								lang.q(
								author$project$View$Lang$ViewOptionsToggleFps(false))
							])) : A2(
						elm$html$Html$a,
						_List_fromArray(
							[
								A2(
								author$project$Route$href,
								A2(author$project$Route$Feature$activate, 1, query),
								author$project$Route$Options),
								elm$html$Html$Attributes$class('btn btn-primary fps-enable')
							]),
						_List_fromArray(
							[
								lang.q(
								author$project$View$Lang$ViewOptionsToggleFps(true))
							]))
					])),
				A2(
				elm$html$Html$div,
				_List_fromArray(
					[
						elm$html$Html$Attributes$class('form-group')
					]),
				_List_fromArray(
					[
						A2(
						elm$html$Html$label,
						_List_Nil,
						_List_fromArray(
							[
								lang.q(author$project$View$Lang$ViewOptionsExport)
							])),
						A2(
						elm$html$Html$input,
						_List_fromArray(
							[
								elm$html$Html$Attributes$type_('text'),
								elm$html$Html$Attributes$class('form-control'),
								elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'is-invalid',
										krisajenkins$remotedata$RemoteData$isFailure(importStatus)),
										_Utils_Tuple2(
										'is-valid',
										krisajenkins$remotedata$RemoteData$isSuccess(importStatus))
									])),
								elm$html$Html$Attributes$value(
								A2(
									elm$core$Maybe$withDefault,
									lang.fH(author$project$View$Lang$ViewOptionsNotYetSaved),
									persistExport)),
								elm$html$Html$Events$onInput(author$project$Page$Options$ImportedSave)
							]),
						_List_Nil),
						A2(
						elm$html$Html$div,
						_List_Nil,
						author$project$View$NotReady$viewRemoteInline(
							A2(
								krisajenkins$remotedata$RemoteData$map,
								elm$core$Basics$always(_List_Nil),
								importStatus)))
					])),
				A2(
				elm$html$Html$div,
				_List_fromArray(
					[
						elm$html$Html$Attributes$class('form-group')
					]),
				_List_fromArray(
					[
						A2(
						elm$html$Html$div,
						_List_fromArray(
							[
								elm$html$Html$Attributes$class('dropdown')
							]),
						_List_fromArray(
							[
								A2(
								elm$html$Html$button,
								_List_fromArray(
									[
										elm$html$Html$Attributes$class('nav-link dropdown-toggle btn btn-primary'),
										A2(elm$html$Html$Attributes$attribute, 'data-toggle', 'dropdown'),
										A2(elm$html$Html$Attributes$attribute, 'role', 'button'),
										A2(elm$html$Html$Attributes$attribute, 'aria-haspopup', 'true')
									]),
								_List_fromArray(
									[
										lang.q(
										author$project$View$Lang$ViewOptionsNumberFormat(
											author$project$Game$numberFormat(game)))
									])),
								A2(
								elm$html$Html$div,
								_List_fromArray(
									[
										elm$html$Html$Attributes$class('dropdown-menu')
									]),
								A2(
									elm$core$List$map,
									function (format) {
										return A2(
											elm$html$Html$button,
											_List_fromArray(
												[
													elm$html$Html$Attributes$class('dropdown-item'),
													elm$html$Html$Events$onClick(
													author$project$Page$Options$UpdatedNumberFormat(format))
												]),
											_List_fromArray(
												[
													lang.q(
													author$project$View$Lang$ViewOptionsNumberFormat(format))
												]));
									},
									author$project$Game$NumberFormat$list))
							]))
					])),
				A2(
				elm$html$Html$div,
				_List_fromArray(
					[
						elm$html$Html$Attributes$class('form-group')
					]),
				_List_fromArray(
					[
						A2(
						elm$html$Html$div,
						_List_fromArray(
							[
								elm$html$Html$Attributes$class('dropdown')
							]),
						_List_fromArray(
							[
								A2(
								elm$html$Html$button,
								_List_fromArray(
									[
										elm$html$Html$Attributes$class('nav-link dropdown-toggle btn btn-primary'),
										A2(elm$html$Html$Attributes$attribute, 'data-toggle', 'dropdown'),
										A2(elm$html$Html$Attributes$attribute, 'role', 'button'),
										A2(elm$html$Html$Attributes$attribute, 'aria-haspopup', 'true')
									]),
								_List_fromArray(
									[
										lang.q(
										author$project$View$Lang$ViewOptionsVelocityUnit(
											author$project$Game$velocityUnit(game)))
									])),
								A2(
								elm$html$Html$div,
								_List_fromArray(
									[
										elm$html$Html$Attributes$class('dropdown-menu')
									]),
								A2(
									elm$core$List$map,
									function (format) {
										return A2(
											elm$html$Html$button,
											_List_fromArray(
												[
													elm$html$Html$Attributes$class('dropdown-item'),
													elm$html$Html$Events$onClick(
													author$project$Page$Options$UpdatedVelocityUnit(format))
												]),
											_List_fromArray(
												[
													lang.q(
													author$project$View$Lang$ViewOptionsVelocityUnit(format))
												]));
									},
									author$project$Game$VelocityUnit$list))
							]))
					])),
				A2(
				elm$html$Html$div,
				_List_fromArray(
					[
						elm$html$Html$Attributes$class('form-group')
					]),
				_List_fromArray(
					[
						A2(
						elm$html$Html$div,
						_List_fromArray(
							[
								elm$html$Html$Attributes$class('dropdown')
							]),
						_List_fromArray(
							[
								A2(
								elm$html$Html$button,
								_List_fromArray(
									[
										elm$html$Html$Attributes$class('nav-link dropdown-toggle btn btn-primary'),
										A2(elm$html$Html$Attributes$attribute, 'data-toggle', 'dropdown'),
										A2(elm$html$Html$Attributes$attribute, 'role', 'button'),
										A2(elm$html$Html$Attributes$attribute, 'aria-haspopup', 'true')
									]),
								_List_fromArray(
									[
										lang.q(
										author$project$View$Lang$ViewOptionsLocale(lang.av))
									])),
								A2(
								elm$html$Html$div,
								_List_fromArray(
									[
										elm$html$Html$Attributes$class('dropdown-menu')
									]),
								_Utils_ap(
									A2(
										elm$core$List$map,
										function (loc) {
											return A2(
												elm$html$Html$button,
												_List_fromArray(
													[
														elm$html$Html$Attributes$class('dropdown-item'),
														elm$html$Html$Events$onClick(
														author$project$Page$Options$UpdatedLocale(loc))
													]),
												_List_fromArray(
													[
														lang.q(
														author$project$View$Lang$ViewOptionsLocale(loc))
													]));
										},
										author$project$Locale$list),
									_List_fromArray(
										[
											A2(
											elm$html$Html$div,
											_List_fromArray(
												[
													elm$html$Html$Attributes$class('dropdown-divider')
												]),
											_List_Nil),
											A2(
											elm$html$Html$a,
											_List_fromArray(
												[
													elm$html$Html$Attributes$class('dropdown-item'),
													A2(author$project$Route$href, query, author$project$Route$Translator)
												]),
											_List_fromArray(
												[
													lang.q(author$project$View$Lang$ViewOptionsHelpTranslate)
												]))
										])))
							]))
					])),
				A2(
				elm$html$Html$div,
				_List_fromArray(
					[
						elm$html$Html$Attributes$class('form-group')
					]),
				_List_fromArray(
					[
						A2(
						elm$html$Html$div,
						_List_fromArray(
							[
								elm$html$Html$Attributes$class('dropdown theme-dropdown')
							]),
						_List_fromArray(
							[
								A2(
								elm$html$Html$button,
								_List_fromArray(
									[
										elm$html$Html$Attributes$class('nav-link dropdown-toggle btn btn-primary'),
										A2(elm$html$Html$Attributes$attribute, 'data-toggle', 'dropdown'),
										A2(elm$html$Html$Attributes$attribute, 'role', 'button'),
										A2(elm$html$Html$Attributes$attribute, 'aria-haspopup', 'true')
									]),
								_List_fromArray(
									[
										lang.q(
										author$project$View$Lang$ViewOptionsTheme(
											author$project$Game$theme(game)))
									])),
								A2(
								elm$html$Html$div,
								_List_fromArray(
									[
										elm$html$Html$Attributes$class('dropdown-menu')
									]),
								A2(
									elm$core$List$map,
									function (theme) {
										return A2(
											elm$html$Html$button,
											_List_fromArray(
												[
													elm$html$Html$Attributes$class('dropdown-item'),
													elm$html$Html$Events$onClick(
													author$project$Page$Options$UpdatedTheme(theme))
												]),
											_List_fromArray(
												[
													lang.q(
													author$project$View$Lang$ViewOptionsTheme(theme))
												]));
									},
									author$project$Game$Theme$list))
							]))
					])),
				A2(
				elm$html$Html$div,
				_List_fromArray(
					[
						elm$html$Html$Attributes$class('form-group')
					]),
				_List_fromArray(
					[
						A2(
						elm$html$Html$button,
						_List_fromArray(
							[
								elm$html$Html$Attributes$class('btn btn-danger'),
								A2(elm$html$Html$Attributes$attribute, 'data-toggle', 'modal'),
								A2(elm$html$Html$Attributes$attribute, 'data-target', '#' + author$project$Page$Options$resetModalId)
							]),
						_List_fromArray(
							[
								lang.q(author$project$View$Lang$ViewOptionsResetSaveLink)
							]))
					])),
				author$project$Page$Options$viewResetModal(lang),
				A2(
				elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								lang.q(author$project$View$Lang$ViewOptionsAnalyticsDesc),
								elm$html$Html$text(' '),
								A2(
								elm$html$Html$a,
								_List_fromArray(
									[
										elm$html$Html$Attributes$target('_blank'),
										elm$html$Html$Attributes$href('https://tools.google.com/dlpage/gaoptout')
									]),
								_List_fromArray(
									[
										lang.q(author$project$View$Lang$ViewOptionsAnalyticsOptOutLink)
									])),
								elm$html$Html$text('.')
							])),
						A2(
						elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								elm$html$Html$a,
								_List_fromArray(
									[
										elm$html$Html$Attributes$target('_blank'),
										elm$html$Html$Attributes$href('http://www.google.com/policies/privacy/partners/')
									]),
								_List_fromArray(
									[
										lang.q(author$project$View$Lang$ViewOptionsAnalyticsPrivacyLink)
									]))
							]))
					])),
				A2(
				elm$html$Html$div,
				_List_fromArray(
					[
						elm$html$Html$Attributes$class('form-group'),
						A2(elm$html$Html$Attributes$style, 'float', 'right')
					]),
				A2(author$project$Route$Feature$isActive, 0, query) ? _List_fromArray(
					[
						A2(
						elm$html$Html$a,
						_List_fromArray(
							[
								A2(author$project$Route$href, query, author$project$Route$Debug),
								elm$html$Html$Attributes$class('btn btn-link')
							]),
						_List_fromArray(
							[
								elm$html$Html$text('Debugging tools')
							])),
						A2(
						elm$html$Html$a,
						_List_fromArray(
							[
								A2(
								author$project$Route$href,
								A2(author$project$Route$Feature$deactivate, 0, query),
								author$project$Route$Options),
								elm$html$Html$Attributes$class('btn btn-secondary debug-disable')
							]),
						_List_fromArray(
							[
								lang.q(
								author$project$View$Lang$ViewOptionsToggleDebug(false))
							]))
					]) : _List_fromArray(
					[
						A2(
						elm$html$Html$a,
						_List_fromArray(
							[
								A2(
								author$project$Route$href,
								A2(author$project$Route$Feature$activate, 0, query),
								author$project$Route$Options),
								elm$html$Html$Attributes$class('btn btn-secondary debug-enable')
							]),
						_List_fromArray(
							[
								lang.q(
								author$project$View$Lang$ViewOptionsToggleDebug(true))
							]))
					]))
			]);
	});
var author$project$Page$Options$view = F2(
	function (model, game) {
		var m = model;
		return _Utils_ap(
			A2(
				elm$core$List$map,
				elm$html$Html$map(author$project$Page$Options$GotTabNavMsg),
				A3(author$project$View$TabNav$viewFromGame, elm$core$Maybe$Nothing, m.f, game)),
			_Utils_ap(
				A2(author$project$Page$Options$viewReady, model, game),
				A2(
					author$project$Route$Feature$isActive,
					0,
					author$project$Session$query(m.f)) ? A2(author$project$Page$Options$viewDebug, m.f, game) : _List_Nil));
	});
var author$project$Page$PaypalDone$view = _List_fromArray(
	[author$project$View$Icon$loading]);
var author$project$Page$Register$InputEmail = function (a) {
	return {$: 2, a: a};
};
var author$project$Page$Register$InputPassword = function (a) {
	return {$: 3, a: a};
};
var author$project$Page$Register$InputPassword2 = function (a) {
	return {$: 4, a: a};
};
var author$project$Page$Register$InputRemember = function (a) {
	return {$: 5, a: a};
};
var author$project$Page$Register$Submit = {$: 1};
var author$project$View$Lang$ViewRegisterFieldEmail = {$: 150};
var author$project$View$Lang$ViewRegisterFieldPassword = {$: 151};
var author$project$View$Lang$ViewRegisterFieldPassword2 = {$: 152};
var author$project$View$Lang$ViewRegisterFieldRememberMe = {$: 153};
var author$project$View$Lang$ViewRegisterLinkLogin = {$: 155};
var author$project$View$Lang$ViewRegisterSubmit = {$: 154};
var author$project$View$Lang$ViewRegisterTitle = {$: 149};
var author$project$Page$Register$view = F2(
	function (_n0, gd) {
		var model = _n0;
		var qs = author$project$Session$query(model.f);
		var lang = A2(author$project$View$Lang$gameDataToLang, model.f, gd);
		var error = author$project$View$FormUtil$failure(model.a$);
		return _List_fromArray(
			[
				A2(
				elm$html$Html$h3,
				_List_Nil,
				_List_fromArray(
					[
						lang.q(author$project$View$Lang$ViewRegisterTitle)
					])),
				A2(
				elm$html$Html$form,
				_List_fromArray(
					[
						elm$html$Html$Events$onSubmit(author$project$Page$Register$Submit)
					]),
				_List_fromArray(
					[
						A2(
						elm$html$Html$div,
						_List_fromArray(
							[
								elm$html$Html$Attributes$class('form-group')
							]),
						A2(
							elm$core$List$cons,
							A2(
								elm$html$Html$label,
								_List_fromArray(
									[
										elm$html$Html$Attributes$for('playfab-login-email')
									]),
								_List_fromArray(
									[
										lang.q(author$project$View$Lang$ViewRegisterFieldEmail)
									])),
							A4(
								author$project$View$FormUtil$field,
								A2(author$project$PlayFab$errorField, error, 'Email'),
								elm$html$Html$input,
								_List_fromArray(
									[
										elm$html$Html$Attributes$type_('email'),
										elm$html$Html$Attributes$id('playfab-login-email'),
										elm$html$Html$Attributes$class('form-control'),
										elm$html$Html$Attributes$value(model.bW),
										elm$html$Html$Events$onInput(author$project$Page$Register$InputEmail)
									]),
								_List_Nil))),
						A2(
						elm$html$Html$div,
						_List_fromArray(
							[
								elm$html$Html$Attributes$class('form-group')
							]),
						A2(
							elm$core$List$cons,
							A2(
								elm$html$Html$label,
								_List_fromArray(
									[
										elm$html$Html$Attributes$for('playfab-login-password')
									]),
								_List_fromArray(
									[
										lang.q(author$project$View$Lang$ViewRegisterFieldPassword)
									])),
							A4(
								author$project$View$FormUtil$field,
								A2(author$project$PlayFab$errorField, error, 'Password'),
								elm$html$Html$input,
								_List_fromArray(
									[
										elm$html$Html$Attributes$type_('password'),
										elm$html$Html$Attributes$id('playfab-login-password'),
										elm$html$Html$Attributes$class('form-control'),
										elm$html$Html$Attributes$value(model.cq),
										elm$html$Html$Events$onInput(author$project$Page$Register$InputPassword)
									]),
								_List_Nil))),
						A2(
						elm$html$Html$div,
						_List_fromArray(
							[
								elm$html$Html$Attributes$class('form-group')
							]),
						A2(
							elm$core$List$cons,
							A2(
								elm$html$Html$label,
								_List_fromArray(
									[
										elm$html$Html$Attributes$for('playfab-login-password2')
									]),
								_List_fromArray(
									[
										lang.q(author$project$View$Lang$ViewRegisterFieldPassword2)
									])),
							A4(
								author$project$View$FormUtil$field,
								A2(author$project$PlayFab$errorField, error, 'Password2'),
								elm$html$Html$input,
								_List_fromArray(
									[
										elm$html$Html$Attributes$type_('password'),
										elm$html$Html$Attributes$id('playfab-login-password2'),
										elm$html$Html$Attributes$class('form-control'),
										elm$html$Html$Attributes$value(model.bu),
										elm$html$Html$Events$onInput(author$project$Page$Register$InputPassword2)
									]),
								_List_Nil))),
						A2(
						elm$html$Html$div,
						_List_fromArray(
							[
								elm$html$Html$Attributes$class('form-group form-check')
							]),
						_List_fromArray(
							[
								A2(
								elm$html$Html$input,
								_List_fromArray(
									[
										elm$html$Html$Attributes$type_('checkbox'),
										elm$html$Html$Attributes$id('playfab-login-remember'),
										elm$html$Html$Attributes$class('form-check-input'),
										elm$html$Html$Attributes$checked(model.bv),
										elm$html$Html$Events$onCheck(author$project$Page$Register$InputRemember)
									]),
								_List_Nil),
								A2(
								elm$html$Html$label,
								_List_fromArray(
									[
										elm$html$Html$Attributes$for('playfab-login-remember'),
										elm$html$Html$Attributes$class('form-check-label')
									]),
								_List_fromArray(
									[
										lang.q(author$project$View$Lang$ViewRegisterFieldRememberMe)
									]))
							])),
						author$project$View$FormUtil$error(
						author$project$PlayFab$Error$toMessages(error)),
						krisajenkins$remotedata$RemoteData$isLoading(model.a$) ? A2(
						elm$html$Html$button,
						_List_fromArray(
							[
								elm$html$Html$Attributes$type_('submit'),
								elm$html$Html$Attributes$class('btn btn-primary disabled'),
								elm$html$Html$Attributes$disabled(true)
							]),
						_List_fromArray(
							[
								author$project$View$Icon$loading,
								elm$html$Html$text(' '),
								lang.q(author$project$View$Lang$ViewRegisterSubmit)
							])) : A2(
						elm$html$Html$button,
						_List_fromArray(
							[
								elm$html$Html$Attributes$type_('submit'),
								elm$html$Html$Attributes$class('btn btn-primary')
							]),
						_List_fromArray(
							[
								lang.q(author$project$View$Lang$ViewRegisterSubmit)
							]))
					])),
				A2(
				elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						elm$html$Html$a,
						_List_fromArray(
							[
								elm$html$Html$Attributes$class('btn btn-link'),
								A2(author$project$Route$href, qs, author$project$Route$Login)
							]),
						_List_fromArray(
							[
								lang.q(author$project$View$Lang$ViewRegisterLinkLogin)
							]))
					]))
			]);
	});
var author$project$Page$ResetPassword$InputEmail = function (a) {
	return {$: 2, a: a};
};
var author$project$Page$ResetPassword$Submit = {$: 1};
var author$project$View$Lang$ViewResetPasswordFieldEmail = {$: 172};
var author$project$View$Lang$ViewResetPasswordSubmit = {$: 173};
var author$project$View$Lang$ViewResetPasswordTitle = {$: 171};
var author$project$Page$ResetPassword$view = F2(
	function (_n0, gd) {
		var model = _n0;
		var qs = author$project$Session$query(model.f);
		var lang = A2(author$project$View$Lang$gameDataToLang, model.f, gd);
		var error = author$project$View$FormUtil$failure(model.a$);
		return _List_fromArray(
			[
				A2(
				elm$html$Html$h3,
				_List_Nil,
				_List_fromArray(
					[
						lang.q(author$project$View$Lang$ViewResetPasswordTitle)
					])),
				A2(
				elm$html$Html$form,
				_List_fromArray(
					[
						elm$html$Html$Events$onSubmit(author$project$Page$ResetPassword$Submit)
					]),
				_List_fromArray(
					[
						A2(
						elm$html$Html$div,
						_List_fromArray(
							[
								elm$html$Html$Attributes$class('form-group')
							]),
						A2(
							elm$core$List$cons,
							A2(
								elm$html$Html$label,
								_List_fromArray(
									[
										elm$html$Html$Attributes$for('playfab-login-email')
									]),
								_List_fromArray(
									[
										lang.q(author$project$View$Lang$ViewResetPasswordFieldEmail)
									])),
							A4(
								author$project$View$FormUtil$field,
								A2(author$project$PlayFab$errorField, error, 'Email'),
								elm$html$Html$input,
								_List_fromArray(
									[
										elm$html$Html$Attributes$type_('email'),
										elm$html$Html$Attributes$id('playfab-login-email'),
										elm$html$Html$Attributes$class('form-control'),
										elm$html$Html$Attributes$value(model.bW),
										elm$html$Html$Events$onInput(author$project$Page$ResetPassword$InputEmail)
									]),
								_List_Nil))),
						author$project$View$FormUtil$error(
						author$project$PlayFab$Error$toMessages(error)),
						function () {
						var _n1 = model.a$;
						switch (_n1.$) {
							case 1:
								return A2(
									elm$html$Html$button,
									_List_fromArray(
										[
											elm$html$Html$Attributes$type_('submit'),
											elm$html$Html$Attributes$class('btn btn-primary disabled'),
											elm$html$Html$Attributes$disabled(true)
										]),
									_List_fromArray(
										[
											author$project$View$Icon$loading,
											elm$html$Html$text(' '),
											lang.q(author$project$View$Lang$ViewResetPasswordSubmit)
										]));
							case 3:
								return A2(
									elm$html$Html$button,
									_List_fromArray(
										[
											elm$html$Html$Attributes$type_('submit'),
											elm$html$Html$Attributes$class('btn btn-success')
										]),
									_List_fromArray(
										[
											lang.q(author$project$View$Lang$ViewResetPasswordSubmit)
										]));
							case 2:
								return A2(
									elm$html$Html$button,
									_List_fromArray(
										[
											elm$html$Html$Attributes$type_('submit'),
											elm$html$Html$Attributes$class('btn btn-danger')
										]),
									_List_fromArray(
										[
											lang.q(author$project$View$Lang$ViewResetPasswordSubmit)
										]));
							default:
								return A2(
									elm$html$Html$button,
									_List_fromArray(
										[
											elm$html$Html$Attributes$type_('submit'),
											elm$html$Html$Attributes$class('btn btn-primary')
										]),
									_List_fromArray(
										[
											lang.q(author$project$View$Lang$ViewResetPasswordSubmit)
										]));
						}
					}()
					])),
				function () {
				var _n2 = author$project$Session$user(model.f);
				if ((_n2.$ === 3) && (!_n2.a.$)) {
					var user = _n2.a.a;
					return A2(
						elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								elm$html$Html$a,
								_List_fromArray(
									[
										elm$html$Html$Attributes$class('btn btn-link'),
										A2(author$project$Route$href, qs, author$project$Route$User)
									]),
								_List_fromArray(
									[
										elm$html$Html$text(
										A2(
											author$project$PlayFab$User$displayName,
											author$project$Session$iframe(model.f),
											user))
									]))
							]));
				} else {
					return A2(
						elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										elm$html$Html$a,
										_List_fromArray(
											[
												elm$html$Html$Attributes$class('btn btn-link'),
												A2(author$project$Route$href, qs, author$project$Route$Register)
											]),
										_List_fromArray(
											[
												lang.q(author$project$View$Lang$ViewLoginLinkRegister)
											]))
									])),
								A2(
								elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										elm$html$Html$a,
										_List_fromArray(
											[
												elm$html$Html$Attributes$class('btn btn-link'),
												A2(author$project$Route$href, qs, author$project$Route$Login)
											]),
										_List_fromArray(
											[
												lang.q(author$project$View$Lang$ViewRegisterLinkLogin)
											]))
									]))
							]));
				}
			}()
			]);
	});
var author$project$Page$Spell$GotTabNavMsg = function (a) {
	return {$: 3, a: a};
};
var author$project$View$BuyN$ClickedAscend = function (a) {
	return {$: 2, a: a};
};
var author$project$Session$orderProgress = function (name) {
	return A2(
		elm$core$Basics$composeR,
		author$project$Session$unwrap,
		A2(
			elm$core$Basics$composeR,
			function ($) {
				return $.az;
			},
			elm$core$Dict$get(name)));
};
var author$project$View$Lang$ViewAscendProgressCapDiff = function (a) {
	return {$: 48, a: a};
};
var author$project$View$BuyN$viewAscendCostExceedsCap = F4(
	function (session, game, progress, _n0) {
		var pct = _n0.dB;
		var cap = _n0.c0;
		var percent100 = pct * 100;
		var lang = A2(author$project$View$Lang$gameToLang, session, game);
		var capCostDiff = A2(author$project$Decimal$sub, progress.es, cap);
		var capCostPercent = 100 * author$project$Decimal$toFloat(
			A2(author$project$Decimal$div, capCostDiff, progress.es));
		var capGapPercent = (100 - percent100) - capCostPercent;
		return _List_fromArray(
			[
				A2(
				elm$html$Html$div,
				_List_fromArray(
					[
						elm$html$Html$Attributes$class('progress ascend-progress')
					]),
				_List_fromArray(
					[
						A2(
						elm$html$Html$div,
						_List_fromArray(
							[
								elm$html$Html$Attributes$class('progress-bar'),
								A2(
								elm$html$Html$Attributes$style,
								'width',
								elm$core$String$fromFloat(percent100) + '%'),
								A2(elm$html$Html$Attributes$style, 'text-align', 'left'),
								A2(elm$html$Html$Attributes$style, 'z-index', '1'),
								A2(elm$html$Html$Attributes$attribute, 'role', 'progressbar'),
								A2(
								elm$html$Html$Attributes$attribute,
								'aria-valuenow',
								elm$core$String$fromFloat(percent100)),
								A2(elm$html$Html$Attributes$attribute, 'aria-valuemax', '100')
							]),
						_List_fromArray(
							[
								lang.q(
								author$project$View$Lang$ViewAscendProgressCapDiff(capCostDiff))
							])),
						A2(
						elm$html$Html$div,
						_List_fromArray(
							[
								elm$html$Html$Attributes$class('progress-bar bg-danger'),
								A2(
								elm$html$Html$Attributes$style,
								'width',
								elm$core$String$fromFloat(capGapPercent) + '%')
							]),
						_List_Nil),
						A2(
						elm$html$Html$div,
						_List_fromArray(
							[
								elm$html$Html$Attributes$class('progress-bar bg-warning'),
								A2(
								elm$html$Html$Attributes$style,
								'width',
								elm$core$String$fromFloat(capCostPercent) + '%')
							]),
						_List_Nil)
					]))
			]);
	});
var author$project$Game$Order$Progress$remaining = function (_n0) {
	var from = _n0.dj;
	var now = _n0.cm;
	var total = _n0.d2;
	return A2(
		author$project$Duration$max,
		author$project$Duration$zero,
		A2(
			author$project$Duration$sub,
			total,
			author$project$Duration$since(
				{eb: now, eh: from})));
};
var author$project$View$Lang$ViewCostMet = F2(
	function (a, b) {
		return {$: 121, a: a, b: b};
	});
var author$project$View$Lang$ViewCostNotMet = F3(
	function (a, b, c) {
		return {$: 122, a: a, b: b, c: c};
	});
var author$project$View$BuyN$viewCost2 = F3(
	function (session, game, progress) {
		var lang = A2(author$project$View$Lang$gameToLang, session, game);
		if (progress.$ === 1) {
			return _List_fromArray(
				[author$project$View$Icon$loading]);
		} else {
			var ps = progress.a;
			return A2(
				elm$core$List$map,
				function (p) {
					var _n1 = p.cE;
					if (!_n1.$) {
						var pct = _n1.a;
						var pctStr = elm$core$String$fromFloat(
							(pct > 0.95) ? 100 : (pct * 100));
						return A2(
							elm$html$Html$div,
							_List_fromArray(
								[
									elm$html$Html$Attributes$class('progress')
								]),
							_List_fromArray(
								[
									A2(
									elm$html$Html$div,
									_List_fromArray(
										[
											elm$html$Html$Attributes$class('progress-bar bg-success'),
											A2(elm$html$Html$Attributes$style, 'width', pctStr + '%'),
											A2(elm$html$Html$Attributes$style, 'text-align', 'left'),
											A2(elm$html$Html$Attributes$attribute, 'role', 'progressbar'),
											A2(elm$html$Html$Attributes$attribute, 'aria-valuenow', pctStr),
											A2(elm$html$Html$Attributes$attribute, 'aria-valuemax', '100')
										]),
									_List_fromArray(
										[
											lang.q(
											A2(author$project$View$Lang$ViewCostMet, p, pct))
										]))
								]));
					} else {
						var pct = _n1.a;
						var duration = _n1.b;
						var tailStr = elm$core$String$fromFloat(
							(pct > 0.99) ? 0 : ((1 - pct) * 100));
						var route = A2(
							elm$core$Maybe$andThen,
							function (u) {
								var _n3 = u.es;
								if (!_n3.b) {
									return elm$core$Maybe$Nothing;
								} else {
									return elm$core$Maybe$Just(
										A3(
											author$project$Route$Unit,
											author$project$GameData$Tab$idToString(u.fM),
											u.cA,
											{
												dz: elm$core$Maybe$Just(
													'@' + author$project$Decimal$toString(p.es))
											}));
								}
							},
							A2(
								author$project$GameData$unitByName,
								author$project$GameData$Unit$idToString(p.bS),
								author$project$Game$gameData(game)));
						var pctStr = elm$core$String$fromFloat(
							(pct > 0.99) ? 100 : (pct * 100));
						return A2(
							elm$html$Html$div,
							_List_fromArray(
								[
									elm$html$Html$Attributes$class('progress')
								]),
							_List_fromArray(
								[
									A2(
									elm$html$Html$div,
									_List_fromArray(
										[
											elm$html$Html$Attributes$class('progress-bar'),
											A2(elm$html$Html$Attributes$style, 'width', pctStr + '%'),
											A2(elm$html$Html$Attributes$style, 'text-align', 'left'),
											A2(elm$html$Html$Attributes$style, 'z-index', '1'),
											A2(elm$html$Html$Attributes$attribute, 'role', 'progressbar'),
											A2(elm$html$Html$Attributes$attribute, 'aria-valuenow', pctStr),
											A2(elm$html$Html$Attributes$attribute, 'aria-valuemax', '100')
										]),
									_List_fromArray(
										[
											function () {
											if (route.$ === 1) {
												return elm$html$Html$span(_List_Nil);
											} else {
												var r = route.a;
												return elm$html$Html$a(
													_List_fromArray(
														[
															A2(
															author$project$Route$href,
															author$project$Session$query(session),
															r)
														]));
											}
										}()(
											_List_fromArray(
												[
													lang.q(
													A3(
														author$project$View$Lang$ViewCostNotMet,
														p,
														pct,
														A2(elm$core$Maybe$map, author$project$Game$Order$Progress$remaining, duration)))
												]))
										])),
									A2(
									elm$html$Html$div,
									_List_fromArray(
										[
											elm$html$Html$Attributes$class('progress-bar bg-danger'),
											A2(elm$html$Html$Attributes$style, 'width', tailStr + '%')
										]),
									_List_Nil)
								]));
					}
				},
				ps);
		}
	});
var author$project$View$BuyN$viewAscendCost = F3(
	function (session, game, item) {
		var progress = A2(
			author$project$Session$orderProgress,
			author$project$GameData$Item$name(item),
			session);
		if (((!progress.$) && progress.a.b) && (!progress.a.b.b)) {
			var _n1 = progress.a;
			var p = _n1.a;
			var _n2 = A2(
				author$project$GameData$unitByName,
				author$project$GameData$Unit$idToString(p.bS),
				author$project$Game$gameData(game));
			if (!_n2.$) {
				var currency = _n2.a;
				var _n3 = _Utils_Tuple2(currency.eZ, p.cE);
				if ((!_n3.a.$) && (_n3.b.$ === 1)) {
					var capExpr = _n3.a.a;
					var _n4 = _n3.b;
					var pct = _n4.a;
					var mduration = _n4.b;
					var cap = A3(
						author$project$Parser$Stat$evalWithDefault,
						author$project$Decimal$zero,
						author$project$Game$getGameVar(game),
						capExpr);
					return A2(author$project$Decimal$lt, cap, p.es) ? A4(
						author$project$View$BuyN$viewAscendCostExceedsCap,
						session,
						game,
						p,
						{c0: cap, dB: pct}) : A3(author$project$View$BuyN$viewCost2, session, game, progress);
				} else {
					return A3(author$project$View$BuyN$viewCost2, session, game, progress);
				}
			} else {
				return A3(author$project$View$BuyN$viewCost2, session, game, progress);
			}
		} else {
			return A3(author$project$View$BuyN$viewCost2, session, game, progress);
		}
	});
var author$project$View$Lang$ViewAscendBuyCost = F3(
	function (a, b, c) {
		return {$: 47, a: a, b: b, c: c};
	});
var author$project$View$Lang$ViewAscendPlot = {$: 46};
var author$project$View$Lang$ViewUnitAscend = {$: 41};
var author$project$View$BuyN$viewAscend = F4(
	function (session, game, order, ti) {
		var lang = A2(author$project$View$Lang$gameToLang, session, game);
		var button_ = order.ds ? A2(
			elm$html$Html$button,
			_List_fromArray(
				[
					elm$html$Html$Attributes$class('btn btn-success buy-button'),
					elm$html$Html$Attributes$type_('button'),
					elm$html$Html$Events$onClick(
					author$project$View$BuyN$ClickedAscend(order)),
					elm$html$Html$Attributes$tabindex(ti.fN)
				]),
			_List_fromArray(
				[
					author$project$View$Icon$fas('rocket'),
					elm$html$Html$text(' '),
					lang.q(author$project$View$Lang$ViewUnitAscend)
				])) : A2(
			elm$html$Html$button,
			_List_fromArray(
				[
					elm$html$Html$Attributes$class('btn btn-primary buy-button disabled'),
					elm$html$Html$Attributes$disabled(true),
					elm$html$Html$Attributes$tabindex(ti.fN)
				]),
			_List_fromArray(
				[
					author$project$View$Icon$fas('rocket'),
					elm$html$Html$text(' '),
					lang.q(author$project$View$Lang$ViewUnitAscend)
				]));
		return A2(
			elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							lang.q(author$project$View$Lang$ViewAscendPlot)
						])),
					A2(
					elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							lang.q(
							A3(
								author$project$View$Lang$ViewAscendBuyCost,
								order.et,
								order.es,
								author$project$Game$getGameVar(game)))
						])),
					A2(
					elm$html$Html$div,
					_List_Nil,
					A3(author$project$View$BuyN$viewAscendCost, session, game, order.eW)),
					button_
				]));
	});
var author$project$Game$costUI = A2(
	elm$core$Basics$composeR,
	author$project$Game$unwrap,
	function ($) {
		return $.aq;
	});
var author$project$View$BuyN$CostCollapsed = {$: 4};
var author$project$View$BuyN$CostExpanded = {$: 3};
var author$project$View$BuyN$GotInput = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var author$project$View$BuyN$helpModalId = 'help-modal';
var author$project$View$Lang$ViewCostMin = F2(
	function (a, b) {
		return {$: 120, a: a, b: b};
	});
var author$project$View$Lang$ViewSpellBuyCost = F3(
	function (a, b, c) {
		return {$: 45, a: a, b: b, c: c};
	});
var author$project$View$Lang$ViewUnitBuyCost = F3(
	function (a, b, c) {
		return {$: 35, a: a, b: b, c: c};
	});
var author$project$View$Lang$ViewUnitUpgradeBuyCost = function (a) {
	return {$: 38, a: a};
};
var author$project$View$BuyN$viewCost = F3(
	function (lang, order, min) {
		var _n0 = A2(
			author$project$Decimal$lt,
			author$project$GameData$Item$resToDec(order.et),
			author$project$Decimal$one) ? _Utils_Tuple2(
			elm$core$Result$Ok(1),
			order.c6) : _Utils_Tuple2(order.et, order.es);
		var count = _n0.a;
		var cost = _n0.b;
		return min ? _List_fromArray(
			[
				lang.q(
				A2(
					author$project$View$Lang$ViewCostMin,
					count,
					author$project$GameData$Item$id(order.eW)))
			]) : _List_fromArray(
			[
				function () {
				var _n1 = order.eW;
				switch (_n1.$) {
					case 0:
						var u = _n1.a;
						return lang.q(
							A3(author$project$View$Lang$ViewUnitBuyCost, count, u.eL, cost));
					case 1:
						var u = _n1.a;
						return lang.q(
							author$project$View$Lang$ViewUnitUpgradeBuyCost(order.c6));
					default:
						var s = _n1.a;
						return lang.q(
							A3(author$project$View$Lang$ViewSpellBuyCost, count, s.eL, cost));
				}
			}()
			]);
	});
var author$project$View$Lang$ViewBuyNFormatLink = {$: 203};
var author$project$View$Lang$ViewUnitBuyN = function (a) {
	return {$: 39, a: a};
};
var author$project$View$Lang$ViewUnitCantBuy = {$: 40};
var author$project$View$BuyN$viewBuyN = F4(
	function (session, game, order, ti) {
		var selectorOptions = _List_fromArray(
			['1%', '25%', '100%', '1']);
		var selectorBtn = A2(
			elm$html$Html$div,
			_List_fromArray(
				[
					elm$html$Html$Attributes$class('btn btn-outline-secondary dropdown-toggle'),
					elm$html$Html$Attributes$type_('button'),
					A2(elm$html$Html$Attributes$attribute, 'data-toggle', 'dropdown'),
					A2(elm$html$Html$Attributes$attribute, 'aria-haspopup', 'true')
				]),
			_List_Nil);
		var lang = A2(author$project$View$Lang$gameToLang, session, game);
		var isRequestValid = function () {
			var _n2 = order.cE;
			if (_n2.$ === 1) {
				return false;
			} else {
				return true;
			}
		}();
		var buyButton = order.ds ? A2(
			elm$html$Html$button,
			_List_fromArray(
				[
					elm$html$Html$Attributes$class('btn btn-secondary buy-button'),
					elm$html$Html$Attributes$type_('submit'),
					elm$html$Html$Attributes$tabindex(-1)
				]),
			_List_fromArray(
				[
					lang.q(
					author$project$View$Lang$ViewUnitBuyN(order.et))
				])) : A2(
			elm$html$Html$button,
			_List_fromArray(
				[
					elm$html$Html$Attributes$class('btn btn-outline-secondary buy-button disabled'),
					elm$html$Html$Attributes$type_('button'),
					elm$html$Html$Attributes$disabled(true),
					elm$html$Html$Attributes$tabindex(-1)
				]),
			_List_fromArray(
				[
					lang.q(author$project$View$Lang$ViewUnitCantBuy)
				]));
		var _n0 = A2(author$project$Game$buyN, order.eW, game);
		var inputText = _n0.a;
		var request = _n0.b;
		var selectorMenu = A2(
			elm$html$Html$div,
			_List_fromArray(
				[
					elm$html$Html$Attributes$class('dropdown-menu')
				]),
			_Utils_ap(
				A2(
					elm$core$List$map,
					function (val) {
						return A2(
							elm$html$Html$button,
							_List_fromArray(
								[
									elm$html$Html$Attributes$class('dropdown-item'),
									elm$html$Html$Attributes$type_('button'),
									elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'active',
											_Utils_eq(val, inputText))
										])),
									elm$html$Html$Events$onClick(
									A2(author$project$View$BuyN$GotInput, order.eW, val))
								]),
							_List_fromArray(
								[
									elm$html$Html$text(val)
								]));
					},
					A2(
						elm$core$List$cons,
						inputText,
						A2(
							elm$core$List$filter,
							elm$core$Basics$neq(inputText),
							selectorOptions))),
				_List_fromArray(
					[
						A2(
						elm$html$Html$button,
						_List_fromArray(
							[
								elm$html$Html$Attributes$class('dropdown-item'),
								elm$html$Html$Attributes$type_('button'),
								A2(elm$html$Html$Attributes$attribute, 'data-toggle', 'modal'),
								A2(elm$html$Html$Attributes$attribute, 'data-target', '#' + author$project$View$BuyN$helpModalId)
							]),
						_List_fromArray(
							[
								author$project$View$Icon$fas('question-circle'),
								elm$html$Html$text(' '),
								lang.q(author$project$View$Lang$ViewBuyNFormatLink)
							]))
					])));
		var textInput = A2(
			elm$html$Html$input,
			_List_fromArray(
				[
					elm$html$Html$Attributes$type_('text'),
					elm$html$Html$Attributes$class('form-control'),
					elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('is-invalid', !isRequestValid)
						])),
					elm$html$Html$Attributes$value(inputText),
					elm$html$Html$Events$onInput(
					author$project$View$BuyN$GotInput(order.eW)),
					elm$html$Html$Attributes$tabindex(ti.fN)
				]),
			_List_Nil);
		return A2(
			elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					function () {
					var _n1 = author$project$Game$costUI(game);
					if (_n1 === 1) {
						return A2(
							elm$html$Html$p,
							_List_Nil,
							_Utils_ap(
								A3(author$project$View$BuyN$viewCost, lang, order, false),
								_List_fromArray(
									[
										A2(
										elm$html$Html$button,
										_List_fromArray(
											[
												elm$html$Html$Attributes$class('btn btn-link'),
												elm$html$Html$Events$onClick(author$project$View$BuyN$CostExpanded)
											]),
										_List_fromArray(
											[
												author$project$View$Icon$fas('chevron-down')
											]))
									])));
					} else {
						return A2(
							elm$html$Html$div,
							_List_Nil,
							_Utils_ap(
								A3(author$project$View$BuyN$viewCost, lang, order, true),
								_Utils_ap(
									_List_fromArray(
										[
											A2(
											elm$html$Html$button,
											_List_fromArray(
												[
													elm$html$Html$Attributes$class('btn btn-link'),
													elm$html$Html$Events$onClick(author$project$View$BuyN$CostCollapsed)
												]),
											_List_fromArray(
												[
													author$project$View$Icon$fas('chevron-up')
												]))
										]),
									A3(
										author$project$View$BuyN$viewCost2,
										session,
										game,
										A2(
											author$project$Session$orderProgress,
											author$project$GameData$Item$name(order.eW),
											session)))));
					}
				}(),
					A2(
					elm$html$Html$form,
					_List_fromArray(
						[
							elm$html$Html$Attributes$class('input-group'),
							elm$html$Html$Events$onSubmit(
							author$project$View$BuyN$ClickedBuy(order))
						]),
					_List_fromArray(
						[
							A2(
							elm$html$Html$div,
							_List_fromArray(
								[
									elm$html$Html$Attributes$class('dropdown input-group-prepend')
								]),
							_List_fromArray(
								[selectorBtn, selectorMenu])),
							textInput,
							A2(
							elm$html$Html$div,
							_List_fromArray(
								[
									elm$html$Html$Attributes$class('input-group-append')
								]),
							_List_fromArray(
								[buyButton]))
						]))
				]));
	});
var author$project$View$BuyN$viewRespec = F4(
	function (session, game, order, ti) {
		var lang = A2(author$project$View$Lang$gameToLang, session, game);
		var button_ = order.ds ? A2(
			elm$html$Html$button,
			_List_fromArray(
				[
					elm$html$Html$Attributes$class('btn btn-success buy-button'),
					elm$html$Html$Events$onClick(
					author$project$View$BuyN$ClickedBuy(order)),
					elm$html$Html$Attributes$tabindex(ti.fN)
				]),
			_List_fromArray(
				[
					lang.q(
					author$project$View$Lang$ViewUnitBuyN(order.et))
				])) : A2(
			elm$html$Html$button,
			_List_fromArray(
				[
					elm$html$Html$Attributes$class('btn btn-primary buy-button disabled'),
					elm$html$Html$Attributes$disabled(true),
					elm$html$Html$Attributes$tabindex(ti.fN)
				]),
			_List_fromArray(
				[
					lang.q(author$project$View$Lang$ViewUnitCantBuy)
				]));
		return A2(
			elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					function () {
					var _n0 = author$project$Game$costUI(game);
					if (_n0 === 1) {
						return A2(
							elm$html$Html$p,
							_List_Nil,
							_Utils_ap(
								A3(author$project$View$BuyN$viewCost, lang, order, false),
								_List_fromArray(
									[
										A2(
										elm$html$Html$button,
										_List_fromArray(
											[
												elm$html$Html$Attributes$class('btn btn-link'),
												elm$html$Html$Events$onClick(author$project$View$BuyN$CostExpanded)
											]),
										_List_fromArray(
											[
												author$project$View$Icon$fas('chevron-down')
											]))
									])));
					} else {
						return A2(
							elm$html$Html$div,
							_List_Nil,
							_Utils_ap(
								A3(author$project$View$BuyN$viewCost, lang, order, true),
								_Utils_ap(
									_List_fromArray(
										[
											A2(
											elm$html$Html$button,
											_List_fromArray(
												[
													elm$html$Html$Attributes$class('btn btn-link'),
													elm$html$Html$Events$onClick(author$project$View$BuyN$CostCollapsed)
												]),
											_List_fromArray(
												[
													author$project$View$Icon$fas('chevron-up')
												]))
										]),
									A3(
										author$project$View$BuyN$viewCost2,
										session,
										game,
										A2(
											author$project$Session$orderProgress,
											author$project$GameData$Item$name(order.eW),
											session)))));
					}
				}(),
					button_
				]));
	});
var author$project$View$BuyN$view = F5(
	function (session, game, snap, orderResult, ti) {
		if (orderResult.$ === 1) {
			return elm$core$Maybe$Nothing;
		} else {
			var order = orderResult.a;
			return elm$core$Maybe$Just(
				function () {
					var view_ = function (u) {
						return u.e9.cX ? A4(author$project$View$BuyN$viewAscend, session, game, order, ti) : ((!elm$core$List$isEmpty(u.e9.dR)) ? A4(author$project$View$BuyN$viewRespec, session, game, order, ti) : A4(author$project$View$BuyN$viewBuyN, session, game, order, ti));
					};
					var _n1 = order.eW;
					switch (_n1.$) {
						case 0:
							var u = _n1.a;
							return view_(u);
						case 1:
							var u = _n1.a;
							return view_(u);
						default:
							var s = _n1.a;
							return view_(s);
					}
				}());
		}
	});
var author$project$View$Lang$ViewBuyNFormatClose = {$: 205};
var author$project$View$Lang$ViewBuyNFormatTitle = {$: 204};
var author$project$View$Lang$text = elm$html$Html$text;
var elm$html$Html$s = _VirtualDom_node('s');
var author$project$View$BuyN$viewHelpModal = function (lang) {
	var example = function (n) {
		return elm$html$Html$text('\"' + (n + '\"'));
	};
	return A2(
		elm$html$Html$div,
		_List_fromArray(
			[
				elm$html$Html$Attributes$class('modal fade'),
				elm$html$Html$Attributes$id(author$project$View$BuyN$helpModalId),
				elm$html$Html$Attributes$tabindex(-1),
				A2(elm$html$Html$Attributes$attribute, 'role', 'dialog'),
				A2(elm$html$Html$Attributes$attribute, 'aria-hidden', 'true')
			]),
		_List_fromArray(
			[
				A2(
				elm$html$Html$div,
				_List_fromArray(
					[
						elm$html$Html$Attributes$class('modal-dialog'),
						A2(elm$html$Html$Attributes$attribute, 'role', 'document')
					]),
				_List_fromArray(
					[
						A2(
						elm$html$Html$div,
						_List_fromArray(
							[
								elm$html$Html$Attributes$class('modal-content')
							]),
						_List_fromArray(
							[
								A2(
								elm$html$Html$div,
								_List_fromArray(
									[
										elm$html$Html$Attributes$class('modal-header')
									]),
								_List_fromArray(
									[
										A2(
										elm$html$Html$h5,
										_List_fromArray(
											[
												elm$html$Html$Attributes$class('modal-title')
											]),
										_List_fromArray(
											[
												author$project$View$Icon$fas('question-circle'),
												elm$html$Html$text(' '),
												lang.q(author$project$View$Lang$ViewBuyNFormatTitle)
											])),
										A2(
										elm$html$Html$button,
										_List_fromArray(
											[
												elm$html$Html$Attributes$class('close'),
												A2(elm$html$Html$Attributes$attribute, 'data-dismiss', 'modal'),
												A2(elm$html$Html$Attributes$attribute, 'aria-label', 'close')
											]),
										_List_fromArray(
											[
												elm$html$Html$text('×')
											]))
									])),
								A2(
								elm$html$Html$div,
								_List_fromArray(
									[
										elm$html$Html$Attributes$class('modal-body')
									]),
								_List_fromArray(
									[
										A2(
										elm$html$Html$ul,
										_List_fromArray(
											[
												elm$html$Html$Attributes$class('list-group list-group-flush')
											]),
										_List_fromArray(
											[
												A2(
												elm$html$Html$li,
												_List_fromArray(
													[
														elm$html$Html$Attributes$class('list-group-item')
													]),
												_List_fromArray(
													[
														example('10%'),
														author$project$View$Lang$text(' buys as many as possible with up to 10% of your money.')
													])),
												A2(
												elm$html$Html$li,
												_List_fromArray(
													[
														elm$html$Html$Attributes$class('list-group-item')
													]),
												_List_fromArray(
													[
														example('123'),
														author$project$View$Lang$text(' buys 123 '),
														A2(
														elm$html$Html$i,
														_List_Nil,
														_List_fromArray(
															[
																elm$html$Html$text('before')
															])),
														elm$html$Html$text(' considering twin upgrades, or fails to buy anything. If you have 1 twin upgrade, this will buy 246.')
													])),
												A2(
												elm$html$Html$li,
												_List_fromArray(
													[
														elm$html$Html$Attributes$class('list-group-item')
													]),
												_List_fromArray(
													[
														example('=123'),
														author$project$View$Lang$text(' buys 123 or more '),
														A2(
														elm$html$Html$i,
														_List_Nil,
														_List_fromArray(
															[
																elm$html$Html$text('after')
															])),
														elm$html$Html$text(' considering twin upgrades, rounded up, or fails to buy anything. If you have 1 twin upgrade, this will buy 124.')
													])),
												A2(
												elm$html$Html$li,
												_List_fromArray(
													[
														elm$html$Html$Attributes$class('list-group-item')
													]),
												_List_fromArray(
													[
														example('@123'),
														author$project$View$Lang$text(' buys the number needed to have a total of 123. If you already have 23, this will buy 100.')
													])),
												A2(
												elm$html$Html$li,
												_List_fromArray(
													[
														elm$html$Html$Attributes$class('list-group-item')
													]),
												_List_fromArray(
													[
														author$project$View$Lang$text('Numbers with suffixes work - '),
														example('23e9'),
														A2(
														elm$html$Html$s,
														_List_Nil,
														_List_fromArray(
															[
																author$project$View$Lang$text(', '),
																example('23 billion'),
																author$project$View$Lang$text(', or '),
																example('23b'),
																author$project$View$Lang$text('.')
															]))
													]))
											]))
									])),
								A2(
								elm$html$Html$div,
								_List_fromArray(
									[
										elm$html$Html$Attributes$class('modal-footer')
									]),
								_List_fromArray(
									[
										A2(
										elm$html$Html$button,
										_List_fromArray(
											[
												elm$html$Html$Attributes$class('btn btn-primary'),
												A2(elm$html$Html$Attributes$attribute, 'data-dismiss', 'modal'),
												A2(elm$html$Html$Attributes$attribute, 'aria-label', 'close')
											]),
										_List_fromArray(
											[
												lang.q(author$project$View$Lang$ViewBuyNFormatClose)
											]))
									]))
							]))
					]))
			]));
};
var author$project$View$Description$Cocoon$capHref = function (game) {
	return A2(
		elm$core$Result$map,
		function (c) {
			return A3(
				author$project$Route$Unit,
				'larva',
				'cocoon',
				{
					dz: elm$core$Maybe$Just(
						'@' + author$project$Decimal$toString(c))
				});
		},
		A2(author$project$View$DescriptionVars$evalVar, game, 'clonelarvae.add.larva.cap'));
};
var author$project$View$Lang$DescCloneLarvae1 = function (a) {
	return {$: 217, a: a};
};
var author$project$View$Lang$DescCloneLarvae2 = F3(
	function (a, b, c) {
		return {$: 218, a: a, b: b, c: c};
	});
var author$project$View$Lang$DescCloneLarvae3 = function (a) {
	return {$: 219, a: a};
};
var author$project$View$Description$CloneLarvae$view = F3(
	function (session, game, spell) {
		var query = author$project$Session$query(session);
		var lang = A2(author$project$View$Lang$gameToLang, session, game);
		return A2(
			elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							lang.q(
							author$project$View$Lang$DescCloneLarvae1(
								author$project$View$DescriptionVars$evalVar(game)))
						])),
					A2(
					elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							lang.q(
							A3(
								author$project$View$Lang$DescCloneLarvae2,
								query,
								author$project$View$Description$Cocoon$capHref(game),
								author$project$View$DescriptionVars$evalVar(game)))
						])),
					A2(
					elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							lang.q(
							author$project$View$Lang$DescCloneLarvae3(
								author$project$View$DescriptionVars$evalVar(game)))
						]))
				]));
	});
var author$project$View$Lang$DescCocoon1 = {$: 214};
var author$project$View$Lang$DescCocoon2 = function (a) {
	return {$: 215, a: a};
};
var author$project$View$Lang$DescCocoon3 = F3(
	function (a, b, c) {
		return {$: 216, a: a, b: b, c: c};
	});
var author$project$View$Description$Cocoon$view = F3(
	function (session, game, unit) {
		var query = author$project$Session$query(session);
		var lang = A2(author$project$View$Lang$gameToLang, session, game);
		return A2(
			elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							lang.q(author$project$View$Lang$DescCocoon1)
						])),
					A2(
					elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							lang.q(
							author$project$View$Lang$DescCocoon2(query))
						])),
					A2(
					elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							lang.q(
							A3(
								author$project$View$Lang$DescCocoon3,
								query,
								author$project$View$Description$Cocoon$capHref(game),
								author$project$View$DescriptionVars$evalVar(game)))
						]))
				]));
	});
var author$project$View$Lang$ViewEnergyLinkCrystals = {$: 202};
var author$project$View$Description$Energy$view = F3(
	function (session, game, unit) {
		var lang = A2(author$project$View$Lang$gameToLang, session, game);
		return A2(
			elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					lang.q(
					A2(
						author$project$View$Lang$UnitDesc,
						author$project$View$DescriptionVars$evalVar(game),
						unit.eL)),
					A2(
					elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							elm$html$Html$a,
							_List_fromArray(
								[
									A2(
									author$project$Route$href,
									author$project$Session$query(session),
									A2(author$project$Route$unit, 'energy', 'crystal'))
								]),
							_List_fromArray(
								[
									lang.q(author$project$View$Lang$ViewEnergyLinkCrystals)
								]))
						]))
				]));
	});
var author$project$Decimal$epsilon = author$project$Decimal$fromFloat(author$project$Decimal$epsilonF);
var author$project$View$Description$Hatchery$MutagenAlmost = function (a) {
	return {$: 1, a: a};
};
var author$project$View$Description$Hatchery$MutagenNotReady = {$: 2};
var author$project$View$Description$Hatchery$MutagenReady = function (a) {
	return {$: 0, a: a};
};
var author$project$View$Description$Hatchery$two = author$project$Decimal$fromInt(2);
var author$project$View$Description$Hatchery$mutagenStats = F2(
	function (game, parentCount) {
		return A2(
			elm$core$Basics$composeR,
			elm$core$List$head,
			A2(
				elm$core$Basics$composeR,
				elm$core$Maybe$map(
					function (d) {
						return A2(
							author$project$Decimal$gte,
							A2(author$project$Decimal$add, author$project$Decimal$epsilon, parentCount),
							author$project$Decimal$fromInt(d.e1)) ? author$project$View$Description$Hatchery$MutagenReady(
							{
								eo: author$project$Decimal$toFloat(
									A3(
										author$project$Parser$Stat$evalWithDefault,
										author$project$Decimal$zero,
										author$project$Game$getGameVar(game),
										d.eo)),
								et: A3(
									author$project$Parser$Stat$evalWithDefault,
									author$project$Decimal$zero,
									author$project$Game$getGameVar(game),
									d.et)
							}) : (A2(
							author$project$Decimal$gte,
							A2(author$project$Decimal$add, author$project$Decimal$epsilon, parentCount),
							A2(
								author$project$Decimal$flipDiv,
								author$project$View$Description$Hatchery$two,
								author$project$Decimal$fromInt(d.e1))) ? author$project$View$Description$Hatchery$MutagenAlmost(
							{
								et: parentCount,
								d0: author$project$Decimal$fromInt(d.e1)
							}) : author$project$View$Description$Hatchery$MutagenNotReady);
					}),
				elm$core$Maybe$withDefault(author$project$View$Description$Hatchery$MutagenNotReady)));
	});
var author$project$View$Lang$DescHatcheryMutagen = F2(
	function (a, b) {
		return {$: 211, a: a, b: b};
	});
var author$project$View$Lang$DescHatcheryMutagenLol = {$: 212};
var author$project$View$Lang$DescHatcheryMutagenUnlock = F2(
	function (a, b) {
		return {$: 213, a: a, b: b};
	});
var author$project$View$Description$Hatchery$viewMutagenStats = F3(
	function (lang, id, state) {
		switch (state.$) {
			case 0:
				var mutagen = state.a;
				return A2(
					elm$html$Html$p,
					_List_fromArray(
						[
							elm$html$Html$Attributes$title(
							lang.fH(author$project$View$Lang$DescHatcheryMutagenLol))
						]),
					_List_fromArray(
						[
							lang.q(
							A2(author$project$View$Lang$DescHatcheryMutagen, id, mutagen))
						]));
			case 1:
				var mutagen = state.a;
				var percent = author$project$Decimal$toFloat(
					A2(author$project$Decimal$div, mutagen.et, mutagen.d0));
				var percentStr = elm$core$String$fromInt(
					elm$core$Basics$floor(100 * percent)) + '%';
				return A2(
					elm$html$Html$p,
					_List_fromArray(
						[
							elm$html$Html$Attributes$class('progress')
						]),
					_List_fromArray(
						[
							A2(
							elm$html$Html$div,
							_List_fromArray(
								[
									elm$html$Html$Attributes$class('progress-bar'),
									A2(elm$html$Html$Attributes$style, 'width', percentStr)
								]),
							_List_fromArray(
								[
									lang.q(
									A2(author$project$View$Lang$DescHatcheryMutagenUnlock, id, mutagen))
								]))
						]));
			default:
				return A2(elm$html$Html$p, _List_Nil, _List_Nil);
		}
	});
var author$project$View$Description$Hatchery$view = F3(
	function (session, game, unit) {
		var mutagen = A3(
			author$project$View$Description$Hatchery$mutagenStats,
			game,
			A2(author$project$Game$unitCount, unit.eL, game),
			unit.e9.bM);
		var lang = A2(author$project$View$Lang$gameToLang, session, game);
		var crystal = A3(author$project$View$Description$Hatchery$crystalStats, session, game, unit.e9.bP);
		return A2(
			elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							lang.q(
							A2(
								author$project$View$Lang$UnitDesc,
								author$project$View$DescriptionVars$evalVar(game),
								unit.eL))
						])),
					A3(
					author$project$View$Description$Hatchery$viewMutagenStats,
					lang,
					author$project$GameData$Item$Id$UnitId(unit.eL),
					mutagen),
					A2(
					elm$html$Html$p,
					_List_Nil,
					A3(
						elm_community$maybe_extra$Maybe$Extra$unwrap,
						_List_Nil,
						A2(
							elm$core$Basics$composeR,
							author$project$View$Lang$DescHatcheryCrystals(
								author$project$GameData$Item$Id$UnitId(unit.eL)),
							A2(elm$core$Basics$composeR, lang.q, elm$core$List$singleton)),
						crystal))
				]));
	});
var author$project$View$Lang$UpgradeDesc = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var author$project$View$Description$Hatchery$viewExpansion = F3(
	function (session, game, upgrade) {
		var mutagen = A3(
			author$project$View$Description$Hatchery$mutagenStats,
			game,
			A2(author$project$Game$upgradeCount, upgrade.eL, game),
			upgrade.e9.bM);
		var lang = A2(author$project$View$Lang$gameToLang, session, game);
		var crystal = A3(author$project$View$Description$Hatchery$crystalStats, session, game, upgrade.e9.bP);
		return A2(
			elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							lang.q(
							A2(
								author$project$View$Lang$UpgradeDesc,
								author$project$View$DescriptionVars$evalVar(game),
								upgrade.eL))
						])),
					A3(
					author$project$View$Description$Hatchery$viewMutagenStats,
					lang,
					author$project$GameData$Item$Id$UpgradeId(upgrade.eL),
					mutagen),
					A2(
					elm$html$Html$p,
					_List_Nil,
					A3(
						elm_community$maybe_extra$Maybe$Extra$unwrap,
						_List_Nil,
						A2(
							elm$core$Basics$composeR,
							author$project$View$Lang$DescHatcheryCrystals(
								author$project$GameData$Item$Id$UpgradeId(upgrade.eL)),
							A2(elm$core$Basics$composeR, lang.q, elm$core$List$singleton)),
						crystal))
				]));
	});
var author$project$GameData$Tab$Id$fromString = elm$core$Basics$identity;
var author$project$View$Lang$DescMutantMeatProd = F2(
	function (a, b) {
		return {$: 208, a: a, b: b};
	});
var author$project$View$Description$MutantMeat$view = F2(
	function (session, game) {
		var units = A2(
			elm$core$List$filter,
			function (u) {
				return A2(
					author$project$Game$UnitsSnapshot$isUnitVisible,
					u.eL,
					author$project$Game$units(game));
			},
			A2(
				author$project$GameData$unitsByTabId,
				author$project$GameData$Tab$Id$fromString('meat'),
				author$project$Game$gameData(game)));
		var lang = A2(author$project$View$Lang$gameToLang, session, game);
		var viewBonus = function (_n0) {
			var u = _n0.a;
			var b = _n0.b;
			return A2(
				elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						lang.q(
						A2(author$project$View$Lang$DescMutantMeatProd, u.eL, b))
					]));
		};
		var gd = author$project$Game$gameData(game);
		var bonus = function (unit) {
			return A2(
				elm$core$Maybe$andThen,
				A2(
					elm$core$Basics$composeR,
					elm$core$Tuple$second,
					A2(
						elm$core$Basics$composeR,
						A2(
							author$project$Parser$Stat$evalFullWithDefault,
							author$project$Decimal$zero,
							author$project$Game$getGameVar(game)),
						A2(
							elm$core$Basics$composeR,
							function ($) {
								return $.dh;
							},
							elm$core$Dict$get('mutation')))),
				unit.fl);
		};
		var bonuses = A2(
			elm$core$List$filterMap,
			function (u) {
				return A2(
					elm$core$Maybe$map,
					elm$core$Tuple$pair(u),
					bonus(u));
			},
			units);
		return A2(
			elm$html$Html$p,
			_List_Nil,
			A2(elm$core$List$map, viewBonus, bonuses));
	});
var author$project$View$Description$Territory$PieChart$Radians = elm$core$Basics$identity;
var author$project$View$Description$Territory$PieChart$Slice = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var author$project$View$Description$Territory$PieChart$slices = function (increments) {
	var totalN = function (n) {
		return elm$core$List$sum(
			A2(
				elm$core$List$map,
				function (_n0) {
					var r = _n0;
					return r;
				},
				A2(elm$core$List$take, n, increments)));
	};
	return A2(
		elm$core$List$indexedMap,
		function (n) {
			return author$project$View$Description$Territory$PieChart$Slice(
				totalN(n));
		},
		increments);
};
var elm$core$Basics$pi = _Basics_pi;
var elm$core$Basics$turns = function (angleInTurns) {
	return (2 * elm$core$Basics$pi) * angleInTurns;
};
var author$project$View$Description$Territory$PieChart$turns = A2(elm$core$Basics$composeR, elm$core$Basics$turns, elm$core$Basics$identity);
var elm$core$Basics$cos = _Basics_cos;
var elm$core$Basics$sin = _Basics_sin;
var elm$core$Basics$fromPolar = function (_n0) {
	var radius = _n0.a;
	var theta = _n0.b;
	return _Utils_Tuple2(
		radius * elm$core$Basics$cos(theta),
		radius * elm$core$Basics$sin(theta));
};
var elm$svg$Svg$trustedNode = _VirtualDom_nodeNS('http://www.w3.org/2000/svg');
var elm$svg$Svg$path = elm$svg$Svg$trustedNode('path');
var elm$svg$Svg$text = elm$virtual_dom$VirtualDom$text;
var elm$svg$Svg$title = elm$svg$Svg$trustedNode('title');
var elm$svg$Svg$Attributes$class = _VirtualDom_attribute('class');
var elm$svg$Svg$Attributes$d = _VirtualDom_attribute('d');
var author$project$View$Description$Territory$PieChart$viewArc = F3(
	function (class_, label, _n0) {
		var angle0 = _n0.a;
		var dAngle = _n0.b;
		var largeArc = (_Utils_cmp(
			dAngle,
			elm$core$Basics$turns(0.5)) > 0) ? '1' : '0';
		var _n1 = elm$core$Basics$fromPolar(
			_Utils_Tuple2(1, angle0 + dAngle));
		var x1 = _n1.a;
		var y1 = _n1.b;
		var _n2 = elm$core$Basics$fromPolar(
			_Utils_Tuple2(1, angle0));
		var x0 = _n2.a;
		var y0 = _n2.b;
		var d = A2(
			elm$core$String$join,
			' ',
			_List_fromArray(
				[
					'M',
					elm$core$String$fromFloat(x0),
					elm$core$String$fromFloat(y0),
					'A 1 1 0',
					largeArc,
					'1',
					elm$core$String$fromFloat(x1),
					elm$core$String$fromFloat(y1),
					'L 0 0'
				]));
		return A2(
			elm$svg$Svg$path,
			_List_fromArray(
				[
					elm$svg$Svg$Attributes$d(d),
					elm$svg$Svg$Attributes$class(class_)
				]),
			_List_fromArray(
				[
					A2(
					elm$svg$Svg$title,
					_List_Nil,
					_List_fromArray(
						[
							elm$svg$Svg$text(label)
						]))
				]));
	});
var elm$svg$Svg$svg = elm$svg$Svg$trustedNode('svg');
var elm$svg$Svg$Attributes$height = _VirtualDom_attribute('height');
var elm$svg$Svg$Attributes$viewBox = _VirtualDom_attribute('viewBox');
var elm$svg$Svg$Attributes$width = _VirtualDom_attribute('width');
var author$project$View$Description$Territory$PieChart$view = function (labeledTurns) {
	var turns_ = A2(elm$core$List$map, elm$core$Tuple$second, labeledTurns);
	var slices_ = author$project$View$Description$Territory$PieChart$slices(
		A2(elm$core$List$map, author$project$View$Description$Territory$PieChart$turns, turns_));
	var labels = A2(elm$core$List$map, elm$core$Tuple$first, labeledTurns);
	var labeledSlices = A3(elm$core$List$map2, elm$core$Tuple$pair, labels, slices_);
	return A2(
		elm$svg$Svg$svg,
		_List_fromArray(
			[
				elm$svg$Svg$Attributes$width('300'),
				elm$svg$Svg$Attributes$height('300'),
				elm$svg$Svg$Attributes$viewBox('-1.2 -1.2 2.4 2.4')
			]),
		A2(
			elm$core$List$indexedMap,
			F2(
				function (i, _n0) {
					var l = _n0.a;
					var s = _n0.b;
					return A3(
						author$project$View$Description$Territory$PieChart$viewArc,
						'pie-' + elm$core$String$fromInt(i),
						l,
						s);
				}),
			labeledSlices));
};
var author$project$View$Lang$DescTerritoryLegendEntry = F2(
	function (a, b) {
		return {$: 209, a: a, b: b};
	});
var author$project$View$Description$Territory$view = F3(
	function (session, game, unit) {
		var snap = author$project$Game$units(game);
		var prods = A2(
			elm$core$List$map,
			function (_n7) {
				var u = _n7.a;
				var _n8 = _n7.b;
				var p = _n8.b;
				return _Utils_Tuple2(
					u,
					function () {
						var each = A3(
							author$project$Parser$Stat$evalWithDefault,
							author$project$Decimal$zero,
							author$project$Game$getGameVar(game),
							p);
						var count = A2(author$project$Game$UnitsSnapshot$count, u.eL, snap);
						return A2(author$project$Decimal$mul, each, count);
					}());
			},
			A2(
				elm$core$List$filter,
				function (_n5) {
					var u = _n5.a;
					var _n6 = _n5.b;
					var p = _n6.a;
					return (author$project$GameData$Unit$idToString(p) === 'territory') && A2(author$project$Game$UnitsSnapshot$isUnitVisible, u.eL, snap);
				},
				A2(
					elm$core$List$filterMap,
					function (u) {
						return A2(
							elm$core$Maybe$map,
							elm$core$Tuple$pair(u),
							u.fl);
					},
					author$project$GameData$units(
						author$project$Game$gameData(game)))));
		var total = author$project$Decimal$sum(
			A2(elm$core$List$map, elm$core$Tuple$second, prods));
		var percents = A2(
			elm$core$List$sortBy,
			function (_n4) {
				var pct = _n4.c;
				return -pct;
			},
			A2(
				elm$core$List$filter,
				function (_n3) {
					var pct = _n3.c;
					return pct > 1.0e-2;
				},
				A2(
					elm$core$List$map,
					function (_n2) {
						var u = _n2.a;
						var prod = _n2.b;
						return _Utils_Tuple3(
							u,
							prod,
							author$project$Decimal$toFloat(
								A2(
									author$project$Decimal$div,
									prod,
									A2(author$project$Decimal$max, author$project$Decimal$one, total))));
					},
					prods)));
		var lang = A2(author$project$View$Lang$gameToLang, session, game);
		return A2(
			elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					lang.q(
					A2(
						author$project$View$Lang$UnitDesc,
						author$project$View$DescriptionVars$evalVar(game),
						unit.eL)),
					A2(
					elm$html$Html$ul,
					_List_fromArray(
						[
							elm$html$Html$Attributes$class('legend')
						]),
					A2(
						elm$core$List$indexedMap,
						F2(
							function (index, _n0) {
								var u = _n0.a;
								var prod = _n0.b;
								var percent = _n0.c;
								return A2(
									elm$html$Html$li,
									_List_fromArray(
										[
											elm$html$Html$Attributes$class(
											'entry entry-' + elm$core$String$fromInt(index))
										]),
									_List_fromArray(
										[
											A2(
											elm$html$Html$span,
											_List_fromArray(
												[
													elm$html$Html$Attributes$class('dot')
												]),
											_List_fromArray(
												[
													author$project$View$Icon$fas('circle')
												])),
											lang.q(
											A2(author$project$View$Lang$DescTerritoryLegendEntry, u.eL, percent))
										]));
							}),
						percents)),
					author$project$View$Description$Territory$PieChart$view(
					A2(
						elm$core$List$map,
						function (_n1) {
							var u = _n1.a;
							var percent = _n1.c;
							return _Utils_Tuple2(
								lang.fH(
									A2(author$project$View$Lang$DescTerritoryLegendEntry, u.eL, percent)),
								percent);
						},
						percents))
				]));
	});
var author$project$View$Description$view = F3(
	function (session, game, item) {
		var _n0 = _Utils_Tuple2(
			author$project$GameData$Item$name(item),
			item);
		_n0$7:
		while (true) {
			switch (_n0.a) {
				case 'mutantmeat':
					return elm$core$Maybe$Just(
						A2(author$project$View$Description$MutantMeat$view, session, game));
				case 'energy':
					if (!_n0.b.$) {
						var u = _n0.b.a;
						return elm$core$Maybe$Just(
							A3(author$project$View$Description$Energy$view, session, game, u));
					} else {
						break _n0$7;
					}
				case 'territory':
					if (!_n0.b.$) {
						var u = _n0.b.a;
						return elm$core$Maybe$Just(
							A3(author$project$View$Description$Territory$view, session, game, u));
					} else {
						break _n0$7;
					}
				case 'hatchery':
					if (!_n0.b.$) {
						var u = _n0.b.a;
						return elm$core$Maybe$Just(
							A3(author$project$View$Description$Hatchery$view, session, game, u));
					} else {
						break _n0$7;
					}
				case 'expansion':
					if (_n0.b.$ === 1) {
						var u = _n0.b.a;
						return elm$core$Maybe$Just(
							A3(author$project$View$Description$Hatchery$viewExpansion, session, game, u));
					} else {
						break _n0$7;
					}
				case 'cocoon':
					if (!_n0.b.$) {
						var u = _n0.b.a;
						return elm$core$Maybe$Just(
							A3(author$project$View$Description$Cocoon$view, session, game, u));
					} else {
						break _n0$7;
					}
				case 'clonelarvae':
					if (_n0.b.$ === 2) {
						var s = _n0.b.a;
						return elm$core$Maybe$Just(
							A3(author$project$View$Description$CloneLarvae$view, session, game, s));
					} else {
						break _n0$7;
					}
				default:
					break _n0$7;
			}
		}
		return elm$core$Maybe$Nothing;
	});
var author$project$View$Lang$SpellDesc = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var author$project$View$Lang$ViewSpellHeader = function (a) {
	return {$: 44, a: a};
};
var author$project$Page$Spell$viewSpell = F5(
	function (stab, session, game, snapshot, spell) {
		var tabSlug = author$project$Select$tabToSlug(stab);
		var query = author$project$Session$query(session);
		var order = A3(
			author$project$Game$Order$fromBuyN,
			game,
			snapshot,
			author$project$GameData$Item$Spell(spell));
		var lang = A2(author$project$View$Lang$gameToLang, session, game);
		return _List_fromArray(
			[
				A2(
				elm$html$Html$h3,
				_List_Nil,
				_List_fromArray(
					[
						A2(author$project$Route$Feature$isActive, 5, query) ? author$project$View$Device$onlyMobileInline(
						_List_fromArray(
							[
								A2(
								elm$html$Html$a,
								_List_fromArray(
									[
										A2(
										author$project$Route$href,
										query,
										author$project$Route$Tab(tabSlug))
									]),
								_List_fromArray(
									[
										author$project$View$Icon$fas('bars'),
										elm$html$Html$text(' ')
									]))
							])) : A2(elm$html$Html$span, _List_Nil, _List_Nil),
						lang.q(
						author$project$View$Lang$ViewSpellHeader(spell.eL))
					])),
				A2(
				elm$html$Html$div,
				_List_fromArray(
					[
						elm$html$Html$Attributes$class('desc-icon-resource'),
						elm$html$Html$Attributes$class(
						'desc-icon-' + author$project$GameData$Spell$name(spell)),
						elm$html$Html$Attributes$class(
						'icon-' + author$project$GameData$Spell$name(spell))
					]),
				_List_Nil),
				function () {
				var _n0 = A3(
					author$project$View$Description$view,
					session,
					game,
					author$project$GameData$Item$Spell(spell));
				if (!_n0.$) {
					var html = _n0.a;
					return html;
				} else {
					return lang.q(
						A2(
							author$project$View$Lang$SpellDesc,
							author$project$View$DescriptionVars$evalVar(game),
							spell.eL));
				}
			}(),
				A2(
				elm$html$Html$map,
				author$project$Page$Spell$GotBuyNMsg,
				A2(
					elm$core$Maybe$withDefault,
					A2(elm$html$Html$div, _List_Nil, _List_Nil),
					A5(
						author$project$View$BuyN$view,
						session,
						game,
						snapshot,
						order,
						{fN: 1}))),
				author$project$View$BuyN$viewHelpModal(lang)
			]);
	});
var author$project$Page$Spell$view = F2(
	function (_n0, game) {
		var tabSlug = _n0.a;
		var spellSlug = _n0.b;
		var session = _n0.c;
		return A3(
			author$project$View$NotReady$viewResult,
			session,
			author$project$Game$gameData(game),
			function () {
				var snap = A2(author$project$Session$safeUnits, game, session);
				var _n1 = _Utils_Tuple2(
					A3(author$project$Select$tabBySlug, tabSlug, game, snap),
					A3(author$project$Select$spellBySlug, spellSlug, game, snap));
				if (!_n1.a.$) {
					if (!_n1.b.$) {
						var stab = _n1.a.a;
						var spell = _n1.b.a;
						return elm$core$Result$Ok(
							_Utils_ap(
								A2(
									elm$core$List$map,
									elm$html$Html$map(author$project$Page$Spell$GotTabNavMsg),
									A4(
										author$project$View$TabNav$view,
										A2(
											elm$core$Maybe$map,
											function ($) {
												return $.eL;
											},
											author$project$Select$unwrapTab(stab)),
										session,
										game,
										snap)),
								_Utils_ap(
									A7(
										author$project$View$UnitSidebar$wrap,
										author$project$Page$Spell$ClickedRoute,
										stab,
										author$project$GameData$Item$Spell(spell),
										session,
										game,
										snap,
										A5(author$project$Page$Spell$viewSpell, stab, session, game, snap, spell)),
									A4(
										author$project$View$ItemDebug$view,
										session,
										game,
										snap,
										_List_fromArray(
											[
												author$project$GameData$Item$Spell(spell)
											])))));
					} else {
						var _n3 = _n1.b;
						return elm$core$Result$Err('no such spell');
					}
				} else {
					var _n2 = _n1.a;
					return elm$core$Result$Err('no such tab');
				}
			}());
	});
var author$project$Page$Statistics$GotTabNavMsg = elm$core$Basics$identity;
var author$project$View$Lang$ViewStatisticsClicks = function (a) {
	return {$: 96, a: a};
};
var author$project$View$Lang$ViewStatisticsDecimal = function (a) {
	return {$: 98, a: a};
};
var author$project$View$Lang$ViewStatisticsEntryCreated = function (a) {
	return {$: 97, a: a};
};
var author$project$View$Lang$ViewStatisticsItemName = function (a) {
	return {$: 102, a: a};
};
var author$project$Page$Statistics$viewSpell = F3(
	function (lang, statistics, spell) {
		var v = function (entry) {
			return A2(
				elm$html$Html$tr,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						elm$html$Html$td,
						_List_fromArray(
							[
								elm$html$Html$Attributes$class('name')
							]),
						_List_fromArray(
							[
								lang.q(
								author$project$View$Lang$ViewStatisticsItemName(
									author$project$GameData$Item$Id$SpellId(spell.eL)))
							])),
						A2(
						elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								lang.q(
								author$project$View$Lang$ViewStatisticsEntryCreated(entry.bV))
							])),
						A2(
						elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								lang.q(
								author$project$View$Lang$ViewStatisticsClicks(entry.C))
							])),
						A2(
						elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								lang.q(
								author$project$View$Lang$ViewStatisticsDecimal(entry.aY))
							])),
						A2(
						elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								elm$html$Html$text('-')
							]))
					]));
		};
		return A2(
			elm$core$Maybe$map,
			v,
			A2(
				elm$core$Dict$get,
				author$project$GameData$Spell$name(spell),
				statistics.Z));
	});
var author$project$Page$Statistics$viewUnit = F3(
	function (lang, statistics, unit) {
		var v = function (entry) {
			return A2(
				elm$html$Html$tr,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						elm$html$Html$td,
						_List_fromArray(
							[
								elm$html$Html$Attributes$class('name')
							]),
						_List_fromArray(
							[
								lang.q(
								author$project$View$Lang$ViewStatisticsItemName(
									author$project$GameData$Item$Id$UnitId(unit.eL)))
							])),
						A2(
						elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								lang.q(
								author$project$View$Lang$ViewStatisticsEntryCreated(entry.bV))
							])),
						A2(
						elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								lang.q(
								author$project$View$Lang$ViewStatisticsClicks(entry.C))
							])),
						A2(
						elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								lang.q(
								author$project$View$Lang$ViewStatisticsDecimal(entry.aY))
							])),
						A2(
						elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								lang.q(
								author$project$View$Lang$ViewStatisticsDecimal(entry.fU))
							]))
					]));
		};
		return A2(
			elm$core$Maybe$map,
			v,
			A2(
				elm$core$Dict$get,
				author$project$GameData$Unit$name(unit),
				statistics.em));
	});
var author$project$Page$Statistics$viewUpgrade = F3(
	function (lang, statistics, upgrade) {
		var v = function (entry) {
			return A2(
				elm$html$Html$tr,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						elm$html$Html$td,
						_List_fromArray(
							[
								elm$html$Html$Attributes$class('name')
							]),
						_List_fromArray(
							[
								lang.q(
								author$project$View$Lang$ViewStatisticsItemName(
									author$project$GameData$Item$Id$UpgradeId(upgrade.eL)))
							])),
						A2(
						elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								lang.q(
								author$project$View$Lang$ViewStatisticsEntryCreated(entry.bV))
							])),
						A2(
						elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								lang.q(
								author$project$View$Lang$ViewStatisticsClicks(entry.C))
							])),
						A2(
						elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								lang.q(
								author$project$View$Lang$ViewStatisticsDecimal(entry.aY))
							])),
						A2(
						elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								elm$html$Html$text('-')
							]))
					]));
		};
		return A2(
			elm$core$Maybe$map,
			v,
			A2(
				elm$core$Dict$get,
				author$project$GameData$Upgrade$name(upgrade),
				statistics.Z));
	});
var author$project$View$Lang$ViewStatisticsCreated = function (a) {
	return {$: 103, a: a};
};
var author$project$View$Lang$ViewStatisticsHeaderClicks = {$: 93};
var author$project$View$Lang$ViewStatisticsHeaderCreated = {$: 101};
var author$project$View$Lang$ViewStatisticsHeaderEntryCreated = {$: 92};
var author$project$View$Lang$ViewStatisticsHeaderName = {$: 91};
var author$project$View$Lang$ViewStatisticsHeaderNum = {$: 94};
var author$project$View$Lang$ViewStatisticsHeaderSaveSize = {$: 99};
var author$project$View$Lang$ViewStatisticsHeaderTwinNum = {$: 95};
var author$project$View$Lang$ViewStatisticsSaveSize = function (a) {
	return {$: 100, a: a};
};
var author$project$View$Lang$ViewStatisticsTitle = {$: 90};
var elm$html$Html$dd = _VirtualDom_node('dd');
var elm$html$Html$dl = _VirtualDom_node('dl');
var elm$html$Html$dt = _VirtualDom_node('dt');
var elm$html$Html$thead = _VirtualDom_node('thead');
var author$project$Page$Statistics$viewReady = F2(
	function (session, game) {
		var statistics = author$project$Game$statistics(game);
		var lang = A2(author$project$View$Lang$gameToLang, session, game);
		var gd = author$project$Game$gameData(game);
		return _List_fromArray(
			[
				A2(
				elm$html$Html$h1,
				_List_Nil,
				_List_fromArray(
					[
						lang.q(author$project$View$Lang$ViewStatisticsTitle)
					])),
				A2(
				elm$html$Html$table,
				_List_fromArray(
					[
						elm$html$Html$Attributes$class('table statistics')
					]),
				_List_fromArray(
					[
						A2(
						elm$html$Html$thead,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								elm$html$Html$tr,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										elm$html$Html$th,
										_List_Nil,
										_List_fromArray(
											[
												lang.q(author$project$View$Lang$ViewStatisticsHeaderName)
											])),
										A2(
										elm$html$Html$th,
										_List_Nil,
										_List_fromArray(
											[
												lang.q(author$project$View$Lang$ViewStatisticsHeaderEntryCreated)
											])),
										A2(
										elm$html$Html$th,
										_List_Nil,
										_List_fromArray(
											[
												lang.q(author$project$View$Lang$ViewStatisticsHeaderClicks)
											])),
										A2(
										elm$html$Html$th,
										_List_Nil,
										_List_fromArray(
											[
												lang.q(author$project$View$Lang$ViewStatisticsHeaderNum)
											])),
										A2(
										elm$html$Html$th,
										_List_Nil,
										_List_fromArray(
											[
												lang.q(author$project$View$Lang$ViewStatisticsHeaderTwinNum)
											]))
									]))
							])),
						A2(
						elm$html$Html$tbody,
						_List_Nil,
						_Utils_ap(
							A2(
								elm$core$List$filterMap,
								A2(author$project$Page$Statistics$viewUnit, lang, statistics),
								author$project$GameData$units(gd)),
							_Utils_ap(
								A2(
									elm$core$List$filterMap,
									A2(author$project$Page$Statistics$viewUpgrade, lang, statistics),
									author$project$GameData$upgrades(gd)),
								A2(
									elm$core$List$filterMap,
									A2(author$project$Page$Statistics$viewSpell, lang, statistics),
									author$project$GameData$spells(gd)))))
					])),
				A2(
				elm$html$Html$dl,
				_List_fromArray(
					[
						elm$html$Html$Attributes$class('row')
					]),
				_List_fromArray(
					[
						A2(
						elm$html$Html$dt,
						_List_fromArray(
							[
								elm$html$Html$Attributes$class('col-3')
							]),
						_List_fromArray(
							[
								lang.q(author$project$View$Lang$ViewStatisticsHeaderSaveSize)
							])),
						A2(
						elm$html$Html$dd,
						_List_fromArray(
							[
								elm$html$Html$Attributes$class('col-9')
							]),
						_List_fromArray(
							[
								lang.q(
								author$project$View$Lang$ViewStatisticsSaveSize(
									A2(
										elm$core$Maybe$map,
										elm$core$String$length,
										author$project$Session$persistExport(session))))
							])),
						A2(
						elm$html$Html$dt,
						_List_fromArray(
							[
								elm$html$Html$Attributes$class('col-3')
							]),
						_List_fromArray(
							[
								lang.q(author$project$View$Lang$ViewStatisticsHeaderCreated)
							])),
						A2(
						elm$html$Html$dd,
						_List_fromArray(
							[
								elm$html$Html$Attributes$class('col-9')
							]),
						_List_fromArray(
							[
								lang.q(
								author$project$View$Lang$ViewStatisticsCreated(
									{
										H: author$project$Game$created(game),
										cm: A2(author$project$Session$safeNow, game, session)
									}))
							]))
					]))
			]);
	});
var author$project$Page$Statistics$view = F2(
	function (session, game) {
		return _Utils_ap(
			A2(
				elm$core$List$map,
				elm$html$Html$map(elm$core$Basics$identity),
				A3(author$project$View$TabNav$viewFromGame, elm$core$Maybe$Nothing, session, game)),
			A2(author$project$Page$Statistics$viewReady, session, game));
	});
var author$project$Page$Tab$GotTabNavMsg = function (a) {
	return {$: 0, a: a};
};
var author$project$Page$Tab$ClickedRow = function (a) {
	return {$: 2, a: a};
};
var author$project$Page$Tab$viewAchievementsEntry = F2(
	function (session, game) {
		var query = author$project$Session$query(session);
		var points = author$project$Game$achievementPoints(game);
		var lang = A2(author$project$View$Lang$gameToLang, session, game);
		var bonus = A2(
			elm$core$Maybe$withDefault,
			1,
			A2(
				elm$core$Maybe$map,
				author$project$Decimal$toFloat,
				A2(
					elm$core$Maybe$andThen,
					function (_n0) {
						var prod = _n0.b;
						return A2(
							elm$core$Dict$get,
							'achievementbonus',
							A3(
								author$project$Parser$Stat$evalFullWithDefault,
								author$project$Decimal$zero,
								author$project$Game$getGameVar(game),
								prod).dh);
					},
					A2(
						elm$core$Maybe$andThen,
						function ($) {
							return $.fl;
						},
						A2(
							author$project$GameData$unitByName,
							'hatchery',
							author$project$Game$gameData(game))))));
		return A2(
			elm$html$Html$tr,
			_List_fromArray(
				[
					elm$html$Html$Events$onClick(
					author$project$Page$Tab$ClickedRow(author$project$Route$Achievements))
				]),
			_List_fromArray(
				[
					A2(
					elm$html$Html$td,
					_List_fromArray(
						[
							elm$html$Html$Attributes$class('upgradable-icon')
						]),
					_List_Nil),
					A2(
					elm$html$Html$td,
					_List_fromArray(
						[
							elm$html$Html$Attributes$class('item-name')
						]),
					_List_fromArray(
						[
							A2(
							elm$html$Html$a,
							_List_fromArray(
								[
									A2(author$project$Route$href, query, author$project$Route$Achievements)
								]),
							_List_fromArray(
								[
									A2(
									elm$html$Html$span,
									_List_fromArray(
										[
											elm$html$Html$Attributes$class('list-icon-resource icon-achievements')
										]),
									_List_Nil),
									lang.q(author$project$View$Lang$ViewUnitSidebarAchievementPoints)
								]))
						])),
					A2(
					elm$html$Html$td,
					_List_fromArray(
						[
							elm$html$Html$Attributes$class('count')
						]),
					_List_fromArray(
						[
							lang.q(
							author$project$View$Lang$ViewUnitSidebarCount(
								author$project$Decimal$fromInt(points.d6)))
						])),
					A2(
					elm$html$Html$td,
					_List_fromArray(
						[
							elm$html$Html$Attributes$class('velocity')
						]),
					_List_fromArray(
						[
							author$project$View$Lang$text('+'),
							elm$html$Html$text(
							elm$core$String$fromInt(
								elm$core$Basics$floor(100 * (bonus - 1)))),
							author$project$View$Lang$text('% larvae')
						]))
				]));
	});
var author$project$Page$Tab$viewSpellEntry = F5(
	function (stab, session, game, snapshot, spell) {
		var tabSlug = author$project$Select$tabToSlug(stab);
		var query = author$project$Session$query(session);
		var lang = A2(author$project$View$Lang$gameToLang, session, game);
		return A2(
			elm$html$Html$tr,
			_List_fromArray(
				[
					elm$html$Html$Events$onClick(
					author$project$Page$Tab$ClickedRow(
						A2(author$project$Route$Spell, tabSlug, spell.cA)))
				]),
			_List_fromArray(
				[
					A2(
					elm$html$Html$td,
					_List_fromArray(
						[
							elm$html$Html$Attributes$class('upgradable-icon')
						]),
					_List_Nil),
					A2(
					elm$html$Html$td,
					_List_fromArray(
						[
							elm$html$Html$Attributes$class('item-name')
						]),
					_List_fromArray(
						[
							A2(
							elm$html$Html$a,
							_List_fromArray(
								[
									A2(
									author$project$Route$href,
									query,
									A2(author$project$Route$Spell, tabSlug, spell.cA))
								]),
							_List_fromArray(
								[
									A2(
									elm$html$Html$span,
									_List_fromArray(
										[
											elm$html$Html$Attributes$class('list-icon-resource'),
											elm$html$Html$Attributes$class(
											'icon-' + author$project$GameData$Spell$name(spell))
										]),
									_List_Nil),
									lang.q(
									author$project$View$Lang$ViewUnitSidebarSpellName(spell.eL)),
									elm$html$Html$text(' ')
								]))
						])),
					A2(
					elm$html$Html$td,
					_List_fromArray(
						[
							elm$html$Html$Attributes$class('count')
						]),
					_List_Nil),
					A2(
					elm$html$Html$td,
					_List_fromArray(
						[
							elm$html$Html$Attributes$class('velocity')
						]),
					_List_Nil)
				]));
	});
var author$project$View$Lang$ViewTabVelocity = F2(
	function (a, b) {
		return {$: 29, a: a, b: b};
	});
var author$project$Page$Tab$viewUnitEntry = F5(
	function (stab, session, game, snapshot, _n0) {
		var unit = _n0.a;
		var count = _n0.b;
		var velocity = A2(author$project$Game$UnitsSnapshot$velocity, unit.eL, snapshot);
		var tabSlug = author$project$Select$tabToSlug(stab);
		var query = author$project$Session$query(session);
		var production = A2(
			elm$core$Maybe$withDefault,
			author$project$Decimal$zero,
			A2(
				elm$core$Maybe$map,
				function ($) {
					return $.d2;
				},
				A4(
					author$project$Game$UnitsSnapshot$production,
					unit,
					author$project$Game$gameData(game),
					author$project$Game$getVar(game),
					snapshot)));
		var lang = A2(author$project$View$Lang$gameToLang, session, game);
		var isWatchTriggered = A3(author$project$Select$isUnitSidebarWatchTriggered, unit, game, snapshot);
		var isAscendTriggered = A3(author$project$Select$isUnitSidebarAscendTriggered, unit, game, snapshot);
		return A2(
			elm$html$Html$tr,
			_List_fromArray(
				[
					elm$html$Html$Events$onClick(
					author$project$Page$Tab$ClickedRow(
						A2(author$project$Route$unit, tabSlug, unit.cA)))
				]),
			_List_fromArray(
				[
					A2(
					elm$html$Html$td,
					_List_fromArray(
						[
							elm$html$Html$Attributes$class('upgradable-icon')
						]),
					_Utils_ap(
						isWatchTriggered ? _List_fromArray(
							[author$project$View$Icon$upgradable]) : _List_Nil,
						isAscendTriggered ? _List_fromArray(
							[
								author$project$View$Icon$fas('rocket')
							]) : _List_Nil)),
					A2(
					elm$html$Html$td,
					_List_fromArray(
						[
							elm$html$Html$Attributes$class('item-name')
						]),
					_List_fromArray(
						[
							A2(
							elm$html$Html$a,
							_List_fromArray(
								[
									A2(
									author$project$Route$href,
									query,
									A2(author$project$Route$unit, tabSlug, unit.cA))
								]),
							_List_fromArray(
								[
									A2(
									elm$html$Html$span,
									_List_fromArray(
										[
											elm$html$Html$Attributes$class('list-icon-resource'),
											elm$html$Html$Attributes$class(
											'icon-' + author$project$GameData$Unit$name(unit))
										]),
									_List_Nil),
									lang.q(
									author$project$View$Lang$ViewUnitSidebarUnitName(unit.eL)),
									elm$html$Html$text(' ')
								]))
						])),
					A2(
					elm$html$Html$td,
					_List_fromArray(
						[
							elm$html$Html$Attributes$class('count')
						]),
					_List_fromArray(
						[
							lang.q(
							author$project$View$Lang$ViewUnitSidebarCount(count))
						])),
					A2(
					elm$html$Html$td,
					_List_fromArray(
						[
							elm$html$Html$Attributes$class('velocity')
						]),
					(!_Utils_eq(velocity, author$project$Decimal$zero)) ? _List_fromArray(
						[
							lang.q(
							A2(author$project$View$Lang$ViewTabVelocity, unit, velocity))
						]) : (((author$project$GameData$Tab$idToString(unit.fM) === 'territory') && (!_Utils_eq(production, author$project$Decimal$zero))) ? _List_fromArray(
						[
							lang.q(
							A2(author$project$View$Lang$ViewTabVelocity, unit, production))
						]) : _List_Nil))
				]));
	});
var author$project$Page$Tab$viewReady = F4(
	function (session, game, snapshot, stab) {
		var units = A3(author$project$Select$unitCountsByTab, stab, game, snapshot);
		var spells = A3(author$project$Select$spellsByTab, stab, game, snapshot);
		var lang = A2(author$project$View$Lang$gameToLang, session, game);
		var achieves = function () {
			if (stab.$ === 1) {
				return true;
			} else {
				var tab = stab.a;
				return tab.fB;
			}
		}();
		return _List_fromArray(
			[
				A2(
				elm$html$Html$table,
				_List_fromArray(
					[
						elm$html$Html$Attributes$class('table sidebar tab'),
						elm$html$Html$Attributes$class('table-hover')
					]),
				_List_fromArray(
					[
						A2(
						elm$html$Html$tbody,
						_List_Nil,
						_Utils_ap(
							(achieves && (author$project$Game$achievementPoints(game).d6 > 0)) ? _List_fromArray(
								[
									A2(author$project$Page$Tab$viewAchievementsEntry, session, game)
								]) : _List_Nil,
							_Utils_ap(
								A2(
									elm$core$List$map,
									A4(author$project$Page$Tab$viewSpellEntry, stab, session, game, snapshot),
									spells),
								A2(
									elm$core$List$map,
									A4(author$project$Page$Tab$viewUnitEntry, stab, session, game, snapshot),
									units))))
					]))
			]);
	});
var author$project$Page$Tab$view = F2(
	function (model, game) {
		var tabSlug = model.a;
		var session = model.b;
		return A3(
			author$project$View$NotReady$viewResult,
			session,
			author$project$Game$gameData(game),
			function () {
				var snap = A2(author$project$Session$safeUnits, game, session);
				var _n0 = A3(author$project$Select$tabBySlug, tabSlug, game, snap);
				if (!_n0.$) {
					var stab = _n0.a;
					return elm$core$Result$Ok(
						_Utils_ap(
							A2(
								elm$core$List$map,
								elm$html$Html$map(author$project$Page$Tab$GotTabNavMsg),
								A3(author$project$View$TabNav$viewFromGame, elm$core$Maybe$Nothing, session, game)),
							A4(author$project$Page$Tab$viewReady, session, game, snap, stab)));
				} else {
					return elm$core$Result$Err('no such tab');
				}
			}());
	});
var author$project$Page$Translator$GotTabNavMsg = function (a) {
	return {$: 1, a: a};
};
var author$project$Page$Translator$GotJsonChange = function (a) {
	return {$: 2, a: a};
};
var elm$html$Html$Attributes$download = function (fileName) {
	return A2(elm$html$Html$Attributes$stringProperty, 'download', fileName);
};
var author$project$Page$Translator$viewReady = F2(
	function (_n0, game) {
		var session = _n0.a;
		var status = _n0.b;
		var txt = _n0.c;
		var lang = A2(author$project$View$Lang$gameToLang, session, game);
		return _List_fromArray(
			[
				A2(
				elm$html$Html$h1,
				_List_Nil,
				_List_fromArray(
					[
						author$project$View$Lang$text('Translating Tools')
					])),
				A2(
				elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						elm$html$Html$text('Text throughout the game will change as you type below. For example, try '),
						A2(
						elm$html$Html$code,
						_List_Nil,
						_List_fromArray(
							[
								elm$html$Html$text('{\"header\": {\"message\": \"群れシミュレータ\"}}')
							])),
						elm$html$Html$text(' and watch the top of this screen.')
					])),
				A2(
				elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						elm$html$Html$text('Your changes are visible when '),
						A2(
						elm$html$Html$code,
						_List_Nil,
						_List_fromArray(
							[
								elm$html$Html$text('?translator=1')
							])),
						elm$html$Html$text(' is in the URL, or when you\'re on this page.')
					])),
				A2(
				elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						elm$html$Html$text('You can upload '),
						A2(
						elm$html$Html$a,
						_List_fromArray(
							[
								elm$html$Html$Attributes$target('_blank'),
								elm$html$Html$Attributes$href('/lang/en-us.json')
							]),
						_List_fromArray(
							[
								elm$html$Html$text(' the English translation file ')
							])),
						elm$html$Html$text(' to '),
						A2(
						elm$html$Html$a,
						_List_fromArray(
							[
								elm$html$Html$Attributes$target('_blank'),
								elm$html$Html$Attributes$href('https://translate.google.com/toolkit/')
							]),
						_List_fromArray(
							[
								elm$html$Html$text('Google\'s translation toolkit')
							])),
						elm$html$Html$text(' to get started.')
					])),
				A2(
				elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						elm$html$Html$a,
						_List_fromArray(
							[
								elm$html$Html$Attributes$target('_blank'),
								elm$html$Html$Attributes$href('https://gitlab.com/erosson/swarm-elm/blob/master/CONTRIBUTING.md#contributing-translations')
							]),
						_List_fromArray(
							[
								elm$html$Html$text('Detailed translation instructions are here')
							])),
						elm$html$Html$text('. Thanks for your help translating Swarm Simulator!')
					])),
				A2(
				elm$html$Html$textarea,
				_List_fromArray(
					[
						A2(elm$html$Html$Attributes$style, 'width', '100%'),
						A2(elm$html$Html$Attributes$style, 'height', '100%'),
						A2(elm$html$Html$Attributes$style, 'min-height', '50vh'),
						elm$html$Html$Events$onInput(author$project$Page$Translator$GotJsonChange)
					]),
				_List_fromArray(
					[
						elm$html$Html$text(txt)
					])),
				function () {
				if (status.$ === 2) {
					var err = status.a;
					return A2(
						elm$html$Html$pre,
						_List_fromArray(
							[
								elm$html$Html$Attributes$class('alert alert-danger')
							]),
						_List_fromArray(
							[
								elm$html$Html$text(err)
							]));
				} else {
					return A2(
						elm$html$Html$a,
						_List_fromArray(
							[
								elm$html$Html$Attributes$href(
								'data:text/plain;charset:utf-8,' + elm$url$Url$percentEncode(txt)),
								elm$html$Html$Attributes$download('translation.json')
							]),
						_List_fromArray(
							[
								elm$html$Html$text('Download your translation file')
							]));
				}
			}()
			]);
	});
var author$project$Page$Translator$view = F2(
	function (model, game) {
		var session = model.a;
		return _Utils_ap(
			A2(
				elm$core$List$map,
				elm$html$Html$map(author$project$Page$Translator$GotTabNavMsg),
				A3(author$project$View$TabNav$viewFromGame, elm$core$Maybe$Nothing, session, game)),
			A2(author$project$Page$Translator$viewReady, model, game));
	});
var author$project$Page$Unit$GotTabNavMsg = function (a) {
	return {$: 3, a: a};
};
var author$project$Game$velocityUI = A2(
	elm$core$Basics$composeR,
	author$project$Game$unwrap,
	function ($) {
		return $.aK;
	});
var author$project$Game$HatchableRate$eval = F2(
	function (game, snapshot) {
		return A2(
			author$project$Parser$Stat$evalWithDefault,
			author$project$Decimal$zero,
			A2(author$project$Game$getVar, game, snapshot));
	});
var author$project$Game$HatchableRate$fixedCostExprs = function (unit) {
	var fold = function (_n1) {
		var costId = _n1.a;
		var costVal = _n1.b;
		return elm$core$Result$andThen(
			function (costs) {
				if (!costVal.$) {
					var expr = costVal.a;
					return elm$core$Result$Ok(
						A2(
							elm$core$List$cons,
							_Utils_Tuple2(costId, expr),
							costs));
				} else {
					return elm$core$Result$Err(
						'non-fixed cost: ' + author$project$GameData$Unit$idToString(costId));
				}
			});
	};
	return A3(
		elm$core$List$foldr,
		fold,
		elm$core$Result$Ok(_List_Nil),
		unit.es);
};
var author$project$Game$HatchableRate$hatchableRateFromFixedCosts = F3(
	function (twins, snapshot, costs) {
		var rateFromCost = function (_n0) {
			var costId = _n0.a;
			var cost = _n0.b;
			return _Utils_Tuple2(
				costId,
				A2(
					author$project$Decimal$div,
					A2(author$project$Game$UnitsSnapshot$velocity, costId, snapshot),
					cost));
		};
		var rates = A2(elm$core$List$map, rateFromCost, costs);
		var minRate = A2(
			elm$core$Maybe$withDefault,
			author$project$Decimal$zero,
			author$project$Decimal$minimum(
				A2(elm$core$List$map, elm$core$Tuple$second, rates)));
		return {
			dD: A2(
				elm$core$List$map,
				elm$core$Tuple$mapSecond(
					A2(
						elm$core$Basics$composeR,
						author$project$Decimal$div(minRate),
						author$project$Decimal$toFloat)),
				rates),
			cu: A2(author$project$Decimal$mul, twins, minRate)
		};
	});
var author$project$Game$HatchableRate$hatchableRate = F3(
	function (unit, game, snapshot) {
		if (elm$core$List$isEmpty(unit.es)) {
			return elm$core$Result$Err('unit is not buyable');
		} else {
			var twins = A3(author$project$Game$Order$twinUnits, game, snapshot, unit);
			return A2(
				elm$core$Result$andThen,
				function (out) {
					return _Utils_eq(out.cu, author$project$Decimal$zero) ? elm$core$Result$Err('rate is zero') : elm$core$Result$Ok(out);
				},
				A2(
					elm$core$Result$map,
					A2(author$project$Game$HatchableRate$hatchableRateFromFixedCosts, twins, snapshot),
					A2(
						elm$core$Result$map,
						elm$core$List$map(
							elm$core$Tuple$mapSecond(
								A2(author$project$Game$HatchableRate$eval, game, snapshot))),
						author$project$Game$HatchableRate$fixedCostExprs(unit))));
		}
	});
var author$project$Page$Unit$VelocityCollapsed = {$: 7};
var author$project$Page$Unit$VelocityExpanded = {$: 6};
var author$project$Page$Unit$tabindex0 = 2;
var author$project$View$BuyN$viewProgress = function (progress) {
	var percent = elm$core$String$fromFloat(progress.dC * 100);
	return A2(
		elm$html$Html$div,
		_List_fromArray(
			[
				elm$html$Html$Attributes$class('progress')
			]),
		_List_fromArray(
			[
				A2(
				elm$html$Html$div,
				_List_fromArray(
					[
						elm$html$Html$Attributes$class('progress-bar'),
						A2(elm$html$Html$Attributes$style, 'width', percent + '%'),
						A2(elm$html$Html$Attributes$attribute, 'role', 'progressbar'),
						A2(elm$html$Html$Attributes$attribute, 'aria-valuenow', percent),
						A2(elm$html$Html$Attributes$attribute, 'aria-valuemax', '100')
					]),
				_List_fromArray(
					[
						elm$html$Html$text(
						elm$core$String$fromInt(
							elm$core$Basics$floor(progress.dC * 100))),
						elm$html$Html$text('%'),
						function () {
						var _n0 = progress.da;
						if (!_n0.$) {
							var d = _n0.a;
							return elm$html$Html$text(
								' - ' + author$project$Duration$toString(d));
						} else {
							return elm$html$Html$text('');
						}
					}()
					]))
			]));
};
var author$project$View$Lang$ViewUnitCappedCount = F3(
	function (a, b, c) {
		return {$: 32, a: a, b: b, c: c};
	});
var author$project$Page$Unit$viewCappedCount = F6(
	function (unit, count, capExpr, session, game, snapshot) {
		var lang = A2(author$project$View$Lang$gameToLang, session, game);
		var cap = A3(
			author$project$Parser$Stat$evalWithDefault,
			author$project$Decimal$zero,
			author$project$Game$getGameVar(game),
			capExpr);
		var progress = _Utils_eq(cap, author$project$Decimal$zero) ? {
			da: elm$core$Maybe$Just(author$project$Duration$zero),
			dC: 1
		} : {
			da: elm$core$Maybe$Just(
				author$project$Duration$fromSecs(
					author$project$Decimal$toFloat(
						A2(
							author$project$Decimal$div,
							A2(author$project$Decimal$sub, cap, count),
							A2(author$project$Game$UnitsSnapshot$velocity, unit.eL, snapshot))))),
			dC: author$project$Decimal$toFloat(
				A2(author$project$Decimal$div, count, cap))
		};
		return _List_fromArray(
			[
				author$project$View$BuyN$viewProgress(progress),
				lang.q(
				A3(author$project$View$Lang$ViewUnitCappedCount, count, cap, unit.eL))
			]);
	});
var author$project$View$Lang$ViewUnitHatchableRate = F2(
	function (a, b) {
		return {$: 43, a: a, b: b};
	});
var author$project$View$Lang$ViewUnitProdEach = function (a) {
	return {$: 33, a: a};
};
var author$project$View$Lang$ViewUnitProdTotal = function (a) {
	return {$: 34, a: a};
};
var author$project$View$Lang$ViewUnitVelocity = F2(
	function (a, b) {
		return {$: 42, a: a, b: b};
	});
var author$project$View$Watcher$viewWatchedIcon = function (watched) {
	switch (watched) {
		case 0:
			return _List_fromArray(
				[
					author$project$View$Icon$upgradable,
					elm$html$Html$text(' '),
					author$project$View$Icon$fas('eye-slash')
				]);
		case 1:
			return _List_fromArray(
				[
					author$project$View$Icon$upgradable,
					elm$html$Html$text(' '),
					author$project$View$Icon$fas('ban')
				]);
		case 2:
			return _List_fromArray(
				[
					author$project$View$Icon$upgradable,
					elm$html$Html$text(' ×1')
				]);
		case 3:
			return _List_fromArray(
				[
					author$project$View$Icon$upgradable,
					elm$html$Html$text(' ×2')
				]);
		default:
			return _List_fromArray(
				[
					author$project$View$Icon$upgradable,
					elm$html$Html$text(' ×4')
				]);
	}
};
var author$project$View$Watcher$SetWatched = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var author$project$View$Watcher$viewWatchedDesc = function (watched) {
	switch (watched) {
		case 2:
			return ' Notify when buyable';
		case 3:
			return ' Notify at 2x cost';
		case 4:
			return ' Notify at 4x cost';
		case 1:
			return ' Never notify';
		default:
			return ' Hide upgrade';
	}
};
var author$project$View$Watcher$viewWatcherEntry = F4(
	function (game, item, active, entry) {
		return A2(
			elm$html$Html$button,
			_List_fromArray(
				[
					elm$html$Html$Attributes$class('dropdown-item'),
					elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'active',
							_Utils_eq(active, entry))
						])),
					elm$html$Html$Events$onClick(
					A2(author$project$View$Watcher$SetWatched, item, entry))
				]),
			_Utils_ap(
				author$project$View$Watcher$viewWatchedIcon(entry),
				_List_fromArray(
					[
						elm$html$Html$text(
						author$project$View$Watcher$viewWatchedDesc(entry))
					])));
	});
var author$project$View$Watcher$viewWatcher = F3(
	function (options, game, item) {
		var _n0 = A2(author$project$Game$watched, item, game);
		if (_n0.$ === 1) {
			return A2(elm$html$Html$div, _List_Nil, _List_Nil);
		} else {
			var active = _n0.a;
			return A2(
				elm$html$Html$div,
				_List_fromArray(
					[
						elm$html$Html$Attributes$class('float-right')
					]),
				_List_fromArray(
					[
						A2(
						elm$html$Html$button,
						_List_fromArray(
							[
								elm$html$Html$Attributes$class('btn dropdown-toggle'),
								elm$html$Html$Attributes$type_('button'),
								A2(elm$html$Html$Attributes$attribute, 'data-toggle', 'dropdown'),
								A2(elm$html$Html$Attributes$attribute, 'aria-haspopup', 'true')
							]),
						author$project$View$Watcher$viewWatchedIcon(active)),
						A2(
						elm$html$Html$div,
						_List_fromArray(
							[
								elm$html$Html$Attributes$class('dropdown-menu')
							]),
						A2(
							elm$core$List$map,
							A3(author$project$View$Watcher$viewWatcherEntry, game, item, active),
							options))
					]));
		}
	});
var author$project$View$Watcher$viewUnitWatcher = F2(
	function (game, unit) {
		return A3(
			author$project$View$Watcher$viewWatcher,
			_List_fromArray(
				[2, 3, 4, 1]),
			game,
			author$project$GameData$Item$Unit(unit));
	});
var elm_community$result_extra$Result$Extra$isOk = function (x) {
	if (!x.$) {
		return true;
	} else {
		return false;
	}
};
var author$project$Page$Unit$viewUnit = F6(
	function (stab, session, game, snapshot, unit, count) {
		var velocity = A2(author$project$Game$UnitsSnapshot$velocity, unit.eL, snapshot);
		var tabSlug = author$project$Select$tabToSlug(stab);
		var query = author$project$Session$query(session);
		var production = A3(author$project$Game$production, unit, game, snapshot);
		var order = A3(
			author$project$Game$Order$fromBuyN,
			game,
			snapshot,
			author$project$GameData$Item$Unit(unit));
		var lang = A2(author$project$View$Lang$gameToLang, session, game);
		var hatchRate = A3(author$project$Game$HatchableRate$hatchableRate, unit, game, snapshot);
		var isVelocityUIToggleVisible = (!_Utils_eq(velocity, author$project$Decimal$zero)) || elm_community$result_extra$Result$Extra$isOk(hatchRate);
		return _List_fromArray(
			[
				A2(
				elm$html$Html$h3,
				_List_Nil,
				_List_fromArray(
					[
						A2(author$project$Route$Feature$isActive, 5, query) ? author$project$View$Device$onlyMobileInline(
						_List_fromArray(
							[
								A2(
								elm$html$Html$a,
								_List_fromArray(
									[
										A2(
										author$project$Route$href,
										query,
										author$project$Route$Tab(tabSlug))
									]),
								_List_fromArray(
									[
										author$project$View$Icon$fas('bars'),
										elm$html$Html$text(' ')
									]))
							])) : A2(elm$html$Html$span, _List_Nil, _List_Nil),
						lang.q(
						author$project$View$Lang$ViewUnitHeader(unit.eL))
					])),
				A2(
				elm$html$Html$map,
				author$project$Page$Unit$GotWatcherMsg,
				A2(author$project$View$Watcher$viewUnitWatcher, game, unit)),
				A2(
				elm$html$Html$div,
				_List_fromArray(
					[
						elm$html$Html$Attributes$class('desc-icon-resource'),
						elm$html$Html$Attributes$class(
						'desc-icon-' + author$project$GameData$Unit$name(unit)),
						elm$html$Html$Attributes$class(
						'icon-' + author$project$GameData$Unit$name(unit))
					]),
				_List_Nil),
				function () {
				var _n0 = A3(
					author$project$View$Description$view,
					session,
					game,
					author$project$GameData$Item$Unit(unit));
				if (!_n0.$) {
					var html = _n0.a;
					return html;
				} else {
					return lang.q(
						A2(
							author$project$View$Lang$UnitDesc,
							author$project$View$DescriptionVars$evalVar(game),
							unit.eL));
				}
			}(),
				A2(
				elm$html$Html$p,
				_List_Nil,
				function () {
					var _n1 = unit.eZ;
					if (_n1.$ === 1) {
						return _List_fromArray(
							[
								lang.q(
								A2(author$project$View$Lang$ViewUnitCount, count, unit.eL)),
								function () {
								if (isVelocityUIToggleVisible) {
									var _n2 = author$project$Game$velocityUI(game);
									if (!_n2) {
										return A2(
											elm$html$Html$button,
											_List_fromArray(
												[
													elm$html$Html$Attributes$class('btn btn-link'),
													elm$html$Html$Events$onClick(author$project$Page$Unit$VelocityExpanded)
												]),
											_List_fromArray(
												[
													author$project$View$Icon$fas('chevron-down')
												]));
									} else {
										return A2(
											elm$html$Html$button,
											_List_fromArray(
												[
													elm$html$Html$Attributes$class('btn btn-link'),
													elm$html$Html$Events$onClick(author$project$Page$Unit$VelocityCollapsed)
												]),
											_List_fromArray(
												[
													author$project$View$Icon$fas('chevron-up')
												]));
									}
								} else {
									return A2(elm$html$Html$span, _List_Nil, _List_Nil);
								}
							}()
							]);
					} else {
						var capExpr = _n1.a;
						return A6(author$project$Page$Unit$viewCappedCount, unit, count, capExpr, session, game, snapshot);
					}
				}()),
				A2(
				elm$html$Html$p,
				_List_Nil,
				A3(
					elm_community$maybe_extra$Maybe$Extra$unwrap,
					_List_Nil,
					function (prod) {
						return _List_fromArray(
							[
								lang.q(
								author$project$View$Lang$ViewUnitProdEach(prod))
							]);
					},
					production)),
				A2(
				elm$html$Html$p,
				_List_Nil,
				_Utils_eq(count, author$project$Decimal$zero) ? _List_Nil : A3(
					elm_community$maybe_extra$Maybe$Extra$unwrap,
					_List_Nil,
					function (prod) {
						return _List_fromArray(
							[
								lang.q(
								author$project$View$Lang$ViewUnitProdTotal(prod))
							]);
					},
					production)),
				A2(
				elm$html$Html$div,
				_List_Nil,
				function () {
					var _n3 = author$project$Game$velocityUI(game);
					if (_n3 === 1) {
						return _Utils_ap(
							_Utils_eq(velocity, author$project$Decimal$zero) ? _List_Nil : _List_fromArray(
								[
									A2(
									elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											lang.q(
											A2(author$project$View$Lang$ViewUnitVelocity, unit.eL, velocity))
										]))
								]),
							function () {
								if (!hatchRate.$) {
									var hatch = hatchRate.a;
									return _List_fromArray(
										[
											A2(
											elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[
													lang.q(
													A2(author$project$View$Lang$ViewUnitHatchableRate, unit.eL, hatch))
												]))
										]);
								} else {
									return _List_Nil;
								}
							}());
					} else {
						return _List_Nil;
					}
				}()),
				A2(
				elm$html$Html$map,
				author$project$Page$Unit$GotBuyNMsg,
				A2(
					elm$core$Maybe$withDefault,
					A2(elm$html$Html$div, _List_Nil, _List_Nil),
					A5(
						author$project$View$BuyN$view,
						session,
						game,
						snapshot,
						order,
						{fN: author$project$Page$Unit$tabindex0}))),
				author$project$View$BuyN$viewHelpModal(lang)
			]);
	});
var author$project$View$Lang$ViewUnitUpgradeHeader = F2(
	function (a, b) {
		return {$: 37, a: a, b: b};
	});
var author$project$View$Watcher$viewUpgradeWatcher = F2(
	function (game, upgrade) {
		return A3(
			author$project$View$Watcher$viewWatcher,
			_List_fromArray(
				[2, 3, 4, 1, 0]),
			game,
			author$project$GameData$Item$Upgrade(upgrade));
	});
var author$project$Page$Unit$viewUpgrade = F5(
	function (session, game, snapshot, index, upgrade) {
		var order = A3(
			author$project$Game$Order$fromBuyN,
			game,
			snapshot,
			author$project$GameData$Item$Upgrade(upgrade));
		var lang = A2(author$project$View$Lang$gameToLang, session, game);
		var count = A2(author$project$Game$upgradeCount, upgrade.eL, game);
		var _n0 = A2(
			author$project$Game$watched,
			author$project$GameData$Item$Upgrade(upgrade),
			game);
		if ((!_n0.$) && (!_n0.a)) {
			var _n1 = _n0.a;
			return elm$core$Maybe$Just(
				A2(
					elm$html$Html$div,
					_List_fromArray(
						[
							A2(elm$html$Html$Attributes$style, 'clear', 'right'),
							A2(elm$html$Html$Attributes$style, 'opacity', '0.65')
						]),
					_List_fromArray(
						[
							A2(
							elm$html$Html$map,
							author$project$Page$Unit$GotWatcherMsg,
							A2(author$project$View$Watcher$viewUpgradeWatcher, game, upgrade)),
							A2(
							elm$html$Html$div,
							_List_fromArray(
								[
									elm$html$Html$Attributes$class('upgrade-header')
								]),
							_List_fromArray(
								[
									lang.q(
									A2(author$project$View$Lang$ViewUnitUpgradeHeader, count, upgrade.eL))
								]))
						])));
		} else {
			var _n2 = A2(
				elm$core$Maybe$map,
				elm$html$Html$map(author$project$Page$Unit$GotBuyNMsg),
				A5(
					author$project$View$BuyN$view,
					session,
					game,
					snapshot,
					order,
					{fN: author$project$Page$Unit$tabindex0 + index}));
			if (_n2.$ === 1) {
				return elm$core$Maybe$Nothing;
			} else {
				var viewBuyN = _n2.a;
				return elm$core$Maybe$Just(
					A2(
						elm$html$Html$div,
						_List_fromArray(
							[
								A2(elm$html$Html$Attributes$style, 'clear', 'right')
							]),
						_List_fromArray(
							[
								A2(
								elm$html$Html$map,
								author$project$Page$Unit$GotWatcherMsg,
								A2(author$project$View$Watcher$viewUpgradeWatcher, game, upgrade)),
								A2(
								elm$html$Html$div,
								_List_fromArray(
									[
										elm$html$Html$Attributes$class('upgrade-header')
									]),
								_List_fromArray(
									[
										lang.q(
										A2(author$project$View$Lang$ViewUnitUpgradeHeader, count, upgrade.eL))
									])),
								function () {
								var _n3 = A3(
									author$project$View$Description$view,
									session,
									game,
									author$project$GameData$Item$Upgrade(upgrade));
								if (!_n3.$) {
									var html = _n3.a;
									return html;
								} else {
									return lang.q(
										A2(
											author$project$View$Lang$UpgradeDesc,
											author$project$View$DescriptionVars$evalVar(game),
											upgrade.eL));
								}
							}(),
								viewBuyN
							])));
			}
		}
	});
var author$project$View$Lang$ViewUnitUpgradesTitle = {$: 36};
var elm$html$Html$h4 = _VirtualDom_node('h4');
var author$project$Page$Unit$viewUpgrades = F4(
	function (session, game, snapshot, unit) {
		var _n0 = A2(
			elm$core$List$filterMap,
			elm$core$Basics$identity,
			A2(
				elm$core$List$indexedMap,
				A3(author$project$Page$Unit$viewUpgrade, session, game, snapshot),
				A3(author$project$Select$upgradesByUnitId, unit.eL, game, snapshot)));
		if (!_n0.b) {
			return _List_Nil;
		} else {
			var upgradesViews = _n0;
			var lang = A2(author$project$View$Lang$gameToLang, session, game);
			return _List_fromArray(
				[
					A2(elm$html$Html$hr, _List_Nil, _List_Nil),
					A2(
					elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							lang.q(author$project$View$Lang$ViewUnitUpgradesTitle)
						])),
					A2(elm$html$Html$div, _List_Nil, upgradesViews)
				]);
		}
	});
var author$project$Page$Unit$view = F2(
	function (_n0, game0) {
		var tabSlug = _n0.a;
		var unitSlug = _n0.b;
		var ns = _n0.c;
		var session = _n0.d;
		return A3(
			author$project$View$NotReady$viewResult,
			session,
			author$project$Game$gameData(game0),
			function () {
				var snap = A2(author$project$Session$safeUnits, game0, session);
				var _n1 = _Utils_Tuple2(
					A3(author$project$Select$tabBySlug, tabSlug, game0, snap),
					A3(author$project$Select$unitBySlug, unitSlug, game0, snap));
				if (!_n1.a.$) {
					if (!_n1.b.$) {
						var stab = _n1.a.a;
						var _n2 = _n1.b.a;
						var unit = _n2.a;
						var count = _n2.b;
						var game = function () {
							var _n3 = ns.dz;
							if (_n3.$ === 1) {
								return game0;
							} else {
								var buyN = _n3.a;
								return A3(
									author$project$Game$setBuyN,
									author$project$GameData$Item$Unit(unit),
									buyN,
									game0);
							}
						}();
						return elm$core$Result$Ok(
							_Utils_ap(
								A2(
									elm$core$List$map,
									elm$html$Html$map(author$project$Page$Unit$GotTabNavMsg),
									A4(
										author$project$View$TabNav$view,
										A2(
											elm$core$Maybe$map,
											function ($) {
												return $.eL;
											},
											author$project$Select$unwrapTab(stab)),
										session,
										game,
										snap)),
								_Utils_ap(
									A7(
										author$project$View$UnitSidebar$wrap,
										author$project$Page$Unit$ClickedRoute,
										stab,
										author$project$GameData$Item$Unit(unit),
										session,
										game,
										snap,
										_Utils_ap(
											A6(author$project$Page$Unit$viewUnit, stab, session, game, snap, unit, count),
											A4(author$project$Page$Unit$viewUpgrades, session, game, snap, unit))),
									A4(
										author$project$View$ItemDebug$view,
										session,
										game,
										snap,
										_List_fromArray(
											[
												author$project$GameData$Item$Unit(unit)
											])))));
					} else {
						var _n5 = _n1.b;
						return elm$core$Result$Err('no such unit');
					}
				} else {
					var _n4 = _n1.a;
					return elm$core$Result$Err('no such tab');
				}
			}());
	});
var author$project$Page$User$GotTabNavMsg = function (a) {
	return {$: 0, a: a};
};
var author$project$Duration$negate = function (_n0) {
	var a = _n0;
	return -a;
};
var author$project$Cooldown$percent = F3(
	function (now, duration, cooldown) {
		var _n0 = A2(author$project$Cooldown$tick, now, cooldown);
		if (!_n0.$) {
			return 1;
		} else {
			var end = _n0.a;
			var start = A2(
				author$project$Duration$addPosix,
				author$project$Duration$negate(duration),
				end);
			var elapsed = author$project$Duration$since(
				{eb: now, eh: start});
			return author$project$Duration$toMillis(elapsed) / A2(
				elm$core$Basics$max,
				1,
				author$project$Duration$toMillis(duration));
		}
	});
var author$project$Page$User$Logout = {$: 1};
var author$project$Page$User$ManualPlayFabWriteRequest = {$: 3};
var author$project$PlayFab$TitleId$devSite = function (_n0) {
	var id = _n0;
	return 'https://developer.playfab.com/en-US/' + id;
};
var author$project$PlayFab$User$rememberIdToString = function (_n0) {
	var r = _n0;
	return A2(elm$core$String$left, 8, r) + ('...' + A2(elm$core$String$right, 8, r));
};
var author$project$View$Lang$ViewUserButtonChangePassword = {$: 170};
var author$project$View$Lang$ViewUserButtonForcePush = {$: 168};
var author$project$View$Lang$ViewUserButtonLogout = {$: 169};
var author$project$View$Lang$ViewUserDescPush1 = {$: 160};
var author$project$View$Lang$ViewUserDescPush2 = function (a) {
	return {$: 161, a: a};
};
var author$project$View$Lang$ViewUserPushError = function (a) {
	return {$: 165, a: a};
};
var author$project$View$Lang$ViewUserPushFailure = function (a) {
	return {$: 163, a: a};
};
var author$project$View$Lang$ViewUserPushNone = {$: 164};
var author$project$View$Lang$ViewUserPushNotReady = F2(
	function (a, b) {
		return {$: 167, a: a, b: b};
	});
var author$project$View$Lang$ViewUserPushReady = {$: 166};
var author$project$View$Lang$ViewUserPushSuccess = function (a) {
	return {$: 162, a: a};
};
var author$project$View$Lang$ViewUserTitle = {$: 159};
var author$project$Page$User$viewReady = F3(
	function (session, gd, ustate) {
		var user = ustate.cQ;
		var userId = author$project$PlayFab$User$idToString(
			author$project$PlayFab$User$id(user));
		var titleId = author$project$PlayFab$TitleId$fromSession(session);
		var lang = A2(author$project$View$Lang$gameDataToLang, session, gd);
		var isConflict = elm_community$maybe_extra$Maybe$Extra$isJust(
			author$project$Session$offlineSyncConflict(session));
		return _Utils_ap(
			_List_fromArray(
				[
					A2(
					elm$html$Html$h1,
					_List_Nil,
					_List_fromArray(
						[
							lang.q(author$project$View$Lang$ViewUserTitle)
						])),
					A2(
					elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							elm$html$Html$text(
							A2(
								author$project$PlayFab$User$displayName,
								author$project$Session$iframe(session),
								user)),
							elm$html$Html$text(' #'),
							elm$html$Html$text(userId)
						])),
					A2(
					elm$html$Html$p,
					_List_Nil,
					function () {
						var _n0 = author$project$PlayFab$User$role(user);
						if (_n0 === 1) {
							return _List_fromArray(
								[
									elm$html$Html$text('role: admin')
								]);
						} else {
							return _List_Nil;
						}
					}()),
					A2(
					elm$html$Html$div,
					_List_Nil,
					function () {
						var _n1 = ustate.fL;
						if (_n1.$ === 1) {
							var conflict = _n1.a;
							return _List_fromArray(
								[
									A2(
									elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											elm$html$Html$text('Offline-sync conflict!')
										]))
								]);
						} else {
							var sync = _n1.a;
							var since = A2(
								elm$core$Maybe$map2,
								F2(
									function (after, before) {
										return author$project$Duration$since(
											{eb: after, eh: before});
									}),
								author$project$Session$now(session));
							return _Utils_ap(
								A2(
									elm$core$List$map,
									function (s) {
										return A2(
											elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[s]));
									},
									elm$core$List$concat(
										_List_fromArray(
											[
												_List_fromArray(
												[
													lang.q(author$project$View$Lang$ViewUserDescPush1),
													lang.q(
													author$project$View$Lang$ViewUserDescPush2(author$project$Session$userSyncCooldownDuration))
												]),
												function () {
												var _n2 = since(sync.d_);
												if (!_n2.$) {
													var d = _n2.a;
													return _List_fromArray(
														[
															lang.q(
															author$project$View$Lang$ViewUserPushSuccess(d))
														]);
												} else {
													return _List_Nil;
												}
											}(),
												function () {
												var _n3 = since(sync.dP);
												if (!_n3.$) {
													var d = _n3.a;
													return (_Utils_eq(sync.dP, sync.d_) || _Utils_eq(sync.dO, krisajenkins$remotedata$RemoteData$Loading)) ? _List_Nil : _List_fromArray(
														[
															lang.q(
															author$project$View$Lang$ViewUserPushFailure(d))
														]);
												} else {
													return _List_fromArray(
														[
															lang.q(author$project$View$Lang$ViewUserPushNone)
														]);
												}
											}(),
												function () {
												var _n4 = sync.dO;
												if (_n4.$ === 2) {
													var err = _n4.a;
													return _List_fromArray(
														[
															lang.q(
															author$project$View$Lang$ViewUserPushError(err))
														]);
												} else {
													return _List_Nil;
												}
											}(),
												function () {
												var _n5 = author$project$Session$now(session);
												if (_n5.$ === 1) {
													return _List_fromArray(
														[author$project$View$Icon$loading]);
												} else {
													var now_ = _n5.a;
													var _n6 = A2(author$project$Cooldown$tick, now_, sync._);
													if (!_n6.$) {
														return _List_fromArray(
															[
																lang.q(author$project$View$Lang$ViewUserPushReady)
															]);
													} else {
														var until = _n6.a;
														var pct = A3(author$project$Cooldown$percent, now_, author$project$Session$userSyncCooldownDuration, sync._);
														var d = author$project$Duration$since(
															{eb: until, eh: now_});
														return _List_fromArray(
															[
																lang.q(
																A2(author$project$View$Lang$ViewUserPushNotReady, d, pct))
															]);
													}
												}
											}()
											]))),
								_List_fromArray(
									[
										A2(
										elm$html$Html$div,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												elm$html$Html$button,
												_List_fromArray(
													[
														elm$html$Html$Attributes$class('btn btn-info'),
														elm$html$Html$Events$onClick(author$project$Page$User$ManualPlayFabWriteRequest),
														elm$html$Html$Attributes$disabled(
														isConflict || krisajenkins$remotedata$RemoteData$isLoading(sync.dO))
													]),
												_List_fromArray(
													[
														krisajenkins$remotedata$RemoteData$isLoading(sync.dO) ? author$project$View$Icon$loading : elm$html$Html$text(''),
														lang.q(author$project$View$Lang$ViewUserButtonForcePush)
													]))
											])),
										A2(
										author$project$Route$Feature$isActive,
										4,
										author$project$Session$query(session)) ? A2(
										elm$html$Html$div,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												elm$html$Html$a,
												_List_fromArray(
													[
														elm$html$Html$Attributes$class('btn btn-link'),
														A2(
														author$project$Route$href,
														author$project$Session$query(session),
														author$project$Route$MtxHistory)
													]),
												_List_fromArray(
													[
														lang.q(author$project$View$Lang$ViewMtxShopHistory)
													]))
											])) : A2(elm$html$Html$div, _List_Nil, _List_Nil)
									]));
						}
					}()),
					A2(
					elm$html$Html$div,
					_List_Nil,
					function () {
						var _n7 = author$project$Session$iframe(session);
						if (!_n7.$) {
							return _List_fromArray(
								[
									A2(
									elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											elm$html$Html$a,
											_List_fromArray(
												[
													elm$html$Html$Attributes$class('btn btn-link'),
													A2(
													author$project$Route$href,
													author$project$Session$query(session),
													author$project$Route$ResetPassword)
												]),
											_List_fromArray(
												[
													lang.q(author$project$View$Lang$ViewUserButtonChangePassword)
												]))
										])),
									A2(
									elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											elm$html$Html$button,
											_List_fromArray(
												[
													elm$html$Html$Attributes$class('btn btn-secondary'),
													elm$html$Html$Events$onClick(author$project$Page$User$Logout)
												]),
											_List_fromArray(
												[
													lang.q(author$project$View$Lang$ViewUserButtonLogout)
												]))
										]))
								]);
						} else {
							return _List_Nil;
						}
					}())
				]),
			A2(
				author$project$Route$Feature$isActive,
				0,
				author$project$Session$query(session)) ? _List_fromArray(
				[
					A2(
					elm$html$Html$div,
					_List_fromArray(
						[
							elm$html$Html$Attributes$class('card')
						]),
					_List_fromArray(
						[
							A2(
							elm$html$Html$h6,
							_List_fromArray(
								[
									elm$html$Html$Attributes$class('card-header')
								]),
							_List_fromArray(
								[
									elm$html$Html$text('user debug')
								])),
							A2(
							elm$html$Html$div,
							_List_fromArray(
								[
									elm$html$Html$Attributes$class('card-body')
								]),
							_List_fromArray(
								[
									A2(
									elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											elm$html$Html$a,
											_List_fromArray(
												[
													elm$html$Html$Attributes$href(
													author$project$PlayFab$TitleId$devSite(titleId) + ('/players/' + (userId + '/overview'))),
													elm$html$Html$Attributes$target('_blank')
												]),
											_List_fromArray(
												[
													elm$html$Html$text('overview #'),
													elm$html$Html$text(userId)
												])),
											elm$html$Html$text(', '),
											A2(
											elm$html$Html$a,
											_List_fromArray(
												[
													elm$html$Html$Attributes$href(
													author$project$PlayFab$TitleId$devSite(titleId) + ('/players/' + (userId + '/data'))),
													elm$html$Html$Attributes$target('_blank')
												]),
											_List_fromArray(
												[
													elm$html$Html$text('userdata #'),
													elm$html$Html$text(userId)
												]))
										])),
									function () {
									var id = function () {
										var _n8 = A2(
											elm$core$Maybe$map,
											author$project$PlayFab$User$rememberIdToString,
											author$project$PlayFab$User$rememberId(user));
										if (_n8.$ === 1) {
											return '(none)';
										} else {
											var rid = _n8.a;
											return rid;
										}
									}();
									return A2(
										elm$html$Html$div,
										_List_Nil,
										_List_fromArray(
											[
												elm$html$Html$text('remember-me: ' + id)
											]));
								}()
								]))
						]))
				]) : _List_Nil);
	});
var author$project$Page$User$viewBody = F2(
	function (session, gd) {
		var lang = A2(author$project$View$Lang$gameDataToLang, session, gd);
		var _n0 = author$project$Session$userState(session);
		switch (_n0.$) {
			case 0:
				return _List_Nil;
			case 1:
				return _List_fromArray(
					[author$project$View$Icon$loading]);
			case 2:
				var err = _n0.a;
				return _List_fromArray(
					[
						A2(
						elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								elm$html$Html$text(
								author$project$PlayFab$Error$toString(err))
							]))
					]);
			default:
				if (_n0.a.$ === 1) {
					var _n1 = _n0.a;
					return _List_fromArray(
						[
							A2(
							elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									lang.q(author$project$View$Lang$ViewUserAnonymous)
								])),
							A2(
							elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											elm$html$Html$a,
											_List_fromArray(
												[
													elm$html$Html$Attributes$class('btn btn-link'),
													A2(
													author$project$Route$href,
													author$project$Session$query(session),
													author$project$Route$Login)
												]),
											_List_fromArray(
												[
													lang.q(author$project$View$Lang$ViewUserAnonymousLogin)
												]))
										])),
									A2(
									elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											elm$html$Html$a,
											_List_fromArray(
												[
													elm$html$Html$Attributes$class('btn btn-link'),
													A2(
													author$project$Route$href,
													author$project$Session$query(session),
													author$project$Route$Register)
												]),
											_List_fromArray(
												[
													lang.q(author$project$View$Lang$ViewUserAnonymousRegister)
												]))
										]))
								]))
						]);
				} else {
					var ustate = _n0.a.a;
					return A3(author$project$Page$User$viewReady, session, gd, ustate);
				}
		}
	});
var author$project$Page$User$view = F2(
	function (session, game) {
		return _Utils_ap(
			A2(
				elm$core$List$map,
				elm$html$Html$map(author$project$Page$User$GotTabNavMsg),
				A3(author$project$View$TabNav$viewFromGame, elm$core$Maybe$Nothing, session, game)),
			A2(
				author$project$Page$User$viewBody,
				session,
				author$project$Game$gameData(game)));
	});
var author$project$View$TabNav$viewMoreMenuPage = F2(
	function (session, game) {
		var snap = A2(author$project$Session$safeUnits, game, session);
		return _Utils_ap(
			A4(author$project$View$TabNav$view, elm$core$Maybe$Nothing, session, game, snap),
			_List_fromArray(
				[
					A2(
					elm$html$Html$div,
					_List_Nil,
					A3(author$project$View$TabNav$viewMoreDropdownEntries, session, game, snap))
				]));
	});
var author$project$Main$viewBody = F2(
	function (model, game) {
		switch (model.$) {
			case 0:
				var s = model.a;
				return A2(author$project$Page$NotFound$view, s, game);
			case 1:
				var m = model.a;
				return A2(
					elm$core$List$map,
					elm$html$Html$map(author$project$Main$GotDebugMsg),
					A2(author$project$Page$Debug$view, m, game));
			case 3:
				var s = model.a;
				return A2(
					elm$core$List$map,
					elm$html$Html$map(author$project$Main$GotTabMsg),
					A2(author$project$Page$Tab$view, s, game));
			case 4:
				var m = model.a;
				return A2(
					elm$core$List$map,
					elm$html$Html$map(author$project$Main$GotUnitMsg),
					A2(author$project$Page$Unit$view, m, game));
			case 5:
				var m = model.a;
				return A2(
					elm$core$List$map,
					elm$html$Html$map(author$project$Main$GotSpellMsg),
					A2(author$project$Page$Spell$view, m, game));
			case 2:
				var m = model.a;
				return A2(
					elm$core$List$map,
					elm$html$Html$map(author$project$Main$GotMtxShopMsg),
					A2(author$project$Page$MtxShop$view, m, game));
			case 6:
				var s = model.a;
				return A2(
					elm$core$List$map,
					elm$html$Html$map(author$project$Main$GotAchievementsMsg),
					A2(author$project$Page$Achievements$view, s, game));
			case 7:
				var m = model.a;
				return A2(
					elm$core$List$map,
					elm$html$Html$map(author$project$Main$GotOptionsMsg),
					A2(author$project$Page$Options$view, m, game));
			case 8:
				var s = model.a;
				return A2(
					elm$core$List$map,
					elm$html$Html$map(author$project$Main$GotStatisticsMsg),
					A2(author$project$Page$Statistics$view, s, game));
			case 9:
				var s = model.a;
				return A2(
					elm$core$List$map,
					elm$html$Html$map(author$project$Main$GotChangelogMsg),
					A2(author$project$Page$Changelog$view, s, game));
			case 10:
				var s = model.a;
				return A2(
					elm$core$List$map,
					elm$html$Html$map(author$project$Main$GotUserMsg),
					A2(author$project$Page$User$view, s, game));
			case 11:
				var s = model.a;
				return A2(
					elm$core$List$map,
					elm$html$Html$map(author$project$Main$GotMtxHistoryMsg),
					A2(author$project$Page$MtxHistory$view, s, game));
			case 12:
				var m = model.a;
				return A2(
					elm$core$List$map,
					elm$html$Html$map(author$project$Main$GotLoginMsg),
					A2(
						author$project$Page$Login$view,
						m,
						author$project$Game$gameData(game)));
			case 13:
				var m = model.a;
				return A2(
					elm$core$List$map,
					elm$html$Html$map(author$project$Main$GotRegisterMsg),
					A2(
						author$project$Page$Register$view,
						m,
						author$project$Game$gameData(game)));
			case 14:
				var m = model.a;
				return A2(
					elm$core$List$map,
					elm$html$Html$map(author$project$Main$GotResetPasswordMsg),
					A2(
						author$project$Page$ResetPassword$view,
						m,
						author$project$Game$gameData(game)));
			case 15:
				var s = model.a;
				return author$project$Page$PaypalDone$view;
			case 16:
				var s = model.a;
				return A2(
					elm$core$List$map,
					elm$html$Html$map(author$project$Main$GotMoreMenuMsg),
					A2(author$project$View$TabNav$viewMoreMenuPage, s, game));
			default:
				var m = model.a;
				return A2(
					elm$core$List$map,
					elm$html$Html$map(author$project$Main$GotTranslatorMsg),
					A2(author$project$Page$Translator$view, m, game));
		}
	});
var author$project$Session$errors = A2(
	elm$core$Basics$composeR,
	author$project$Session$unwrap,
	function ($) {
		return $.ab;
	});
var author$project$Session$error = A2(elm$core$Basics$composeR, author$project$Session$errors, elm$core$List$head);
var author$project$View$Error$ResetSavedGame = 1;
var author$project$View$Error$errorReportUrl = F2(
	function (session, message) {
		return 'https://docs.google.com/forms/d/e/1FAIpQLSfffiBB3W9PIoVW-dV1v-2LggyjL4Iws5xezM_B3pw4ci4EJw/viewform?usp=pp_url&entry.318271744=' + (message + ('&entry.1808064759=' + A2(
			elm$core$Maybe$withDefault,
			'(empty)',
			author$project$Session$persistExport(session))));
	});
var author$project$View$Lang$ViewErrorGameBug = {$: 22};
var author$project$View$Lang$ViewErrorGameExport = {$: 21};
var author$project$View$Lang$ViewErrorGameLoad = {$: 20};
var author$project$View$Lang$ViewErrorGameReportButton = {$: 23};
var author$project$View$Lang$ViewErrorGameResetButton = {$: 24};
var elm$html$Html$Attributes$readonly = elm$html$Html$Attributes$boolProperty('readOnly');
var author$project$View$Error$viewGameError = F3(
	function (session, gd, message) {
		var query = author$project$Session$query(session);
		var persistExport = function () {
			var _n0 = author$project$Session$persistExport(session);
			if (_n0.$ === 1) {
				return '(unknown)';
			} else {
				var str = _n0.a;
				return str;
			}
		}();
		var lang = A2(author$project$View$Lang$gameDataToLang, session, gd);
		return _List_fromArray(
			[
				A2(
				elm$html$Html$div,
				_List_fromArray(
					[
						elm$html$Html$Attributes$class('error-container alert alert-danger'),
						A2(elm$html$Html$Attributes$attribute, 'role', 'alert')
					]),
				_List_fromArray(
					[
						A2(
						elm$html$Html$div,
						_List_fromArray(
							[
								elm$html$Html$Attributes$class('container')
							]),
						_List_fromArray(
							[
								A2(
								elm$html$Html$h1,
								_List_fromArray(
									[
										elm$html$Html$Attributes$class('alert-heading')
									]),
								_List_fromArray(
									[
										lang.q(author$project$View$Lang$ViewErrorTitle)
									])),
								A2(
								elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										lang.q(author$project$View$Lang$ViewErrorGameLoad)
									])),
								A2(
								elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										lang.q(author$project$View$Lang$ViewErrorGameExport),
										A2(
										elm$html$Html$input,
										_List_fromArray(
											[
												elm$html$Html$Attributes$readonly(true),
												elm$html$Html$Attributes$value(persistExport)
											]),
										_List_Nil)
									])),
								A2(
								elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										lang.q(author$project$View$Lang$ViewErrorGameBug),
										A2(
										elm$html$Html$a,
										_List_fromArray(
											[
												elm$html$Html$Attributes$class('btn btn-info'),
												elm$html$Html$Attributes$target('_blank'),
												elm$html$Html$Attributes$href(
												A2(author$project$View$Error$errorReportUrl, session, message))
											]),
										_List_fromArray(
											[
												lang.q(author$project$View$Lang$ViewErrorGameReportButton)
											]))
									])),
								A2(
								elm$html$Html$pre,
								_List_Nil,
								_List_fromArray(
									[
										elm$html$Html$text(message)
									])),
								A2(
								elm$html$Html$button,
								_List_fromArray(
									[
										elm$html$Html$Attributes$class('btn btn-danger'),
										A2(elm$html$Html$Attributes$attribute, 'aria-label', 'close'),
										elm$html$Html$Events$onClick(1)
									]),
								_List_fromArray(
									[
										lang.q(author$project$View$Lang$ViewErrorGameResetButton)
									]))
							]))
					]))
			]);
	});
var author$project$View$Error$IgnoreSessionError = 0;
var author$project$View$Lang$ViewErrorCloseButton = {$: 19};
var author$project$View$Lang$ViewErrorMore = function (a) {
	return {$: 18, a: a};
};
var author$project$View$Lang$ViewErrorTime = function (a) {
	return {$: 16, a: a};
};
var author$project$View$Lang$ViewErrorTimeUnknown = {$: 17};
var author$project$View$Error$viewSessionError = F4(
	function (session, gd, message, mtime) {
		var time = A2(
			elm$core$Maybe$withDefault,
			author$project$View$Lang$ViewErrorTimeUnknown,
			A3(
				elm$core$Maybe$map2,
				F2(
					function (now, at) {
						return author$project$View$Lang$ViewErrorTime(
							{bR: at, cm: now});
					}),
				author$project$Session$now(session),
				mtime));
		var query = author$project$Session$query(session);
		var moreErrors = elm$core$List$length(
			author$project$Session$errors(session)) - 1;
		var lang = A2(author$project$View$Lang$gameDataToLang, session, gd);
		return _List_fromArray(
			[
				A2(
				elm$html$Html$div,
				_List_fromArray(
					[
						elm$html$Html$Attributes$class('error-container alert alert-danger'),
						A2(elm$html$Html$Attributes$attribute, 'role', 'alert')
					]),
				_List_fromArray(
					[
						A2(
						elm$html$Html$div,
						_List_fromArray(
							[
								elm$html$Html$Attributes$class('container')
							]),
						_List_fromArray(
							[
								A2(
								elm$html$Html$button,
								_List_fromArray(
									[
										elm$html$Html$Attributes$class('close'),
										A2(elm$html$Html$Attributes$attribute, 'aria-label', 'close'),
										elm$html$Html$Events$onClick(0)
									]),
								_List_fromArray(
									[
										A2(
										elm$html$Html$span,
										_List_fromArray(
											[
												A2(elm$html$Html$Attributes$attribute, 'aria-hidden', 'true')
											]),
										_List_fromArray(
											[
												elm$html$Html$text('×')
											]))
									])),
								A2(
								elm$html$Html$h1,
								_List_fromArray(
									[
										elm$html$Html$Attributes$class('alert-heading')
									]),
								_List_fromArray(
									[
										lang.q(author$project$View$Lang$ViewErrorTitle)
									])),
								A2(
								elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										lang.q(time)
									])),
								A2(
								elm$html$Html$p,
								_List_Nil,
								(moreErrors <= 0) ? _List_Nil : _List_fromArray(
									[
										lang.q(
										author$project$View$Lang$ViewErrorMore(moreErrors))
									])),
								A2(
								elm$html$Html$pre,
								_List_Nil,
								_List_fromArray(
									[
										elm$html$Html$text(message)
									])),
								A2(
								elm$html$Html$button,
								_List_fromArray(
									[
										elm$html$Html$Attributes$class('btn btn-danger'),
										A2(elm$html$Html$Attributes$attribute, 'aria-label', 'close'),
										elm$html$Html$Events$onClick(0)
									]),
								_List_fromArray(
									[
										lang.q(author$project$View$Lang$ViewErrorCloseButton)
									]))
							]))
					]))
			]);
	});
var author$project$FrameRate$maximum = function (fr) {
	return A3(
		elm$core$List$foldl,
		author$project$Duration$max,
		author$project$Duration$zero,
		function () {
			if (!fr.$) {
				return _List_Nil;
			} else {
				var frames = fr.b;
				return frames;
			}
		}());
};
var author$project$Duration$sum = A2(
	elm$core$Basics$composeR,
	elm$core$List$map(author$project$Duration$toMillis),
	A2(elm$core$Basics$composeR, elm$core$List$sum, author$project$Duration$fromMillis));
var author$project$Duration$mean = function (ds) {
	return author$project$Duration$fromMillis(
		(author$project$Duration$toMillis(
			author$project$Duration$sum(ds)) / A2(
			elm$core$Basics$max,
			1,
			elm$core$List$length(ds))) | 0);
};
var author$project$FrameRate$toAverage = function (fr) {
	if (!fr.$) {
		return author$project$Duration$zero;
	} else {
		var frames = fr.b;
		return author$project$Duration$mean(frames);
	}
};
var author$project$FrameRate$toFPS = function (fr) {
	return (1000 / author$project$Duration$toMillis(
		author$project$FrameRate$toAverage(fr))) | 0;
};
var author$project$Game$newAchievements = A2(
	elm$core$Basics$composeR,
	author$project$Game$unwrap,
	function ($) {
		return $.A;
	});
var author$project$Session$frameRate = A2(
	elm$core$Basics$composeR,
	author$project$Session$unwrap,
	function ($) {
		return $.ad;
	});
var author$project$Session$serviceWorker = A2(
	elm$core$Basics$composeR,
	author$project$Session$unwrap,
	function ($) {
		return $.by;
	});
var author$project$Session$timezone = A2(
	elm$core$Basics$composeR,
	author$project$Session$unwrap,
	function ($) {
		return $.a4;
	});
var author$project$Game$achievementProgress = function (_n0) {
	var g = _n0;
	return author$project$Game$Achievement$progress(g);
};
var author$project$Game$fadeNewAchievement = F2(
	function (now, game) {
		var g = game;
		var _n0 = g.A;
		if (_n0.$ === 1) {
			return false;
		} else {
			var _n1 = _n0.a;
			var started = _n1.a;
			return _Utils_cmp(
				elm$time$Time$posixToMillis(now),
				elm$time$Time$posixToMillis(started) + 4000) > -1;
		}
	});
var author$project$View$Header$AchievementToastClose = 1;
var author$project$View$Lang$ViewAchievementsEntryUnlocked = {$: 109};
var author$project$View$Header$viewAchievementToast = F3(
	function (session, game, _n0) {
		var achievement = _n0.b;
		var query = author$project$Session$query(session);
		var progdesc = A2(
			author$project$Page$Achievements$toProgdesc,
			author$project$Game$gameData(game),
			A2(author$project$Game$achievementProgress, game, achievement));
		var lang = A2(author$project$View$Lang$gameToLang, session, game);
		var fade = A2(
			author$project$Game$fadeNewAchievement,
			A2(author$project$Session$safeNow, game, session),
			game);
		return A2(
			elm$html$Html$div,
			_List_fromArray(
				[
					elm$html$Html$Attributes$class('container alert alert-success achievement-toast'),
					elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('achievement-show', !fade),
							_Utils_Tuple2('achievement-hide', fade)
						])),
					A2(elm$html$Html$Attributes$attribute, 'role', 'status'),
					A2(elm$html$Html$Attributes$attribute, 'aria-live', 'polite')
				]),
			_List_fromArray(
				[
					A2(
					elm$html$Html$div,
					_List_fromArray(
						[
							elm$html$Html$Attributes$class('row')
						]),
					_List_fromArray(
						[
							A2(
							elm$html$Html$div,
							_List_fromArray(
								[
									elm$html$Html$Attributes$class('col-11')
								]),
							_List_Nil),
							A2(
							elm$html$Html$div,
							_List_fromArray(
								[
									elm$html$Html$Attributes$class('col-1 close')
								]),
							_List_fromArray(
								[
									A2(
									elm$html$Html$button,
									_List_fromArray(
										[
											elm$html$Html$Attributes$class('btn btn-link'),
											A2(elm$html$Html$Attributes$style, 'padding', '0'),
											A2(elm$html$Html$Attributes$style, 'margin', '0'),
											elm$html$Html$Events$onClick(1)
										]),
									_List_fromArray(
										[
											elm$html$Html$text('×')
										]))
								]))
						])),
					A2(
					elm$html$Html$div,
					_List_fromArray(
						[
							elm$html$Html$Attributes$class('row')
						]),
					_List_fromArray(
						[
							A2(
							elm$html$Html$div,
							_List_fromArray(
								[
									elm$html$Html$Attributes$class('icon col-2')
								]),
							_List_fromArray(
								[
									author$project$View$Icon$fas('trophy')
								])),
							A2(
							elm$html$Html$div,
							_List_fromArray(
								[
									elm$html$Html$Attributes$class('body col-8')
								]),
							_List_fromArray(
								[
									A2(
									elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											elm$html$Html$small,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													elm$html$Html$i,
													_List_Nil,
													_List_fromArray(
														[
															lang.q(author$project$View$Lang$ViewAchievementsEntryUnlocked)
														]))
												]))
										])),
									A2(
									elm$html$Html$h3,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											elm$html$Html$a,
											_List_fromArray(
												[
													elm$html$Html$Attributes$class('alert-link'),
													A2(author$project$Route$href, query, author$project$Route$Achievements)
												]),
											_List_fromArray(
												[
													lang.q(
													author$project$View$Lang$AchievementName(achievement.eL))
												]))
										])),
									A2(
									elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											lang.q(
											A2(author$project$View$Lang$AchievementDesc, achievement.eL, progdesc))
										])),
									A2(
									elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											elm$html$Html$small,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													elm$html$Html$i,
													_List_Nil,
													_List_fromArray(
														[
															lang.q(
															author$project$View$Lang$AchievementLongDesc(achievement.eL))
														]))
												]))
										]))
								])),
							A2(
							elm$html$Html$div,
							_List_fromArray(
								[
									elm$html$Html$Attributes$class('col-2 points')
								]),
							_List_fromArray(
								[
									elm$html$Html$text(
									'+' + elm$core$String$fromInt(achievement.cs))
								]))
						]))
				]));
	});
var author$project$View$Header$Refresh = 0;
var author$project$View$Lang$ServiceWorkerUpdateDownloaded = {$: 3};
var author$project$View$Header$viewServiceWorker = F2(
	function (lang, lastEvent) {
		if (lastEvent.$ === 1) {
			return A2(elm$html$Html$span, _List_Nil, _List_Nil);
		} else {
			switch (lastEvent.a) {
				case 0:
					var _n1 = lastEvent.a;
					return A2(elm$html$Html$span, _List_Nil, _List_Nil);
				case 1:
					var _n2 = lastEvent.a;
					return A2(elm$html$Html$span, _List_Nil, _List_Nil);
				default:
					var _n3 = lastEvent.a;
					return A2(
						elm$html$Html$button,
						_List_fromArray(
							[
								elm$html$Html$Attributes$class('navbar-brand btn btn-link btn-primary'),
								elm$html$Html$Events$onClick(0)
							]),
						_List_fromArray(
							[
								author$project$View$Icon$fas('wrench'),
								lang.q(author$project$View$Lang$ServiceWorkerUpdateDownloaded)
							]));
			}
		}
	});
var author$project$View$Lang$FrameRate = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var author$project$View$Lang$Header = {$: 1};
var author$project$View$Lang$ViewFoolsAfterLink = {$: 132};
var author$project$View$Lang$ViewFoolsAfterTitle = {$: 131};
var author$project$View$Lang$ViewFoolsInvitedBody = {$: 125};
var author$project$View$Lang$ViewFoolsInvitedLink = {$: 126};
var author$project$View$Lang$ViewFoolsInvitedLol = {$: 123};
var author$project$View$Lang$ViewFoolsInvitedTitle = {$: 124};
var author$project$View$Lang$ViewFoolsOnBody = {$: 129};
var author$project$View$Lang$ViewFoolsOnLol = {$: 127};
var author$project$View$Lang$ViewFoolsOnTitle = {$: 128};
var author$project$View$Header$view = F2(
	function (session, gameData) {
		var query = author$project$Session$query(session);
		var lang = A2(author$project$View$Lang$gameDataToLang, session, gameData);
		var fps = A2(
			elm$core$Maybe$map,
			function (fr) {
				return A2(
					author$project$View$Lang$FrameRate,
					author$project$FrameRate$toFPS(fr),
					{
						eg: author$project$FrameRate$toAverage(fr),
						dw: author$project$FrameRate$maximum(fr)
					});
			},
			author$project$Session$frameRate(session));
		var date = function (mmdd) {
			var _n4 = _Utils_Tuple2(
				author$project$Session$now(session),
				author$project$Session$timezone(session));
			if ((!_n4.a.$) && (!_n4.b.$)) {
				var now = _n4.a.a;
				var tz = _n4.b.a;
				return elm$core$String$fromInt(
					A2(elm$time$Time$toYear, tz, now)) + ('/' + mmdd);
			} else {
				return '';
			}
		};
		return _Utils_ap(
			_List_fromArray(
				[
					A2(
					elm$html$Html$div,
					_List_fromArray(
						[
							elm$html$Html$Attributes$class('container header')
						]),
					_List_fromArray(
						[
							A2(
							elm$html$Html$div,
							_List_fromArray(
								[
									elm$html$Html$Attributes$class('navbar'),
									elm$html$Html$Attributes$class('navbar-light'),
									elm$html$Html$Attributes$class('bg-light'),
									elm$html$Html$Attributes$class('border'),
									elm$html$Html$Attributes$class('rounded')
								]),
							_List_fromArray(
								[
									A2(
									elm$html$Html$div,
									_List_fromArray(
										[
											elm$html$Html$Attributes$class('navbar-brand')
										]),
									_List_fromArray(
										[
											A2(
											elm$html$Html$a,
											_List_fromArray(
												[
													elm$html$Html$Attributes$class('navbar-brand page-title'),
													A2(author$project$Route$href, query, author$project$Route$Home),
													elm$html$Html$Attributes$tabindex(1)
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$span,
													_List_Nil,
													_List_fromArray(
														[
															lang.q(author$project$View$Lang$Header)
														]))
												])),
											A2(
											elm$html$Html$a,
											_List_fromArray(
												[
													elm$html$Html$Attributes$class('navbar-brand header-version'),
													elm$html$Html$Attributes$class('text-muted'),
													A2(author$project$Route$href, query, author$project$Route$Changelog)
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$small,
													_List_Nil,
													_List_fromArray(
														[
															elm$html$Html$text(
															author$project$Session$version(session))
														]))
												])),
											A2(
											author$project$View$Header$viewServiceWorker,
											lang,
											author$project$Session$serviceWorker(session)),
											A2(
											elm$html$Html$span,
											_List_fromArray(
												[
													elm$html$Html$Attributes$class('navbar-text'),
													elm$html$Html$Attributes$class('text-muted')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$small,
													_List_Nil,
													_List_fromArray(
														[
															A3(
															elm_community$maybe_extra$Maybe$Extra$unwrap,
															elm$html$Html$text(''),
															lang.q,
															fps)
														]))
												]))
										]))
								])),
							A2(
							elm$html$Html$code,
							_List_fromArray(
								[
									elm$html$Html$Attributes$class('environment-label')
								]),
							function () {
								var _n0 = author$project$Session$environment(session);
								if (!_n0.$) {
									return _List_Nil;
								} else {
									var env = _n0;
									return _List_fromArray(
										[
											elm$html$Html$text('(environment: '),
											elm$html$Html$text(
											author$project$Session$Environment$toString(env)),
											elm$html$Html$text(')')
										]);
								}
							}()),
							function () {
							var _n1 = author$project$Fools$status(session);
							switch (_n1) {
								case 0:
									return A2(
										elm$html$Html$div,
										_List_fromArray(
											[
												elm$html$Html$Attributes$class('alert alert-info')
											]),
										_List_fromArray(
											[
												A2(
												elm$html$Html$div,
												_List_fromArray(
													[
														elm$html$Html$Attributes$class('close'),
														A2(elm$html$Html$Attributes$attribute, 'data-dismiss', 'alert')
													]),
												_List_fromArray(
													[
														elm$html$Html$text('×')
													])),
												A2(
												elm$html$Html$div,
												_List_fromArray(
													[
														elm$html$Html$Attributes$class('float-right')
													]),
												_List_fromArray(
													[
														elm$html$Html$text(
														date('04/01'))
													])),
												A2(
												elm$html$Html$p,
												_List_fromArray(
													[
														elm$html$Html$Attributes$title(
														lang.fH(author$project$View$Lang$ViewFoolsInvitedLol))
													]),
												_List_fromArray(
													[
														A2(
														elm$html$Html$b,
														_List_Nil,
														_List_fromArray(
															[
																lang.q(author$project$View$Lang$ViewFoolsInvitedTitle)
															]))
													])),
												A2(
												elm$html$Html$p,
												_List_Nil,
												_List_fromArray(
													[
														lang.q(author$project$View$Lang$ViewFoolsInvitedBody)
													])),
												A2(
												elm$html$Html$p,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														elm$html$Html$a,
														_List_fromArray(
															[
																A2(
																author$project$Route$href,
																A3(author$project$Route$Config$insert, 2, 'on', query),
																author$project$Route$Home)
															]),
														_List_fromArray(
															[
																lang.q(author$project$View$Lang$ViewFoolsInvitedLink)
															]))
													]))
											]));
								case 1:
									return A2(
										elm$html$Html$div,
										_List_fromArray(
											[
												elm$html$Html$Attributes$class('alert alert-info')
											]),
										_List_fromArray(
											[
												A2(
												elm$html$Html$div,
												_List_fromArray(
													[
														elm$html$Html$Attributes$class('close'),
														A2(elm$html$Html$Attributes$attribute, 'data-dismiss', 'alert')
													]),
												_List_fromArray(
													[
														elm$html$Html$text('×')
													])),
												A2(
												elm$html$Html$div,
												_List_fromArray(
													[
														elm$html$Html$Attributes$class('float-right')
													]),
												_List_fromArray(
													[
														elm$html$Html$text(
														date('04/01'))
													])),
												A2(
												elm$html$Html$p,
												_List_fromArray(
													[
														elm$html$Html$Attributes$title(
														lang.fH(author$project$View$Lang$ViewFoolsOnLol))
													]),
												_List_fromArray(
													[
														A2(
														elm$html$Html$b,
														_List_Nil,
														_List_fromArray(
															[
																lang.q(author$project$View$Lang$ViewFoolsOnTitle)
															]))
													])),
												A2(
												elm$html$Html$p,
												_List_Nil,
												_List_fromArray(
													[
														lang.q(author$project$View$Lang$ViewFoolsOnBody)
													])),
												A2(
												elm$html$Html$p,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														elm$html$Html$a,
														_List_fromArray(
															[
																A2(
																author$project$Route$href,
																A3(author$project$Route$Config$insert, 2, 'invited', query),
																author$project$Route$Home)
															]),
														_List_fromArray(
															[
																elm$html$Html$text('')
															]))
													]))
											]));
								case 3:
									return A2(
										elm$html$Html$div,
										_List_fromArray(
											[
												elm$html$Html$Attributes$class('alert alert-info')
											]),
										_List_fromArray(
											[
												A2(
												elm$html$Html$div,
												_List_fromArray(
													[
														elm$html$Html$Attributes$class('close'),
														A2(elm$html$Html$Attributes$attribute, 'data-dismiss', 'alert')
													]),
												_List_fromArray(
													[
														elm$html$Html$text('×')
													])),
												A2(
												elm$html$Html$div,
												_List_fromArray(
													[
														elm$html$Html$Attributes$class('float-right')
													]),
												_List_fromArray(
													[
														elm$html$Html$text(
														date('04/02'))
													])),
												A2(
												elm$html$Html$p,
												_List_Nil,
												_List_fromArray(
													[
														lang.q(author$project$View$Lang$ViewFoolsAfterTitle)
													])),
												A2(
												elm$html$Html$p,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														elm$html$Html$a,
														_List_fromArray(
															[
																A2(
																author$project$Route$href,
																A3(author$project$Route$Config$insert, 2, 'on', query),
																author$project$Route$Home)
															]),
														_List_fromArray(
															[
																lang.q(author$project$View$Lang$ViewFoolsAfterLink)
															]))
													]))
											]));
								default:
									return A2(elm$html$Html$div, _List_Nil, _List_Nil);
							}
						}()
						]))
				]),
			function () {
				var _n2 = author$project$Session$game(session);
				if (_n2.$ === 3) {
					var game = _n2.a;
					return _List_fromArray(
						[
							A2(
							elm$html$Html$div,
							_List_fromArray(
								[
									elm$html$Html$Attributes$class('achievement-toast-container')
								]),
							function () {
								var _n3 = author$project$Game$newAchievements(game);
								if (_n3.$ === 1) {
									return _List_fromArray(
										[
											A2(
											elm$html$Html$div,
											_List_fromArray(
												[
													elm$html$Html$Attributes$class('achievement-hide')
												]),
											_List_Nil)
										]);
								} else {
									var _new = _n3.a;
									return _List_fromArray(
										[
											A3(author$project$View$Header$viewAchievementToast, session, game, _new)
										]);
								}
							}())
						]);
				} else {
					return _List_Nil;
				}
			}());
	});
var author$project$Fools$isOn = A2(
	elm$core$Basics$composeR,
	author$project$Fools$status,
	elm$core$Basics$eq(1));
var author$project$View$Header$themeHref = function (theme) {
	if (!theme) {
		return elm$html$Html$Attributes$href('/css/bootstrap/bootstrap.min.css');
	} else {
		return elm$html$Html$Attributes$href(
			'/css/bootswatch/' + (author$project$Game$Theme$toString(theme) + '/bootstrap.min.css'));
	}
};
var elm$virtual_dom$VirtualDom$node = function (tag) {
	return _VirtualDom_node(
		_VirtualDom_noScript(tag));
};
var elm$html$Html$node = elm$virtual_dom$VirtualDom$node;
var krisajenkins$remotedata$RemoteData$unwrap = F3(
	function (_default, _function, remoteData) {
		if (remoteData.$ === 3) {
			var data = remoteData.a;
			return _function(data);
		} else {
			return _default;
		}
	});
var author$project$View$Header$viewCss = function (session) {
	var theme = A3(
		krisajenkins$remotedata$RemoteData$unwrap,
		0,
		author$project$Game$theme,
		author$project$Session$game(session));
	return _Utils_ap(
		_List_fromArray(
			[
				A3(
				elm$html$Html$node,
				'link',
				_List_fromArray(
					[
						elm$html$Html$Attributes$rel('stylesheet'),
						author$project$View$Header$themeHref(theme)
					]),
				_List_Nil)
			]),
		author$project$Fools$isOn(session) ? _List_fromArray(
			[
				A3(
				elm$html$Html$node,
				'link',
				_List_fromArray(
					[
						elm$html$Html$Attributes$rel('stylesheet'),
						elm$html$Html$Attributes$href('/css/kittens.css')
					]),
				_List_Nil)
			]) : _List_Nil);
};
var elm$html$Html$iframe = _VirtualDom_node('iframe');
var author$project$View$Header$viewLocalStorageIframe = _List_fromArray(
	[
		A2(
		elm$html$Html$iframe,
		_List_fromArray(
			[
				elm$html$Html$Attributes$id('www-localstorage'),
				elm$html$Html$Attributes$src('https://www.swarmsim.com/localstorage.html'),
				A2(elm$html$Html$Attributes$style, 'display', 'none')
			]),
		_List_Nil)
	]);
var author$project$KeyCombo$names = A2(
	elm$core$Basics$composeR,
	author$project$KeyCombo$list,
	elm$core$List$map(
		function (c) {
			return _Utils_Tuple2(c.E, c.br);
		}));
var author$project$View$KeyCombo$Close = 0;
var author$project$View$KeyCombo$Noop = 1;
var author$project$View$Lang$KeyCombo = function (a) {
	return {$: 220, a: a};
};
var author$project$View$KeyCombo$viewBinding = F2(
	function (lang, _n0) {
		var c = _n0.a;
		var name = _n0.b;
		return _List_fromArray(
			[
				A2(
				elm$html$Html$dt,
				_List_Nil,
				_List_fromArray(
					[
						elm$html$Html$text(
						author$project$KeyCombo$toString(c))
					])),
				A2(
				elm$html$Html$dd,
				_List_Nil,
				_List_fromArray(
					[
						lang.q(
						author$project$View$Lang$KeyCombo(name))
					]))
			]);
	});
var author$project$View$KeyCombo$view = F3(
	function (session, gd, getBindings) {
		if (author$project$Session$keyCombosHelp(session)) {
			var lang = A2(author$project$View$Lang$gameDataToLang, session, gd);
			var bindings = author$project$KeyCombo$names(
				getBindings(0));
			return _List_fromArray(
				[
					A2(
					elm$html$Html$div,
					_List_fromArray(
						[
							elm$html$Html$Attributes$class('modal modal-open show'),
							A2(elm$html$Html$Attributes$style, 'display', 'block'),
							elm$html$Html$Attributes$tabindex(-1),
							A2(elm$html$Html$Attributes$attribute, 'role', 'dialog'),
							A2(elm$html$Html$Attributes$attribute, 'aria-hidden', 'true'),
							elm$html$Html$Events$onClick(0)
						]),
					_List_fromArray(
						[
							A2(
							elm$html$Html$div,
							_List_fromArray(
								[
									elm$html$Html$Attributes$class('modal-dialog keycombo'),
									A2(elm$html$Html$Attributes$attribute, 'role', 'document')
								]),
							_List_fromArray(
								[
									A2(
									elm$html$Html$div,
									_List_fromArray(
										[
											elm$html$Html$Attributes$class('modal-content'),
											A2(
											elm$html$Html$Events$stopPropagationOn,
											'click',
											elm$json$Json$Decode$succeed(
												_Utils_Tuple2(1, true)))
										]),
									_List_fromArray(
										[
											A2(
											elm$html$Html$div,
											_List_fromArray(
												[
													elm$html$Html$Attributes$class('modal-header')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$h5,
													_List_fromArray(
														[
															elm$html$Html$Attributes$class('modal-title')
														]),
													_List_fromArray(
														[
															author$project$View$Icon$fas('keyboard'),
															elm$html$Html$text(' '),
															lang.q(author$project$View$Lang$ViewTabHotkeys)
														])),
													A2(
													elm$html$Html$button,
													_List_fromArray(
														[
															elm$html$Html$Attributes$class('close'),
															elm$html$Html$Events$onClick(0),
															A2(elm$html$Html$Attributes$attribute, 'aria-label', 'close')
														]),
													_List_fromArray(
														[
															elm$html$Html$text('×')
														]))
												])),
											A2(
											elm$html$Html$div,
											_List_fromArray(
												[
													elm$html$Html$Attributes$class('modal-body')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$dl,
													_List_Nil,
													elm$core$List$concat(
														A2(
															elm$core$List$map,
															author$project$View$KeyCombo$viewBinding(lang),
															bindings)))
												])),
											A2(
											elm$html$Html$div,
											_List_fromArray(
												[
													elm$html$Html$Attributes$class('modal-footer')
												]),
											_List_Nil)
										]))
								]))
						])),
					A2(
					elm$html$Html$div,
					_List_fromArray(
						[
							elm$html$Html$Attributes$class('modal-backdrop show')
						]),
					_List_Nil)
				]);
		} else {
			return _List_Nil;
		}
	});
var author$project$View$Lang$Title = {$: 0};
var author$project$Game$OfflineSync$modalId = 'offlineSyncConflict';
var author$project$Decimal$isAlmostEqual = F3(
	function (allowedError, a, b) {
		if (_Utils_eq(b, author$project$Decimal$zero)) {
			return _Utils_eq(a, author$project$Decimal$zero);
		} else {
			var _n0 = A2(author$project$Decimal$compare, a, b);
			switch (_n0) {
				case 1:
					return true;
				case 2:
					return _Utils_cmp(
						elm$core$Basics$abs(
							author$project$Decimal$toFloat(
								A2(author$project$Decimal$div, a, b))),
						elm$core$Basics$abs(allowedError)) < 1;
				default:
					return _Utils_cmp(
						elm$core$Basics$abs(
							author$project$Decimal$toFloat(
								A2(author$project$Decimal$div, b, a))),
						elm$core$Basics$abs(allowedError)) < 1;
			}
		}
	});
var author$project$Select$unitCountsDiff = F2(
	function (_n0, _n1) {
		var game1 = _n0.a;
		var snap1 = _n0.b;
		var game2 = _n1.a;
		var snap2 = _n1.b;
		var isVisible = function (u) {
			return A2(author$project$Select$isUnitVisible, snap1, u) || A2(author$project$Select$isUnitVisible, snap2, u);
		};
		var countDiff = function (u) {
			var count2 = A2(author$project$Game$UnitsSnapshot$count, u.eL, snap2);
			var count1 = A2(author$project$Game$UnitsSnapshot$count, u.eL, snap1);
			return _Utils_Tuple2(
				u,
				A3(author$project$Decimal$isAlmostEqual, 1.001, count1, count2) ? elm$core$Result$Ok(count1) : elm$core$Result$Err(
					_Utils_Tuple2(count1, count2)));
		};
		return A2(
			elm$core$List$map,
			countDiff,
			A2(
				elm$core$List$filter,
				isVisible,
				author$project$GameData$units(
					author$project$Game$gameData(game1))));
	});
var author$project$View$Lang$ViewConflictButtonLocal = {$: 139};
var author$project$View$Lang$ViewConflictButtonLogout = {$: 140};
var author$project$View$Lang$ViewConflictButtonRemote = {$: 141};
var author$project$View$Lang$ViewConflictDesc = {$: 134};
var author$project$View$Lang$ViewConflictExportLocal = {$: 135};
var author$project$View$Lang$ViewConflictExportRemote = {$: 136};
var author$project$View$Lang$ViewConflictGameCreated = function (a) {
	return {$: 137, a: a};
};
var author$project$View$Lang$ViewConflictGameEncoded = function (a) {
	return {$: 138, a: a};
};
var author$project$View$Lang$ViewConflictTitle = {$: 133};
var author$project$View$OfflineSync$UseLocalOverwriteRemote = 0;
var author$project$View$OfflineSync$UseLocalWithLogout = 2;
var author$project$View$OfflineSync$UseRemoteOverwriteLocal = 1;
var author$project$View$OfflineSync$nbsp = '\u00a0';
var author$project$View$OfflineSync$viewDiffLine = F2(
	function (a, b) {
		return A2(
			elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					elm$html$Html$div,
					_List_fromArray(
						[
							elm$html$Html$Attributes$class('bg-success'),
							A2(elm$html$Html$Attributes$style, 'width', '100%')
						]),
					_List_fromArray(
						[
							A2(
							elm$html$Html$div,
							_List_fromArray(
								[
									A2(elm$html$Html$Attributes$style, 'float', 'left')
								]),
							_List_fromArray(
								[
									elm$html$Html$text('+' + author$project$View$OfflineSync$nbsp)
								])),
							A2(
							elm$html$Html$div,
							_List_fromArray(
								[
									A2(elm$html$Html$Attributes$style, 'float', 'left')
								]),
							a),
							A2(
							elm$html$Html$div,
							_List_fromArray(
								[
									A2(elm$html$Html$Attributes$style, 'clear', 'left')
								]),
							_List_Nil)
						])),
					A2(
					elm$html$Html$div,
					_List_fromArray(
						[
							elm$html$Html$Attributes$class('bg-info'),
							A2(elm$html$Html$Attributes$style, 'width', '100%')
						]),
					_List_fromArray(
						[
							A2(
							elm$html$Html$div,
							_List_fromArray(
								[
									A2(elm$html$Html$Attributes$style, 'float', 'left')
								]),
							_List_fromArray(
								[
									elm$html$Html$text('−' + author$project$View$OfflineSync$nbsp)
								])),
							A2(
							elm$html$Html$div,
							_List_fromArray(
								[
									A2(elm$html$Html$Attributes$style, 'float', 'left')
								]),
							b),
							A2(
							elm$html$Html$div,
							_List_fromArray(
								[
									A2(elm$html$Html$Attributes$style, 'clear', 'left')
								]),
							_List_Nil)
						]))
				]));
	});
var author$project$View$OfflineSync$viewTextDiffLine = F2(
	function (a, b) {
		return _Utils_eq(a, b) ? A2(
			elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					elm$html$Html$text(a)
				])) : A2(
			author$project$View$OfflineSync$viewDiffLine,
			_List_fromArray(
				[
					elm$html$Html$text(a)
				]),
			_List_fromArray(
				[
					elm$html$Html$text(b)
				]));
	});
var author$project$View$OfflineSync$viewUnitDiffEntry = F3(
	function (session, game, _n0) {
		var unit = _n0.a;
		var diff = _n0.b;
		var lang = A2(author$project$View$Lang$gameToLang, session, game);
		var line = function (count) {
			return _List_fromArray(
				[
					A2(
					elm$html$Html$span,
					_List_fromArray(
						[
							elm$html$Html$Attributes$class('list-label')
						]),
					_List_fromArray(
						[
							A2(
							elm$html$Html$span,
							_List_fromArray(
								[
									elm$html$Html$Attributes$class('list-icon-resource'),
									elm$html$Html$Attributes$class(
									'icon-' + author$project$GameData$Unit$name(unit))
								]),
							_List_Nil),
							lang.q(
							author$project$View$Lang$ViewUnitSidebarUnitName(unit.eL)),
							elm$html$Html$text(': ')
						])),
					A2(
					elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							lang.q(
							author$project$View$Lang$ViewUnitSidebarCount(count))
						]))
				]);
		};
		if (!diff.$) {
			var count = diff.a;
			return line(count);
		} else {
			var _n2 = diff.a;
			var count1 = _n2.a;
			var count2 = _n2.b;
			return _List_fromArray(
				[
					A2(
					author$project$View$OfflineSync$viewDiffLine,
					line(count1),
					line(count2))
				]);
		}
	});
var author$project$View$OfflineSync$view = F3(
	function (session, gameData, conflict) {
		var remoteSnap = A2(
			author$project$Game$evalUnits,
			A2(author$project$Session$safeNow, conflict.cv.ae, session),
			conflict.cv.ae);
		var localSnap = A2(
			author$project$Game$evalUnits,
			A2(author$project$Session$safeNow, conflict.b8.ae, session),
			conflict.b8.ae);
		var lang = A2(author$project$View$Lang$gameDataToLang, session, gameData);
		var diff = A2(
			author$project$Select$unitCountsDiff,
			_Utils_Tuple2(conflict.b8.ae, localSnap),
			_Utils_Tuple2(conflict.cv.ae, remoteSnap));
		return _List_fromArray(
			[
				A2(
				elm$html$Html$div,
				_List_fromArray(
					[
						elm$html$Html$Attributes$id(author$project$Game$OfflineSync$modalId),
						elm$html$Html$Attributes$class('conflict card bg-warning'),
						A2(elm$html$Html$Attributes$attribute, 'role', 'dialog')
					]),
				_List_fromArray(
					[
						A2(
						elm$html$Html$div,
						_List_fromArray(
							[
								elm$html$Html$Attributes$class('card-header')
							]),
						_List_fromArray(
							[
								A2(
								elm$html$Html$h5,
								_List_fromArray(
									[
										elm$html$Html$Attributes$class('card-title')
									]),
								_List_fromArray(
									[
										author$project$View$Icon$fas('exclamation-triangle'),
										elm$html$Html$text(' '),
										lang.q(author$project$View$Lang$ViewConflictTitle)
									]))
							])),
						A2(
						elm$html$Html$div,
						_List_fromArray(
							[
								elm$html$Html$Attributes$class('card-body')
							]),
						_List_fromArray(
							[
								A2(
								elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										lang.q(author$project$View$Lang$ViewConflictDesc)
									])),
								A2(elm$html$Html$hr, _List_Nil, _List_Nil),
								A2(
								elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										author$project$View$OfflineSync$viewDiffLine,
										_List_fromArray(
											[
												lang.q(author$project$View$Lang$ViewConflictExportLocal),
												A2(
												elm$html$Html$input,
												_List_fromArray(
													[
														elm$html$Html$Attributes$readonly(true),
														elm$html$Html$Attributes$value(conflict.b8.bj)
													]),
												_List_Nil)
											]),
										_List_fromArray(
											[
												lang.q(author$project$View$Lang$ViewConflictExportRemote),
												A2(
												elm$html$Html$input,
												_List_fromArray(
													[
														elm$html$Html$Attributes$readonly(true),
														elm$html$Html$Attributes$value(conflict.cv.bj)
													]),
												_List_Nil)
											])),
										A2(
										author$project$View$OfflineSync$viewTextDiffLine,
										lang.fH(
											author$project$View$Lang$ViewConflictGameCreated(
												author$project$Game$created(conflict.b8.ae))),
										lang.fH(
											author$project$View$Lang$ViewConflictGameCreated(
												author$project$Game$created(conflict.cv.ae)))),
										A2(
										author$project$View$OfflineSync$viewTextDiffLine,
										lang.fH(
											author$project$View$Lang$ViewConflictGameEncoded(
												author$project$Game$encoded(conflict.b8.ae))),
										lang.fH(
											author$project$View$Lang$ViewConflictGameEncoded(
												author$project$Game$encoded(conflict.cv.ae)))),
										A2(elm$html$Html$hr, _List_Nil, _List_Nil),
										A2(
										elm$html$Html$div,
										_List_Nil,
										A2(
											elm$core$List$map,
											A2(
												elm$core$Basics$composeR,
												A2(author$project$View$OfflineSync$viewUnitDiffEntry, session, conflict.b8.ae),
												elm$html$Html$div(_List_Nil)),
											diff)),
										A2(elm$html$Html$hr, _List_Nil, _List_Nil),
										A2(
										author$project$View$OfflineSync$viewDiffLine,
										_List_fromArray(
											[
												A2(
												elm$html$Html$div,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														elm$html$Html$button,
														_List_fromArray(
															[
																elm$html$Html$Attributes$class('btn btn-primary'),
																A2(elm$html$Html$Attributes$attribute, 'aria-label', 'close'),
																elm$html$Html$Events$onClick(0)
															]),
														_List_fromArray(
															[
																lang.q(author$project$View$Lang$ViewConflictButtonLocal)
															]))
													])),
												A2(
												elm$html$Html$div,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														elm$html$Html$button,
														_List_fromArray(
															[
																elm$html$Html$Attributes$class('btn btn-secondary'),
																A2(elm$html$Html$Attributes$attribute, 'aria-label', 'close'),
																elm$html$Html$Events$onClick(2)
															]),
														_List_fromArray(
															[
																lang.q(author$project$View$Lang$ViewConflictButtonLogout)
															]))
													]))
											]),
										_List_fromArray(
											[
												A2(
												elm$html$Html$div,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														elm$html$Html$button,
														_List_fromArray(
															[
																elm$html$Html$Attributes$class('btn btn-primary'),
																A2(elm$html$Html$Attributes$attribute, 'aria-label', 'close'),
																elm$html$Html$Events$onClick(1)
															]),
														_List_fromArray(
															[
																lang.q(author$project$View$Lang$ViewConflictButtonRemote)
															]))
													]))
											]))
									]))
							]))
					]))
			]);
	});
var author$project$Game$Tutorial$FirstAscension = 10;
var author$project$Game$Tutorial$FirstDrone = 0;
var author$project$Game$Tutorial$FirstExpansion = 8;
var author$project$Game$Tutorial$FirstHatchery = 2;
var author$project$Game$Tutorial$FirstMutagen = 11;
var author$project$Game$Tutorial$FirstNotify = 3;
var author$project$Game$Tutorial$FirstQueen = 4;
var author$project$Game$Tutorial$FirstTerritory = 6;
var author$project$Game$Tutorial$MoreDrones = 1;
var author$project$Game$Tutorial$MoreExpansions = 9;
var author$project$Game$Tutorial$MoreQueens = 5;
var author$project$Game$Tutorial$MoreTerritory = 7;
var author$project$Game$Tutorial$step = function (_n0) {
	var undo = _n0.fW;
	var game = _n0.ae;
	var units = _n0.k;
	var upgradesDict = author$project$Game$upgradesDict(game);
	var upgrade = function (name) {
		return A3(
			elm_community$maybe_extra$Maybe$Extra$unwrap,
			0,
			author$project$Decimal$toFloat,
			A2(elm$core$Dict$get, name, upgradesDict));
	};
	var unitsDict = author$project$Game$UnitsSnapshot$toDict(units);
	var unit = function (name) {
		return A3(
			elm_community$maybe_extra$Maybe$Extra$unwrap,
			0,
			author$project$Decimal$toFloat,
			A2(elm$core$Dict$get, name, unitsDict));
	};
	var undoUnitsDict = A2(
		elm$core$Maybe$map,
		A2(elm$core$Basics$composeR, author$project$Game$units, author$project$Game$UnitsSnapshot$toDict),
		undo);
	var undoUnit = F2(
		function (name, _default) {
			return A3(
				elm_community$maybe_extra$Maybe$Extra$unwrap,
				_default,
				A2(
					elm$core$Basics$composeR,
					elm$core$Dict$get(name),
					A2(elm_community$maybe_extra$Maybe$Extra$unwrap, 0, author$project$Decimal$toFloat)),
				undoUnitsDict);
		});
	return (unit('ascension') > 0) ? (((unit('ascension') === 1) && (!A2(undoUnit, 'ascension', -1))) ? elm$core$Maybe$Just(11) : elm$core$Maybe$Nothing) : (((unit('premutagen') > 0) && (!A2(undoUnit, 'premutagen', -1))) ? elm$core$Maybe$Just(10) : ((upgrade('expansion') >= 5) ? elm$core$Maybe$Nothing : ((upgrade('expansion') > 0) ? elm$core$Maybe$Just(9) : ((unit('hatchery') > 1) ? ((unit('queen') >= 5) ? ((unit('territory') > 5) ? elm$core$Maybe$Just(8) : ((unit('territory') > 0) ? elm$core$Maybe$Just(7) : elm$core$Maybe$Just(6))) : ((unit('queen') > 0) ? elm$core$Maybe$Just(5) : elm$core$Maybe$Just(4))) : ((unit('drone') >= 10) ? ((unit('meat') >= 300) ? elm$core$Maybe$Just(3) : elm$core$Maybe$Just(2)) : ((unit('drone') > 0) ? elm$core$Maybe$Just(1) : elm$core$Maybe$Just(0)))))));
};
var author$project$Session$undoState = A2(
	elm$core$Basics$composeR,
	author$project$Session$unwrap,
	A2(
		elm$core$Basics$composeR,
		function ($) {
			return $.ae;
		},
		A2(
			elm$core$Basics$composeR,
			author$project$Session$GameLoader$undoState,
			elm$core$Maybe$map(elm$core$Tuple$second))));
var author$project$View$Lang$ViewTutorial = F2(
	function (a, b) {
		return {$: 179, a: a, b: b};
	});
var author$project$View$Tutorial$view = F2(
	function (session, game) {
		var units = A2(author$project$Session$safeUnits, game, session);
		var query = author$project$Session$query(session);
		var lang = A2(author$project$View$Lang$gameToLang, session, game);
		var _n0 = author$project$Game$Tutorial$step(
			{
				ae: game,
				fW: author$project$Session$undoState(session),
				k: units
			});
		if (!_n0.$) {
			var step = _n0.a;
			return _List_fromArray(
				[
					A2(
					elm$html$Html$div,
					_List_fromArray(
						[
							elm$html$Html$Attributes$class('alert alert-info')
						]),
					_List_fromArray(
						[
							lang.q(
							A2(author$project$View$Lang$ViewTutorial, query, step))
						]))
				]);
		} else {
			return _List_Nil;
		}
	});
var author$project$View$Lang$ViewUserErrorLoggedOut = {$: 206};
var author$project$View$Lang$ViewUserErrorLoggedOutRemember = {$: 207};
var author$project$View$UserError$view = F2(
	function (session, game) {
		var query = author$project$Session$query(session);
		var lang = A2(author$project$View$Lang$gameToLang, session, game);
		var _n0 = author$project$Session$userState(session);
		if (_n0.$ === 2) {
			var err = _n0.a;
			return _List_fromArray(
				[
					A2(
					elm$html$Html$div,
					_List_fromArray(
						[
							elm$html$Html$Attributes$class('alert alert-danger')
						]),
					function () {
						if (err.$ === 1) {
							var status = err.a;
							var json = err.b;
							return _List_fromArray(
								[
									A2(
									elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											elm$html$Html$a,
											_List_fromArray(
												[
													elm$html$Html$Attributes$class('dropdown-item'),
													A2(author$project$Route$href, query, author$project$Route$Login)
												]),
											_List_fromArray(
												[
													author$project$View$Icon$fas('user-times'),
													elm$html$Html$text(' '),
													lang.q(author$project$View$Lang$ViewUserErrorLoggedOut)
												]))
										])),
									A2(
									elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											elm$html$Html$i,
											_List_Nil,
											_List_fromArray(
												[
													lang.q(author$project$View$Lang$ViewUserErrorLoggedOutRemember)
												]))
										]))
								]);
						} else {
							return _List_fromArray(
								[
									A2(
									elm$html$Html$a,
									_List_fromArray(
										[
											elm$html$Html$Attributes$class('dropdown-item'),
											A2(author$project$Route$href, query, author$project$Route$Login)
										]),
									_List_fromArray(
										[
											author$project$View$Icon$fas('user-times'),
											elm$html$Html$text(' '),
											A2(
											elm$html$Html$code,
											_List_Nil,
											_List_fromArray(
												[
													elm$html$Html$text(
													author$project$PlayFab$Error$toString(err))
												]))
										]))
								]);
						}
					}())
				]);
		} else {
			return _List_Nil;
		}
	});
var author$project$Session$welcomeBack = A2(
	elm$core$Basics$composeR,
	author$project$Session$unwrap,
	function ($) {
		return $.a9;
	});
var author$project$View$Lang$ViewWelcomeBack = function (a) {
	return {$: 175, a: a};
};
var author$project$View$Lang$ViewWelcomeBackClose = {$: 178};
var author$project$View$Lang$ViewWelcomeBackLol = {$: 176};
var author$project$View$Lang$ViewWelcomeBackTitle = {$: 174};
var author$project$View$WelcomeBack$Close = 0;
var author$project$View$WelcomeBack$Noop = 1;
var author$project$View$WelcomeBack$diffUnits = F2(
	function (game, _n0) {
		var before = _n0.eh;
		var after = _n0.eb;
		var isVisible = function (unit) {
			return A2(author$project$Game$UnitsSnapshot$isUnitVisible, unit.eL, after);
		};
		var gd = author$project$Game$gameData(game);
		var meatUnits = A2(
			elm$core$List$take,
			3,
			A2(
				elm$core$List$filter,
				function (unit) {
					return A2(
						author$project$Decimal$gt,
						A2(author$project$Game$UnitsSnapshot$velocity, unit.eL, after),
						author$project$Decimal$zero);
				},
				A2(
					elm$core$List$filter,
					isVisible,
					A2(
						elm$core$List$filter,
						function (unit) {
							return author$project$GameData$Unit$name(unit) !== 'meat';
						},
						A2(author$project$GameData$unitsByTabName, 'meat', gd)))));
		var tabUnits = A2(
			elm$core$List$filter,
			isVisible,
			A2(
				elm$core$List$filterMap,
				function (tab) {
					return A2(author$project$GameData$unitById, tab.d3, gd);
				},
				author$project$GameData$tabs(gd)));
		var diff1 = function (id) {
			return A2(
				author$project$Decimal$max,
				author$project$Decimal$zero,
				A2(
					author$project$Decimal$sub,
					A2(author$project$Game$UnitsSnapshot$count, id, after),
					A2(author$project$Game$UnitsSnapshot$count, id, before)));
		};
		return A2(
			elm$core$List$filter,
			function (_n1) {
				var u = _n1.a;
				var c = _n1.b;
				return A2(author$project$Decimal$gt, c, author$project$Decimal$zero);
			},
			A2(
				elm$core$List$map,
				function (u) {
					return _Utils_Tuple2(
						u,
						diff1(u.eL));
				},
				_Utils_ap(meatUnits, tabUnits)));
	});
var author$project$View$Lang$ViewWelcomeBackEntry = F2(
	function (a, b) {
		return {$: 177, a: a, b: b};
	});
var author$project$View$WelcomeBack$viewUnitsDiff = F3(
	function (session, game, _n0) {
		var unit = _n0.a;
		var count = _n0.b;
		var route = A2(
			author$project$Route$unit,
			author$project$GameData$Tab$idToString(unit.fM),
			author$project$GameData$Unit$name(unit));
		var lang = A2(author$project$View$Lang$gameToLang, session, game);
		return A2(
			elm$html$Html$li,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					elm$html$Html$a,
					_List_fromArray(
						[
							A2(
							author$project$Route$href,
							author$project$Session$query(session),
							route)
						]),
					_List_fromArray(
						[
							lang.q(
							A2(author$project$View$Lang$ViewWelcomeBackEntry, unit.eL, count))
						]))
				]));
	});
var author$project$View$WelcomeBack$view = F2(
	function (session, game) {
		var _n0 = author$project$Session$welcomeBack(session);
		if (!_n0.$) {
			var wb = _n0.a;
			var lang = A2(author$project$View$Lang$gameToLang, session, game);
			var duration = author$project$Duration$since(
				{
					eb: author$project$Game$UnitsSnapshot$at(wb.eb),
					eh: author$project$Game$UnitsSnapshot$at(wb.eh)
				});
			return _List_fromArray(
				[
					A2(
					elm$html$Html$div,
					_List_fromArray(
						[
							elm$html$Html$Attributes$class('modal modal-open show'),
							A2(elm$html$Html$Attributes$style, 'display', 'block'),
							elm$html$Html$Attributes$tabindex(-1),
							A2(elm$html$Html$Attributes$attribute, 'role', 'dialog'),
							A2(elm$html$Html$Attributes$attribute, 'aria-hidden', 'true'),
							elm$html$Html$Events$onClick(0)
						]),
					_List_fromArray(
						[
							A2(
							elm$html$Html$div,
							_List_fromArray(
								[
									elm$html$Html$Attributes$class('modal-dialog'),
									A2(elm$html$Html$Attributes$attribute, 'role', 'document')
								]),
							_List_fromArray(
								[
									A2(
									elm$html$Html$div,
									_List_fromArray(
										[
											elm$html$Html$Attributes$class('modal-content'),
											A2(
											elm$html$Html$Events$stopPropagationOn,
											'click',
											elm$json$Json$Decode$succeed(
												_Utils_Tuple2(1, true)))
										]),
									_List_fromArray(
										[
											A2(
											elm$html$Html$div,
											_List_fromArray(
												[
													elm$html$Html$Attributes$class('modal-header')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$h5,
													_List_fromArray(
														[
															elm$html$Html$Attributes$class('modal-title')
														]),
													_List_fromArray(
														[
															lang.q(author$project$View$Lang$ViewWelcomeBackTitle)
														])),
													A2(
													elm$html$Html$button,
													_List_fromArray(
														[
															elm$html$Html$Attributes$class('close'),
															elm$html$Html$Events$onClick(0),
															A2(elm$html$Html$Attributes$attribute, 'aria-label', 'close')
														]),
													_List_fromArray(
														[
															elm$html$Html$text('×')
														]))
												])),
											A2(
											elm$html$Html$div,
											_List_fromArray(
												[
													elm$html$Html$Attributes$class('modal-body')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$p,
													_List_fromArray(
														[
															elm$html$Html$Attributes$title(
															lang.fH(author$project$View$Lang$ViewWelcomeBackLol))
														]),
													_List_fromArray(
														[
															lang.q(
															author$project$View$Lang$ViewWelcomeBack(duration))
														])),
													A2(
													elm$html$Html$ul,
													_List_Nil,
													A2(
														elm$core$List$map,
														A2(author$project$View$WelcomeBack$viewUnitsDiff, session, game),
														A2(author$project$View$WelcomeBack$diffUnits, game, wb)))
												])),
											A2(
											elm$html$Html$div,
											_List_fromArray(
												[
													elm$html$Html$Attributes$class('modal-footer')
												]),
											_List_fromArray(
												[
													A2(
													elm$html$Html$button,
													_List_fromArray(
														[
															A2(elm$html$Html$Attributes$style, 'width', '100%'),
															elm$html$Html$Attributes$class('btn btn-primary'),
															elm$html$Html$Events$onClick(0)
														]),
													_List_fromArray(
														[
															lang.q(author$project$View$Lang$ViewWelcomeBackClose)
														]))
												]))
										]))
								]))
						])),
					A2(
					elm$html$Html$div,
					_List_fromArray(
						[
							elm$html$Html$Attributes$class('modal-backdrop show')
						]),
					_List_Nil)
				]);
		} else {
			return _List_Nil;
		}
	});
var author$project$Main$view = function (model) {
	var session = author$project$Main$toSession(model);
	var _n0 = author$project$Session$gameData(session);
	if (_n0.$ === 1) {
		var err = _n0.a;
		return {
			cZ: _Utils_ap(
				author$project$View$Header$viewCss(session),
				_List_fromArray(
					[
						A2(
						elm$html$Html$div,
						_List_fromArray(
							[
								elm$html$Html$Attributes$class('error-container alert alert-danger'),
								A2(elm$html$Html$Attributes$attribute, 'role', 'alert')
							]),
						_List_fromArray(
							[
								A2(
								elm$html$Html$div,
								_List_fromArray(
									[
										elm$html$Html$Attributes$class('container')
									]),
								_List_fromArray(
									[
										A2(
										elm$html$Html$h1,
										_List_fromArray(
											[
												elm$html$Html$Attributes$class('alert-heading')
											]),
										_List_fromArray(
											[
												elm$html$Html$text('Oops')
											])),
										A2(
										elm$html$Html$p,
										_List_Nil,
										_List_fromArray(
											[
												elm$html$Html$text('Something broke static game data (including translation strings, so this error is English-only).')
											])),
										A2(
										elm$html$Html$p,
										_List_Nil,
										_List_fromArray(
											[
												elm$html$Html$text('Can\'t ignore this error, it\'s pretty disastrous. Your saved progress will be fine, though!')
											])),
										A2(
										elm$html$Html$p,
										_List_Nil,
										_List_fromArray(
											[
												elm$html$Html$text('Check back in a few hours, and the developer should have this fixed.')
											])),
										A2(
										elm$html$Html$pre,
										_List_Nil,
										_List_fromArray(
											[
												elm$html$Html$text(err)
											]))
									]))
							]))
					])),
			d1: 'Swarm Simulator startup\'s stuck. Static spreadsheet\'s screwed, son.'
		};
	} else {
		var gd = _n0.a;
		return {
			cZ: _Utils_ap(
				author$project$View$Header$viewCss(session),
				_Utils_ap(
					author$project$View$Header$viewLocalStorageIframe,
					_Utils_ap(
						A2(
							elm$core$List$map,
							elm$html$Html$map(author$project$Main$GotHeaderMsg),
							A2(author$project$View$Header$view, session, gd)),
						_Utils_ap(
							A2(
								elm$core$List$map,
								elm$html$Html$map(author$project$Main$GotKeyCombosHelpMsg),
								A3(
									author$project$View$KeyCombo$view,
									session,
									gd,
									function (_n1) {
										return author$project$Main$keyCombos(model);
									})),
							_List_fromArray(
								[
									A2(
									elm$html$Html$div,
									_List_fromArray(
										[
											elm$html$Html$Attributes$class('container main')
										]),
									function () {
										var _n2 = author$project$Session$offlineSyncConflict(session);
										if (!_n2.$) {
											var conflict = _n2.a;
											return A2(
												elm$core$List$map,
												elm$html$Html$map(author$project$Main$GotOfflineSyncMsg),
												A3(author$project$View$OfflineSync$view, session, gd, conflict));
										} else {
											var _n3 = author$project$Session$error(session);
											if (!_n3.$) {
												var _n4 = _n3.a;
												var message = _n4.a;
												var time = _n4.b;
												return A2(
													elm$core$List$map,
													elm$html$Html$map(author$project$Main$GotErrorViewMsg),
													A4(author$project$View$Error$viewSessionError, session, gd, message, time));
											} else {
												var _n5 = author$project$Session$game(session);
												switch (_n5.$) {
													case 0:
														return _List_Nil;
													case 1:
														return _List_fromArray(
															[author$project$View$Icon$loading]);
													case 2:
														var err = _n5.a;
														return A2(
															elm$core$List$map,
															elm$html$Html$map(author$project$Main$GotErrorViewMsg),
															A3(author$project$View$Error$viewGameError, session, gd, err));
													default:
														var game = _n5.a;
														return _Utils_ap(
															A2(author$project$View$UserError$view, session, game),
															_Utils_ap(
																A2(
																	elm$core$List$map,
																	elm$html$Html$map(author$project$Main$GotWelcomeBackMsg),
																	A2(author$project$View$WelcomeBack$view, session, game)),
																_Utils_ap(
																	A2(author$project$View$Tutorial$view, session, game),
																	A2(author$project$Main$viewBody, model, game))));
												}
											}
										}
									}()),
									A2(
									elm$html$Html$div,
									_List_fromArray(
										[
											elm$html$Html$Attributes$class('container')
										]),
									_List_fromArray(
										[
											A2(
											elm$html$Html$div,
											_List_fromArray(
												[
													elm$html$Html$Attributes$class('footer')
												]),
											_List_Nil)
										]))
								]))))),
			d1: A2(author$project$View$Lang$gameDataToLang, session, gd).fH(author$project$View$Lang$Title)
		};
	}
};
var elm$browser$Browser$application = _Browser_application;
var author$project$Main$main = elm$browser$Browser$application(
	{eQ: author$project$Main$init, fa: author$project$Main$UrlChanged, fb: author$project$Main$LinkClicked, fJ: author$project$Main$subscriptions, fY: author$project$Main$update, f_: author$project$Main$view});
_Platform_export({'Main':{'init':author$project$Main$main(
	A2(
		elm$json$Json$Decode$andThen,
		function (version) {
			return A2(
				elm$json$Json$Decode$andThen,
				function (translator) {
					return A2(
						elm$json$Json$Decode$andThen,
						function (lang) {
							return A2(
								elm$json$Json$Decode$andThen,
								function (hostname) {
									return A2(
										elm$json$Json$Decode$andThen,
										function (gameData) {
											return A2(
												elm$json$Json$Decode$andThen,
												function (environment) {
													return A2(
														elm$json$Json$Decode$andThen,
														function (changelog) {
															return elm$json$Json$Decode$succeed(
																{c4: changelog, de: environment, D: gameData, dp: hostname, b6: lang, cJ: translator, d7: version});
														},
														A2(elm$json$Json$Decode$field, 'changelog', elm$json$Json$Decode$string));
												},
												A2(elm$json$Json$Decode$field, 'environment', elm$json$Json$Decode$string));
										},
										A2(elm$json$Json$Decode$field, 'gameData', elm$json$Json$Decode$value));
								},
								A2(elm$json$Json$Decode$field, 'hostname', elm$json$Json$Decode$string));
						},
						A2(elm$json$Json$Decode$field, 'lang', elm$json$Json$Decode$value));
				},
				A2(elm$json$Json$Decode$field, 'translator', elm$json$Json$Decode$value));
		},
		A2(elm$json$Json$Decode$field, 'version', elm$json$Json$Decode$string)))(0)}});}(this));